"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __esm = (fn, res) => function __init() {
  return fn && (res = (0, fn[__getOwnPropNames(fn)[0]])(fn = 0)), res;
};
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/Utils/getParents.ts
var getParents;
var init_getParents = __esm({
  "src/Utils/getParents.ts"() {
    "use strict";
    getParents = (elements, filter, stopEl = document.body, blockElementsOnly = false) => {
      const results = [];
      const elementsArray = Array.isArray(elements) ? elements : [elements];
      elementsArray.forEach((element) => {
        let currentEl = element.parentElement;
        while (currentEl && currentEl !== stopEl) {
          if ((!filter || currentEl.matches(filter)) && (!blockElementsOnly || getComputedStyle(currentEl).display === "block")) {
            results.push(currentEl);
          }
          currentEl = currentEl.parentElement;
        }
      });
      return results;
    };
  }
});

// src/Utils/isBlank.ts
var isBlank;
var init_isBlank = __esm({
  "src/Utils/isBlank.ts"() {
    "use strict";
    isBlank = (value) => {
      if (typeof value === "string") {
        return /^\s*$/.test(value);
      }
      return value == null;
    };
  }
});

// src/Utils/isNode.ts
var isNode;
var init_isNode = __esm({
  "src/Utils/isNode.ts"() {
    "use strict";
    isNode = (variable, type) => {
      if (variable instanceof type) {
        return true;
      }
      const altType = variable?.ownerDocument?.defaultView?.[type.name];
      return Boolean(altType && variable instanceof altType);
    };
  }
});

// src/Utils/addClass.ts
var addClass;
var init_addClass = __esm({
  "src/Utils/addClass.ts"() {
    "use strict";
    init_isNode();
    addClass = (elements, classNames) => {
      const classes = classNames.split(" ").filter((cls) => cls.trim() !== "");
      const targetElements = Array.isArray(elements) ? elements : [elements];
      targetElements.forEach((element) => {
        if (isNode(element, Element)) {
          classes.forEach((className) => element.classList.add(className));
        }
      });
    };
  }
});

// src/Utils/removeClass.ts
var removeClass;
var init_removeClass = __esm({
  "src/Utils/removeClass.ts"() {
    "use strict";
    init_isNode();
    removeClass = (elements, classNames) => {
      const classes = classNames.split(" ").filter((cls) => cls.trim() !== "");
      const targetElements = Array.isArray(elements) ? elements : [elements];
      targetElements.forEach((element) => {
        if (isNode(element, Element)) {
          element.classList.remove(...classes);
        }
      });
    };
  }
});

// src/Utils/toggleClass.ts
var toggleClass;
var init_toggleClass = __esm({
  "src/Utils/toggleClass.ts"() {
    "use strict";
    toggleClass = (elems, className) => {
      if (!className.trim()) return;
      const elements = Array.isArray(elems) ? elems : [elems];
      elements.forEach((element) => {
        if (element.nodeType === Node.ELEMENT_NODE && element.classList) {
          element.classList.toggle(className);
        }
      });
    };
  }
});

// src/Utils/setStyle.ts
var setStyle;
var init_setStyle = __esm({
  "src/Utils/setStyle.ts"() {
    "use strict";
    init_isNode();
    setStyle = (elements, property, value) => {
      const elementArray = Array.isArray(elements) ? elements : [elements];
      elementArray.forEach((element) => {
        if (isNode(element, HTMLElement)) {
          element.style.setProperty(property, value);
        }
      });
    };
  }
});

// src/Utils/getTag.ts
var getTag;
var init_getTag = __esm({
  "src/Utils/getTag.ts"() {
    "use strict";
    getTag = (tagNames, startElement = document, onlyChildren = false) => {
      const tags = tagNames.split(",").map((tag) => tag.trim().toLowerCase());
      const elements = Array.isArray(startElement) ? startElement : [startElement];
      const matchingElements = /* @__PURE__ */ new Set();
      elements.forEach((element) => {
        const foundElements = onlyChildren ? Array.from(element.children).filter((child) => tags.includes(child.tagName.toLowerCase())) : tags.flatMap((tag) => Array.from(element.getElementsByTagName(tag)));
        foundElements.forEach((el) => matchingElements.add(el));
      });
      return Array.from(matchingElements);
    };
  }
});

// src/Utils/setHtml.ts
var setHtml;
var init_setHtml = __esm({
  "src/Utils/setHtml.ts"() {
    "use strict";
    setHtml = (node, content) => {
      if (!node) return;
      switch (node.nodeType) {
        case Node.ELEMENT_NODE:
          node.innerHTML = content;
          break;
        case Node.TEXT_NODE:
          node.textContent = content;
          break;
        case Node.COMMENT_NODE:
          node.data = content;
          break;
        default:
          console.warn(`Unsupported node type for setting content:`, node);
      }
    };
  }
});

// src/Utils/getHtml.ts
var getHtml;
var init_getHtml = __esm({
  "src/Utils/getHtml.ts"() {
    "use strict";
    init_isNode();
    getHtml = (element) => {
      if (!element) return "";
      if (isNode(element, HTMLInputElement) || isNode(element, HTMLTextAreaElement)) {
        return element.value;
      }
      if ("innerHTML" in element) {
        return element.innerHTML;
      }
      return element.textContent ?? "";
    };
  }
});

// src/Utils/trim.ts
var ltrim, rtrim, trim;
var init_trim = __esm({
  "src/Utils/trim.ts"() {
    "use strict";
    ltrim = (str, trimChars = "\\s") => {
      return str.replace(new RegExp(`^[${trimChars}]+`, "g"), "");
    };
    rtrim = (str, trimChars = "\\s") => {
      return str.replace(new RegExp(`[${trimChars}]+$`, "g"), "");
    };
    trim = (value, trimChars = "\\s") => {
      return ltrim(rtrim(value, trimChars), trimChars);
    };
  }
});

// src/Utils/isBlockElement.ts
function isBlockElement(element) {
  if (!element) {
    return false;
  }
  const blockElements = /* @__PURE__ */ new Set([
    "P",
    "DIV",
    "PRE",
    "UL",
    "OL",
    "LI",
    "TABLE",
    "TBODY",
    "TD",
    "TH",
    "TR",
    "CAPTION",
    "FIELDSET",
    "FORM",
    "BLOCKQUOTE",
    "DL",
    "DIR",
    "CENTER",
    "ADDRESS",
    "H1",
    "H2",
    "H3",
    "H4",
    "H5",
    "H6",
    "IMG",
    "HEADER",
    "NAV",
    "SECTION",
    "MAIN",
    "ARTICLE",
    "ASIDE",
    "FOOTER",
    "DETAILS",
    "FIGURE",
    "DIALOG",
    "CANVAS",
    "AUDIO",
    "VIDEO",
    "BODY"
  ]);
  return blockElements.has(element.nodeName.toUpperCase());
}
var init_isBlockElement = __esm({
  "src/Utils/isBlockElement.ts"() {
    "use strict";
  }
});

// src/Utils/isStubElement.ts
function isStubElement(element) {
  if (!element) {
    return false;
  }
  const stubElements = /* @__PURE__ */ new Set([
    "IMG",
    "BR",
    "HR",
    "IFRAME",
    "PARAM",
    "LINK",
    "META",
    "INPUT",
    "FRAME",
    "COL",
    "BASE",
    "AREA",
    "EMBED",
    "CANVAS",
    "SOURCE",
    "TRACK"
  ]);
  return stubElements.has(element.nodeName.toUpperCase());
}
var init_isStubElement = __esm({
  "src/Utils/isStubElement.ts"() {
    "use strict";
  }
});

// src/Utils/getDirectChildren.ts
var getDirectChildren;
var init_getDirectChildren = __esm({
  "src/Utils/getDirectChildren.ts"() {
    "use strict";
    init_isNode();
    getDirectChildren = (elements, selector) => {
      const getChildElements = (el) => selector ? Array.from(el.children).filter((child) => child.matches(selector)) : Array.from(el.children);
      if (isNode(elements, Element)) {
        return getChildElements(elements);
      } else {
        return Array.from(elements).flatMap(getChildElements);
      }
    };
  }
});

// src/Utils/getAllChildren.ts
var getAllChildren;
var init_getAllChildren = __esm({
  "src/Utils/getAllChildren.ts"() {
    "use strict";
    init_isNode();
    getAllChildren = (elements, selector) => {
      const getDescendants = (el) => selector ? Array.from(el.querySelectorAll(selector)) : Array.from(el.querySelectorAll("*"));
      if (isNode(elements, Element)) {
        return getDescendants(elements);
      } else {
        return Array.from(elements).flatMap(getDescendants);
      }
    };
  }
});

// src/Utils/hasClass.ts
var hasClass;
var init_hasClass = __esm({
  "src/Utils/hasClass.ts"() {
    "use strict";
    init_isNode();
    hasClass = (elements, className) => {
      const checkClass = (el) => el.classList.contains(className);
      if (isNode(elements, Element)) {
        return checkClass(elements);
      } else {
        return Array.from(elements).some(checkClass);
      }
    };
  }
});

// src/Utils/getStyle.ts
var getStyle;
var init_getStyle = __esm({
  "src/Utils/getStyle.ts"() {
    "use strict";
    getStyle = (element, properties) => {
      const computedStyles = window.getComputedStyle(element);
      if (typeof properties === "string") {
        return computedStyles.getPropertyValue(properties);
      } else {
        const styles = {};
        properties.forEach((property) => {
          styles[property] = computedStyles.getPropertyValue(property);
        });
        return styles;
      }
    };
  }
});

// src/Utils/isPartOfDom.ts
var isPartOfDOM;
var init_isPartOfDom = __esm({
  "src/Utils/isPartOfDom.ts"() {
    "use strict";
    isPartOfDOM = (element, parent = document.body) => {
      if (!element || !parent) {
        return false;
      }
      return parent.contains(element);
    };
  }
});

// src/Utils/isChildOf.ts
var isChildOf;
var init_isChildOf = __esm({
  "src/Utils/isChildOf.ts"() {
    "use strict";
    isChildOf = (el, parent, stopElem) => {
      const parents = Array.isArray(parent) ? parent : [parent];
      try {
        while (el && el !== stopElem) {
          if (el.parentNode && parents.includes(el.parentNode)) {
            return true;
          }
          el = el.parentNode;
        }
      } catch (e) {
        console.error("Error occurred while checking parent nodes:", e);
      }
      return false;
    };
  }
});

// src/Utils/prevAll.ts
var prevAll;
var init_prevAll = __esm({
  "src/Utils/prevAll.ts"() {
    "use strict";
    prevAll = (elements, selector) => {
      const elementsArray = Array.isArray(elements) ? elements : [elements];
      const selectors = selector ? selector.split(",").map((s) => s.trim()) : null;
      const uniqueSiblings = /* @__PURE__ */ new Set();
      elementsArray.forEach((element) => {
        let previousSibling = element.previousElementSibling;
        while (previousSibling) {
          if (!selectors || selectors.some((sel) => previousSibling?.matches(sel))) {
            uniqueSiblings.add(previousSibling);
          }
          previousSibling = previousSibling.previousElementSibling;
        }
      });
      return Array.from(uniqueSiblings);
    };
  }
});

// src/Utils/nextAll.ts
var nextAll;
var init_nextAll = __esm({
  "src/Utils/nextAll.ts"() {
    "use strict";
    nextAll = (elements, selector) => {
      const elementsArray = Array.isArray(elements) ? elements : [elements];
      const selectors = selector ? selector.split(",").map((s) => s.trim()) : null;
      const uniqueSiblings = /* @__PURE__ */ new Set();
      elementsArray.forEach((element) => {
        let nextSibling = element.nextElementSibling;
        while (nextSibling) {
          if (!selectors || selectors.some((sel) => nextSibling?.matches(sel))) {
            uniqueSiblings.add(nextSibling);
          }
          nextSibling = nextSibling.nextElementSibling;
        }
      });
      return Array.from(uniqueSiblings);
    };
  }
});

// src/Utils/attr.ts
var attr;
var init_attr = __esm({
  "src/Utils/attr.ts"() {
    "use strict";
    init_isNode();
    attr = (elements, key, value) => {
      const elementsArray = isNode(elements, Element) ? [elements] : Array.from(elements).filter((node) => isNode(node, Element));
      if (elementsArray.length === 0) {
        return null;
      }
      if (typeof key === "object" && key !== null) {
        elementsArray.forEach((element) => {
          for (const [attr2, val] of Object.entries(key)) {
            element.setAttribute(attr2, String(val));
          }
        });
        return;
      }
      if (value !== void 0) {
        elementsArray.forEach((element, index) => {
          const val = typeof value === "function" ? value(index, element.getAttribute(key) || "") : String(value);
          element.setAttribute(key, val);
        });
        return;
      }
      const values = elementsArray.map((element) => element.getAttribute(key));
      return values.length === 1 ? values[0] : values;
    };
  }
});

// src/Utils/removeAttr.ts
var removeAttr;
var init_removeAttr = __esm({
  "src/Utils/removeAttr.ts"() {
    "use strict";
    init_isNode();
    removeAttr = (elements, name) => {
      const elementsArray = (isNode(elements, Element) ? [elements] : Array.from(elements)).filter(
        (node) => isNode(node, Element)
      );
      elementsArray.forEach((element) => {
        element.removeAttribute(name);
      });
    };
  }
});

// src/Utils/getNodeTextContent.ts
var getNodeTextContent;
var init_getNodeTextContent = __esm({
  "src/Utils/getNodeTextContent.ts"() {
    "use strict";
    init_isNode();
    getNodeTextContent = (node) => {
      if (node.nodeType === Node.TEXT_NODE) {
        return node.textContent || "";
      } else if (isNode(node, Element)) {
        return node.textContent || "";
      }
      return "";
    };
  }
});

// src/Utils/empty.ts
var empty;
var init_empty = __esm({
  "src/Utils/empty.ts"() {
    "use strict";
    empty = (element) => {
      if (!element) return false;
      if (element.nodeType === Node.ELEMENT_NODE) {
        while (element.firstChild) {
          element.removeChild(element.firstChild);
        }
      } else if (element.nodeType === Node.TEXT_NODE) {
        element.textContent = "";
      } else {
        return false;
      }
      return true;
    };
  }
});

// src/Utils/find.ts
var find;
var init_find = __esm({
  "src/Utils/find.ts"() {
    "use strict";
    find = (parent, exp) => {
      const parents = Array.isArray(parent) ? parent : [parent];
      const selectors = exp.split(",").map((selector) => selector.trim());
      const results = [];
      parents.forEach((parentElement) => {
        selectors.forEach((selector) => {
          results.push(...Array.from(parentElement.querySelectorAll(selector)));
        });
      });
      return Array.from(new Set(results));
    };
  }
});

// src/Utils/getElementCoords.ts
var getElementCoords;
var init_getElementCoords = __esm({
  "src/Utils/getElementCoords.ts"() {
    "use strict";
    getElementCoords = (element) => {
      if (!element) throw new Error("Element is required.");
      const rect = element.getBoundingClientRect();
      return {
        x: rect.left + window.scrollX,
        y: rect.top + window.scrollY
      };
    };
  }
});

// src/Utils/setNodeTextContent.ts
var setNodeTextContent;
var init_setNodeTextContent = __esm({
  "src/Utils/setNodeTextContent.ts"() {
    "use strict";
    setNodeTextContent = (node, text) => {
      node.textContent = text;
    };
  }
});

// src/Utils/isIterable.ts
var isIterable;
var init_isIterable = __esm({
  "src/Utils/isIterable.ts"() {
    "use strict";
    isIterable = (variable) => {
      return Boolean(variable?.[Symbol.iterator]);
    };
  }
});

// src/Utils/removeElement.ts
var removeElement, _removeElement;
var init_removeElement = __esm({
  "src/Utils/removeElement.ts"() {
    "use strict";
    init_isNode();
    init_isIterable();
    removeElement = (selectorOrElement) => {
      if (!selectorOrElement) {
        return;
      }
      if (typeof selectorOrElement === "string") {
        document.querySelectorAll(selectorOrElement).forEach(_removeElement);
      } else if (isNode(selectorOrElement, Node)) {
        _removeElement(selectorOrElement);
      } else if (isIterable(selectorOrElement)) {
        selectorOrElement.forEach((el) => _removeElement(el));
      } else {
        throw new Error(`Unsupported argument type`);
      }
    };
    _removeElement = (element) => {
      if (element && element.parentNode) {
        element.parentNode.removeChild(element);
      }
    };
  }
});

// src/Utils/isTag.ts
var isTag;
var init_isTag = __esm({
  "src/Utils/isTag.ts"() {
    "use strict";
    isTag = (node, tag) => {
      if (!node || !node.nodeName) {
        return false;
      }
      const nodeTagName = node.nodeName.toLowerCase();
      if (typeof tag === "string") {
        return nodeTagName === tag.toLowerCase();
      }
      if (Array.isArray(tag)) {
        return tag.some((t) => nodeTagName === t.toLowerCase());
      }
      return false;
    };
  }
});

// src/Utils/isText.ts
var isText;
var init_isText = __esm({
  "src/Utils/isText.ts"() {
    "use strict";
    isText = (node, notEmpty = false) => {
      if (!node) return false;
      return node.nodeType === Node.TEXT_NODE && (!notEmpty || (node.textContent?.trim().length ?? 0) > 0);
    };
  }
});

// src/Utils/getTagName.ts
var getTagName;
var init_getTagName = __esm({
  "src/Utils/getTagName.ts"() {
    "use strict";
    getTagName = (node) => {
      if (node?.nodeType === node?.TEXT_NODE) {
        return null;
      }
      return node?.nodeName?.toLowerCase() ?? null;
    };
  }
});

// src/Utils/constants.ts
var KEY_CODE_DELETE, KEY_CODE_ESC, ERROR_MUST_SPECIFY_BEFORE_AND_ELEMENT, ERROR_BEFORE_ELEMENT_MUST_HAVE_PARENT;
var init_constants = __esm({
  "src/Utils/constants.ts"() {
    "use strict";
    KEY_CODE_DELETE = 46;
    KEY_CODE_ESC = 27;
    ERROR_MUST_SPECIFY_BEFORE_AND_ELEMENT = `Both 'before' and 'elem' elements must be provided`;
    ERROR_BEFORE_ELEMENT_MUST_HAVE_PARENT = `before element must have a parent node`;
  }
});

// src/Utils/insertBefore.ts
var insertBefore;
var init_insertBefore = __esm({
  "src/Utils/insertBefore.ts"() {
    "use strict";
    init_constants();
    init_isNode();
    insertBefore = (before, elem) => {
      if (!before || !elem) {
        throw new Error(ERROR_MUST_SPECIFY_BEFORE_AND_ELEMENT);
      }
      if (!before.parentNode) {
        throw new Error(ERROR_BEFORE_ELEMENT_MUST_HAVE_PARENT);
      }
      const elements = isNode(elem, Node) ? [elem] : Array.from(elem);
      elements.forEach((el) => {
        if (isNode(el, Node)) {
          before.parentNode?.insertBefore(el, before);
        }
      });
    };
  }
});

// src/Utils/insertAfter.ts
var insertAfter;
var init_insertAfter = __esm({
  "src/Utils/insertAfter.ts"() {
    "use strict";
    init_isNode();
    insertAfter = (after, elem) => {
      if (!after || !elem) {
        throw new Error("Both after and elem must be provided");
      }
      if (!after.parentNode) {
        throw new Error("after element must have a parent node");
      }
      const elements = isNode(elem, Node) ? [elem] : Array.from(elem);
      elements.forEach((el) => {
        if (isNode(el, Node)) {
          after.parentNode?.insertBefore(el, after.nextSibling);
          after = el;
        }
      });
    };
  }
});

// src/Utils/moveChildrenToElement.ts
var moveChildrenToElement;
var init_moveChildrenToElement = __esm({
  "src/Utils/moveChildrenToElement.ts"() {
    "use strict";
    init_isText();
    init_removeElement();
    moveChildrenToElement = (sourceElement, targetElement, joinTextNodes) => {
      while (sourceElement.firstChild) {
        if (joinTextNodes === true && isText(targetElement.lastChild) === true && isText(sourceElement.firstChild) === true) {
          targetElement.lastChild.data += sourceElement.firstChild.data;
          removeElement(sourceElement.firstChild);
        } else {
          targetElement.appendChild(sourceElement.firstChild);
        }
      }
    };
  }
});

// src/Utils/isInputKey.ts
var isInputKey;
var init_isInputKey = __esm({
  "src/Utils/isInputKey.ts"() {
    "use strict";
    init_constants();
    isInputKey = (e) => {
      if ((e.which !== 0 || e.keyCode === KEY_CODE_DELETE) && e.ctrlKey !== true && e.altKey !== true && e.metaKey !== true && e.which !== KEY_CODE_ESC) {
        return true;
      }
      return false;
    };
  }
});

// src/Utils/event.ts
var eventStore, addEvent, parseTypeAndNamespace, safedblclick, removeEvent, trigger, hover, preventDefault;
var init_event = __esm({
  "src/Utils/event.ts"() {
    "use strict";
    eventStore = /* @__PURE__ */ new WeakMap();
    addEvent = (elements, type, callback, data) => {
      if (!elements) return;
      const elementArray = Array.isArray(elements) ? elements : [elements];
      const [eventType, namespace] = parseTypeAndNamespace(type);
      elementArray.forEach((element) => {
        if (eventType === "safedblclick") {
          safedblclick(element, callback, callback, data);
        } else {
          const listener = (event2) => {
            if (callback(event2, data) === false) {
              preventDefault(event2);
            }
          };
          element.addEventListener(eventType, listener);
          const events = eventStore.get(element) || [];
          events.push({ type: eventType, namespace, callback: listener });
          eventStore.set(element, events);
        }
      });
    };
    parseTypeAndNamespace = (type) => {
      const [eventType, namespace] = type.split(".");
      return [eventType, namespace || null];
    };
    safedblclick = (element, clickCallback, dblClickCallback, data) => {
      let clickTimeout = null;
      const singleClickListener = (event2) => {
        clearTimeout(clickTimeout);
        clickTimeout = window.setTimeout(() => {
          clickCallback(event2, data);
        }, 250);
      };
      const doubleClickListener = (event2) => {
        clearTimeout(clickTimeout);
        dblClickCallback(event2, data);
      };
      element.addEventListener("click", singleClickListener);
      element.addEventListener("dblclick", doubleClickListener);
      const events = eventStore.get(element) || [];
      events.push(
        { type: "click", namespace: null, callback: singleClickListener },
        { type: "dblclick", namespace: null, callback: doubleClickListener }
      );
      eventStore.set(element, events);
    };
    removeEvent = (elements, type) => {
      const elementArray = Array.isArray(elements) ? elements : [elements];
      const [eventType, namespace] = parseTypeAndNamespace(type || "");
      elementArray.forEach((element) => {
        const events = eventStore.get(element);
        if (!events) return;
        const remainingEvents = events.filter((eventRecord) => {
          const matchesType = !eventType || eventRecord.type === eventType;
          const matchesNamespace = !namespace || eventRecord.namespace === namespace;
          if (matchesType && matchesNamespace) {
            element.removeEventListener(eventRecord.type, eventRecord.callback);
            return false;
          }
          return true;
        });
        if (remainingEvents.length) {
          eventStore.set(element, remainingEvents);
        } else {
          eventStore.delete(element);
        }
      });
    };
    trigger = (elements, type, data) => {
      const elementArray = Array.isArray(elements) ? elements : [elements];
      const [eventType, namespace] = parseTypeAndNamespace(type);
      elementArray.forEach((element) => {
        const event2 = new CustomEvent(eventType, { detail: data, bubbles: true });
        event2.namespace = namespace;
        element.dispatchEvent(event2);
      });
    };
    hover = (elements, over, out) => {
      const elementArray = Array.isArray(elements) ? elements : [elements];
      elementArray.forEach((element) => {
        if (over) element.addEventListener("mouseenter", over);
        if (out) element.addEventListener("mouseleave", out);
        const events = eventStore.get(element) || [];
        if (over) events.push({ type: "mouseenter", namespace: null, callback: over });
        if (out) events.push({ type: "mouseleave", namespace: null, callback: out });
        eventStore.set(element, events);
      });
    };
    preventDefault = (event2) => {
      event2.preventDefault();
      event2.stopPropagation();
    };
  }
});

// src/Lib/Util.js
var Util_exports = {};
__export(Util_exports, {
  registerPlugin: () => registerPlugin
});
var import_jquery, registerPlugin;
var init_Util = __esm({
  "src/Lib/Util.js"() {
    "use strict";
    import_jquery = __toESM(require("jquery"));
    init_isBlank();
    init_addClass();
    init_removeClass();
    init_toggleClass();
    init_setStyle();
    init_getTag();
    init_setHtml();
    init_getHtml();
    init_trim();
    init_isBlockElement();
    init_isStubElement();
    init_getDirectChildren();
    init_getAllChildren();
    init_hasClass();
    init_getStyle();
    init_isPartOfDom();
    init_isChildOf();
    init_getParents();
    init_prevAll();
    init_nextAll();
    init_attr();
    init_removeAttr();
    init_getNodeTextContent();
    init_empty();
    init_find();
    init_getElementCoords();
    init_setNodeTextContent();
    init_removeElement();
    init_isTag();
    init_isText();
    init_getTagName();
    init_insertBefore();
    init_insertAfter();
    init_moveChildrenToElement();
    init_isInputKey();
    init_event();
    registerPlugin = (Viper2) => {
      var ViperUtil = Viper2.Util = {
        $: import_jquery.default,
        ELEMENT_NODE: 1,
        ATTRIBUTE_NODE: 2,
        TEXT_NODE: 3,
        CDATA_SECTION_NODE: 4,
        ENTITY_REFERENCE_NODE: 5,
        ENTITY_NODE: 6,
        PROCESSING_INSTRUCTION_NODE: 7,
        COMMENT_NODE: 8,
        DOCUMENT_NODE: 9,
        DOCUMENT_TYPE_NODE: 10,
        DOCUMENT_FRAGMENT_NODE: 11,
        NOTATION_NODE: 12,
        DOM_VK_DELETE: 46,
        DOM_VK_LEFT: 37,
        DOM_VK_UP: 38,
        DOM_VK_RIGHT: 39,
        DOM_VK_DOWN: 40,
        DOM_VK_ENTER: 13,
        DOM_VK_BACKSPACE: 8,
        _browserType: null,
        _browserVersion: null,
        _viperElement: null,
        isKey: function(e, keys) {
          var eKeys = [];
          if (e.ctrlKey === true || e.metaKey === true) {
            eKeys.push("ctrl");
          }
          if (e.shiftKey === true) {
            eKeys.push("shift");
          }
          if (e.altKey === true) {
            eKeys.push("alt");
          }
          switch (e.keyCode) {
            case 13:
              eKeys.push("enter");
              break;
            case ViperUtil.DOM_VK_LEFT:
              eKeys.push("left");
              break;
            case ViperUtil.DOM_VK_RIGHT:
              eKeys.push("right");
              break;
            case ViperUtil.DOM_VK_UP:
              eKeys.push("up");
              break;
            case ViperUtil.DOM_VK_DOWN:
              eKeys.push("down");
              break;
            case 9:
              eKeys.push("tab");
              break;
            case ViperUtil.DOM_VK_DELETE:
              eKeys.push("delete");
              break;
            case ViperUtil.DOM_VK_BACKSPACE:
              eKeys.push("backspace");
              break;
            default:
              var code = e.which;
              if (code) {
                eKeys.push(String.fromCharCode(code).toLowerCase());
              }
              break;
          }
          eKeys = eKeys.sort();
          keys = keys.toLowerCase().split("+").sort();
          var kCount = keys.length;
          if (kCount !== eKeys.length) {
            return false;
          }
          for (var i = 0; i < kCount; i++) {
            if (keys[i] !== eKeys[i]) {
              return false;
            }
          }
          return true;
        },
        isInputKey,
        isTag,
        getTagName,
        /**
         * Removes the element from the document.
         *
         * The element is removed by telling the element's parent node to remove the
         * element we want.
         *
         * @param {DomElement} element The element to remove from the document.
         *
         * @return TRUE if the element is removed successfully.
         * @type   bool
         */
        remove: removeElement,
        /**
         * Inserts a new element directly before another element in the DOM tree.
         *
         * @param {DomElement} before The element that is to be inserted before.
         * @param {DomElement} elem   The element to insert.
         *
         * @return TRUE if the element is inserted correctly.
         * @type   bool
         */
        insertBefore,
        /**
         * Inserts an element in the DOM tree before another element.
         *
         * @param {DomElement} after The element to insert after.
         * @param {DomElement} elem  The element to insert.
         *
         * @return TRUE If the element is inserted correctly.
         * @type   bool
         */
        insertAfter,
        moveChildrenToElement,
        /**
         * Applies the passed class to the element.
         *
         * @param {DomElement} element   The element to apply the class to.
         * @param {String}     classNames The classes to apply (separated by spaces).
         *
         * @return void
         * @type   void
         */
        addClass,
        /**
         * Removes the passed class from the element.
         *
         * @param {DomElement} element   The element to remove the class from.
         * @param {String}     classNames The classes to remove (separated by spaces).
         *
         * @return void
         * @type   void
         */
        removeClass,
        /**
         * Adds/removes specified class name from given elements.
         *
         * @param {DomElements} elems     The elements to add/remove the class from.
         * @param {String}      className The class to add/remove.
         *
         * @return void
         */
        toggleClass,
        /**
         * Sets a CSS style property on an element.
         *
         * The property name can be passed in as either javascript style notation
         * (fontHeight) or CSS notation (font-height).
         *
         * @param {Element} element  The element to apply the style to.
         * @param {String}     property The name of the property to set
         *                              eg. backgroundColor, borderWidth etc.
         * @param {String}     value    The value to set the property to.
         *
         * @type void
         */
        setStyle,
        /**
         * Returns objects with the passed tag name, beneath the optional start element.
         *
         * @param {String}     tagName      The type of tag to find.
         * @param {DomElement} startElement The element to search under (if omitted
         *                                  defaults to document).
         * @param {Boolean}    onlyChildren If true, only the immediate children
         *                                  of the startElement will be searched.
         *
         * @return Array(DomElement).
         */
        getTag,
        /**
         * Sets the content of an element.
         *
         * If the element doesn't have an innerHTML property, then the value or other
         * equivalent property will be set instead, so this method can and should be
         * used for all elements.
         *
         * @param {DomElement} element The element to set content for.
         * @param {String}     content The content to apply to the element.
         *
         * @return TRUE if the content is correctly set.
         * @type   bool
         */
        setHtml,
        /**
         * Get the content of an element.
         *
         * If the element is a textbox or another element that doesn't have HTML then
         * its' value will be returned, which allows this method to be used to retrieve
         * the content of any element.
         *
         * @param {DomElement} element The element to retrieve the content from.
         *
         * @return The content of the element.
         * @type   String
         */
        getHtml,
        /**
         * Retrurns TRUE if the specified element is a block element.
         *
         * @param {DOMElement} element The element to check.
         *
         * @return {boolean}
         */
        isBlockElement,
        /**
         * Returns true if the specified element does not have any children.
         *
         * @param {DOMElement} element The element to check.
         *
         * @return {boolean}
         */
        isStubElement,
        isEmptyElement: function(element) {
          if (!element.firstChild) {
            return true;
          }
          var brCount = 0;
          for (var i = 0; i < element.childNodes.length; i++) {
            var el = element.childNodes[i];
            if (el.nodeType === ViperUtil.TEXT_NODE) {
              if (trim(el.data).length !== 0) {
                return false;
              } else {
                continue;
              }
            } else if (isTag(el, "br") === false) {
              return false;
            } else if (brCount !== 0) {
              return false;
            } else {
              brCount++;
            }
          }
          return true;
        },
        isText,
        isSpacerBR: function(node) {
          if (isTag(node, "br") === true && !node.nextSibling && isBlockElement(node.parentNode) === true) {
            return true;
          }
          return false;
        },
        isElement: function(node) {
          if (node && node.nodeType === this.ELEMENT_NODE) {
            return true;
          }
          return false;
        },
        isFirstNonEmptyTextNode: function(node) {
          if (this.isText(node) === false) {
            return false;
          }
          while (node.previousSibling && this.isText(node.previousSibling) === true) {
            if (this.trim(node.previousSibling.data) !== "") {
              return false;
            }
            node = node.previousSibling;
          }
          return true;
        },
        endsWithSpace: function(node, nonBreaking) {
          if (this.isText(node) === false) {
            return false;
          }
          if (nonBreaking === true) {
            if (node.data.charCodeAt(node.data.length - 1) === 160) {
              return true;
            }
          } else if (node.data.charAt(node.data.length - 1) === " ") {
            return true;
          }
          return false;
        },
        startsWithSpace: function(node, nonBreaking) {
          if (this.isText(node) === false) {
            return false;
          }
          if (nonBreaking === true) {
            if (node.data.charCodeAt(0) === 160) {
              return true;
            }
          } else if (node.data.charAt(0) === " ") {
            return true;
          }
          return false;
        },
        replaceCharAt: function(textNode, pos, replacement) {
          if (this.isText(textNode) === false) {
            return false;
          }
          switch (pos) {
            case "last":
              pos = textNode.data.length - 1;
              break;
            case "first":
              pos = 0;
              break;
          }
          textNode.data = textNode.data.substr(0, pos) + replacement + textNode.data.substr(pos + 1);
          return true;
        },
        /**
         * returns a left trimmed string.
         *
         * @param {String} value The string to trim.
         * @param {String} trimChars The different chars to trim off the left.
         *
         * @return {String}
         */
        ltrim: function(str, trimChars) {
          trimChars = trimChars || "\\s";
          return str.replace(new RegExp("^[" + trimChars + "]+", "g"), "");
        },
        /**
         * returns a right trimmed string.
         *
         * @param {String} value The string to trim.
         * @param {String} trimChars The different chars to trim off the right.
         *
         * @return {String}
         */
        rtrim: function(str, trimChars) {
          trimChars = trimChars || "\\s";
          return str.replace(new RegExp("[" + trimChars + "]+$", "g"), "");
        },
        /**
         * returns a trimmed string.
         *
         * @param {String} value The string to trim.
         * @param {String} trimChars The different chars to trim off both sides.
         *
         * @return {String}
         */
        trim: function(value, trimChars) {
          return ViperUtil.ltrim(ViperUtil.rtrim(value, trimChars), trimChars);
        },
        ucFirst: function(str) {
          return str.substr(0, 1).toUpperCase() + str.substr(1, str.length);
        },
        replaceAll: function(search, replace, subject) {
          search = search.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
          var r = new RegExp(search, "g");
          return subject.replace(r, replace);
        },
        /**
         * returns true if specified string is blank.
         *
         * @param {String} value The string to test.
         *
         * @return {String}
         */
        isBlank,
        isset: function(v) {
          if (typeof v !== "undefined" && v !== null) {
            return true;
          }
          return false;
        },
        isObj: function(v) {
          if (v !== null && typeof v === "object") {
            return true;
          }
          return false;
        },
        isEmpty: function(value) {
          if (value) {
            if (value instanceof Array) {
              if (value.length > 0) {
                return false;
              }
            } else {
              for (var id in value) {
                if (value.hasOwnProperty(id) === true) {
                  return false;
                }
              }
            }
          }
          return true;
        },
        // TODO: Event based function use jQuery namespaces. Need to handle them differently.
        /**
         * Binds event type to specified elements.
         */
        addEvent,
        /**
         * Removes bound event type from specified elements.
         */
        removeEvent,
        /**
         * Trigger a type of event on all specified elements.
         */
        trigger,
        hover,
        /**
         * Prevents default action and event bubbling.
         *
         * @param Event evt The event object.
         */
        preventDefault,
        /**
         * Returns the target that a mouse event occured on.
         *
         * @param Event evt The event object.
         *
         * @return The element that the event occured on.
         * @type   DomElement
         */
        getMouseEventTarget: function(evt) {
          var ret = null;
          if (evt.target) {
            ret = evt.target;
          } else if (evt.srcElement) {
            ret = evt.srcElement;
          }
          return ret;
        },
        /**
         * Retrieves all elements underneath the parent element that contain the class.
         *
         * @param {String}     className    Space seperated string of classes
         *                                  to search on.
         * @param {DomElement} startElement The element to start from.
         *                                  If null, will search the whole document.
         * @param {String}     tagName      The elements to restrict the
         *                                  search to. Eg. 'div span'.
         * @param {Boolean}    onlyChildren If true, only the immediate children of the
         *                                  startElement will be searched.
         *
         * @return An array of elements that have the passed class applied.
         * @type   Array(DomElement)
         */
        getClass: function(className, startElement, tagName, onlyChildren) {
          var ret;
          if (!startElement) {
            startElement = document.body;
          }
          className = "." + className.split(" ").join(".");
          if (tagName) {
            className = tagName + className;
          }
          if (onlyChildren === true) {
            ret = getDirectChildren(startElement, className);
          } else {
            ret = getAllChildren(startElement, className);
          }
          return ret;
        },
        /**
         * Determines if the element has the passed class applied to it.
         *
         * @param {DomElement} element   The element to check.
         * @param {String}     className The class to check for.
         *
         * @return TRUE if the element has the class applied.
         * @type   bool
         */
        hasClass,
        /**
         * Gets a CSS style property of an element.
         *
         * @param {DomElement} element  The element to retrieve the style from.
         * @param {String}     property The name of the property to get in CSS notation
         *                              eg. background-color, border-width etc.
         *
         * @return The value of the passed style for the passed element.
         * @type   string
         */
        getStyle,
        /**
         * Returns the computed styles for given element.
         */
        getComputedStyle: function(el, styleName) {
          if (styleName) {
            styleName = ViperUtil.camelCase(styleName);
          }
          if (document.defaultView && document.defaultView.getComputedStyle) {
            var styles = document.defaultView.getComputedStyle(el, null);
            if (styleName) {
              return styles[styleName];
            }
            return styles;
          } else if (el.currentStyle) {
            if (styleName) {
              return el.currentStyle[styleName];
            }
            return el.currentStyle;
          }
        },
        getFirstBlockParent: function(elem, stopEl, incSelf) {
          if (incSelf === true && isBlockElement(elem) === true) {
            return elem;
          }
          stopEl = stopEl || this._viperElement;
          while (elem.parentNode) {
            elem = elem.parentNode;
            if (stopEl && elem === stopEl) {
              return null;
            }
            if (isBlockElement(elem) === true) {
              return elem;
            }
          }
          return null;
        },
        getParents: function(elements, filter, stopEl, blockElementsOnly) {
          stopEl = stopEl || this._viperElement;
          return getParents(elements, filter, stopEl, blockElementsOnly);
        },
        /**
         * Returns list of parent elements that have only one child.
         *
         * @param node        {DOMNode} The child element to get parents of.
         * @param tagName     {string}  The tag name filter.
         * @param elementType {boolean} Can be one of block|inline|stub.
         *                              If the tagName filter is set then this param is ignored.
         *
         * @return {array} Parent elements.
         */
        getSurroundingParents: function(node, tagName, elementType, stopElem) {
          var parents = [];
          if (!node) {
            return parents;
          }
          stopElem = stopElem || this._viperElement;
          var parent = node.parentNode;
          while (parent) {
            if (stopElem && parent === stopElem) {
              break;
            }
            var c = parent.childNodes.length;
            if (c > 1) {
              for (var i = 0; i < c; i++) {
                var child = parent.childNodes[i];
                if (child.nodeType === ViperUtil.ELEMENT_NODE) {
                  if (child !== node) {
                    return parents;
                  }
                } else if (child !== node && ViperUtil.isBlank(ViperUtil.trim(child.data)) !== true) {
                  return parents;
                }
              }
            }
            if (!tagName) {
              var isOfType = false;
              if (elementType) {
                switch (elementType) {
                  case "block":
                    isOfType = ViperUtil.isBlockElement(parent);
                    break;
                  case "stub":
                    isOfType = isStubElement(parent);
                    break;
                  default:
                    if (parent.nodeType === ViperUtil.ELEMENT_NODE && ViperUtil.isBlockElement(parent) === false) {
                      isOfType = true;
                    }
                    break;
                }
              } else {
                isOfType = true;
              }
              if (isOfType) {
                parents.push(parent);
              }
            } else if (ViperUtil.isTag(parent, tagName) === true) {
              parents.push(parent);
            }
            node = parent;
            parent = parent.parentNode;
          }
          return parents;
        },
        getTopSurroundingParent: function(node, tagName, elementType, stopElem) {
          var parents = this.getSurroundingParents(node, tagName, elementType, stopElem);
          if (parents.length > 0) {
            return parents.pop();
          }
        },
        hasSurroundingParent: function(element, parentTagName, stopEl) {
          var parents = this.getSurroundingParents(element, parentTagName, null, stopEl);
          if (parents.length > 0) {
            return true;
          }
          return false;
        },
        getSurroundedChildren: function(element, asTagNames) {
          var children = [];
          if (!element) {
            return children;
          }
          if (element.childNodes.length !== 1 || element.firstChild.nodeType !== ViperUtil.ELEMENT_NODE) {
            return children;
          }
          if (asTagNames === true) {
            children.push(ViperUtil.getTagName(element.firstChild));
          } else {
            children.push(element.firstChild);
          }
          children = children.concat(this.getSurroundedChildren(element.firstChild));
          return children;
        },
        getBlockChildren: function(parent) {
          var children = [];
          var c = parent.childNodes.length;
          for (var i = 0; i < c; i++) {
            if (parent.childNodes[i].nodeType === this.ELEMENT_NODE) {
              if (this.isBlockElement(parent.childNodes[i]) === true) {
                children.push(parent.childNodes[i]);
              }
            }
          }
          return children;
        },
        hasBlockChildren: function(parent) {
          var c = parent.childNodes.length;
          for (var i = 0; i < c; i++) {
            if (parent.childNodes[i].nodeType === this.ELEMENT_NODE) {
              if (this.isBlockElement(parent.childNodes[i]) === true) {
                return true;
              }
            }
          }
          return false;
        },
        /**
         * Returns the parent element where the specified element is the last deepest child.
         * E.g. <p>This is an <strong><em>example <sub>text</sub></em>..</strong></p>.
         * Given "text" "em" will be returned.
         */
        getTopEndParent: function(element, includeBlockElements, stopElem) {
          if (!element) {
            return null;
          }
          stopElem = stopElem || this._viperElement;
          var parent = element.parentNode;
          if (includeBlockElements !== true && ViperUtil.isBlockElement(parent) === true) {
            return null;
          }
          while (!parent.nextSibling && (includeBlockElements === true || ViperUtil.isBlockElement(parent) === false)) {
            if (parent === stopElem) {
              break;
            }
            parent = parent.parentNode;
          }
          return parent;
        },
        elementIsEmpty: function(elem) {
          if (this.isBlank(this.getNodeTextContent(elem)) === true) {
            var tags = this.getTag("*", elem);
            var ln = tags.length;
            for (var i = 0; i < ln; i++) {
              if (this.isStubElement(tags[i]) === true) {
                return false;
              }
            }
            return true;
          }
          return false;
        },
        isChildOfElems: function(el, parents) {
          while (el && el.parentNode) {
            if (this.inArray(el.parentNode, parents) === true) {
              return true;
            }
            el = el.parentNode;
          }
          return false;
        },
        /**
         * Returns true if the specified element(s) is a child of parent.
         */
        isChildOf,
        /**
         * Returns elements between fromElem and toElem.
         * Example:
         * <div>text
         *    <span id="x">SPAN</span>
         *    <br />
         *    <p>
         *          <strong>text</strong>
         *    </p>
         * </div>
         *  <div>
         *    <div id="a">AAAA</div>
         *    <div id="y">xxxxx</div>
         *  </div>
         * Calling getElementsFromTo(x, y);
         * Result: [br, p, div(id=a)]
         */
        getElementsBetween: function(fromElem, toElem, range) {
          var elements = [];
          if (!fromElem || !toElem) {
            return elements;
          }
          if (fromElem === toElem) {
            return elements;
          }
          if (ViperUtil.isChildOf(toElem, fromElem) === true) {
            var fElemLen = fromElem.childNodes.length;
            for (var i = 0; i < fElemLen; i++) {
              if (fromElem.childNodes[i] === toElem) {
                break;
              } else if (ViperUtil.isChildOf(toElem, fromElem.childNodes[i]) === true) {
                return ViperUtil.arrayMerge(elements, ViperUtil.getElementsBetween(fromElem.childNodes[i], toElem));
              } else {
                elements.push(fromElem.childNodes[i]);
              }
            }
            return elements;
          }
          var startEl = fromElem.nextSibling;
          while (startEl) {
            if (ViperUtil.isChildOf(toElem, startEl) === true) {
              elements = ViperUtil.arrayMerge(elements, ViperUtil.getElementsBetween(startEl, toElem));
              return elements;
            } else if (startEl === toElem) {
              return elements;
            } else {
              elements.push(startEl);
              startEl = startEl.nextSibling;
            }
          }
          var fromParents = ViperUtil.getParents(fromElem);
          var toParents = ViperUtil.getParents(toElem);
          var parentElems = ViperUtil.arrayDiff(fromParents, toParents, true);
          var pElemLen = parentElems.length;
          for (var j = 0; j < pElemLen - 1; j++) {
            elements = ViperUtil.arrayMerge(elements, ViperUtil.getSiblings(parentElems[j], "next"));
          }
          var lastParent = parentElems[parentElems.length - 1];
          if (lastParent) {
            elements = ViperUtil.arrayMerge(elements, ViperUtil.getElementsBetween(lastParent, toElem));
            if (lastParent.firstChild === lastParent.lastChild && lastParent.firstChild === fromElem && lastParent !== toElem && (!range || range.startOffset === 0)) {
              elements.push(lastParent);
            }
          }
          return elements;
        },
        /**
         * Returns the siblings of the element.
         *
         * @param DomNode element          The element.
         * @param string  dir              Direction of the siblings. (values: prev, next).
         * @param boolean elementNodesOnly If true then only the ELEMENT_NODEs will be returned.
         *                                 Other nodes like TEXT_NODE will be ignored.
         * @param DomNode stopElem         If specified any sibling from stopElem will not be returned.
         */
        getSiblings: function(element, dir, elementNodesOnly, stopElem) {
          if (elementNodesOnly === true) {
            if (dir === "prev") {
              return prevAll(element);
            } else {
              return nextAll(element);
            }
          } else {
            var elems = [];
            if (dir === "prev") {
              while (element.previousSibling) {
                element = element.previousSibling;
                if (element === stopElem) {
                  break;
                }
                elems.push(element);
              }
            } else {
              while (element.nextSibling) {
                element = element.nextSibling;
                if (element === stopElem) {
                  break;
                }
                elems.push(element);
              }
            }
            return elems;
          }
        },
        /**
         * Returns true if the specified element is paret of the DOM tree.
         *
         * @param {DOMNode} element The element to check.
         *
         * @return {boolean}
         */
        isPartOfDOM,
        /**
         * Merges an array of any type similiar to PHP.
         *
         * If array1 is a JS array the elements will simply be added to the end of array1.
         * If array1 is an object the arrays will be merged maintaining keys and if a key
         * for an element exists in array2 which is the same as array 1 the value in array2
         * will overwrite in array1.
         *
         * @param {array|object} array1 First array to merge into.
         * @param {array|object} array2 Second array to merge in.
         *
         * @return {array|object}
         */
        arrayMerge: function(array1, array2) {
          if (array1 instanceof Array) {
            var maintainIndex = false;
          } else {
            var maintainIndex = true;
          }
          ViperUtil.foreach(array2, function(idx) {
            var value = array2[idx];
            if (maintainIndex === true) {
              array1[idx] = value;
            } else {
              array1.push(value);
            }
          });
          return array1;
        },
        /**
         * Loop through object or array.
         */
        foreach: function(value, cb) {
          if (value instanceof Array) {
            var len = value.length;
            for (var i = 0; i < len; i++) {
              var res = cb.call(this, i);
              if (res === false) {
                break;
              }
            }
          } else {
            for (var id in value) {
              if (value.hasOwnProperty(id) === true) {
                var res = cb.call(this, id);
                if (res === false) {
                  break;
                }
              }
            }
          }
        },
        /**
         * Sets/Gets the attribute for specified element(s).
         *
         * @param mixed element Element(s) to modify.
         * @param mixed key     Key can the the attribute name or key/value object.
         * @param mixed value   Value can be string, number, function.
         *                      Ignored when key param is an object.
         */
        attr,
        removeAttr,
        /**
         * Returns the coordinates of a rectangle that will cover the element.
         *
         * Returns the coordinates of the top left corner (x1, y1) as well as the
         * bottom-right corner (x2, y2).
         *
         * @param {DomElement} element The element which we want the dimensions for.
         *
         * @return The 2 x and 2 y coordinates of the element's bounding rectangle.
         * @type   Object
         */
        getBoundingRectangle: function(element) {
          var coords = ViperUtil.getElementCoords(element);
          var width = ViperUtil.getElementWidth(element);
          var height = ViperUtil.getElementHeight(element);
          var result = {
            x1: parseInt(coords.x),
            y1: parseInt(coords.y),
            x2: parseInt(coords.x + width),
            y2: parseInt(coords.y + height)
          };
          return result;
        },
        /**
         * Returns the textual information within a text node.
         *
         * @param {Text} The node to reteive the text for.
         *
         * @return string
         * @type void
         */
        getNodeTextContent,
        getUniqueId: function() {
          var id = Math.ceil((1 + Math.random()) * 1e5).toString();
          id += Math.ceil((1 + Math.random()) * 1e5).toString();
          return id;
        },
        /**
         * Returns the object with the passed ID.
         *
         * @param {String}     id           The ID of the element to find.
         * @param {DomElement} startElement The element to search under (if omitted
         *                                  defaults to document).
         *
         * @return DomElement
         */
        getid: function(id, startElement) {
          if (!startElement) {
            startElement = document;
          }
          const element = startElement.getElementById(id);
          return element;
        },
        /**
         * Completely removes all content that is contained within the passed element.
         *
         * If the element was the following: <p id="mypara"><span>Content</span></p>,
         * when called with dom.empty(ViperUtil.getid('mypara')) the paragraph would become
         * <p id="mypara"></p>.
         *
         * @param {DomElement} element The element to empty.
         *
         * @return TRUE if the element is successfully emptied.
         * @type   boolean
         */
        empty,
        find,
        getFirstChildTextNode: function(node) {
          if (node.firstChild) {
            if (node.firstChild.nodeType === ViperUtil.ELEMENT_NODE) {
              return ViperUtil.getFirstChildTextNode(node.firstChild);
            } else {
              return node.firstChild;
            }
          } else if (node && node.nodeType === ViperUtil.TEXT_NODE) {
            return node;
          }
          return null;
        },
        getFirstElementChild: function(node) {
          if (node) {
            if (node.firstElementChild) {
              return node.firstElementChild;
            } else {
              var child = node.firstChild;
              while (child) {
                if (child.nodeType === ViperUtil.ELEMENT_NODE) {
                  return child;
                }
                child = child.nextSibling;
              }
            }
          }
          return null;
        },
        getLastChildTextNode: function(node) {
          if (node.lastChild) {
            if (node.lastChild.nodeType === ViperUtil.ELEMENT_NODE) {
              return ViperUtil.getLastChildTextNode(node.lastChild);
            } else {
              return node.lastChild;
            }
          } else if (node && node.nodeType === ViperUtil.TEXT_NODE) {
            return node;
          }
          return null;
        },
        copyAttributes: function(fromElem, toElem, override) {
          override = override || true;
          if (!fromElem || !toElem) {
            return;
          }
          for (var i = 0; i < fromElem.attributes.length; i++) {
            var attr2 = fromElem.attributes[i];
            if (override !== true || this.hasAttribute(toElem, attr2.name) === false) {
              this.attr(toElem, attr2.name, attr2.value);
            }
          }
        },
        hasAttribute: function(element, attribute) {
          if (element.hasAttribute) {
            return element.hasAttribute(attribute);
          } else if (element.getAttribute) {
            if (element.getAttribute(attribute) === null) {
              return false;
            } else {
              return true;
            }
          }
          return false;
        },
        /**
         * Returns true if the given element has valid content.
         *
         * E.g. <p><br /></p> will not return true but <p><img /></p> will return true.
         *
         */
        hasContent: function(element) {
          if (ViperUtil.isBlank(ViperUtil.getNodeTextContent(element)) === true) {
            var tags = ViperUtil.getTag("*", element);
            var ln = tags.length;
            for (var i = 0; i < ln; i++) {
              if (isStubElement(tags[i]) === true && ViperUtil.isTag(tags[i], "br") === false) {
                return true;
              }
            }
            return false;
          }
          return true;
        },
        /**
         * Returns the height of the element.
         *
         * By default, returns the "outer" dimensions, including padding and borders. If the
         * "inner" parameter is passed as true, the dimensions returned will exclude these.
         *
         * @param {DomElement} element The element which we want the height for.
         * @param {Boolean}    inner   true indicates inner dimensions wanted.
         *
         * @return integer
         */
        getElementHeight: function(element, inner) {
          if (inner === true) {
            return element.clientHeight;
          } else {
            return element.offsetHeight;
          }
        },
        /**
         * Returns the width of the element.
         *
         * By default, returns the "outer" dimensions, including padding and borders. If the
         * "inner" parameter is passed as true, the dimensions returned will exclude these.
         *
         * @param {DomElement} element The element which we want the width for.
         * @param {Boolean}    inner   true indicates inner dimensions wanted.
         *
         * @return integer
         */
        getElementWidth: function(element, inner) {
          if (inner === true) {
            return element.clientWidth;
          } else {
            return element.offsetWidth;
          }
        },
        isFn: function(f) {
          if (typeof f === "function") {
            return true;
          }
          return false;
        },
        /**
         * Returns the dimensions of the viewable window.
         *
         * @return The 2 x and 2 y coordinates of the viewable window.
         * @type   Object
         */
        getWindowDimensions: function(win) {
          win = win || window;
          var windowWidth = 0;
          var windowHeight = 0;
          if (win.innerWidth) {
            windowWidth = win.innerWidth;
            windowHeight = win.innerHeight;
            var scrollWidth = ViperUtil.getScrollbarWidth();
            if (win.document.documentElement.scrollHeight > windowHeight) {
              if (typeof scrollWidth === "number") {
                windowWidth -= scrollWidth;
              }
            }
            if (win.document.body.scrollWidth > windowWidth) {
              if (typeof scrollWidth === "number") {
                windowHeight -= scrollWidth;
              }
            }
          } else if (win.document.documentElement && (win.document.documentElement.clientWidth || win.document.documentElement.clientHeight)) {
            windowWidth = win.document.documentElement.clientWidth;
            windowHeight = win.document.documentElement.clientHeight;
          } else if (win.document.body && (win.document.body.clientWidth || win.document.body.clientHeight)) {
            windowWidth = win.document.body.clientWidth;
            windowHeight = win.document.body.clientHeight;
          }
          var result = {
            width: windowWidth,
            height: windowHeight
          };
          return result;
        },
        /**
         * Returns the current scroll position of the screen.
         *
         * @return Object
         * @type   Object
         */
        getScrollCoords: function(win) {
          win = win || window;
          var scrollX = 0;
          var scrollY = 0;
          if (win.pageYOffset) {
            scrollX = win.pageXOffset;
            scrollY = win.pageYOffset;
          } else if (win.document.body && (win.document.body.scrollLeft || win.document.body.scrollTop)) {
            scrollX = win.document.body.scrollLeft;
            scrollY = win.document.body.scrollTop;
          } else {
            scrollX = win.document.documentElement.scrollLeft;
            scrollY = win.document.documentElement.scrollTop;
          }
          var coords = {
            x: scrollX,
            y: scrollY
          };
          return coords;
        },
        getElementScrollCoords: function(element) {
          var scrollX = 0;
          var scrollY = 0;
          if (ViperUtil.isset(element.scrollLeft) === true) {
            scrollX = element.scrollLeft;
            scrollY = element.scrollTop;
          }
          var coords = {
            x: scrollX,
            y: scrollY
          };
          return coords;
        },
        /**
         * Returns the width of the scrollbar programmatically.
         *
         * This is necessary to determine the viewable browser window, as Firefox and
         * Opera only display the scrollbars when necessary and report their window
         * dimensions without the scrollbar. This method will create a div out of the
         * viewable range, and measure it with and without a scrollbar. The difference
         * is returned.
         * NB: This will only be run once, as the value is stored after execution.
         *
         * @return integer
         */
        getScrollbarWidth: function() {
          if (ViperUtil._scrollBarWidth) {
            return ViperUtil._scrollBarWidth;
          }
          var wrapDiv = null;
          var childDiv = null;
          var widthNoScrollBar = 0;
          var widthWithScrollBar = 0;
          wrapDiv = document.createElement("div");
          wrapDiv.style.position = "absolute";
          wrapDiv.style.top = "-1000px";
          wrapDiv.style.left = "-1000px";
          wrapDiv.style.width = "100px";
          wrapDiv.style.height = "50px";
          wrapDiv.style.overflow = "hidden";
          childDiv = document.createElement("div");
          childDiv.style.width = "100%";
          childDiv.style.height = "200px";
          wrapDiv.appendChild(childDiv);
          document.body.appendChild(wrapDiv);
          widthNoScrollBar = childDiv.offsetWidth;
          wrapDiv.style.overflow = "auto";
          widthWithScrollBar = childDiv.offsetWidth;
          document.body.removeChild(document.body.lastChild);
          var scrollBarWidth = widthNoScrollBar - widthWithScrollBar;
          ViperUtil._scrollBarWidth = scrollBarWidth;
          return scrollBarWidth;
        },
        /**
         * Retrieves the coordinate of the element relative to the page.
         *
         * @param {DomElement} el  The element which we want the coordinates for.
         *
         * @return Object
         */
        getElementCoords,
        getElementFrameElement: function(element) {
          if (element.ownerDocument.defaultView) {
            return element.ownerDocument.defaultView.frameElement;
          } else {
            return element.ownerDocument.frames.frameElement;
          }
          return null;
        },
        /**
         * Determines the position of the bubble given a target element.
         *
         * @param {DOMNode} element       The Bubble element.
         * @param {DOMNode} targetElement The element to point to.
         */
        determinePosition: function(element, settings) {
          settings = settings || {};
          const targetElement = settings.targetElement;
          const alignClassPrefix = settings.alignClassPrefix || "ViperUtil-align";
          const arrowClassPrefix = settings.arrowClassPrefix || "ViperUtil-arrow";
          var validPositions = {
            left: ["right.middle", "right.top", "right.bottom"],
            right: ["left.middle", "left.top", "left.bottom"],
            bottom: ["top.left", "top.middle", "top.right"],
            top: ["bottom.left", "bottom.middle", "bottom.right"]
          };
          var classNames = ["top", "left", "right", "bottom", "middle", "center"];
          ViperUtil.foreach(classNames, function(i) {
            ViperUtil.removeClass(element, alignClassPrefix + classNames[i]);
            ViperUtil.removeClass(element, arrowClassPrefix + classNames[i]);
          });
          if (this.isElementOffScreen(targetElement) === true) {
            var relPos = ViperUtil.getRelativeWindowPosition(
              targetElement.ownerDocument.defaultView.frameElement,
              element.ownerDocument.defaultView.frameElement
            );
            ViperUtil.setStyle(element, "left", relPos.x + "px");
            ViperUtil.setStyle(element, "top", relPos.y + "px");
            return;
          }
          var relPos = ViperUtil.getRelativeWindowPosition(targetElement, this.getElementFrameElement(element));
          var targetRect = {};
          targetRect.x1 = relPos.x;
          targetRect.y1 = relPos.y;
          targetRect.x2 = relPos.x + ViperUtil.getElementWidth(targetElement);
          targetRect.y2 = relPos.y + ViperUtil.getElementHeight(targetElement);
          var elemRect = ViperUtil.getBoundingRectangle(element);
          var elemH = elemRect.y2 - elemRect.y1;
          var elemW = elemRect.x2 - elemRect.x1;
          var winDim = ViperUtil.getWindowDimensions(element.ownerDocument.defaultView);
          var targetMidX = 0;
          var targetMidY = 0;
          var self = this;
          var _positionElement = function(position2, arrowPositions) {
            switch (position2) {
              case "top":
                targetMidX = targetRect.x1 + (targetRect.x2 - targetRect.x1) / 2;
                targetMidY = targetRect.y1;
                break;
              case "bottom":
                targetMidX = targetRect.x1 + (targetRect.x2 - targetRect.x1) / 2;
                targetMidY = targetRect.y2;
                break;
              case "left":
                targetMidX = targetRect.x1;
                targetMidY = targetRect.y1 + (targetRect.y2 - targetRect.y1) / 2;
                break;
              case "right":
                targetMidX = targetRect.x2;
                targetMidY = targetRect.y1 + (targetRect.y2 - targetRect.y1) / 2;
                break;
              default:
                return false;
            }
            var oln = arrowPositions.length;
            var arrowElemWidth = 19;
            var arrowElemHeight = 31;
            var arrowPadding = 15;
            for (var o = 0; o < oln; o++) {
              var posX = 0;
              var posY = 0;
              var classParts = arrowPositions[o].split(".");
              switch (classParts[0]) {
                case "top":
                  posY = targetMidY;
                  break;
                case "bottom":
                  posY = targetMidY - elemH;
                  break;
                case "right":
                  posX = targetMidX - elemW - arrowElemWidth;
                  break;
                case "left":
                  posX = targetMidX;
                  break;
                default:
                  break;
              }
              switch (classParts[1]) {
                case "left":
                  posX = targetMidX;
                  break;
                case "right":
                  posX = targetMidX - elemW;
                  break;
                case "middle":
                  if (classParts[0] === "top" || classParts[0] === "bottom") {
                    classParts[1] = "center";
                    posX = targetMidX - elemW / 2;
                  } else {
                    posY = targetMidY - elemH / 2;
                  }
                  break;
                case "top":
                  posY = targetMidY - arrowElemHeight / 2 - arrowPadding;
                  break;
                case "bottom":
                  posY = targetMidY - (elemH - arrowElemHeight / 2 - arrowPadding);
                  break;
                default:
                  break;
              }
              var scrollCoords = ViperUtil.getScrollCoords(element.ownerDocument.defaultView);
              if (settings.fixedPositioning === true) {
                posX = Math.abs(posX);
                posY = Math.abs(posY);
              } else {
                posX += scrollCoords.x;
                posY += scrollCoords.y;
              }
              ViperUtil.addClass(element, arrowClassPrefix + classParts[0]);
              ViperUtil.addClass(element, alignClassPrefix + classParts[1]);
              ViperUtil.setStyle(element, "left", posX + "px");
              ViperUtil.setStyle(element, "top", posY + "px");
              if (self.isElementCutOff(element) === false) {
                return true;
              } else {
                ViperUtil.removeClass(element, arrowClassPrefix + classParts[0]);
                ViperUtil.removeClass(element, alignClassPrefix + classParts[1]);
              }
            }
            return false;
          };
          var positioned = false;
          if (settings.position) {
            positioned = _positionElement(settings.position, settings.arrowPositions);
          }
          if (positioned === false) {
            for (var pos in validPositions) {
              if (_positionElement(pos, validPositions[pos]) === true) {
                return;
              }
            }
          }
        },
        isElementOffScreen: function(element) {
          var coords = ViperUtil.getElementCoords(element);
          var dims = ViperUtil.getElementDimensions(element);
          var scrollCoords = ViperUtil.getScrollCoords(element.ownerDocument.defaultView);
          var windowDims = ViperUtil.getWindowDimensions(element.ownerDocument.defaultView);
          coords.x -= scrollCoords.x;
          coords.y -= scrollCoords.y;
          if (coords.y + dims.height < 0 || coords.y > windowDims.height || coords.x + dims.width < 0 || coords.x > windowDims.width) {
            return true;
          }
          return false;
        },
        height: (element) => {
          if (!element) {
            return 0;
          } else if (element === window) {
            return ViperUtil.getWindowDimensions(element).height;
          }
          const styles = window.getComputedStyle(element);
          const height = styles.getPropertyValue("height");
          return parseFloat(height);
        },
        width: (element) => {
          if (!element) {
            return 0;
          } else if (element === window) {
            return ViperUtil.getWindowDimensions(element).width;
          }
          const styles = window.getComputedStyle(element);
          const width = styles.getPropertyValue("width");
          return parseFloat(width);
        },
        /**
         * Returns true if the element is cut off due to its position in window or iframe.
         */
        isElementCutOff: function(element) {
          var win = element.ownerDocument.defaultView || window;
          var scrollCoords = ViperUtil.getScrollCoords(win);
          var winHeight = ViperUtil.height(win);
          var winWidth = ViperUtil.width(win);
          var relPos = ViperUtil.getRelativeWindowPosition(element);
          var elDim = ViperUtil.getElementDimensions(element);
          var coords = ViperUtil.getElementCoords(element, true);
          coords.x -= scrollCoords.x;
          coords.y -= scrollCoords.y;
          if (coords.y < 0 || coords.y + elDim.height > winHeight || coords.x < 0 || coords.x + elDim.width > winWidth) {
            return true;
          }
          while (win.frameElement) {
            win = win.frameElement.ownerDocument.defaultView;
            var parentHeight = ViperUtil.height(win);
            var parentWidth = ViperUtil.width(win);
            if (parentHeight < winHeight) {
              winHeight = parentHeight;
            }
            if (parentWidth < winWidth) {
              winWidth = parentWidth;
            }
          }
          if (relPos.y < 0 || relPos.y + elDim.height > winHeight || relPos.x < 0 || relPos.x + elDim.width > winWidth) {
            return true;
          }
          return false;
        },
        isIntersectingRect: function(rect1, rect2) {
          if (rect2.x1 > rect1.x2 || rect2.x2 < rect1.x1 || rect2.y1 > rect1.y2 || rect2.y2 < rect1.y1) {
            return false;
          }
          return true;
        },
        /**
         * Returns the absolute dimensions of the passed element.
         *
         * By default, returns the "outer" dimensions, including padding and borders. If the
         * "inner" parameter is passed as true, the dimensions returned will exclude these.
         *
         * @param {DomElement} element The element which we want the dimensions for.
         * @param {Boolean}    inner   true indicates inner dimensions wanted.
         *
         * @return Object
         */
        getElementDimensions: function(element, inner) {
          if (inner === void 0) {
            inner = false;
          }
          var result = {
            width: ViperUtil.getElementWidth(element, inner),
            height: ViperUtil.getElementHeight(element, inner)
          };
          return result;
        },
        /**
         * Returns the position of the element relative to the specified top frame.
         *
         * @param {DomElement} elem     The element.
         * @param {DomElement} topFrame The most outer frame or null for main frame.
         *
         * @return void
         */
        getRelativeWindowPosition: function(elem, topFrame) {
          var offset = null;
          var frameElement = this.getElementFrameElement(elem);
          if (frameElement) {
            offset = ViperUtil.getElementCoords(elem);
            if (frameElement !== topFrame) {
              var frameOffset = ViperUtil.getRelativeWindowPosition(frameElement, topFrame);
              offset.x += frameOffset.x;
              offset.y += frameOffset.y;
            }
          } else {
            offset = ViperUtil.getElementCoords(elem);
          }
          var scrollCoords = ViperUtil.getScrollCoords(elem.ownerDocument.defaultView);
          offset.y -= scrollCoords.y;
          offset.x -= scrollCoords.x;
          return offset;
        },
        removeEmptyNodes: function(parent, callback) {
          var elems = ViperUtil.find(parent, ":empty");
          var i = elems.length;
          var removed = false;
          while (i > 0) {
            i--;
            if (isStubElement(elems[i]) === false) {
              if (!callback || callback.call(this, elems[i]) !== false) {
                remove(elems[i]);
                removed = true;
              }
            }
          }
          if (removed === true) {
            this.removeEmptyNodes(parent, callback);
          }
        },
        /**
         * Returns a unique path for the given node.
         *
         * @param DOMNode node The node to retrieve the path for.
         *
         * @return string the path.
         */
        getXPath: function(node) {
          var path = "";
          while (node && node.parentNode) {
            if (node.nodeType === ViperUtil.TEXT_NODE) {
              var sibling = node.previousSibling;
              var pos = 1;
              while (sibling) {
                pos++;
                sibling = sibling.previousSibling;
              }
              if (pos <= 1) {
                path = "/node()";
              } else {
                path = "/node()[" + pos + "]";
              }
            } else {
              var nodeName = node.nodeName.toLowerCase();
              var sibling = node.previousSibling;
              var pos = 1;
              while (sibling) {
                if (sibling.nodeType === ViperUtil.ELEMENT_NODE && nodeName === sibling.nodeName.toLowerCase()) {
                  pos++;
                }
                sibling = sibling.previousSibling;
              }
              if (pos <= 1) {
                path = "/" + nodeName + path;
              } else {
                path = "/" + nodeName + "[" + pos + "]" + path;
              }
            }
            node = node.parentNode;
          }
          return path;
        },
        /**
         * Returns the node within the document for the specified path.
         *
         * @param string path The path for the wanted node.
         *
         * @return DOMNode
         */
        getNodeFromXPath: function(path) {
          if (document.evaluate) {
            var node = document.evaluate(path, document, null, XPathResult.FIRST_ORDERED_NODE_TYPE, null);
            return node.singleNodeValue;
          } else {
            return ViperUtil.getNodeFromPath(path);
          }
        },
        /**
         * Provides an domtree traversal method for retrieving the node for the
         * specified path.
         *
         * @param string path The path for the wanted node.
         *
         * @return DOMNode
         */
        getNodeFromPath: function(path) {
          var paths = path.split("/");
          var parent = document;
          var pln = paths.length;
          for (var i = 0; i < pln; i++) {
            if (ViperUtil.trim(paths[i]) === "") {
              continue;
            }
            parent = ViperUtil.getNodeFromPathSegment(parent, paths[i]);
          }
          return parent;
        },
        /**
         * Returns the node for the specified path segment under the specified parent.
         *
         * @param DOMElement parent The parent to retreive the child for.
         * @param string     path   The path segment that identifies the child.
         *
         * @return DOMNode
         */
        getNodeFromPathSegment: function(parent, path) {
          var pos = path.match(/\[(\d+)\]/);
          if (!pos) {
            pos = 1;
          } else {
            pos = parseInt(pos[1]);
            if (!pos) {
              pos = 1;
            }
          }
          var brPos = path.indexOf("[") || path.length;
          var type = path.substr(0, brPos);
          if (!type) {
            type = path;
          }
          var node, found = 1;
          var cln = parent.childNodes.length;
          for (var i = 0; i < cln; i++) {
            node = parent.childNodes[i];
            if (node.nodeType === ViperUtil.DOCUMENT_TYPE_NODE) {
              continue;
            }
            if (type === "node()") {
              if (found === pos) {
                return node;
              }
              found++;
            } else if (node.nodeName && type === node.nodeName.toLowerCase()) {
              if (found === pos) {
                return node;
              }
              found++;
            }
          }
          throw Error("XPath: node could not be found");
        },
        getFrames: function(doc) {
          doc = doc || document;
          if (doc.frames) {
            return doc.frames;
          } else if (doc.defaultView.frames) {
            return doc.defaultView.frames;
          }
          return [];
        },
        /**
         * Returns the loaded DOM Documents (main window, iframes, etc).
         *
         * @return {array}
         */
        getDocuments: function(nested, parentDoc) {
          parentDoc = parentDoc || document;
          var docs = [parentDoc];
          var frames = this.getFrames(parentDoc);
          var c = frames.length;
          for (var i = 0; i < c; i++) {
            var doc = this.getIFrameDocument(frames[i]);
            if (doc !== null) {
              if (nested === true) {
                docs = docs.concat(this.getDocuments(nested, doc));
              } else {
                docs.push(doc);
              }
            }
          }
          return docs;
        },
        getTopDocument: function() {
          var doc = document;
          while (doc.defaultView.frameElement) {
            doc = doc.defaultView.frameElement.ownerDocument;
          }
          return doc;
        },
        /**
         * Returns the document element for the specified iframe.
         *
         * @param {IFrameElement} iframe The iframe to retreive the document for.
         *
         * @return {DocumentElement}
         */
        getIFrameDocument: function(iframe) {
          var doc = null;
          try {
            if (iframe.contentDocument) {
              doc = iframe.contentDocument;
            } else if (iframe.contentWindow) {
              doc = iframe.contentWindow.document;
            } else if (iframe.document) {
              doc = iframe.document;
            }
          } catch (e) {
            doc = null;
          }
          return doc;
        },
        getDocumentOffset: function(doc) {
          var doc = doc || Viper2.document;
          var offset = {
            x: 0,
            y: 0
          };
          while (document !== doc) {
            var frameElem = doc.defaultView.frameElement;
            if (!frameElem) {
              continue;
            }
            var coords = this.getElementCoords(frameElem);
            offset.x += coords.x;
            offset.y += coords.y;
            doc = frameElem.ownerDocument;
          }
          return offset;
        },
        getDocumentWindow: function() {
          return Viper2.document.defaultView;
        },
        /**
         * Very basic implementation of sprintf.
         *
         * Currently only supports replacement of %s in the specified string.
         * Usage: ViperUtil.sprintf('Very %s implementation of %s.', 'basic', 'sprintf');
         */
        sprintf: function(str) {
          var c = arguments.length;
          if (c <= 1) {
            return str;
          }
          for (var i = 1; i < c; i++) {
            str = str.replace(/%s/, arguments[i]);
          }
          return str;
        },
        walk: function(elem, callback, stopElem, lvl) {
          if (!elem || elem === stopElem) {
            return false;
          }
          if (!lvl) {
            lvl = 0;
          }
          var nextSibling = elem.nextSibling;
          var parentNode = elem.parentNode;
          var retVal = callback.call(this, elem, lvl);
          if (retVal === false) {
            return false;
          } else if (retVal instanceof Object) {
            nextSibling = retVal;
          }
          if (elem.childNodes && elem.childNodes.length > 0) {
            if (ViperUtil.walk(elem.firstChild, callback, stopElem, lvl + 1) === false) {
              return false;
            }
          } else if (nextSibling) {
            if (ViperUtil.walk(nextSibling, callback, stopElem, lvl) === false) {
              return false;
            }
          } else {
            while (parentNode && !parentNode.nextSibling) {
              parentNode = parentNode.parentNode;
              lvl--;
            }
            if (!parentNode) {
              return false;
            }
            if (ViperUtil.walk(parentNode.nextSibling, callback, stopElem, lvl - 1) === false) {
              return false;
            }
          }
        },
        /**
         * Set the textual information within a text node.
         *
         * @param {Text} The node to manipulate.
         * @param {String} Text value of the node.
         *
         * @return void
         * @type void
         */
        setNodeTextContent,
        /**
         * Implements inheritance for two classes.
         *
         * @param {funcPtr} child  The class that is inheriting the parent methods.
         * @param {funcPtr} parent The parent that is being implemented.
         *
         * @return void
         * @type   void
         */
        inherits: function(child, parent) {
          var above = function() {
          };
          if (ViperUtil.isset(parent) === true) {
            for (let value in parent.prototype) {
              if (child.prototype[value]) {
                above.prototype[value] = parent.prototype[value];
                continue;
              }
              child.prototype[value] = parent.prototype[value];
            }
          }
          if (child.prototype) {
            above.prototype.constructor = parent;
            child.prototype["super"] = new above();
          }
        },
        isArray: function(v) {
          return Array.isArray(v);
        },
        /**
         * Return TRUE if the value exists in an array..
         *
         * @param {String}  needle        The item you are looking for.
         * @param {array}   haystack      The array to look through.
         * @param {boolean} typeSensitive Type sensitive comparison - default is true.
         *
         * @return {String}
         */
        inArray: function(needle, haystack, typeSensitive) {
          if (ViperUtil.isset(typeSensitive) === false) {
            typeSensitive = true;
          }
          var hln = haystack.length;
          for (var i = 0; i < hln; i++) {
            if (typeSensitive === true && needle === haystack[i] || typeSensitive === false && needle == haystack[i]) {
              return true;
            }
          }
          return false;
        },
        /*
         * Searches the array for the given item.
         *
         * Returns the item index if found, else false.
         *
         * @param mixed needle   Item to search in the specified array.
         * @param array haystack The array.
         *
         * @return int
         */
        arraySearch: function(needle, haystack) {
          var length = haystack.length;
          for (var i = 0; i < length; i++) {
            if (haystack[i] === needle) {
              return i;
            }
          }
          return -1;
        },
        removeArrayIndex: function(array, index) {
          if (!array || index >= array.length) {
            return null;
          }
          return array.splice(index, 1);
        },
        /**
         * Computes the difference of two arrays.
         * If firstOnly is set to TRUE then only the elements that are in first array
         * but not in the second array will be returned.
         */
        arrayDiff: function(array1, array2, firstOnly) {
          var al = array1.length;
          var res = [];
          for (var i = 0; i < al; i++) {
            if (ViperUtil.inArray(array1[i], array2) === false) {
              res.push(array1[i]);
            }
          }
          if (firstOnly !== true) {
            al = array2.length;
            for (var i = 0; i < al; i++) {
              if (ViperUtil.inArray(array2[i], array1) === false) {
                res.push(array2[i]);
              }
            }
          }
          return res;
        },
        arrayIntersect: function(array1, array2) {
          var newArray = [];
          var n1c = array1.length;
          var n2c = array2.length;
          for (var i = 0; i < n1c; i++) {
            if (newArray.length === n2c) {
              break;
            }
            for (var j = 0; j < n2c; j++) {
              if (array1[i] === array2[j]) {
                newArray.push(array1[i]);
                break;
              }
            }
          }
          return newArray;
        },
        arrayUnique: function(array) {
          var tmp = {};
          var newArray = [];
          var ln = array.length;
          for (var i = 0; i < ln; i++) {
            if (tmp[array[i]] === true) {
              continue;
            }
            tmp[array[i]] = true;
            newArray.push(array[i]);
          }
          return newArray;
        },
        /**
         * returns an ellipsized string.
         *
         * @param {String} value The string to trim.
         *
         * @return {String}
         */
        ellipsize: function(value, length) {
          if (typeof value !== "string" || typeof length !== "number") {
            return "";
          }
          if (length < 0) {
            return "";
          }
          if (value.length <= length) {
            return value;
          }
          value = value.substr(0, length);
          value = value.replace(/\s$/, "");
          var end = value.substr(length - 3, 3);
          var endNoDots = end.replace(/\.$/, "");
          var numDots = end.length - endNoDots.length;
          value = value + ViperUtil.strRepeat(".", 3 - numDots);
          return value;
        },
        strRepeat: function(str, multiplier) {
          var rstr = "";
          for (var i = 0; i < multiplier; i++) {
            rstr += str;
          }
          return rstr;
        },
        stripTags: function(content, allowedTags) {
          var match;
          var re = new RegExp(/<\/?(\w+)((\s+\w+(\s*=\s*(?:".*?"|'.*?'|[^'">\s]+))?)+\s*|\s*)\/?>/gim);
          var resCont = content;
          while ((match = re.exec(content)) != null) {
            if (ViperUtil.isset(allowedTags) === false || ViperUtil.inArray(match[1], allowedTags) !== true) {
              resCont = resCont.replace(match[0], "");
            }
          }
          return resCont;
        },
        commonEntitiesArray: {
          160: "&nbsp;",
          // space
          168: "&uml;",
          //  ¨
          169: "&copy;",
          //  ©
          170: "&ordf;",
          //  ª
          171: "&laquo;",
          //  «
          172: "&not;",
          //  ¬
          173: "&shy;",
          //  ­
          174: "&reg;",
          //  ®
          175: "&macr;",
          //  ¯
          176: "&deg;",
          //  °
          177: "&plusmn;",
          //  ±
          178: "&sup2;",
          //  ²
          179: "&sup3;",
          //  ³
          180: "&acute;",
          //  ´
          181: "&micro;",
          //  µ
          182: "&para;",
          //  ¶
          183: "&middot;",
          //  ·
          184: "&cedil;",
          //  ¸
          185: "&sup1;",
          //  ¹
          186: "&ordm;",
          //  º
          187: "&raquo;",
          //  »
          188: "&frac14;",
          //  ¼
          189: "&frac12;",
          //  ½
          190: "&frac34;",
          //  ¾
          191: "&iquest;",
          //  ¿
          215: "&times;",
          //  ×
          247: "&divide;",
          //  ÷
          977: "&thetasym;",
          //  ϑ
          978: "&upsih;",
          //  ϒ
          982: "&piv;",
          //  ϖ
          8216: "&lsquo;",
          //  ‘
          8217: "&rsquo;",
          //  ’
          8218: "&sbquo;",
          //  ‚
          8220: "&ldquo;",
          //  “
          8221: "&rdquo;",
          //  ”
          8222: "&bdquo;",
          //  „
          8223: "&ldquo;",
          //  “
          8226: "&bull;",
          //  *
          8230: "&hellip;",
          //  …
          8242: "&prime;",
          //  ′
          8243: "&Prime;",
          //  ″
          8254: "&oline;",
          //  ‾
          8260: "&frasl;",
          //  ⁄
          8472: "&weierp;",
          //  ℘
          8465: "&image;",
          //  ℑ
          8476: "&real;",
          //  ℜ
          8482: "&trade;",
          //  ™
          8501: "&alefsym;",
          //  ℵ
          8592: "&larr;",
          //  ←
          8593: "&uarr;",
          //  ↑
          8594: "&rarr;",
          //  →
          8595: "&darr;",
          //  ↓
          8596: "&harr;",
          //  ↔
          8629: "&crarr;",
          //  ↵
          8656: "&lArr;",
          //  ⇐
          8657: "&uArr;",
          //  ⇑
          8658: "&rArr;",
          //  ⇒
          8659: "&dArr;",
          //  ⇓
          8660: "&hArr;",
          //  ⇔
          8704: "&forall;",
          //  ∀
          8706: "&part;",
          //  ∂
          8707: "&exist;",
          //  ∃
          8709: "&empty;",
          //  ∅
          8711: "&nabla;",
          //  ∇
          8712: "&isin;",
          //  ∈
          8713: "&notin;",
          //  ∉
          8715: "&ni;",
          //  ∋
          8719: "&prod;",
          //  ∏
          8721: "&sum;",
          //  ∑
          8722: "&minus;",
          //  −
          8727: "&lowast;",
          //  ∗
          8730: "&radic;",
          //  √
          8733: "&prop;",
          //  ∝
          8734: "&infin;",
          //  ∞
          8736: "&ang;",
          //  ∠
          8743: "&and;",
          //  ∧
          8744: "&or;",
          //  ∨
          8745: "&cap;",
          //  ∩
          8746: "&cup;",
          //  ∪
          8747: "&int;",
          //  ∫
          8756: "&there4;",
          //  ∴
          8764: "&sim;",
          //  ∼
          8773: "&cong;",
          //  ≅
          8776: "&asymp;",
          //  ≈
          8800: "&ne;",
          //  ≠
          8801: "&equiv;",
          //  ≡
          8804: "&le;",
          //  ≤
          8805: "&ge;",
          //  ≥
          8834: "&sub;",
          //  ⊂
          8835: "&sup;",
          //  ⊃
          8836: "&nsub;",
          //  ⊄
          8838: "&sube;",
          //  ⊆
          8839: "&supe;",
          //  ⊇
          8853: "&oplus;",
          //  ⊕
          8855: "&otimes;",
          //  ⊗
          8869: "&perp;",
          //  ⊥
          8901: "&sdot;",
          //  ⋅
          8968: "&lceil;",
          //  ⌈
          8969: "&rceil;",
          //  ⌉
          8970: "&lfloor;",
          //  ⌊
          8971: "&rfloor;",
          //  ⌋
          9001: "&lang;",
          //  ⟨
          9002: "&rang;",
          //  ⟩
          9674: "&loz;",
          //  ◊
          9824: "&spades;",
          //  ♠
          9827: "&clubs;",
          //  ♣
          9829: "&hearts;",
          //  ♥
          9830: "&diams;"
          //  ♦
        },
        alphabetEntitiesArray: {
          161: "&iexcl;",
          //  ¡
          162: "&cent;",
          //  ¢
          163: "&pound;",
          //  £
          164: "&curren;",
          //  ¤
          165: "&yen;",
          //  ¥
          166: "&brvbar;",
          //  ¦
          167: "&sect;",
          //  §
          192: "&Agrave;",
          //  À
          193: "&Aacute;",
          //  Á
          194: "&Acirc;",
          //  Â
          195: "&Atilde;",
          //  Ã
          196: "&Auml;",
          //  Ä
          197: "&Aring;",
          //  Å
          198: "&AElig;",
          //  Æ
          199: "&Ccedil;",
          //  Ç
          200: "&Egrave;",
          //  È
          201: "&Eacute;",
          //  É
          202: "&Ecirc;",
          //  Ê
          203: "&Euml;",
          //  Ë
          204: "&Igrave;",
          //  Ì
          205: "&Iacute;",
          //  Í
          206: "&Icirc;",
          //  Î
          207: "&Iuml;",
          //  Ï
          208: "&ETH;",
          //  Ð
          209: "&Ntilde;",
          //  Ñ
          210: "&Ograve;",
          //  Ò
          211: "&Oacute;",
          //  Ó
          212: "&Ocirc;",
          //  Ô
          213: "&Otilde;",
          //  Õ
          214: "&Ouml;",
          //  Ö
          216: "&Oslash;",
          //  Ø
          217: "&Ugrave;",
          //  Ù
          218: "&Uacute;",
          //  Ú
          219: "&Ucirc;",
          //  Û
          220: "&Uuml;",
          //  Ü
          221: "&Yacute;",
          //  Ý
          222: "&THORN;",
          //  Þ
          223: "&szlig;",
          //  ß
          224: "&agrave;",
          //  à
          225: "&aacute;",
          //  á
          226: "&acirc;",
          //  â
          227: "&atilde;",
          //  ã
          228: "&auml;",
          //  ä
          229: "&aring;",
          //  å
          230: "&aelig;",
          //  æ
          231: "&ccedil;",
          //  ç
          232: "&egrave;",
          //  è
          233: "&eacute;",
          //  é
          234: "&ecirc;",
          //  ê
          235: "&euml;",
          //  ë
          236: "&igrave;",
          //  ì
          237: "&iacute;",
          //  í
          238: "&icirc;",
          //  î
          239: "&iuml;",
          //  ï
          240: "&eth;",
          //  ð
          241: "&ntilde;",
          //  ñ
          242: "&ograve;",
          //  ò
          243: "&oacute;",
          //  ó
          244: "&ocirc;",
          //  ô
          245: "&otilde;",
          //  õ
          246: "&ouml;",
          //  ö
          248: "&oslash;",
          //  ø
          249: "&ugrave;",
          //  ù
          250: "&uacute;",
          //  ú
          251: "&ucirc;",
          //  û
          252: "&uuml;",
          //  ü
          253: "&yacute;",
          //  ý
          254: "&thorn;",
          //  þ
          255: "&yuml;",
          //  ÿ
          402: "&fnof;",
          //  ƒ
          913: "&Alpha;",
          //  Α
          914: "&Beta;",
          //  Β
          915: "&Gamma;",
          //  Γ
          916: "&Delta;",
          //  Δ
          917: "&Epsilon;",
          //  Ε
          918: "&Zeta;",
          //  Ζ
          919: "&Eta;",
          //  Η
          920: "&Theta;",
          //  Θ
          921: "&Iota;",
          //  Ι
          922: "&Kappa;",
          //  Κ
          923: "&Lambda;",
          //  Λ
          924: "&Mu;",
          //  Μ
          925: "&Nu;",
          //  Ν
          926: "&Xi;",
          //  Ξ
          927: "&Omicron;",
          //  Ο
          928: "&Pi;",
          //  Π
          929: "&Rho;",
          //  Ρ
          931: "&Sigma;",
          //  Σ
          932: "&Tau;",
          //  Τ
          933: "&Upsilon;",
          //  Υ
          934: "&Phi;",
          //  Φ
          935: "&Chi;",
          //  Χ
          936: "&Psi;",
          //  Ψ
          937: "&Omega;",
          //  Ω
          945: "&alpha;",
          //  α
          946: "&beta;",
          //  β
          947: "&gamma;",
          //  γ
          948: "&delta;",
          //  δ
          949: "&epsilon;",
          //  ε
          950: "&zeta;",
          //  ζ
          951: "&eta;",
          //  η
          952: "&theta;",
          //  θ
          953: "&iota;",
          //  ι
          954: "&kappa;",
          //  κ
          955: "&lambda;",
          //  λ
          956: "&mu;",
          //  μ
          957: "&nu;",
          //  ν
          958: "&xi;",
          //  ξ
          959: "&omicron;",
          //  ο
          960: "&pi;",
          //  π
          961: "&rho;",
          //  ρ
          962: "&sigmaf;",
          //  ς
          963: "&sigma;",
          //  σ
          964: "&tau;",
          //  τ
          965: "&upsilon;",
          //  υ
          966: "&phi;",
          //  φ
          967: "&chi;",
          //  χ
          968: "&psi;",
          //  ψ
          969: "&omega;"
          //  ω
        },
        replaceNamedEntities: function(html) {
          var newHtml = "";
          var ln = html.length;
          for (let i = 0; i < ln; i++) {
            const code = html.charCodeAt(i);
            if (code > 127) {
              var entity = ViperUtil.commonEntitiesArray[code];
              if (!entity) {
                entity = ViperUtil.alphabetEntitiesArray[code];
              }
              if (entity) {
                newHtml += entity;
              } else {
                newHtml += html.charAt(i);
              }
            } else {
              newHtml += html.charAt(i);
            }
          }
          return newHtml;
        },
        /**
         * Does not replace currency symbols, and alphabet symbols.
         */
        replaceCommonNamedEntities: function(html) {
          var newHtml = "";
          var ln = html.length;
          for (let i = 0; i < ln; i++) {
            const code = html.charCodeAt(i);
            if (code > 127) {
              var entity = ViperUtil.commonEntitiesArray[code];
              if (entity) {
                newHtml += entity;
              } else {
                newHtml += html.charAt(i);
              }
            } else {
              newHtml += html.charAt(i);
            }
          }
          return newHtml;
        },
        getTextNodes: function(parent, removeEmpty) {
          var nodes = [];
          if (ViperUtil.isBrowser("msie") === false) {
            var walk = document.createTreeWalker(parent, NodeFilter.SHOW_TEXT);
            let node;
            while (node = walk.nextNode()) {
              nodes.push(node);
            }
          } else {
            if (parent && parent.childNodes) {
              var ln = parent.childNodes.length;
              for (var i = 0; i < ln; i++) {
                var child = parent.childNodes[i];
                if (child.nodeType === ViperUtil.TEXT_NODE) {
                  if (removeEmpty === true && /^\s*$/.test(child.data) === true) {
                    remove(child);
                  } else {
                    nodes.push(child);
                  }
                } else if (child.childNodes && child.childNodes.length > 0) {
                  nodes = nodes.concat(ViperUtil.getTextNodes(child));
                }
              }
            }
          }
          return nodes;
        },
        normaliseTextNodeSiblings: function(element) {
          var prevCont = element.previousSibling;
          var nextCont = element.nextSibling;
          var info = null;
          var joinTextNodes = function(toNode, node) {
            if (ViperUtil.isText(toNode) !== true || ViperUtil.isText(node) !== true) {
              return;
            }
            if (node.data[0] === " " && toNode.data[toNode.data.length - 1] === " ") {
              node.data = String.fromCharCode(160) + node.data.substr(1);
            }
            toNode.data += node.data;
            remove(node);
          };
          if (prevCont && nextCont && prevCont.nodeType === ViperUtil.TEXT_NODE && nextCont.nodeType === ViperUtil.TEXT_NODE) {
            info = {
              splitOffset: prevCont.data.length,
              textNode: prevCont
            };
            if (nextCont.data[0] === " " && prevCont.data[prevCont.data.length - 1] === " ") {
              nextCont.data = String.fromCharCode(160) + nextCont.data.substr(1);
            }
            prevCont.data += nextCont.data;
          } else if (this.isText(nextCont) === true) {
            info = {
              splitOffset: element.data.length,
              textNode: element
            };
            while (this.isText(element.nextSibling) === true) {
              joinTextNodes(element, element.nextSibling);
            }
          } else if (this.isText(prevCont) === true) {
            var splitOffset = 0;
            while (this.isText(element.previousSibling) === true) {
              splitOffset += element.previousSibling.data.length;
              element.data = element.previousSibling.data + element.data;
              remove(element.previousSibling);
            }
            info = {
              splitOffset,
              textNode: element
            };
          }
          return info;
        },
        getCommonAncestor: function(a, b) {
          var node = a;
          while (node) {
            if (ViperUtil.isChildOf(b, node) === true) {
              return node;
            }
            node = node.parentNode;
          }
          return null;
        },
        /**
         * Returns true if the given range start and end nodes are in different block tags.
         *
         * @return {boolean}
         */
        rangeInDiffBlocks: function(range) {
          if (range.startContainer !== range.endContainer && this.getFirstBlockParent(range.startContainer, true) !== this.getFirstBlockParent(range.endContainer, true)) {
            return true;
          }
          return false;
        },
        clone: function(value, shallow) {
          if (typeof value !== "object") {
            return value;
          }
          if (value === null) {
            var valueClone = null;
          } else {
            var valueClone = new value.constructor();
            for (var property in value) {
              if (shallow) {
                valueClone[property] = value[property];
              }
              if (value[property] === null) {
                valueClone[property] = null;
              } else if (typeof value[property] === "object") {
                valueClone[property] = ViperUtil.clone(value[property], shallow);
              } else {
                valueClone[property] = value[property];
              }
            }
          }
          return valueClone;
        },
        /**
         * Adds given (var => value) list to the given URLs query string.
         */
        addToQueryString: function(url, addQueries) {
          var mergedUrl = "";
          var baseUrl = ViperUtil.baseUrl(url);
          var queryStringArray = ViperUtil.queryString(url);
          const mergedQry = ViperUtil.objectMerge(queryStringArray, addQueries);
          var queryStr = "?";
          ViperUtil.foreach(mergedQry, function(key) {
            queryStr = queryStr + key + "=" + mergedQry[key] + "&";
          });
          if (queryStr.length > 1) {
            mergedUrl = baseUrl + queryStr.substr(0, queryStr.length - 1);
          } else {
            mergedUrl = url;
          }
          var anchorPartURL = ViperUtil.getURLAnchor(url);
          if (anchorPartURL.length > 0) {
            mergedUrl = mergedUrl + anchorPartURL;
          }
          return mergedUrl;
        },
        /**
         * Return key value pairs from the given query string.
         */
        queryString: function(url) {
          var result = {};
          var qStartIdx = url.search(/\?/);
          if (qStartIdx === -1) {
            return result;
          } else {
            var aStartIdx = url.search(/\#/);
            if (aStartIdx === -1) {
              var anchorPartAdj = 0;
            } else {
              var anchorPartAdj = url.length - aStartIdx + 1;
            }
            var queryStr = url.substr(qStartIdx + 1, url.length - qStartIdx - anchorPartAdj);
            if (queryStr.length > 0) {
              var pairs = queryStr.split("&");
              var len = pairs.length;
              var pair = [];
              for (var i = 0; i < len; i++) {
                if (pairs[i].search("=") !== -1) {
                  pair = pairs[i].split("=");
                  result[pair[0]] = pair[1];
                }
              }
              return result;
            } else {
              return result;
            }
          }
        },
        /**
         * Returns the anchor part of the URL.  Blank if no # or
         * hash followed by the actual anchor name
         */
        getURLAnchor: function(url) {
          if (typeof url === "string") {
            var aStartIdx = url.search(/\#/);
            if (aStartIdx === -1) {
              url = "";
            } else {
              url = url.substr(aStartIdx, url.length - aStartIdx);
            }
          }
          return url;
        },
        baseUrl: function(fullUrl) {
          var qStartIdx = fullUrl.search(/\?|#/);
          if (qStartIdx === -1) {
            return fullUrl;
          } else {
            var baseUrl = fullUrl.substr(0, qStartIdx);
            return baseUrl;
          }
        },
        loadScript: function(src, callback, timeout) {
          var t = null;
          if (timeout) {
            t = setTimeout(callback, timeout);
          }
          var script = document.createElement("script");
          script.onload = function() {
            clearTimeout(t);
            script.onload = null;
            script.onreadystatechange = null;
            callback.call(this);
          };
          script.onreadystatechange = function() {
            if (/^(complete|loaded)$/.test(this.readyState) === true) {
              clearTimeout(t);
              script.onreadystatechange = null;
              script.onload();
            }
          };
          script.src = src;
          if (document.head) {
            document.head.appendChild(script);
          } else {
            document.getElementsByTagName("head")[0].appendChild(script);
          }
        },
        objectMerge: function(ob1, ob2) {
          ViperUtil.foreach(ob2, function(key) {
            ob1[key] = ob2[key];
            return true;
          });
          return ob1;
        },
        /**
         * Converts a property like background-color to backgroundColor.
         *
         * @param {String} property The string to convert.
         *
         * @return The converted string.
         * @type   string
         */
        camelCase: function(property) {
          var hyphenTest = /-([a-z])/;
          while (hyphenTest.test(property) == true) {
            property = property.replace(hyphenTest, RegExp.$1.toUpperCase());
          }
          return property;
        },
        /**
         * Returns the current browser type.
         *
         * @return {string}
         */
        getBrowserType: function() {
          if (ViperUtil._browserType === null) {
            var tests = ["edge", "trident", "msie", "firefox", "chrome", "safari"];
            var tln = tests.length;
            for (var i = 0; i < tln; i++) {
              var r = new RegExp(tests[i], "i");
              if (r.test(navigator.userAgent) === true) {
                if (tests[i] === "trident") {
                  ViperUtil._browserType = "msie";
                } else {
                  ViperUtil._browserType = tests[i];
                }
                return ViperUtil._browserType;
              }
            }
            ViperUtil._browserType = "other";
          }
          return ViperUtil._browserType;
        },
        /**
         * Returns the version of the current browser.
         *
         * @return {integer}
         */
        getBrowserVersion: function() {
          if (ViperUtil._browserVersion !== null) {
            return ViperUtil._browserVersion;
          }
          var browsers = ["Edge", "MSIE", "Trident", "Chrome", "Safari", "Firefox"];
          var c = browsers.length;
          var uAgent = navigator.userAgent;
          var browserName = null;
          for (var i = 0; i < c; i++) {
            var nameIndex = uAgent.indexOf(browsers[i]);
            if (nameIndex >= 0) {
              browserName = browsers[i];
              break;
            }
          }
          if (!browserName) {
            return null;
          }
          if (browserName === "Safari") {
            browserName = "Version";
          }
          var re = null;
          if (browserName === "MSIE") {
            re = new RegExp("MSIE (\\d+)");
          } else if (browserName === "Trident") {
            re = new RegExp("rv:(\\d+)");
          } else {
            re = new RegExp(browserName + "/(\\d+)");
          }
          var matches = re.exec(uAgent);
          if (!matches) {
            return null;
          }
          ViperUtil._browserVersion = parseInt(matches[1]);
          return ViperUtil._browserVersion;
        },
        /**
         * Checks if specified browser type is the current browser.
         *
         * @param {string}  browser The browser type to test.
         * @param {string}  version The version of the browser. Example formats: 23, <10, >=11.
         *
         * @return {boolean}
         */
        isBrowser: function(browser, version) {
          if (ViperUtil.getBrowserType() !== browser) {
            return false;
          } else if (!version) {
            return true;
          }
          version = version.toString();
          var currentVer = ViperUtil.getBrowserVersion().toString();
          if (version === currentVer) {
            return true;
          }
          var match = version.match(/^(<=|>=|<|>)([\d\.]+$)/);
          if (!match) {
            return false;
          }
          version = parseFloat(match[2]);
          switch (match[1]) {
            case "<=":
              return currentVer <= version;
            case ">=":
              return currentVer >= version;
            case "<":
              return currentVer < version;
            case ">":
              return currentVer > version;
            default:
              return false;
          }
          return false;
        },
        getOS: function() {
          var platform = navigator.platform.toLowerCase();
          if (platform.indexOf("win") === 0) {
            return "windows";
          } else if (platform.indexOf("mac") === 0) {
            return "mac";
          } else if (platform.indexOf("linux") === 0) {
            return "linux";
          }
          return platform;
        },
        isOS: function(os) {
          if (this.getOS() === os) {
            return true;
          }
          return false;
        },
        /**
         * Clones given node and its children.
         */
        cloneNode: function(node) {
          var clone = null;
          if (ViperUtil.isBrowser("msie", "8") === true && node.nodeType !== ViperUtil.TEXT_NODE) {
            var clone = document.createElement("div");
            ViperUtil.setHtml(clone, ViperUtil.trim(node.outerHTML));
            clone = clone.firstChild;
          } else {
            clone = node.cloneNode(true);
          }
          return clone;
        },
        /**
         * Starts debugging after specified calls to this method.
         */
        dcall: function(c) {
          if (!ViperUtil._dcall) {
            ViperUtil._dcall = 0;
          }
          ViperUtil._dcall++;
          console.info(ViperUtil._dcall);
          if (c === ViperUtil._dcall) {
            debugger;
          }
        },
        setViperElement: function(element) {
          this._viperElement = element;
        }
      };
    };
  }
});

// src/Lib/Translation.js
var Translation_exports = {};
__export(Translation_exports, {
  registerPlugin: () => registerPlugin2
});
var registerPlugin2;
var init_Translation = __esm({
  "src/Lib/Translation.js"() {
    "use strict";
    registerPlugin2 = (Viper2) => {
      Viper2.Translation = new function() {
        var _strings = {};
        var _lang = null;
        this.add = function(code, strings) {
          _strings[code] = strings;
        };
        this.isLoaded = function(code) {
          if (_strings[code]) {
            return true;
          }
          return false;
        };
        this.setLanguage = function(code) {
          _lang = code;
        };
        Viper2._ = function(str) {
          if (_lang !== null && _strings[_lang]) {
            str = _strings[_lang][str] || str;
          }
          return str;
        };
      }();
    };
  }
});

// src/Lib/Tools.js
var Tools_exports = {};
__export(Tools_exports, {
  registerPlugin: () => registerPlugin3
});
var import_interactjs, registerPlugin3;
var init_Tools = __esm({
  "src/Lib/Tools.js"() {
    "use strict";
    import_interactjs = __toESM(require("interactjs"));
    registerPlugin3 = (Viper2) => {
      const { Util: ViperUtil, _ } = Viper2;
      Viper2.Tools = function(viper) {
        this.viper = viper;
        this._items = {};
        this._preventMouseUp = false;
        var self = this;
        this.viper.registerCallback("Viper:mouseUp", "ViperTools", function(e) {
          if (self._preventMouseUp === true) {
            self._preventMouseUp = false;
            return false;
          }
        });
      };
      Viper2.Tools.prototype = {
        addItem: function(id, item) {
          this._items[id] = item;
        },
        removeItem: function(id) {
          var item = this.getItem(id);
          if (!item) {
            return;
          }
          delete this._items[id];
          if (item.element) {
            ViperUtil.remove(item.element);
          }
          this.viper.removeCallback(null, "ViperTools-" + id);
          this.viper.removeCallback(null, id);
          this.viper.fireCallbacks("ViperTools:itemRemoved", id);
        },
        getItem: function(id) {
          return this._items[id];
        },
        createRow: function(id, customClass) {
          var elem = document.createElement("div");
          ViperUtil.addClass(elem, "Viper-subSectionRow");
          if (customClass) {
            ViperUtil.addClass(elem, customClass);
          }
          this.addItem(id, {
            type: "row",
            element: elem
          });
          return elem;
        },
        /**
         * Creates a button group.
         *
         * @param {string} customClass Custom class to apply to the group.
         *
         * @return {DOMElement} The button group element.
         */
        createButtonGroup: function(id, customClass) {
          var group = document.createElement("div");
          ViperUtil.addClass(group, "Viper-buttonGroup");
          if (customClass) {
            ViperUtil.addClass(group, customClass);
          }
          this.addItem(id, {
            type: "buttonGroup",
            element: group,
            buttons: []
          });
          return group;
        },
        /**
         * Creates a toolbar button.
         *
         * @param {string}     content        The content of the button.
         * @param {string}     titleAttr      The title attribute for the button.
         * @param {string}     customClass    Class to add to the button for extra styling.
         * @param {function}   clickAction    The function to call when the button is clicked.
         *                                    Note that this action is ignored if the
         *                                    subSection param is specified. Clicking will
         *                                    then toggle the sub section visibility.
         * @param {boolean}    disabled       True if the button is disabled.
         * @param {string}     isActive       True if the button is active.
         *
         * @return {DOMElement} The new button element.
         */
        createButton: function(id, content, titleAttr, customClass, clickAction, disabled, isActive) {
          if (!content) {
            if (customClass) {
              content = '<span class="Viper-buttonIcon ' + customClass + '"></span>';
            } else {
              content = "";
            }
            content += "&nbsp;";
          }
          var button = document.createElement("div");
          button.setAttribute("id", this.viper.getId() + "-" + id);
          if (titleAttr) {
            if (disabled === true) {
              titleAttr = titleAttr + " [" + _("Not available") + "]";
            }
            button.setAttribute("title", titleAttr);
          }
          ViperUtil.setHtml(button, content);
          ViperUtil.addClass(button, "Viper-button");
          if (disabled === true) {
            ViperUtil.addClass(button, "Viper-disabled");
          }
          if (customClass) {
            ViperUtil.addClass(button, customClass);
          }
          var mouseUpAction = function() {
          };
          var self = this;
          if (clickAction) {
            ViperUtil.addEvent(button, "mousedown." + this.viper.getEventNamespace(), function(e) {
              self._preventMouseUp = true;
              ViperUtil.preventDefault(e);
              if (ViperUtil.hasClass(button, "Viper-disabled") === true) {
                return false;
              }
              setTimeout(function() {
                self._preventMouseUp = false;
              }, 200);
              self.viper.fireCallbacks("ViperTools:buttonClicked", id);
              return clickAction.call(this, e);
            });
          }
          ViperUtil.addEvent(button, "mouseup." + this.viper.getEventNamespace(), function(e) {
            mouseUpAction.call(this, e);
            self._preventMouseUp = false;
            ViperUtil.preventDefault(e);
            return false;
          });
          if (isActive === true) {
            ViperUtil.addClass(button, "Viper-active");
          }
          this.addItem(id, {
            type: "button",
            element: button,
            setIconClass: function(iconClass) {
              var btnIconElem = ViperUtil.getClass("Viper-buttonIcon", button);
              if (btnIconElem.length === 0) {
                btnIconElem = document.createElement("span");
                ViperUtil.addClass(btnIconElem, "Viper-buttonIcon");
                ViperUtil.insertBefore(button.firstChild, btnIconElem);
              } else {
                btnIconElem = btnIconElem[0];
                btnIconElem.className = "Viper-buttonIcon";
              }
              ViperUtil.addClass(btnIconElem, iconClass);
            },
            setButtonShortcut: function(key) {
              var extraTitleAttr = " (" + key + ")";
              if (extraTitleAttr.indexOf("CTRL") >= 0) {
                if (navigator.platform.indexOf("Mac") >= 0) {
                  extraTitleAttr = extraTitleAttr.replace("CTRL", "CMD");
                }
              }
              button.setAttribute("title", titleAttr + extraTitleAttr);
              self.viper.registerCallback("Viper:keyDown", "ViperTools-" + id, function(e) {
                if (ViperUtil.isKey(e, key) === true) {
                  if (ViperUtil.hasClass(button, "Viper-disabled") !== true) {
                    clickAction.call(e, button);
                  }
                  return false;
                }
              });
            },
            setMouseUpAction: function(callback) {
              mouseUpAction = callback;
            },
            isEnabled: function() {
              return !this._disabled;
            },
            isActive: function() {
              return ViperUtil.hasClass(button, "Viper-active");
            },
            setContent: function(content2) {
              ViperUtil.setHtml(button, content2);
            },
            _disabled: disabled,
            hide: function() {
              ViperUtil.addClass(button, "Viper-hidden");
            },
            show: function() {
              ViperUtil.removeClass(button, "Viper-hidden");
            }
          });
          return button;
        },
        addButtonToGroup: function(buttonid, groupid) {
          var button = this.getItem(buttonid);
          var group = this.getItem(groupid);
          if (!button || !group || button.type !== "button" || group.type !== "buttonGroup") {
            throw new Error("Invalid argument for ViperTools.addButtonToGroup('" + buttonid + "', '" + groupid + "')");
            return;
          }
          group.element.appendChild(button.element);
          group.buttons.push(buttonid);
        },
        setButtonInactive: function(buttonid) {
          var button = this.getItem(buttonid);
          if (!button) {
            return;
          }
          ViperUtil.removeClass(button.element, "Viper-active");
        },
        setButtonActive: function(buttonid) {
          var button = this.getItem(buttonid);
          if (!button) {
            return;
          }
          ViperUtil.addClass(button.element, "Viper-active");
          this.enableButton(buttonid);
        },
        enableButton: function(buttonid) {
          var buttonObj = this.getItem(buttonid);
          if (!buttonObj || buttonObj.isEnabled() === true) {
            return;
          }
          var button = buttonObj.element;
          var title = button.getAttribute("title");
          if (title) {
            button.setAttribute("title", title.replace(" [" + _("Not available") + "]", ""));
          }
          ViperUtil.removeClass(button, "Viper-disabled");
          buttonObj._disabled = false;
        },
        disableButton: function(buttonid) {
          var buttonObj = this.getItem(buttonid);
          if (buttonObj.isEnabled() !== true) {
            return;
          }
          var button = buttonObj.element;
          var title = button.getAttribute("title");
          if (title) {
            title = title.replace(" [" + _("Not available") + "]", "");
            button.setAttribute("title", title + " [" + _("Not available") + "]");
          }
          ViperUtil.addClass(button, "Viper-disabled");
          buttonObj._disabled = true;
        },
        /**
         * Creates a textbox.
         *
         * @param {string}   value      The initial value of the textbox.
         * @param {string}   label      The label of the textbox.
         * @param {boolean}  required   True if this field is required.
         * @param {boolean}  expandable If true then the textbox will expand when focused.
         *
         * @return {DOMNode} If label specified the label element else the textbox element.
         */
        createTextbox: function(id, label, value, action, required, expandable, desc, events, labelWidth) {
          return this._createTextbox(id, label, value, action, required, expandable, desc, events, labelWidth);
        },
        createTextarea: function(id, label, value, required, desc, events, labelWidth, rows, cols) {
          return this._createTextbox(id, label, value, null, required, false, desc, events, labelWidth, true, rows, cols);
        },
        _createTextbox: function(id, label, value, action, required, expandable, desc, events, labelWidth, isTextArea, rows, cols) {
          label = label || "&nbsp;";
          value = value || "";
          var textBox = document.createElement("div");
          ViperUtil.addClass(textBox, "Viper-textbox");
          if (required === true && !value) {
            ViperUtil.addClass(textBox, "Viper-required");
          }
          var labelEl = document.createElement("label");
          ViperUtil.addClass(labelEl, "Viper-textbox-label");
          textBox.appendChild(labelEl);
          var main = document.createElement("div");
          ViperUtil.addClass(main, "Viper-textbox-main");
          labelEl.appendChild(main);
          var title = document.createElement("span");
          ViperUtil.addClass(title, "Viper-textbox-title");
          ViperUtil.setHtml(title, label);
          if (labelWidth) {
            ViperUtil.setStyle(title, "width", labelWidth);
          }
          var width = 0;
          var tmp = document.createElement("div");
          ViperUtil.addClass(tmp, "ViperITP");
          if (navigator.userAgent.match(/iPad/i) !== null) {
            ViperUtil.addClass(tmp, "device-ipad");
          }
          ViperUtil.setStyle(tmp, "display", "block");
          tmp.appendChild(title);
          this.viper.addElement(tmp);
          width = ViperUtil.getElementWidth(title) + 10 + "px";
          tmp.parentNode.removeChild(tmp);
          main.appendChild(title);
          var inputType = "input";
          if (isTextArea === true) {
            inputType = "textarea";
          }
          var input = document.createElement(inputType);
          input.value = value;
          if (isTextArea === true) {
            ViperUtil.addClass(input, "Viper-textbox-textArea");
          } else {
            input.type = "text";
            ViperUtil.addClass(input, "Viper-textbox-input");
          }
          ViperUtil.setStyle(main, "padding-left", width);
          main.appendChild(input);
          if (required === true) {
            input.setAttribute("placeholder", _("required"));
          }
          if (desc) {
            var descEl = document.createElement("span");
            ViperUtil.addClass(descEl, "Viper-textbox-desc");
            ViperUtil.setHtml(descEl, desc);
            textBox.appendChild(descEl);
          }
          var moveCaretToEnd = true;
          var self = this;
          ViperUtil.addEvent(input, "focus", function(e) {
            ViperUtil.addClass(textBox, "Viper-focused");
            self.viper.highlightSelection();
            input.value = input.value;
            if (ViperUtil.isBrowser("firefox") === true) {
              setTimeout(function() {
                input.selectionStart = input.value.length;
              }, 2);
            }
          });
          ViperUtil.addEvent(input, "blur", function() {
            ViperUtil.removeClass(textBox, "Viper-active");
            ViperUtil.removeClass(textBox, "Viper-focused");
          });
          var changed = false;
          var _addActionButton = function() {
            var actionIcon2 = document.createElement("span");
            ViperUtil.addClass(actionIcon2, "Viper-textbox-action");
            main.appendChild(actionIcon2);
            ViperUtil.addEvent(actionIcon2, "click", function() {
              if (ViperUtil.hasClass(textBox, "Viper-actionRevert") === true) {
                input.value = value;
                ViperUtil.removeClass(textBox, "Viper-actionRevert");
                ViperUtil.addClass(textBox, "Viper-actionClear");
                actionIcon2.setAttribute("title", "Clear this value");
              } else if (ViperUtil.hasClass(textBox, "Viper-actionClear") === true) {
                value = input.value;
                input.value = "";
                ViperUtil.removeClass(textBox, "Viper-actionClear");
                if (value) {
                  ViperUtil.addClass(textBox, "Viper-actionRevert");
                  actionIcon2.setAttribute("title", "Revert to original value");
                  if (required === true) {
                    ViperUtil.addClass(textBox, "Viper-required");
                  }
                } else if (required === true) {
                  ViperUtil.addClass(textBox, "Viper-required");
                  ViperUtil.setStyle(actionIcon2, "display", "none");
                }
              }
              self.viper.fireCallbacks("ViperTools:changed:" + id);
            });
            return actionIcon2;
          };
          if (value !== "" && isTextArea !== true) {
            var actionIcon = _addActionButton();
            actionIcon.setAttribute("title", "Clear this value");
            ViperUtil.addClass(textBox, "Viper-actionClear");
          }
          var onchange = function(e) {
            ViperUtil.addClass(textBox, "Viper-focused");
            if (isTextArea !== true) {
              var actionIcon2 = ViperUtil.getClass("Viper-textbox-action", main);
              if (actionIcon2.length === 0) {
                actionIcon2 = _addActionButton();
              } else {
                actionIcon2 = actionIcon2[0];
              }
            }
            ViperUtil.setStyle(actionIcon2, "display", "block");
            ViperUtil.setStyle(actionIcon2, "visibility", "visible");
            ViperUtil.removeClass(textBox, "Viper-actionClear");
            ViperUtil.removeClass(textBox, "Viper-actionRevert");
            if (input.value !== value && value !== "") {
              if (isTextArea !== true) {
                actionIcon2.setAttribute("title", "Revert to original value");
                ViperUtil.addClass(textBox, "Viper-actionRevert");
              }
              ViperUtil.removeClass(textBox, "Viper-required");
            } else if (input.value !== "") {
              if (isTextArea !== true) {
                actionIcon2.setAttribute("title", "Clear this value");
                ViperUtil.addClass(textBox, "Viper-actionClear");
              }
              ViperUtil.removeClass(textBox, "Viper-required");
            } else {
              if (isTextArea !== true) {
                ViperUtil.setStyle(actionIcon2, "display", "none");
              }
              if (required === true) {
                ViperUtil.addClass(textBox, "Viper-required");
              }
            }
            if ((e.which !== 13 || isTextArea === true || e.type === "paste") && input.value !== value) {
              self.viper.fireCallbacks("ViperTools:changed:" + id);
            }
            if (action && e.which === 13) {
              self.viper.focus();
              action.call(input, input.value);
            } else if (!action && e.which === 13 && isTextArea !== true && (ViperUtil.isBrowser("chrome") || ViperUtil.isBrowser("safari"))) {
              var forms = ViperUtil.getParents(main, "form", self.viper.getViperElement());
              if (forms.length > 0 && ViperUtil.getTag("input", forms[0]).length > 2) {
                return forms[0].onsubmit();
              }
            }
          };
          ViperUtil.addEvent(input, "keyup", onchange);
          ViperUtil.addEvent(input, "paste", function(e) {
            setTimeout(function() {
              return onchange(e);
            }, 10);
          });
          if (events) {
            for (var eventType in events) {
              ViperUtil.addEvent(input, eventType, events[eventType]);
            }
          }
          this.addItem(id, {
            type: "textbox",
            element: textBox,
            input,
            label: labelEl,
            required,
            getValue: function() {
              return input.value;
            },
            setValue: function(newValue, isInitialValue) {
              input.value = newValue;
              value = newValue;
              if (isTextArea !== true) {
                var actionIcon2 = ViperUtil.getClass("Viper-textbox-action", main);
                if (actionIcon2.length === 0) {
                  actionIcon2 = _addActionButton();
                } else {
                  actionIcon2 = actionIcon2[0];
                }
                ViperUtil.setStyle(actionIcon2, "display", "block");
              }
              ViperUtil.removeClass(textBox, "Viper-actionClear");
              ViperUtil.removeClass(textBox, "Viper-actionRevert");
              if (isTextArea !== true) {
                if (input.value !== value && value !== "") {
                  actionIcon2.setAttribute("title", "Revert to original value");
                  ViperUtil.addClass(textBox, "Viper-actionRevert");
                  ViperUtil.removeClass(textBox, "Viper-required");
                } else if (input.value !== "") {
                  actionIcon2.setAttribute("title", "Clear this value");
                  ViperUtil.addClass(textBox, "Viper-actionClear");
                  ViperUtil.removeClass(textBox, "Viper-required");
                } else {
                  ViperUtil.setStyle(actionIcon2, "display", "none");
                  if (required === true) {
                    ViperUtil.addClass(textBox, "Viper-required");
                  }
                }
              }
              if (isInitialValue === false) {
                self.viper.fireCallbacks("ViperTools:changed:" + id);
              }
            },
            disable: function() {
              ViperUtil.addClass(textBox, "Viper-disabled");
              input.setAttribute("disabled", true);
              input.blur();
            },
            enable: function() {
              ViperUtil.removeClass(textBox, "Viper-disabled");
              input.removeAttribute("disabled");
            },
            setRequired: function(required2) {
              if (required2 === true) {
                input.setAttribute("placeholder", _("required"));
                if (ViperUtil.trim(input.value) === "") {
                  ViperUtil.addClass(textBox, "Viper-required");
                }
              } else {
                ViperUtil.removeClass(textBox, "Viper-required");
                input.removeAttribute("placeholder");
              }
              this.required = required2;
            },
            setLabel: function(newLabel) {
              ViperUtil.setHtml(ViperUtil.getClass("Viper-textbox-title", labelEl)[0], newLabel);
            },
            hide: function() {
              ViperUtil.addClass(textBox, "Viper-hidden");
            },
            show: function() {
              ViperUtil.removeClass(textBox, "Viper-hidden");
            }
          });
          return textBox;
        },
        setFieldEvent: function(itemid, eventType, event2) {
          var item = this.getItem(itemid);
          if (!item || !item.input) {
            return;
          }
          ViperUtil.addEvent(item.input, eventType, event2);
        },
        /**
         * Sets the list of errors of the specified item.
         *
         * If no errors specified then all exisiting errors will be cleared.
         *
         * @param {string} itemid The item id.
         * @param {array}  errors List of errors.
         */
        setFieldErrors: function(itemid, errors) {
          var item = this.getItem(itemid);
          if (!item || !item.input) {
            return;
          }
          errors = errors || [];
          var errorCount = errors.length;
          var msgsElement = ViperUtil.getClass("Viper-" + item.type + "-messages", item.element);
          if (msgsElement.length === 0) {
            if (errorCount === 0) {
              return;
            }
            msgsElement = document.createElement("div");
            ViperUtil.addClass(msgsElement, "Viper-textbox-messages");
            item.label.appendChild(msgsElement);
          } else {
            msgsElement = msgsElement[0];
            if (errorCount === 0) {
              ViperUtil.remove(msgsElement);
              return;
            }
            ViperUtil.empty(msgsElement);
          }
          var content = "";
          for (var i = 0; i < errorCount; i++) {
            content += '<span class="Viper-textbox-error">' + errors[i] + "</span>";
          }
          ViperUtil.setHtml(msgsElement, content);
        },
        /**
         * Creates a checkbox.
         *
         * @param {string}  id      The id of the item.
         * @param {string}  label   The label for the checkbox.
         * @param {boolean} checked True if checked by default.
         *
         * @return {DOMElement} The checkbox element.
         */
        createCheckbox: function(id, label, checked, changeCallback) {
          var labelElem = document.createElement("label");
          ViperUtil.addClass(labelElem, "Viper-checkbox");
          if (checked === true) {
            ViperUtil.addClass(labelElem, "Viper-active");
          }
          var checkbox = document.createElement("input");
          checkbox.type = "checkbox";
          checkbox.checked = checked || false;
          var checkboxSwitch = document.createElement("span");
          ViperUtil.addClass(checkboxSwitch, "Viper-checkbox-switch");
          var checkboxSlider = document.createElement("span");
          ViperUtil.addClass(checkboxSlider, "Viper-checkbox-slider");
          checkboxSwitch.appendChild(checkboxSlider);
          checkboxSwitch.appendChild(checkbox);
          var text = document.createElement("span");
          ViperUtil.addClass(text, "Viper-checkbox-title");
          ViperUtil.setHtml(text, label);
          labelElem.appendChild(text);
          labelElem.appendChild(checkboxSwitch);
          var self = this;
          ViperUtil.addEvent(checkbox, "click", function() {
            if (checkbox.checked === true) {
              ViperUtil.addClass(labelElem, "Viper-active");
            } else {
              ViperUtil.removeClass(labelElem, "Viper-active");
            }
            if (changeCallback) {
              changeCallback.call(this, checkbox.checked);
            }
            self.viper.fireCallbacks("ViperTools:changed:" + id);
          });
          this.addItem(id, {
            type: "checkbox",
            element: labelElem,
            input: checkbox,
            getValue: function() {
              return checkbox.checked;
            },
            setValue: function(checked2, isInitialValue) {
              checkbox.checked = checked2;
              if (checked2 === true) {
                ViperUtil.addClass(labelElem, "Viper-active");
              } else {
                ViperUtil.removeClass(labelElem, "Viper-active");
              }
              if (changeCallback && isInitialValue !== true) {
                changeCallback.call(this, checked2, true);
              }
            }
          });
          return labelElem;
        },
        /**
         * Creates a radio button.
         *
         * @param {string}  name    The name of the group the radio button belongs to.
         * @param {string}  value   The value of the radio button.
         * @param {string}  label   The label for the radio button.
         * @param {boolean} checked True if checked by default.
         *
         * @return {DOMElement} The checkbox element.
         */
        createRadiobutton: function(name, value, label, checked) {
          var labelElem = document.createElement("label");
          ViperUtil.addClass(labelElem, "Viper-radiobtn-label");
          var radio = document.createElement("input");
          radio.type = "radio";
          radio.name = name;
          radio.value = value;
          radio.checked = checked || false;
          ViperUtil.addClass(radio, "Viper-radiobtn");
          var span = document.createElement("span");
          ViperUtil.addClass(span, "Viper-radio-text");
          ViperUtil.setHtml(span, label);
          labelElem.appendChild(radio);
          labelElem.appendChild(span);
          return labelElem;
        },
        createPopup: function(id, title, topContent, midContent, bottomContent, customClass, draggable, resizable, openCallback, closeCallback, resizeCallback) {
          title = title || "&nbsp;";
          var self = this;
          var main = document.createElement("div");
          ViperUtil.addClass(main, "Viper-popup Viper-themeDark");
          if (customClass) {
            ViperUtil.addClass(main, customClass);
          }
          var header = document.createElement("div");
          ViperUtil.addClass(header, "Viper-popup-header");
          const interactable = (0, import_interactjs.default)(main);
          if (draggable !== false) {
            var dragIcon = document.createElement("div");
            ViperUtil.addClass(dragIcon, "Viper-popup-dragIcon");
            header.appendChild(dragIcon);
            var overlay = document.createElement("div");
            ViperUtil.addClass(overlay, "Viper-dragOverlay");
            const position2 = { x: 0, y: 0 };
            interactable.draggable({
              allowFrom: header,
              listeners: {
                start: () => {
                  self.viper.addElement(overlay);
                },
                end: () => {
                  ViperUtil.remove(overlay);
                },
                move(event2) {
                  position2.x += event2.dx;
                  position2.y += event2.dy;
                  event2.target.style.transform = `translate(${position2.x}px, ${position2.y}px)`;
                }
              }
            });
          }
          header.appendChild(document.createTextNode(title));
          var closeIcon = document.createElement("div");
          ViperUtil.addClass(closeIcon, "Viper-popup-closeIcon");
          header.appendChild(closeIcon);
          ViperUtil.addEvent(closeIcon, "mousedown", function() {
            self.closePopup(id, "closeIcon");
          });
          var fullScreen = false;
          var originalOpenCallback = openCallback;
          openCallback = function() {
            fullScreen = false;
            if (originalOpenCallback) {
              return originalOpenCallback.call(this);
            }
          };
          this.viper.registerCallback("Viper:keyUp", "ViperTools", function(e) {
            if (e.which === 27 && main.parentNode) {
              self.closePopup(id);
            }
          });
          var showfullScreen = function() {
            var headerHeight = ViperUtil.getElementHeight(header);
            var topHeight = ViperUtil.getElementHeight(topContent);
            var bottomHeight = ViperUtil.getElementHeight(bottomContent);
            var toolbarHeight = 35;
            var windowDim = ViperUtil.getWindowDimensions();
            ViperUtil.setStyle(main, "left", 0);
            ViperUtil.setStyle(main, "top", toolbarHeight + "px");
            ViperUtil.setStyle(main, "margin-left", 0);
            ViperUtil.setStyle(main, "margin-top", 0);
            ViperUtil.setStyle(midContent, "width", windowDim.width - 20 + "px");
            ViperUtil.setStyle(
              midContent,
              "height",
              windowDim.height - toolbarHeight - bottomHeight - headerHeight - topHeight - 10 + "px"
            );
            if (resizeCallback) {
              resizeCallback.call(this);
            }
          };
          var currentSize = null;
          ViperUtil.addEvent(
            header,
            "safedblclick",
            function() {
            },
            function() {
              if (fullScreen !== true) {
                fullScreen = true;
                var mainCoords = ViperUtil.getElementCoords(main);
                currentSize = {
                  width: ViperUtil.getElementWidth(midContent),
                  height: ViperUtil.getElementHeight(midContent),
                  left: mainCoords.x,
                  top: mainCoords.y
                };
                showfullScreen();
                ViperUtil.removeEvent(window, "resize.ViperTools-popup-" + id);
                ViperUtil.addEvent(window, "resize.ViperTools-popup-" + id, function() {
                  showfullScreen();
                });
              } else {
                ViperUtil.removeEvent(window, "resize.ViperTools-popup-" + id);
                fullScreen = false;
                ViperUtil.setStyle(main, "left", currentSize.left + "px");
                ViperUtil.setStyle(main, "top", currentSize.top + "px");
                ViperUtil.setStyle(midContent, "width", currentSize.width + "px");
                ViperUtil.setStyle(midContent, "height", currentSize.height + "px");
                if (resizeCallback) {
                  resizeCallback.call(this);
                }
              }
            }
          );
          main.appendChild(header);
          if (topContent) {
            ViperUtil.addClass(topContent, "Viper-popup-top");
            main.appendChild(topContent);
          }
          ViperUtil.addClass(midContent, "Viper-popup-content");
          main.appendChild(midContent);
          if (bottomContent) {
            ViperUtil.addClass(bottomContent, "Viper-popup-bottom");
            main.appendChild(bottomContent);
          }
          if (resizable !== false) {
            var overlay = document.createElement("div");
            ViperUtil.addClass(overlay, "Viper-dragOverlay");
            const resizeHandle = document.createElement("div");
            ViperUtil.addClass(resizeHandle, "Viper-popup-resizeHandle");
            midContent.appendChild(resizeHandle);
            interactable.resizable({
              edges: {
                top: false,
                left: false,
                bottom: true,
                right: true
              },
              listeners: {
                start: () => {
                  self.viper.addElement(overlay);
                },
                end: () => {
                  ViperUtil.remove(overlay);
                  resizeCallback?.call(this);
                },
                move: function(event2) {
                  const { width, height } = event2.rect;
                  const widthDiff = event2.target.scrollWidth - midContent.scrollWidth;
                  const heightDiff = event2.target.scrollHeight - midContent.scrollHeight;
                  Object.assign(midContent.style, {
                    width: `${width - widthDiff}px`,
                    height: `${height - heightDiff}px`
                  });
                  resizeCallback?.call(this);
                }
              }
            });
          }
          this.addItem(id, {
            type: "popup",
            element: main,
            topContent,
            midContent,
            bottomContent,
            openCallback,
            closeCallback,
            showTop: function() {
              if (fullScreen === true) {
                showfullScreen();
              }
            },
            hideTop: function() {
              if (fullScreen === true) {
                showfullScreen();
              }
            }
          });
          return main;
        },
        openPopup: function(id, width, height, minWidth) {
          var popup = this.getItem(id);
          var contentElem = popup.midContent;
          var popupElement = popup.element;
          if (minWidth) {
            ViperUtil.setStyle(contentElem, "min-width", minWidth);
          }
          if (width) {
            ViperUtil.setStyle(contentElem, "width", width + "px");
          }
          if (height) {
            ViperUtil.setStyle(contentElem, "height", height + "px");
          }
          ViperUtil.setStyle(popupElement, "left", "-9999px");
          ViperUtil.setStyle(popupElement, "top", "-9999px");
          ViperUtil.setStyle(popupElement, "visibility", "hidden");
          this.viper.addElement(popupElement);
          var elementDim = ViperUtil.getBoundingRectangle(popupElement);
          var windowDim = ViperUtil.getWindowDimensions();
          var toolbarHieght = 36;
          var marginTop = (elementDim.y2 - elementDim.y1) / 2 * -1;
          var offScreenTop = windowDim.height / 2 + marginTop;
          if (offScreenTop < toolbarHieght) {
            marginTop -= offScreenTop - toolbarHieght;
          }
          if (elementDim.y2 - elementDim.y1 > windowDim.height - toolbarHieght) {
            ViperUtil.setStyle(
              contentElem,
              "height",
              height - (elementDim.y2 - elementDim.y1 - windowDim.height) - toolbarHieght + "px"
            );
          }
          ViperUtil.setStyle(popupElement, "margin-left", (elementDim.x2 - elementDim.x1) / 2 * -1 + "px");
          ViperUtil.setStyle(popupElement, "margin-top", marginTop + "px");
          ViperUtil.setStyle(popupElement, "left", "50%");
          ViperUtil.setStyle(popupElement, "top", "50%");
          if (popup.openCallback) {
            if (popup.openCallback.call(this) === false) {
              popupElement.parentNode.removeChild(popupElement);
              return;
            }
          }
          this.viper.fireCallbacks("ViperTools:popup:open", id);
          ViperUtil.setStyle(popupElement, "visibility", "visible");
        },
        closePopup: function(id, closer) {
          var popup = this.getItem(id);
          if (popup.closeCallback) {
            if (popup.closeCallback.call(this, closer) === false) {
              return;
            }
          }
          if (popup.element.parentNode) {
            popup.element.parentNode.removeChild(popup.element);
          }
          this.viper.fireCallbacks("ViperTools:popup:close", id);
        },
        createInlineToolbar: function(id, compact, elementTypes, updateCallback) {
          var self = this;
          var toolbar = document.createElement("div");
          var viper = this.viper;
          ViperUtil.attr(toolbar, "data-toolid", id);
          ViperUtil.attr(toolbar, "id", this.viper.getId() + "-" + id);
          var toolsContainer = document.createElement("div");
          toolbar.appendChild(toolsContainer);
          var subSectionContainer = document.createElement("div");
          ViperUtil.setHtml(subSectionContainer, '<span class="Viper-subSectionArrow"></span>');
          toolbar.appendChild(subSectionContainer);
          ViperUtil.addClass(toolbar, "ViperITP Viper-themeDark Viper-scalable");
          ViperUtil.addClass(toolsContainer, "ViperITP-tools");
          ViperUtil.addClass(subSectionContainer, "ViperITP-subSectionWrapper");
          if (navigator.userAgent.match(/iPad/i) !== null) {
            ViperUtil.addClass(toolbar, "device-ipad");
          }
          if (compact === true) {
            ViperUtil.addClass(toolbar, "Viper-compact");
          }
          ViperUtil.addEvent(toolbar, "mousedown", function(e) {
            var target = ViperUtil.getMouseEventTarget(e);
            if (ViperUtil.isTag(target, "input") !== true && ViperUtil.isTag(target, "textarea") !== true) {
              ViperUtil.preventDefault(e);
              return false;
            }
          });
          ViperUtil.addEvent(toolbar, "mouseup", function(e) {
            ViperUtil.preventDefault(e);
            return false;
          });
          var _update = false;
          this.viper.registerCallback("Viper:selectionChanged", id, function(range) {
            if (self.viper.rangeInViperBounds(range) === false) {
              return;
            }
            if (range.collapsed === true && _update !== true) {
              self.getItem(id).hide();
              return;
            }
            self.getItem(id).update(range);
          });
          this.viper.registerCallback("Viper:editableElementChanged", id, function() {
            var elemDoc = self.viper.getViperElementDocument();
            if (elemDoc !== document) {
              var t = null;
              var toolbar2 = self.getItem(id);
              ViperUtil.removeEvent(elemDoc.defaultView, "scroll." + id);
              ViperUtil.addEvent(elemDoc.defaultView, "scroll." + id, function(e) {
                if (toolbar2.isVisible() === true) {
                  self.getItem(id).updatePosition();
                }
              });
            }
          });
          this.viper.registerCallback(["Viper:clickedOutside", "Viper:disabled"], id, function(range) {
            self.getItem(id).hide();
          });
          this.viper.registerCallback(["Viper:mouseDown", "ViperHistoryManager:undo"], id, function(data) {
            _update = false;
            if (data && data.target) {
              var target = ViperUtil.getMouseEventTarget(data);
              if (target === toolbar || ViperUtil.isChildOf(target, toolbar) === true) {
                if (ViperUtil.isTag(target, "input") === true || ViperUtil.isTag(target, "textarea") === true) {
                  return true;
                }
                return false;
              } else if (elementTypes && ViperUtil.inArray(ViperUtil.getTagName(target), elementTypes) === true) {
                self.getItem(id).update(null, target);
                return;
              } else if (ViperUtil.inArray(ViperUtil.getTagName(target), self.getItem(id)._keepOpenTagList) === true) {
                _update = true;
                return;
              } else {
                var allParents = ViperUtil.getParents(target, null, self.viper.getViperElement());
                for (var i = 0; i < allParents.length; i++) {
                  if (ViperUtil.inArray(ViperUtil.getTagName(allParents[i]), self.getItem(id)._keepOpenTagList) === true) {
                    _update = true;
                    return;
                  }
                }
                var parents = ViperUtil.getSurroundingParents(target);
                for (var i = 0; i < parents.length; i++) {
                  if (ViperUtil.inArray(ViperUtil.getTagName(parents[i]), self.getItem(id)._keepOpenTagList) === true) {
                    _update = true;
                    return;
                  }
                }
              }
            }
            self.getItem(id).hide();
          });
          var tools = this;
          var buttonElements = null;
          this.addItem(id, {
            type: "toolbar",
            element: toolbar,
            addButton: function(button, index) {
              if (ViperUtil.isset(index) === true && toolsContainer.childNodes.length > index) {
                if (index < 0) {
                  index = toolsContainer.childNodes.length + index;
                  if (index < 0) {
                    index = 0;
                  }
                }
                ViperUtil.insertBefore(toolsContainer.childNodes[index], button);
              } else {
                toolsContainer.appendChild(button);
              }
            },
            showButton: function(buttonid, disabled) {
              if (tools.getItem(buttonid).type !== "button") {
                throw new Error("Invalid button for showButton(): " + buttonid);
              } else if (this._availableButtons !== null && !this._availableButtons[buttonid.toLowerCase()]) {
                return;
              }
              this._buttonShown = true;
              var button = self.getItem(buttonid);
              ViperUtil.removeClass(button.element, "ViperITP-button-hidden");
              ViperUtil.removeClass(button.element.parentNode, "ViperITP-button-hidden");
              if (disabled === true) {
                self.disableButton(buttonid);
              } else {
                self.enableButton(buttonid);
              }
            },
            update: function(range, element) {
              if (!updateCallback || self.viper.isEnabled() === false) {
                return;
              }
              var selectedNode = element || null;
              range = range || self.viper.getViperRange();
              if (!selectedNode) {
                if (elementTypes && elementTypes.length > 0) {
                  return;
                }
              }
              var activeSection = this._activeSection;
              if (range.collapsed === true) {
                activeSection = null;
              }
              this.closeActiveSubsection(true);
              this._buttonShown = false;
              this._subSectionShown = false;
              this.resetButtons();
              if (buttonElements === null) {
                buttonElements = [];
                for (var node = toolsContainer.firstChild; node; node = node.nextSibling) {
                  if (ViperUtil.hasClass(node, "Viper-buttonGroup") === true) {
                    var groupButtons = [node];
                    for (var button = node.firstChild; button; button = button.nextSibling) {
                      groupButtons.push(button);
                    }
                    buttonElements.push(groupButtons);
                  } else if (ViperUtil.hasClass(node, "Viper-button") === true) {
                    buttonElements.push(node);
                  }
                }
              } else {
                while (toolsContainer.firstChild) {
                  toolsContainer.removeChild(toolsContainer.firstChild);
                }
                for (var i = 0; i < buttonElements.length; i++) {
                  if (buttonElements[i].length) {
                    for (var j = 1; j < buttonElements[i].length; j++) {
                      buttonElements[i][0].appendChild(buttonElements[i][j]);
                    }
                    toolsContainer.appendChild(buttonElements[i][0]);
                  } else {
                    toolsContainer.appendChild(buttonElements[i]);
                  }
                }
              }
              updateCallback.call(this, range, selectedNode, activeSection !== null);
              var buttonsToRemove = ViperUtil.getClass("ViperITP-button-hidden", toolsContainer);
              for (var i = 0; i < buttonsToRemove.length; i++) {
                buttonsToRemove[i].parentNode.removeChild(buttonsToRemove[i]);
              }
              if (this._buttonShown === true || this._subSectionShown === true) {
                this.updatePosition(range, selectedNode);
              } else {
                this.hide();
              }
              if (activeSection) {
                this.toggleSubSection(activeSection);
              }
            },
            resetButtons: function() {
              ViperUtil.removeClass(toolbar, "Viper-subSectionVisible");
              ViperUtil.addClass(ViperUtil.getClass("Viper-buttonGroup", toolsContainer), "ViperITP-button-hidden");
              var buttons = ViperUtil.getClass("Viper-button", toolsContainer);
              ViperUtil.addClass(buttons, "ViperITP-button-hidden");
              ViperUtil.removeClass(buttons, "Viper-selected");
              ViperUtil.removeClass(buttons, "Viper-active");
            },
            hide: function() {
              if (this._onHideCallback) {
                if (this._onHideCallback.call(this) === false) {
                  return false;
                }
              }
              this.closeActiveSubsection(true);
              this._activeSection = null;
              ViperUtil.removeClass(toolbar, "Viper-visible");
              for (let subsectionid in this._subSectionActionWidgets) {
                tools.disableButton(subsectionid + "-applyButton");
              }
              return true;
            },
            isVisible: function() {
              return ViperUtil.hasClass(toolbar, "Viper-visible");
            },
            /**
             * Adds the given element as a sub section of the toolbar.
             *
             * @param {string} id       The id of the new sub section.
             * @param {DOMNode} element The DOMNode to convert to sub section.
             *
             * @return {DOMNode} The element that was passed in.
             */
            makeSubSection: function(id2, element, onOpenCallback, onCloseCallback) {
              if (!element) {
                return false;
              }
              var subSection = document.createElement("div");
              var form = document.createElement("form");
              subSection.appendChild(form);
              form.appendChild(element);
              form.onsubmit = function() {
                return false;
              };
              var submitBtn = document.createElement("input");
              submitBtn.type = "submit";
              ViperUtil.setStyle(submitBtn, "display", "none");
              form.appendChild(submitBtn);
              ViperUtil.addClass(subSection, "Viper-subSection");
              this._subSections[id2] = subSection;
              subSectionContainer.appendChild(subSection);
              tools.addItem(id2, {
                type: "VITPSubSection",
                element: subSection,
                form,
                _onOpenCallback: onOpenCallback,
                _onCloseCallback: onCloseCallback,
                setActionButtonTitle: function(title) {
                  self.viper.Tools.getItem(id2 + "-applyButton").setContent(title);
                }
              });
              return subSection;
            },
            /**
             * Sets the specified button to toggle the given sub section.
             *
             * @param {string} buttonid     Id of the button.
             * @param {string} subSectionid Id of the sub section.
             */
            setSubSectionButton: function(buttonid, subSectionid) {
              if (!this._subSections[subSectionid]) {
                throw new Error("Invalid sub section id: " + subSectionid);
                return false;
              }
              var button = tools.getItem(buttonid).element;
              var self2 = this;
              this._subSectionButtons[subSectionid] = buttonid;
              ViperUtil.removeEvent(button, "mousedown");
              ViperUtil.addEvent(button, "mousedown", function(e) {
                self2.toggleSubSection(subSectionid);
                ViperUtil.preventDefault(e);
              });
            },
            /**
             * Toggles the visibility of the specified sub section.
             *
             * @param {string} subSectionid The if of the sub section.
             */
            toggleSubSection: function(subSectionid, ignoreCallbacks) {
              var subSection = this._subSections[subSectionid];
              if (!subSection) {
                return false;
              }
              if (this._activeSection) {
                var activeSubSection = this._activeSection;
                this.closeActiveSubsection(ignoreCallbacks);
                if (subSectionid === activeSubSection) {
                  return;
                }
              }
              ViperUtil.removeClass(
                ViperUtil.getClass("Viper-subSection Viper-active", subSectionContainer),
                "Viper-active"
              );
              if (this._subSectionButtons[subSectionid]) {
                var subSectionButton = tools.getItem(this._subSectionButtons[subSectionid]).element;
                if (ViperUtil.hasClass(subSectionButton, "ViperITP-button-hidden") === true) {
                  this._activeSection = null;
                  return;
                }
              }
              if (ignoreCallbacks !== true) {
                var openCallback = tools.getItem(subSectionid)._onOpenCallback;
                if (openCallback) {
                  openCallback.call(this);
                }
              }
              ViperUtil.addClass(subSectionButton, "Viper-selected");
              ViperUtil.addClass(subSection, "Viper-active");
              ViperUtil.addClass(toolbar, "Viper-subSectionVisible");
              this._activeSection = subSectionid;
              this._updateSubSectionArrowPos();
              var self2 = this;
              setTimeout(function() {
                self2.focusSubSection();
              }, 50);
              this._subSectionShown = true;
              var subSectionForm = tools.getItem(subSectionid).form;
              ViperUtil.removeEvent(document, "keydown." + id);
              ViperUtil.addEvent(document, "keydown." + id, function(e) {
                if (subSectionForm && e.which === 13 && ViperUtil.isTag(e.target, "textarea") === false) {
                  return subSectionForm.onsubmit();
                }
              });
            },
            focusSubSection: function() {
              try {
                var subSection = this._subSections[this._activeSection];
                var inputElements = ViperUtil.getTag("input[type=text], textarea, input[type=checkbox]", subSection);
                if (inputElements.length > 0) {
                  for (var i = 0; i < inputElements.length; i++) {
                    if (ViperUtil.getElementWidth(inputElements[i]) === 0 || inputElements[i].disabled) {
                      continue;
                    }
                    inputElements[i].focus();
                    ViperUtil.removeClass(inputElements[i].parentNode.parentNode.parentNode, "Viper-active");
                    tools.viper.highlightSelection();
                    break;
                  }
                }
              } catch (e) {
              }
            },
            closeActiveSubsection: function(ignoreCallbacks) {
              if (this._activeSection) {
                var prevSubSection = this._subSections[this._activeSection];
                if (prevSubSection) {
                  ViperUtil.removeClass(prevSubSection, "Viper-active");
                  tools.viper.fireCallbacks("ViperToolbar:subsectionClosed", this._activeSection);
                  if (this._subSectionButtons[this._activeSection]) {
                    ViperUtil.removeClass(
                      tools.getItem(this._subSectionButtons[this._activeSection]).element,
                      "Viper-selected"
                    );
                  }
                  if (ignoreCallbacks !== true) {
                    var closeCallback = tools.getItem(this._activeSection)._onCloseCallback;
                    if (closeCallback) {
                      closeCallback.call(this);
                    }
                  }
                  ViperUtil.removeClass(toolbar, "Viper-subSectionVisible");
                  this._activeSection = null;
                  ViperUtil.removeEvent(document, "keydown." + id);
                  return;
                }
              }
            },
            /**
             *
             *
             * @param {string}   subSectionid The id of the sub section.
             * @param {function} action       The function to call when the sub section action
             *                                is triggered.
             * @param {array}    widgetids    The id of widgets that will cause the action
             *                                button to be activated when they are changed.
             *
             * @return void
             */
            setSubSectionAction: function(subSectionid, action, widgetids) {
              widgetids = widgetids || [];
              var subSection = tools.getItem(subSectionid);
              if (!subSection) {
                return;
              }
              subSection.form.onsubmit = function(e) {
                if (e) {
                  ViperUtil.preventDefault(e);
                }
                var button2 = tools.getItem(subSectionid + "-applyButton");
                if (button2.isEnabled() === false) {
                  return false;
                }
                tools.viper.focus();
                try {
                  action.call(this);
                } catch (e2) {
                  console.error("Sub Section Action threw exception:" + e2.message, e2.stack);
                }
                tools.disableButton(subSectionid + "-applyButton");
                return false;
              };
              var button = tools.createButton(
                subSectionid + "-applyButton",
                _("Apply Changes"),
                _("Apply Changes"),
                "",
                subSection.form.onsubmit,
                true
              );
              subSection.element.appendChild(button);
              this.addSubSectionActionWidgets(subSectionid, widgetids);
            },
            addSubSectionActionWidgets: function(subSectionid, widgetids) {
              if (!this._subSectionActionWidgets[subSectionid]) {
                this._subSectionActionWidgets[subSectionid] = [];
              }
              var self2 = this;
              for (var i = 0; i < widgetids.length; i++) {
                this._subSectionActionWidgets[subSectionid].push(widgetids[i]);
                (function(widgetid) {
                  tools.viper.registerCallback("ViperTools:changed:" + widgetid, "ViperToolbarPlugin:" + id, function() {
                    if (self2._subSectionActionDisabled[subSectionid] === true) {
                      return;
                    }
                    var subSectionWidgets = self2._subSectionActionWidgets[subSectionid];
                    var c = subSectionWidgets.length;
                    var enable = true;
                    for (var j = 0; j < c; j++) {
                      var widget = tools.getItem(subSectionWidgets[j]);
                      if (widget && widget.required === true && ViperUtil.trim(widget.getValue()) === "") {
                        enable = false;
                        break;
                      }
                    }
                    if (enable === true) {
                      tools.enableButton(subSectionid + "-applyButton");
                    } else {
                      tools.disableButton(subSectionid + "-applyButton");
                    }
                  });
                })(widgetids[i]);
              }
            },
            disableSubsectionAction: function(subsectionid, keepButtonState) {
              if (keepButtonState !== true) {
                tools.disableButton(subsectionid + "-applyButton");
              }
              this._subSectionActionDisabled[subsectionid] = true;
            },
            enableSubsectionAction: function(subsectionid, keepButtonState) {
              if (keepButtonState !== true) {
                tools.enableButton(subsectionid + "-applyButton");
              }
              delete this._subSectionActionDisabled[subsectionid];
            },
            getActiveSection: function() {
              return this._activeSection;
            },
            addKeepOpenTag: function(tagName) {
              this._keepOpenTagList.push(tagName);
            },
            orderButtons: function(buttonOrder) {
              var buttons = ViperUtil.getClass("Viper-button", toolsContainer);
              var c = buttons.length;
              if (c === 0) {
                return;
              }
              this._availableButtons = {};
              buttonElements = null;
              while (toolsContainer.firstChild) {
                toolsContainer.removeChild(toolsContainer.firstChild);
              }
              var addedButtons = this.addedButtons;
              if (addedButtons === null) {
                addedButtons = {};
                for (var i = 0; i < c; i++) {
                  var button = buttons[i];
                  var id2 = button.id.toLowerCase().replace(self.viper.getId().toLowerCase() + "-vitp", "");
                  addedButtons[id2] = button;
                }
                this.addedButtons = addedButtons;
              }
              var bc = buttonOrder.length;
              for (var i = 0; i < bc; i++) {
                var button = buttonOrder[i];
                if (typeof button === "string") {
                  button = button.toLowerCase();
                  if (addedButtons[button]) {
                    this._availableButtons["vitp" + button.toLowerCase()] = true;
                    this.addButton(addedButtons[button]);
                  }
                } else {
                  var gc = button.length;
                  var groupid = null;
                  for (var j = 0; j < gc; j++) {
                    if (addedButtons[button[j].toLowerCase()]) {
                      if (groupid === null) {
                        groupid = "ViperInlineToolbarPlugin:buttons:" + i;
                        const groupElement = self.createButtonGroup(groupid);
                        this.addButton(groupElement);
                      }
                      this._availableButtons["vitp" + button[j].toLowerCase()] = true;
                      self.addButtonToGroup("vitp" + ViperUtil.ucFirst(button[j]), groupid);
                    }
                  }
                }
              }
            },
            addedButtons: null,
            hideToolsSection: function() {
              ViperUtil.setStyle(toolsContainer, "display", "none");
              ViperUtil.addClass(toolbar, "Viper-noTools");
            },
            setOnHideCallback: function(callback) {
              this._onHideCallback = callback;
            },
            _subSections: {},
            _activeSection: null,
            _subSectionButtons: {},
            _subSectionActionWidgets: {},
            _subSectionActionDisabled: {},
            _buttonShown: false,
            _subSectionShown: false,
            _verticalPosUpdateOnly: false,
            _keepOpenTagList: [],
            _onHideCallback: null,
            _availableButtons: null,
            updatePosition: function(range, selectedNode) {
              var _self = this;
              self.viper.Tools.updatePositionOfElement(toolbar, range, selectedNode, function() {
                _self.hide();
              });
            },
            setVerticalUpdateOnly: function(verticalOnly) {
              this._verticalPosUpdateOnly = verticalOnly;
            },
            _updateSubSectionArrowPos: function() {
              if (!this._activeSection) {
                return;
              }
              var button = this._subSectionButtons[this._activeSection];
              if (!button) {
                return;
              }
              button = tools.getItem(button).element;
              if (!button) {
                return;
              }
              var buttonRect = ViperUtil.getBoundingRectangle(button);
              var toolbarPos = ViperUtil.getBoundingRectangle(toolbar);
              var xPos = buttonRect.x1 - toolbarPos.x1 + (buttonRect.x2 - buttonRect.x1) / 2;
              ViperUtil.setStyle(subSectionContainer.firstChild, "left", xPos + "px");
            }
          });
          this.viper.addElement(toolbar);
          return toolbar;
        },
        getVisibleToolbarRectangles: function() {
          var rects = [];
          var visibleToolbars = ViperUtil.getClass("ViperITP Viper-visible", this.viper.getElementHolder());
          if (visibleToolbars.length === 0) {
            return rects;
          }
          for (var i = 0; i < visibleToolbars.length; i++) {
            rects.push(ViperUtil.getBoundingRectangle(visibleToolbars[i]));
          }
          return rects;
        },
        createToolTip: function(id, content, element) {
          var self = this;
          var tooltip = document.createElement("div");
          ViperUtil.addClass(tooltip, "Viper-tooltip");
          ViperUtil.setHtml(tooltip, content);
          var visible = false;
          var mouseX = 0;
          var mouseY = 0;
          if (element && element !== "mouse") {
            var timer = null;
            ViperUtil.hover(
              element,
              function() {
                timer = setTimeout(function() {
                  self.getItem(id).show(element);
                }, 500);
              },
              function() {
                clearTimeout(timer);
                self.getItem(id).hide();
              }
            );
          } else if (element === "mouse") {
            ViperUtil.addEvent(document, "mousemove", function(e) {
              mouseX = e.pageX;
              mouseY = e.pageY;
              if (visible !== true) {
                return;
              }
              ViperUtil.setStyle(tooltip, "left", mouseX + "px");
              ViperUtil.setStyle(tooltip, "top", mouseY + "px");
            });
          }
          this.addItem(id, {
            type: "tooltip",
            element: tooltip,
            show: function(elem) {
              if (elem && elem.nodeType) {
                var rect = ViperUtil.getBoundingRectangle(elem);
                ViperUtil.setStyle(tooltip, "left", rect.x2 + "px");
                ViperUtil.setStyle(tooltip, "top", rect.y2 + "px");
                self.viper.addElement(tooltip);
                visible = true;
              } else if (elem === "mouse" || element === "mouse") {
                ViperUtil.setStyle(tooltip, "left", mouseX + "px");
                ViperUtil.setStyle(tooltip, "top", mouseY + "px");
                self.viper.addElement(tooltip);
                visible = true;
              }
            },
            hide: function() {
              visible = false;
              if (tooltip.parentNode) {
                tooltip.parentNode.removeChild(tooltip);
              }
            }
          });
          return tooltip;
        },
        createPopoutPanel: function(id, contentElement) {
          var panel = document.createElement("div");
          ViperUtil.addClass(panel, "Viper-popoutPanel");
          ViperUtil.attr(panel, "data-id", id);
          if (contentElement) {
            panel.appendChild(contentElement);
          }
          this.viper.addElement(panel);
          this.addItem(id, {
            type: "popoutPanel",
            element: panel,
            show: function(target) {
              ViperUtil.addClass(panel, "ViperUtil-visible");
              ViperUtil.determinePosition(panel, {
                targetElement: target,
                position: "right",
                arrowPositions: ["left.middle", "left.top", "left.bottom"]
              });
            },
            hide: function() {
              ViperUtil.removeClass(panel, "ViperUtil-visible");
            },
            isOpen: function() {
              return ViperUtil.hasClass(panel, "ViperUtil-visible");
            }
          });
          return panel;
        },
        createSelectionList: function(id, listItems, itemClickedCallback) {
          var self = this;
          var list = document.createElement("ol");
          ViperUtil.addClass(list, "Viper-selectionList");
          for (var itemid in listItems) {
            var li = document.createElement("li");
            ViperUtil.attr(li, "data-id", itemid);
            if (typeof listItems[itemid] === "string") {
              ViperUtil.setHtml(li, listItems[itemid]);
            } else {
              ViperUtil.setHtml(li, listItems[itemid].content);
              if (listItems[itemid].selected === true) {
                ViperUtil.addClass(li, "ViperUtil-selectionList-selected");
              }
            }
            list.appendChild(li);
          }
          ViperUtil.addEvent(list, "click", function(e) {
            if (ViperUtil.isTag(e.target, "li") === true) {
              ViperUtil.toggleClass(e.target, "selected");
              self.viper.fireCallbacks("ViperTools:changed:" + id);
              if (itemClickedCallback) {
                itemClickedCallback.call(
                  this,
                  ViperUtil.attr(e.target, "data-id"),
                  ViperUtil.hasClass(e.target, "selected"),
                  e.target
                );
              }
            }
          });
          ViperUtil.addEvent(list, "click", function(e) {
          });
          this.addItem(id, {
            type: "selectionList",
            element: list,
            setSelectedItems: function(itemids, isInitialValue) {
              var items = ViperUtil.getTag("li", list);
              var ln = items.length;
              for (var i = 0; i < ln; i++) {
                if (ViperUtil.inArray(ViperUtil.attr(items[i], "data-id"), itemids) === true) {
                  ViperUtil.addClass(items[i], "selected");
                } else {
                  ViperUtil.removeClass(items[i], "selected");
                }
              }
              if (isInitialValue !== true) {
                self.viper.fireCallbacks("ViperTools:changed:" + id);
              }
            },
            getSelectedItems: function() {
              var selectedItems = ViperUtil.getClass("selected", list);
              var items = [];
              for (var i = 0; i < selectedItems.length; i++) {
                items.push(ViperUtil.attr(selectedItems[i], "data-id"));
              }
              return items;
            },
            removeFromSelection: function(itemid2) {
              var items = ViperUtil.getClass("selected", list);
              var ln = items.length;
              for (var i = 0; i < ln; i++) {
                if (ViperUtil.attr(items[i], "data-id") === itemid2) {
                  ViperUtil.removeClass(items[i], "selected");
                  self.viper.fireCallbacks("ViperTools:changed:" + id);
                  break;
                }
              }
            },
            hideItem: function(itemid2) {
              var items = ViperUtil.getTag("li", list);
              var item = this._getItem(itemid2);
              ViperUtil.addClass(item, "Viper-hidden");
              ViperUtil.removeClass(ViperUtil.getClass("lastVisibleItem", list), "lastVisibleItem");
              for (var i = items.length - 1; i >= 0; i--) {
                if (ViperUtil.hasClass(items[i], "Viper-hidden") === false) {
                  ViperUtil.addClass(items[i], "lastVisibleItem");
                  break;
                }
              }
            },
            showItem: function(itemid2) {
              var items = ViperUtil.getTag("li", list);
              var item = this._getItem(itemid2);
              ViperUtil.removeClass(item, "Viper-hidden");
              ViperUtil.removeClass(ViperUtil.getClass("lastVisibleItem", list), "lastVisibleItem");
              for (var i = items.length - 1; i >= 0; i--) {
                if (ViperUtil.hasClass(items[i], "Viper-hidden") === false) {
                  ViperUtil.addClass(items[i], "lastVisibleItem");
                  break;
                }
              }
            },
            _getItem: function(itemid2) {
              return ViperUtil.find(list, '[data-id="' + itemid2 + '"]')[0];
            }
          });
          return list;
        },
        scaleElement: function(element) {
          var zoom = document.documentElement.clientWidth / window.innerWidth;
          if (zoom === 1) {
            var scale = 1;
            ViperUtil.setStyle(element, "-webkit-transform", "scale(" + scale + ", " + scale + ")");
            ViperUtil.setStyle(element, "-moz-transform", "scale(" + scale + ", " + scale + ")");
            return;
          }
          var scale = 1 / zoom + 0.2;
          ViperUtil.setStyle(element, "-webkit-transform", "scale(" + scale + ", " + scale + ")");
          ViperUtil.setStyle(element, "-moz-transform", "scale(" + scale + ", " + scale + ")");
          return scale;
        },
        updatePositionOfElement: function(element, range, selectedNode, hideCallback) {
          var margin = 15;
          var tools = this.viper.Tools;
          range = range || tools.viper.getViperRange();
          var getElementCoords2 = function(element2) {
            var elemRect = ViperUtil.getBoundingRectangle(element2);
            var scrollCoords2 = ViperUtil.getScrollCoords(element2.ownerDocument.defaultView);
            return {
              left: elemRect.x1 - scrollCoords2.x,
              right: elemRect.x2 - scrollCoords2.x,
              top: elemRect.y1 - scrollCoords2.y,
              bottom: elemRect.y2 - scrollCoords2.y
            };
          };
          var rangeCoords = null;
          var selectedNode = selectedNode || range.getNodeSelection(range);
          if (selectedNode !== null && selectedNode !== tools.viper.getViperElement()) {
            rangeCoords = getElementCoords2(selectedNode);
          } else {
            rangeCoords = range.rangeObj.getBoundingClientRect();
          }
          if (!rangeCoords || rangeCoords.left === 0 && rangeCoords.top === 0 && ViperUtil.isBrowser("firefox") === true) {
            if (range.collapsed === true) {
              var span = document.createElement("span");
              tools.viper.insertNodeAtCaret(span);
              rangeCoords = getElementCoords2(span);
              ViperUtil.remove(span);
              if (!rangeCoords) {
                return;
              }
            } else {
              var startNode = range.getStartNode();
              var endNode = range.getEndNode();
              if (!startNode || !endNode) {
                return;
              }
              if (startNode.nodeType === ViperUtil.TEXT_NODE && startNode.data.indexOf("\n") === 0 && endNode.nodeType === ViperUtil.TEXT_NODE && range.endOffset === endNode.data.length) {
                range.setStart(endNode, endNode.data.length);
                range.collapse(true);
                rangeCoords = range.rangeObj.getBoundingClientRect();
              }
            }
          }
          if (!rangeCoords || rangeCoords.bottom === 0 && rangeCoords.height === 0 && rangeCoords.left === 0) {
            if (ViperUtil.isBrowser("chrome") === true || ViperUtil.isBrowser("safari") === true) {
              var startNode = range.getStartNode();
              if (startNode.nodeType === ViperUtil.TEXT_NODE) {
                if (range.startOffset < startNode.data.length) {
                  var offset = range.startOffset;
                  if (startNode.data.length > 1) {
                    offset += 1;
                  }
                  range.setEnd(startNode, offset);
                  rangeCoords = range.rangeObj.getBoundingClientRect();
                  range.collapse(true);
                  if (rangeCoords) {
                    rangeCoords.right = rangeCoords.left;
                  }
                } else if (range.startOffset > 0) {
                  range.setStart(startNode, range.startOffset - 1);
                  rangeCoords = range.rangeObj.getBoundingClientRect();
                  range.collapse(false);
                  if (rangeCoords) {
                    rangeCoords.right = rangeCoords.left;
                  }
                }
              }
            } else {
              rangeCoords = getElementCoords2(tools.viper.getViperElement());
              rangeCoords.bottom = rangeCoords.top + 10;
            }
          }
          var frameOffset = { x: 0, y: 0 };
          const rangeDocument = range.getStartNode().ownerDocument;
          const elementDocument = element.ownerDocument;
          if (rangeDocument !== elementDocument) {
            frameOffset = ViperUtil.getDocumentOffset(rangeDocument);
            var newCoords = {};
            newCoords.bottom = rangeCoords.bottom + frameOffset.y;
            newCoords.top = rangeCoords.top + frameOffset.y;
            newCoords.bottom = rangeCoords.bottom + frameOffset.y;
            newCoords.left = rangeCoords.left + frameOffset.x;
            newCoords.right = rangeCoords.right + frameOffset.x;
            newCoords.height = rangeCoords.height;
            newCoords.width = rangeCoords.width;
            rangeCoords = newCoords;
          }
          var scrollCoords = ViperUtil.getScrollCoords();
          if (selectedNode && selectedNode.ownerDocument !== document || range.startContainer && range.startContainer.ownerDocument !== document) {
            scrollCoords.x = 0;
            scrollCoords.y = 0;
          }
          ViperUtil.addClass(element, "Viper-calcWidth");
          ViperUtil.setStyle(element, "width", "auto");
          var elementWidth = ViperUtil.getElementWidth(element);
          ViperUtil.removeClass(element, "Viper-calcWidth");
          ViperUtil.setStyle(element, "width", elementWidth + "px");
          var viperElemCoords = getElementCoords2(tools.viper.getViperElement());
          var elemWindowDim = ViperUtil.getWindowDimensions(Viper2.document.defaultView);
          var mainWindowDim = ViperUtil.getWindowDimensions();
          if (this._verticalPosUpdateOnly !== true) {
            var left = rangeCoords.left + (rangeCoords.right - rangeCoords.left) / 2 + scrollCoords.x - elementWidth / 2;
            ViperUtil.removeClass(element, "Viper-orientationLeft Viper-orientationRight");
            if (left > elemWindowDim.width + frameOffset.x) {
              left = viperElemCoords.left;
            }
            if (left < 0) {
              left += elementWidth / 2;
              ViperUtil.addClass(element, "Viper-orientationLeft");
            } else if (left + elementWidth > mainWindowDim.width) {
              left -= elementWidth / 2;
              ViperUtil.addClass(element, "Viper-orientationRight");
            }
            ViperUtil.setStyle(element, "left", left + "px");
          }
          var top = rangeCoords.bottom + margin;
          if (ViperUtil.getStyle(element, "position") !== "fixed") {
            top += scrollCoords.y;
          }
          if (top === 0) {
            if (hideCallback) {
              hideCallback.call(this);
            }
            return;
          } else if (top + 50 > mainWindowDim.height + scrollCoords.y || top > elemWindowDim.height + scrollCoords.y + frameOffset.y) {
            if (hideCallback) {
              hideCallback.call(this);
            }
            return;
          } else if (top < viperElemCoords.top && Viper2.document === document) {
            top = viperElemCoords.top + 50;
            if (left < viperElemCoords.left && this._verticalPosUpdateOnly !== true) {
              ViperUtil.setStyle(element, "left", viperElemCoords.left + 50 + "px");
            }
          } else if (Viper2.document !== document && top < ViperUtil.getDocumentOffset().y) {
            if (hideCallback) {
              hideCallback.call(this);
            }
            return;
          }
          ViperUtil.setStyle(element, "top", top + "px");
          ViperUtil.addClass(element, "Viper-visible");
        }
      };
    };
  }
});

// src/Lib/Selection.js
var Selection_exports = {};
__export(Selection_exports, {
  registerPlugin: () => registerPlugin4
});
var registerPlugin4;
var init_Selection = __esm({
  "src/Lib/Selection.js"() {
    "use strict";
    registerPlugin4 = (Viper2) => {
      Viper2.Selection = {
        _selection: null,
        _viper: null,
        /**
         * Returns the selection object for the current browser.
         *
         * @return {ViperSelection}
         */
        _getSelection: function() {
          if (this._viper.document) {
            return this._viper.document.getSelection();
          }
          return this.Viper.document.getSelection();
        },
        /**
         * Creates a range object.
         *
         * @return {ViperDOMRange}
         */
        createRange: function() {
          var rangeObj = null;
          if (Viper2.document.createRange) {
            rangeObj = Viper2.document.createRange();
            return new Viper2.MozRange(rangeObj);
          } else {
            throw Error("UnsupportedOperationException: createRange() not supported.");
          }
        },
        /**
         * Returns the range object at the specified position. The current range object
         * is at position 0.
         *
         * @param int pos The position of the wanted range.
         *
         * @return {ViperDOMRange}
         */
        getRangeAt: function(pos) {
          this._selection = this._getSelection();
          var selection = this._selection;
          if (selection?.getRangeAt && selection.rangeCount > 0) {
            try {
              var range = selection.getRangeAt(pos);
              return new Viper2.MozRange(range);
            } catch (e) {
              return null;
            }
          }
          return this.createRange();
        },
        /**
         * Adds the specified range to the current selection.
         *
         * @param {ViperDOMRange} range The range to add.
         */
        addRange: function(range) {
          this._selection = this._getSelection();
          if (this._selection.addRange) {
            if (this._selection.rangeCount > 0) {
              this._selection.removeAllRanges();
            }
            this._selection.addRange(range.rangeObj);
          }
          if (this._viper) {
            this._viper.resetViperRange(range);
          }
        },
        removeRange: function(range) {
          var selection = this._getSelection();
          if (selection) {
            if (selection.removeRange) {
              selection.removeRange(range.rangeObj);
            } else if (selection.empty) {
              selection.empty();
            }
          }
        },
        removeAllRanges: function() {
          var selection = this._getSelection();
          if (selection.removeAllRanges) {
            selection.removeAllRanges();
          }
        }
      };
    };
  }
});

// src/Lib/DOMRange.js
var DOMRange_exports = {};
__export(DOMRange_exports, {
  registerPlugin: () => registerPlugin5
});
var registerPlugin5;
var init_DOMRange = __esm({
  "src/Lib/DOMRange.js"() {
    "use strict";
    registerPlugin5 = (Viper2) => {
      const { Util: ViperUtil, Selection: ViperSelection } = Viper2;
      Viper2.DOMRange = function(rangeObj) {
        this.rangeObj = rangeObj;
        this.startContainer = null;
        this.endContainer = null;
        this.startOffset = 0;
        this.endOffset = 0;
        this.collapsed = true;
        this.commonAncestorContainer = null;
        this.anchorToStart = "undefined";
      };
      Viper2.DOMRange.START_TO_START = 0;
      Viper2.DOMRange.START_TO_END = 1;
      Viper2.DOMRange.END_TO_END = 3;
      Viper2.DOMRange.END_TO_START = 4;
      Viper2.DOMRange.CHARACTER_UNIT = "character";
      Viper2.DOMRange.WORD_UNIT = "word";
      Viper2.DOMRange.LINE_UNIT = "line";
      Viper2.DOMRange.prototype = {
        /**
         * Moves the start point of the range to the offset within the specified node.
         *
         * @param Node    node   The node where the range should start.
         * @param Integer offset The offset within the node where the range should start.
         *
         * @return void
         * @throws RangeException, DomException
         */
        setStart: function(node, offset) {
        },
        /**
         * Moves the end point of the range to the offset within the specified node.
         *
         * @param Node    node   The node where the range should end.
         * @param Integer offset The offset within the node where the range should end.
         *
         * @return void
         * @throws RangeException, DomException
         */
        setEnd: function(node, offset) {
        },
        /**
         * Moves the start point of the range to before the specified node.
         *
         * @param Node node The node where the range should start before.
         *
         * @return void
         * @throws RangeException, DomException
         */
        setStartBefore: function(node) {
        },
        /**
         * Moves the start point of the range to after the specified node.
         *
         * @param Node node The node where the range should start after.
         *
         * @return void
         * @throws RangeException, DomException
         */
        setStartAfter: function(node) {
        },
        /**
         * Moves the end point of the range to before the specified node.
         *
         * @param Node node The node where the range should end before.
         *
         * @return void
         * @throws RangeException, DomException
         */
        setEndBefore: function(node) {
        },
        /**
         * Moves the end point of the range to after the specified node.
         *
         * @param Node node The node where the range should end after.
         *
         * @return void
         * @throws RangeException, DomException
         */
        setEndAfter: function(node) {
        },
        /**
         * Selects the node, including its element.
         *
         * @param Node node The node to be selected.
         *
         * @return void
         * @throws RangeException, DomException
         */
        selectNode: function(node) {
        },
        /**
         * Selects the node, excluding its element.
         *
         * @param Node node The node who's contents should be selected.
         *
         * @return void
         * @throws RangeException, DomException
         */
        selectNodeContents: function(node) {
        },
        /**
         * Selects the node, excluding its element.
         *
         * @param Node node The node who's contents should be selected.
         *
         * @return void
         * @throws RangeException, DomException
         */
        surroundContents: function(node) {
        },
        /**
         * Collapses the range to the start or end of the current boundary points.
         *
         * @param boolean toStart If TRUE the range will be collapsed the the start of
         *                        the range, otherwise it will be collapsed to the end
         *                        of the range.
         *
         * @return void
         * @throws DOMException
         */
        collapse: function(toStart) {
        },
        // Range Comparisons.
        /**
         * Compare the boundary-points of two Ranges in a document and returns
         * -1, 0 or 1 depending on whether the corresponding boundary-point of the
         * Range is respectively before, equal to, or after the corresponding
         * boundary-point of sourceRange.
         *
         * @param integer  how         A flag as to how to compare the boundary points
         *                             of the range, which should be one of
         *                             START_TO_START, END_TO_END, START_TO_END and
         *                             END_TO_START.
         * @param W3CRange sourceRange The source range to compare to this range.
         *
         * @return integer
         * @see W3CRange.START_TO_START
         * @see W3CRange.START_TO_END
         * @see W3CRange.END_TO_END
         * @see W3CRange.END_TO_START
         * @thows DOMException
         */
        compareBoundaryPoints: function(how, sourceRange) {
        },
        // Extract Content.
        /**
         * Deletes the contents within the current range.
         *
         * @return void
         * @throws DOMException
         */
        deleteContents: function() {
        },
        /**
         * Extracts the contents from the current document, returning the contents in
         * a document fragment.
         *
         * @return DocumentFragment
         * @throws DOMException
         */
        extractContents: function() {
        },
        /**
         * Clones the contents of the range, returning the content in a DocumentFragment
         * without modifying the current Viper.document.
         *
         * @return DocumentFragment.
         * @throws DOMException
         */
        cloneContents: function() {
        },
        // Inserting.
        /**
         * Inserts a node into the Document or DocumentFragment at the start of the Range.
         * If the container is a Text node, this will be split at the start of the Range
         * (as if the Text node's splitText method was performed at the insertion point)
         * and the insertion will occur between the two resulting Text nodes. Adjacent Text
         * nodes will not be automatically merged. If the node to be inserted is a
         * DocumentFragment node, the children will be inserted rather than the
         * DocumentFragment node itself.
         *
         * @param Node node The node to be inserted.
         *
         * @return void
         * @throws DOMException, RangeException
         */
        insertNode: function(node) {
        },
        // Misc.
        /**
         * Clones this range object and returns an exact copy.
         *
         * @return W3CRange.
         */
        cloneRange: function() {
        },
        /**
         * Returns the string contents of the selected text within the range. The contents
         * will not contain any markup.
         *
         * @return string
         */
        toString: function() {
        },
        /**
         * Detaches the range from the document releasing any resources used.
         *
         * @return void
         * @throws DOMException
         */
        detach: function() {
        },
        /*
         * Extensions the W3C Range, including some of the Internet Explorer Range
         * methods.
         */
        /**
         * Returns the DOMElement that is common between the start and end positions
         * of the range.
         *
         * @return DOMElement
         */
        getCommonElement: function() {
        },
        /**
         * Moves the start of the range using the specified unitType, by the specified
         * number of units. Defaults to Viper.DOMRange.CHARACTER_UNIT and units of 1.
         *
         * @param int unitType The unitType to move, which should be one of
         *                     Viper.DOMRange.CHARACTER_UNIT, Viper.DOMRange.WORD_UNIT or Viper.DOMRange.LINE_UNIT.
         * @param int units    The number of units to move. If positive the range will
         *                     be moved RIGHT for LTR languages, or LEFT or RTL languages.
         *
         * @return void
         */
        moveStart: function(unitType, units) {
        },
        /**
         * Moves the end of the range using the specified unitType, by the specified
         * number of units. Defaults to Viper.DOMRange.CHARACTER_UNIT and units of 1.
         *
         * @param int unitType The unitType to move, which should be one of
         *                     Viper.DOMRange.CHARACTER_UNIT, Viper.DOMRange.WORD_UNIT or Viper.DOMRange.LINE_UNIT.
         * @param int units    The number of units to move. If positive the range will
         *                     be moved RIGHT for LTR languages, or LEFT or RTL languages.
         *
         * @return void
         */
        moveEnd: function(unitType, units) {
        },
        /**
         * Sets the anchor point of the range to the start or end of the range. Once
         * the anchor point is set, the focus point becomes the other end of the range.
         *
         * @param boolean toStart If TRUE the anchor point will be set to the start
         *                        of the range, other the focus will be set the the
         *                        end.
         *
         * @see setFocus()
         * @see moveFocus()
         */
        setAnchor: function(toStart) {
        },
        /**
         * Sets the focus point to exist in the node at the specified offset. The
         * anchor point should be set using setAnchor before calling this method.
         *
         * @param DomNode node   The node where the focus should exist.
         * @param integer offset The offset within the node where the offset should
         *                       exist.
         *
         * @see setAnchor()
         * @see moveFocus()
         * @throws RangeException If no anchor point is set.
         */
        setFocus: function(node, offset) {
        },
        /**
         * Moves the focus point by the specified unitType by the number of specified
         * units. Defaults to Viper.DOMRange.CHARACTER_UNIT and units of 1.
         *
         * @param string unitType  The unitType to move, which should be one of
         *                         Viper.DOMRange.CHARACTER_UNIT, Viper.DOMRange.WORD_UNIT
         *                         or Viper.DOMRange.LINE_UNIT.
         * @param integer units    The number of units to move. If positive the range will
         *                         be moved RIGHT for LTR languages, or LEFT or RTL languages.
         *
         * @see setAnchor()
         * @see moveFocus()
         * @throws RangeException If no anchor point is set.
         */
        moveFocus: function(unitType, units) {
        },
        /**
         * Returns the coordinates where the range starts.
         *
         * If true, the start coodinates of the range will be return, otherwise the
         * end coordinates will be returned.
         *
         * @return Object[x, y]
         */
        getRangeCoords: function(toStart) {
        },
        /**
         * Returns the bounding rectangle for the range.
         *
         * @return Object[left, top, right, bottom]
         */
        getBoundingClientRect: function() {
        },
        /**
         * Returns the deepest previous container that the range can be extended to.
         * For example, if the previous container is an element that contains text nodes,
         * the the container's lastChild is returned.
         *
         * @param {DomNode} container        The current container.
         * @param {array}   skippedBlockElem Skipped block elements.
         *
         * @return The text container that range can extend to.
         * @type   {TextNode}
         */
        getPreviousContainer: function(container, skippedBlockElem, skipEmptyNodes, stubElementIsSelectable, stopAtBlockElement) {
          if (!container) {
            return null;
          }
          while (container.previousSibling) {
            container = container.previousSibling;
            if (container.nodeType !== ViperUtil.TEXT_NODE) {
              if (ViperUtil.isStubElement(container) === true) {
                return container;
              } else {
                var child = this._getLastSelectableChild(container, skipEmptyNodes, stubElementIsSelectable);
                if (child !== null) {
                  return child;
                }
              }
            } else if (this._isSelectable(container) === true) {
              return container;
            }
          }
          while (container && !container.previousSibling) {
            container = container.parentNode;
          }
          if (!container) {
            return null;
          }
          if (stopAtBlockElement === true && ViperUtil.isBlockElement(container) === true) {
            return null;
          }
          container = container.previousSibling;
          if (this._isSelectable(container) === true) {
            return container;
          } else if (skippedBlockElem && ViperUtil.isBlockElement(container) === true) {
            skippedBlockElem.push(container);
          }
          if (container && container.nodeType !== ViperUtil.TEXT_NODE) {
            var selChild = this._getLastSelectableChild(container, skipEmptyNodes, stubElementIsSelectable);
            if (selChild !== null) {
              return selChild;
            }
          }
          return this.getPreviousContainer(container, skippedBlockElem, skipEmptyNodes, stubElementIsSelectable);
        },
        _isSelectable: function(container) {
          if (container && container.nodeType === ViperUtil.TEXT_NODE && container.data.length !== 0 && container.data.match(/^\n\s*$/) === null) {
            return true;
          }
          return false;
        },
        /**
         * Returns the deepest next container that the range can be extended to.
         * For example, if the next container is an element that contains text nodes,
         * the the container's firstChild is returned.
         *
         * @param {DomNode} container        The current container.
         * @param {array}   skippedBlockElem Skipped block elements.
         *
         * @return The text container that range can extend to.
         * @type   {TextNode}
         */
        getNextContainer: function(container, skippedBlockElem, skipSpaceTextNodes, stubElementIsSelectable, stopAtBlockElement) {
          if (!container) {
            return null;
          }
          while (container.nextSibling) {
            container = container.nextSibling;
            if (container.nodeType !== ViperUtil.TEXT_NODE) {
              var child = this._getFirstSelectableChild(container, stubElementIsSelectable);
              if (child !== null) {
                return child;
              }
            } else if (this._isSelectable(container) === true) {
              return container;
            }
          }
          while (container && !container.nextSibling) {
            container = container.parentNode;
          }
          if (!container) {
            return null;
          }
          if (stopAtBlockElement === true && ViperUtil.isBlockElement(container) === true) {
            return null;
          }
          container = container.nextSibling;
          if (this._isSelectable(container) === true) {
            return container;
          } else if (skippedBlockElem && ViperUtil.isBlockElement(container) === true) {
            skippedBlockElem.push(container);
          }
          var selChild = this._getFirstSelectableChild(container, stubElementIsSelectable);
          if (selChild !== null && (stubElementIsSelectable === true && ViperUtil.isTag(selChild, "br") === true || skipSpaceTextNodes !== true || ViperUtil.trim(selChild.data) !== "")) {
            if (selChild.nodeType !== ViperUtil.TEXT_NODE || selChild.data.charCodeAt(0) !== 10) {
              return selChild;
            }
          }
          return this.getNextContainer(container, skippedBlockElem, skipSpaceTextNodes, stubElementIsSelectable);
        },
        _getFirstSelectableChild: function(element, stubElementIsSelectable) {
          if (element) {
            if (element.nodeType !== ViperUtil.TEXT_NODE) {
              var child = element.firstChild;
              while (child) {
                if (ViperUtil.attr(child, "contenteditable") === "false") {
                  var newNode = document.createTextNode("");
                  ViperUtil.insertBefore(child, newNode);
                  return newNode;
                } else if (this._isSelectable(child) === true || stubElementIsSelectable === true && ViperUtil.isStubElement(child) === true) {
                  return child;
                } else if (child.firstChild) {
                  var res = this._getFirstSelectableChild(child, stubElementIsSelectable);
                  if (res !== null) {
                    return res;
                  } else {
                    child = child.nextSibling;
                  }
                } else {
                  child = child.nextSibling;
                }
              }
            } else {
              return element;
            }
          }
          return null;
        },
        _getLastSelectableChild: function(element, skipEmptyNodes, stubElementIsSelectable) {
          if (element) {
            if (element.nodeType !== ViperUtil.TEXT_NODE) {
              var child = element.lastChild;
              while (child) {
                if (ViperUtil.attr(child, "contenteditable") === "false") {
                  var newNode = document.createTextNode("");
                  ViperUtil.insertAfter(child, newNode);
                  return newNode;
                } else if (this._isSelectable(child) === true || stubElementIsSelectable === true && ViperUtil.isStubElement(child) === true) {
                  return child;
                } else if (child.lastChild) {
                  var res = this._getLastSelectableChild(child, skipEmptyNodes, stubElementIsSelectable);
                  if (res !== null) {
                    return res;
                  } else {
                    child = child.previousSibling;
                  }
                } else {
                  child = child.previousSibling;
                }
              }
            } else {
              if (skipEmptyNodes !== true || element.data.match(/^\n\s*$/) === null) {
                return element;
              }
            }
          }
          return null;
        },
        moveCaretAway: function(sourceElement, parentElement, defaultTagName, back) {
          var next = true;
          var selectable = null;
          if (back === true) {
            next = false;
            selectable = this.getPreviousContainer(sourceElement, null, true, true);
            if (!selectable || (selectable !== parentElement && ViperUtil.isChildOf(selectable, parentElement) === false) === true) {
              next = true;
              selectable = this.getNextContainer(sourceElement, null, true, true);
            }
          } else {
            selectable = this.getNextContainer(sourceElement, null, true, true);
            if (!selectable || (selectable !== parentElement && ViperUtil.isChildOf(selectable, parentElement) === false) === true) {
              next = false;
              selectable = this.getPreviousContainer(sourceElement, null, true, true);
            }
          }
          if (!selectable || (selectable !== parentElement && ViperUtil.isChildOf(selectable, parentElement) === false) === true) {
            var defTag = null;
            if (defaultTagName !== "") {
              defTag = document.createElement(defaultTagName);
              ViperUtil.setHtml(defTag, "<br/>");
            } else {
              defTag = document.createTextNode(" ");
            }
            ViperUtil.insertAfter(sourceElement, defTag);
            this.setStart(defTag, 0);
            this.collapse(true);
            ViperSelection.addRange(this);
            return false;
          } else if (next === true || selectable.nodeType !== ViperUtil.TEXT_NODE) {
            this.setStart(selectable, 0);
            this.collapse(true);
          } else {
            this.setStart(selectable, selectable.data.length);
            this.collapse(true);
          }
          ViperSelection.addRange(this);
          return this;
        },
        _normalizeNode: function(node) {
          if (node.nodeType === ViperUtil.ELEMENT_NODE) {
            var c = node.childNodes.length;
            var str = "";
            var mChild = null;
            for (var i = 0; i < c; i++) {
              var child = node.childNodes[i];
              if (child.nodeType === ViperUtil.TEXT_NODE) {
                str += child.data;
                if (mChild === null) {
                  mChild = child;
                } else {
                  ViperUtil.remove(child);
                }
              } else if (mChild !== null) {
                mChild.data = str;
              }
            }
            if (mChild !== null) {
              mChild.nodeValue = str;
            }
          } else if (node.nodeType === ViperUtil.TEXT_NODE) {
            this._normalizeNode(node.parentNode);
          }
        },
        getNodeIndex: function(node) {
          if (!node || !node.parentNode) {
            return;
          }
          var index = 0;
          var prev = node.previousSibling;
          while (prev) {
            prev = prev.previousSibling;
            index++;
          }
          return index;
        },
        getStartNode: function() {
          if (!this.startContainer) {
            return null;
          }
          if (this.startContainer.nodeType === ViperUtil.ELEMENT_NODE) {
            var ln = this.startContainer.childNodes.length;
            if (ln > this.startOffset) {
              return this.startContainer.childNodes[this.startOffset];
            } else if (ln === this.startOffset && ViperUtil.isStubElement(this.startContainer.childNodes[this.startOffset - 1]) === true) {
              return this.startContainer.childNodes[this.startOffset - 1];
            } else if (ln > 0 && ln === this.startOffset && this.startContainer.childNodes[this.startOffset - 1].nodeType !== ViperUtil.TEXT_NODE && this.collapsed === true) {
              return this._getLastSelectableChild(this.startContainer.childNodes[this.startOffset - 1]);
            }
          }
          return this.startContainer;
        },
        getEndNode: function() {
          if (!this.endContainer) {
            return null;
          }
          if (this.endContainer.nodeType === ViperUtil.ELEMENT_NODE) {
            var ln = this.endContainer.childNodes.length;
            if (ln > this.endOffset) {
              return this.endContainer.childNodes[this.endOffset];
            } else if (ln === this.endOffset && ln !== 0) {
              var lastChild = this.endContainer.childNodes[this.endOffset - 1];
              if (ViperUtil.isStubElement(lastChild) === true) {
                return this.endContainer.childNodes[this.endOffset - 1];
              } else if (lastChild.nodeType === ViperUtil.ELEMENT_NODE && lastChild.lastChild.nodeType === ViperUtil.TEXT_NODE && this.startContainer.nodeType === ViperUtil.TEXT_NODE) {
                return lastChild.lastChild;
              } else if (ln > 0 && ln === this.endOffset && this.endContainer.childNodes[this.endOffset - 1].nodeType !== ViperUtil.TEXT_NODE && this.collapsed === true) {
                return this._getLastSelectableChild(this.endContainer.childNodes[this.endOffset - 1]);
              }
            }
          }
          return this.endContainer;
        },
        /**
         * Caching for the getNodeSelection method.
         */
        _nodeSel: {},
        /**
         * Clears the getNodeSelection() method cache.
         */
        clearNodeSelectionCache: function() {
          this._nodeSel = {};
        },
        getNodeSelection: function(range, forceUpdate) {
          range = range || this;
          if (forceUpdate !== true && this._nodeSel && this._nodeSel.startContainer === range.startContainer && this._nodeSel.endContainer === range.endContainer && this._nodeSel.startOffset === range.startOffset && this._nodeSel.endOffset === range.endOffset && this._nodeSel.collapsed === range.collapsed && this._nodeSel.commonAncestor === range.commonAncestorContainer && this._nodeSel.startNode === range.getStartNode() && this._nodeSel.endNode === range.getEndNode()) {
            return this._nodeSel.node;
          }
          this._nodeSel.startContainer = range.startContainer;
          this._nodeSel.endContainer = range.endContainer;
          this._nodeSel.startOffset = range.startOffset;
          this._nodeSel.endOffset = range.endOffset;
          this._nodeSel.collapsed = range.collapsed;
          this._nodeSel.startNode = range.getStartNode();
          this._nodeSel.endNode = range.getEndNode();
          this._nodeSel.commonAncestor = range.commonAncestorContainer;
          this._nodeSel.node = null;
          var startNode = range.getStartNode();
          var endNode = range.getEndNode();
          var common = range.getCommonElement();
          if (!startNode && !endNode) {
            this._nodeSel.node = null;
            return null;
          } else if (startNode && endNode && startNode === endNode && startNode.nodeType !== ViperUtil.TEXT_NODE && range.startOffset === range.endOffset && this.startContainer.childNodes.length >= range.startOffset && ViperUtil.isStubElement(startNode) === false) {
            this._nodeSel.node = null;
            return null;
          } else if (startNode && endNode && startNode === endNode && startNode.nodeType !== ViperUtil.TEXT_NODE && range.startOffset + 1 === range.endOffset && this.startContainer.childNodes.length >= range.startOffset) {
            this._nodeSel.node = startNode;
            return startNode;
          } else if (startNode && endNode && startNode.nodeType === ViperUtil.ELEMENT_NODE && endNode.nodeType === ViperUtil.ELEMENT_NODE && startNode !== endNode && endNode === common && !startNode.nextElementSibling && range.startOffset + 1 === range.endOffset) {
            this._nodeSel.node = startNode;
            return startNode;
          } else if (startNode && !endNode) {
            if (startNode.nodeType === ViperUtil.TEXT_NODE) {
              if (range.endContainer.nodeType === ViperUtil.ELEMENT_NODE && range.endOffset >= range.endContainer.childNodes.length && startNode.nodeType === ViperUtil.TEXT_NODE && range.startOffset === 0 && range.endContainer === range.commonAncestorContainer && (common.firstChild === startNode || this._getFirstSelectableChild(common) === startNode)) {
                this._nodeSel.node = range.commonAncestorContainer;
                return this._nodeSel.node;
              } else if (this._nodeSel.startOffset === startNode.data.length && startNode.nextSibling && startNode.nextSibling.nodeType === ViperUtil.ELEMENT_NODE && this._nodeSel.endContainer.childNodes.length === this._nodeSel.endOffset && this._nodeSel.endContainer.childNodes[this._nodeSel.endOffset - 1] === startNode.nextSibling) {
                this._nodeSel.node = startNode.nextSibling;
                return this._nodeSel.node;
              } else if (ViperUtil.trim(startNode.data) === "") {
                this._nodeSel.node = null;
                return null;
              } else {
                this._nodeSel.node = null;
                return null;
              }
            } else if (startNode.nodeType === ViperUtil.ELEMENT_NODE && this.endContainer === this.startContainer && this.startOffset === 0 && this.endOffset >= this.endContainer.childNodes.length) {
              if (this.endOffset === 1 && this.endContainer.childNodes.length === 1) {
                startNode = this.endContainer.childNodes[0];
              } else {
                startNode = this.endContainer;
              }
            }
            this._nodeSel.node = startNode;
            return startNode;
          } else if (!startNode && endNode) {
            this._nodeSel.node = endNode;
            return endNode;
          } else if (startNode.nodeType === ViperUtil.TEXT_NODE && endNode.nodeType === ViperUtil.TEXT_NODE && startNode === endNode && range.startOffset === 0 && range.endOffset === endNode.data.length && range.collapsed === false && endNode.nextSibling && (!ViperUtil.isTag(endNode.nextSibling, "br") || endNode.nextSibling.nextSibling)) {
            this._nodeSel.node = null;
            return null;
          } else if (startNode.nodeType === ViperUtil.TEXT_NODE && endNode.nodeType === ViperUtil.TEXT_NODE && startNode === endNode && range.startOffset === startNode.data.length && range.collapsed === true) {
            this._nodeSel.node = null;
            return null;
          } else if (startNode.nodeType === ViperUtil.ELEMENT_NODE && range.endContainer.nodeType === ViperUtil.ELEMENT_NODE && startNode.nextSibling === endNode) {
            this._nodeSel.node = startNode;
            return startNode;
          } else if (startNode.nodeType === ViperUtil.TEXT_NODE && endNode.nodeType === ViperUtil.TEXT_NODE && range.startOffset === 0 && range.endOffset === endNode.data.length && this._getFirstSelectableChild(common) === startNode && this._getLastSelectableChild(common) === endNode) {
            this._nodeSel.node = common;
            return common;
          } else if (range.startContainer === range.endContainer && range.startContainer.nodeType === ViperUtil.ELEMENT_NODE && range.startOffset === 0 && range.endOffset === 0 && (range.startContainer.childNodes.length === 0 || range.startContainer.childNodes.length === 1 && ViperUtil.isStubElement(range.startContainer.childNodes[0]) === false && (range.startContainer.childNodes[0].nodeType !== ViperUtil.TEXT_NODE || range.startContainer.childNodes[0].data.length === 0))) {
            this._nodeSel.node = range.startContainer;
            return range.startContainer;
          } else if (startNode.nodeType === ViperUtil.ELEMENT_NODE && endNode.nodeType === ViperUtil.TEXT_NODE && range.endOffset === endNode.data.length && this._getLastSelectableChild(startNode) === endNode) {
            this._nodeSel.node = startNode;
            return startNode;
          } else if (startNode.nodeType === ViperUtil.TEXT_NODE && endNode.nodeType === ViperUtil.TEXT_NODE && range.startOffset === 0 && range.endOffset === endNode.data.length && range.commonAncestorContainer && range.commonAncestorContainer.nodeType === ViperUtil.ELEMENT_NODE && this._getFirstSelectableChild(range.commonAncestorContainer) === startNode && this._getLastSelectableChild(range.commonAncestorContainer) === endNode) {
            this._nodeSel.node = range.commonAncestorContainer;
            return range.commonAncestorContainer;
          } else if (startNode.nodeType === ViperUtil.TEXT_NODE && endNode.nodeType === ViperUtil.TEXT_NODE && range.startOffset === 0 && range.endOffset === endNode.data.length && common && this._getFirstSelectableChild(common) === startNode && this._getLastSelectableChild(common) === endNode) {
            this._nodeSel.node = common;
            return common;
          } else if (ViperUtil.isBrowser("chrome") === true && startNode.nodeType === ViperUtil.TEXT_NODE && range.startOffset === 0 && range.endOffset === 0 && range.endContainer.nodeType === ViperUtil.ELEMENT_NODE && ViperUtil.isBlockElement(range.endContainer) === true && this._getFirstSelectableChild(ViperUtil.getFirstBlockParent(startNode)) === startNode && this.getNextContainer(ViperUtil.getFirstBlockParent(startNode), null, false, true) === range._getFirstSelectableChild(range.endContainer)) {
            this._nodeSel.node = ViperUtil.getFirstBlockParent(startNode);
            return this._nodeSel.node;
          } else if (endNode !== startNode && endNode === common && (startNode === common.firstElementChild || startNode === common.firstChild) && range.startOffset === 0) {
            this._nodeSel.node = common;
            return this._nodeSel.node;
          } else if (range.startContainer.nodeType === ViperUtil.TEXT_NODE && range.startOffset === range.startContainer.data.length && range.endContainer.nodeType === ViperUtil.ELEMENT_NODE && range.endOffset === 1 && ViperUtil.isBlockElement(range.endContainer) === false) {
            var surroundedChildren = ViperUtil.getSurroundedChildren(range.endContainer);
            var selNode = range.endContainer;
            if (surroundedChildren.length > 0) {
              selNode = surroundedChildren.pop();
            }
            this._nodeSel.node = selNode;
            return this._nodeSel.node;
          } else if (range.startContainer.nodeType === ViperUtil.TEXT_NODE && range.startOffset === range.startContainer.data.length && range.endContainer.nodeType === ViperUtil.ELEMENT_NODE && range.endOffset === range.endContainer.childNodes.length && ViperUtil.isText(range.endContainer.childNodes[range.endContainer.childNodes.length - 1].previousSibling) === true) {
            this._nodeSel.node = range.endContainer.childNodes[range.endContainer.childNodes.length - 1];
            return this._nodeSel.node;
          } else if (range.startContainer.nodeType === ViperUtil.TEXT_NODE && range.endContainer.nodeType === ViperUtil.TEXT_NODE && range.startOffset === range.startContainer.data.length && range.endOffset === 0 && range.startContainer.nextSibling === range.endContainer.previousSibling && range.startContainer.nextSibling.nodeType === ViperUtil.ELEMENT_NODE) {
            this._nodeSel.node = range.startContainer.nextSibling;
            return this._nodeSel.node;
          } else if (range.startContainer.nodeType === ViperUtil.ELEMENT_NODE && range.startContainer.childNodes[range.startOffset] && range.startContainer.childNodes[range.startOffset].nodeType === ViperUtil.ELEMENT_NODE && range.endContainer.nodeType === ViperUtil.TEXT_NODE && range.endOffset === 0 && range.endContainer.previousSibling === range.startContainer.childNodes[range.startOffset]) {
            this._nodeSel.node = range.endContainer.previousSibling;
            return this._nodeSel.node;
          } else if (ViperUtil.isText(startNode) === true && range.startOffset === startNode.data.length && ViperUtil.isElement(range.endContainer) === true && ViperUtil.isText(range.endContainer.childNodes[range.endOffset]) === true && ViperUtil.isElement(startNode.nextSibling) === true && startNode.nextSibling.nextSibling === range.endContainer.childNodes[range.endOffset]) {
            this._nodeSel.node = startNode.nextSibling;
            return this._nodeSel.node;
          } else if (ViperUtil.isText(startNode) === true && range.startOffset === 0 && ViperUtil.isElement(range.endContainer) === true && !startNode.previousSibling && ViperUtil.isText(range.endContainer.childNodes[range.endOffset]) === true && startNode.parentNode.nextSibling === range.endContainer.childNodes[range.endOffset]) {
            this._nodeSel.node = startNode.parentNode;
            return this._nodeSel.node;
          }
          var startMoved = null;
          if (startNode.nodeType === ViperUtil.TEXT_NODE) {
            if (range.startOffset !== 0) {
              if (range.startOffset !== startNode.data.length) {
                this._nodeSel.node = null;
                return null;
              } else {
                if (startNode.nextSibling) {
                  startNode = this._getFirstSelectableChild(startNode.nextSibling);
                  if (!startNode) {
                    this._nodeSel.node = null;
                    return null;
                  }
                } else {
                  startMoved = {
                    startContainer: this.startContainer,
                    startOffset: this.startOffset
                  };
                  this.moveStart(Viper2.DOMRange.CHARACTER_UNIT, 1);
                  startNode = range.getStartNode();
                }
              }
            }
          } else if (startNode.nodeType === ViperUtil.ELEMENT_NODE && endNode.nodeType === ViperUtil.ELEMENT_NODE && common === startNode) {
            this._nodeSel.node = startNode;
            return startNode;
          }
          if (startNode.previousSibling) {
            if (startNode.previousSibling.nodeType !== ViperUtil.TEXT_NODE || startNode.previousSibling.data.length !== 0) {
              if (startMoved) {
                this.setStart(startMoved.startContainer, startMoved.startOffset);
              }
              this._nodeSel.node = null;
              return null;
            }
          }
          if (endNode.nodeType === ViperUtil.TEXT_NODE) {
            if (range.endOffset !== 0) {
              if (range.endOffset === endNode.data.length && !endNode.nextSibling && (startNode.parentNode === endNode.parentNode || this._getLastSelectableChild(startNode.parentNode) === endNode)) {
                this._nodeSel.node = startNode.parentNode;
                return startNode.parentNode;
              } else {
                this._nodeSel.node = null;
                return null;
              }
            }
          } else if (!endNode.nextSibling && ViperUtil.isTag(endNode, "br") === true) {
            if (this._getLastSelectableChild(startNode.parentNode) === endNode.previousSibling) {
              this._nodeSel.node = startNode.parentNode;
              return startNode.parentNode;
            }
          }
          this._nodeSel.node = null;
          return null;
        }
      };
    };
  }
});

// src/Utils/position.ts
var position;
var init_position = __esm({
  "src/Utils/position.ts"() {
    "use strict";
    position = (element) => {
      const offsetParent = element.offsetParent;
      if (!offsetParent) {
        return { top: 0, left: 0 };
      }
      const elementRect = element.getBoundingClientRect();
      const parentRect = offsetParent.getBoundingClientRect();
      const top = elementRect.top - parentRect.top - offsetParent.clientTop;
      const left = elementRect.left - parentRect.left - offsetParent.clientLeft;
      return { top, left };
    };
  }
});

// src/Lib/MozRange.js
var MozRange_exports = {};
__export(MozRange_exports, {
  registerPlugin: () => registerPlugin6
});
var registerPlugin6;
var init_MozRange = __esm({
  "src/Lib/MozRange.js"() {
    "use strict";
    init_position();
    registerPlugin6 = (Viper2) => {
      const { Util: ViperUtil } = Viper2;
      Viper2.MozRange = function(rangeObj) {
        ViperUtil.inherits(Viper2.MozRange, Viper2.DOMRange);
        Viper2.DOMRange.call(this, rangeObj);
        this.startContainer = rangeObj.startContainer;
        this.startOffset = rangeObj.startOffset;
        this.endContainer = rangeObj.endContainer;
        this.endOffset = rangeObj.endOffset;
        this.collapsed = rangeObj.collapsed;
        this.commonAncestorContainer = rangeObj.commonAncestorContainer;
        this.posSpan = Viper2.document.createElement("span");
        Viper2.DOMRange.START_TO_START = Range.START_TO_START;
        Viper2.DOMRange.START_TO_END = Range.END_TO_START;
        Viper2.DOMRange.END_TO_END = Range.END_TO_END;
        Viper2.DOMRange.END_TO_START = Range.START_TO_END;
      };
      Viper2.MozRange.prototype = {
        /**
         * Moves the start point of the range to the offset within the specified node.
         *
         * @param Node    node   The node where the range should start.
         * @param Integer offset The offset within the node where the range should start.
         *
         * @return void
         * @throws RangeException, DomException
         */
        setStart: function(node, offset) {
          this.rangeObj.setStart(node, offset);
          this.startContainer = node;
          this.startOffset = offset;
          if (this.endContainer === null) {
            this.endContainer = node;
            this.endOffset = offset;
          }
          this._setCommonAncestorContainer();
          this._setCollapsed();
        },
        /**
         * Moves the end point of the range to the offset within the specified node.
         *
         * @param Node    node   The node where the range should end.
         * @param Integer offset The offset within the node where the range should end.
         *
         * @return void
         * @throws RangeException, DomException
         */
        setEnd: function(node, offset) {
          this.rangeObj.setEnd(node, offset);
          this.endContainer = node;
          this.endOffset = offset;
          if (this.startContainer === null) {
            this.startContainer = node;
            this.startOffset = offset;
          }
          this._setCommonAncestorContainer();
          this._setCollapsed();
        },
        /**
         * Moves the start point of the range to before the specified node.
         *
         * @param Node node The node where the range should start before.
         *
         * @return void
         * @throws RangeException, DomException
         */
        setStartBefore: function(node) {
          this.rangeObj.setStartBefore(node);
          this.endContainer = this.rangeObj.endContainer;
          this.endOffset = this.rangeObj.endOffset;
          this.startContainer = this.rangeObj.startContainer;
          this.startOffset = this.rangeObj.startOffset;
          this._setCollapsed();
          this._setCommonAncestorContainer();
        },
        /**
         * Moves the start point of the range to after the specified node.
         *
         * @param Node node The node where the range should start after.
         *
         * @return void
         * @throws RangeException, DomException
         */
        setStartAfter: function(node) {
          this.rangeObj.setStartAfter(node);
          this.endContainer = this.rangeObj.endContainer;
          this.endOffset = this.rangeObj.endOffset;
          this.startContainer = this.rangeObj.startContainer;
          this.startOffset = this.rangeObj.startOffset;
          this._setCollapsed();
          this._setCommonAncestorContainer();
        },
        /**
         * Moves the end point of the range to before the specified node.
         *
         * @param Node node The node where the range should end before.
         *
         * @return void
         * @throws RangeException, DomException
         */
        setEndBefore: function(node) {
          this.rangeObj.setEndBefore(node);
          this.endContainer = this.rangeObj.endContainer;
          this.endOffset = this.rangeObj.endOffset;
          this.startContainer = this.rangeObj.startContainer;
          this.startOffset = this.rangeObj.startOffset;
          this._setCollapsed();
          this._setCommonAncestorContainer();
        },
        /**
         * Moves the end point of the range to after the specified node.
         *
         * @param Node node The node where the range should end after.
         *
         * @return void
         * @throws RangeException, DomException
         */
        setEndAfter: function(node) {
          this.rangeObj.setEndAfter(node);
          this.endContainer = this.rangeObj.endContainer;
          this.endOffset = this.rangeObj.endOffset;
          this.startContainer = this.rangeObj.startContainer;
          this.startOffset = this.rangeObj.startOffset;
          this._setCollapsed();
          this._setCommonAncestorContainer();
        },
        /**
         * Selects the node, including its element.
         *
         * @param Node node The node to be selected.
         *
         * @return void
         * @throws RangeException, DomException
         */
        selectNode: function(node) {
          this.rangeObj.selectNode(node);
          this.startContainer = this.rangeObj.startContainer;
          this.startOffset = this.rangeObj.startOffset;
          this.endContainer = this.rangeObj.endContainer;
          this.endOffset = this.rangeObj.endOffset;
          this._setCollapsed();
          this._setCommonAncestorContainer();
        },
        /**
         * Selects the node, excluding its element.
         *
         * @param Node node The node who's contents should be selected.
         *
         * @return void
         * @throws RangeException, DomException
         */
        selectNodeContents: function(node) {
          this.rangeObj.selectNodeContents(node);
          this.startContainer = this.rangeObj.startContainer;
          this.startOffset = this.rangeObj.startOffset;
          this.endContainer = this.rangeObj.endContainer;
          this.endOffset = this.rangeObj.endOffset;
          this._setCollapsed();
          this._setCommonAncestorContainer();
        },
        /**
         *
         * @param Node node The node who's contents should be selected.
         *
         * @return void
         * @throws RangeException, DomException
         */
        surroundContents: function(node) {
          this.rangeObj.surroundContents(node);
          this.startContainer = this.rangeObj.startContainer;
          this.startOffset = this.rangeObj.startOffset;
          this.endContainer = this.rangeObj.endContainer;
          this.endOffset = this.rangeObj.endtOffset;
          this._setCollapsed();
          this._setCommonAncestorContainer();
        },
        /**
         * Collapses the range to the start or end of the current boundary points.
         *
         * @param boolean toStart If TRUE the range will be collapsed the the start of
         *                        the range, otherwise it will be collapsed to the end
         *                        of the range.
         *
         * @return void
         * @throws DOMException
         */
        collapse: function(toStart) {
          this.rangeObj.collapse(toStart);
          this.collapsed = true;
          if (toStart) {
            this.endContainer = this.startContainer;
            this.endOffset = this.startOffset;
          } else {
            this.startContainer = this.endContainer;
            this.startOffset = this.endOffset;
          }
        },
        // Range Comparisons.
        /**
         * Compare the boundary-points of two Ranges in a document and returns
         * -1, 0 or 1 depending on whether the corresponding boundary-point of the
         * Range is respectively before, equal to, or after the corresponding
         * boundary-point of sourceRange.
         *
         * @param integer  how         A flag as to how to compare the boundary points
         *                             of the range, which should be one of
         *                             START_TO_START, END_TO_END, START_TO_END and
         *                             END_TO_START.
         * @param ViperMozRange sourceRange The source range to compare to this range.
         *
         * @return integer
         * @see W3CRange.START_TO_START
         * @see W3CRange.START_TO_END
         * @see W3CRange.END_TO_END
         * @see W3CRange.END_TO_START
         * @throws DOMException
         */
        compareBoundaryPoints: function(how, sourceRange) {
          return this.rangeObj.compareBoundaryPoints(how, sourceRange.rangeObj);
        },
        // Extract Content.
        /**
         * Deletes the contents within the current range.
         *
         * @return void
         * @throws DOMException
         */
        deleteContents: function(viperElem, defaultTagName) {
          var startContainer = this.startContainer;
          var startOffset = this.startOffset;
          if (!startContainer) {
            startContainer = this.rangeObj.startContainer;
          }
          if (startContainer === this.endContainer && startContainer.nodeType === ViperUtil.TEXT_NODE) {
            var before = this.startContainer.data.substring(0, this.startOffset);
            var after = this.startContainer.data.substring(this.endOffset);
            this.startContainer.data = before + after;
          } else {
            this.rangeObj.deleteContents();
          }
          if (startContainer.nodeType === ViperUtil.TEXT_NODE) {
            var nextSibling = startContainer.nextSibling;
            while (nextSibling) {
              if (nextSibling && nextSibling.nodeType === ViperUtil.TEXT_NODE) {
                startContainer.data += nextSibling.data;
                ViperUtil.remove(nextSibling);
                nextSibling = startContainer.nextSibling;
              } else {
                break;
              }
            }
          }
          this.setStart(startContainer, startOffset);
          this.collapse(true);
          this._setCommonAncestorContainer();
        },
        /**
         * Extracts the contents from the current document, returning the contents in
         * a document fragment.
         *
         * @return DocumentFragment
         * @throws DOMException
         */
        extractContents: function() {
          return this.rangeObj.extractContents();
        },
        createDocumentFragment: function(str) {
          var fragment = null;
          if (!this.rangeObj.createContextualFragment) {
            var fragment = document.createDocumentFragment();
            var div = document.createElement("div");
            div.innerHTML = str;
            var c = div.childNodes.length;
            for (var i = 0; i < c; i++) {
              var child = div.childNodes[i].cloneNode(true);
              fragment.appendChild(child);
            }
          } else {
            fragment = this.rangeObj.createContextualFragment(str);
          }
          return fragment;
        },
        /**
         * Clones the contents of the range, returning the content in a DocumentFragment
         * without modifying the current Viper.document.
         *
         * @return DocumentFragment.
         * @throws DOMException
         */
        cloneContents: function() {
          return this.rangeObj.cloneContents();
        },
        // Inserting.
        /**
         * Inserts a node into the Document or DocumentFragment at the start of the Range.
         * If the container is a Text node, this will be split at the start of the Range
         * (as if the Text node's splitText method was performed at the insertion point)
         * and the insertion will occur between the two resulting Text nodes. Adjacent Text
         * nodes will not be automatically merged. If the node to be inserted is a
         * DocumentFragment node, the children will be inserted rather than the
         * DocumentFragment node itself.
         *
         * @param Node node The node to be inserted.
         *
         * @return void
         * @throws DOMException, RangeException
         */
        insertNode: function(node) {
          if (this.startContainer.nodeType === ViperUtil.ELEMENT_NODE) {
            if (ViperUtil.isStubElement(this.startContainer) === true) {
              throw Error("HIERARCHY_REQUEST_ERR");
            }
          }
          this.rangeObj.insertNode(node);
          if (node.previousSibling && node.previousSibling.nodeType === ViperUtil.TEXT_NODE) {
            if (node.previousSibling.data === "") {
              ViperUtil.remove(node.previousSibling);
            }
          }
          if (node.nextSibling && node.nextSibling.nodeType === ViperUtil.TEXT_NODE) {
            if (node.nextSibling.data === "") {
              ViperUtil.remove(node.nextSibling);
            }
          }
          this.startContainer = this.rangeObj.startContaier;
          this.startOffset = this.rangeObj.startOffset;
          this.endContainer = this.rangeObj.endContainer;
          this.endOffset = this.rangeObj.endOffset;
          this._setCollapsed();
          this._setCommonAncestorContainer();
        },
        // Misc.
        /**
         * Clones this range object and returns an exact copy.
         *
         * @return W3CRange.
         */
        cloneRange: function() {
          var clone = this.rangeObj.cloneRange();
          return new Viper2.MozRange(clone);
        },
        /**
         * Returns the string contents of the selected text within the range. The contents
         * will not contain any markup.
         *
         * @return string
         */
        toString: function() {
          return this.rangeObj.toString();
        },
        /**
         * Detaches the range from the document releasing any resources used.
         *
         * @return void
         * @throws DOMException
         */
        detach: function() {
          this.rangeObj.detach();
        },
        comparePoint: function(node, offset) {
          return this.rangeObj.comparePoint(node, offset);
        },
        // Private helper methods for W3CRange Standard.
        _setCommonAncestorContainer: function() {
          this.commonAncestorContainer = this.rangeObj.commonAncestorContainer;
        },
        _setCollapsed: function() {
          if (this.startContainer === this.endContainer && this.startOffset === this.endOffset) {
            this.collapsed = true;
          } else {
            this.collapsed = false;
          }
        },
        // Extensions to the W3CRange standard.
        getCommonElement: function() {
          if (this.commonAncestorContainer.nodeType === ViperUtil.ELEMENT_NODE) {
            return this.commonAncestorContainer;
          }
          return this.commonAncestorContainer.parentNode;
        },
        /**
         * Returns the range coordinates (x, y) where the range begins or ends.
         *
         * @param boolean toStart If TRUE the coordinates of the start of the range will
         *                        be returned, else the end range coordinates will be
         *                        returned.
         *
         * @return Object {x, y}
         */
        getRangeCoords: function(toStart) {
          var clone = this.rangeObj.cloneRange();
          clone.collapse(toStart);
          var normalize = true;
          if (clone.startContainer.nodeType === ViperUtil.TEXT_NODE) {
            if (clone.startOffset === 0) {
              if (clone.startContainer.previousSibling && clone.startContainer.previousSibling.nodeType !== ViperUtil.TEXT_NODE) {
                normalize = false;
              }
            }
          } else {
            normalize = false;
          }
          var posSpan = this.posSpan;
          clone.insertNode(posSpan);
          var previous = posSpan.previousSibling;
          var next = posSpan.nextSibling;
          var c = position(posSpan);
          var coords = {
            x: c.left,
            y: c.top
          };
          ViperUtil.remove(posSpan);
          if (normalize) {
            previous.data += next.data;
            ViperUtil.remove(next);
            this.setEnd(this.endContainer, this.endOffset);
            this.setStart(this.startContainer, this.startOffset);
          }
          return coords;
        },
        moveStart: function(unitType, units) {
          if (units === 0) {
            throw Error("InvalidArgumentException: units cannot be 0");
          }
          switch (unitType) {
            case Viper2.DOMRange.CHARACTER_UNIT:
              if (units > 0) {
                this._moveCharRight(true, units);
              } else {
                this._moveCharLeft(true, units);
              }
              break;
            case Viper2.DOMRange.LINE_UNIT:
              if (units > 0) {
                this._moveLineDown(true);
              } else {
                this._moveLineUp(true);
              }
              break;
            case Viper2.DOMRange.WORD_UNIT:
            default:
              break;
          }
          this._setCommonAncestorContainer();
          this._setCollapsed();
        },
        moveEnd: function(unitType, units) {
          if (units === 0) {
            throw Error("InvalidArgumentException: units cannot be 0");
          }
          switch (unitType) {
            case Viper2.DOMRange.CHARACTER_UNIT:
              if (units > 0) {
                this._moveCharRight(false, units);
              } else {
                this._moveCharLeft(false, units);
              }
              break;
            case Viper2.DOMRange.LINE_UNIT:
              if (units > 0) {
                this._moveLineDown(false);
              } else {
                this._moveLineUp(false);
              }
              break;
            case Viper2.DOMRange.WORD_UNIT:
            default:
              break;
          }
          this._setCommonAncestorContainer();
          this._setCollapsed();
        },
        _setRange: function(start, container, offset) {
          if (start) {
            this.setStart(container, offset);
          } else {
            this.setEnd(container, offset);
          }
        },
        _moveCharLeft: function(moveStart, units) {
          var container, offset;
          if (moveStart) {
            container = this.startContainer;
            offset = this.startOffset;
          } else {
            container = this.endContainer;
            offset = this.endOffset;
          }
          offset += units;
          if (container.nodeType === ViperUtil.ELEMENT_NODE) {
            if (container.hasChildNodes()) {
              container = container.childNodes[offset];
              offset = 0;
            }
          }
          if (offset < 0) {
            while (offset < 0) {
              var skippedBlockElem = [];
              container = this.getPreviousContainer(container, skippedBlockElem);
              if (container.nodeType === ViperUtil.ELEMENT_NODE) {
                continue;
              }
              offset = container.data.length;
              if (container.nodeType === ViperUtil.TEXT_NODE && skippedBlockElem.length === 0) {
                offset--;
              }
            }
          }
          this._setRange(moveStart, container, offset);
        },
        /**
         * If incSpaces is false then any space at the beginning of a line will
         * be ignored.
         */
        getStartOffset: function(incSpaces) {
          if (incSpaces === true) {
            return this.startOffset;
          }
          var spaces = 0;
          var container = this.startContainer;
          var cc = container.data.charCodeAt(0);
          while (cc === 10 || cc === 32) {
            spaces++;
            cc = container.data.charCodeAt(spaces);
          }
          var offset = this.startOffset - spaces;
          return offset;
        },
        _getNextTextNode: function(container) {
          if (container.nodeType === ViperUtil.ELEMENT_NODE) {
            if (container.childNodes.length !== 0) {
              return this._getFirstSelectableChild(container);
            }
          }
          container = this.getNextContainer(container);
          if (container.nodeType === ViperUtil.TEXT_NODE) {
            return container;
          }
          return this._getNextTextNode(container);
        },
        _moveCharRight: function(moveStart, units) {
          var container, offset;
          if (moveStart) {
            container = this.startContainer;
            offset = this.startOffset;
          } else {
            container = this.endContainer;
            offset = this.endOffset;
          }
          if (container.nodeType === ViperUtil.ELEMENT_NODE) {
            container = container.childNodes[offset];
            if (container.nodeType !== ViperUtil.TEXT_NODE) {
              container = this._getNextTextNode(container);
            }
            offset = units;
          } else {
            offset += units;
          }
          var diff = offset - container.data.length;
          if (diff > 0) {
            var skippedBlockElem = [];
            while (diff > 0) {
              container = this.getNextContainer(container, skippedBlockElem);
              if (container.nodeType === ViperUtil.ELEMENT_NODE) {
                continue;
              }
              if (container.data.length >= diff) {
                break;
              } else if (container.data.length > 0) {
                diff -= container.data.length;
              }
            }
            offset = 0;
            if (container.nodeType === ViperUtil.TEXT_NODE && skippedBlockElem.length === 0) {
              offset++;
            }
          }
          this._setRange(moveStart, container, offset);
        },
        _filterWords: function(words) {
          var wc = words.length;
          var fwords = [];
          for (var i = 0; i < wc; i++) {
            if (words[i].length > 0) {
              fwords.push(words[i]);
            }
          }
          return fwords;
        },
        _moveLineUp: function(moveStart) {
          var container = null;
          var offset = null;
          if (moveStart) {
            container = this.startContainer;
            offset = this.startOffset;
          } else {
            container = this.endContainer;
            offset = this.endOffset;
          }
          if (container.nodeType === ViperUtil.ELEMENT_NODE) {
            container = this.getPreviousContainer(container);
          }
          var words = container.data.substr(offset).split(/\s+/);
          var startCoords = this.getRangeCoords(moveStart);
          var coords = null;
          var prevXCoord = 0;
          var nextLine = 0;
          var wordLen = 0;
          var prevYCoord = 0;
          var prevCont = null;
          var prevOffset = 0;
          while (true) {
            prevOffset = offset;
            prevCont = container;
            if (nextLine === 0 && words.length > 0) {
              offset -= words.pop().length;
            } else {
              offset--;
            }
            if (offset <= 0) {
              var found = false;
              while (found === false) {
                container = this.getPreviousContainer(container);
                if (container !== null && container.nodeType === ViperUtil.TEXT_NODE && container.data.length !== 0) {
                  found = true;
                }
              }
              offset = container.data.length;
            }
            if (moveStart) {
              this.setStart(container, offset);
            } else {
              this.setEnd(container, offset);
            }
            coords = this.getRangeCoords(moveStart);
            if (startCoords.y !== coords.y) {
              if (prevYCoord !== coords.y) {
                prevYCoord = coords.y;
                nextLine++;
                if (nextLine > 1) {
                  if (prevCont !== container) {
                    prevOffset = prevCont.data.length;
                  }
                  if (moveStart) {
                    this.setStart(prevCont, prevOffset);
                  } else {
                    this.setEnd(prevCont, prevOffset);
                  }
                  break;
                }
              }
              if (coords.x <= startCoords.x) {
                if (offset < container.data.length && Math.abs(coords.x - startCoords.x) > Math.abs(prevXCoord - startCoords.x)) {
                  offset++;
                  if (moveStart) {
                    this.setStart(container, offset);
                  } else {
                    this.setEnd(container, offset);
                  }
                }
                break;
              } else {
                prevXCoord = coords.x;
              }
            }
          }
        },
        _moveLineDown: function(moveStart) {
          var container = null;
          var offset = null;
          if (moveStart) {
            container = this.startContainer;
            offset = this.startOffset;
          } else {
            container = this.endContainer;
            offset = this.endOffset;
          }
          if (container.nodeType === ViperUtil.ELEMENT_NODE) {
            container = this.getNextContainer(container);
          }
          var words = container.data.substr(offset).split(/\s+/);
          var startCoords = this.getRangeCoords(moveStart);
          var coords = null;
          var prevXCoord = 0;
          var nextLine = 0;
          var wordLen = 0;
          var prevYCoord = 0;
          var prevCont = null;
          var prevOffset = 0;
          while (true) {
            prevOffset = offset;
            prevCont = container;
            if (nextLine === 0 && words.length > 0) {
              offset += words.shift().length;
            } else {
              offset++;
            }
            if (offset >= container.data.length) {
              var found = false;
              while (found === false) {
                container = this.getNextContainer(container);
                if (container.data.length !== 0) {
                  found = true;
                }
              }
              offset = 0;
            }
            if (moveStart) {
              this.setStart(container, offset);
            } else {
              this.setEnd(container, offset);
            }
            coords = this.getRangeCoords(moveStart);
            if (startCoords.y !== coords.y) {
              if (prevYCoord !== coords.y) {
                prevYCoord = coords.y;
                nextLine++;
                if (nextLine > 1) {
                  if (prevCont !== container) {
                    prevOffset = prevCont.data.length;
                  }
                  if (moveStart) {
                    this.setStart(prevCont, prevOffset);
                  } else {
                    this.setEnd(prevCont, prevOffset);
                  }
                  break;
                }
              }
              if (coords.x >= startCoords.x) {
                if (offset > 1 && Math.abs(coords.x - startCoords.x) > Math.abs(prevXCoord - startCoords.x)) {
                  offset--;
                  if (moveStart) {
                    this.setStart(container, offset);
                  } else {
                    this.setEnd(container, offset);
                  }
                }
                break;
              } else {
                prevXCoord = coords.x;
              }
            }
          }
        },
        getHTMLContents: function(clonedSelection) {
          if (!clonedSelection) {
            clonedSelection = this.rangeObj.cloneContents();
          }
          var div = Viper2.document.createElement("div");
          div.appendChild(clonedSelection.cloneNode(true));
          return div.innerHTML;
        },
        getHTMLContentsObj: function() {
          return this.rangeObj.cloneContents();
        }
      };
    };
  }
});

// src/Lib/PluginManager.js
var PluginManager_exports = {};
__export(PluginManager_exports, {
  registerPlugin: () => registerPlugin7
});
var registerPlugin7;
var init_PluginManager = __esm({
  "src/Lib/PluginManager.js"() {
    "use strict";
    registerPlugin7 = (Viper2) => {
      const { Util: ViperUtil } = Viper2;
      var _plugins = {};
      Viper2.PluginManager = function(viper) {
        this.viper = viper;
        this._plugins = null;
        this._pluginSettings = {};
        this._pluginSets = {};
      };
      Viper2.PluginManager.addPlugin = function(pluginName, pluginObj, inherits) {
        _plugins[pluginName] = {
          obj: pluginObj,
          inherits
        };
      };
      Viper2.PluginManager.getClass = function(pluginName) {
        return _plugins[pluginName].obj;
      };
      Viper2.PluginManager.prototype = {
        getPluginNames: function() {
          var plugins = [];
          for (var name in this._plugins) {
            plugins.push(name);
          }
          return plugins;
        },
        setPlugins: function(plugins, pluginSetName) {
          if (this._plugins) {
            for (var plugin in this._plugins) {
              this.removePlugin(plugin);
            }
          }
          if (!pluginSetName) {
            pluginSetName = "*";
          }
          this._pluginSets[pluginSetName] = plugins;
          this._pluginSettings = {};
          this._plugins = {};
          var c = plugins.length;
          for (var i = 0; i < c; i++) {
            var pluginName = "";
            var pluginSettings = null;
            if (typeof plugins[i] === "object") {
              pluginName = plugins[i].name;
              pluginSettings = plugins[i].settings;
            } else {
              pluginName = plugins[i];
            }
            this._usePlugin(pluginName, pluginSettings, true);
          }
          for (var pluginName in this._plugins) {
            if (this._plugins[pluginName].init) {
              this._plugins[pluginName].init();
            }
          }
        },
        createPluginSet: function(pluginSetName, plugins) {
          this._pluginSets[pluginSetName] = plugins;
        },
        usePluginSet: function(pluginSetName) {
          if (!this._pluginSets[pluginSetName]) {
            console.error("Invalid plugin set: " + pluginSetName);
            return;
          }
          this.setPlugins(this._pluginSets[pluginSetName], pluginSetName);
        },
        usePlugin: function(pluginName, settings) {
          this._usePlugin(pluginName, settings);
        },
        _usePlugin: function(pluginName, settings, batch) {
          if (!_plugins[pluginName]) {
            return;
          }
          if (_plugins[pluginName].inherits && _plugins[pluginName].inherited !== true) {
            ViperUtil.inherits(_plugins[pluginName].obj, _plugins[_plugins[pluginName].inherits].obj);
            _plugins[pluginName].inherited = true;
          }
          var plugin = new _plugins[pluginName].obj(this.viper);
          this._plugins[pluginName] = plugin;
        },
        /**
         * Removes specified plugin.
         *
         * @param {string} pluginName Name of the plugin.
         *
         * @return void
         */
        removePlugin: function(pluginName) {
          if (this._plugins[pluginName]) {
            if (ViperUtil.isFn(this._plugins[pluginName].remove) === true) {
              this._plugins[pluginName].remove();
            }
            this.viper.removeCallback(null, pluginName);
            this.viper.fireCallbacks("PluginManager:pluginRemoved", pluginName);
            delete this._plugins[pluginName];
          }
        },
        /**
         * Removes the specified plugins or all plugins if nothing specified.
         *
         * @param {array} pluginNames Array of plugin names. If not specified then all
         *                            plugins will be removed.
         */
        removePlugins: function(pluginNames) {
          if (!pluginNames) {
            for (var pluginName in this._plugins) {
              this.removePlugin(pluginName);
            }
          } else {
            var c = pluginNames.length;
            for (var i = 0; i < c; i++) {
              this.removePlugin(pluginNames[i]);
            }
          }
        },
        /**
         * Returns the plugin object for specified plugin name.
         *
         * @param {string} name Name of the plugin.
         *
         * @return The Viper plugin object.
         * @type {ViperPlugin}
         */
        getPlugin: function(name) {
          return this._plugins[name];
        },
        getPluginObject: function(name) {
          return _plugins[name].obj;
        },
        getPlugins: function() {
          return this._plugins;
        },
        /**
         * Use this method to set settings for multiple plugins.
         *
         *  {
         *      pluginName: {
         *        settingOne: ...,
         *        settingTwo: ...
         *      },
         *      ...
         *  }
         *
         */
        setSettings: function(settings) {
          for (var pluginName in settings) {
            if (this._plugins[pluginName]) {
              for (var settingName in settings[pluginName]) {
                this._plugins[pluginName].setSetting(settingName, settings[pluginName][settingName]);
              }
            }
          }
        },
        setPluginSettings: function(pluginName, settings) {
          if (this._plugins[pluginName]) {
            this._plugins[pluginName].setSettings(settings);
          }
          this._pluginSettings[pluginName] = settings;
        },
        setPluginSetting: function(pluginName, setting, value) {
          if (this._plugins[pluginName]) {
            this._plugins[pluginName].setSetting(setting, value);
          }
        },
        disablePlugin: function(name) {
          if (this._plugins[name].disable) {
            this._plugins[name].disable();
          }
        },
        getPluginForElement: function(element) {
          for (var i in this._plugins) {
            if (this._plugins[i].isPluginElement) {
              if (this._plugins[i].isPluginElement(element) === true) {
                return i;
              }
            }
          }
          return false;
        },
        isSpecialElement: function(element) {
          for (var i in this._plugins) {
            if (this._plugins[i].isSpecialElement) {
              if (this._plugins[i].isSpecialElement(element) === true) {
                return true;
              }
            }
          }
          return false;
        }
      };
    };
  }
});

// src/Lib/HistoryManager.js
var HistoryManager_exports = {};
__export(HistoryManager_exports, {
  registerPlugin: () => registerPlugin8
});
var registerPlugin8;
var init_HistoryManager = __esm({
  "src/Lib/HistoryManager.js"() {
    "use strict";
    registerPlugin8 = (Viper2) => {
      const { Util: ViperUtil, Selection: ViperSelection } = Viper2;
      Viper2.HistoryManager = function(viper) {
        this.viper = viper;
        this.undoHistory = [];
        this.redoHistory = [];
        this.batchCount = 0;
        this.batchTask = null;
        this.historyStore = {};
        this._activeElement = null;
        this.historyLimit = 30;
        this._ignoreAdd = false;
        this._maxChars = 50;
        this._charCount = 0;
        this._lastAction = null;
      };
      Viper2.HistoryManager.prototype = {
        /**
         * Creates a new undo task.
         *
         * @param string source  The source of the action.
         * @param string action  Type of the action.
         */
        add: function(source, action) {
          if (this._ignoreAdd === true) {
            return;
          }
          if (this.viper._subElementActive === true) {
            return;
          }
          try {
            var range = this.viper.getCurrentRange();
            if (this.viper.rangeInViperBounds(range) === false) {
              var child = range._getFirstSelectableChild(this.viper.getViperElement());
              if (!child) {
                range = null;
              } else {
                try {
                  range.setStart(child, 0);
                  range.collapse(true);
                } catch (e) {
                  range = null;
                }
              }
            }
          } catch (e) {
            range = null;
          }
          if (!range) {
            var task = {
              content: this.viper.getRawHTML(),
              range: null
            };
          } else {
            var startContainer = range.startContainer;
            if (startContainer.nodeType === ViperUtil.ELEMENT_NODE && startContainer.childNodes[range.startOffset] && startContainer.childNodes[range.startOffset].nodeType === ViperUtil.ELEMENT_NODE && range.collapsed === true) {
              var child = range._getFirstSelectableChild(startContainer.childNodes[range.startOffset]);
              if (child) {
                range.setStart(child, 0);
                range.collapse(true);
              }
            }
            var task = {
              content: this.viper.getRawHTML(),
              range: {
                startContainer: ViperUtil.getXPath(range.startContainer),
                endContainer: ViperUtil.getXPath(range.endContainer),
                startOffset: range.startOffset,
                endOffset: range.endOffset,
                collapsed: range.collapsed
              }
            };
          }
          var modify = false;
          if (action === "text_change" && this._lastAction && this._lastAction.action === action && this._lastAction.range && this._lastAction.range.startOffset === range.startOffset - 1 && this._lastAction.range.startContainer === range.startContainer) {
            if (this._charCount < this._maxChars) {
              modify = true;
            } else {
              this._charCount = 0;
            }
            this._charCount++;
          } else {
            this._charCount = 0;
          }
          this._lastAction = {
            action,
            range
          };
          if (this.batchTask === null) {
            if (modify === true) {
              this.undoHistory[this.undoHistory.length - 1] = task;
            } else {
              this.undoHistory.push(task);
              if (this.undoHistory.length > this.historyLimit) {
                this.undoHistory.shift();
              }
            }
            this.redoHistory = [];
          } else {
            this.batchTask = task;
          }
          this.viper.fireCallbacks("ViperHistoryManager:add");
        },
        /**
         * Undo the last task and move it from undo history to redo history.
         */
        undo: function() {
          if (this.viper._subElementActive === true) {
            return;
          }
          var undoLength = this.undoHistory.length;
          if (undoLength <= 1) {
            return;
          }
          this.viper.fireCallbacks("ViperHistoryManager:beforeUndo");
          var range = this.viper.getCurrentRange();
          var startPath = null;
          var endPath = null;
          try {
            startPath = ViperUtil.getXPath(range.startContainer);
            endPath = ViperUtil.getXPath(range.endContainer);
          } catch (e) {
          }
          var currentState = {
            content: this.viper.getRawHTML(),
            range: {
              startContainer: startPath,
              endContainer: endPath,
              startOffset: range.startOffset,
              endOffset: range.endOffset,
              collapsed: range.collapsed
            }
          };
          this.redoHistory.push(currentState);
          this.undoHistory.pop();
          const task = this.undoHistory[this.undoHistory.length - 1];
          this.viper.setRawHTML(task.content);
          this._selectTaskRange(task);
          this.viper.highlightToSelection();
          this._ignoreAdd = true;
          this.viper.resetViperRange(null);
          this.viper.fireNodesChanged([this.viper.getViperElement()]);
          this.viper.fireCallbacks("ViperHistoryManager:undo");
          this.viper.fireSelectionChanged();
          this._ignoreAdd = false;
          this._lastAction = null;
        },
        redo: function() {
          if (this.viper._subElementActive === true) {
            return;
          }
          if (this.redoHistory.length === 0) {
            return;
          }
          var task = this.redoHistory.pop();
          this.undoHistory.push(task);
          this.viper.setRawHTML(task.content);
          this._selectTaskRange(task);
          this.viper.highlightToSelection();
          this._ignoreAdd = true;
          this.viper.resetViperRange(null);
          this.viper.fireNodesChanged([this.viper.getViperElement()]);
          this.viper.fireCallbacks("ViperHistoryManager:redo");
          this.viper.fireSelectionChanged();
          this._ignoreAdd = false;
          this._lastAction = null;
          return this.redoHistory.length;
        },
        /**
         * Clear the history.
         */
        clear: function() {
          this.undoHistory = [];
          this.redoHistory = [];
          this.batchCount = 0;
          this.batchTask = null;
          this._ignoreAdd = false;
          this._lastAction = null;
          this._charCount = 0;
          this.viper.fireCallbacks("ViperHistoryManager:clear");
        },
        setActiveElement: function(elem) {
          if (this._activeElement) {
            if (this.historyStore[this._activeElement] && this.historyStore[this._activeElement].element !== elem) {
              this._saveHistory(this._activeElement);
            }
          }
          var self = this;
          var loaded = false;
          ViperUtil.foreach(this.historyStore, function(key2) {
            if (self.historyStore[key2].element === elem) {
              self._loadHistory(key2);
              loaded = true;
              return false;
            }
          });
          if (loaded === false) {
            var key = ViperUtil.getUniqueId();
            this.historyStore[key] = {
              undo: [],
              redo: [],
              element: elem
            };
            this._loadHistory(key);
            this.add();
          }
        },
        _selectTaskRange: function(task) {
          if (!task || !task.range) {
            return;
          }
          try {
            var startContainer = ViperUtil.getNodeFromXPath(task.range.startContainer);
            var endContainer = ViperUtil.getNodeFromXPath(task.range.endContainer);
            var range = this.viper.getCurrentRange();
            range.setEnd(endContainer, task.range.endOffset);
            range.setStart(startContainer, task.range.startOffset);
            range.setEnd(endContainer, task.range.endOffset);
            if (task.range.collapsed === true) {
              range.collapse(true);
            }
            ViperSelection.addRange(range);
          } catch (e) {
          }
        },
        _loadHistory: function(key) {
          if (this.historyStore[key]) {
            this._activeElement = key;
            this.undoHistory = this.historyStore[key].undo;
            this.redoHistory = this.historyStore[key].redo;
            this.batchTask = null;
            this.batchCount = 0;
          }
        },
        _saveHistory: function(key) {
          if (this.historyStore[key]) {
            this.historyStore[key].undo = this.undoHistory;
            this.historyStore[key].redo = this.redoHistory;
          }
        },
        /**
         * Starts a new batch undo block.
         * All undo tasks added while batch undo process is active will count as a
         * single undo task.
         */
        begin: function() {
          this.batchCount++;
          if (this.batchTask === null) {
            this.batchTask = true;
          }
        },
        /**
         * Ends batch undo block.
         */
        end: function() {
          this.batchCount--;
          if (this.batchCount === 0 && this.batchTask !== null) {
            this.batchTask = null;
            if (this.batchTask !== true) {
              this.add();
            }
          }
        },
        getUndoCount: function() {
          return this.undoHistory.length;
        },
        getRedoCount: function() {
          return this.redoHistory.length;
        }
      };
    };
  }
});

// src/Lib/KeyboardHandler.js
var KeyboardHandler_exports = {};
__export(KeyboardHandler_exports, {
  registerPlugin: () => registerPlugin9
});
var registerPlugin9;
var init_KeyboardHandler = __esm({
  "src/Lib/KeyboardHandler.js"() {
    "use strict";
    registerPlugin9 = (Viper2) => {
      const { Util: ViperUtil, Selection: ViperSelection } = Viper2;
      Viper2.KeyboardHandler = function(viper) {
        this._viper = viper;
        this._preventKeyPress = false;
        this._tagList = "p|div|h1|h2|h3|h4|h5|h6|blockquote|section|main|article|aside".split("|");
        this._keepContainerList = "td|th".split("|");
        this._viper.addSpecialKey(13);
      };
      Viper2.KeyboardHandler.prototype = {
        init: function() {
          var self = this;
          var elem = this._viper.getViperElement();
          var namespace = this._viper.getEventNamespace();
          var isKeyboardEvent = false;
          ViperUtil.addEvent(elem, "keypress." + namespace, function(e) {
            isKeyboardEvent = true;
            return self.keyPress(e);
          });
          ViperUtil.addEvent(elem, "keydown." + namespace, function(e) {
            isKeyboardEvent = true;
            return self.keyDown(e);
          });
          ViperUtil.addEvent(Viper2.document, "keydown." + namespace, function(e) {
            isKeyboardEvent = true;
            if (e.which === 8 || e.which === 46) {
              var range = self._viper.getCurrentRange();
              if (self._viper.isOutOfBounds(range.startContainer) === true ^ self._viper.isOutOfBounds(range.endContainer) === true) {
                ViperUtil.preventDefault(e);
                return false;
              }
            }
          });
          ViperUtil.addEvent(elem, "keyup." + namespace, function(e) {
            isKeyboardEvent = false;
            return self.keyUp(e);
          });
          Viper2.Util.addEvent(elem, "input." + namespace, function(e) {
            if (isKeyboardEvent === false) {
              self._viper.contentChanged();
            }
          });
          this._viper.registerCallback("ViperFormatPlugin:formatChanged", "KeyboardHandler", function(type) {
            if (type === "pre") {
              self.cleanPreTags();
            }
          });
        },
        /**
         * Handle the keyPress event.
         *
         * @param {event} e The event object.
         *
         * return {boolean} Returns false if default event needs to be blocked.
         */
        keyPress: function(e) {
          if (this._preventKeyPress === true || this._viper.isEnabled() !== true) {
            this._preventKeyPress = false;
            return true;
          }
          var returnValue = this._viper.fireCallbacks("Viper:keyPress", e);
          if (returnValue === false) {
            ViperUtil.preventDefault(e);
            return false;
          }
          var viperElement = this._viper.getViperElement();
          if (ViperUtil.isInputKey(e) === true) {
            this._viper.fireCallbacks("Viper:charInsert", String.fromCharCode(e.which));
            var resetContent = false;
            var range = this._viper.getCurrentRange();
            var startNode = range.getStartNode();
            var endNode = range.getEndNode();
            if (range.startOffset === 0 && range.endContainer === viperElement && range.endOffset === viperElement.childNodes.length - 1 && range.startContainer === range._getFirstSelectableChild(viperElement)) {
              resetContent = true;
            } else if (range.startOffset === 0 && range.endContainer === range._getLastSelectableChild(viperElement) && range.endOffset === range.endContainer.data.length && range.startContainer === range._getFirstSelectableChild(viperElement)) {
              resetContent = true;
            } else if (range.startOffset === 0 && range.startContainer === range.endContainer && range.startContainer === viperElement && range.endOffset >= viperElement.childNodes.length) {
              resetContent = true;
            }
            var nodeSelection = null;
            if (resetContent !== true) {
              nodeSelection = range.getNodeSelection(range, true);
              if (nodeSelection && nodeSelection === viperElement) {
                resetContent = true;
              }
            }
            if (resetContent === true) {
              var tagName = this._viper.getDefaultBlockTag();
              if (viperElement.childNodes.length === 1 && ViperUtil.isBlockElement(viperElement.childNodes[0]) === true) {
                tagName = ViperUtil.getTagName(viperElement.childNodes[0]);
              }
              if (!tagName) {
                ViperUtil.setHtml(viperElement, "");
              } else {
                ViperUtil.setHtml(viperElement, "<" + tagName + ">&nbsp;</" + tagName + ">");
                range.setStart(range._getFirstSelectableChild(viperElement), 0);
              }
              range.collapse(true);
              ViperSelection.addRange(range);
            } else if (e.which >= 32 && e.which <= 126) {
              var char = String.fromCharCode(e.which);
              if (nodeSelection && ViperUtil.isBlockElement(nodeSelection) === true && String.fromCharCode(e.which) !== "") {
                switch (ViperUtil.getTagName(nodeSelection)) {
                  case "table":
                  case "ul":
                  case "ol":
                    var defaultTagName = this._viper.getDefaultBlockTag();
                    var defTag = null;
                    if (defaultTagName !== "") {
                      defTag = document.createElement(defaultTagName);
                      ViperUtil.setHtml(defTag, String.fromCharCode(e.which));
                    } else {
                      defTag = document.createTextNode(String.fromCharCode(e.which));
                    }
                    ViperUtil.insertAfter(nodeSelection, defTag);
                    ViperUtil.remove(nodeSelection);
                    range.setStart(defTag, 1);
                    range.collapse(true);
                    break;
                  case "tfooter":
                  case "tbody":
                  case "thead":
                  case "tr":
                  case "li":
                    return true;
                    break;
                  default:
                    var textNode = document.createTextNode(String.fromCharCode(e.which));
                    if (ViperUtil.isStubElement(nodeSelection) === true) {
                      ViperUtil.insertBefore(nodeSelection, textNode);
                      ViperUtil.remove(nodeSelection);
                    } else {
                      ViperUtil.setHtml(nodeSelection, "");
                      if (ViperUtil.isTag(nodeSelection, "blockquote") === true) {
                        var quoteP = document.createElement("p");
                        nodeSelection.appendChild(quoteP);
                        nodeSelection = quoteP;
                      }
                      nodeSelection.appendChild(textNode);
                    }
                    range.setStart(textNode, 1);
                    range.collapse(true);
                    break;
                }
                ViperSelection.addRange(range);
                this._viper.fireNodesChanged([textNode]);
                return false;
              } else if (startNode === endNode && ViperUtil.isTag(startNode, "br") === true && range.collapsed === true) {
                var textNode = null;
                if (ViperUtil.isText(startNode.previousSibling) === true) {
                  textNode = startNode.previousSibling;
                  textNode.data += char;
                } else {
                  textNode = document.createTextNode(char);
                  ViperUtil.insertBefore(startNode, textNode);
                }
                if (ViperUtil.isSpacerBR(startNode) === true) {
                  ViperUtil.remove(startNode);
                }
                range.setStart(textNode, textNode.data.length);
                range.collapse(true);
                ViperSelection.addRange(range);
                this._viper.fireNodesChanged([textNode]);
                return false;
              } else if (range.startContainer === range.endContainer && range.startContainer.nodeType === ViperUtil.TEXT_NODE && range.collapsed === true && range.startOffset === range.startContainer.data.length) {
                if (range.startContainer.data.charAt(range.startOffset - 1) === " ") {
                  if (e.which === 32) {
                    range.startContainer.data = range.startContainer.data.substr(0, range.startOffset - 1);
                    range.startContainer.data += String.fromCharCode(160) + String.fromCharCode(160);
                  } else {
                    range.startContainer.data += char;
                  }
                  range.setStart(range.startContainer, range.startContainer.data.length);
                  range.collapse(true);
                  ViperSelection.addRange(range);
                  this._viper.fireNodesChanged([range.startContainer]);
                  return false;
                } else if (range.startContainer.data.length === 0) {
                  if (range.startContainer.previousSibling && range.startContainer.previousSibling.nodeType === ViperUtil.TEXT_NODE) {
                    var prevSib = range.startContainer.previousSibling;
                    if (prevSib.data.charAt(prevSib.data.length - 1) === " ") {
                      prevSib.data += char;
                      range.setStart(prevSib, prevSib.data.length);
                      range.collapse(true);
                      ViperSelection.addRange(range);
                      this._viper.fireNodesChanged([range.startContainer]);
                      return false;
                    }
                  } else if (range.startContainer.parentNode && ViperUtil.isBlockElement(range.startContainer.parentNode) === false && ViperUtil.isEmptyElement(range.startContainer.parentNode) === true) {
                    var parentPrevSib = range.startContainer.parentNode.previousSibling;
                    if (parentPrevSib && parentPrevSib.nodeType === ViperUtil.TEXT_NODE && parentPrevSib.data.charAt(parentPrevSib.data.length - 1) === " ") {
                      parentPrevSib.data += char;
                      range.setStart(parentPrevSib, parentPrevSib.data.length);
                      range.collapse(true);
                      ViperSelection.addRange(range);
                      this._viper.fireNodesChanged([parentPrevSib]);
                      return false;
                    }
                  }
                } else {
                  var endParent = ViperUtil.getTopEndParent(range.startContainer);
                  var firstSelectable = null;
                  if (endParent) {
                    firstSelectable = range._getFirstSelectableChild(endParent.nextSibling);
                  }
                  if (char == " ") {
                    if (firstSelectable) {
                      if (firstSelectable.data.charAt(0) == " ") {
                        char = String.fromCharCode(160);
                      }
                    } else {
                      var blockParent = ViperUtil.getFirstBlockParent(range.startContainer);
                      if (blockParent && blockParent.lastChild === range.startContainer) {
                        blockParent.appendChild(document.createElement("br"));
                      }
                    }
                  } else if (ViperUtil.endsWithSpace(range.startContainer, true) === true) {
                    ViperUtil.replaceCharAt(range.startContainer, "last", " ");
                  }
                  range.startContainer.data += char;
                  range.setStart(range.startContainer, range.startContainer.data.length);
                  range.collapse(true);
                  ViperSelection.addRange(range);
                  this._viper.fireNodesChanged([range.startContainer]);
                  return false;
                }
              }
              if (range.collapsed === true && char !== " " && range.startContainer.nodeType === ViperUtil.TEXT_NODE && range.endOffset === range.startContainer.data.length && range.endOffset > 0 && range.startContainer.data.lastIndexOf(String.fromCharCode(160)) === range.startContainer.data.length - 1) {
                range.startContainer.data = range.startContainer.data.substr(0, range.startContainer.data.length - 1);
                range.startContainer.data += " " + char;
                range.setStart(range.startContainer, range.startContainer.data.length);
                range.collapse(true);
                ViperSelection.addRange(range);
                this._viper.fireNodesChanged([range.startContainer]);
                return false;
              }
              var startNode = range.getStartNode();
              if (e.which !== 0 && range.startContainer === range.endContainer && range.collapsed === true && range.startOffset === 0) {
                var textContainer = null;
                if (range.startContainer.nodeType === ViperUtil.ELEMENT_NODE) {
                  if (range.startContainer.childNodes[range.startOffset] && range.startContainer.childNodes[range.startOffset] && range.startContainer.childNodes[range.startOffset].nodeType === ViperUtil.TEXT_NODE) {
                    textContainer = range.startContainer.childNodes[range.startOffset];
                  }
                } else {
                  textContainer = range.startContainer;
                }
                if (textContainer && textContainer.nodeType === ViperUtil.TEXT_NODE) {
                  if (textContainer.previousSibling && ViperUtil.isStubElement(textContainer.previousSibling) === false && ViperUtil.isText(textContainer.previousSibling) === false && ViperUtil.isBlockElement(textContainer.previousSibling) === false) {
                    var prevCont = range._getLastSelectableChild(textContainer.previousSibling);
                    if (ViperUtil.isText(prevCont) === true && this._viper.isSpecialElement(textContainer.previousSibling) === false) {
                      prevCont.data += char;
                      range.setStart(prevCont, prevCont.data.length);
                      range.collapse(true);
                      ViperSelection.addRange(range);
                      this._viper.fireNodesChanged([textContainer]);
                      return false;
                    }
                  }
                  if (!textContainer.previousSibling) {
                    var parent = textContainer.parentNode;
                    while (!parent.previousSibling && ViperUtil.isBlockElement(parent) === false) {
                      if (parent === viperElement) {
                        break;
                      }
                      parent = parent.parentNode;
                    }
                    if (ViperUtil.isText(parent.previousSibling, true) === true) {
                      if (char === " " && ViperUtil.endsWithSpace(parent.previousSibling) === true) {
                        char = String.fromCharCode(160);
                      } else if (char !== " " && ViperUtil.endsWithSpace(parent.previousSibling, true) === true) {
                        ViperUtil.replaceCharAt(parent.previousSibling, "last", " ");
                      }
                      parent.previousSibling.data += char;
                      range.setStart(parent.previousSibling, parent.previousSibling.data.length);
                      range.collapse(true);
                      ViperSelection.addRange(range);
                      this._viper.fireNodesChanged([parent.previousSibling]);
                      return false;
                    } else if (char === " ") {
                      char = String.fromCharCode(160);
                    } else if (ViperUtil.startsWithSpace(textContainer, true) === true) {
                      ViperUtil.replaceCharAt(textContainer, 0, " ");
                    }
                  } else if (textContainer.data.length > 1 && (textContainer.data.charCodeAt(0) === 160 || textContainer.data.charCodeAt(0) === 32) && textContainer.data[1] !== " ") {
                    if (char === " ") {
                      char = String.fromCharCode(160);
                    } else {
                      textContainer.data = " " + textContainer.data.substr(1);
                    }
                  }
                  textContainer.data = char + textContainer.data;
                  range.setStart(textContainer, 1);
                  range.collapse(true);
                  ViperSelection.addRange(range);
                  this._viper.fireNodesChanged([textContainer]);
                  return false;
                } else if (ViperUtil.isTag(startNode, "br") === true) {
                  var textNode = document.createTextNode(char);
                  ViperUtil.insertBefore(startNode, textNode);
                  range.setStart(textNode, 1);
                  range.collapse(true);
                  ViperSelection.addRange(range);
                  this._viper.fireNodesChanged([textNode]);
                  return false;
                }
              } else if (ViperUtil.isBrowser("chrome") === true) {
                if (ViperUtil.rangeInDiffBlocks(range) === true) {
                  this.handleDelete({ which: 8, keyCode: 8, preventDefault: function() {
                  } });
                }
              } else if (ViperUtil.isText(range.startContainer) === true && range.collapsed === true) {
                if (range.startOffset > 0) {
                  if (char !== " " && (range.startContainer.data.charCodeAt(range.startOffset - 1) === 32 || range.startContainer.data.charCodeAt(range.startOffset - 1) === 160) && (range.startContainer.data.charCodeAt(range.startOffset) === 160 || range.startContainer.data.charCodeAt(range.startOffset) === 32)) {
                    range.startContainer.data = range.startContainer.data.substr(0, range.startOffset - 1) + " " + char + " " + range.startContainer.data.substr(range.startOffset + 1);
                    range.setStart(range.startContainer, range.startOffset + 1);
                    range.collapse(true);
                    ViperSelection.addRange(range);
                    this._viper.fireNodesChanged([range.startContainer]);
                    return false;
                  }
                }
              } else if (ViperUtil.isText(range.startContainer) === false && range.collapsed === true && char !== " ") {
                var startNode = range.getStartNode();
                if (ViperUtil.isText(startNode) === true) {
                  if (ViperUtil.isText(startNode.previousSibling) === true) {
                    var prevSib = startNode.previousSibling;
                    var prevLen = prevSib.data.length;
                    if (prevSib.data.charCodeAt(prevLen - 1) === 160) {
                      prevSib.data = prevSib.data.substr(0, prevLen - 1) + " ";
                    }
                    prevSib.data += char + startNode.data;
                    ViperUtil.remove(startNode);
                    range.setStart(prevSib, prevLen + 1);
                    range.collapse(true);
                    ViperSelection.addRange(range);
                    this._viper.fireNodesChanged([prevSib]);
                    return false;
                  }
                }
              } else if (range.startContainer !== range.endContainer && ViperUtil.isText(range.startContainer) === true && ViperUtil.isText(range.endContainer) === true) {
                range.deleteContents();
                range.startContainer.data += char;
                range.setStart(range.startContainer, range.startContainer.data.length);
                range.collapse(true);
                ViperSelection.addRange(range);
                this._viper.fireNodesChanged([range.startContainer]);
                return false;
              }
            }
            var self = this;
            setTimeout(function() {
              self._viper.fireNodesChanged([range.startContainer]);
            }, 5);
            return true;
          }
          return true;
        },
        keyUp: function(e) {
          if (this._viper.fireCallbacks("Viper:keyUp", e) === false) {
            ViperUtil.preventDefault(e);
            return false;
          }
          if (e.which === ViperUtil.DOM_VK_BACKSPACE) {
            var html = ViperUtil.getHtml(this._viper.element);
            if (!html || html === "<br>") {
              ViperUtil.setHtml(this._viper.element, "");
              this._viper.initEditableElement();
            }
          }
          if (e.which >= 37 && e.which <= 40) {
            var range = this._viper.getCurrentRange();
            if (e.which >= 39 && range.startContainer === range.endContainer && range.startOffset === range.endOffset && range.endOffset >= range.startContainer.childNodes.length) {
              var lastSelectable = range._getLastSelectableChild(range.startContainer.childNodes[range.endOffset - 1]);
              if (lastSelectable && lastSelectable.nodeType === ViperUtil.TEXT_NODE) {
                range.setStart(lastSelectable, lastSelectable.data.length);
                range.collapse(true);
                ViperSelection.addRange(range);
              }
            } else if (e.which <= 38 && range.startOffset === 0 && range.startOffset === range.endOffset && range.startContainer === range.endContainer && range.startContainer.nodeType === ViperUtil.ELEMENT_NODE && ViperUtil.isStubElement(range.startContainer.childNodes[range.startOffset]) === false) {
              var firstSelectable = range._getFirstSelectableChild(range.startContainer.childNodes[range.startOffset]);
              range.setStart(firstSelectable, 0);
              range.collapse(true);
              ViperSelection.addRange(range);
            }
          }
          var ignoredKeys = [16, 17, 18, 20, 27, 91];
          if (this._keyDownRangeCollapsed === false && ViperUtil.inArray(e.which, ignoredKeys) === false && e.ctrlKey === false && e.metaKey === false || e.which === 8 || e.which === 46 || e.which >= 37 && e.which <= 40) {
            this._viper.fireSelectionChanged();
          }
          this._keyDownRangeCollapsed = true;
        },
        /**
         * Keeps track of range status during keydown and keyup event.
         *
         * This var prevents keyUp event firing selectionChanged for each key up event.
         * Its for performance reasons only.
         */
        _keyDownRangeCollapsed: true,
        /**
         * Handle the keyDown event.
         *
         * @param {event} e The event object.
         *
         * return {void|boolean} Returns false if default event needs to be blocked.
         */
        keyDown: function(e) {
          this._viper.resetViperRange(null);
          var range = this._viper.getCurrentRange();
          if (this._keyDownRangeCollapsed === true) {
            this._keyDownRangeCollapsed = range.collapsed;
          }
          if (ViperUtil.isKey(e, "ENTER") === true) {
            return this.handleEnter();
          } else if (ViperUtil.isKey(e, "SHIFT+ENTER") === true) {
            return this.handleSoftEnter(e);
          } else if (ViperUtil.isKey(e, "DELETE") === true || ViperUtil.isKey(e, "BACKSPACE") === true) {
            var retval = this.handleDelete(e);
            if (retval !== false && ViperUtil.isBrowser("firefox") === false) {
              var self = this;
              setTimeout(function() {
                self._viper.fireNodesChanged();
              }, 5);
            }
            return retval;
          }
          var returnValue = this._viper.fireCallbacks("Viper:keyDown", e);
          if (returnValue === false) {
            ViperUtil.preventDefault(e);
            return false;
          }
          if (e.ctrlKey === false && e.which !== 17 && e.altKey === false && e.which !== 18 && e.shiftKey === false && e.which !== 16 && e.metaKey === false && e.which !== 224 && e.which !== 27) {
            if (this._viper.isSpecialKey(e) === false) {
              if (ViperUtil.isBrowser("firefox") === true) {
                this._firefoxKeyDown(e);
              } else if ((ViperUtil.isKey(e, "backspace") === true || ViperUtil.isKey(e, "delete") === true) && (ViperUtil.isBrowser("chrome") === true || ViperUtil.isBrowser("safari") === true)) {
                this._viper.contentChanged(true);
              }
              var self = this;
              setTimeout(function() {
                self._viper.fireSelectionChanged(null, true);
              }, 10);
              return true;
            }
          } else if (e.which === 65 && (e.metaKey === true || e.ctrlKey === true) || e.which >= 37 && e.which <= 40 && (e.metaKey === true || e.ctrlKey === true) && e.shiftKey === true) {
            var self = this;
            setTimeout(function() {
              self._viper.fireSelectionChanged();
            }, 10);
            return true;
          }
        },
        _firefoxKeyDown: function(e) {
          if (e.which >= 37 && e.which <= 40) {
            var range = this._viper.getCurrentRange();
            if (e.which >= 39 && range.startContainer === range.endContainer && range.startOffset === 0 && range.endOffset >= range.startContainer.childNodes.length) {
              var lastSelectable = range._getLastSelectableChild(range.startContainer.childNodes[range.endOffset - 1]);
              if (lastSelectable && lastSelectable.nodeType === ViperUtil.TEXT_NODE) {
                range.setStart(lastSelectable, lastSelectable.data.length);
                range.collapse(true);
                ViperSelection.addRange(range);
              }
            }
            return;
          }
          var range = this._viper.getCurrentRange();
          var elem = this._viper.getViperElement();
          if (elem.childNodes.length === 0 || elem.childNodes.length === 1 && ViperUtil.isTag(elem.childNodes[0], "br") === true || elem === range.startContainer && elem === range.endContainer && range.startOffset === 0 && range.endOffset >= range.endContainer.childNodes.length) {
            var tagName = this._viper.getDefaultBlockTag();
            if (elem.childNodes.length === 1 && ViperUtil.isBlockElement(elem.childNodes[0]) === true) {
              tagName = ViperUtil.getTagName(elem.childNodes[0]);
            }
            var textNode = document.createTextNode("");
            if (!tagName) {
              ViperUtil.setHtml(this._viper.element, "");
              this._viper.element.appendChild(textNode);
            } else {
              ViperUtil.setHtml(this._viper.element, "<" + tagName + "></" + tagName + ">");
              this._viper.element.firstChild.appendChild(textNode);
            }
            range.setStart(textNode, 0);
            range.collapse(true);
            ViperSelection.addRange(range);
          } else {
            var startNode = range.getStartNode();
            var endNode = range.getEndNode();
            if (startNode && startNode === endNode && startNode.nodeType === ViperUtil.ELEMENT_NODE && startNode.parentNode === this._viper.element && range.startOffset === 0) {
              var firstChild = range._getFirstSelectableChild(startNode);
              if (firstChild) {
                range.setStart(firstChild, 0);
                range.collapse(true);
                ViperSelection.addRange(range);
              }
            }
          }
          if (range.startContainer === range.endContainer && ViperUtil.isTag(range.startContainer, "br") === true) {
            var textNode = document.createTextNode("");
            ViperUtil.insertAfter(range.startContainer, textNode);
            ViperUtil.remove(range.startContainer);
            range.setStart(textNode, 0);
            range.collapse(true);
            ViperSelection.addRange(range);
          }
        },
        handleEnter: function(returnFirstBlock) {
          this._viper.fireCallbacks("Viper:beforeEnter");
          var defaultTagName = this._viper.getDefaultBlockTag();
          var self = this;
          var range = this._viper.getCurrentRange();
          var endNode = range.getEndNode();
          var startNode = range.getStartNode();
          var viperElem = this._viper.getViperElement();
          if (!endNode) {
            if (startNode) {
              endNode = startNode;
            } else if (range.startContainer.nodeType === ViperUtil.ELEMENT_NODE && !range.startContainer.childNodes[range.startOffset] && range.startContainer.childNodes[range.startOffset - 1]) {
              endNode = range.startContainer.childNodes[range.startOffset - 1];
            } else if (range.startContainer.nodeType === ViperUtil.ELEMENT_NODE && range.startContainer.childNodes.length === 0 && !endNode) {
              endNode = range.startContainer;
            }
          }
          try {
            if (!startNode && !endNode && range.collapsed === true && ViperUtil.isTag(range.startContainer, "br") === true) {
              startNode = range.startContainer;
              endNode = startNode;
            }
            if (endNode && endNode.nodeType === ViperUtil.TEXT_NODE && ViperUtil.trim(ViperUtil.trim(endNode.data)).replace(String.fromCharCode(160), "") === "") {
              endNode.data = "";
              if (range.startContainer === endNode && range.collapsed === true && range.startOffset > 0) {
                range.setStart(endNode, 0);
                range.collapse(true);
              }
            }
          } catch (e) {
            return;
          }
          if (range.collapsed === true && (startNode && startNode.nodeType === ViperUtil.TEXT_NODE || ViperUtil.isTag(startNode, "br") === true) && !startNode.previousSibling && range.startOffset === 0 && ViperUtil.getParents(startNode, "blockquote", this._viper.getViperElement()).length > 0 && ViperUtil.isTag(ViperUtil.getFirstBlockParent(startNode), "p") === true) {
            var parentPtag = ViperUtil.getFirstBlockParent(startNode);
            var prevTag = parentPtag.previousSibling;
            while (prevTag) {
              if (ViperUtil.isBlockElement(prevTag) === true) {
                break;
              }
              prevTag = prevTag.previousSibling;
            }
            if (prevTag) {
              var parentBlockquote = ViperUtil.getParents(parentPtag, "blockquote", this._viper.getViperElement())[0];
              var newBlockquote = parentBlockquote.cloneNode(false);
              if (parentPtag.nextSibling) {
                while (parentPtag.nextSibling) {
                  if (this.isEmptyBlockElement(parentPtag.nextSibling) === true) {
                    ViperUtil.remove(parentPtag.nextSibling);
                  } else {
                    newBlockquote.appendChild(parentPtag.nextSibling);
                  }
                }
                ViperUtil.insertBefore(newBlockquote.firstChild, parentPtag);
              } else {
                newBlockquote.appendChild(parentPtag);
              }
              if (this.isEmptyBlockElement(parentPtag) === true) {
                ViperUtil.remove(parentPtag);
              }
              ViperUtil.removeEmptyNodes(newBlockquote);
              if (this.isEmptyBlockElement(newBlockquote) === false) {
                ViperUtil.insertAfter(parentBlockquote, newBlockquote);
              }
              var midP = document.createElement("p");
              midP.appendChild(document.createElement("br"));
              ViperUtil.insertAfter(parentBlockquote, midP);
              range.selectNode(midP.firstChild);
              range.collapse(true);
              ViperSelection.addRange(range);
              this._viper.contentChanged();
              return false;
            }
          }
          var firstBlock = null;
          if (ViperUtil.isTag(endNode, "li") === true && endNode === startNode && endNode.firstChild === null) {
            firstBlock = endNode;
          } else {
            firstBlock = ViperUtil.getFirstBlockParent(endNode);
          }
          if (range.collapsed === true && (endNode.nodeType === ViperUtil.TEXT_NODE && (range.endOffset === endNode.data.length || range.endOffset === ViperUtil.rtrim(endNode.data).length) || endNode.nodeType === ViperUtil.ELEMENT_NODE && ViperUtil.isTag(endNode, "br")) && (!endNode.nextSibling || ViperUtil.isTag(endNode.nextSibling, "br") === true && !endNode.nextSibling.nextSibling) && (range._getLastSelectableChild(firstBlock, true) === endNode || range._getLastSelectableChild(firstBlock, true) === null && ViperUtil.isTag(endNode, "br") === true || endNode.nodeType === ViperUtil.TEXT_NODE && endNode.data.length === 0) || ViperUtil.isTag(firstBlock, "li") === true && endNode === startNode && endNode.firstChild === null) {
            if (firstBlock && !defaultTagName && firstBlock === this._viper.getViperElement()) {
              var br = document.createElement("br");
              this._viper.insertNodeAtCaret(br);
              if (!br.nextSibling) {
                ViperUtil.insertAfter(br, document.createElement("br"));
              }
              range.setStart(br.nextSibling, 0);
              range.collapse(true);
              ViperSelection.addRange(range);
              this._viper.contentChanged();
              return false;
            } else if (firstBlock) {
              var firstBlockTagName = ViperUtil.getTagName(firstBlock);
              var handleEnter = false;
              var removeFirstBlock = false;
              if (ViperUtil.inArray(firstBlockTagName, this._tagList) === true) {
                handleEnter = true;
              } else if (firstBlockTagName === "li" && ViperUtil.trim(ViperUtil.getNodeTextContent(firstBlock)) === "") {
                if (defaultTagName === "") {
                  this.splitList(firstBlock);
                  this._viper.contentChanged();
                  return false;
                } else {
                  handleEnter = true;
                  removeFirstBlock = true;
                }
              }
              if (handleEnter === true) {
                if (defaultTagName === "") {
                  var br = document.createElement("br");
                  ViperUtil.insertAfter(firstBlock, br);
                  range.setStart(br, 0);
                  range.collapse(true);
                  ViperSelection.addRange(range);
                  this._viper.contentChanged();
                  return false;
                }
                var content = "<br />";
                var tagName = defaultTagName;
                var p = document.createElement(tagName);
                ViperUtil.setHtml(p, content);
                if (ViperUtil.isTag(firstBlock, "p") === true && firstBlock.parentNode !== this._viper.getViperElement() && !firstBlock.nextSibling && ViperUtil.trim(ViperUtil.getNodeTextContent(firstBlock)) === "") {
                  ViperUtil.insertAfter(firstBlock.parentNode, p);
                  removeFirstBlock = true;
                } else {
                  if (firstBlockTagName === "li") {
                    var parentListItem = ViperUtil.getFirstBlockParent(firstBlock.parentNode);
                    if (parentListItem && ViperUtil.isTag(parentListItem, "li") === true) {
                      newList = document.createElement("li");
                      newList.appendChild(document.createElement("br"));
                      var subList = null;
                      while (firstBlock.nextSibling) {
                        if (ViperUtil.isTag(firstBlock.nextSibling, "li") === true) {
                          if (!subList) {
                            subList = document.createElement(ViperUtil.getTagName(firstBlock.parentNode));
                            newList.appendChild(subList);
                          }
                          subList.appendChild(firstBlock.nextSibling);
                        } else if (subList) {
                          subList.appendChild(firstBlock.nextSibling);
                        } else {
                          newList.appendChild(firstBlock.nextSibling);
                        }
                      }
                      ViperUtil.remove(firstBlock);
                      ViperUtil.insertAfter(parentListItem, newList);
                      range.selectNode(newList.firstChild);
                      range.collapse(true);
                      ViperSelection.addRange(range);
                      this._viper.contentChanged();
                      return false;
                    }
                    var newList = document.createElement(ViperUtil.getTagName(firstBlock.parentNode));
                    while (firstBlock.nextSibling) {
                      newList.appendChild(firstBlock.nextSibling);
                    }
                    if (ViperUtil.getTag("li", newList).length > 0) {
                      ViperUtil.insertAfter(firstBlock.parentNode, newList);
                    }
                    ViperUtil.insertAfter(firstBlock.parentNode, p);
                  } else {
                    ViperUtil.insertAfter(firstBlock, p);
                  }
                }
                if (removeFirstBlock === true) {
                  ViperUtil.remove(firstBlock);
                }
                if (p.firstChild.nodeType === ViperUtil.TEXT_NODE) {
                  range.setEnd(p.firstChild, 0);
                  range.collapse(false);
                } else {
                  range.selectNode(p.firstChild);
                  range.collapse(true);
                }
                ViperSelection.addRange(range);
                this._viper.contentChanged();
                return false;
              }
            }
          }
          var startNode = range.getStartNode();
          var blockParent = null;
          if (!startNode) {
            if (range.startContainer.childNodes.length <= range.startOffset && range.startOffset !== 0) {
              startNode = range.startContainer.childNodes[range.startContainer.childNodes.length - 1];
            } else {
              startNode = range.startContainer;
            }
            if (ViperUtil.isBlockElement(startNode) === true) {
              blockParent = startNode;
            }
          } else {
            blockParent = ViperUtil.getFirstBlockParent(startNode);
          }
          if (startNode && ViperUtil.isTag(blockParent, "pre") === true) {
            if (startNode.parentNode === blockParent && startNode.nodeType === ViperUtil.TEXT_NODE && ViperUtil.trim(startNode.data) === "" && (!startNode.previousSibling || startNode.previousSibling.data === "\n")) {
              while (startNode.nextSibling) {
                ViperUtil.remove(startNode.nextSibling);
              }
              ViperUtil.remove(startNode);
              var p = document.createElement("p");
              ViperUtil.setHtml(p, "<br />");
              ViperUtil.insertAfter(blockParent, p);
              range.selectNode(p.firstChild);
              range.collapse(true);
              ViperSelection.addRange(range);
            } else {
              this.insertTextAtRange(range, "\n");
              this._viper.contentChanged();
            }
            return false;
          } else if ((blockParent === null || blockParent === this._viper.getViperElement()) && !defaultTagName) {
            if (startNode.nodeType === ViperUtil.TEXT_NODE && startNode.data.length > range.startOffset + 1 && startNode.data.charCodeAt(range.startOffset) === 32) {
              startNode.data = startNode.data.substring(0, range.startOffset) + String.fromCharCode(160) + startNode.data.substring(range.startOffset + 1);
              range.setStart(startNode, range.startOffset);
              range.collapse(true);
              ViperSelection.addRange(range);
            }
            var br = document.createElement("br");
            if (ViperUtil.isText(range.startContainer) === true && range.startOffset === range.startContainer.data.length && !range.startContainer.nextSibling) {
              var parent = range.startContainer.parentNode;
              while (parent !== viperElem) {
                if (parent.nextSibling) {
                  break;
                }
                parent = parent.parentNode;
              }
              if (parent && parent !== viperElem) {
                ViperUtil.insertAfter(parent, br);
              } else {
                ViperUtil.insertAfter(range.startContainer, br);
              }
            } else if (ViperUtil.isText(range.startContainer) === true && range.startOffset === 0 && !range.startContainer.previousSibling) {
              var parent = range.startContainer.parentNode;
              while (parent !== viperElem) {
                if (parent.previousSibling) {
                  break;
                }
                parent = parent.parentNode;
              }
              if (parent && parent !== viperElem) {
                ViperUtil.insertBefore(parent, br);
              }
            } else {
              this._viper.insertNodeAtCaret(br);
            }
            var selectable = br.nextSibling;
            if (ViperUtil.isText(br.nextSibling) !== true || br.nextSibling.data.charAt(0) === "\n") {
              if (ViperUtil.isElement(br.nextSibling) === true && ViperUtil.isStubElement(br.nextSibling) === false) {
                var firstSelectable = range._getFirstSelectableChild(br.nextSibling);
                if (firstSelectable) {
                  selectable = firstSelectable;
                } else {
                  selectable = document.createTextNode("");
                  ViperUtil.insertAfter(br, selectable);
                }
              } else {
                selectable = document.createTextNode(String.fromCharCode(160));
                ViperUtil.insertAfter(br, selectable);
              }
            }
            range.setStart(selectable, 0);
            range.collapse(true);
            ViperSelection.addRange(range);
            this._viper.contentChanged();
            return false;
          }
          var selectedNode = range.getNodeSelection();
          if (selectedNode && selectedNode === viperElem) {
            var elem = document.createElement(defaultTagName);
            ViperUtil.setHtml(elem, "<br />");
            if (viperElem.firstChild) {
              ViperUtil.insertBefore(viperElem.firstChild, elem);
            } else {
              viperElem.appendChild(elem);
            }
            range.selectNode(elem.firstChild);
            range.collapse(true);
            ViperSelection.addRange(range);
            this._viper.fireSelectionChanged();
            return false;
          } else if (!selectedNode && startNode && startNode === endNode && startNode.nodeType === ViperUtil.ELEMENT_NODE && (ViperUtil.isBrowser("firefox") !== true || !(ViperUtil.isTag(startNode, "br") === true && (!blockParent || ViperUtil.isTag(blockParent, "li") === true))) && ViperUtil.isStubElement(startNode) === false && ViperUtil.isBlockElement(startNode) === true) {
            var elem = document.createElement(defaultTagName);
            ViperUtil.setHtml(elem, "<br />");
            if (startNode === viperElem.lastChild) {
              ViperUtil.insertAfter(startNode, elem);
            } else {
              ViperUtil.insertBefore(startNode, elem);
            }
            range.selectNode(elem.firstChild);
            range.collapse(true);
            ViperSelection.addRange(range);
            this._viper.fireSelectionChanged();
            return false;
          } else if (!selectedNode && startNode && endNode && startNode !== endNode && startNode.nodeType === ViperUtil.ELEMENT_NODE && endNode.nodeType === ViperUtil.ELEMENT_NODE) {
            var elem = document.createElement(defaultTagName);
            ViperUtil.setHtml(elem, "<br />");
            if (ViperUtil.isStubElement(endNode) === true) {
              ViperUtil.insertAfter(startNode, elem);
            } else {
              ViperUtil.insertAfter(endNode, elem);
            }
            range.selectNode(elem.firstChild);
            range.collapse(true);
            ViperSelection.addRange(range);
            this._viper.fireSelectionChanged();
            return false;
          } else if (ViperUtil.isBrowser("firefox") === true && startNode.nodeType === ViperUtil.TEXT_NODE && endNode === startNode && range.startOffset === startNode.data.length && range.collapsed === true && ViperUtil.isTag(blockParent, "li") === true && ViperUtil.isChildOf(ViperUtil.getFirstBlockParent(range.getNextContainer(startNode)), blockParent)) {
            var li = document.createElement("li");
            if (!startNode.nextSibling || ViperUtil.isTag(startNode.nextSibling, "br") === false) {
              li.appendChild(document.createElement("br"));
            }
            while (startNode.nextSibling) {
              li.appendChild(startNode.nextSibling);
            }
            ViperUtil.insertAfter(blockParent, li);
            range.selectNode(li.firstChild);
            range.collapse(true);
            ViperSelection.addRange(range);
            return false;
          } else if (selectedNode && ViperUtil.isTag(selectedNode, "li") === true && blockParent === selectedNode && startNode === endNode && ViperUtil.isTag(startNode, "br") === true && range.collapsed === true && !startNode.nextSibling) {
            var parentListItem = ViperUtil.getFirstBlockParent(blockParent.parentNode);
            if (parentListItem && ViperUtil.isTag(parentListItem, "li") === true) {
              var li = document.createElement("li");
              li.appendChild(document.createElement("br"));
              while (startNode.nextSibling) {
                li.appendChild(startNode.nextSibling);
              }
              var subList = null;
              while (blockParent.nextSibling) {
                if (ViperUtil.isTag(blockParent.nextSibling, "li") === true) {
                  if (!subList) {
                    subList = document.createElement(ViperUtil.getTagName(blockParent.parentNode));
                    li.appendChild(subList);
                  }
                  subList.appendChild(blockParent.nextSibling);
                } else if (subList) {
                  subList.appendChild(blockParent.nextSibling);
                } else {
                  li.appendChild(blockParent.nextSibling);
                }
              }
              ViperUtil.remove(blockParent);
              ViperUtil.insertAfter(parentListItem, li);
              range.selectNode(li.firstChild);
              range.collapse(true);
              ViperSelection.addRange(range);
              return false;
            } else if (ViperUtil.isBrowser("chrome") === true) {
              var elem = null;
              if (defaultTagName) {
                elem = document.createElement(defaultTagName);
                elem.appendChild(document.createElement("br"));
              } else {
                elem = document.createElement("br");
              }
              ViperUtil.insertAfter(blockParent.parentNode, elem);
              var listItems = [];
              for (var node = blockParent; node; node = node.nextSibling) {
                if (ViperUtil.isTag(node, "li") === true) {
                  listItems.push(node);
                }
              }
              if (listItems.length > 0) {
                var newList = document.createElement(ViperUtil.getTagName(blockParent.parentNode));
                ViperUtil.insertAfter(elem, newList);
                while (listItems.length > 0) {
                  newList.appendChild(listItems.shift());
                }
              }
              ViperUtil.remove(blockParent);
              if (defaultTagName) {
                range.selectNode(elem.firstChild);
              } else {
                range.selectNode(elem);
              }
              range.collapse(true);
              ViperSelection.addRange(range);
              return false;
            }
          } else if (range.collapsed === true && startNode.nodeType === ViperUtil.TEXT_NODE && startNode.data.length > range.startOffset + 1 && startNode.data.charCodeAt(range.startOffset) === 32) {
            startNode.data = startNode.data.substring(0, range.startOffset) + String.fromCharCode(160) + startNode.data.substring(range.startOffset + 1);
            range.setStart(startNode, range.startOffset);
            range.collapse(true);
            ViperSelection.addRange(range);
          } else if (startNode && startNode === endNode && ViperUtil.isStubElement(startNode) === true && startNode.parentNode === self._viper.getViperElement()) {
            var defTag = null;
            if (defaultTagName !== "") {
              defTag = document.createElement(defaultTagName);
              ViperUtil.setHtml(defTag, "<br/>");
            } else {
              defTag = document.createTextNode(" ");
            }
            ViperUtil.insertAfter(startNode, defTag);
            range.setStart(defTag, 0);
            range.collapse(true);
            ViperSelection.addRange(range);
            return false;
          } else if (ViperUtil.isBrowser("firefox") === true && range.collapsed === true && startNode.nodeType === ViperUtil.TEXT_NODE && range.endOffset === startNode.data.length && startNode.nextSibling && ViperUtil.isTag(startNode.nextSibling, "br") && ViperUtil.isText(startNode.nextSibling.nextSibling, true) === true) {
            var br = startNode.nextSibling;
            setTimeout(function() {
              var textNode = document.createTextNode("");
              ViperUtil.insertBefore(br, textNode);
              range.setStart(textNode, 0);
              range.collapse(true);
              ViperSelection.addRange(range);
            }, 10);
          } else if (startNode.nodeType === ViperUtil.TEXT_NODE && range.endOffset === startNode.data.length && startNode.data.length !== 0 && range.collapsed === true && startNode.nextSibling === null && ViperUtil.isBlockElement(startNode.parentNode) === false && ViperUtil.isTag(ViperUtil.getFirstBlockParent(startNode.parentNode), "li") === false) {
            var parent = startNode.parentNode;
            var surroundingParents = ViperUtil.getSurroundingParents(parent, null, "inline");
            if (surroundingParents.length > 0) {
              parent = surroundingParents.pop();
            }
            var parentNextSibling = parent.nextSibling;
            if (!parentNextSibling || parentNextSibling.nodeType !== ViperUtil.TEXT_NODE) {
              parentNextSibling = document.createTextNode("");
              ViperUtil.insertAfter(parent, parentNextSibling);
            }
            range.setStart(parentNextSibling, 0);
            range.collapse(true);
            ViperSelection.addRange(range);
          } else if (range.startContainer.nodeType === ViperUtil.TEXT_NODE && range.collapsed === true && range.startOffset === range.startContainer.data.length + 1 && range.startContainer.previousSibling && range.startContainer.previousSibling.nodeType !== ViperUtil.TEXT_NODE && (range.startContainer.nextSibling === null || ViperUtil.isTag(range.startContainer.nextSibling, "br") === true) && ViperUtil.trim(range.startContainer.data) === "") {
            var parent = ViperUtil.getFirstBlockParent(range.startContainer);
            if (parent) {
              var newParent = document.createElement(ViperUtil.getTagName(parent));
              ViperUtil.setHtml(newParent, "<br />");
              ViperUtil.insertAfter(parent, newParent);
              range.setStart(newParent.firstChild, 0);
              range.collapse(true);
              ViperSelection.addRange(range);
              self._viper.fireSelectionChanged(null, true);
              return false;
            }
          } else if ((ViperUtil.isBrowser("chrome") === true || ViperUtil.isBrowser("safari") === true) && range.startOffset === 0 && range.collapsed === true && range.startContainer.nodeType === ViperUtil.TEXT_NODE && range._getFirstSelectableChild(ViperUtil.getFirstBlockParent(range.startContainer)) === range.startContainer) {
            var parent = ViperUtil.getFirstBlockParent(range.startContainer);
            var newParent = document.createElement(ViperUtil.getTagName(parent));
            ViperUtil.setHtml(newParent, "<br />");
            ViperUtil.insertBefore(parent, newParent);
            this._viper.contentChanged(true);
            return false;
          } else if (range.startContainer.nodeType === ViperUtil.ELEMENT_NODE && range.collapsed === true && range.startOffset === 0 && range.startContainer.previousSibling && range.startContainer.previousSibling.nodeType === ViperUtil.TEXT_NODE && range.startContainer.nextSibling === null && ViperUtil.isTag(range.startContainer, "br") === true) {
            var parent = ViperUtil.getFirstBlockParent(range.startContainer);
            if (parent) {
              var newParent = document.createElement(ViperUtil.getTagName(parent));
              ViperUtil.setHtml(newParent, "<br />");
              ViperUtil.insertAfter(parent, newParent);
              range.setStart(newParent.firstChild, 0);
              range.collapse(true);
              ViperSelection.addRange(range);
              self._viper.fireSelectionChanged(null, true);
              return false;
            }
          } else if (range.startContainer.nodeType === ViperUtil.TEXT_NODE && range.collapsed === true && range.startOffset === range.startContainer.data.length && range.startContainer.nextSibling && range.startContainer.nextSibling.nodeType !== ViperUtil.TEXT_NODE && ViperUtil.isTag(range.startContainer.nextSibling, "br") === false && ViperUtil.isBlockElement(range.startContainer.nextSibling) === false) {
            this.splitAtRange();
            this._viper.contentChanged();
            return false;
          } else if (range.startContainer === range.endContainer && defaultTagName !== "" && ViperUtil.isBlockElement(range.startContainer) === true && range.collapsed === true && range.startOffset === range.startContainer.childNodes.length && ViperUtil.isTag(range.startContainer.childNodes[range.startOffset - 1], "table") === true) {
            var newTag = document.createElement(defaultTagName);
            ViperUtil.setHtml(newTag, "<br />");
            ViperUtil.insertAfter(range.startContainer.childNodes[range.startOffset - 1], newTag);
            range.setStart(newTag.firstChild, 0);
            range.collapse(true);
            ViperSelection.addRange(range);
            this._viper.contentChanged();
            return false;
          } else if (range.collapsed === true) {
            if (ViperUtil.isText(range.startContainer) === true) {
              if (range.startOffset === range.startContainer.data.length) {
                if (range.startContainer.nextSibling === null) {
                  var firstBlockParent = ViperUtil.getFirstBlockParent(range.startContainer);
                  if (firstBlockParent) {
                    if (range._getLastSelectableChild(firstBlockParent) === range.startContainer) {
                      if (ViperUtil.isTag(firstBlockParent, "li") === true) {
                        var parents = ViperUtil.getParents(range.startContainer, null, firstBlockParent);
                        if (parents.length > 0) {
                          var li = document.createElement("li");
                          var parent = li;
                          for (var i = parents.length - 1; i >= 0; i--) {
                            var node = document.createElement(ViperUtil.getTagName(parents[i]));
                            parent.appendChild(node);
                            parent = node;
                          }
                          if (parent) {
                            ViperUtil.insertAfter(firstBlockParent, li);
                            parent.appendChild(document.createElement("br"));
                            range.setStart(parent.firstChild, 0);
                            range.collapse(true);
                            ViperSelection.addRange(range);
                            this._viper.contentChanged();
                            return false;
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
          if (defaultTagName !== "" && range.collapsed === true) {
            var firstBlockParent = ViperUtil.getFirstBlockParent(range.startContainer);
            if (firstBlockParent) {
              if (firstBlockParent !== viperElem) {
                if (ViperUtil.isBrowser("firefox") === true && ViperUtil.isTag(firstBlockParent.parentNode, "blockquote") === false) {
                  this.splitAtRange();
                  this._viper.contentChanged();
                  return false;
                }
              }
            }
          }
          if (range.startOffset === 0 && range.collapsed === true && range.startContainer.nodeType === ViperUtil.TEXT_NODE && (range.startContainer.previousSibling === null || range.startContainer.previousSibling && range.startContainer.previousSibling.nodeType !== ViperUtil.TEXT_NODE)) {
            this.splitAtRange();
            this._viper.contentChanged();
            return false;
          }
          setTimeout(function() {
            var prevSelectable = range.getPreviousContainer(range.startContainer);
            if (ViperUtil.isText(prevSelectable) === true) {
              if (prevSelectable.data.length > 1 && prevSelectable.data[prevSelectable.data.length - 1] === String.fromCharCode(160) && prevSelectable.data[prevSelectable.data.length - 2] != " ") {
                prevSelectable.data = prevSelectable.data.substr(0, prevSelectable.data.length - 1) + " ";
              }
            }
            self._viper.fireSelectionChanged(null, true);
          }, 5);
          return true;
        },
        handleDelete: function(e) {
          e = e || { which: 8, keyCode: 8 };
          var range = this._viper.getViperRange();
          if (this._viper.fireCallbacks("Viper:beforeDelete", e) === false) {
            return false;
          }
          if (this._isWholeViperElementSelected(range) === true) {
            ViperUtil.setHtml(this._viper.getViperElement(), "");
            this._viper.initEditableElement();
            this._viper.contentChanged();
            return false;
          }
          if (ViperUtil.isBrowser("chrome") === true || ViperUtil.isBrowser("safari") === true) {
            return this._handleDeleteForWebkit(e, range);
          }
          if (e.which === 46) {
            return this._handleDeleteFromRight(e, range);
          }
          var defaultTagName = this._viper.getDefaultBlockTag();
          var viperElement = this._viper.getViperElement();
          var firstSelectable = range._getFirstSelectableChild(viperElement);
          var startNode = range.getStartNode();
          if (!startNode && range.startOffset === 0 && range.startContainer.nodeType !== ViperUtil.TEXT_NODE && range.collapsed === true && !range.startContainer.firstChild) {
            startNode = range.startContainer;
          }
          if (range.collapsed === true && e.keyCode === 8 && range.startOffset === 0) {
            if (startNode && (startNode.nodeType === ViperUtil.TEXT_NODE || ViperUtil.isTag(startNode, "br") === true)) {
              var skippedBlockElem = [];
              var node = range.getPreviousContainer(startNode, skippedBlockElem, true, true);
              if (this._viper.isOutOfBounds(node) === true) {
                if (skippedBlockElem.length > 0) {
                  for (var i = 0; i < skippedBlockElem.length; i++) {
                    if (ViperUtil.isTag(skippedBlockElem[i], "p") === true) {
                      ViperUtil.remove(skippedBlockElem[i]);
                    }
                  }
                } else if (startNode.nodeType !== ViperUtil.TEXT_NODE || startNode.data.length === 0) {
                  node = range.getNextContainer(startNode, skippedBlockElem, true, true);
                  if (node && this._viper.isOutOfBounds(node) === false) {
                    ViperUtil.remove(ViperUtil.getSurroundingParents(startNode));
                    range.setStart(node, 0);
                    range.collapse(true);
                    ViperSelection.addRange(range);
                  }
                } else {
                  var nonSelectableElements = ViperUtil.getElementsBetween(viperElement, startNode);
                  ViperUtil.remove(nonSelectableElements);
                }
                if ((startNode.nodeType === ViperUtil.TEXT_NODE && ViperUtil.trim(startNode.data).length === 0 || ViperUtil.isTag(startNode, "br") === true) && ViperUtil.isTag(startNode.parentNode, "li") === true && ViperUtil.getTag("li", startNode.parentNode.parentNode).length === 1) {
                  if (startNode.parentNode.parentNode.parentNode === this._viper.getViperElement() && startNode.parentNode.parentNode.nextSibling === null && startNode.parentNode.parentNode.previousSibling === null) {
                    ViperUtil.remove(startNode.parentNode.parentNode);
                    this._viper.initEditableElement();
                  } else {
                    this._viper.moveCaretAway(startNode.parentNode.parentNode, true);
                    ViperUtil.remove(startNode.parentNode.parentNode);
                  }
                  this._viper.contentChanged();
                }
                return false;
              }
            }
          }
          if (range.startOffset === 0 && range.collapsed === true && startNode.nodeType === ViperUtil.TEXT_NODE) {
            var firstBlock = ViperUtil.getFirstBlockParent(startNode);
            if (firstBlock && range._getFirstSelectableChild(firstBlock) === startNode && firstBlock.previousElementSibling && ViperUtil.isStubElement(firstBlock.previousElementSibling) === true) {
              ViperUtil.remove(firstBlock.previousElementSibling);
              this._viper.contentChanged();
              return false;
            } else if (e.keyCode === 8 && range.collapsed === true && startNode.nodeType === ViperUtil.TEXT_NODE && (range.startOffset === 0 || range.startOffset === 1 && startNode.data.charAt(0) === " ") && (!startNode.previousSibling || ViperUtil.isTag(startNode.previousSibling, "br") === true)) {
              var prevSelectable = range.getPreviousContainer(startNode, null, true, true);
              var currentParent = ViperUtil.getFirstBlockParent(startNode);
              var prevParent = ViperUtil.getFirstBlockParent(prevSelectable);
              if (currentParent !== prevParent && this._viper.isOutOfBounds(prevSelectable) === false) {
                var elemsBetween = ViperUtil.getElementsBetween(prevParent, currentParent);
                if (elemsBetween.length > 0 && elemsBetween[0].nodeType === ViperUtil.TEXT_NODE && ViperUtil.isBlank(ViperUtil.trim(elemsBetween[0].data)) === false) {
                  ViperUtil.remove(elemsBetween[elemsBetween.length - 1]);
                } else {
                  if (prevParent.lastChild && ViperUtil.isTag(prevParent.lastChild, "br") === true) {
                    ViperUtil.remove(prevParent.lastChild);
                  }
                  if (currentParent.lastChild && ViperUtil.isTag(currentParent.lastChild, "br") === true) {
                    ViperUtil.remove(currentParent.lastChild);
                  }
                  var firstChild = currentParent.firstChild;
                  while (currentParent.firstChild) {
                    if (ViperUtil.isText(currentParent.firstChild) !== true && ViperUtil.getTagName(prevParent.lastChild) === ViperUtil.getTagName(currentParent.firstChild)) {
                      ViperUtil.moveChildrenToElement(currentParent.firstChild, prevParent.lastChild, false);
                      ViperUtil.remove(currentParent.firstChild);
                    } else {
                      prevParent.appendChild(currentParent.firstChild);
                    }
                  }
                  if (ViperUtil.isTag(currentParent, ["td", "th"]) === false) {
                    ViperUtil.remove(currentParent);
                  }
                  if (prevSelectable.nodeType === ViperUtil.TEXT_NODE) {
                    range.setEnd(prevSelectable, prevSelectable.data.length);
                  } else if (prevSelectable.parentNode === null || ViperUtil.isStubElement(prevSelectable) === true) {
                    if (firstChild.nodeType === ViperUtil.TEXT_NODE) {
                      range.setEnd(firstChild, 0);
                    } else {
                      var firstSelectable = range._getFirstSelectableChild(firstChild);
                      if (firstSelectable) {
                        range.setEnd(firstSelectable, 0);
                      } else {
                        range.selectNode(firstChild);
                      }
                    }
                  } else {
                    range.selectNode(prevSelectable);
                  }
                  range.collapse(false);
                  ViperSelection.addRange(range);
                }
                this._viper.contentChanged();
                return false;
              }
            }
          } else if (range.startOffset === 0 && range.collapsed === true && range.startContainer === range.endContainer && e.keyCode === 8 && (ViperUtil.elementIsEmpty(range.startContainer) === true || ViperUtil.getHtml(range.startContainer) === "<br>")) {
            if ((ViperUtil.isTag(range.startContainer, "br") !== true || ViperUtil.isTag(range.startContainer.parentNode, "td") === false && ViperUtil.isTag(range.startContainer.parentNode, "th") === false) && ViperUtil.isTag(range.startContainer, "td") === false && ViperUtil.isTag(range.startContainer, "th") === false) {
              var skippedBlockElem = [];
              var endCont = range.endContainer;
              var node = range.getPreviousContainer(range.startContainer, skippedBlockElem, true, true);
              var isList = false;
              var startOffset = 0;
              if (!node || ViperUtil.isChildOf(node, this._viper.element) === false) {
                if (skippedBlockElem.length > 0) {
                  for (var i = 0; i < skippedBlockElem.length; i++) {
                    if (ViperUtil.isTag(skippedBlockElem[i], "p") === true) {
                      ViperUtil.remove(skippedBlockElem[i]);
                    }
                  }
                }
                node = endCont;
                if (ViperUtil.isTag(node, "li") === false) {
                  return false;
                } else {
                  isList = true;
                }
              } else if (node.nodeType === ViperUtil.TEXT_NODE) {
                startOffset = node.data.length;
                if (endCont.previousSibling !== null && ViperUtil.isBlockElement(endCont.previousSibling) === false && node.data.length > 0) {
                  startOffset--;
                  node.data = node.data.substr(0, startOffset);
                }
              }
              range.setEnd(node, startOffset);
              range.collapse(false);
              ViperSelection.addRange(range);
              if (endCont && endCont.nodeType === ViperUtil.ELEMENT_NODE && (ViperUtil.isTag(endCont, "td") === true || ViperUtil.isTag(endCont, "th") === true)) {
                return;
              }
              var parent = endCont.parentNode;
              ViperUtil.remove(endCont);
              while (parent.childNodes.length === 0) {
                if (parent === viperElement) {
                  break;
                }
                var remove2 = parent;
                parent = parent.parentNode;
                ViperUtil.remove(remove2);
              }
              if (isList && parent === this._viper.getViperElement()) {
                node = range._getFirstSelectableChild(parent, true);
                if (!node) {
                  this._viper.initEditableElement();
                  node = range._getFirstSelectableChild(parent, true);
                }
              }
              range.setEnd(node, startOffset);
              range.collapse(false);
              ViperSelection.addRange(range);
              this._viper.contentChanged();
              return false;
            } else if (!range.startContainer.previousSibling) {
              return false;
            } else if (ViperUtil.isTag(range.startContainer, ["td", "th"]) === true) {
              return false;
            }
          }
          var nodeSelection = range.getNodeSelection();
          if (nodeSelection && ViperUtil.isBlockElement(nodeSelection) === true) {
            if (ViperUtil.inArray(ViperUtil.getTagName(nodeSelection), this._keepContainerList) === true) {
              ViperUtil.setHtml(nodeSelection, "<br/>");
              range.setStart(nodeSelection, 0);
              range.collapse(true);
            } else {
              this._viper.moveCaretAway(nodeSelection, true);
              ViperUtil.remove(nodeSelection);
            }
            this._viper.contentChanged();
            return false;
          }
          if (range.collapsed === true) {
            if (range.startContainer.nodeType === ViperUtil.ELEMENT_NODE) {
              var childCount = range.startContainer.childNodes.length;
              if (range.startOffset === childCount || range.startOffset === childCount - 1) {
                var lastChild = range.startContainer.childNodes[childCount - 1];
                var textNode = null;
                if (ViperUtil.isStubElement(ViperUtil.getSurroundedChildren(range.startContainer).pop()) === true) {
                  textNode = range.getPreviousContainer(range.startContainer);
                  ViperUtil.remove(range.startContainer);
                  if (textNode) {
                    range.setStart(textNode, textNode.data.length);
                    range.collapse(true);
                    ViperSelection.addRange(range);
                  }
                  this._viper.contentChanged();
                  return false;
                } else if (ViperUtil.isStubElement(lastChild) === true) {
                  this._viper.moveCaretAway(lastChild, true);
                  ViperUtil.remove(lastChild);
                  this._viper.contentChanged();
                  return false;
                } else if (lastChild.nodeType === ViperUtil.ELEMENT_NODE) {
                  textNode = range._getLastSelectableChild(lastChild);
                } else if (lastChild.nodeType === ViperUtil.TEXT_NODE) {
                  if (lastChild.data.length > 0) {
                    textNode = lastChild;
                  } else {
                    textNode = range.getPreviousContainer(lastChild);
                  }
                }
                if (textNode) {
                  textNode.data = textNode.data.substr(0, textNode.data.length - 1);
                  range.setStart(textNode, textNode.data.length);
                  range.collapse(true);
                  ViperSelection.addRange(range);
                  this._viper.contentChanged();
                  return false;
                }
              }
            } else {
              if (range.startOffset > 0) {
                var textNode = range.startContainer;
                textNode.data = textNode.data.substr(0, range.startOffset - 1) + textNode.data.substr(range.startOffset);
                this._normaliseNextNodes(textNode);
                if (textNode.data === " " && textNode.nextSibling === null && textNode.previousSibling && ViperUtil.isTag(textNode.previousSibling, "br") === true) {
                  textNode.data = "";
                  var br = document.createElement("br");
                  textNode.parentNode.appendChild(br);
                  range.setStart(textNode, 0);
                } else {
                  range.setStart(textNode, range.startOffset - 1);
                }
                range.collapse(true);
                if (textNode.data.length === 0 && textNode.nextSibling === null && textNode.previousSibling === null && ViperUtil.isBlockElement(textNode.parentNode) === true) {
                  var br = document.createElement("br");
                  textNode.parentNode.appendChild(br);
                }
                ViperSelection.addRange(range);
                this._viper.contentChanged();
                return false;
              } else {
                this._normaliseNextNodes(range.startContainer);
                if (range.startContainer.previousSibling === null && (range.startContainer.nextSibling === null || ViperUtil.isTag(range.startContainer.nextSibling, "br") === true)) {
                  var parent = range.startContainer.parentNode;
                  var previousContainer = range.getPreviousContainer(range.startContainer);
                  if (previousContainer) {
                    previousContainer.data = previousContainer.data.substr(0, previousContainer.data.length - 1);
                    range.setStart(previousContainer, previousContainer.data.length);
                    range.collapse(true);
                    ViperSelection.addRange(range);
                    ViperUtil.remove(parent);
                    this._viper.contentChanged();
                    return false;
                  }
                } else if (this._viper.isSpecialElement(range.startContainer.previousSibling) === true || ViperUtil.isStubElement(range.startContainer.previousSibling) === true || ViperUtil.isStubElement(ViperUtil.getSurroundedChildren(range.startContainer.previousSibling).pop()) === true) {
                  var node = range.startContainer.previousSibling;
                  var surroundingParents = ViperUtil.getSurroundingParents(node);
                  if (surroundingParents.length > 0) {
                    node = ViperUtil.remove(surroundingParents.pop());
                  }
                  ViperUtil.remove(node);
                  this._viper.contentChanged();
                  return false;
                } else {
                  var previousContainer = range.getPreviousContainer(range.startContainer);
                  if (previousContainer) {
                    if (this._viper.isOutOfBounds(previousContainer) === true) {
                      if (range.startContainer.previousSibling) {
                        ViperUtil.remove(range.startContainer.previousSibling);
                        this._viper.contentChanged(true);
                        return false;
                      }
                    } else {
                      if (previousContainer.nodeType === ViperUtil.TEXT_NODE) {
                        range.setStart(previousContainer, previousContainer.data.length);
                      } else if (ViperUtil.isStubElement(previousContainer) === true) {
                        ViperUtil.remove(previousContainer);
                        this._viper.contentChanged(true);
                        return false;
                      } else {
                        range.setStart(previousContainer, 0);
                      }
                      range.collapse(true);
                      ViperSelection.addRange(range);
                      return;
                    }
                  }
                }
              }
            }
          } else {
            if (range.startContainer === range.endContainer) {
              if (range.startContainer.nodeType === ViperUtil.TEXT_NODE) {
                var textNode = range.startContainer;
                if (range.startOffset === 0 && range.endOffset === textNode.data.length) {
                  textNode.data = "";
                  if (ViperUtil.isEmptyElement(textNode.parentNode) === true) {
                    var parent = textNode.parentNode;
                    if (ViperUtil.isBlockElement(parent) === true) {
                      this._viper.moveCaretAway(parent, true);
                      ViperUtil.remove(parent);
                      this._viper.contentChanged();
                      return false;
                    } else if (parent.previousSibling && parent.previousSibling.nodeType === ViperUtil.TEXT_NODE) {
                      textNode = parent.previousSibling;
                    } else {
                      ViperUtil.insertBefore(parent, textNode);
                    }
                    range.setStart(textNode, textNode.data.length);
                    range.collapse(true);
                    ViperUtil.remove(parent);
                  }
                  this._viper.contentChanged();
                  return false;
                }
              }
            } else {
              if (range.startContainer.nodeType === ViperUtil.TEXT_NODE) {
                if (range.endContainer.nodeType === ViperUtil.TEXT_NODE) {
                  if (this._deleteFromDifferentBlockParents(range) === false) {
                    return false;
                  }
                  var container = null;
                  var offset = 0;
                  if (range.startOffset === 0) {
                    if (range.endOffset === range.endContainer.data.length) {
                      container = document.createTextNode("");
                      ViperUtil.insertBefore(range.startContainer, container);
                      offset = 0;
                    } else {
                      container = range.endContainer;
                      offset = 0;
                    }
                  } else {
                    container = range.startContainer;
                    offset = range.startOffset;
                  }
                  var self = this;
                  setTimeout(function() {
                    if (container.data.length === 0 && container.parentNode.childNodes.length === 1 && ViperUtil.isBlockElement(container.parentNode) === false) {
                      var parent2 = container.parentNode;
                      ViperUtil.insertBefore(container.parentNode, container);
                      ViperUtil.remove(parent2);
                    }
                    if (ViperUtil.isText(container.previousSibling) === true) {
                      container = container.previousSibling;
                      offset = container.data.length;
                      ViperUtil.normaliseTextNodeSiblings(container);
                    }
                    range.setStart(container, offset);
                    range.collapse(true);
                    ViperSelection.addRange(range);
                  }, 10);
                }
              }
            }
          }
          if (range.collapsed === false) {
            var nodeSelection = range.getNodeSelection();
            if (nodeSelection) {
              if (nodeSelection === this._viper.getViperElement()) {
                ViperUtil.setHtml(nodeSelection, "");
                this._viper.initEditableElement();
              } else if (ViperUtil.inArray(ViperUtil.getTagName(nodeSelection), this._keepContainerList) === true) {
                ViperUtil.setHtml(nodeSelection, "<br/>");
                range.setStart(nodeSelection, 0);
                range.collapse(true);
                ViperSelection.addRange(range);
                this._viper.contentChanged(false, range);
                return false;
              } else {
                var parents = ViperUtil.getSurroundingParents(nodeSelection, null, null, this.viperElement);
                if (parents.length > 0) {
                  var topParent = parents.pop();
                  if (topParent === this._viper.getViperElement()) {
                    if (parents.length > 0) {
                      nodeSelection = parents.pop();
                    }
                  } else {
                    nodeSelection = topParent;
                  }
                }
                range = this._viper.moveCaretAway(nodeSelection);
                ViperUtil.remove(nodeSelection);
                if (range.startContainer.nodeType === ViperUtil.TEXT_NODE && range.startContainer.previousSibling && range.startContainer.previousSibling.nodeType === ViperUtil.TEXT_NODE) {
                  var length = range.startContainer.previousSibling.data.length;
                  var prev = range.startContainer.previousSibling;
                  ViperUtil.remove(range.startContainer);
                  if (prev.data.charAt(length - 1) === " " && range.startContainer.data.charAt(0) === " ") {
                    prev.data += String.fromCharCode(160);
                    if (range.startContainer.data.length > 1) {
                      prev.data += range.startContainer.data.substring(1, range.startContainer.data.length);
                    }
                  } else {
                    prev.data += range.startContainer.data;
                  }
                  range.setStart(prev, length);
                  range.collapse(true);
                  ViperSelection.addRange(range);
                }
              }
              this._viper.contentChanged();
              return false;
            }
          }
          if (this._handleBackspaceAtStartOfLi(e, range) === false) {
            return false;
          }
          if (this._isStartToEndOfMultiContainerSelection(range) === true) {
            return this._removeContentFromStartToEndOfContainers(range);
          }
        },
        _normaliseNextNodes: function(textNode) {
          while (textNode.nextSibling && textNode.nextSibling.nodeType === ViperUtil.TEXT_NODE) {
            if (textNode.nextSibling.data.length > 0) {
              textNode.data += textNode.nextSibling.data;
            }
            ViperUtil.remove(textNode.nextSibling);
          }
        },
        _deleteFromDifferentBlockParents: function(range) {
          if (this._isStartToEndOfMultiContainerSelection(range) === true) {
            return this._removeContentFromStartToEndOfContainers(range);
          }
          var startParent = range.startContainer;
          var endParent = range.endContainer;
          if (ViperUtil.isBlockElement(startParent) === false) {
            startParent = ViperUtil.getFirstBlockParent(range.startContainer);
          }
          if (ViperUtil.isBlockElement(endParent) === false) {
            endParent = ViperUtil.getFirstBlockParent(range.endContainer);
          }
          if (startParent !== endParent) {
            range.deleteContents();
            if (range.startContainer.parentNode && ViperUtil.isEmptyElement(range.startContainer.parentNode) === true) {
              ViperUtil.remove(range.startContainer.parentNode);
            }
            if (ViperUtil.isEmptyElement(endParent) === false) {
              if (ViperUtil.isBlank(ViperUtil.trim(ViperUtil.getHtml(startParent))) !== true || endParent != this._viper.getViperElement()) {
                var nextSelectable = range.getNextContainer(range.startContainer, null, true);
                if (this._viper.isOutOfBounds(nextSelectable) === false) {
                  var nextParent = ViperUtil.getFirstBlockParent(nextSelectable);
                  if (startParent !== nextParent) {
                    while (nextParent.firstChild) {
                      startParent.appendChild(nextParent.firstChild);
                    }
                    if (this.canRemoveNode(nextParent) === true) {
                      ViperUtil.remove(nextParent);
                    }
                  }
                }
              } else {
                ViperUtil.remove(startParent);
              }
            } else {
              ViperUtil.remove(endParent);
            }
            range.collapse(true);
            ViperSelection.addRange(range);
            this._viper.contentChanged();
            return false;
          }
        },
        _handleBackspaceAtStartOfLi: function(e, range) {
          if (e.which === 46 || range.startOffset !== 0) {
            return;
          }
          if (range.collapsed === true && range.startContainer.nodeType === ViperUtil.TEXT_NODE) {
            var firstBlock = ViperUtil.getFirstBlockParent(range.startContainer);
            var firstSelectable = range._getFirstSelectableChild(firstBlock);
            if (firstBlock && ViperUtil.isTag(firstBlock, "li") === true && firstSelectable === range.startContainer && !firstSelectable.previousSibling) {
              var prevSelectable = range.getPreviousContainer(firstSelectable, null, true, true);
              var prevParent = prevSelectable.parentNode;
              if (prevSelectable && this._viper.isOutOfBounds(prevSelectable) === false) {
                while (firstBlock.lastChild) {
                  if (ViperUtil.isText(firstBlock.lastChild) === true && ViperUtil.isBlank(ViperUtil.trim(firstBlock.lastChild.data)) === true && firstBlock.lastChild === firstBlock.firstChild) {
                    if (firstSelectable === firstBlock.lastChild) {
                      firstSelectable = null;
                    }
                    ViperUtil.remove(firstBlock.lastChild);
                    continue;
                  }
                  ViperUtil.insertAfter(prevSelectable, firstBlock.lastChild);
                }
                if (ViperUtil.isTag(prevSelectable, "br") === true) {
                  ViperUtil.remove(prevSelectable);
                }
                var firstBlockParent = firstBlock.parentNode;
                ViperUtil.remove(firstBlock);
                if (ViperUtil.getTag("li", firstBlockParent).length === 0) {
                  ViperUtil.remove(firstBlockParent);
                }
                var offset = 0;
                if (firstSelectable === null) {
                  firstSelectable = range._getLastSelectableChild(prevParent);
                  if (ViperUtil.isText(firstSelectable) === true) {
                    offset = firstSelectable.data.length;
                  }
                }
                range.setStart(firstSelectable, offset);
                range.collapse(true);
                ViperSelection.addRange(range);
                this._viper.contentChanged(true);
                return false;
              } else {
                var defaultTagName = this._viper.getDefaultBlockTag();
                var lastElem = document.createTextNode("");
                var newElement = null;
                ViperUtil.insertBefore(firstBlock.parentNode, lastElem);
                while (firstBlock.firstChild) {
                  var child = firstBlock.firstChild;
                  if (ViperUtil.isTag(child, ["ul", "ol"]) === true) {
                    ViperUtil.insertAfter(lastElem, child);
                    newElement = null;
                    lastElem = child;
                  } else {
                    if (defaultTagName !== "") {
                      if (newElement === null) {
                        newElement = document.createElement(defaultTagName);
                        ViperUtil.insertAfter(lastElem, newElement);
                        lastElem = newElement;
                      }
                      newElement.appendChild(child);
                    } else {
                      ViperUtil.insertAfter(lastElem, child);
                      lastElem = child;
                    }
                  }
                }
                ViperUtil.remove(firstBlock);
                range.setStart(firstSelectable, 0);
                range.collapse(true);
                ViperSelection.addRange(range);
                this._viper.contentChanged(false, range);
                return false;
              }
            }
          } else if (range.collapsed === true && ViperUtil.isTag(range.startContainer, "li") === true && ViperUtil.getHtml(range.startContainer) === "") {
            var offset = 0;
            var next = false;
            var li = range.startContainer;
            var list = li.parentNode;
            var selectable = range.getPreviousContainer(li, null, true, true);
            if (!selectable || this._viper.isOutOfBounds(selectable) === true) {
              selectable = range.getNextContainer(li, null, true, true);
              next = true;
              if (!selectable || this._viper.isOutOfBounds(selectable) === true) {
                var defaultTagName = this._viper.getDefaultBlockTag();
                if (defaultTagName !== "") {
                  selectable = document.createElement(defaultTagName);
                  ViperUtil.setHtml(selectable, "&nbsp;");
                } else {
                  selectable = document.createTextNode(" ");
                }
                ViperUtil.insertAfter(list, selectable);
              }
            } else {
              offset = selectable.data.length;
            }
            if (selectable) {
              range.setStart(selectable, offset);
              range.collapse(true);
              ViperSelection.addRange(range);
            }
            ViperUtil.remove(li);
            if (ViperUtil.getTag("li", list).length === 0) {
              ViperUtil.remove(list);
            }
            this._viper.contentChanged(false, range);
            return false;
          }
        },
        _handleDeleteFromRight: function(e, range) {
          if (range.collapsed !== true) {
            if (this._isStartToEndOfMultiContainerSelection(range) === true) {
              return this._removeContentFromStartToEndOfContainers(range);
            } else {
              var nodeSelection = range.getNodeSelection();
              if (nodeSelection && ViperUtil.isStubElement(nodeSelection) === false) {
                if (ViperUtil.isTag(nodeSelection, "td") === true || ViperUtil.isTag(nodeSelection, "th") === true) {
                  ViperUtil.setHtml(nodeSelection, "<br>");
                  range.setStart(nodeSelection.firstChild);
                  range.collapse(true);
                  ViperSelection.addRange(range);
                } else {
                  range = this._viper.moveCaretAway(nodeSelection, true);
                  ViperUtil.remove(nodeSelection);
                  if (range.startContainer.nodeType === ViperUtil.TEXT_NODE && range.startContainer.data === " " && range.startContainer.previousSibling && range.startContainer.previousSibling.nodeType !== ViperUtil.TEXT_NODE) {
                    range.startContainer.data = String.fromCharCode(160);
                    range.setStart(range.startContainer, range.startContainer.data.length);
                    range.collapse(true);
                    ViperSelection.addRange(range);
                  }
                }
                this._viper.contentChanged();
                return false;
              } else if (!nodeSelection && range.startContainer.nodeType === ViperUtil.TEXT_NODE && range.startOffset === 0 && range.endContainer.nodeType === ViperUtil.TEXT_NODE && range.endOffset === 0 && range.startContainer !== range.endContainer && ViperUtil.getFirstBlockParent(range.startContainer) === ViperUtil.getFirstBlockParent(range.endContainer)) {
                var startContainer = range.startContainer;
                var endContainer = range.endContainer;
                var elemsBetween = ViperUtil.getElementsBetween(startContainer, endContainer);
                elemsBetween.push(startContainer);
                ViperUtil.remove(elemsBetween);
                range.setStart(endContainer, 0);
                range.collapse(true);
                ViperSelection.addRange(range);
                this._viper.contentChanged();
                return false;
              } else if (!nodeSelection && range.startContainer.nodeType === ViperUtil.TEXT_NODE && range.endContainer.nodeType === ViperUtil.TEXT_NODE && range.endOffset === range.endContainer.data.length) {
                var self = this;
                setTimeout(function() {
                  var range2 = self._viper.getViperRange();
                  var node2 = range2.startContainer;
                  var rangeNode = node2.previousSibling;
                  if (node2.nodeType !== ViperUtil.ELEMENT_NODE) {
                    if (node2.nextSibling && node2.nextSibling.nodeType === ViperUtil.ELEMENT_NODE) {
                      rangeNode = node2;
                      node2 = node2.nextSibling;
                    } else {
                      node2 = null;
                    }
                  }
                  if (node2 && node2 && node2.nodeType === ViperUtil.ELEMENT_NODE && !range2._getFirstSelectableChild(node2)) {
                    ViperUtil.remove(node2);
                    range2.setStart(rangeNode, range2.startOffset);
                    range2.collapse(true);
                    ViperSelection.addRange(range2);
                  } else {
                    node2 = range2.getStartNode();
                    if (node2 && ViperUtil.isText(node2) === false && ViperUtil.elementIsEmpty(node2) === true) {
                      var rangeNode = null;
                      var offset = 0;
                      if (ViperUtil.isText(node2.previousSibling) === true) {
                        rangeNode = node2.previousSibling;
                        offset = node2.previousSibling.data.length;
                        if (ViperUtil.isText(node2.nextSibling) === true) {
                          ViperUtil.remove(node2);
                          ViperUtil.normaliseTextNodeSiblings(node2);
                        } else {
                          ViperUtil.remove(node2);
                        }
                      } else if (ViperUtil.isText(node2.nextSibling) === true) {
                        rangeNode = node2.nextSibling;
                        ViperUtil.remove(node2);
                      }
                      range2.setStart(rangeNode, offset);
                      range2.collapse(true);
                      ViperSelection.addRange(range2);
                    }
                  }
                }, 10);
              }
            }
            return;
          }
          var startNode = range.getStartNode();
          if (!startNode) {
            if (!range.startContainer || range.startContainer.nodeType !== ViperUtil.ELEMENT_NODE || range.startContainer !== range.endContainer) {
              return;
            }
            startNode = range.startContainer;
          }
          if (startNode.nodeType === ViperUtil.ELEMENT_NODE) {
            if (range.startContainer === startNode && startNode.childNodes.length === range.startOffset && ViperUtil.isText(startNode.lastChild)) {
              range.setStart(startNode.lastChild, startNode.lastChild.length);
              range.collapse(true);
              ViperSelection.addRange(range);
              startNode = startNode.lastChild;
            }
          }
          if (startNode.nodeType === ViperUtil.TEXT_NODE) {
            if (range.startOffset === startNode.data.length) {
              if (this._viper.isSpecialElement(startNode.nextSibling) === true) {
                ViperUtil.remove(startNode.nextSibling);
                this._viper.contentChanged();
                return false;
              } else if (ViperUtil.isStubElement(ViperUtil.getSurroundedChildren(startNode.nextSibling).pop()) === true) {
                ViperUtil.remove(startNode.nextSibling);
                this._viper.contentChanged();
                return false;
              } else if (ViperUtil.isStubElement(startNode.nextSibling) === true && (ViperUtil.isTag(startNode.nextSibling, "br") === false || startNode.nextSibling.nextSibling)) {
                if (ViperUtil.isStubElement(startNode.nextSibling.nextSibling) === true) {
                  ViperUtil.remove(startNode.nextSibling.nextSibling);
                  this._viper.contentChanged();
                  return false;
                }
                ViperUtil.remove(startNode.nextSibling);
                this._viper.contentChanged();
                return false;
              } else if (!startNode.nextSibling) {
                var nextSelectable = range.getNextContainer(startNode, null, true, true, true);
                if (nextSelectable && this._viper.isSpecialElement(nextSelectable.parentNode) === true) {
                  ViperUtil.remove(nextSelectable.parentNode);
                }
              } else {
                if (ViperUtil.isTag(startNode.nextSibling, "br") === true && !startNode.nextSibling.nextSibling) {
                  ViperUtil.remove(startNode.nextSibling);
                  var selectable = range.getNextContainer(startNode, null, true, true);
                  if (!selectable || this._viper.isOutOfBounds(selectable) === true) {
                    return false;
                  }
                  var firstBlock = ViperUtil.getFirstBlockParent(selectable);
                  if (firstBlock) {
                    var len = startNode.data.length;
                    ViperUtil.moveChildrenToElement(firstBlock, ViperUtil.getFirstBlockParent(startNode), true);
                    ViperUtil.remove(firstBlock);
                    range.setStart(startNode, len);
                    range.collapse(true);
                    ViperSelection.addRange(range);
                    this._viper.contentChanged();
                    return false;
                  }
                }
              }
              var foundSib = false;
              while (startNode) {
                for (var node = startNode.nextSibling; node; node = node.nextSibling) {
                  if (node.nodeType === ViperUtil.ELEMENT_NODE && ViperUtil.isTag(node, "hr") === true) {
                    ViperUtil.remove(node);
                    this._viper.contentChanged();
                    return false;
                  } else if (node.nodeType !== ViperUtil.TEXT_NODE || ViperUtil.trim(node.data).length !== 0) {
                    foundSib = true;
                    break;
                  }
                }
                if (foundSib === true) {
                  break;
                } else if (ViperUtil.isTag(startNode, "td") === true || ViperUtil.isTag(startNode, "th") === true) {
                  return false;
                }
                startNode = startNode.parentNode;
              }
            } else if (range.startContainer !== startNode && range.startOffset === 0) {
              range.setStart(startNode, 0);
            }
          } else {
            var startNodeIsStub = ViperUtil.isStubElement(startNode);
            if (startNodeIsStub === false) {
              var textNode = range._getFirstSelectableChild(startNode);
              if (textNode) {
                range.setStart(textNode, 0);
              }
            } else if (ViperUtil.isTag(startNode, "br") === true && startNode.parentNode && ViperUtil.isBrowser("firefox") === true) {
              var nextSelectable = range.getNextContainer(startNode, null, true, true);
              if (this._viper.isOutOfBounds(nextSelectable) === true) {
                return false;
              }
              if (nextSelectable) {
                var startParent = startNode.parentNode;
                if (startParent.childNodes.length === 1 && ViperUtil.isTag(startNode.parentNode, ["td", "th"]) === false) {
                  ViperUtil.remove(startParent);
                } else {
                  setTimeout(function() {
                    ViperUtil.remove(startNode);
                  }, 100);
                }
                range.setStart(nextSelectable, 0);
                range.collapse(true);
                ViperSelection.addRange(range);
                this._viper.contentChanged();
                return false;
              } else if (startNode.parentNode.childNodes.length === 1) {
                var tmpNode = document.createTextNode("");
                startNode.parentNode.appendChild(tmpNode);
                ViperUtil.remove(startNode);
                range.setStart(tmpNode);
              } else if (startNode.nextSibling && startNode.nextSibling.nodeType === ViperUtil.TEXT_NODE) {
                range.setStart(startNode.nextSibling, 0);
                range.collapse(true);
                ViperUtil.remove(startNode);
                ViperSelection.addRange(range);
                this._viper.contentChanged();
                return false;
              }
            } else if (startNodeIsStub === true) {
              if (!startNode.nextSibling && ViperUtil.isTag(startNode, "br") === true) {
                var nextSelectable = range.getNextContainer(startNode, null, true, true);
                if (!nextSelectable || this._viper.isOutOfBounds(nextSelectable) === true) {
                  return false;
                }
              }
              this._viper.moveCaretAway(startNodeIsStub);
              var surroundingParents = ViperUtil.getSurroundingParents(startNodeIsStub);
              ViperUtil.remove(surroundingParents.pop() || startNode);
            }
          }
          if (ViperUtil.isTag(startNode, "br") === true && (ViperUtil.isTag(startNode.parentNode, "td") === true || ViperUtil.isTag(startNode.parentNode, "th") === true)) {
            return false;
          } else if (ViperUtil.isTag(startNode.parentNode, "li") === true && ViperUtil.getHtml(startNode.parentNode) === "<br>") {
            return false;
          }
          var startContainer = range.startContainer;
          if (startContainer.nodeType !== ViperUtil.TEXT_NODE) {
            var startNode = range.getStartNode();
            if (startNode && startNode.nodeType !== ViperUtil.TEXT_NODE) {
              var nextSelectable = range.getNextContainer(startContainer, null, true, true, true);
              if (nextSelectable) {
                var startParent = range.startContainer;
                var endParent = ViperUtil.getFirstBlockParent(nextSelectable);
                if (ViperUtil.isBlockElement(startParent) === false) {
                  startParent = ViperUtil.getFirstBlockParent(startParent);
                }
                if (startParent !== nextSelectable) {
                  range.setEnd(nextSelectable, 0);
                  this._deleteFromDifferentBlockParents(range);
                  return false;
                }
              }
            }
          }
        },
        _handleDeleteForWebkit: function(e, range) {
          if (this._handleBackspaceAtStartOfLi(e, range) === false) {
            return false;
          }
          var startNode = range.getStartNode();
          var endNode = range.getEndNode();
          if (e.keyCode === 46 && range.collapsed === true && range.startContainer.nodeType === ViperUtil.TEXT_NODE && range.startOffset === range.startContainer.data.length && (!range.startContainer.nextSibling || ViperUtil.isStubElement(range.startContainer.nextSibling) === true)) {
            var nextSelectable = range.getNextContainer(range.startContainer, null, false, true);
            var currentParent = ViperUtil.getFirstBlockParent(range.startContainer);
            var nextParent = ViperUtil.getFirstBlockParent(nextSelectable);
            if (currentParent !== nextParent && this._viper.isOutOfBounds(nextSelectable) === false) {
              if (ViperUtil.isTag(currentParent, "td") === true || ViperUtil.isTag(currentParent, "th") === true) {
                return false;
              }
              if (currentParent.nextSibling !== nextParent && ViperUtil.isStubElement(currentParent.nextSibling) === true) {
                ViperUtil.remove(currentParent.nextSibling);
                this._viper.contentChanged(true);
                return false;
              }
              if (ViperUtil.isTag(currentParent.lastChild, "br") === true) {
                ViperUtil.remove(currentParent.lastChild);
              }
              while (nextParent.firstChild) {
                if (ViperUtil.isText(nextParent.firstChild) !== true && ViperUtil.getTagName(currentParent.lastChild) === ViperUtil.getTagName(nextParent.firstChild)) {
                  ViperUtil.moveChildrenToElement(nextParent.firstChild, currentParent.lastChild, false);
                  ViperUtil.remove(nextParent.firstChild);
                } else {
                  currentParent.appendChild(nextParent.firstChild);
                }
              }
              ViperUtil.remove(nextParent);
              this._viper.contentChanged(true);
              return false;
            }
          }
          if (e.keyCode === 46 && range.collapsed === true && range.startContainer.nodeType === ViperUtil.ELEMENT_NODE && ViperUtil.isTag(range.getStartNode(), "br") === true) {
            var startNode = range.getStartNode();
            if (ViperUtil.isTag(startNode.parentNode, "td") === true || ViperUtil.isTag(startNode.parentNode, "th") === true) {
              if (!startNode.nextSibling) {
                return false;
              }
            }
            var selectable = range.getNextContainer(startNode, null, true, true);
            if (!selectable || this._viper.isOutOfBounds(selectable) === true) {
              return false;
            }
            var parent = startNode.parentNode;
            if (!startNode.nextSibling && !startNode.previousSibling) {
              ViperUtil.remove(startNode.parentNode);
            } else {
              ViperUtil.remove(startNode);
            }
            if (parent.childNodes.length === 0) {
              ViperUtil.remove(parent);
            }
            if (selectable) {
              range.setStart(selectable, 0);
              range.collapse(true);
              ViperSelection.addRange(range);
            }
            this._viper.contentChanged(true);
            return false;
          } else if (e.keyCode === 8 && (range.collapsed === true && range.startContainer.nodeType === ViperUtil.TEXT_NODE && (range.startOffset === 0 || range.startOffset === 1 && range.startContainer.data.charAt(0) === " ") && (ViperUtil.isFirstNonEmptyTextNode(range.startContainer) === true || ViperUtil.isTag(range.startContainer.previousSibling, "br") === true) || ViperUtil.isText(startNode) === false && range.startOffset === 0)) {
            var prevSelectable = range.getPreviousContainer(range.startContainer, null, true, true);
            var currentParent = ViperUtil.getFirstBlockParent(range.startContainer, null, true);
            var prevParent = ViperUtil.getFirstBlockParent(prevSelectable, null, true);
            if (!currentParent) {
              currentParent = range.startContainer;
            }
            if (currentParent && range._getFirstSelectableChild(currentParent) === range.startContainer && currentParent.previousElementSibling && ViperUtil.isStubElement(currentParent.previousElementSibling) === true) {
              ViperUtil.remove(currentParent.previousElementSibling);
              this._viper.contentChanged();
              return false;
            } else if (currentParent !== prevParent && this._viper.isOutOfBounds(prevSelectable) === false) {
              var elemsBetween = ViperUtil.getElementsBetween(prevParent, currentParent);
              var removeParent = true;
              if (elemsBetween.length > 0) {
                for (var i = elemsBetween.length - 1; i >= 0; i--) {
                  var el = elemsBetween[elemsBetween.length - 1];
                  if (el.nodeType !== ViperUtil.TEXT_NODE || ViperUtil.trim(el.data).length !== 0) {
                    if (ViperUtil.isTag(el, "blockquote") !== true && ViperUtil.isTag(prevParent, "p") === true) {
                      removeParent = false;
                    }
                    break;
                  }
                  ViperUtil.remove(el);
                }
              }
              if (removeParent === true) {
                while (currentParent.firstChild) {
                  if (ViperUtil.isText(currentParent.firstChild) !== true && ViperUtil.getTagName(prevParent.lastChild) === ViperUtil.getTagName(currentParent.firstChild)) {
                    ViperUtil.moveChildrenToElement(currentParent.firstChild, prevParent.lastChild, false);
                    ViperUtil.remove(currentParent.firstChild);
                  } else {
                    prevParent.appendChild(currentParent.firstChild);
                  }
                }
                if (ViperUtil.isTag(currentParent, ["td", "th"]) === false) {
                  ViperUtil.remove(currentParent);
                }
                if (prevSelectable.nodeType === ViperUtil.TEXT_NODE) {
                  range.setStart(prevSelectable, prevSelectable.data.length);
                } else if (ViperUtil.isTag(prevSelectable, "br") === true) {
                  if (ViperUtil.isText(prevSelectable.nextSibling) === true) {
                    range.setStart(prevSelectable.nextSibling, 0);
                  } else {
                    range.setStartAfter(prevSelectable);
                  }
                  ViperUtil.remove(prevSelectable);
                } else {
                  range.setStartAfter(prevSelectable);
                }
                range.collapse(true);
                ViperSelection.addRange(range);
              }
              this._viper.contentChanged(true);
              return false;
            } else if (ViperUtil.isTag(prevSelectable, "br") === true) {
              ViperUtil.remove(prevSelectable);
              this._viper.contentChanged(true);
              return false;
            }
          } else if (range.collapsed === false && range.startContainer !== range.endContainer && range.startContainer.nodeType === ViperUtil.TEXT_NODE) {
            var nodeSelection = range.cloneRange().getNodeSelection();
            if (nodeSelection) {
              var nextSelectable = range.getNextContainer(nodeSelection, null, true);
              if (ViperUtil.inArray(ViperUtil.getTagName(nodeSelection), this._keepContainerList) === true) {
                ViperUtil.setHtml(nodeSelection, "<br/>");
                range.setStart(nodeSelection, 0);
                range.collapse(true);
                ViperSelection.addRange(range);
                this._viper.contentChanged(true);
                return false;
              } else if (this._viper.isOutOfBounds(nextSelectable) === true) {
                nextSelectable = range.getPreviousContainer(range.startContainer, null, true);
                if (nextSelectable) {
                  range.setStart(nextSelectable, nextSelectable.data.length);
                }
              } else {
                range.setStart(nextSelectable, 0);
              }
              ViperUtil.remove(nodeSelection);
            } else if (this._isStartToEndOfMultiContainerSelection(range) === true) {
              return this._removeContentFromStartToEndOfContainers(range);
            } else {
              var startParent = ViperUtil.getFirstBlockParent(range.startContainer, null, true);
              var endParent = ViperUtil.getFirstBlockParent(range.endContainer, null, true);
              if (startParent === endParent) {
                this._viper.contentChanged(true);
                return;
              } else {
                if (this._deleteFromDifferentBlockParents(range) === false) {
                  return false;
                }
              }
            }
            range.collapse(true);
            ViperSelection.addRange(range);
            this._viper.contentChanged();
            return false;
          } else if (range.startContainer.nodeType === ViperUtil.ELEMENT_NODE && range.startContainer === range.endContainer && range.startOffset === range.endOffset && range.startOffset === 0) {
            if (ViperUtil.isTag(range.startContainer, "li") === true && ViperUtil.getTag("li", range.startContainer.parentNode).length === 1) {
              this._placeCaretToValidPosition(range.startContainer.parentNode, range.startContainer.parentNode);
              ViperUtil.remove(range.startContainer.parentNode);
              this._viper.contentChanged();
              return false;
            }
          } else if (range.collapsed === false && range.getNodeSelection()) {
            var nodeSelection = range.getNodeSelection();
            if (nodeSelection && ViperUtil.isStubElement(nodeSelection) === false && ViperUtil.isTag(nodeSelection, "td") === false && ViperUtil.isTag(nodeSelection, "th") === false) {
              var surroundingParents = ViperUtil.getSurroundingParents(nodeSelection);
              if (surroundingParents.length > 0) {
                nodeSelection = surroundingParents.pop();
              }
              range = this._viper.moveCaretAway(nodeSelection, nodeSelection.previousSibling !== null);
              ViperUtil.remove(nodeSelection);
              ViperSelection.addRange(range);
              if (range.startContainer.nodeType === ViperUtil.TEXT_NODE && range.startContainer.data === " " && range.startContainer.previousSibling && range.startContainer.previousSibling.nodeType !== ViperUtil.TEXT_NODE) {
                range.startContainer.data = String.fromCharCode(160);
                range.setStart(range.startContainer, range.startContainer.data.length);
                range.collapse(true);
                ViperSelection.addRange(range);
              } else if (range.startContainer.nodeType === ViperUtil.TEXT_NODE && range.startContainer.previousSibling && range.startContainer.previousSibling.nodeType === ViperUtil.TEXT_NODE) {
                var length = range.startContainer.previousSibling.data.length;
                var prev = range.startContainer.previousSibling;
                ViperUtil.remove(range.startContainer);
                if (prev.data.charAt(length - 1) === " " && range.startContainer.data.charAt(0) === " ") {
                  prev.data += String.fromCharCode(160);
                  if (range.startContainer.data.length > 1) {
                    prev.data += range.startContainer.data.substring(1, range.startContainer.data.length);
                  }
                } else {
                  prev.data += range.startContainer.data;
                }
                range.setStart(prev, length);
                range.collapse(true);
                ViperSelection.addRange(range);
              } else if (!range.startContainer.nextSibling && ViperUtil.isBlockElement(range.startContainer.parentNode) === true && ViperUtil.endsWithSpace(range.startContainer, false) === true) {
                ViperUtil.replaceCharAt(range.startContainer, "last", String.fromCharCode(160));
                range.setStart(range.startContainer, range.startContainer.data.length);
                range.collapse(true);
                ViperSelection.addRange(range);
              }
              this._viper.contentChanged();
              return false;
            }
          }
          if (e.keyCode === 8) {
            if (range.collapsed === true) {
              if (range.startContainer.nodeType === ViperUtil.TEXT_NODE) {
                if (this._viper.isSpecialElement(range.startContainer.parentNode) === true) {
                  var prevSib = range.startContainer.parentNode.previousSibling;
                  ViperUtil.remove(range.startContainer.parentNode);
                  if (ViperUtil.isText(prevSib) === true) {
                    var info = ViperUtil.normaliseTextNodeSiblings(prevSib);
                    range.setStart(info.textNode, info.splitOffset);
                    range.collapse(true);
                    ViperSelection.addRange(range);
                  }
                  this._viper.contentChanged();
                  return false;
                } else if (range.startOffset === 1) {
                  var textNode = range.startContainer;
                  textNode.data = textNode.data.substr(0, range.startOffset - 1) + textNode.data.substr(range.startOffset);
                  this._normaliseNextNodes(textNode);
                  if (textNode.data.length === 0 && textNode.nextSibling === null && textNode.previousSibling === null) {
                    if (ViperUtil.isBlockElement(textNode.parentNode) === true) {
                      var br = document.createElement("br");
                      textNode.parentNode.appendChild(br);
                      range.selectNode(br);
                      range.collapse(true);
                      ViperSelection.addRange(range);
                    } else if (textNode.parentNode.previousSibling && textNode.parentNode.previousSibling.nodeType === ViperUtil.TEXT_NODE) {
                      var parent = textNode.parentNode;
                      textNode = textNode.parentNode.previousSibling;
                      ViperUtil.remove(parent);
                      if (textNode.data.charAt(textNode.data.length - 1) === " ") {
                        textNode.data = textNode.data.substr(0, textNode.data.length - 1) + String.fromCharCode(160);
                      }
                      range.setStart(textNode, textNode.data.length);
                      range.collapse(true);
                      ViperSelection.addRange(range);
                    }
                  } else {
                    if (!textNode.nextSibling && !textNode.prevSibling && ViperUtil.isBlockElement(textNode.parentNode) === true) {
                      ViperUtil.insertAfter(textNode, document.createElement("br"));
                    }
                    range.setStart(textNode, range.startOffset - 1);
                    range.collapse(true);
                    ViperSelection.addRange(range);
                  }
                  this._viper.contentChanged();
                  return false;
                } else if (range.startOffset === 0) {
                  if (this._viper.isSpecialElement(range.startContainer.previousSibling) === true) {
                    ViperUtil.remove(range.startContainer.previousSibling);
                    this._viper.fireNodesChanged();
                    return false;
                  }
                } else if (range.startOffset === range.startContainer.data.length) {
                  if (ViperUtil.isText(range.startContainer.nextSibling) === true && ViperUtil.isBrowser("safari") === true) {
                    var ln = range.startContainer.data.length - 1;
                    range.startContainer.data = range.startContainer.data.substr(0, ln);
                    range.setStart(range.startContainer, ln);
                    range.collapse(true);
                    ViperSelection.addRange(range);
                    this._viper.fireNodesChanged();
                    return false;
                  }
                }
              } else {
                var startNode = range.getStartNode();
                if (ViperUtil.isStubElement(startNode) === true) {
                  if (ViperUtil.isTag(startNode, "br") === true) {
                    var surroundingParents = ViperUtil.getSurroundingParents(startNode);
                    if (surroundingParents.length > 0) {
                      range = this._viper.moveCaretAway(startNode, true);
                      var parentToRemove = surroundingParents.pop();
                      if (range) {
                        var newStartNode = range.getStartNode();
                        if (ViperUtil.isTag(newStartNode, "br") === true && ViperUtil.isText(newStartNode.previousSibling, true) === true) {
                          range.setStart(newStartNode.previousSibling, newStartNode.previousSibling.data.length);
                          range.collapse(true);
                          ViperSelection.addRange(range);
                          ViperUtil.remove(newStartNode);
                        }
                      }
                      ViperUtil.remove(parentToRemove);
                    }
                  }
                  ViperUtil.remove(startNode);
                  this._viper.fireNodesChanged();
                  return false;
                } else if (ViperUtil.isText(startNode) === true) {
                  if (ViperUtil.startsWithSpace(startNode) === true) {
                    if (ViperUtil.isTag(startNode.previousSibling, "br") === true) {
                      ViperUtil.remove(startNode.previousSibling);
                      var info = ViperUtil.normaliseTextNodeSiblings(startNode);
                      range.setStart(info.textNode, info.splitOffset);
                      range.collapse(true);
                      ViperSelection.addRange(range);
                      this._viper.fireNodesChanged();
                      return false;
                    }
                  }
                }
              }
            }
          } else {
            if (range.collapsed === true) {
              var startContainer = range.startContainer;
              if (startContainer.nodeType === ViperUtil.TEXT_NODE) {
                if (range.startOffset === 0) {
                  if (startContainer.data.length === 2 && startContainer.data.charAt(1) === " ") {
                    startContainer.data = String.fromCharCode(160);
                    range.setStart(startContainer, 0);
                    range.collapse(true);
                    ViperSelection.addRange(range);
                    this._viper.contentChanged();
                    return false;
                  } else if (startContainer.data.length === 0) {
                    if (this._viper.isSpecialElement(startContainer.nextSibling) === true) {
                      ViperUtil.remove(startContainer.nextSibling);
                      this._viper.contentChanged(true);
                      return false;
                    }
                  }
                } else if (range.startOffset === startContainer.data.length) {
                  if (this._viper.isSpecialElement(startContainer.nextSibling) === true) {
                    ViperUtil.remove(startContainer.nextSibling);
                    this._viper.contentChanged(true);
                    return false;
                  } else if (!startContainer.nextSibling) {
                    var nextSelectable = range.getNextContainer(startContainer, null, true, true, true);
                    if (nextSelectable && this._viper.isSpecialElement(nextSelectable.parentNode) === true) {
                      ViperUtil.remove(nextSelectable.parentNode);
                      this._viper.contentChanged(true);
                      return false;
                    }
                  } else if (ViperUtil.isStubElement(range.startContainer.nextSibling) === true) {
                    if (ViperUtil.isStubElement(range.startContainer.nextSibling.nextSibling) === true) {
                      ViperUtil.remove(range.startContainer.nextSibling.nextSibling);
                      this._viper.contentChanged();
                      return false;
                    }
                    ViperUtil.remove(range.startContainer.nextSibling);
                    this._viper.contentChanged();
                    return false;
                  }
                } else if (range.startOffset - 1 === ViperUtil.rtrim(startContainer.data).length && startContainer.data.length !== ViperUtil.rtrim(startContainer.data).length && this._viper.isSpecialElement(startContainer.nextSibling) === true) {
                  ViperUtil.remove(startContainer.nextSibling);
                  range.setStart(startContainer, startContainer.data.length);
                  range.collapse(true);
                  ViperSelection.addRange(range);
                  this._viper.contentChanged();
                  return false;
                }
              } else {
                var startNode = range.getStartNode();
                if (startNode && startNode.nodeType !== ViperUtil.TEXT_NODE) {
                  var nextSelectable = range.getNextContainer(startContainer, null, true, true, true);
                  if (ViperUtil.isStubElement(startNode) === true) {
                    var parents = ViperUtil.getSurroundingParents(startNode);
                    if (parents.length > 0) {
                      startNode = parents.pop();
                    }
                    ViperUtil.remove(startNode);
                    this._viper.contentChanged();
                    return false;
                  }
                  if (nextSelectable) {
                    var startParent = range.startContainer;
                    var endParent = ViperUtil.getFirstBlockParent(nextSelectable);
                    if (ViperUtil.isBlockElement(startParent) === false) {
                      startParent = ViperUtil.getFirstBlockParent(startParent);
                    }
                    if (startParent !== nextSelectable) {
                      range.setEnd(nextSelectable, 0);
                      this._deleteFromDifferentBlockParents(range);
                      return false;
                    }
                  }
                }
              }
            }
          }
        },
        _placeCaretToValidPosition: function(startNode, endNode) {
          var range = this._viper.getCurrentRange();
          var newOffset = 0;
          var newSelContainer = range.getNextContainer(endNode, null, true);
          if (!newSelContainer || this._viper.isOutOfBounds(newSelContainer) === true) {
            newSelContainer = range.getPreviousContainer(startNode, null, true);
            if (!newSelContainer || this._viper.isOutOfBounds(newSelContainer) === true) {
              var defaultTagName = this._viper.getDefaultBlockTag();
              newSelContainer = document.createElement("br");
              if (defaultTagName === "") {
                ViperUtil.insertAfter(endNode, newSelContainer);
              } else {
                var newElem = document.createElement(defaultTagName);
                newElem.appendChild(newSelContainer);
                ViperUtil.insertAfter(endNode, newElem);
              }
            } else {
              newOffset = newSelContainer.data.length;
            }
          }
          if (newSelContainer) {
            range.setStart(newSelContainer, newOffset);
            range.collapse(true);
            ViperSelection.addRange(range);
          }
        },
        splitAtRange: function(returnFirstBlock, range) {
          range = range || this._viper.getViperRange();
          var selectedNode = range.getNodeSelection();
          if (selectedNode && selectedNode.nodeType === ViperUtil.ELEMENT_NODE) {
            selectedNode.innerHTML = "&nbsp;";
            return selectedNode;
          }
          if (range.collapsed !== true) {
            if (ViperUtil.isBrowser("chrome") === true || ViperUtil.isBrowser("safari") === true) {
              range.deleteContents();
              ViperSelection.addRange(range);
            } else {
              this._viper.deleteRangeContent();
              ViperSelection.addRange(this._viper.getCurrentRange());
              range = this._viper.getViperRange();
            }
          }
          if (range.startContainer.nodeType === ViperUtil.TEXT_NODE) {
            var parent = range.startContainer.parentNode;
            if (parent === this._viper.getViperElement()) {
              var newNode = range.startContainer;
              if (range.startOffset !== 0 && range.startOffset !== range.startContainer.data.length) {
                newNode = range.startContainer.splitText(range.startOffset);
                ViperUtil.insertBefore(newNode, document.createElement("br"));
                return range.startContainer.nextSibling;
              } else if (range.startOffset === 0) {
                if (range.previousSibling && ViperUtil.isTag(range.previousSibling, "br") === true) {
                  ViperUtil.remove(range.previousSibling);
                }
                return range.startContainer.previousSibling;
              } else {
                return range.startContainer;
              }
            }
            var blockQuote = ViperUtil.getParents(range.startContainer, "blockquote", this._viper.element);
            while (parent) {
              if (ViperUtil.isBlockElement(parent) === true) {
                if (blockQuote.length === 0 || ViperUtil.isTag(parent, "blockquote") === true) {
                  break;
                }
              }
              if (parent.parentNode && parent.parentNode === this._viper.element) {
                break;
              }
              parent = parent.parentNode;
            }
          } else if (range.startContainer === range.endContainer && ViperUtil.isStubElement(range.startContainer) && range.startContainer.parentNode.firstChild === range.startContainer && range.startContainer.parentNode.lastChild === range.startContainer) {
            parent = range.startContainer.parentNode;
            ViperUtil.setHtml(parent, "&nbsp;");
            range.setStart(parent.firstChild, 0);
            range.collapse(true);
          } else {
            parent = range.startContainer;
          }
          var tag = parent.tagName.toLowerCase();
          if (ViperUtil.isChildOf(parent, this._viper.element) === false) {
            var node = range.endContainer;
            while (ViperUtil.isset(node.nextSibling) === true) {
              if (ViperUtil.isBlockElement(node.nextSibling) === true) {
                break;
              }
              node = node.nextSibling;
            }
            range.setEndAfter(node);
            var elem = Viper2.document.createElement("p");
            var docFrag = range.extractContents("p");
            this._viper.deleteRangeContent();
            elem.appendChild(docFrag);
            ViperUtil.insertAfter(range.startContainer, elem);
            range.collapse(true);
            node = range.startContainer;
            while (ViperUtil.isset(node.previousSibling) === true) {
              if (ViperUtil.isBlockElement(node.previousSibling) === true) {
                break;
              }
              node = node.previousSibling;
            }
            range.setStartBefore(node);
            var felem = Viper2.document.createElement("p");
            docFrag = range.extractContents("p");
            felem.appendChild(docFrag);
            ViperUtil.insertBefore(elem, felem);
            if (!elem.firstChild) {
              elem.appendChild(document.createTextNode(""));
            }
            range.setStart(elem.firstChild, 0);
            range.collapse(true);
            return;
          } else if (tag === "pre") {
            this.insertTextAtRange(range, "\n");
            return false;
          } else if (tag === "td" || tag === "th") {
            var bookmark = this._viper.createBookmark(range);
            var p = Viper2.document.createElement("P");
            while (parent.firstChild) {
              p.appendChild(parent.firstChild);
            }
            parent.appendChild(p);
            tag = "p";
            parent = p;
            range = this._viper.selectBookmark(bookmark);
          }
          if (range.startContainer.nodeType === ViperUtil.TEXT_NODE && range.startOffset === range.startContainer.data.length) {
            if (!range.startContainer.nextSibling) {
              var newTextNode = Viper2.document.createTextNode("");
              ViperUtil.insertAfter(range.startContainer.parentNode, newTextNode);
              range.setEnd(newTextNode, 0);
              range.collapse(false);
            }
          }
          try {
            range.setEndAfter(parent.lastChild);
          } catch (e) {
          }
          ViperSelection.addRange(range);
          var elem = parent.cloneNode(false);
          var docFrag = range.extractContents(tag);
          elem.appendChild(docFrag);
          var elemClone = ViperUtil.cloneNode(elem);
          if (ViperUtil.isBlank(ViperUtil.getNodeTextContent(elemClone)) === true) {
            elem = null;
          }
          if (elem === null || elem.tagName && elem.tagName.toLowerCase() !== "li" && ViperUtil.isBlockElement(elem) === false) {
            var newTag = this._viper.getDefaultBlockTag();
            if (tag === "li") {
              newTag = tag;
            }
            var pelem = Viper2.document.createElement(newTag);
            if (elem !== null) {
              pelem.appendChild(elem);
            } else {
              ViperUtil.setHtml(pelem, "&nbsp;");
            }
            elem = pelem;
          }
          if (ViperUtil.elementIsEmpty(parent) === true) {
            ViperUtil.setHtml(parent, "&nbsp;");
          }
          ViperUtil.insertAfter(parent, elem);
          try {
            range.setStart(elem, 0);
            range.setStart(elem, 0);
            range.moveStart("character", 1);
            range.moveStart("character", -1);
          } catch (e) {
          }
          range.collapse(true);
          ViperSelection.addRange(range);
          if (ViperUtil.isBlockElement(parent) === true && ViperUtil.trim(ViperUtil.getHtml(parent)) === "") {
            ViperUtil.setHtml(parent, "&nbsp;");
          } else {
            var lastSelectable = range._getLastSelectableChild(parent);
            if (ViperUtil.isText(lastSelectable) === true && lastSelectable.nextSibling === null && ViperUtil.isBlockElement(lastSelectable.parentNode) === true) {
              ViperUtil.insertAfter(lastSelectable, document.createElement("br"));
            }
          }
          if (returnFirstBlock === true) {
            return parent;
          }
          return false;
        },
        /**
         * Handles shift + enter.
         *
         * Creates a new BR tag at the position of the caret. If the caret is inside a
         * PRE tag then it will create a new P tag and move the caret inside the P tag.
         *
         * @return {boolean} False when it modified the content to prevent event bubbling.
         */
        handleSoftEnter: function(e) {
          if (e) {
            var range = this._viper.getCurrentRange();
            var startNode = range.getStartNode();
            if (startNode && ViperUtil.isTag(ViperUtil.getFirstBlockParent(startNode), "pre") === true) {
              this.insertTextAtRange(range, "\n");
              this._viper.contentChanged();
              return false;
            }
          }
          var node = Viper2.document.createElement("br");
          this._viper.insertNodeAtCaret(node);
          if (ViperUtil.isTag(node.previousSibling, "br") === true) {
            this._viper.insertAfter(node.previousSibling, this._viper.createSpaceNode());
          } else if (!node.nextSibling && ViperUtil.isBlockElement(node.parentNode) === false) {
            ViperUtil.insertAfter(node.parentNode, node);
          } else if (!node.previousSibling && ViperUtil.isText(node.nextSibling) === true) {
            ViperUtil.insertBefore(node.parentNode, node);
          }
          this._viper.contentChanged();
          return !this._viper.setCaretAfterNode(node);
        },
        _isWholeViperElementSelected: function(range) {
          return this._viper.isWholeViperElementSelected(range);
        },
        _isStartToEndOfMultiContainerSelection: function(range) {
          var nodeSelection = range.getNodeSelection();
          if (nodeSelection) {
            return false;
          }
          if (range.startOffset === 0 && range.collapsed === false && range.startContainer !== range.endContainer && range.startContainer.nodeType === ViperUtil.TEXT_NODE && range.endContainer.nodeType === ViperUtil.TEXT_NODE && range.endOffset === range.endContainer.data.length) {
            var startParent = ViperUtil.getFirstBlockParent(range.startContainer);
            var endParent = ViperUtil.getFirstBlockParent(range.endContainer);
            var firstSelectable = range._getFirstSelectableChild(startParent);
            var lastSelectable = range._getLastSelectableChild(endParent);
            if (firstSelectable === range.startContainer && lastSelectable === range.endContainer) {
              return true;
            }
          }
          return false;
        },
        _removeContentFromStartToEndOfContainers: function(range) {
          var startParent = ViperUtil.getFirstBlockParent(range.startContainer);
          var endParent = ViperUtil.getFirstBlockParent(range.endContainer);
          var defaultTagName = this._viper.getDefaultBlockTag();
          var common = ViperUtil.getCommonAncestor(startParent, endParent);
          if (common && (ViperUtil.isTag(common, "ul") === true || ViperUtil.isTag(common, "ol") === true)) {
            defaultTagName = "li";
          }
          if (defaultTagName !== "") {
            var p = document.createElement(defaultTagName);
            ViperUtil.setHtml(p, "<br />");
            ViperUtil.insertBefore(startParent, p);
            ViperUtil.remove(ViperUtil.getElementsBetween(startParent, endParent));
            ViperUtil.remove(startParent);
            ViperUtil.remove(endParent);
            if ((ViperUtil.isTag(p.parentNode, "ul") === true || ViperUtil.isTag(p.parentNode, "ol") === true) && !p.nextSibling) {
              ViperUtil.insertAfter(p.parentNode, p);
            }
            range.setStart(p, 0);
            range.collapse(true);
          } else {
            var br = document.createElement("br");
            var sibling = startParent.previousSibling;
            while (sibling && sibling.nodeType === ViperUtil.TEXT_NODE && ViperUtil.trim(sibling.data) === "") {
              ViperUtil.remove(sibling);
              sibling = sibling.previousSibling;
            }
            ViperUtil.insertBefore(startParent, br);
            ViperUtil.remove(ViperUtil.getElementsBetween(startParent, endParent));
            ViperUtil.remove(startParent);
            ViperUtil.remove(endParent);
            range.setStart(br, 0);
            range.collapse(true);
          }
          ViperSelection.addRange(range);
          this._viper.contentChanged(true);
          return false;
        },
        insertTextAtRange: function(range, text) {
          var node = range.startContainer;
          if (node.nodeType === ViperUtil.TEXT_NODE) {
            var newNode = node.splitText(range.startOffset);
            ViperUtil.insertBefore(newNode, document.createTextNode(text));
          } else {
            node = range.startContainer.childNodes[range.startOffset];
            if (node.nodeType === ViperUtil.TEXT_NODE) {
              var newNode = node.splitText(range.startOffset);
              ViperUtil.insertBefore(newNode, document.createTextNode(text));
            } else {
              newNode = document.createTextNode(text);
              ViperUtil.insertAfter(node, newNode);
            }
          }
          if (newNode.data.length === 0) {
            newNode.data = " ";
          }
          range.setStart(newNode, 0);
          range.collapse(true);
          ViperSelection.addRange(range);
        },
        canRemoveNode: function(node) {
          if (ViperUtil.inArray(ViperUtil.getTagName(node), this._keepContainerList) === true) {
            return false;
          }
          return true;
        },
        cleanPreTags: function() {
          var preTags = ViperUtil.getTag("pre", this._viper.getViperElement());
          var c = preTags.length;
          var bookmark = null;
          var range = this._viper.getViperRange();
          var nodeSelection = range.getNodeSelection();
          if (!nodeSelection) {
            bookmark = this._viper.createBookmark();
          }
          for (var i = 0; i < c; i++) {
            this.cleanPreTag(preTags[i]);
          }
          if (!nodeSelection) {
            this._viper.selectBookmark(bookmark);
          } else {
            range.selectNode(nodeSelection);
          }
        },
        cleanPreTag: function(pre) {
          if (!pre) {
            return;
          }
          var elems = ViperUtil.getTag("p,div", pre);
          var c = elems.length;
          for (var i = 0; i < c; i++) {
            var elem = elems[i];
            while (elem.firstChild) {
              ViperUtil.insertBefore(elem, elem.firstChild);
            }
            ViperUtil.insertBefore(elem, document.createTextNode("\n\n"));
            ViperUtil.remove(elem);
          }
          var elems = ViperUtil.getTag("br", pre);
          var c = elems.length;
          for (var i = 0; i < c; i++) {
            var elem = elems[i];
            ViperUtil.insertBefore(elem, document.createTextNode("\n"));
            ViperUtil.remove(elem);
          }
        },
        isEmptyBlockElement: function(element) {
          if (ViperUtil.isBlockElement(element) === false) {
            return false;
          }
          return ViperUtil.isEmptyElement(element);
        },
        splitList: function(li) {
          var list = li.parentNode;
          if (ViperUtil.isTag(li.nextElementSibling, "li") === true) {
            var listType = ViperUtil.getTagName(list);
            var newList = document.createElement(listType);
            ViperUtil.insertAfter(list, newList);
            while (li.nextSibling) {
              newList.appendChild(li.nextSibling);
            }
          }
          if (ViperUtil.trim(ViperUtil.getNodeTextContent(li)) === "") {
            ViperUtil.remove(li);
          }
          var defaultTagName = this._viper.getDefaultBlockTag();
          var elem = null;
          if (defaultTagName === "") {
            elem = document.createElement("br");
          } else {
            elem = document.createElement(defaultTagName);
          }
          ViperUtil.insertAfter(list, elem);
          if (defaultTagName !== "") {
            elem.appendChild(document.createElement("br"));
          }
          var range = this._viper.getViperRange();
          range.setStart(elem, 0);
          range.collapse(true);
          ViperSelection.addRange(range);
        }
      };
    };
  }
});

// src/Plugins/ViperCopyPastePlugin/ViperCopyPastePlugin.js
var ViperCopyPastePlugin_exports = {};
__export(ViperCopyPastePlugin_exports, {
  registerPlugin: () => registerPlugin10
});
var registerPlugin10;
var init_ViperCopyPastePlugin = __esm({
  "src/Plugins/ViperCopyPastePlugin/ViperCopyPastePlugin.js"() {
    "use strict";
    init_find();
    init_removeAttr();
    init_removeElement();
    registerPlugin10 = (Viper2) => {
      const { Util: ViperUtil, Selection: ViperSelection, _ } = Viper2;
      function ViperCopyPastePlugin(viper) {
        this.viper = viper;
        this.pasteElement = null;
        this.pasteValue = null;
        this.rangeObj = null;
        this.pasteType = "formatted";
        this.cutType = "formatted";
        this.allowedTags = "table|tr|td|th|ul|li|ol|br|p|a|img|form|input|select|option";
        this.convertTags = null;
        this._tmpNode = null;
        this._tmpNodeOffset = 0;
        this._iframe = null;
        this._toolbarElement = null;
        this._selectedRows = null;
        this._pasteProcess = 0;
        this._isRightClick = false;
        this._aggressiveMode = true;
      }
      Viper2.PluginManager.addPlugin("ViperCopyPastePlugin", ViperCopyPastePlugin);
      ViperCopyPastePlugin.prototype = {
        init: function() {
          var self = this;
          this.viper.registerCallback("Viper:editableElementChanged", "ViperCopyPastePlugin", function() {
            self._init();
          });
          this.viper.registerCallback(
            ["Viper:dropped:text/html", "Viper:dropped:Text"],
            "ViperCopyPastePlugin",
            function(data) {
              if (!data.data) {
                return;
              }
              var bookmark = null;
              if (data.origRange.collapsed === false) {
                bookmark = self.viper.createBookmark(data.origRange);
              }
              ViperSelection.addRange(data.range);
              var div = document.createElement("div");
              ViperUtil.setHtml(div, data.data);
              if (bookmark) {
                self.viper.removeBookmark(bookmark);
              }
              self._beforePaste(data.range);
              if (self._bookmark) {
                self._insertTmpNodeBeforeBookmark(self._bookmark);
              }
              self._handleFormattedPasteValue(false, div);
              return false;
            }
          );
          this.viper.registerCallback(["Viper:rightMouseDown", "Viper:mouseDown"], "ViperCopyPastePlugin", function(data) {
            if (data.which === 3) {
              self._isRightClick = true;
            } else {
              self._isRightClick = false;
            }
            self._pasteProcess = 0;
          });
        },
        setSettings: function(settings) {
          if (ViperUtil.isset(settings.pasteType) === true) {
            this.pasteType = settings.pasteType;
          }
          if (ViperUtil.isset(settings.cutType) === true) {
            this.cutType = settings.cutType;
          }
          if (ViperUtil.isset(settings.allowedTags) === true) {
            this.allowedTags = settings.allowedTags;
          }
          if (ViperUtil.isset(settings.convertTags) === true) {
            this.convertTags = settings.convertTags;
          }
          if (ViperUtil.isset(settings.aggressiveMode) === true) {
            this._aggressiveMode = settings.aggressiveMode;
          }
        },
        _init: function() {
          var elem = this.viper.getViperElement();
          if (!elem) {
            return;
          }
          var self = this;
          elem.onpaste = function(e) {
            if (!e.clipboardData) {
              return;
            }
            var dataType = null;
            if (e.clipboardData.types) {
              if (ViperUtil.inArray("text/html", e.clipboardData.types) === true && e.clipboardData.getData("text/html").length !== 0) {
                dataType = "text/html";
              } else if (ViperUtil.inArray("text/plain", e.clipboardData.types) === true && e.clipboardData.getData("text/plain").length !== 0) {
                dataType = "text/plain";
              }
            }
            self._beforePaste();
            if (self.pasteType === "formatted" || self.pasteType === "formattedClean") {
              if (dataType === null) {
                dataType = "text/html";
              }
              var files = ViperUtil.arraySearch("Files", e.clipboardData.types);
              self.pasteElement = self._createPasteDiv();
              var pasteContent = e.clipboardData.getData(dataType);
              if (dataType === "text/plain") {
                pasteContent = pasteContent.replace(/\r\n/g, "<br />");
                pasteContent = pasteContent.replace(/\n/g, "<br />");
              } else if (files === 0) {
                var file = e.clipboardData.items[files];
                var blob = file.getAsFile();
                self.readPastedImage(blob, function() {
                  var base64 = event.target.result;
                  pasteContent = '<img src="' + base64 + '"/>';
                  ViperUtil.setHtml(self.pasteElement, pasteContent);
                  self._handleFormattedPasteValue(self.pasteType === "formattedClean");
                });
                ViperUtil.preventDefault(e);
                return false;
              }
              ViperUtil.setHtml(self.pasteElement, pasteContent);
              self._handleFormattedPasteValue(self.pasteType === "formattedClean");
            } else {
              if (dataType === null) {
                dataType = "text";
              } else {
                dataType = "text/plain";
              }
              self._handleRawPasteValue(e.clipboardData.getData(dataType));
            }
            ViperUtil.preventDefault(e);
            return false;
          };
          var onCopy = function(e) {
            var yCoord = null;
            var range = self.viper.getViperRange();
            var rangeClone = range.cloneRange();
            var selectedContent = "";
            var selectedNode = range.getNodeSelection();
            var viperElem = self.viper.getViperElement();
            if (selectedNode && selectedNode !== viperElem) {
              var surroundingParents = ViperUtil.getSurroundingParents(selectedNode, null, false, viperElem);
              if (surroundingParents.length > 0) {
                selectedNode = surroundingParents.pop();
              }
              var tmp = document.createElement("div");
              tmp.appendChild(selectedNode.cloneNode(true));
              selectedContent = ViperUtil.getHtml(tmp);
            } else {
              selectedContent = range.getHTMLContents();
            }
            selectedContent = self._fixPartialSelection(selectedContent, range);
            selectedContent = '<div class="__viper_copy">' + selectedContent + "</div>";
            if (ViperUtil.isBrowser("chrome") === true || ViperUtil.isBrowser("safari") === true) {
              e.clipboardData.setData("text", range.rangeObj.toString());
              e.clipboardData.setData("text/html", selectedContent);
              ViperUtil.preventDefault(e);
              return false;
            }
            var tmp = document.createElement("div");
            tmp.setAttribute("contenteditable", "true");
            ViperUtil.addClass(tmp, "Viper-copyDiv");
            document.body.appendChild(tmp);
            ViperUtil.setHtml(tmp, selectedContent);
            if (yCoord !== null) {
              ViperUtil.setStyle(tmp, "top", yCoord + "px");
            }
            var firstChild = range._getFirstSelectableChild(tmp);
            var lastChild = range._getLastSelectableChild(tmp);
            if (tmp.lastChild.nodeType === ViperUtil.ELEMENT_NODE) {
              tmp.appendChild(document.createTextNode(""));
              range.setEnd(tmp.lastChild, 0);
            } else {
              range.setEnd(lastChild, lastChild.data.length);
            }
            if (firstChild === null) {
              range.setStart(tmp.firstChild, 0);
            } else if (tmp.firstChild.nodeType === ViperUtil.ELEMENT_NODE) {
              ViperUtil.insertBefore(firstChild, document.createTextNode(""));
              range.setStart(tmp.firstChild, 0);
            } else {
              range.setStart(firstChild, 0);
            }
            ViperSelection.addRange(range);
            setTimeout(function() {
              ViperUtil.remove(tmp);
              ViperSelection.addRange(rangeClone);
            }, 0);
          };
          elem.oncopy = onCopy;
          elem.oncut = function(e) {
            onCopy(e);
            setTimeout(function() {
              var fakeEvent = self._getFakeKeyboardEvent();
              if (self.viper.getKeyboardHandler().handleDelete(fakeEvent) !== false || fakeEvent.prevent !== true) {
                const range = self.viper.getCurrentRange();
                range.deleteContents(self.viper.getViperElement(), self.viper.getDefaultBlockTag());
                ViperSelection.addRange(range);
              }
              self.viper.fireCallbacks("Viper:cut");
              self.viper.contentChanged();
            }, 5);
          };
          if (ViperUtil.isBrowser("chrome") === true || ViperUtil.isBrowser("safari") === true) {
            ViperUtil.addEvent(elem, "drop." + self.viper.getEventNamespace(), function(e) {
              var selectedContent = "";
              var rangeClone = self.viper.getCurrentRange().cloneRange();
              var selectedNode = rangeClone.getNodeSelection();
              if (selectedNode && selectedNode !== elem) {
                var surroundingParents = ViperUtil.getSurroundingParents(selectedNode, null, false, elem);
                if (surroundingParents.length > 0) {
                  selectedNode = surroundingParents.pop();
                }
                var tmp = document.createElement("div");
                tmp.appendChild(selectedNode.cloneNode(true));
                selectedContent = ViperUtil.getHtml(tmp);
              } else {
                selectedContent = rangeClone.getHTMLContents();
              }
              if (!selectedContent) {
                return;
              }
              selectedContent = self._fixPartialSelection(selectedContent, rangeClone);
              var bookmark = null;
              if (!selectedNode) {
                bookmark = self.viper.createBookmark(rangeClone);
              }
              var rangeObj = document.caretRangeFromPoint(e.clientX, e.clientY);
              var range = new Viper2.MozRange(rangeObj);
              self._tmpNode = document.createTextNode(" ");
              range.insertNode(self._tmpNode);
              range.setStart(self._tmpNode, 0);
              range.collapse(true);
              ViperSelection.addRange(range);
              self._pasteContent(selectedContent, false, true);
              if (selectedNode && selectedNode !== self.viper.getViperElement()) {
                ViperUtil.remove(selectedNode);
              } else if (bookmark) {
                self.viper.removeBookmark(bookmark);
              }
              ViperUtil.preventDefault(e);
            });
          }
        },
        readPastedImage: function(file, callback) {
          var reader = new FileReader();
          reader.onload = function(event2) {
            var image = new Image();
            image.src = event2.target.result;
            callback.call(this, image, file);
          };
          reader.readAsDataURL(file);
        },
        _getFakeKeyboardEvent: function() {
          var fakeEvent = {
            prevent: false,
            keyCode: 8,
            which: 8,
            preventDefault: function() {
              this.prevent = true;
            },
            stopPropagation: function() {
            }
          };
          return fakeEvent;
        },
        _beforeCut: function(e, rightClickCut) {
          var yCoord = null;
          var self = this;
          var range = self.viper.getViperRange();
          var rangeClone = range.cloneRange();
          var selectedContent = "";
          var selectedNode = range.getNodeSelection();
          var viperElem = self.viper.getViperElement();
          if (selectedNode && selectedNode !== viperElem) {
            var surroundingParents = ViperUtil.getSurroundingParents(selectedNode, null, false, viperElem);
            if (surroundingParents.length > 0) {
              selectedNode = surroundingParents.pop();
            }
            var tmp = document.createElement("div");
            tmp.appendChild(selectedNode.cloneNode(true));
            selectedContent = ViperUtil.getHtml(tmp);
          } else {
            selectedContent = range.getHTMLContents();
          }
          var tmp = document.createElement("div");
          tmp.setAttribute("contenteditable", "true");
          ViperUtil.addClass(tmp, "Viper-copyDiv");
          if (yCoord !== null) {
            ViperUtil.setStyle(tmp, "top", yCoord + "px");
          }
          tmp.oncut = function(e2) {
            setTimeout(function() {
              ViperUtil.remove(tmp);
              ViperSelection.addRange(rangeClone);
              if (self.viper.getKeyboardHandler().handleDelete({ keyCode: 8, which: 8 }) !== false) {
                rangeClone = self.viper.getViperRange();
                rangeClone.deleteContents(self.viper.getViperElement(), self.viper.getDefaultBlockTag());
                ViperSelection.addRange(rangeClone);
                self.viper.contentChanged();
              } else {
                ViperSelection.addRange(rangeClone);
                self.viper.contentChanged();
              }
            }, 0);
          };
          this.viper.element.appendChild(tmp);
          ViperUtil.setHtml(tmp, selectedContent);
          var firstChild = range._getFirstSelectableChild(tmp);
          var lastChild = range._getLastSelectableChild(tmp);
          if (!firstChild) {
            firstChild = document.createTextNode("");
            if (tmp.firstChild.childNodes.length > 0) {
              ViperUtil.insertBefore(tmp.firstChild.firstChild, firstChild);
            } else {
              ViperUtil.insertBefore(tmp.firstChild);
            }
          }
          if (!lastChild) {
            lastChild = document.createTextNode("");
            if (tmp.lastChild.childNodes.length > 0) {
              tmp.lastChild.appendChild(lastChild);
            } else {
              tmp.appendChild(lastChild);
            }
          }
          range.setEnd(lastChild, lastChild.data.length);
          range.setStart(firstChild, 0);
          ViperSelection.addRange(range);
          if (rightClickCut === true) {
            tmp.oncut();
          }
        },
        _fixPartialSelection: function(selectedContent, range) {
          if (selectedContent.toLowerCase().indexOf("<li>") === 0) {
            var parents = ViperUtil.getParents(range.startContainer, "ul,ol");
            if (parents.length > 0) {
              var listType = ViperUtil.getTagName(parents[0]);
              selectedContent = "<" + listType + ">" + selectedContent + "</" + listType + ">";
            }
          } else {
            var tableMatch = selectedContent.match(/^<(caption|tr|td|tbody|th|tfoot|thead)/i);
            if (tableMatch) {
              switch (tableMatch[1]) {
                case "td":
                  var re = new RegExp(/<\/?(\w+)((\s+\w+(\s*=\s*(?:".*?"|'.*?'|[^'">\s]+))?)+\s*|\s*)\/?>/gim);
                  var resCont = selectedContent;
                  var count = 0;
                  let match;
                  while ((match = re.exec(selectedContent)) != null) {
                    var rep = false;
                    if (match[0].indexOf("<td") === 0) {
                      count++;
                      rep = true;
                    } else if (match[0].indexOf("</td>") === 0) {
                      rep = true;
                    }
                    if (rep === true) {
                      resCont = resCont.replace(match[0], "");
                    }
                  }
                  if (count === 1) {
                    selectedContent = resCont;
                    break;
                  }
                  selectedContent = "<tr>" + selectedContent + "</tr>";
                default:
                  selectedContent = '<table border="1" style="width: 100%;">' + selectedContent + "</table>";
                  break;
              }
            }
          }
          return selectedContent;
        },
        _beforePaste: function(range) {
          range = range || this.viper.getCurrentRange();
          this.rangeObj = range.cloneRange();
          if (this._isTableSelection(range) === true) {
            return;
          }
          this._tmpNode = document.createTextNode("");
          this._tmpNodeOffset = 0;
          try {
            this.viper.insertNodeAtCaret(this._tmpNode, range);
          } catch (e) {
            this.viper.initEditableElement();
            this.viper.insertNodeAtCaret(this._tmpNode);
          }
        },
        _isTableSelection: function(range) {
          this._selectedRows = null;
          var rows = [];
          if (ViperUtil.isBrowser("firefox") === true) {
            var ffRange = null;
            var i = 0;
            while (ffRange = ViperSelection.getRangeAt(i)) {
              i++;
              var elem = ffRange.getStartNode();
              if (ViperUtil.isTag(elem, "td") === false) {
                rows = [];
                continue;
              }
              if (ViperUtil.inArray(elem.parentNode, rows) === false) {
                rows.push(elem.parentNode);
              }
            }
            if (rows.length > 0) {
              this._selectedRows = rows;
              return true;
            }
          }
          var startNode = range.getStartNode();
          var endNode = range.getEndNode();
          var elements = ViperUtil.getElementsBetween(startNode, endNode);
          for (var i = 0; i < elements.length; i++) {
            var row = null;
            if (elements[i].nodeType === ViperUtil.TEXT_NODE) {
              continue;
            } else if (ViperUtil.isTag(elements[i], "td") === false) {
              if (ViperUtil.isTag(elements[i], "tr") === false) {
                return false;
              } else {
                row = elements[i];
              }
            } else {
              row = elements[i].parentNode;
            }
            if (ViperUtil.inArray(row, rows) === false) {
              rows.push(row);
            }
          }
          if (rows.length > 0) {
            this._selectedRows = rows;
            return true;
          }
          return false;
        },
        _handleRawPasteValue: function(content) {
          if (!content) {
            content = "";
          }
          this._tmpNode.data = content;
          var range = this.viper.getCurrentRange();
          range.setStart(this._tmpNode, this._tmpNode.data.length);
          range.collapse(true);
          ViperSelection.addRange(range);
          if (this.pasteElement) {
            ViperUtil.remove(this.pasteElement);
            this.pasteElement = null;
          }
        },
        _createPasteDiv: function(noIframe) {
          var oldEl = ViperUtil.getid("ViperPasteDiv");
          if (oldEl) {
            ViperUtil.remove(oldEl);
          }
          if (noIframe !== true) {
            var iframe = this._createPasteIframe();
            iframe.id = "ViperPasteDivIframe";
            var frameDoc = ViperUtil.getIFrameDocument(iframe);
            this._iframe = iframe;
            return frameDoc.getElementById("ViperPasteIframeDiv");
          } else {
            var div = document.createElement("div");
            div.setAttribute("id", "ViperPasteDiv");
            div.setAttribute("contentEditable", true);
            this.viper.addElement(div);
            var self = this;
            div.onpaste = function(e) {
              var bookmark = self._bookmark;
              self._insertTmpNodeBeforeBookmark(bookmark);
              self.viper.removeBookmark(bookmark, true);
              setTimeout(function() {
                self._handleFormattedPasteValue(null, div);
                self.viper.focus();
              }, 100);
            };
            return div;
          }
        },
        _insertTmpNodeBeforeBookmark: function(bookmark) {
          ViperUtil.insertBefore(bookmark.start, this._tmpNode);
        },
        _createPasteIframe: function(parent) {
          var iframe = document.createElement("iframe");
          iframe.src = "about:blank";
          ViperUtil.addClass(iframe, "ViperCopyPastePlugin-iframe");
          if (parent) {
            parent.appendChild(iframe);
          } else {
            this.viper.addElement(iframe);
          }
          var content = "<!DOCTYPE html><head>";
          content += '</head><body style="overflow:hidden;margin:0;"><div id="ViperPasteIframeDiv" contentEditable="true" ';
          content += 'style="-moz-box-sizing: border-box; box-sizing: border-box; width: 100%; height: 2.1em;outline:none;';
          content += "background: none repeat scroll 0 0 #2B2B2B;border-bottom: 1px solid #777777;border-radius: 0.4em 0.4em 0.4em 0.4em;";
          content += "border-top: 1px solid #000000;box-shadow: 0 0 3px #000000 inset;color: #999;";
          content += "display: block;padding: 4px 0.5em;position: relative;text-align: center;font-style:italic;font-family:arial;font-size:0.9em;";
          content += "overflow:hidden;";
          content += '"></div></body></html>';
          var doc = ViperUtil.getIFrameDocument(iframe);
          doc.open();
          doc.write(content);
          doc.close();
          return iframe;
        },
        _handleFormattedPasteValue: function(stripTags, origPasteElement) {
          this._pasteProcess = 0;
          origPasteElement = origPasteElement || this.pasteElement;
          var pasteElement = origPasteElement.cloneNode(true);
          var isViperContent = false;
          var viperCopyElems = ViperUtil.getClass("__viper_copy", pasteElement);
          if (viperCopyElems.length === 1) {
            isViperContent = true;
            ViperUtil.setHtml(pasteElement, ViperUtil.getHtml(viperCopyElems[0]));
          }
          this.viper.removeNotAllowedAttributes(pasteElement);
          var html = ViperUtil.getHtml(pasteElement);
          if (isViperContent === true) {
            html = html.replace(/&nbsp;$/, "");
          }
          html = this._cleanPaste(html);
          var preHtml = html;
          if (isViperContent === true) {
            html = this._cleanViperPaste(html);
          } else if (this._isGoogleDocs(pasteElement) === true) {
            html = this._cleanGoogleDocsPaste(html);
          } else {
            html = this._cleanWordPaste(html);
            html = this._removeAttributes(html);
            preHtml = html;
            html = this._updateElements(html);
          }
          var tmp = document.createElement("div");
          ViperUtil.setHtml(tmp, html);
          this.viper.cleanDOM(tmp);
          html = ViperUtil.getHtml(tmp);
          var self = this;
          this.viper.fireCallbacks(
            "ViperCopyPastePlugin:cleanPaste",
            { html, stripTags },
            function(obj, newHTML) {
              if (newHTML) {
                html = newHTML;
              }
              self._pasteContent(html, stripTags, isViperContent, preHtml);
            }
          );
        },
        _pasteContent: function(html, stripTags, isViperContent, preHtml) {
          if (this._iframe) {
            ViperUtil.remove(this._iframe);
            this._iframe = null;
          }
          if (stripTags === true) {
            html = ViperUtil.stripTags(html, this.allowedTags.split("|"));
          }
          if (html) {
            html = ViperUtil.trim(html);
            if (isViperContent !== true) {
              html = this.viper.cleanHTML(html, ["dir", "class", "lang", "align"]);
            }
          }
          if (!html) {
            this._updateSelection();
            return;
          }
          var fragment = null;
          var range = this.rangeObj || this.viper.getCurrentRange();
          if (ViperUtil.isBrowser("chrome") === true && range.startContainer === range.endContainer && ViperUtil.isTag(range.startContainer, "br") === true) {
            var tmpTextNode = document.createTextNode("");
            var rangeClone = range.cloneRange();
            rangeClone.setStart(tmpTextNode);
            rangeClone.collapse(true);
            fragment = rangeClone.createDocumentFragment(html);
          } else {
            fragment = range.createDocumentFragment(html);
          }
          var convertTags = this.convertTags;
          if (stripTags === true && this.convertTags !== null) {
            ViperUtil.foreach(convertTags, function(tag) {
              var elems = ViperUtil.getTag(tag, fragment.firstChild);
              var ln = elems.length;
              for (var i2 = 0; i2 < ln; i2++) {
                var cElem = document.createElement(convertTags[tag]);
                while (elems[i2].firstChild) {
                  cElem.appendChild(elems[i2].firstChild);
                }
                ViperUtil.insertBefore(elems[i2], cElem);
                ViperUtil.remove(elems[i2]);
              }
            });
          }
          if (this._selectedRows !== null) {
            var pastedRows = [];
            if (fragment.firstChild && ViperUtil.isTag(fragment.firstChild, "table") === true && fragment.firstChild === fragment.lastChild) {
              pastedRows = ViperUtil.getTag("tr", fragment.firstChild);
            } else if (fragment.firstElementChild && ViperUtil.isTag(fragment.firstElementChild, "td") === true) {
              var cellCount = ViperUtil.getTag("td", this._selectedRows[0]).length;
              var tr = null;
              var i = 0;
              var node = null;
              while (node = fragment.firstElementChild) {
                if (i % cellCount === 0) {
                  tr = document.createElement("tr");
                  pastedRows.push(tr);
                }
                tr.appendChild(node);
                i++;
              }
            }
            if (pastedRows.length > 0) {
              for (var i = 0; i < pastedRows.length; i++) {
                ViperUtil.insertBefore(this._selectedRows[0], pastedRows[i]);
              }
              ViperUtil.remove(this._selectedRows);
              this._updateSelection();
              this.viper.cleanDOM();
              this.viper.contentChanged();
              this.viper.fireCallbacks("ViperCopyPastePlugin:paste");
              return;
            } else {
              var td = ViperUtil.getTag("td", this._selectedRows[0])[0];
              ViperUtil.setHtml(td, " ");
              this._tmpNode = td.firstChild;
            }
          }
          if (ViperUtil.hasBlockChildren(fragment) === true) {
            var keyboardEditor = this.viper.getKeyboardHandler();
            var viperElem = this.viper.getViperElement();
            var prevBlock = null;
            var range = this.viper.getViperRange();
            if (ViperUtil.isPartOfDOM(this._tmpNode, viperElem) === false) {
              var bookmark = this.viper.createBookmark();
              this._insertTmpNodeBeforeBookmark(bookmark);
            }
            range.setEnd(this._tmpNode, 0);
            range.collapse(false);
            if (ViperUtil.getHtml(viperElem) !== "") {
              if (viperElem.firstChild === viperElem.lastChild && (viperElem.firstChild === null || ViperUtil.isTag(viperElem.firstChild, "br") === true)) {
                if (viperElem.firstChild === null) {
                  viperElem.appendChild(this._tmpNode);
                } else {
                  ViperUtil.insertBefore(this._tmpNode, viperElem.firstChild);
                }
              } else if (ViperUtil.trim(ViperUtil.getHtml(this._tmpNode.parentNode)) === "&nbsp;" && ViperUtil.isBlockElement(this._tmpNode.parentNode)) {
                ViperUtil.insertBefore(this._tmpNode.parentNode, this._tmpNode);
                ViperUtil.remove(this._tmpNode.nextSibling);
              } else {
                prevBlock = keyboardEditor.splitAtRange(true, range);
              }
            } else {
              viperElem.appendChild(this._tmpNode);
            }
            if (!prevBlock) {
              prevBlock = this._tmpNode;
            } else {
              try {
                if (!this._tmpNode.parentNode) {
                  if (prevBlock.lastChild) {
                    this._tmpNode = prevBlock.lastChild;
                  } else {
                    this._tmpNode = prevBlock;
                  }
                }
              } catch (e) {
                this._tmpNode = document.createTextNode("");
                if (prevBlock.lastChild) {
                  ViperUtil.insertAfter(prevBlock.lastChild, this._tmpNode);
                } else {
                  prevBlock.appendChild(this._tmpNode);
                }
              }
            }
            var prevCheckCont = ViperUtil.trim(ViperUtil.getNodeTextContent(prevBlock));
            if (prevCheckCont !== "") {
              if (prevCheckCont.length === 1 && prevCheckCont.charCodeAt(0) !== 160) {
                prevBlock = prevBlock.nextSibling;
              }
            }
            if (prevBlock.nextSibling) {
              prevCheckCont = ViperUtil.trim(ViperUtil.getNodeTextContent(prevBlock.nextSibling));
              if (prevCheckCont === "" || prevCheckCont.length === 1 && prevCheckCont.charCodeAt(0) === 160) {
                ViperUtil.remove(prevBlock.nextSibling);
                if (prevBlock.lastChild) {
                  prevCheckCont = ViperUtil.trim(ViperUtil.getNodeTextContent(prevBlock.lastChild));
                  if (prevCheckCont === "" || prevCheckCont.length === 1 && prevCheckCont.charCodeAt(0) === 160) {
                    ViperUtil.remove(prevBlock.lastChild);
                  }
                }
              }
            }
            if (ViperUtil.getParents(prevBlock, "pre", this.viper.getViperElement()).length > 0) {
              var textNode = document.createTextNode(preHtml);
              ViperUtil.insertBefore(this._tmpNode, textNode);
            } else {
              var prevChild = null;
              var lastChild = null;
              var prevWrapper = null;
              while (fragment.lastChild) {
                if (prevChild === fragment.lastChild) {
                  break;
                }
                if (ViperUtil.isTag(fragment.lastChild, "img") === true) {
                  if (fragment.lastChild.src.match("%7E") !== null) {
                    fragment.lastChild.src = fragment.lastChild.src.replace("%7E", "~");
                  }
                }
                var images = ViperUtil.getTag("img", fragment.lastChild);
                for (var i = 0; i < images.length; i++) {
                  if (images[i].src.match("%7E") !== null) {
                    images[i].src = images[i].src.replace("%7E", "~");
                  }
                }
                prevChild = fragment.lastChild;
                var ctNode = null;
                if (ViperUtil.isBlockElement(fragment.lastChild) === true && ViperUtil.isStubElement(fragment.lastChild) === false) {
                  prevWrapper = null;
                  ctNode = fragment.lastChild;
                  if (ViperUtil.isTag(ctNode, ["ul", "ol"]) === true && ViperUtil.isTag(prevBlock, ["li", "ul", "ol"]) === true) {
                    var insAfter = prevBlock;
                    if (ViperUtil.isTag(insAfter, "li") === false) {
                      insAfter = this._tmpNode.nextSibling;
                    }
                    while (ctNode.firstChild) {
                      var firstChild = ctNode.firstChild;
                      ViperUtil.insertAfter(insAfter, firstChild);
                      insAfter = firstChild;
                    }
                    ViperUtil.remove(ctNode);
                  } else if (ViperUtil.isTag(ctNode, "table") === true && ViperUtil.getParents(prevBlock, "table", this.viper.getViperElement()).length > 0) {
                    var tableContentTags = "td,th,caption";
                    var contentNodes = ViperUtil.getTag(tableContentTags, ctNode);
                    while (contentNodes.length > 0) {
                      var contentNode = contentNodes.pop();
                      while (contentNode.childNodes.length > 0) {
                        ViperUtil.insertAfter(prevBlock, contentNode.lastChild);
                      }
                    }
                  } else {
                    ViperUtil.insertAfter(prevBlock, ctNode);
                  }
                } else {
                  var defaultTag = this.viper.getDefaultBlockTag();
                  ctNode = fragment.lastChild;
                  if (defaultTag && prevWrapper === null) {
                    ctNode = document.createElement(defaultTag);
                    ctNode.appendChild(fragment.lastChild);
                    prevWrapper = ctNode;
                  } else if (prevWrapper !== null) {
                    ViperUtil.insertBefore(prevWrapper.firstChild, fragment.lastChild);
                    continue;
                  }
                  ViperUtil.insertAfter(prevBlock, ctNode);
                }
                if (lastChild === null) {
                  lastChild = ctNode;
                }
              }
              if (prevBlock && ViperUtil.isTag(prevBlock, "table") === false) {
                prevCheckCont = ViperUtil.trim(ViperUtil.getNodeTextContent(prevBlock));
                if (prevCheckCont === "" || prevCheckCont.length === 1 && prevCheckCont.charCodeAt(0) === 160) {
                  if (ViperUtil.isChildOf(this._tmpNode, prevBlock) === true) {
                    this._tmpNode = range._getLastSelectableChild(prevBlock.nextSibling);
                    if (this._tmpNode) {
                      this._tmpNodeOffset = this._tmpNode.data.length;
                    } else {
                      this._tmpNodeOffset = 0;
                    }
                  }
                  ViperUtil.remove(prevBlock);
                }
              }
            }
            if (lastChild) {
              var lastSelectable = range._getLastSelectableChild(lastChild);
              if (lastSelectable) {
                this._tmpNode = lastSelectable;
                this._tmpNodeOffset = this._tmpNode.data.length;
              }
            }
          } else {
            if (ViperUtil.getParents(this._tmpNode, "pre", this.viper.getViperElement()).length > 0) {
              var textNode = document.createTextNode(preHtml);
              ViperUtil.insertBefore(this._tmpNode, textNode);
            } else {
              if (this._tmpNode.parentNode === this.viper.getViperElement() && ViperUtil.isBlockElement(fragment.firstChild) === false) {
                var defaultTag = this.viper.getDefaultBlockTag();
                if (defaultTag) {
                  defaultTag = document.createElement(defaultTag);
                  ViperUtil.insertBefore(this._tmpNode, defaultTag);
                  defaultTag.appendChild(this._tmpNode);
                }
              }
              while (fragment.firstChild) {
                ViperUtil.insertBefore(this._tmpNode, fragment.firstChild);
              }
            }
          }
          this._updateSelection();
          this.viper.contentChanged();
          this.viper.fireCallbacks("ViperCopyPastePlugin:paste");
        },
        _cleanWordPaste: function(content) {
          if (!content) {
            return content;
          }
          if (ViperUtil.isBrowser("chrome") === true) {
            content = content.replace(/<span class="Apple-converted-space">&nbsp;<\/span>/g, " ");
          }
          var tmp = document.createElement("div");
          ViperUtil.setHtml(tmp, content);
          this._convertSpansToStyleTags(tmp);
          var msocomanchor = ViperUtil.find(tmp, 'a[class="msocomanchor"]');
          ViperUtil.remove(msocomanchor);
          var msocomoff = ViperUtil.find(tmp, 'hr[class="msocomoff"]');
          if (msocomoff.length > 0) {
            msocomoff = msocomoff[0];
            while (msocomoff.nextSibling) {
              ViperUtil.remove(msocomoff.nextSibling);
            }
            ViperUtil.remove(msocomoff);
          }
          content = ViperUtil.getHtml(tmp);
          content = content.replace(/<\/?span[^>]*>/gi, "");
          content = content.replace(/<\/?\w+:[^>]*>/gi, "");
          content = content.replace(/<\\?\?xml[^>]*>/gi, "");
          content = this._convertWordPasteList(content);
          content = this._cleanStyleAttributes(content);
          content = content.replace('<br clear="all">', "");
          content = this._removeWordTags(content);
          content = this._convertTags(content);
          return content;
        },
        _cleanViperPaste: function(content) {
          content = content.replace(/<(font)((\s+\w+(\s*=\s*(?:".*?"|\'.*?\'|[^\'">\s]+))?)+)?\s*>\s*/gi, "");
          content = content.replace(/\s*<\/(font)((\s+\w+(\s*=\s*(?:".*?"|\'.*?\'|[^\'">\s]+))?)+)?\s*>/gi, "");
          return content;
        },
        _cleanGoogleDocsPaste: function(content) {
          var tmp = document.createElement("div");
          ViperUtil.setHtml(tmp, content);
          var docParent = null;
          if (ViperUtil.isBlockElement(tmp.firstChild) === true) {
            docParent = tmp;
          } else {
            docParent = tmp.firstChild;
          }
          tmp = docParent;
          var docIdElem = ViperUtil.find(tmp, '[id^="docs-internal-guid-"]');
          if (docIdElem.length > 0) {
            ViperUtil.removeAttr(docIdElem, "id");
          } else if (tmp.id && tmp.id.indexOf("docs-internal-guid-") === 0) {
            if (ViperUtil.isBlockElement(tmp) === false && ViperUtil.hasBlockChildren(tmp) === true) {
              var newDocElem = document.createElement("div");
              while (tmp.firstChild) {
                newDocElem.appendChild(tmp.firstChild);
              }
              ViperUtil.insertBefore(tmp, newDocElem);
              ViperUtil.remove(tmp);
              tmp = newDocElem;
            } else {
              ViperUtil.removeAttr(tmp, "id");
            }
          }
          var bTag = ViperUtil.getTag("b", tmp);
          if (bTag.length > 0) {
            ViperUtil.setHtml(tmp, ViperUtil.getHtml(bTag[0]));
          }
          content = ViperUtil.getHtml(tmp);
          content = this._cleanStyleAttributes(content, "google_docs");
          ViperUtil.setHtml(tmp, content);
          this._convertSpansToStyleTags(tmp);
          var pInLI = ViperUtil.find(tmp, "li > p");
          for (var i = 0; i < pInLI.length; i++) {
            while (pInLI[i].firstChild) {
              ViperUtil.insertBefore(pInLI[i], pInLI[i].firstChild);
            }
            ViperUtil.remove(pInLI[i]);
          }
          var nestedLists = ViperUtil.find(tmp, "ol > ol,ol > ul, ul > ul, ul > ol");
          for (var i = 0; i < nestedLists.length; i++) {
            var list = nestedLists[i];
            for (var prevSib = list.previousSibling; prevSib; prevSib = prevSib.previousSibling) {
              if (ViperUtil.isTag(prevSib, "li") === false) {
                continue;
              }
              prevSib.appendChild(list);
              break;
            }
          }
          this._joinSplitLists(tmp);
          var brTags = ViperUtil.find(tmp, " > br");
          if (brTags.length > 0) {
            ViperUtil.remove(brTags);
          }
          var strongAndEmTags = ViperUtil.find(
            tmp,
            "h1 > strong,h2 > strong,h3 > strong,h4 > strong,h5 > strong,h6 > strong,h1 > em,h2 > em,h3 > em,h4 > em,h5 > em,h6 > em"
          );
          for (var i = 0; i < strongAndEmTags.length; i++) {
            while (strongAndEmTags[i].firstChild) {
              ViperUtil.insertBefore(strongAndEmTags[i], strongAndEmTags[i].firstChild);
            }
            ViperUtil.remove(strongAndEmTags[i]);
          }
          content = ViperUtil.getHtml(tmp);
          content = content.replace(/<\/?span[^>]*>/gi, "");
          content = this._cleanStyleAttributes(content);
          return content;
        },
        _isGoogleDocs: function(elem) {
          if (elem.firstChild) {
            if (ViperUtil.isTag(elem.firstChild, "b") === true || ViperUtil.isTag(elem.firstChild.nextSibling, "b") === true || elem.firstChild.id && elem.firstChild.id.indexOf("docs-internal-guid-") === 0) {
              return true;
            } else if (ViperUtil.isTag(elem.firstChild, "meta") === true && ViperUtil.isTag(elem.lastChild, "b") === true || elem.lastChild.id && elem.lastChild.id.indexOf("docs-internal-guid-") === 0) {
              return true;
            } else if (ViperUtil.find(elem, '[id^="docs-internal-guid-"]').length === 1) {
              return true;
            }
          }
          return false;
        },
        _joinSplitLists: function(parentElement) {
          var lists = ViperUtil.find(parentElement, "ol");
          for (var i = lists.length - 1; i >= 0; i--) {
            var list = lists[i];
            if (!list.firstChild) {
              ViperUtil.remove(list);
              continue;
            }
            var start = parseInt(ViperUtil.attr(list, "start")) || 1;
            if (start > 1 && i > 0) {
              var prevList = lists[i - 1];
              var prevStart = parseInt(ViperUtil.attr(prevList, "start")) || 1;
              if (prevStart === start - 1) {
                var elemsBetween = ViperUtil.getElementsBetween(prevList, list);
                try {
                  var lastLi = ViperUtil.find(prevList, " > li")[0];
                  for (var j = 0; j < elemsBetween.length; j++) {
                    lastLi.appendChild(elemsBetween[j]);
                  }
                  while (list.firstChild) {
                    prevList.appendChild(list.firstChild);
                  }
                } catch (e) {
                  continue;
                }
                ViperUtil.remove(list);
              }
            }
          }
        },
        _convertSpansToStyleTags: function(elem) {
          var validStyles = {
            "font-weight:\\s*bold": "strong",
            "font-weight:\\s*(\\d+)": "strong",
            "font-style:\\s*italic": "em",
            "text-decoration:\\s*line-through": "del",
            "vertical-align:\\s*sub": "sub",
            "vertical-align:\\s*super": "sup"
          };
          var spanTags = ViperUtil.getTag("span", elem);
          var regexs = {};
          for (var i = 0; i < spanTags.length; i++) {
            var span = spanTags[i];
            var newTag = null;
            var outerTag = null;
            if (ViperUtil.hasAttribute(span, "style") === true) {
              for (var style in validStyles) {
                if (!regexs[style]) {
                  regexs[style] = new RegExp(style);
                }
                var match = ViperUtil.attr(span, "style").match(regexs[style]);
                if (match !== null) {
                  if (validStyles[style] === "strong") {
                    if (style === "font-weight:\\s*(\\d+)" && match[1] <= 400) {
                      continue;
                    }
                  }
                  var t = document.createElement(validStyles[style]);
                  if (newTag) {
                    newTag.appendChild(t);
                  } else {
                    outerTag = t;
                  }
                  newTag = t;
                }
              }
            }
            if (newTag) {
              while (span.firstChild) {
                newTag.appendChild(span.firstChild);
              }
              ViperUtil.insertBefore(span, outerTag);
            } else {
              while (span.firstChild) {
                ViperUtil.insertBefore(span, span.firstChild);
              }
            }
            ViperUtil.remove(span);
          }
        },
        _removeSpansWithNoAttributes: function(content) {
          var tmp = document.createElement("div");
          ViperUtil.setHtml(tmp, content);
          var spans = ViperUtil.getTag("span", tmp);
          for (var i = 0; i < spans.length; i++) {
            if (ViperUtil.hasAttribute(spans[i], "lang") === false && ViperUtil.hasAttribute(spans[i], "dir") === false && ViperUtil.hasAttribute(spans[i], "style") === false) {
              this._moveChildren(spans[i]);
              ViperUtil.remove(spans[i]);
            }
          }
          content = ViperUtil.getHtml(tmp);
          return content;
        },
        _cleanStyleAttributes: function(content, contentType) {
          var self = this;
          var quote = '"';
          var replaceCallback = function() {
            var styles = arguments[2];
            var stylesList = styles.split(";");
            var validStyles = [];
            var replacement = "";
            for (var i = 0; i < stylesList.length; i++) {
              var style = ViperUtil.trim(stylesList[i].replace("\n", ""));
              if (self.isAllowedStyle(style, contentType) === true) {
                validStyles.push(style);
              }
            }
            if (validStyles.length > 0) {
              styles = validStyles.join(";");
              replacement = "<" + arguments[1] + " style=" + quote + styles + quote + arguments[3];
            } else {
              replacement = "<" + arguments[1] + arguments[3];
            }
            return replacement;
          };
          content = content.replace(new RegExp('<(\\w[^>]*) style="([^"]*)"([^>]*)', "gi"), replaceCallback);
          quote = "'";
          content = content.replace(new RegExp("<(\\w[^>]*) style='([^']*)'([^>]*)", "gi"), replaceCallback);
          return content;
        },
        isAllowedStyle: function(style, contentType) {
          if (style.indexOf("mso-") === 0) {
            return false;
          }
          var styleName = style.split(":");
          var allowedStyles = ["height", "width", "list-style-type"];
          if (this._aggressiveMode === false) {
            allowedStyles = allowedStyles.concat([
              "padding",
              "text-align",
              "text-indent",
              "border-collapse",
              "border",
              "border-top",
              "border-bottom",
              "border-right",
              "border-left"
            ]);
          }
          if (contentType === "google_docs") {
            allowedStyles = allowedStyles.concat(["font-weight", "font-style", "vertical-align", "text-decoration"]);
          }
          if (ViperUtil.inArray(styleName[0], allowedStyles) === true) {
            var invalidStyleValues = {
              "text-align": ["start", "left", "initial"],
              padding: ["0px"],
              "text-indent": ["0px"]
            };
            if (!invalidStyleValues[styleName[0]] || ViperUtil.inArray(ViperUtil.trim(styleName[1]), invalidStyleValues[styleName[0]]) === false) {
              return true;
            }
          }
          return false;
        },
        _convertTags: function(content) {
          var tmp = document.createElement("div");
          ViperUtil.setHtml(tmp, content);
          var insTags = ViperUtil.getTag("ins", tmp);
          var ins = null;
          while (ins = insTags.shift()) {
            while (ins.firstChild) {
              ViperUtil.insertBefore(ins, ins.firstChild);
            }
            ViperUtil.remove(ins);
          }
          var centerTags = ViperUtil.getTag("center", tmp);
          var center = null;
          while (center = centerTags.shift()) {
            var parent = null;
            var childTags = ViperUtil.getTag("*", center);
            if (childTags.length === 0) {
              parent = document.createElement("p");
            }
            while (center.firstChild) {
              if (parent) {
                parent.appendChild(center.firstChild);
              } else {
                ViperUtil.insertBefore(center, center.firstChild);
              }
            }
            if (parent) {
              ViperUtil.insertBefore(center, parent);
            }
            ViperUtil.remove(center);
          }
          content = ViperUtil.getHtml(tmp);
          return content;
        },
        _removeAttributes: function(content) {
          var tmp = document.createElement("div");
          ViperUtil.setHtml(tmp, content);
          removeAttr(find(tmp, "[class]"), "class");
          removeAttr(find(tmp, "br[clear]"), "clear");
          var tableElements = find(tmp, "td,tr,table,tbody,tfoot,thead");
          var c = tableElements.length;
          for (var i = 0; i < c; i++) {
            var attributes = tableElements[i].attributes;
            if (ViperUtil.isTag(tableElements[i], "td") === true || ViperUtil.isTag(tableElements[i], "th") === true) {
              if (!ViperUtil.trim(ViperUtil.getHtml(tableElements[i]))) {
                ViperUtil.setHtml(tableElements[i], "<br />");
              }
            }
            for (var j = attributes.length - 1; j >= 0; j--) {
              var attrName = attributes[j].name.toLowerCase();
              if (attrName === "colspan" || attrName === "rowspan") {
                continue;
              }
              tableElements[i].removeAttribute(attrName);
            }
          }
          removeAttr(find(tmp, "[class]"), "class");
          removeElement(find(tmp, "colgroup"));
          content = ViperUtil.getHtml(tmp);
          return content;
        },
        _updateElements: function(content) {
          var tmp = document.createElement("div");
          ViperUtil.setHtml(tmp, content);
          var tables = ViperUtil.getTag("table", tmp);
          var c = tables.length;
          for (var i = 0; i < c; i++) {
            var table = tables[i];
            ViperUtil.setStyle(tmp, "display", "none");
            this.viper.getViperElement().appendChild(tmp);
            ViperUtil.setStyle(table, "width", "100%");
            var col = ViperUtil.getTag("td,th", table)[0];
            var rightWidth = parseInt(ViperUtil.getComputedStyle(col, "border-right-width"));
            var bottomWidth = parseInt(ViperUtil.getComputedStyle(col, "border-bottom-width"));
            if (bottomWidth === 0 || rightWidth === 0 || isNaN(bottomWidth) === true || isNaN(rightWidth) === true) {
              ViperUtil.attr(table, "border", 1);
            }
            var thead = ViperUtil.getTag("thead", table);
            for (var j = 0; j < thead.length; j++) {
              var tds = ViperUtil.getTag("td", thead);
              for (var k = 0; k < tds.length; k++) {
                var td = tds[k];
                var th = document.createElement("th");
                while (td.firstChild) {
                  th.appendChild(td.firstChild);
                }
                var colspan = ViperUtil.attr(td, "colspan");
                if (colspan) {
                  th.setAttribute("colspan", colspan);
                }
                var rowspan = ViperUtil.attr(td, "rowspan");
                if (rowspan) {
                  th.setAttribute("rowspan", rowspan);
                }
                ViperUtil.insertBefore(td, th);
                ViperUtil.remove(td);
              }
            }
            ViperUtil.remove(tmp);
            ViperUtil.setStyle(tmp, "display", "auto");
          }
          var defaultTag = this.viper.getDefaultBlockTag();
          if (defaultTag !== "") {
            var brs = ViperUtil.getTag("br", tmp);
            if (brs.length !== 0) {
              var br = null;
              var first = true;
              while (br = brs.shift()) {
                if (br.parentNode && br.parentNode.firstChild === br && ViperUtil.isBlockElement(br.parentNode) === true) {
                  ViperUtil.remove(br);
                  continue;
                }
                if (ViperUtil.isTag(br.nextSibling, "br") === true) {
                  while (ViperUtil.isTag(br.nextSibling, "br") === true) {
                    ViperUtil.remove(brs.shift());
                  }
                  var wrapper = document.createElement(defaultTag);
                  ViperUtil.insertAfter(br, wrapper);
                  ViperUtil.remove(br);
                  var node = null;
                  if (first === true) {
                    first = false;
                    var preWrapper = document.createElement(defaultTag);
                    while (node = wrapper.previousSibling) {
                      if (ViperUtil.isBlockElement(node) === true) {
                        break;
                      }
                      if (preWrapper.firstChild) {
                        ViperUtil.insertBefore(preWrapper.firstChild, node);
                      } else {
                        preWrapper.appendChild(node);
                      }
                    }
                    if (preWrapper.childNodes.length !== 0) {
                      ViperUtil.insertBefore(wrapper, preWrapper);
                    }
                  }
                  node = null;
                  while (node = wrapper.nextSibling) {
                    if (ViperUtil.isBlockElement(node) === true || ViperUtil.isTag(node, "br") === true && ViperUtil.isTag(node.nextSibling, "br") === true) {
                      break;
                    } else if (node.nodeType !== ViperUtil.TEXT_NODE || node.data.length !== 0) {
                      wrapper.appendChild(node);
                    }
                  }
                  if (wrapper.childNodes.length === 0) {
                    ViperUtil.remove(wrapper);
                  }
                }
              }
            }
          }
          content = ViperUtil.getHtml(tmp);
          return content;
        },
        _removeWordTags: function(content) {
          var tmp = document.createElement("div");
          ViperUtil.setHtml(tmp, content);
          var tags = ViperUtil.find(tmp, '[language="JavaScript"]');
          for (var i = 0; i < tags.length; i++) {
            if (tags[i].id && tags[i].id.indexOf("_com_") === 0 && tags[i].parentNode && ViperUtil.isTag(tags[i].parentNode, "div") === true) {
              if (ViperUtil.isTag(tags[i].parentNode.previousElementSibling, "hr") === true) {
                ViperUtil.remove(tags[i].parentNode.parentNode);
              } else {
                ViperUtil.remove(tags[i].parentNode);
              }
            } else {
              ViperUtil.remove(tags[i]);
            }
          }
          var aTags = ViperUtil.getTag("a", tmp);
          var c = aTags.length;
          for (var i = 0; i < c; i++) {
            var aTag = aTags[i];
            if (!aTag.getAttribute("href")) {
              if (ViperUtil.isBlank(ViperUtil.getHtml(aTag)) === false) {
                while (aTag.firstChild) {
                  ViperUtil.insertBefore(aTag, aTag.firstChild);
                }
              }
              var parent = aTag.parentNode;
              ViperUtil.remove(aTag);
              if (ViperUtil.isBlank(ViperUtil.getHtml(parent)) === true) {
                ViperUtil.remove(parent);
              }
            } else {
              aTag.setAttribute("href", aTag.getAttribute("href").replace(/\/$/, ""));
              aTag.setAttribute("href", aTag.getAttribute("href").replace(/^blocked::/i, ""));
            }
          }
          var tags = ViperUtil.getTag("div", tmp);
          var c = tags.length;
          for (var i = 0; i < c; i++) {
            var id = tags[i].getAttribute("id");
            if (id && id.indexOf("ftn") === 0) {
              var parent = tags[i].parentNode;
              ViperUtil.remove(tags[i]);
              if (ViperUtil.isBlank(ViperUtil.getHtml(parent)) === true) {
                ViperUtil.remove(parent);
              }
            }
          }
          var lists = ViperUtil.getTag("ol,ul", tmp);
          for (var i = 0; i < lists.length; i++) {
            var node = lists[i].firstChild;
            while (node) {
              if (ViperUtil.isTag(node, "li") === false) {
                while (node.firstChild) {
                  ViperUtil.insertBefore(node, node.firstChild);
                }
                ViperUtil.remove(node);
                node = lists[i].firstChild;
              } else {
                node = node.nextSibling;
              }
            }
          }
          var tags = ViperUtil.find(tmp, "img");
          for (var i = 0; i < tags.length; i++) {
            var img = tags[i];
            if (img.getAttribute("src").indexOf("file://") === 0) {
              img.setAttribute("src", "");
            }
          }
          var tags = ViperUtil.find(tmp, "font");
          for (var i = 0; i < tags.length; i++) {
            if (ViperUtil.getTag("*", tags[i]).length > 1) {
              while (tags[i].firstChild) {
                ViperUtil.insertBefore(tags[i], tags[i].firstChild);
              }
              ViperUtil.remove(tags[i]);
            }
          }
          if (tmp.firstChild && ViperUtil.isTag(tmp.firstChild, "p") === true) {
            var firstChild = tmp.firstChild;
            var nextSibling = firstChild.nextSibling;
            while (nextSibling) {
              if (nextSibling.nodeType === ViperUtil.TEXT_NODE && ViperUtil.isBlank(ViperUtil.trim(nextSibling.data)) === true) {
                nextSibling = nextSibling.nextSibling;
              } else if (nextSibling && ViperUtil.isTag(nextSibling, "font") === true) {
                if (ViperUtil.getNodeTextContent(nextSibling) === "") {
                  var newElement = document.createElement("h1");
                  while (firstChild.firstChild) {
                    newElement.appendChild(firstChild.firstChild);
                  }
                  ViperUtil.insertBefore(firstChild, newElement);
                  ViperUtil.remove(firstChild);
                }
                break;
              } else {
                break;
              }
            }
          }
          var tags = ViperUtil.find(tmp, "font > p");
          var c = tags.length;
          for (var i = 0; i < c; i++) {
            var parent = tags[i].parentNode;
            var fontCount = 0;
            var strongCount = 0;
            var emCount = 0;
            var headingType = 0;
            var fontSize = 0;
            var lastParent = null;
            while (parent) {
              var tagName = ViperUtil.getTagName(parent);
              if (tagName === "font") {
                lastParent = parent;
                fontCount++;
                if (parent.getAttribute("size")) {
                  fontSize = parseInt(parent.getAttribute("size"));
                }
              } else if (tagName === "em") {
                lastParent = parent;
                emCount++;
              } else if (tagName === "strong") {
                lastParent = parent;
                strongCount++;
                break;
              } else {
                break;
              }
              if (!parent.parentNode) {
                break;
              }
              parent = parent.parentNode;
            }
            if (strongCount >= 1) {
              if (fontCount >= 3 && fontSize >= 5) {
                headingType = 1;
              } else if (fontCount >= 3 && fontSize >= 4) {
                headingType = 2;
              } else if (fontCount === 2 && emCount === 0) {
                headingType = 3;
              } else if (fontCount === 2 && emCount >= 1) {
                headingType = 4;
              }
            } else if (emCount === 0 && fontCount === 2) {
              headingType = 5;
            } else if (emCount === 1 && fontCount === 2) {
              headingType = 6;
            }
            if (headingType > 0) {
              var heading = document.createElement("h" + headingType);
              while (tags[i].firstChild) {
                heading.appendChild(tags[i].firstChild);
              }
              ViperUtil.insertBefore(lastParent, heading);
              ViperUtil.remove(tags[i]);
            }
          }
          content = ViperUtil.getHtml(tmp);
          content = content.replace(/<(font)((\s+\w+(\s*=\s*(?:".*?"|\'.*?\'|[^\'">\s]+))?)+)?\s*>\s*/gi, "");
          content = content.replace(/\s*<\/(font)((\s+\w+(\s*=\s*(?:".*?"|\'.*?\'|[^\'">\s]+))?)+)?\s*>/gi, "");
          ViperUtil.setHtml(tmp, content);
          var tags = ViperUtil.getTag("*", tmp);
          var c = tags.length;
          for (var i = 0; i < c; i++) {
            this.removeEmptyNodes(tags[i]);
          }
          tags = ViperUtil.getTag("p", tmp);
          var c = tags.length;
          for (var i = 0; i < c; i++) {
            var tagContent = ViperUtil.getHtml(tags[i]);
            if (tagContent === "&nbsp;" || ViperUtil.isBlank(tagContent) === true || ViperUtil.trim(tagContent).replace(/[\r\n]/, "") === "<br><br>") {
              if (tags[i].previousSibling && tags[i].nextSibling) {
                var prevTagName = ViperUtil.getTagName(tags[i].previousElementSibling);
                var nextTagName = ViperUtil.getTagName(tags[i].nextElementSibling);
                if (prevTagName === nextTagName && ViperUtil.isTag(tags[i].previousElementSibling, ["ul", "ol"])) {
                  ViperUtil.moveChildrenToElement(tags[i].nextElementSibling, tags[i].previousElementSibling);
                  ViperUtil.remove(tags[i].nextElementSibling);
                }
              }
              ViperUtil.remove(tags[i]);
            }
          }
          var prevBlockquote = null;
          var quotes = ViperUtil.find(tmp, '[class="MsoQuote"]');
          for (var i = 0; i < quotes.length; i++) {
            var quote = quotes[i];
            if (prevBlockquote === null || quote.previousElementSibling !== prevBlockquote) {
              prevBlockquote = document.createElement("blockquote");
              ViperUtil.insertBefore(quote, prevBlockquote);
            }
            prevBlockquote.appendChild(quote);
          }
          content = ViperUtil.getHtml(tmp);
          ViperUtil.setHtml(tmp, content);
          return content;
        },
        _getListType: function(elem, listTypes) {
          var style = elem.getAttribute("style");
          var className = elem.getAttribute("class") || "";
          if (!style || style.indexOf("mso-list") === -1 && className.indexOf("MsoList") === -1) {
            return null;
          }
          var tmp = document.createElement("div");
          var range = this.viper.getViperRange();
          var elContent = ViperUtil.getNodeTextContent(elem);
          elContent = elContent.replace(/\n/, "");
          elContent = elContent.replace(/^(&nbsp;)+/m, "");
          elContent = ViperUtil.trim(elContent);
          var info = null;
          ViperUtil.foreach(listTypes, function(k) {
            ViperUtil.foreach(listTypes[k], function(j) {
              ViperUtil.foreach(listTypes[k][j], function(m) {
                var r = new RegExp(listTypes[k][j][m]);
                if (r.test(elContent) === true) {
                  var origHtml = ViperUtil.getHtml(elem);
                  var html = origHtml.replace(/\n/gm, " ");
                  html = ViperUtil.trim(html);
                  html = html.replace(/^(&nbsp;)+/m, "");
                  html = html.replace(/(&nbsp;)+$/m, "");
                  html = ViperUtil.trim(html);
                  var start = 1;
                  if (k === "ol") {
                    var match = elContent.match(r);
                    if (match && match.length === 2) {
                      match = match[1].match(/\d+/);
                      if (match && parseInt(match[0])) {
                        start = parseInt(match[0]);
                      }
                    }
                  }
                  var replacedHTML = html.replace(r, "");
                  if (replacedHTML === html) {
                    ViperUtil.setHtml(tmp, html);
                    var firstChild = range._getFirstSelectableChild(tmp);
                    firstChild.data = firstChild.data.replace(r, "");
                    replacedHTML = ViperUtil.getHtml(tmp);
                  }
                  info = {
                    html: replacedHTML,
                    listType: k,
                    listStyle: j,
                    listStart: start,
                    origHtml
                  };
                  return false;
                }
              });
              if (info !== null) {
                return false;
              }
            });
            if (info !== null) {
              return false;
            }
          });
          return info;
        },
        _convertWordPasteList: function(content) {
          var div = document.createElement("div");
          var ul = null;
          var prevLevel = null;
          var indentLvl = {};
          var li = null;
          var newList = true;
          var prevType = null;
          var styleToLvl = {};
          var prevCssStyle = null;
          var circleCharsArray = [111, 118, 167, 183, 216, 222, 223, 252, 8721, 8226];
          var circleChars = [];
          for (var i = 0; i < circleCharsArray.length; i++) {
            circleChars.push(String.fromCharCode(circleCharsArray[i]));
          }
          circleChars = circleChars.join("|");
          var listTypes = {
            ul: {
              circle: ["^(?:" + circleChars + ")(?:\\s|&nbsp;)+"]
            },
            ol: {
              i: ["^[ivxlcdm]+[\\.\\)](\\s|&nbsp;)+"],
              I: ["^[IVXLCDM]+[\\.\\)](\\s|&nbsp;)+"],
              a: ["^[a-z]+[\\.\\)](\\s|&nbsp;)+"],
              A: ["^[A-Z]+[\\.\\)](\\s|&nbsp;)+"],
              decimal: ["^((?:\\d+|[a-z][^a-z])[\\.\\)]?)+(?:\\s|&nbsp;)+"]
            }
          };
          ViperUtil.setHtml(div, content);
          var pElems = ViperUtil.getTag("p", div);
          var pln = pElems.length;
          for (var i = 0; i < pln; i++) {
            var pEl = pElems[i];
            var listTypeInfo = this._getListType(pEl, listTypes);
            if (listTypeInfo === null) {
              newList = true;
              styleToLvl = {};
              prevLevel = null;
              continue;
            }
            var listType = listTypeInfo.listType;
            var listStyle = listTypeInfo.listStyle;
            var level = (pEl.getAttribute("style") || "").match(/level([\d])+/im);
            var cssStyle = pEl.getAttribute("style");
            ViperUtil.setHtml(pEl, listTypeInfo.html);
            if (listType === "ol" && listTypeInfo.origHtml.indexOf("v") === 0) {
              listType = "ul";
            }
            if (ViperUtil.isTag(pEl.parentNode, "li") === true) {
              listType = ViperUtil.getTagName(pEl.parentNode.parentNode);
            }
            if (!level) {
              level = prevLevel || 1;
            } else {
              level = level[1];
            }
            if (prevType !== listType && level === prevLevel) {
              newList = true;
            }
            prevType = listType;
            if (!listType) {
              listType = "ol";
            }
            if (newList === true) {
              ul = document.createElement(listType);
              indentLvl = {};
              if (listTypeInfo.listStart > 1) {
                ViperUtil.attr(ul, "start", listTypeInfo.listStart);
              }
              if (listStyle !== "decimal" && listStyle !== "circle") {
                ul.setAttribute("type", listStyle);
              }
              indentLvl[level] = ul;
              if (ViperUtil.isTag(pEl.parentNode, "li") === true) {
                ViperUtil.insertBefore(pEl.parentNode.parentNode, ul);
                ViperUtil.remove(pEl.parentNode.parentNode);
              } else {
                ViperUtil.insertBefore(pEl, ul);
              }
            } else {
              if (level !== prevLevel) {
                if (ViperUtil.isset(indentLvl[level]) === true) {
                  ul = indentLvl[level];
                  for (var lv in indentLvl) {
                    if (lv > level) {
                      delete indentLvl[lv];
                    }
                  }
                } else if (level > prevLevel) {
                  ul = document.createElement(listType);
                  if (listStyle !== "decimal" && listStyle !== "circle") {
                    ul.setAttribute("type", listStyle);
                  }
                  li.appendChild(ul);
                  indentLvl[level] = ul;
                }
              }
            }
            li = this._createListItemFromElement(pEl);
            ul.appendChild(li);
            prevLevel = level;
            ViperUtil.remove(pEl);
            newList = false;
          }
          var nestedLists = ViperUtil.find(div, "ol > ol,ol > ul, ul > ul, ul > ol");
          for (var i = 0; i < nestedLists.length; i++) {
            var list = nestedLists[i];
            if (!list.previousElementSibling && !list.nextElementSibling) {
              ViperUtil.insertBefore(list.parentNode, list);
              ViperUtil.remove(list.nextElementSibling);
            }
          }
          var lists = ViperUtil.getTag("ul,ol", div);
          var lc = lists.length;
          for (var i = 0; i < lc; i++) {
            var list = lists[i];
            var styleToType = {
              "lower-alpha": "a",
              "lower-roman": "i",
              "upper-alpha": "A",
              "upper-roman": "I"
            };
            var listStyle = ViperUtil.getStyle(list, "list-style-type");
            if (listStyle) {
              var type = styleToType[listStyle];
              if (type) {
                list.setAttribute("type", type);
              }
            }
            ViperUtil.removeAttr(list, "style");
            if (ViperUtil.isTag(list.parentNode, "ul") === true || ViperUtil.isTag(list.parentNode, "ol") === true) {
              var prevSibling = list.previousSibling;
              while (prevSibling) {
                if (ViperUtil.isTag(prevSibling, "li") === true) {
                  prevSibling.appendChild(list);
                  break;
                }
                prevSibling = prevSibling.previousSibling;
              }
            }
          }
          var listItems = ViperUtil.getTag("li", div);
          var c = listItems.length;
          for (var i = 0; i < c; i++) {
            var li = listItems[i];
            ViperUtil.removeAttr(li, "style");
            if (!li.parentNode || ViperUtil.isTag(li.parentNode, "ul") !== true && ViperUtil.isTag(li.parentNode, "ol") !== true) {
              var list = null;
              var sibling = li.previousSibling;
              while (sibling) {
                if (sibling.nodeType === ViperUtil.TEXT_NODE && ViperUtil.trim(sibling.data) !== "") {
                  break;
                } else if (ViperUtil.isTag(sibling, "ol") === true || ViperUtil.isTag(sibling, "ul") === true) {
                  list = sibling;
                  break;
                } else if (sibling.nodeType === ViperUtil.ELEMENT_NODE) {
                  break;
                }
                sibling = sibling.previousSibling;
              }
              if (list) {
                list.appendChild(li);
              } else {
                list = document.createElement("ul");
                ViperUtil.insertBefore(li, list);
                list.appendChild(li);
              }
            }
          }
          var pInLI = ViperUtil.find(div, "li > p");
          for (var i = 0; i < pInLI.length; i++) {
            while (pInLI[i].firstChild) {
              ViperUtil.insertBefore(pInLI[i], pInLI[i].firstChild);
            }
            ViperUtil.remove(pInLI[i]);
          }
          this._joinSplitLists(div);
          content = ViperUtil.getHtml(div);
          return content;
        },
        removeEmptyNodes: function(node) {
          if (node && node.nodeType === ViperUtil.ELEMENT_NODE) {
            if ((!node.firstChild || ViperUtil.isBlank(ViperUtil.getHtml(node)) === true) && ViperUtil.isStubElement(node) === false) {
              if (ViperUtil.isTag(node, "td") !== true && ViperUtil.isTag(node, "th") !== true) {
                var parent = node.parentNode;
                parent.removeChild(node);
                this.removeEmptyNodes(parent);
              }
            }
          }
        },
        _createListItemFromElement: function(elem) {
          var li = document.createElement("li");
          while (elem.firstChild) {
            li.appendChild(elem.firstChild);
          }
          return li;
        },
        _cleanPaste: function(content) {
          content = ViperUtil.trim(content);
          content = content.replace(/<(meta|link|base)[^>]+>/gi, "");
          content = content.replace(/<title[\s\S]*?<\/title>/gi, "");
          content = content.replace(/<style[\s\S]*?<\/style>/gi, "");
          var pos = content.indexOf("<!--EndFragment-->");
          if (pos > 0) {
            content = content.substr(0, pos);
          }
          content = content.replace(/<!--(.|\s)*?-->/gi, "");
          content = content.replace(/<b(\s+|>)/gi, "<strong$1");
          content = content.replace(/<\/b(\s+|>)/gi, "</strong$1");
          content = content.replace(/<i(\s+|>)/gi, "<em$1");
          content = content.replace(/<\/i(\s+|>)/gi, "</em$1");
          content = content.replace(/<s(\s+|>)/gi, "<del$1");
          content = content.replace(/<\/s(\s+|>)/gi, "</del$1");
          content = content.replace(/<strike(\s+|>)/gi, "<del$1");
          content = content.replace(/<\/strike(\s+|>)/gi, "</del$1");
          return content;
        },
        _moveChildren: function(cont, beforeElem) {
          beforeElem = beforeElem || cont;
          while (ViperUtil.isset(cont.firstChild) === true) {
            ViperUtil.insertBefore(beforeElem, cont.firstChild);
          }
        },
        _updateSelection: function() {
          try {
            if (this._tmpNode !== null && ViperUtil.isPartOfDOM(this._tmpNode, this.viper.getViperElement()) === true) {
              var range = this.viper.getCurrentRange();
              range.setEnd(this._tmpNode, this._tmpNodeOffset);
              range.setStart(this._tmpNode, this._tmpNodeOffset);
              range.collapse(true);
              ViperSelection.addRange(range);
            }
            if (this._bookmark) {
              this.viper.removeBookmarks(null, true);
            }
            ViperUtil.remove(this.pasteElement);
            this._tmpNode = null;
            this.pasteElement = null;
          } catch (e) {
          }
        }
      };
    };
  }
});

// src/Plugins/ViperToolbarPlugin/ViperToolbarPlugin.js
var ViperToolbarPlugin_exports = {};
__export(ViperToolbarPlugin_exports, {
  registerPlugin: () => registerPlugin11
});
var registerPlugin11;
var init_ViperToolbarPlugin = __esm({
  "src/Plugins/ViperToolbarPlugin/ViperToolbarPlugin.js"() {
    "use strict";
    init_addClass();
    init_removeClass();
    registerPlugin11 = (Viper2) => {
      const { Util: ViperUtil, Selection: ViperSelection, _ } = Viper2;
      function ViperToolbarPlugin(viper) {
        this.viper = viper;
        this._toolbar = null;
        this._activeBubble = null;
        this._bubbles = {};
        this._bubbleButtons = {};
        this._settingButtons = null;
        this._enabled = false;
        this._enabledButtons = [];
        this.createToolbar();
        var self = this;
        var clickedOutside = false;
        this.viper.registerCallback("Viper:selectionChanged", "ViperToolbarPlugin", function(range) {
          if (clickedOutside === true || self.viper.rangeInViperBounds(range) === false) {
            return;
          }
          if (self._enabled !== true) {
            self.enable();
          }
          self._updateToolbar(range);
        });
        this.viper.registerCallback("Viper:editableElementChanged", "ViperToolbarPlugin", function(range) {
          self._updateToolbar();
        });
        this.viper.registerCallback("Viper:enabled", "ViperToolbarPlugin", function(range) {
          self._updateToolbar();
        });
        this.viper.registerCallback("Viper:disabled", "ViperToolbarPlugin", function(range) {
          self.disable();
        });
        this.viper.registerCallback("Viper:clickedOutside", "ViperToolbarPlugin", function(range) {
          clickedOutside = true;
          self.disable();
        });
        this.viper.registerCallback("Viper:clickedInside", "ViperToolbarPlugin", function(range) {
          clickedOutside = false;
        });
        this.viper.registerCallback("Viper:focused", "ViperToolbarPlugin", function(range) {
          self.enable();
        });
        this.viper.registerCallback("Viper:mouseDown", "ViperToolbarPlugin", function() {
          if (self._activeBubble) {
            var bubble = self.getBubble(self._activeBubble);
            if (bubble && bubble.getSetting("keepOpen") !== true) {
              self.closeBubble(self._activeBubble);
            }
          }
        });
        this.viper.registerCallback("Viper:destroy", "ViperToolbarPlugin", function(range) {
          self.remove();
        });
      }
      Viper2.PluginManager.addPlugin("ViperToolbarPlugin", ViperToolbarPlugin);
      ViperToolbarPlugin.prototype = {
        init: function() {
          this.viper.addElement(this._toolbar);
        },
        setSettings: function(settings) {
          if (!settings) {
            return;
          }
          for (var setting in settings) {
            this.setSetting(setting, settings[setting]);
          }
        },
        setSetting: function(setting, value) {
          switch (setting) {
            case "parent":
              var parent = value;
              if (typeof parent === "string") {
                parent = ViperUtil.getid(parent);
              }
              this.setParentElement(parent);
              break;
            case "buttons":
              this.setButtons(value);
              break;
            case "allowButtonWrap":
              if (value === true) {
                addClass(this._toolbar, `buttonWrap`);
              } else {
                removeClass(this._toolbar, `buttonWrap`);
              }
              break;
          }
        },
        setButtons: function(buttons) {
          this._settingButtons = buttons;
          while (this._toolbar.firstChild) {
            this._toolbar.removeChild(this._toolbar.firstChild);
          }
          var buttonsLen = buttons.length;
          for (var i = 0; i < buttonsLen; i++) {
            if (typeof buttons[i] === "string") {
              var button = this.viper.Tools.getItem(buttons[i]);
              if (!button || button.type !== "button") {
                continue;
              }
              this._toolbar.appendChild(button.element);
            } else if (buttons[i].length) {
              var groupid = "ViperToolbarPlugin:buttons:" + i;
              var group = this.viper.Tools.createButtonGroup(groupid);
              var subButtonsLen = buttons[i].length;
              for (var j = 0; j < subButtonsLen; j++) {
                var button = this.viper.Tools.getItem(buttons[i][j]);
                if (!button || button.type !== "button") {
                  continue;
                }
                this.viper.Tools.addButtonToGroup(buttons[i][j], groupid);
              }
              this._toolbar.appendChild(group);
            }
          }
          this._settingButtons = null;
        },
        createToolbar: function() {
          var elem = document.createElement("div");
          ViperUtil.addClass(elem, "ViperTP-bar Viper-themeDark Viper-scalable");
          this._toolbar = elem;
          ViperUtil.addClass(this._toolbar, "viper-inactive");
          ViperUtil.addClass(this._toolbar, this.viper.getElementHolder().className);
          ViperUtil.addEvent(elem, "mousedown", function(e) {
            var target = ViperUtil.getMouseEventTarget(e);
            if (ViperUtil.isTag(target, "input") !== true && ViperUtil.isTag(target, "textarea") !== true && ViperUtil.isTag(target, "select") !== true) {
              ViperUtil.preventDefault(e);
              return false;
            }
          });
          ViperUtil.addEvent(elem, "mouseup", function(e) {
            var target = ViperUtil.getMouseEventTarget(e);
            if (ViperUtil.isTag(target, "input") !== true && ViperUtil.isTag(target, "textarea") !== true && ViperUtil.isTag(target, "select") !== true) {
              ViperUtil.preventDefault(e);
              return false;
            }
          });
          if (navigator.userAgent.match(/iPad/i) !== null) {
            ViperUtil.addClass(this._toolbar, "device-ipad");
          }
        },
        setParentElement: function(parent) {
          ViperUtil.setStyle(this._toolbar, "position", "absolute");
          ViperUtil.setStyle(this._toolbar, "top", "0px");
          parent.appendChild(this._toolbar);
          this.positionUpdated();
        },
        positionUpdated: function() {
          this.positionBubble();
          this.viper.fireCallbacks("ViperToolbarPlugin:positionUpdated");
        },
        /**
         * Adds the specified button or button group element to the tools panel.
         *
         * @param {DOMNode} button The button or the button group element.
         *
         * @return void
         */
        addButton: function(button) {
          if (!this._settingButtons) {
            this._toolbar.appendChild(button);
          }
        },
        createBubble: function(id, title, subSectionElement, toolsElement, openCallback, closeCallback, customClass) {
          title = title || "&nbsp;";
          var bubble = document.createElement("div");
          ViperUtil.addClass(bubble, "ViperITP Viper-themeDark Viper-visible Viper-forTopbar");
          ViperUtil.setHtml(bubble, '<div class="ViperITP-header">' + title + "</div>");
          ViperUtil.addEvent(bubble, "mousedown", function(e) {
            var target = ViperUtil.getMouseEventTarget(e);
            if (ViperUtil.isTag(target, "input") !== true && ViperUtil.isTag(target, "textarea") !== true && ViperUtil.isTag(target, "select") !== true) {
              ViperUtil.preventDefault(e);
              return false;
            }
          });
          if (toolsElement) {
            var wrapper = document.createElement("div");
            ViperUtil.addClass(wrapper, "ViperITP-tools");
            bubble.appendChild(wrapper);
            wrapper.appendChild(toolsElement);
          }
          if (customClass) {
            ViperUtil.addClass(bubble, customClass);
          }
          var self = this;
          this._bubbles[id] = bubble;
          var bubbleObj = {
            type: "VTPBubble",
            element: bubble,
            addSubSection: function(id2, element) {
              var wrapper2 = ViperUtil.getClass("ViperITP-subSectionWrapper", bubble);
              if (wrapper2.length > 0) {
                wrapper2 = wrapper2[0];
              } else {
                wrapper2 = document.createElement("div");
                ViperUtil.setHtml(wrapper2, '<span class="Viper-subSectionArrow"></span>');
                ViperUtil.addClass(wrapper2, "ViperITP-subSectionWrapper");
                bubble.appendChild(wrapper2);
              }
              var form = document.createElement("form");
              ViperUtil.addClass(form, "Viper-subSection");
              form.onsubmit = function() {
                return false;
              };
              var submitBtn = document.createElement("input");
              submitBtn.type = "submit";
              ViperUtil.setStyle(submitBtn, "display", "none");
              form.appendChild(submitBtn);
              form.appendChild(element);
              wrapper2.appendChild(form);
              this._subSections[id2] = form;
              self.viper.Tools.addItem(id2, {
                type: "VTPSubSection",
                element: wrapper2,
                form,
                setActionButtonTitle: function(title2) {
                  self.viper.Tools.getItem(id2 + "-applyButton").setContent(title2);
                }
              });
              return element;
            },
            showSubSection: function(id2) {
              if (this._activeSubSection) {
                if (this._activeSubSection !== id2) {
                  this.hideSubSection(this._activeSubSection);
                } else {
                  return;
                }
              }
              ViperUtil.addClass(bubble, "Viper-subSectionVisible");
              ViperUtil.addClass(this._subSections[id2], "Viper-active");
              if (this._subSectionButtons[id2]) {
                var button = this._subSectionButtons[id2].element;
                ViperUtil.addClass(button, "Viper-selected");
                var subSectionArrow = ViperUtil.getClass("Viper-subSectionArrow", bubble)[0];
                var pos = ViperUtil.getBoundingRectangle(button);
                var bubblePos = ViperUtil.getBoundingRectangle(bubble);
                ViperUtil.setStyle(subSectionArrow, "left", pos.x1 - bubblePos.x1 + (pos.x2 - pos.x1) / 2 + "px");
                ViperUtil.addClass(subSectionArrow, "Viper-visible");
              }
              var inputElements = ViperUtil.getTag("input[type=text], textarea", this._subSections[id2]);
              if (inputElements.length > 0 && self._canFocusField(inputElements[0]) === true) {
                try {
                  setTimeout(function() {
                    inputElements[0].focus();
                  }, 10);
                } catch (e) {
                }
              }
              this._activeSubSection = id2;
            },
            hideSubSection: function(id2) {
              id2 = id2 || this._activeSubSection;
              ViperUtil.removeClass(bubble, "Viper-subSectionVisible");
              ViperUtil.removeClass(this._subSections[id2], "Viper-active");
              this._activeSubSection = null;
              if (this._subSectionButtons[id2]) {
                ViperUtil.removeClass(this._subSectionButtons[id2].element, "Viper-selected");
              }
            },
            setSubSectionButton: function(sectionid, buttonid) {
              if (!this._subSections[sectionid]) {
                return false;
              }
              var button = self.viper.Tools.getItem(buttonid);
              if (!button || !button.type === "button") {
                return false;
              }
              this._subSectionButtons[sectionid] = button;
            },
            setSubSectionAction: function(subSectionid, action, widgetids, customButtonid, noFocus) {
              widgetids = widgetids || [];
              var tools = self.viper.Tools;
              var subSection = tools.getItem(subSectionid);
              if (!subSection) {
                return;
              }
              this.updateSubSectionAction(subSectionid, action);
              var buttonid = customButtonid;
              var _self = this;
              subSection.form.onsubmit = function(e) {
                if (e) {
                  ViperUtil.preventDefault(e);
                }
                if (!buttonid) {
                  buttonid = subSectionid + "-applyButton";
                }
                var button2 = tools.getItem(buttonid);
                if (button2.isEnabled() === false) {
                  return false;
                }
                if (noFocus !== true) {
                  self.viper.focus();
                }
                if (!customButtonid) {
                  tools.disableButton(subSectionid + "-applyButton");
                }
                var action2 = _self.getSubsectionAction(subSectionid);
                try {
                  action2.call(this);
                } catch (e2) {
                  console.error(e2.message);
                }
                setTimeout(function() {
                  var inputElements = ViperUtil.getTag("input[type=text], textarea", subSection.form);
                  for (var i = 0; i < inputElements.length; i++) {
                    if (self._canFocusField(inputElements[i]) === true) {
                      try {
                        inputElements[i].focus();
                      } catch (e2) {
                      }
                    }
                  }
                }, 50);
                return false;
              };
              if (!buttonid) {
                var button = tools.createButton(
                  subSectionid + "-applyButton",
                  _("Apply Changes"),
                  _("Apply Changes"),
                  "",
                  subSection.form.onsubmit,
                  true
                );
                subSection.form.appendChild(button);
              }
              this.addSubSectionActionWidgets(subSectionid, widgetids);
            },
            updateSubSectionAction: function(subSectionid, action) {
              this._subSectionActions[subSectionid] = action;
            },
            getSubsectionAction: function(subSectionid) {
              return this._subSectionActions[subSectionid];
            },
            addSubSectionActionWidgets: function(subSectionid, widgetids) {
              if (!this._subSectionActionWidgets[subSectionid]) {
                this._subSectionActionWidgets[subSectionid] = [];
              }
              var subsec = this;
              var tools = self.viper.Tools;
              for (var i = 0; i < widgetids.length; i++) {
                this._subSectionActionWidgets[subSectionid].push(widgetids[i]);
                (function(widgetid) {
                  self.viper.registerCallback("ViperTools:changed:" + widgetid, "ViperToolbarPlugin", function() {
                    var subSectionWidgets = subsec._subSectionActionWidgets[subSectionid];
                    var c = subSectionWidgets.length;
                    var enable = true;
                    for (var j = 0; j < c; j++) {
                      var widget = tools.getItem(subSectionWidgets[j]);
                      if (widget && widget.required === true && ViperUtil.trim(widget.getValue()) === "") {
                        enable = false;
                        break;
                      }
                    }
                    if (enable === true) {
                      tools.enableButton(subSectionid + "-applyButton");
                    } else {
                      tools.disableButton(subSectionid + "-applyButton");
                    }
                  });
                })(widgetids[i]);
              }
            },
            setSetting: function(setting, value) {
              this._settings[setting] = value;
            },
            getSetting: function(setting) {
              return this._settings[setting];
            },
            setTitle: function(title2) {
              ViperUtil.setHtml(ViperUtil.getClass("ViperITP-header", bubble)[0], title2);
            },
            getActiveSubSection: function() {
              return this._subSections[this._activeSubSection];
            },
            _settings: {
              keepOpen: false
            },
            _subSections: {},
            _subSectionButtons: {},
            _activeSubSection: null,
            _openCallback: openCallback,
            _closeCallback: closeCallback,
            _subSectionActionWidgets: {},
            _subSectionActions: {}
          };
          if (subSectionElement) {
            bubbleObj.addSubSection(id + "SubSection", subSectionElement);
            if (!toolsElement) {
              bubbleObj.showSubSection(id + "SubSection");
            }
          }
          this.viper.Tools.addItem(id, bubbleObj);
          return bubble;
        },
        getBubble: function(id) {
          return this.viper.Tools.getItem(id);
        },
        setBubbleButton: function(bubbleid, buttonid, useCustomToggler) {
          if (!this._bubbles[bubbleid]) {
            return false;
          }
          var bubble = this.getBubble(bubbleid);
          var button = this.viper.Tools.getItem(buttonid).element;
          var self = this;
          this._bubbleButtons[bubbleid] = buttonid;
          if (useCustomToggler !== true) {
            ViperUtil.removeEvent(button, "mousedown");
            ViperUtil.addEvent(button, "mousedown", function(e) {
              if (ViperUtil.hasClass(button, "Viper-disabled") === true) {
                return;
              }
              self.toggleBubble(bubbleid);
              ViperUtil.preventDefault(e);
            });
          }
        },
        toggleBubble: function(bubbleid) {
          if (!this._activeBubble || this._activeBubble !== bubbleid) {
            this.showBubble(bubbleid);
            return true;
          } else {
            this.closeBubble(bubbleid);
            return false;
          }
        },
        closeBubble: function(bubbleid) {
          if (!this._activeBubble) {
            return;
          }
          if (this._closeBubble(bubbleid) !== false) {
            this.viper.focus();
            this.viper.highlightToSelection();
          }
        },
        _closeBubble: function(bubbleid) {
          ViperUtil.removeClass(this.viper.Tools.getItem(this._bubbleButtons[bubbleid]).element, "Viper-selected");
          var bubble = this.viper.Tools.getItem(bubbleid);
          var bubbleElem = bubble.element;
          if (bubbleElem.parentNode && bubbleElem.parentNode.nodeType !== ViperUtil.DOCUMENT_FRAGMENT_NODE) {
            bubbleElem.parentNode.removeChild(bubbleElem);
          } else {
            return false;
          }
          if (bubble._closeCallback) {
            bubble._closeCallback.call(this);
          }
          this.viper.fireCallbacks("ViperToolbarPlugin:bubbleClosed", bubbleid);
          if (this._activeBubble === bubbleid) {
            this._activeBubble = null;
          }
          ViperUtil.removeEvent(document, "keydown.ViperToolbarPluginSubSection");
        },
        showBubble: function(bubbleid) {
          if (this._activeBubble) {
            if (this._activeBubble === bubbleid) {
              return;
            }
            this._closeBubble(this._activeBubble);
          }
          ViperUtil.addClass(this.viper.Tools.getItem(this._bubbleButtons[bubbleid]).element, "Viper-selected");
          var bubble = this.viper.Tools.getItem(bubbleid);
          var bubbleElem = bubble.element;
          if (bubble._openCallback) {
            bubble._openCallback.call(this);
          }
          if (!bubbleElem.parentNode || bubbleElem.parentNode.nodeType === ViperUtil.DOCUMENT_FRAGMENT_NODE) {
            this._toolbar.appendChild(bubbleElem);
          }
          for (var subSectionid in bubble._subSections) {
            var applyChangesBtn = this.viper.Tools.getItem(subSectionid + "-applyButton");
            if (applyChangesBtn) {
              this.viper.Tools.disableButton(subSectionid + "-applyButton");
            }
          }
          this.positionBubble(bubbleid);
          this._activeBubble = bubbleid;
          var inputElements = ViperUtil.getTag("input[type=text], textarea", bubbleElem);
          for (var i = 0; i < inputElements.length; i++) {
            if (this._canFocusField(inputElements[i]) === true) {
              try {
                setTimeout(function() {
                  inputElements[i].focus();
                }, 10);
              } catch (e) {
              }
              break;
            }
          }
          var inlineToolbarPlugin = this.viper.getPluginManager().getPlugin("ViperInlineToolbarPlugin");
          if (inlineToolbarPlugin) {
            inlineToolbarPlugin.hideToolbar();
          }
          ViperUtil.removeEvent(document, "keydown.ViperToolbarPluginSubSection");
          ViperUtil.addEvent(document, "keydown.ViperToolbarPluginSubSection", function(e) {
            if (e.which === 13 && bubble.getActiveSubSection()) {
              return bubble.getActiveSubSection().onsubmit();
            }
          });
        },
        _canFocusField: function(field) {
          if (ViperUtil.getElementWidth(field) !== 0 && (ViperUtil.isBrowser("chrome") !== true || ViperUtil.getElementCoords(field).x > 0)) {
            return true;
          }
          return false;
        },
        getActiveBubble: function() {
          if (!this._activeBubble) {
            return null;
          }
          return this.getBubble(this._activeBubble);
        },
        positionBubble: function(bubbleid) {
          bubbleid = bubbleid || this._activeBubble;
          if (!bubbleid) {
            return;
          }
          var bubble = this.viper.Tools.getItem(bubbleid).element;
          var button = this.viper.Tools.getItem(this._bubbleButtons[bubbleid]).element;
          var toolsWidth = ViperUtil.getElementWidth(bubble);
          var scrollCoords = ViperUtil.getScrollCoords();
          var windowDim = ViperUtil.getWindowDimensions();
          var elemDim = ViperUtil.getBoundingRectangle(button);
          var toolbarDim = ViperUtil.getBoundingRectangle(this._toolbar);
          var left = elemDim.x1 + (elemDim.x2 - elemDim.x1) / 2 - toolsWidth / 2 - scrollCoords.x - toolbarDim.x1;
          if (left + toolsWidth >= windowDim.width) {
            left -= toolsWidth / 2 - 40;
            ViperUtil.addClass(bubble, "Viper-orientationLeft");
          } else {
            ViperUtil.removeClass(bubble, "Viper-orientationLeft");
          }
          ViperUtil.setStyle(bubble, "left", left + "px");
          ViperUtil.setStyle(bubble, "top", "35px");
        },
        disable: function() {
          if (this._enabled === false) {
            return;
          }
          this._enabled = false;
          ViperUtil.removeClass(this._toolbar, "viper-active");
          ViperUtil.addClass(this._toolbar, "viper-inactive");
          if (this._activeBubble) {
            this.closeBubble(this._activeBubble);
          }
          var buttons = ViperUtil.getClass("Viper-button", this._toolbar);
          var c = buttons.length;
          var viperid = this.viper.getId();
          var enabledButtons = [];
          for (var i = 0; i < c; i++) {
            var buttonid = buttons[i].id.replace(viperid + "-", "");
            if (this.viper.Tools.getItem(buttonid).isEnabled() === true) {
              enabledButtons.push(buttonid);
            }
            this.viper.Tools.disableButton(buttonid);
          }
          this._enabledButtons = enabledButtons;
          this.viper.fireCallbacks("ViperToolbarPlugin:disabled");
        },
        enable: function() {
          if (this._enabled === true || this.viper.fireCallbacks("ViperToolbarPlugin:canEnableToolbar") === false) {
            return;
          }
          this._enabled = true;
          ViperUtil.removeClass(this._toolbar, "viper-inactive");
          ViperUtil.addClass(this._toolbar, "viper-active");
          while (this._enabledButtons.length) {
            this.viper.Tools.enableButton(this._enabledButtons.pop());
          }
          this.viper.fireCallbacks("ViperToolbarPlugin:enabled");
        },
        hide: function() {
          ViperUtil.setStyle(this._toolbar, "display", "none");
        },
        show: function() {
          ViperUtil.setStyle(this._toolbar, "display", "block");
        },
        isDisabled: function() {
          return !this._enabled;
        },
        isVisible: function() {
          if (ViperUtil.getStyle(this._toolbar, "display") === "none") {
            return false;
          }
          return true;
        },
        exists: function() {
          if (this._toolbar) {
            return true;
          }
          return false;
        },
        remove: function() {
          ViperUtil.remove(this._toolbar);
        },
        isPluginElement: function(element) {
          if (element !== this._toolbar && ViperUtil.isChildOf(element, this._toolbar) === false) {
            return false;
          }
          return true;
        },
        _updateToolbar: function(range) {
          if (this.viper.isEnabled() === false || this._enabled === false) {
            return;
          }
          range = range || this.viper.getCurrentRange();
          this.viper.fireCallbacks("ViperToolbarPlugin:updateToolbar", { range });
        }
      };
    };
  }
});

// src/Plugins/ViperInlineToolbarPlugin/ViperInlineToolbarPlugin.js
var ViperInlineToolbarPlugin_exports = {};
__export(ViperInlineToolbarPlugin_exports, {
  registerPlugin: () => registerPlugin12
});
var registerPlugin12;
var init_ViperInlineToolbarPlugin = __esm({
  "src/Plugins/ViperInlineToolbarPlugin/ViperInlineToolbarPlugin.js"() {
    "use strict";
    registerPlugin12 = (Viper2) => {
      const { Util: ViperUtil, Selection: ViperSelection, _ } = Viper2;
      function ViperInlineToolbarPlugin(viper) {
        this.viper = viper;
        this._lineage = null;
        this._lineageClicked = false;
        this._currentLineageIndex = null;
        this._lineageItemSelected = false;
        this._margin = 15;
        this._toolbarWidget = null;
        this._selectionLineage = [];
        this._toolbarElement = null;
        this._subSections = {};
        this._subSectionButtons = {};
        this._subSectionActionWidgets = {};
        this._topToolbar = null;
        this._buttons = null;
        this._initialised = false;
      }
      Viper2.PluginManager.addPlugin("ViperInlineToolbarPlugin", ViperInlineToolbarPlugin);
      ViperInlineToolbarPlugin.prototype = {
        init: function() {
          var self = this;
          this._topToolbar = this.viper.getPluginManager().getPlugin("ViperToolbarPlugin");
          this._initToolbar();
          this.viper.registerCallback("Viper:selectionChanged", "ViperInlineToolbarPlugin", function() {
            if (self._toolbarWidget.isVisible() === false) {
              self._setCurrentLineageIndex(null);
            }
          });
          this.viper.registerCallback("Viper:rightMouseDown", "ViperInlineToolbarPlugin", function(e) {
            if (ViperUtil.isChildOf(e.target, self._toolbarElement) === false) {
              self.hideToolbar();
            }
          });
          this.viper.registerCallback("Viper:mouseUp", "ViperInlineToolbarPlugin", function(e) {
            if (self.viper._mouseDownEvent && ViperUtil.isChildOf(self.viper._mouseDownEvent.target, self._toolbarElement) === true) {
              return false;
            }
          });
          this.viper.registerCallback("Viper:getNodeSelection", "ViperInlineToolbarPlugin", function(data) {
            var lineage = self.getLineage();
            var currentLinIndex = self.getCurrentLineageIndex();
            var element = lineage[currentLinIndex];
            if (element && element.nodeType !== ViperUtil.TEXT_NODE) {
              return element;
            }
            return null;
          });
        },
        setSettings: function(settings) {
          if (!settings) {
            return;
          }
          if (settings.buttons) {
            this._buttons = settings.buttons;
            if (this._toolbarWidget) {
              this._toolbarWidget.orderButtons(this._buttons);
            }
          }
        },
        getToolbar: function() {
          return this._toolbarWidget;
        },
        _initToolbar: function() {
          var tools = this.viper.Tools;
          var toolbarid = "ViperInlineToolbar";
          var self = this;
          var toolbarElem = tools.createInlineToolbar(
            toolbarid,
            false,
            null,
            function(range, nodeSelection, hasActiveSection) {
              self.updateToolbar(range, nodeSelection, hasActiveSection);
            }
          );
          this._toolbarWidget = tools.getItem(toolbarid);
          var lineage = document.createElement("ul");
          ViperUtil.addClass(lineage, "ViperITP-lineage");
          ViperUtil.insertBefore(toolbarElem.firstChild, lineage);
          this._lineage = lineage;
          this._toolbarElement = toolbarElem;
          var toolbar = tools.getItem(toolbarid);
          this.viper.fireCallbacks("ViperInlineToolbarPlugin:initToolbar", toolbar);
          this._initialised = true;
        },
        isInitialised: function() {
          return this._initialised;
        },
        /**
         * Upudates the toolbar.
         *
         * This method is usually called by the Viper:selectionChanged event.
         *
         * @param {DOMRange} range The DOMRange object.
         */
        updateToolbar: function(range, nodeSelection, hasActiveSection) {
          if (this._lineageClicked !== true) {
            this._updateOriginalSelection(range, nodeSelection);
          }
          if (this._topToolbar) {
            var bubble = this._topToolbar.getActiveBubble();
            if (bubble && bubble.getSetting("keepOpen") !== true) {
              return false;
            }
          }
          this._lineageItemSelected = false;
          if (this._lineageClicked !== true && hasActiveSection !== true) {
            this._setCurrentLineageIndex(null);
          }
          var lineage = this._getSelectionLineage(range, nodeSelection);
          this._selectionLineage = lineage;
          if (!lineage || lineage.length === 0) {
            return false;
          }
          if (ViperUtil.isBrowser("firefox") === true && ViperUtil.isTag(lineage[lineage.length - 1], "br") === true) {
            this.hideToolbar();
            return false;
          }
          this._updateInnerContainer(range, lineage, nodeSelection);
          if (this._lineageClicked === true) {
            this._lineageClicked = false;
            return false;
          }
          var selIndex = null;
          if (hasActiveSection === true) {
            selIndex = this.getCurrentLineageIndex();
          }
          this._updateLineage(lineage, selIndex);
        },
        hideToolbar: function() {
          this._toolbarWidget.hide();
        },
        /**
         * Fires the updateToolbar event so that other plugins can modify the contents of the toolbar.
         *
         * @param {DOMRange} range   The DOMRange object.
         * @param {array}    lineage The lineage array.
         */
        _updateInnerContainer: function(range, lineage, nodeSelection) {
          if (!lineage || lineage.length === 0) {
            return;
          }
          if (this._currentLineageIndex === null || this._currentLineageIndex >= lineage.length) {
            this._setCurrentLineageIndex(lineage.length - 1);
          }
          var data = {
            range,
            lineage,
            current: this._currentLineageIndex,
            toolbar: this._toolbarWidget,
            nodeSelection
          };
          this.viper.fireCallbacks("ViperInlineToolbarPlugin:updateToolbar", data);
        },
        /**
         * Returns a better tag name for the given DOMElement tag name.
         *
         * For example: strong -> Bold, u -> Underline.
         *
         * @param {string}  tagName The tag name of a DOMElement.
         * @param {DOMNode} tag     The source tag.
         *
         * @return {string} The readable name.
         */
        getReadableTagName: function(tagName, tag) {
          var readableTagName = this.viper.fireCallbacks("ViperInlineToolbarPlugin:getReadableTagName", {
            tagName,
            tag
          });
          if (readableTagName) {
            return readableTagName;
          }
          switch (tagName) {
            case "strong":
              tagName = _("Bold");
              break;
            case "u":
              tagName = _("Underline");
              break;
            case "em":
            case "i":
              tagName = _("Italic");
              break;
            case "li":
              tagName = _("Item");
              break;
            case "ul":
            case "ol":
              tagName = _("List");
              break;
            case "td":
              tagName = _("Cell");
              break;
            case "tr":
              tagName = _("Row");
              break;
            case "th":
              tagName = _("Header");
              break;
            case "a":
              tagName = _("Link");
              break;
            case "blockquote":
              tagName = _("Quote");
              break;
            case "img":
              tagName = _("Image");
              break;
            case "abbr":
              tagName = _("Abbreviation");
              break;
            case "sub":
              tagName = _("Subscript");
              break;
            case "sup":
              tagName = _("Superscript");
              break;
            case "del":
              tagName = _("Strikethrough");
              break;
            case "thead":
              tagName = _("Table Header");
              break;
            case "tfoot":
              tagName = _("Table Footer");
              break;
            case "tbody":
              tagName = _("Table Body");
              break;
            default:
              tagName = ViperUtil.ucFirst(tagName);
              break;
          }
          return tagName;
        },
        /**
         * Selects the specified lineage index.
         *
         * @param {integer} index The lineage index to select.
         */
        selectLineageItem: function(index) {
          var tags = ViperUtil.getTag("li", this._lineage);
          if (tags[index]) {
            ViperUtil.trigger(tags[index], "click");
          }
        },
        getLineage: function() {
          this._selectionLineage = this._getSelectionLineage();
          return this._selectionLineage;
        },
        getCurrentLineageIndex: function() {
          if (this._currentLineageIndex !== null && this.viper.getViperRange().collapsed === false) {
            return this._currentLineageIndex;
          } else if (this._selectionLineage.length === 0) {
            return 0;
          } else {
            return this._selectionLineage.length - 1;
          }
        },
        remove: function() {
          this.viper.Tools.removeItem("ViperInlineToolbar");
        },
        /**
         * Updates the contents of the lineage container.
         *
         * @param {array} lineage The lineage array.
         */
        _updateLineage: function(lineage, selIndex) {
          ViperUtil.empty(this._lineage);
          var viper = this.viper;
          var c = lineage.length;
          var self = this;
          var linElems = [];
          selIndex = selIndex || null;
          for (var i = 0; i < c; i++) {
            if (!lineage[i].tagName) {
              continue;
            }
            var tagName = lineage[i].tagName.toLowerCase();
            var parent = document.createElement("li");
            ViperUtil.addClass(parent, "ViperITP-lineageItem");
            if (i === c - 1 && selIndex === null || selIndex !== null && i === selIndex) {
              ViperUtil.addClass(parent, "Viper-selected");
            }
            ViperUtil.setHtml(parent, this.getReadableTagName(tagName, lineage[i]));
            this._lineage.appendChild(parent);
            linElems.push(parent);
            (function(clickElem, selectionElem, index) {
              ViperUtil.addEvent(clickElem, "click.ViperInlineToolbarPlugin", function(e) {
                self.viper.fireCallbacks("ViperInlineToolbarPlugin:lineageClicked");
                self._lineageClicked = true;
                self._setCurrentLineageIndex(index);
                ViperUtil.removeClass(linElems, "Viper-selected");
                ViperUtil.addClass(clickElem, "Viper-selected");
                self._selectNode(selectionElem);
                ViperUtil.preventDefault(e);
                return false;
              });
            })(parent, lineage[i], i);
          }
          if (this._originalRange.collapsed === true || lineage[lineage.length - 1].nodeType !== ViperUtil.TEXT_NODE) {
            return;
          }
          var parent = document.createElement("li");
          ViperUtil.addClass(parent, "ViperITP-lineageItem Viper-selected");
          ViperUtil.setHtml(parent, _("Selection"));
          linElems.push(parent);
          this._lineage.appendChild(parent);
          ViperUtil.addEvent(parent, "click.ViperInlineToolbarPlugin", function(e) {
            self.viper.fireCallbacks("ViperInlineToolbarPlugin:lineageClicked");
            self._lineageClicked = true;
            var prevIndex = self._currentLineageIndex;
            self._setCurrentLineageIndex(lineage.length - 1);
            ViperUtil.removeClass(linElems, "Viper-selected");
            ViperUtil.addClass(parent, "Viper-selected");
            self._selectPreviousRange(lineage, prevIndex);
            ViperUtil.preventDefault(e);
            return false;
          });
        },
        _selectNode: function(node) {
          this.viper.focus();
          var range = this.viper.getViperRange();
          if (this._lineageItemSelected === false) {
            this._updateOriginalSelection(range);
          }
          ViperSelection.removeAllRanges();
          range = this.viper.getViperRange();
          var first = range._getFirstSelectableChild(node);
          var last = range._getLastSelectableChild(node);
          if (!first || !last) {
            range.selectNode(node);
          } else {
            range.setStart(first, 0);
            range.setEnd(last, last.data.length);
          }
          ViperSelection.addRange(range);
          this.viper.fireCallbacks("ViperInlineToolbarPlugin:lineageItemSelected", node);
          this._toolbarWidget.closeActiveSubsection(true);
          this._toolbarWidget.setVerticalUpdateOnly(true);
          this.viper.fireSelectionChanged(range, true);
          this._toolbarWidget.setVerticalUpdateOnly(false);
          this._lineageItemSelected = true;
        },
        _selectPreviousRange: function(lineage, prevIndex) {
          this.viper.focus();
          ViperSelection.removeAllRanges();
          var range = this.viper.getViperRange();
          if (this._originalRange.nodeType) {
            range.selectNode(this._originalRange);
          } else {
            range.setStart(this._originalRange.startContainer, this._originalRange.startOffset);
            range.setEnd(this._originalRange.endContainer, this._originalRange.endOffset);
          }
          ViperSelection.addRange(range);
          this._toolbarWidget.closeActiveSubsection(true);
          this._toolbarWidget.setVerticalUpdateOnly(true);
          this.viper.fireSelectionChanged(range, true);
          this._toolbarWidget.setVerticalUpdateOnly(false);
          this._updateOriginalSelection(range);
        },
        _setCurrentLineageIndex: function(index) {
          this._currentLineageIndex = index;
        },
        _updateOriginalSelection: function(range, nodeSelection) {
          if (nodeSelection) {
            this._originalRange = nodeSelection;
            return;
          }
          this._originalRange = {
            startContainer: range.startContainer,
            endContainer: range.endContainer,
            startOffset: range.startOffset,
            endOffset: range.endOffset,
            collapsed: range.collapsed
          };
        },
        /**
         * Returns the selection's parent elements.
         *
         * @param {DOMRange} range The DOMRange object.
         *
         * @return {array} Array of DOMElements.
         */
        _getSelectionLineage: function(range, nodeSelection) {
          range = range || this.viper.getViperRange();
          var lineage = [];
          var parent = null;
          var nodeSelection = nodeSelection || range.getNodeSelection(range, true);
          var viperElement = this.viper.getViperElement();
          if (nodeSelection && viperElement !== nodeSelection) {
            parent = nodeSelection;
          } else {
            var startNode = range.getStartNode();
            if (!startNode) {
              return lineage;
            } else if (startNode.nodeType == ViperUtil.TEXT_NODE && (startNode.data.length === 0 || ViperUtil.isBlank(ViperUtil.trim(startNode.data)) === true) && startNode.nextSibling && startNode.nextSibling.nodeType === ViperUtil.TEXT_NODE) {
              startNode = startNode.nextSibling;
            }
            var endNode = range.getEndNode();
            if (startNode.nodeType !== ViperUtil.TEXT_NODE || ViperUtil.isBlank(startNode.data) !== true) {
              if (startNode.nodeType !== ViperUtil.TEXT_NODE && startNode !== range.getEndNode()) {
                if (endNode !== viperElement) {
                  lineage.push(range.getEndNode());
                } else {
                  var firstSelectable = range._getFirstSelectableChild(startNode);
                  lineage.push(firstSelectable);
                }
              } else {
                if (ViperUtil.isBrowser("edge") === true && startNode.nodeType === ViperUtil.TEXT_NODE && range.startOffset === startNode.data.length && range.collapsed === false && startNode.nextSibling && startNode.nextSibling.nodeType === ViperUtil.ELEMENT_NODE && ViperUtil.isStubElement(startNode.nextSibling) === false) {
                  var firstSelectable = range._getFirstSelectableChild(startNode.nextSibling);
                  if (firstSelectable) {
                    startNode = firstSelectable;
                  }
                }
                lineage.push(startNode);
                if (range.startContainer.nodeType === ViperUtil.TEXT_NODE && range.endContainer.nodeType === ViperUtil.TEXT_NODE && range.endOffset === 0 && range.getPreviousContainer(range.endContainer) === range.startContainer && range.endContainer.previousSibling !== range.startContainer) {
                  lineage.push(range.startContainer.parentNode);
                }
              }
            }
          }
          var viperElement = this.viper.getViperElement();
          if (parent === null) {
            var endNode = range.getEndNode();
            if (startNode && startNode === endNode) {
              parent = startNode.parentNode;
            } else if (range.endContainer === endNode && endNode.childNodes.length === range.endOffset && startNode.parentNode === endNode.childNodes[endNode.childNodes.length - 1]) {
              parent = startNode.parentNode;
            } else {
              parent = range.getCommonElement();
              if (this.viper.isOutOfBounds(parent) === true) {
                parent = viperElement;
              }
            }
          }
          if (parent === viperElement) {
            return lineage;
          }
          if (parent) {
            lineage.push(parent);
            parent = parent.parentNode;
            while (parent && parent !== viperElement) {
              if (parent === document) {
                return [];
              }
              lineage.push(parent);
              parent = parent.parentNode;
            }
          }
          lineage = lineage.reverse();
          return lineage;
        }
      };
    };
  }
});

// src/Plugins/ViperCoreStylesPlugin/ViperCoreStylesPlugin.js
var ViperCoreStylesPlugin_exports = {};
__export(ViperCoreStylesPlugin_exports, {
  registerPlugin: () => registerPlugin13
});
var registerPlugin13;
var init_ViperCoreStylesPlugin = __esm({
  "src/Plugins/ViperCoreStylesPlugin/ViperCoreStylesPlugin.js"() {
    "use strict";
    registerPlugin13 = (Viper2) => {
      const { Util: ViperUtil, Selection: ViperSelection, _ } = Viper2;
      function ViperCoreStylesPlugin(viper) {
        this.viper = viper;
        this.styleTags = ["strong", "em", "sub", "sup", "del"];
        this.toolbarPlugin = null;
        this._onChangeAddStyle = [];
        this._justifyButtons = ["left", "center", "right", "block"];
        this._buttons = {
          strong: "bold",
          em: "italic",
          sub: "subscript",
          sup: "superscript",
          del: "strikethrough",
          removeFormat: "removeFormat",
          hr: "hr",
          code: "code"
        };
      }
      Viper2.PluginManager.addPlugin("ViperCoreStylesPlugin", ViperCoreStylesPlugin);
      ViperCoreStylesPlugin.prototype = {
        handleKeyPress: function(e, type) {
          if (type) {
            return this.handleStyle(type);
          }
        },
        setSetting: function(setting, value) {
          switch (setting) {
            case "justifyButtons":
              value = value || this._justifyButtons;
              for (var i = 0; i < this._justifyButtons.length; i++) {
                if (ViperUtil.inArray(this._justifyButtons[i], value) === true) {
                  this.viper.Tools.getItem("ViperCoreStylesPlugin:vtp:" + this._justifyButtons[i]).show();
                } else {
                  this.viper.Tools.getItem("ViperCoreStylesPlugin:vtp:" + this._justifyButtons[i]).hide();
                }
              }
              break;
          }
        },
        init: function() {
          var self = this;
          var ctrlName = "CTRL";
          if (navigator.platform.toLowerCase().indexOf("mac") >= 0) {
            ctrlName = "CMD";
          }
          var tools = this.viper.Tools;
          var toolbarPlugin = this.viper.PluginManager.getPlugin("ViperToolbarPlugin");
          this.toolbarPlugin = toolbarPlugin;
          var toolbarButtons = {};
          var btnGroup = tools.createButtonGroup("ViperCoreStylesPlugin:vtp:stylesBtns");
          toolbarButtons.styles = ["strong", "em", "sub", "sup", "del", "code"];
          toolbarButtons.removeFormat = ["removeFormat"];
          toolbarButtons.justify = this._justifyButtons;
          toolbarButtons.other = ["hr"];
          tools.createButton(
            "bold",
            "",
            _("Bold"),
            "Viper-bold",
            function() {
              return self.handleStyle("strong");
            },
            true
          );
          tools.createButton(
            "italic",
            "",
            _("Italic"),
            "Viper-italic",
            function() {
              return self.handleStyle("em");
            },
            true
          );
          tools.createButton(
            "removeFormat",
            "",
            _("Remove Format"),
            "Viper-removeFormat",
            function() {
              self.removeFormat();
            },
            true
          );
          tools.addButtonToGroup("bold", "ViperCoreStylesPlugin:vtp:stylesBtns");
          tools.addButtonToGroup("italic", "ViperCoreStylesPlugin:vtp:stylesBtns");
          tools.addButtonToGroup("removeFormat", "ViperCoreStylesPlugin:vtp:stylesBtns");
          var btnGroup2 = tools.createButtonGroup("ViperCoreStylesPlugin:vtp:btnGroup2");
          tools.createButton(
            "subscript",
            "",
            _("Subscript"),
            "Viper-subscript",
            function() {
              self.handleStyle("sub");
            },
            true
          );
          tools.createButton(
            "superscript",
            "",
            _("Superscript"),
            "Viper-superscript",
            function() {
              self.handleStyle("sup");
            },
            true
          );
          tools.createButton(
            "strikethrough",
            "",
            _("Strikethrough"),
            "Viper-strikethrough",
            function() {
              self.handleStyle("del");
            },
            true
          );
          tools.createButton(
            "code",
            "",
            _("Code"),
            "Viper-code",
            function() {
              self.handleStyle("code");
            },
            true
          );
          tools.addButtonToGroup("subscript", "ViperCoreStylesPlugin:vtp:btnGroup2");
          tools.addButtonToGroup("superscript", "ViperCoreStylesPlugin:vtp:btnGroup2");
          tools.addButtonToGroup("strikethrough", "ViperCoreStylesPlugin:vtp:btnGroup2");
          tools.addButtonToGroup("code", "ViperCoreStylesPlugin:vtp:btnGroup2");
          var justifyBubbleContent = document.createElement("div");
          var btnGroup3 = tools.createButtonGroup("ViperCoreStylesPlugin:vtp:btnGroup3");
          tools.createButton("ViperCoreStylesPlugin:vtp:left", "", _("Left Justify"), "Viper-justifyLeft", function() {
            self.handleJustify("left");
          });
          tools.createButton(
            "ViperCoreStylesPlugin:vtp:center",
            "",
            _("Center Justify"),
            "Viper-justifyCenter",
            function() {
              self.handleJustify("center");
            }
          );
          tools.createButton("ViperCoreStylesPlugin:vtp:right", "", _("Right Justify"), "Viper-justifyRight", function() {
            self.handleJustify("right");
          });
          tools.createButton("ViperCoreStylesPlugin:vtp:block", "", _("Block Justify"), "Viper-justifyBlock", function() {
            self.handleJustify("justify");
          });
          tools.addButtonToGroup("ViperCoreStylesPlugin:vtp:left", "ViperCoreStylesPlugin:vtp:btnGroup3");
          tools.addButtonToGroup("ViperCoreStylesPlugin:vtp:center", "ViperCoreStylesPlugin:vtp:btnGroup3");
          tools.addButtonToGroup("ViperCoreStylesPlugin:vtp:right", "ViperCoreStylesPlugin:vtp:btnGroup3");
          tools.addButtonToGroup("ViperCoreStylesPlugin:vtp:block", "ViperCoreStylesPlugin:vtp:btnGroup3");
          justifyBubbleContent.appendChild(btnGroup3);
          var hr = tools.createButton(
            "hr",
            "",
            _("Horizontal Rule"),
            "Viper-insertHr",
            function() {
              self.handleHR();
            },
            true
          );
          tools.getItem("bold").setButtonShortcut("CTRL+B");
          tools.getItem("italic").setButtonShortcut("CTRL+I");
          if (toolbarPlugin) {
            toolbarPlugin.addButton(btnGroup);
            toolbarPlugin.addButton(btnGroup2);
            toolbarPlugin.createBubble(
              "ViperCoreStylesPlugin:justifyBubble",
              _("Justification"),
              null,
              justifyBubbleContent
            );
            var justifyBubbleToggle = tools.createButton(
              "justify",
              "",
              _("Toggle Justification"),
              "Viper-justifyLeft",
              null,
              true
            );
            toolbarPlugin.addButton(justifyBubbleToggle);
            toolbarPlugin.setBubbleButton("ViperCoreStylesPlugin:justifyBubble", "justify");
            toolbarPlugin.addButton(hr);
            this.viper.registerCallback("ViperToolbarPlugin:updateToolbar", "ViperCoreStylesPlugin", function(data) {
              var range = data;
              if (data.range) {
                range = data.range;
              }
              setTimeout(function() {
                self._updateToolbarButtonStates(toolbarButtons, range);
              }, 10);
              if (self._onChangeAddStyle.length > 0) {
                var style = null;
                while (style = self._onChangeAddStyle.shift()) {
                  self.viper.Tools.setButtonInactive(self._buttons[style]);
                }
              }
            });
          }
          this.viper.registerCallback("Viper:keyDown", "ViperCoreStylesPlugin", function(e) {
            if (e.which === 85 && (e.ctrlKey === true || e.metaKey === true)) {
              return false;
            }
          });
          this.viper.registerCallback("Viper:keyPress", "ViperCoreStylesPlugin", function(e) {
            if (self._onChangeAddStyle.length > 0 && ViperUtil.isInputKey(e) === true) {
              var character = String.fromCharCode(e.which);
              return self.viper.insertTextAtCaret(character);
            }
          });
          this.viper.registerCallback("Viper:nodesInserted", "ViperCoreStylesPlugin", function(data) {
            return self._wrapNodeWithActiveStyle(data.node, data.range);
          });
          this.viper.registerCallback("Viper:charInsert", "ViperCoreStylesPlugin", function(data) {
            self._onChangeAddStyle = [];
          });
          var inlineToolbar = this.viper.PluginManager.getPlugin("ViperInlineToolbarPlugin");
          if (inlineToolbar) {
            if (inlineToolbar.isInitialised() === true) {
              self._createInlineToolbarContent(inlineToolbar.getToolbar());
            } else {
              this.viper.registerCallback(
                "ViperInlineToolbarPlugin:initToolbar",
                "ViperCoreStylesPlugin",
                function(toolbar) {
                  self._createInlineToolbarContent(toolbar);
                }
              );
            }
            this.viper.registerCallback("ViperInlineToolbarPlugin:updateToolbar", "ViperCoreStylesPlugin", function(data) {
              self._updateInlineToolbar(data);
            });
          }
          var tagNames = {
            em: _("Italic"),
            strong: _("Bold"),
            sub: _("Subscript"),
            sup: _("Superscript"),
            del: _("Strikethrough"),
            code: _("Code")
          };
          this.viper.registerCallback("Viper:mouseDown", "ViperCoreStylesPlugin", function(e) {
            self._selectedImage = null;
            var target = ViperUtil.getMouseEventTarget(e);
            if (target && ViperUtil.isTag(target, "hr") !== true) {
              if (ViperUtil.isTag(target, "img") === true) {
                self.viper.Tools.disableButton("ViperCoreStylesPlugin:vtp:block");
                self._selectedImage = target;
                self._updateToolbarButtonStates();
              }
              return;
            }
            var blockSibling = target.nextSibling;
            while (blockSibling) {
              if (ViperUtil.isBlockElement(blockSibling) === true) {
                break;
              } else if (blockSibling.nodeType === ViperUtil.TEXT_NODE && ViperUtil.trim(blockSibling.data) !== "") {
                blockSibling = null;
                break;
              }
              blockSibling = blockSibling.nextSibling;
            }
            if (!blockSibling) {
              blockSibling = document.createElement("p");
              ViperUtil.setHtml(blockSibling, "&nbsp;");
              ViperUtil.insertAfter(target, blockSibling);
            } else if (ViperUtil.getHtml(blockSibling) === "") {
              ViperUtil.setHtml(blockSibling, "&nbsp;");
            }
            var range = self.viper.getViperRange();
            var selectable = range._getFirstSelectableChild(blockSibling);
            if (!selectable) {
              selectable = document.createTextNode(" ");
              if (blockSibling.firstChild) {
                ViperUtil.insertBefore(blockSibling.firstChild, selectable);
              } else {
                blockSibling.appendChild(selectable);
              }
            }
            range.setStart(selectable, 0);
            range.collapse(true);
            ViperSelection.addRange(range);
            return false;
          });
        },
        handleJustify: function(type) {
          if (this._selectedImage) {
            this._handleImageJustify(this._selectedImage, type);
            return;
          }
          var range = this.viper.getViperRange();
          var start = range.startContainer;
          var end = range.endContainer;
          var node = start;
          var next = null;
          var common = this.viper.getNodeSelection();
          if (!common) {
            common = range.getCommonElement();
            common = this.getFirstBlockParent(common);
          }
          if (ViperUtil.isBlockElement(common) === true && ViperUtil.inArray(ViperUtil.getTagName(common), ["tr", "table"]) === false && ViperUtil.isChildOf(common, this.viper.element) === true) {
            this.toggleJustify(common, type);
          } else {
            var parent = null;
            var bookmark = null;
            var elemsBetween = [];
            if (range.collapsed !== true || ViperUtil.isStubElement(start) === false) {
              bookmark = this.viper.createBookmark();
              elemsBetween = ViperUtil.getElementsBetween(bookmark.start, bookmark.end);
            } else {
              elemsBetween = ViperUtil.getElementsBetween(start, end);
              elemsBetween.unshift(start);
              elemsBetween.push(end);
            }
            var toggleAlignment = true;
            var parentElements = [];
            while (node = elemsBetween.shift()) {
              if (ViperUtil.isBlockElement(node) === true) {
                if (ViperUtil.getStyle(node, "text-align") !== type) {
                  toggleAlignment = false;
                }
                if (ViperUtil.inArray(node, parentElements) === false) {
                  parentElements.push(node);
                }
                parent = null;
              } else if (parent === null && (parent = this.getFirstBlockParent(node))) {
                if (ViperUtil.getStyle(parent, "text-align") !== type) {
                  toggleAlignment = false;
                }
                if (ViperUtil.inArray(parent, parentElements) === false) {
                  parentElements.push(parent);
                }
                parent = null;
              } else if (node.nodeType == ViperUtil.TEXT_NODE && ViperUtil.isBlank(ViperUtil.trim(node.data)) === true) {
                continue;
              } else {
                if (parent === null) {
                  parent = Viper2.document.createElement("p");
                  ViperUtil.insertBefore(node, parent);
                }
                if (ViperUtil.getStyle(parent, "text-align") !== type) {
                  toggleAlignment = false;
                }
                parent.appendChild(node);
                if (ViperUtil.inArray(parent, parentElements) === false) {
                  parentElements.push(parent);
                }
              }
              if (node === end) {
                break;
              }
            }
            for (var i = 0; i < parentElements.length; i++) {
              this.toggleJustify(parentElements[i], type, !toggleAlignment);
            }
            if (bookmark !== null) {
              this.viper.selectBookmark(bookmark);
            }
          }
          this.viper.focus();
          this.viper.contentChanged();
        },
        toggleJustify: function(node, type, force) {
          var current = node.style.textAlign;
          if (force !== true && current === type) {
            ViperUtil.setStyle(node, "text-align", "");
            if (ViperUtil.hasAttribute(node, "style") === true && node.getAttribute("style") === "") {
              node.removeAttribute("style");
            }
          } else {
            ViperUtil.setStyle(node, "text-align", type);
          }
        },
        _handleImageJustify: function(image, type) {
          if (!image || type === "block") {
            return;
          }
          var currentType = this._getImageJustify(image);
          if (currentType === type) {
            type = null;
          }
          this.viper.fireCallbacks("ViperCoreStylesPlugin:beforeImageUpdate", image);
          switch (type) {
            case "left":
              ViperUtil.setStyle(image, "float", "left");
              ViperUtil.setStyle(image, "margin", "1em 1em 1em 0px");
              ViperUtil.setStyle(image, "display", "");
              break;
            case "right":
              ViperUtil.setStyle(image, "float", "right");
              ViperUtil.setStyle(image, "margin", "1em 0px 1em 1em");
              ViperUtil.setStyle(image, "display", "");
              break;
            case "center":
              ViperUtil.setStyle(image, "margin", "1em auto");
              ViperUtil.setStyle(image, "float", "");
              ViperUtil.setStyle(image, "display", "block");
              break;
            default:
              ViperUtil.setStyle(image, "margin", "");
              ViperUtil.setStyle(image, "float", "");
              ViperUtil.setStyle(image, "display", "");
              break;
          }
          if (image.getAttribute("style") === "") {
            image.removeAttribute("style");
          }
          var types = ["left", "center", "right", "block"];
          var c = types.length;
          this.viper.Tools.getItem("justify").setIconClass("Viper-justifyLeft");
          this.viper.Tools.setButtonInactive("justify");
          for (var i = 0; i < c; i++) {
            this.viper.Tools.setButtonInactive("ViperCoreStylesPlugin:vtp:" + types[i]);
          }
          this.viper.Tools.disableButton("ViperCoreStylesPlugin:vtp:block");
          if (type !== null) {
            this.viper.Tools.setButtonActive("ViperCoreStylesPlugin:vtp:" + type);
            this.viper.Tools.getItem("justify").setIconClass("Viper-justify" + ViperUtil.ucFirst(type));
          } else {
            this.viper.Tools.getItem("justify").setIconClass("Viper-justifyLeft");
          }
          this.viper.Tools.setButtonActive("justify");
          this.viper.contentChanged();
          this.viper.fireCallbacks("ViperCoreStylesPlugin:afterImageUpdate", image);
        },
        _getImageJustify: function(image) {
          if (!image) {
            return null;
          }
          var type = "";
          var imgFloat = ViperUtil.getStyle(image, "float");
          if (imgFloat === "left") {
            type = "left";
          } else if (imgFloat === "right") {
            type = "right";
          } else if (ViperUtil.getStyle(image, "display") === "block") {
            type = "center";
          }
          return type;
        },
        handleHR: function() {
          var hr = document.createElement("hr");
          this.viper.HistoryManager.begin();
          var range = this.viper.getViperRange();
          if (range.collapsed !== true) {
            range.deleteContents();
            range = this.viper.getViperRange();
          }
          if (!range.startContainer.previousSibling && range.collapsed === true && range.startOffset === 0 && ViperUtil.isBlockElement(range.startContainer.parentNode) === true) {
            if (this.viper.isEditableElement(range.startContainer.parentNode) === true) {
              ViperUtil.insertBefore(range.startContainer, hr);
            } else {
              ViperUtil.insertBefore(range.startContainer.parentNode, hr);
            }
            this.viper.HistoryManager.end();
            this.viper.fireSelectionChanged(range, true);
            return;
          } else {
            var prev = this.viper.getKeyboardHandler().splitAtRange(true, null);
            if (ViperUtil.isTag(prev, "br") === true && prev.nextSibling === null && prev.previousSibling === null) {
              prev = prev.parentNode;
              var prevElemSib = prev.previousElementSibling;
              if (ViperUtil.isTag(prevElemSib, ["ul", "ol", "table"]) === true) {
                ViperUtil.remove(prev);
                prev = prevElemSib;
              }
            }
          }
          var nextSibling = prev.nextSibling;
          var blockTag = this.viper.getDefaultBlockTag();
          ViperUtil.insertAfter(prev, hr);
          if (ViperUtil.isTag(nextSibling, "br") === true) {
            ViperUtil.remove(nextSibling);
            nextSibling = prev.nextSibling.nextSibling;
          } else if (!nextSibling || ViperUtil.isBlockElement(nextSibling) === false && blockTag !== "") {
            if (blockTag !== "") {
              var p = document.createElement(blockTag);
              ViperUtil.setHtml(p, "&nbsp;");
              ViperUtil.insertAfter(hr, p);
              nextSibling = p;
            } else {
              nextSibling = document.createTextNode("");
              ViperUtil.insertAfter(hr, nextSibling);
            }
          } else {
            if (ViperUtil.trim(ViperUtil.getNodeTextContent(nextSibling)) === "" && ViperUtil.elementIsEmpty(nextSibling) === true) {
              if (!nextSibling.nextElementSibling || ViperUtil.isBlockElement(nextSibling.nextElementSibling) === false) {
                if (ViperUtil.isStubElement(nextSibling) !== true) {
                  ViperUtil.setHtml(nextSibling, "&nbsp;");
                }
                var nextEmptyElem = nextSibling.nextSibling;
                while (nextEmptyElem) {
                  if (ViperUtil.isBlockElement(nextEmptyElem) === true) {
                    var html = ViperUtil.getHtml(nextEmptyElem);
                    if (html === "" || html === "<br>" || html === "&nbsp;") {
                      nextEmptyElem.parentNode.removeChild(nextEmptyElem);
                    }
                    break;
                  } else if (nextEmptyElem.nodeType === ViperUtil.TEXT_NODE && ViperUtil.trim(nextEmptyElem.data) !== "") {
                    break;
                  }
                  nextEmptyElem = nextEmptyElem.nextSibling;
                }
              } else if (nextSibling.nextElementSibling) {
                var delNode = nextSibling;
                nextSibling = nextSibling.nextElementSibling;
                ViperUtil.remove(delNode);
              }
            } else if (range.startOffset === 0 && (ViperUtil.trim(ViperUtil.getNodeTextContent(prev)) === "" || ViperUtil.getHtml(prev) === "&nbsp;")) {
              ViperUtil.remove(prev);
            }
          }
          var range = this.viper.getViperRange();
          var selectable = range._getFirstSelectableChild(nextSibling);
          if (!selectable) {
            selectable = document.createTextNode("");
            if (nextSibling.firstChild) {
              ViperUtil.insertBefore(nextSibling.firstChild, selectable);
            } else {
              nextSibling.appendChild(selectable);
            }
          }
          range.setStart(selectable, 0);
          range.collapse(true);
          ViperSelection.addRange(range);
          if (nextSibling.previousSibling && nextSibling.previousSibling.nodeType === ViperUtil.TEXT_NODE && ViperUtil.trim(nextSibling.previousSibling.data) === "") {
            ViperUtil.remove(nextSibling.previousSibling);
          }
          this.viper.HistoryManager.end();
          this.viper.fireSelectionChanged(range, true);
        },
        getFirstBlockParent: function(elem) {
          if (ViperUtil.isBlockElement(elem) === true) {
            return elem;
          }
          var parents = ViperUtil.getParents(elem);
          var parent = null;
          var pln = parents.length;
          for (var i = 0; i < pln; i++) {
            parent = parents[i];
            if (parent === this.viper.element) {
              return null;
            }
            if (ViperUtil.isBlockElement(parent) === true) {
              return parent;
            }
          }
        },
        getAlignment: function(element) {
          var parent = this.getFirstBlockParent(element);
          if (parent !== null) {
            return ViperUtil.getStyle(parent, "text-align");
          }
        },
        setAlignment: function(element, type) {
          ViperUtil.setStyle(element, "text-align", type);
        },
        removeFormat: function() {
          var range = this.viper.getViperRange().cloneRange();
          range = this.viper.adjustRange(range);
          var self = this;
          var nodeSelection = range.getNodeSelection();
          var startNode = null;
          var endNode = null;
          var bookmark = null;
          if (nodeSelection) {
            var sParents = ViperUtil.getSurroundingParents(nodeSelection);
            if (sParents.length > 0 && sParents[sParents.length - 1] !== this.viper.getViperElement()) {
              nodeSelection = sParents[sParents.length - 1];
            }
          }
          if (nodeSelection && nodeSelection === this.viper.getViperElement()) {
            nodeSelection = null;
          }
          if (!nodeSelection) {
            var startNode = range.getStartNode();
            if (ViperUtil.isChildOf(startNode, this.viper.element) === false) {
              range.setStart(this.viper.element, 0);
            }
            var endNode = range.getEndNode();
            if (ViperUtil.isChildOf(endNode, this.viper.element) === false) {
              range.setEnd(this.viper.element, this.viper.element.childNodes.length);
            }
            ViperSelection.addRange(range);
            bookmark = this.viper.createBookmark();
            startNode = ViperUtil.getFirstBlockParent(bookmark.start);
            if (ViperUtil.isChildOf(startNode, this.viper.element) === false) {
              startNode = bookmark.start;
            }
          } else {
            bookmark = this.viper.createBookmark();
            startNode = nodeSelection;
          }
          var stopElem = null;
          if (nodeSelection) {
            stopElem = range._getLastSelectableChild(nodeSelection);
          }
          ViperUtil.walk(startNode, function(elem) {
            if (bookmark && elem === bookmark.end) {
              return false;
            }
            var continueElement = null;
            if (!bookmark || elem !== bookmark.start) {
              if (elem.nodeType === ViperUtil.ELEMENT_NODE) {
                self.viper.removeAttribute(elem, "style");
                self.viper.removeAttribute(elem, "class");
                if (elem.attributes.length === 0 && ViperUtil.isTag(elem, "span") === true) {
                  continueElement = elem.firstChild;
                  while (elem.firstChild) {
                    ViperUtil.insertBefore(elem, elem.firstChild);
                  }
                  ViperUtil.remove(elem);
                  if (nodeSelection === elem) {
                    return false;
                  }
                }
              }
            }
            if (nodeSelection && elem === stopElem) {
              return false;
            }
            return continueElement;
          });
          if (bookmark) {
            this.viper.selectBookmark(bookmark);
          }
          var tags = this.styleTags.concat(["font", "u", "strike"]);
          var tmpSpan = null;
          if (nodeSelection) {
            var tagName = ViperUtil.getTagName(nodeSelection);
            if (ViperUtil.inArray(tagName, tags) === true) {
              bookmark = this.viper.createBookmark();
              tmpSpan = document.createElement("span");
              ViperUtil.insertBefore(nodeSelection, tmpSpan);
              tmpSpan.appendChild(nodeSelection);
            }
          }
          var tln = tags.length;
          for (var i = 0; i < tln; i++) {
            this.viper.removeStyle(tags[i], tmpSpan);
          }
          if (tmpSpan) {
            while (tmpSpan.firstChild) {
              ViperUtil.insertBefore(tmpSpan, tmpSpan.firstChild);
            }
            ViperUtil.remove(tmpSpan);
            this.viper.selectBookmark(bookmark);
          }
          if (nodeSelection && this.viper.isOutOfBounds(nodeSelection) === false) {
            range.selectNode(nodeSelection);
            ViperSelection.addRange(range);
          }
          this.viper.contentChanged();
          if (nodeSelection && ViperUtil.isTag(nodeSelection, "table") === true && (ViperUtil.isBrowser("chrome") === true || ViperUtil.isBrowser("safari") === true)) {
            var inlineToolbar = this.viper.PluginManager.getPlugin("ViperInlineToolbarPlugin");
            inlineToolbar.getToolbar().updatePosition(null, nodeSelection);
          }
        },
        _wrapNodeWithActiveStyle: function(node, range) {
          if (!node || !this._onChangeAddStyle.length || !range) {
            return;
          }
          var origData = node.data;
          var style = null;
          while (style = this._onChangeAddStyle.shift()) {
            var nodes = this.viper.splitNodeAtRange(style, range, true);
            if (ViperUtil.isTag(nodes.prevNode, style) === true || ViperUtil.isTag(nodes.nextNode, style) === true) {
              if (this._onChangeAddStyle.length > 0) {
                node.data = "";
              } else {
                node.data = origData;
              }
              if (nodes.midNode === null) {
                ViperUtil.insertAfter(nodes.prevNode, node);
              } else if (nodes.midNode.nodeType === ViperUtil.TEXT_NODE) {
                nodes.midNode.data = node.data + nodes.midNode.data;
                node = nodes.midNode;
              } else {
                var tmpnode = nodes.midNode;
                while (tmpnode.firstChild) {
                  tmpnode = tmpnode.firstChild;
                }
                tmpnode.appendChild(node);
              }
              if (ViperUtil.getNodeTextContent(nodes.nextNode).length === 0) {
                ViperUtil.remove(nodes.nextNode);
              }
              if ((!nodes.midNode || !nodes.midNode.parentNode) && nodes.prevNode && nodes.prevNode.parentNode) {
                ViperUtil.insertAfter(nodes.prevNode, node);
              }
              var emptyTextNode = null;
              while (emptyTextNode = node.nextSibling) {
                if (emptyTextNode.nodeType === ViperUtil.TEXT_NODE && emptyTextNode.data.length === 0) {
                  ViperUtil.remove(emptyTextNode);
                } else {
                  break;
                }
              }
              if (!node.nextSibling && node.nodeType === ViperUtil.TEXT_NODE) {
                ViperUtil.insertAfter(node, document.createElement("br"));
              }
              if (node.data.length > 0) {
                range.setEnd(node, 1);
              } else {
                range.setEnd(node, 0);
              }
              range.collapse(false);
              ViperSelection.addRange(range);
            } else {
              var styleTag = Viper2.document.createElement(style);
              if (nodes.prevNode) {
                this.viper.insertAfter(nodes.prevNode, styleTag);
              } else if (nodes.nextNode) {
                this.viper.insertBefore(nodes.nextNode, styleTag);
              }
              var offset = 1;
              if (this._onChangeAddStyle.length > 0) {
                node.data = "";
                offset = 0;
              } else {
                node.data = origData;
              }
              styleTag.appendChild(node);
              range.setStart(node, offset);
              range.collapse(true);
              ViperSelection.addRange(range);
            }
          }
          return false;
        },
        handleStyle: function(style) {
          var range = this.viper.getViperRange();
          if (range.collapsed === true) {
            var index = ViperUtil.arraySearch(style, this._onChangeAddStyle);
            if (index >= 0) {
              ViperUtil.removeArrayIndex(this._onChangeAddStyle, index);
              this.viper.Tools.setButtonInactive(this._buttons[style]);
            } else {
              this._onChangeAddStyle.push(style);
              var button = this.viper.Tools.getItem(this._buttons[style]);
              if (button) {
                if (button.isActive() === true) {
                  this.viper.Tools.setButtonInactive(this._buttons[style]);
                } else {
                  this.viper.Tools.setButtonActive(this._buttons[style]);
                }
              }
              if (style === "sup") {
                this.viper.Tools.disableButton(this._buttons["sub"]);
              } else if (style === "sub") {
                this.viper.Tools.disableButton(this._buttons["sup"]);
              }
            }
            return false;
          }
          var selectedNode = range.getNodeSelection(null, true);
          var startNode = null;
          var endNode = null;
          var viperElement = this.viper.getViperElement();
          if (!selectedNode) {
            startNode = range.getStartNode();
            endNode = range.getEndNode();
          } else {
            startNode = selectedNode;
          }
          if (!endNode) {
            endNode = startNode;
          }
          var commonParent = range.getCommonElement();
          if (startNode === endNode && (startNode === viperElement || startNode.nodeType === ViperUtil.TEXT_NODE && ViperUtil.trim(startNode.data) === "" && startNode === viperElement.firstChild)) {
            startNode = range._getFirstSelectableChild(viperElement);
            endNode = range._getLastSelectableChild(viperElement);
            if (ViperUtil.getParents(startNode, style, viperElement).length > 0 && ViperUtil.getParents(endNode, style, viperElement).length > 0) {
              this.viper.removeStyle(style);
              this.viper.contentChanged(false, this.viper.adjustRange());
              return;
            }
          }
          if (ViperUtil.isTag(commonParent, style) === true || ViperUtil.isTag(startNode, style) === true || ViperUtil.getParents(startNode, style).length > 0 && ViperUtil.getParents(endNode, style).length > 0 || selectedNode && this._getWholeStyleSelections(selectedNode, [style], []).length > 0) {
            this.viper.removeStyle(style);
            this.viper.contentChanged();
            return false;
          }
          this.viper.HistoryManager.begin();
          this.applyTag(style);
          this.viper.contentChanged();
          this.viper.HistoryManager.end();
          return false;
        },
        getStyleTags: function() {
          var range = this.viper.getViperRange();
          var tags = ViperUtil.getParents(range.startContainer, this.styleTags.join(","));
          return tags;
        },
        applyTag: function(tag) {
          this.viper.HistoryManager.begin();
          this.viper.surroundContents(tag);
          this.viper.HistoryManager.end();
        },
        _canStyleNode: function(node, topBar) {
          if (topBar === true) {
            if (this._selectedImage || ViperUtil.isTag(node, "img") === true) {
              return false;
            }
            return true;
          }
          var tagName = ViperUtil.getTagName(node);
          if (ViperUtil.isBlockElement(node) === true) {
            if (ViperUtil.isTag(node, "li") !== true && ViperUtil.isTag(node, "td") !== true && ViperUtil.isTag(node, "th") !== true && ViperUtil.isTag(node, "img") !== true) {
              return false;
            }
          } else {
            var tagNames = ["thead", "tfoot"];
            if (ViperUtil.inArray(tagName, tagNames) === true) {
              return false;
            }
          }
          return true;
        },
        _createInlineToolbarContent: function(toolbar) {
          var self = this;
          var tools = this.viper.Tools;
          var buttonGroup = tools.createButtonGroup("ViperCoreStylesPlugin:vitp:btnGroup");
          tools.createButton("vitpBold", "", _("Bold"), "Viper-bold", function() {
            return self.handleStyle("strong");
          });
          tools.createButton("vitpItalic", "", _("Italic"), "Viper-italic", function() {
            return self.handleStyle("em");
          });
          tools.createButton("vitpCode", "", _("Code"), "Viper-code", function() {
            return self.handleStyle("code");
          });
          tools.addButtonToGroup("vitpBold", "ViperCoreStylesPlugin:vitp:btnGroup");
          tools.addButtonToGroup("vitpItalic", "ViperCoreStylesPlugin:vitp:btnGroup");
          tools.addButtonToGroup("vitpCode", "ViperCoreStylesPlugin:vitp:btnGroup");
          toolbar.addButton(buttonGroup);
        },
        _updateInlineToolbar: function(data) {
          if (data.range.collapsed === true) {
            return;
          }
          if (this._canStyleNode(data.lineage[data.current]) !== true) {
            this._selectedImage = null;
            return;
          } else if (ViperUtil.isTag(data.lineage[data.current], "img") === true) {
            this.viper.Tools.disableButton("ViperCoreStylesPlugin:vtp:block");
            this._selectedImage = data.lineage[data.current];
            return;
          }
          this.viper.Tools.setButtonInactive("vitpBold");
          this.viper.Tools.setButtonInactive("vitpItalic");
          this.viper.Tools.setButtonInactive("vitpCode");
          var selectedNode = data.range.getNodeSelection();
          var ignoredTags = ["h1", "h2", "h3", "h4", "h5", "h6"];
          if (!selectedNode) {
            ignoredTags.push("a");
          } else {
            switch (ViperUtil.getTagName(selectedNode)) {
              case "a":
              case "strong":
              case "em":
                break;
              default:
                ignoredTags.push("a");
                break;
            }
          }
          var activeStates = {};
          for (var i = 0; i < data.lineage.length; i++) {
            var tagName = ViperUtil.getTagName(data.lineage[i]);
            if (ViperUtil.inArray(tagName, ignoredTags) === true) {
              return;
            } else if (tagName === "strong") {
              this.viper.Tools.setButtonActive("vitpBold");
            } else if (tagName === "em") {
              this.viper.Tools.setButtonActive("vitpItalic");
            } else if (tagName === "code") {
              this.viper.Tools.setButtonActive("vitpCode");
            }
          }
          var tagNames = ["strong", "em", "code"];
          var states = this._getActiveStates(data.range, tagNames);
          for (var i = 0; i < states.length; i++) {
            var tagName = states[i];
            if (tagName === "strong") {
              this.viper.Tools.setButtonActive("vitpBold");
            } else if (tagName === "em") {
              this.viper.Tools.setButtonActive("vitpItalic");
            } else if (tagName === "code") {
              this.viper.Tools.setButtonActive("vitpCode");
            }
          }
          data.toolbar.showButton("vitpBold");
          data.toolbar.showButton("vitpItalic");
          data.toolbar.showButton("vitpCode");
        },
        _updateToolbarButtonStates: function(buttons, range) {
          range = range || this.viper.getViperRange();
          var startNode = this.viper.getNodeSelection();
          if (!startNode) {
            startNode = range.getStartNode();
          }
          if (!startNode) {
            startNode = range.startContainer;
          }
          var endNode = range.getEndNode();
          if (!endNode) {
            endNode = range.endContainer;
          }
          var tools = this.viper.Tools;
          if (this._canStyleNode(startNode, true) !== true) {
            for (var btn in buttons) {
              if (btn === "justify" || btn === "removeFormat") {
                continue;
              }
              var c = buttons[btn].length;
              for (var i = 0; i < c; i++) {
                var buttonName = this._buttons[buttons[btn][i]] || "ViperCoreStylesPlugin:vtp:" + buttons[btn][i];
                tools.disableButton(buttonName);
              }
            }
            if (this._selectedImage) {
              var type = this._getImageJustify(this._selectedImage);
              tools.enableButton("justify");
              var types = ["left", "center", "right", "block"];
              var c = types.length;
              tools.getItem("justify").setIconClass("Viper-justifyLeft");
              tools.setButtonInactive("justify");
              for (var i = 0; i < c; i++) {
                tools.setButtonInactive("ViperCoreStylesPlugin:vtp:" + types[i]);
              }
              if (type) {
                tools.setButtonActive("ViperCoreStylesPlugin:vtp:" + type);
                tools.getItem("justify").setIconClass("Viper-justify" + ViperUtil.ucFirst(type));
                tools.setButtonActive("justify");
              }
            }
            return;
          }
          var tagNames = [];
          var c = buttons.styles.length;
          for (var i = 0; i < c; i++) {
            tools.enableButton(this._buttons[buttons.styles[i]]);
            tools.setButtonInactive(this._buttons[buttons.styles[i]]);
            tagNames.push(buttons.styles[i]);
          }
          if (ViperUtil.isTag(range.startContainer, "sub") === true || ViperUtil.isTag(range.endContainer, "sub") === true) {
            tools.disableButton(this._buttons["sup"]);
          } else if (ViperUtil.isTag(range.startContainer, "sup") === true || ViperUtil.isTag(range.endContainer, "sup") === true) {
            tools.disableButton(this._buttons["sub"]);
          } else {
            var elems = [range.startContainer, range.endContainer];
            while (elems.length > 0) {
              var elem = elems.shift();
              var subParents = ViperUtil.getParents(elem, null, this.viper.getViperElement());
              for (var i = 0; i < subParents.length; i++) {
                var tagName = ViperUtil.getTagName(subParents[i]);
                if (tagName === "sub") {
                  tools.disableButton(this._buttons["sup"]);
                  break;
                } else if (tagName === "sup") {
                  tools.disableButton(this._buttons["sub"]);
                  break;
                }
              }
            }
          }
          var states = this._getActiveStates(range, tagNames);
          for (var i = 0; i < states.length; i++) {
            tools.setButtonActive(this._buttons[states[i]]);
          }
          if (range.collapsed === false) {
            tools.enableButton("removeFormat");
          } else {
            tools.disableButton("removeFormat");
          }
          var hasParent = true;
          if (!ViperUtil.getFirstBlockParent(startNode, null, true) || !ViperUtil.getFirstBlockParent(endNode, null, true)) {
            hasParent = false;
          }
          if (hasParent) {
            tools.enableButton("justify");
            if (!states.alignment) {
              states.alignment = "start";
            }
            if (states.alignment) {
              var justify = states.alignment;
              var c = buttons.justify.length;
              var toolbarButton = tools.getItem("justify");
              toolbarButton.setIconClass("Viper-justifyLeft");
              if (justify === "justify") {
                justify = "block";
              }
              var setToggleInactive = true;
              for (var i = 0; i < c; i++) {
                tools.enableButton("ViperCoreStylesPlugin:vtp:" + buttons.justify[i]);
                if (buttons.justify[i] === justify) {
                  tools.setButtonActive("ViperCoreStylesPlugin:vtp:" + buttons.justify[i]);
                  toolbarButton.setIconClass("Viper-justify" + ViperUtil.ucFirst(justify));
                  tools.setButtonActive("justify");
                  setToggleInactive = false;
                } else {
                  tools.setButtonInactive("ViperCoreStylesPlugin:vtp:" + buttons.justify[i]);
                }
              }
              if (setToggleInactive === true) {
                tools.setButtonInactive("justify");
              }
            }
          } else {
            tools.disableButton("justify");
          }
          var enableHr = true;
          var hrIgnoreTags = "tr,td,th,li,caption,img,ul,ol,table";
          if (ViperUtil.inArray(ViperUtil.getTagName(startNode), hrIgnoreTags.split(",")) === true) {
            enableHr = false;
          }
          if (enableHr === true) {
            var parents = ViperUtil.getParents(startNode, hrIgnoreTags, this.viper.getViperElement());
            if (parents.length > 0) {
              enableHr = false;
            }
          }
          if (enableHr === true) {
            tools.enableButton("hr");
          } else {
            tools.disableButton("hr");
          }
        },
        _getActiveStates: function(range, tagNames) {
          var activeStates = [];
          var selectedNode = range.getNodeSelection(null, true);
          var startNode = null;
          var endNode = null;
          if (!selectedNode) {
            startNode = range.getStartNode();
            endNode = range.getEndNode();
          } else if (selectedNode === this.viper.getViperElement()) {
            startNode = range._getFirstSelectableChild(selectedNode);
            endNode = range._getLastSelectableChild(selectedNode);
          } else {
            startNode = selectedNode;
          }
          if (!endNode) {
            endNode = startNode;
          }
          if (startNode && endNode) {
            var viperElement = this.viper.getViperElement();
            if (startNode === endNode && startNode === viperElement) {
              startNode = range._getFirstSelectableChild(viperElement);
              endNode = range._getLastSelectableChild(viperElement);
              if (!startNode) {
                return activeStates;
              }
            }
            activeStates.alignment = null;
            var startParent = null;
            if (!selectedNode || selectedNode === viperElement || ViperUtil.isBlockElement(selectedNode) === false) {
              startParent = ViperUtil.getFirstBlockParent(startNode, null, true);
            } else {
              startParent = selectedNode;
            }
            if (startNode !== endNode) {
              var endParent = endNode;
              if (endNode !== viperElement) {
                endParent = ViperUtil.getFirstBlockParent(endNode, null, true);
              }
              if (startParent && endParent) {
                var elems = ViperUtil.getElementsBetween(startParent, endParent);
                elems.unshift(startParent);
                elems.push(endParent);
                var c = elems.length;
                for (var i = 0; i < c; i++) {
                  if (elems[i].nodeType === ViperUtil.ELEMENT_NODE && ViperUtil.isBlockElement(elems[i]) === true) {
                    var alignment = elems[i].style.textAlign;
                    if (activeStates.alignment !== null && alignment !== activeStates.alignment) {
                      activeStates.alignment = null;
                      break;
                    } else {
                      activeStates.alignment = alignment;
                    }
                  }
                }
              }
            } else if (startParent && startParent.style) {
              activeStates.alignment = startParent.style.textAlign;
            }
            if (startNode === endNode || selectedNode && selectedNode !== viperElement) {
              while (startNode && ViperUtil.isBlockElement(startNode) !== true && startNode !== this.viper.getViperElement()) {
                var pos = ViperUtil.arraySearch(ViperUtil.getTagName(startNode), tagNames);
                if (pos >= 0) {
                  activeStates.push(tagNames[pos]);
                }
                startNode = startNode.parentNode;
              }
              activeStates.concat(this._getWholeStyleSelections(endNode, tagNames, activeStates));
            } else {
              var foundTags = [];
              while (startNode && ViperUtil.isBlockElement(startNode) !== true && startNode !== this.viper.getViperElement()) {
                var pos = ViperUtil.arraySearch(ViperUtil.getTagName(startNode), tagNames);
                if (pos >= 0) {
                  foundTags.push(tagNames[pos]);
                }
                startNode = startNode.parentNode;
              }
              while (endNode && ViperUtil.isBlockElement(endNode) !== true && endNode !== this.viper.getViperElement()) {
                var tagName = ViperUtil.getTagName(endNode);
                var pos = ViperUtil.arraySearch(tagName, foundTags);
                if (pos >= 0) {
                  activeStates.push(tagName);
                }
                endNode = endNode.parentNode;
              }
            }
          }
          return activeStates;
        },
        _getWholeStyleSelections: function(parentNode, tagNames, parentStyles) {
          var range = this.viper.getCurrentRange();
          var firstSelectable = range._getFirstSelectableChild(parentNode);
          var lastSelectable = range._getLastSelectableChild(parentNode);
          var firstSelectableParents = [];
          var styles = parentStyles;
          if (firstSelectable && lastSelectable) {
            while (firstSelectable && firstSelectable.parentNode !== parentNode) {
              var pos = ViperUtil.arraySearch(ViperUtil.getTagName(firstSelectable.parentNode), tagNames);
              if (pos >= 0) {
                firstSelectableParents.push(tagNames[pos]);
              }
              firstSelectable = firstSelectable.parentNode;
            }
            if (firstSelectableParents.length > 0) {
              while (lastSelectable && lastSelectable.parentNode !== parentNode) {
                var pos = ViperUtil.arraySearch(ViperUtil.getTagName(lastSelectable.parentNode), tagNames);
                if (pos >= 0 && ViperUtil.inArray(tagNames[pos], firstSelectableParents) === true && ViperUtil.inArray(tagNames[pos], styles) === false) {
                  styles.push(tagNames[pos]);
                }
                lastSelectable = lastSelectable.parentNode;
              }
            }
          }
          return styles;
        },
        remove: function() {
          this.viper.Tools.removeItem("ViperCoreStylesPlugin:vtp:stylesBtns");
          this.viper.Tools.removeItem("bold");
          this.viper.Tools.removeItem("italic");
          this.viper.Tools.removeItem("code");
          this.viper.Tools.removeItem("subscript");
          this.viper.Tools.removeItem("superscript");
          this.viper.Tools.removeItem("strikethrough");
          this.viper.Tools.removeItem("vitpBold");
          this.viper.Tools.removeItem("vitpItalic");
          this.viper.removeCallback(null, "ViperCoreStylesPlugin");
        }
      };
    };
  }
});

// src/Plugins/ViperFormatPlugin/ViperFormatPlugin.js
var ViperFormatPlugin_exports = {};
__export(ViperFormatPlugin_exports, {
  registerPlugin: () => registerPlugin14
});
var registerPlugin14;
var init_ViperFormatPlugin = __esm({
  "src/Plugins/ViperFormatPlugin/ViperFormatPlugin.js"() {
    "use strict";
    registerPlugin14 = (Viper2) => {
      const { Util: ViperUtil, Selection: ViperSelection, _ } = Viper2;
      function ViperFormatPlugin(viper) {
        this.viper = viper;
        this.styleTags = {
          h1: _("Heading 1"),
          h2: _("Heading 2"),
          h3: _("Heading 3"),
          h4: _("Heading 4"),
          h5: _("Heading 5"),
          h6: _("Heading 6"),
          p: _("Paragraph"),
          pre: _("Preformatted"),
          address: _("Address"),
          blockquote: _("Quote")
        };
        this.toolbarPlugin = null;
        this.activeStyles = [];
        this._range = null;
        this._inlineToolbar = null;
        this._custStyles = null;
        this._custStyleNames = null;
        this._popoutid = null;
        this._styleListid = "ViperFormatPlugin-classList";
        this._stylePickerRow = [];
        this._stylesListElement = [];
        this._selectedNode = null;
        this._formatButtons = {
          p: "P",
          div: "DIV",
          blockquote: "Quote",
          pre: "PRE"
        };
        this._headingButtons = {
          h1: "H1",
          h2: "H2",
          h3: "H3",
          h4: "H4",
          h5: "H5",
          h6: "H6"
        };
        this._inlineToolbarActiveSubSection = null;
        this.initInlineToolbar();
      }
      Viper2.PluginManager.addPlugin("ViperFormatPlugin", ViperFormatPlugin);
      ViperFormatPlugin.prototype = {
        init: function() {
          var self = this;
          this.toolbarPlugin = this.viper.PluginManager.getPlugin("ViperToolbarPlugin");
          if (this.toolbarPlugin) {
            this._createToolbarContent();
          }
          this.viper.registerCallback("ViperTableEditorPlugin:initToolbar", "ViperFormatPlugin", function(data) {
            self._createTableEditorContent(data.toolbar, data.type);
          });
          this.viper.registerCallback("ViperTableEditorPlugin:updateToolbar", "ViperFormatPlugin", function(data) {
            self._updateTableEditorContent(data);
          });
        },
        setSettings: function(settings) {
          this.setSetting("styles", settings.styles);
          this.setSetting("formatButtons", settings.formatButtons);
          this.setSetting("headerButtons", settings.formatButtons);
        },
        setSetting: function(setting, value) {
          switch (setting) {
            case "styles":
              this._custStyles = value || {};
              var items = {};
              var expanded = {};
              for (var name in this._custStyles) {
                var classNames = "";
                var showFor = "";
                var hideFor = "";
                if (typeof this._custStyles[name] === "string") {
                  classNames = this._custStyles[name].split(" ");
                } else if (typeof this._custStyles[name] === "object" && this._custStyles[name].classNames) {
                  classNames = this._custStyles[name].classNames.split(" ");
                  if (this._custStyles[name].showFor) {
                    if (this._custStyles[name].showFor === "*") {
                      showFor = "*";
                    } else {
                      showFor = this._custStyles[name].showFor.split(",");
                    }
                  }
                  if (this._custStyles[name].hideFor) {
                    if (this._custStyles[name].hideFor === "*") {
                      hideFor = "*";
                    } else {
                      hideFor = this._custStyles[name].hideFor.split(",");
                    }
                  }
                } else {
                  continue;
                }
                items[classNames.join(" ")] = name;
                expanded[classNames.join(" ")] = {
                  classNames,
                  showFor,
                  hideFor
                };
              }
              this._custStyleNames = items;
              this._custStyles = expanded;
              var self = this;
              var tools = this.viper.Tools;
              var listElement = tools.getItem(this._styleListid);
              if (listElement) {
                ViperUtil.remove(listElement.element);
              }
              var listElement = tools.createSelectionList(this._styleListid, items, function() {
                self._updateDefinedStylesList();
              });
              var panel = this.viper.Tools.getItem(this._popoutid);
              if (!panel) {
                return;
              }
              panel.element.appendChild(listElement);
              break;
            case "formatButtons":
              value = value || Object.keys(this._formatButtons);
              for (var button in this._formatButtons) {
                if (ViperUtil.inArray(button, value) === true) {
                  this._showButton("formats:" + this._formatButtons[button]);
                } else {
                  this._hideButton("formats:" + this._formatButtons[button]);
                }
              }
              break;
            case "headingButtons":
              value = value || Object.keys(this._headingButtons);
              for (var button in this._headingButtons) {
                if (ViperUtil.inArray(button, value) === true) {
                  this._showButton("heading:" + button);
                } else {
                  this._hideButton("heading:" + button);
                }
              }
              break;
          }
        },
        _showButton: function(buttonid) {
          var toolbarTypes = ["vtp", "vitp"];
          for (var i = 0; i < toolbarTypes.length; i++) {
            var fixedid = "ViperFormatPlugin:" + toolbarTypes[i] + ":" + buttonid;
            this.viper.Tools.getItem(fixedid).show();
          }
        },
        _hideButton: function(buttonid) {
          var toolbarTypes = ["vtp", "vitp"];
          for (var i = 0; i < toolbarTypes.length; i++) {
            var fixedid = "ViperFormatPlugin:" + toolbarTypes[i] + ":" + buttonid;
            this.viper.Tools.getItem(fixedid).hide();
          }
        },
        _getHeadingsSection: function(prefix) {
          var self = this;
          var tools = this.viper.Tools;
          var headingsSubSection = document.createElement("div");
          var headingBtnGroup = tools.createButtonGroup(prefix + "headingFormats");
          headingsSubSection.appendChild(headingBtnGroup);
          for (var i = 1; i <= 6; i++) {
            (function(headingCount) {
              tools.createButton(
                prefix + "heading:h" + headingCount,
                "H" + headingCount,
                ViperUtil.sprintf(_("Convert to Heading %s"), headingCount),
                null,
                function() {
                  self.handleFormat("h" + headingCount);
                }
              );
              tools.addButtonToGroup(prefix + "heading:h" + headingCount, prefix + "headingFormats");
            })(i);
          }
          return headingsSubSection;
        },
        _getFormatsSection: function(prefix) {
          var self = this;
          var tools = this.viper.Tools;
          var formatsSubSection = document.createElement("div");
          var formatButtons = this._formatButtons;
          for (var tag in formatButtons) {
            (function(tagName) {
              var button = tools.createButton(
                prefix + "formats:" + formatButtons[tagName],
                formatButtons[tagName],
                ViperUtil.sprintf(_("Convert to %s"), formatButtons[tagName]),
                null,
                function() {
                  self.handleFormat(tagName);
                }
              );
              formatsSubSection.appendChild(button);
            })(tag);
          }
          return formatsSubSection;
        },
        _getAnchorSection: function(prefix) {
          var self = this;
          var tools = this.viper.Tools;
          var anchorSubContent = document.createElement("div");
          var idTextbox = tools.createTextbox(prefix + "anchor:input", _("ID"), "");
          anchorSubContent.appendChild(idTextbox);
          return anchorSubContent;
        },
        _getClassSection: function(prefix, element) {
          var self = this;
          var tools = this.viper.Tools;
          var classSubContent = document.createElement("div");
          this._createDefinedStylesBlock(classSubContent, prefix);
          var classTextbox = tools.createTextbox(prefix + "class:input", _("Class"), "");
          classSubContent.appendChild(classTextbox);
          return classSubContent;
        },
        /**
         * Handles the Defined Styles section of the class subsection.
         */
        _createDefinedStylesBlock: function(classSubContentElement, prefix) {
          var tools = this.viper.Tools;
          var stylePicker = document.createElement("div");
          var stylePickerRow = tools.createRow(prefix + "customStyles", "ViperUtil-hidden");
          stylePickerRow.appendChild(stylePicker);
          ViperUtil.addClass(stylePicker, "ViperFormatPlugin-stylePickerButton");
          ViperUtil.setHtml(stylePicker, _("Choose Styles"));
          classSubContentElement.appendChild(stylePickerRow);
          this._stylePickerRow.push(stylePickerRow);
          var stylesListElement = document.createElement("div");
          ViperUtil.addClass(stylesListElement, "ViperFormatPlugin-stylesList");
          stylePickerRow.appendChild(stylesListElement);
          this._stylesListElement.push(stylesListElement);
          ViperUtil.addEvent(stylesListElement, "click", function(e) {
            if (ViperUtil.hasClass(e.target, "ViperFormatPlugin-styleListItem-remove") === true) {
              tools.getItem(self._styleListid).removeFromSelection(ViperUtil.attr(e.target, "data-id"));
              self._updateDefinedStylesList();
            }
          });
          var title = document.createElement("div");
          ViperUtil.addClass(title, "ViperFormatPlugin-stylePicker-title");
          ViperUtil.setHtml(title, _("Custom Class"));
          stylePickerRow.appendChild(title);
          if (!this._popoutid) {
            var classList = document.createElement("div");
            ViperUtil.addClass(classList, "ViperFormatPlugin-classList");
            this._popoutid = this.viper.getId() + "-ViperFormatPlugin-classPopout";
            tools.createPopoutPanel(this._popoutid, classList);
            this.viper.registerCallback(
              ["ViperToolbar:subsectionClosed", "ViperToolbarPlugin:bubbleClosed"],
              "ViperFormatPlugin",
              function(sectionid) {
                if (sectionid.indexOf("ViperFormatPlugin:") === 0 || sectionid.indexOf("ViperTableEditor-Format-") === 0) {
                  tools.getItem(self._popoutid).hide();
                }
              }
            );
          }
          var self = this;
          var popout = tools.getItem(self._popoutid);
          ViperUtil.addEvent(stylePicker, "click", function() {
            if (popout.isOpen() !== true) {
              popout.show(stylePicker);
            } else {
              popout.hide();
            }
          });
          this.viper.registerCallback("Viper:editableElementChanged", "ViperFormatPlugin-stylePicker", function() {
            var elemDoc = self.viper.getViperElementDocument();
            if (elemDoc !== document) {
              ViperUtil.removeEvent(elemDoc.defaultView, "scroll.ViperFormatPlugin-stylePicker");
              ViperUtil.addEvent(elemDoc.defaultView, "scroll.ViperFormatPlugin-stylePicker", function(e) {
                if (popout.isOpen() === true) {
                  popout.hide();
                }
              });
            }
          });
        },
        _getToolbarContents: function(toolbarType) {
          var prefix = "ViperFormatPlugin:" + toolbarType + ":";
          return {
            headings: this._getHeadingsSection(prefix),
            formats: this._getFormatsSection(prefix),
            anchor: this._getAnchorSection(prefix),
            cssClass: this._getClassSection(prefix)
          };
        },
        getNodeWithAttributeFromRange: function(attributeName, node) {
          if (!attributeName) {
            return null;
          }
          var range = this.viper.getViperRange();
          var selectedNode = node || range.getNodeSelection();
          if (selectedNode && selectedNode.nodeType === ViperUtil.ELEMENT_NODE && selectedNode !== this.viper.getViperElement() && ViperUtil.hasAttribute(selectedNode, attributeName) === true) {
            return selectedNode;
          }
          return null;
        },
        _getAttributeValue: function(attribute, node) {
          if (!node) {
            return "";
          }
          node = this.getNodeWithAttributeFromRange(attribute, node);
          if (node) {
            var value = this.viper.getAttribute(node, attribute);
            if (attribute === "class") {
              value = this._removeViperHighlightClass(value);
            }
            return value;
          }
          return "";
        },
        getTagFromRange: function(range, tagNames) {
          var c = tagNames.length;
          var selectedNode = range.getNodeSelection();
          if (selectedNode && selectedNode.nodeType === ViperUtil.ELEMENT_NODE) {
            if (selectedNode === this.viper.getViperElement()) {
              return null;
            }
            for (var i = 0; i < c; i++) {
              if (ViperUtil.isTag(selectedNode, tagNames[i]) === true) {
                return selectedNode;
              }
            }
          }
          var viperElem = this.viper.getViperElement();
          var common = range.getCommonElement();
          while (common) {
            if (common === viperElem) {
              return null;
            }
            for (var i = 0; i < c; i++) {
              if (ViperUtil.isTag(common, tagNames[i]) === true) {
                return common;
              }
            }
            if (ViperUtil.isBlockElement(common) === true) {
              break;
            }
            common = common.parentNode;
          }
          return null;
        },
        _removeViperHighlightClass: function(className) {
          return className.replace(/\s*(__viper_selHighlight|__viper_cleanOnly)/gi, "");
        },
        getCommonFormatElement: function(range) {
          range = range || this.viper.getViperRange();
          var startNode = range.getStartNode();
          var endNode = range.getEndNode();
          var common = range.getCommonElement();
          if (!endNode) {
            endNode = startNode;
          }
          if (ViperUtil.isChildOf(common, this.viper.getViperElement()) === false) {
            return null;
          }
          var startParents = ViperUtil.getParents(startNode, null, common, true);
          var endParents = ViperUtil.getParents(endNode, null, common, true);
          var startTopParent = common;
          var endTopParent = common;
          if (startParents.length > 0) {
            startTopParent = startParents[startParents.length - 1];
          }
          if (endParents.length > 0) {
            endTopParent = endParents[endParents.length - 1];
          }
          if (startTopParent === endTopParent) {
            return common;
          }
          var first = false;
          var last = null;
          for (var node = common.firstChild; node; node = node.nextSibling) {
            if (node.nodeType === ViperUtil.TEXT_NODE) {
              continue;
            } else if (node === startTopParent) {
              first = true;
            } else if (first !== true) {
              return null;
            }
            last = node;
          }
          if (last !== endTopParent) {
            return null;
          }
          return common;
        },
        initInlineToolbar: function() {
          var self = this;
          this.viper.registerCallback("ViperInlineToolbarPlugin:initToolbar", "ViperFormatPlugin", function(toolbar) {
            self.createInlineToolbar(toolbar);
          });
          this.viper.registerCallback("ViperInlineToolbarPlugin:updateToolbar", "ViperFormatPlugin", function(data) {
            self.updateInlineToolbar(data);
          });
        },
        createInlineToolbar: function(toolbar) {
          var tools = this.viper.Tools;
          var prefix = "ViperFormatPlugin:vitp:";
          var self = this;
          this._inlineToolbar = this.viper.getPluginManager().getPlugin("ViperInlineToolbarPlugin");
          var headingsSubSection = toolbar.makeSubSection(prefix + "heading:subSection", this._getHeadingsSection(prefix));
          var formatsSubSection = toolbar.makeSubSection(prefix + "formats:subSection", this._getFormatsSection(prefix));
          var buttonGroup = tools.createButtonGroup(prefix + "formatsAndHeading:buttons");
          toolbar.addButton(buttonGroup);
          tools.createButton("vitpFormats", "", _("Toggle Formats"), "Viper-formats");
          tools.addButtonToGroup("vitpFormats", prefix + "formatsAndHeading:buttons");
          toolbar.setSubSectionButton("vitpFormats", prefix + "formats:subSection");
          tools.createButton("vitpHeadings", "", _("Toggle Headings"), "Viper-headings");
          tools.addButtonToGroup("vitpHeadings", prefix + "formatsAndHeading:buttons");
          toolbar.setSubSectionButton("vitpHeadings", prefix + "heading:subSection");
          var buttonGroup = tools.createButtonGroup(prefix + "anchorAndClassButtons");
          toolbar.addButton(buttonGroup);
          tools.createButton("vitpAnchor", "", _("Anchor name (ID)"), "Viper-anchorID");
          tools.addButtonToGroup("vitpAnchor", prefix + "anchorAndClassButtons");
          toolbar.makeSubSection(prefix + "anchor:subSection", this._getAnchorSection(prefix));
          toolbar.setSubSectionButton("vitpAnchor", prefix + "anchor:subSection");
          toolbar.setSubSectionAction(
            prefix + "anchor:subSection",
            function() {
              var value = tools.getItem(prefix + "anchor:input").getValue();
              self._setAttributeForSelection("id", value);
            },
            [prefix + "anchor:input"]
          );
          tools.createButton("vitpClass", "", _("Class name"), "Viper-cssClass");
          tools.addButtonToGroup("vitpClass", prefix + "anchorAndClassButtons");
          toolbar.makeSubSection(prefix + "class:subSection", this._getClassSection(prefix));
          toolbar.setSubSectionButton("vitpClass", prefix + "class:subSection");
          toolbar.setSubSectionAction(
            prefix + "class:subSection",
            function() {
              var value = tools.getItem(prefix + "class:input").getValue();
              self._updateClassAttribute(value);
            },
            [prefix + "class:input", self._styleListid]
          );
        },
        _updateClassAttribute: function(value, element) {
          if (this._custStyles) {
            var tools = this.viper.Tools;
            var selectedStyles = tools.getItem(this._styleListid).getSelectedItems();
            if (selectedStyles.length > 0) {
              value = this._removeDefinedStylesFromClass(value, selectedStyles);
              value += " " + selectedStyles.join(" ");
            }
          }
          if (element) {
            this._setAttributeForElement(element, "class", value);
          } else {
            this._setAttributeForSelection("class", value);
          }
        },
        _getClassInitialValue: function(attrClass, node) {
          var selectedItems = [];
          if (this._custStyles && attrClass) {
            var classNames = attrClass.split(" ");
            var listItems = [];
            for (var custStyle in this._custStyles) {
              var intersect = ViperUtil.arrayIntersect(this._custStyles[custStyle].classNames, classNames);
              if (intersect.length === this._custStyles[custStyle].classNames.length) {
                selectedItems.push(custStyle);
                attrClass = this._removeDefinedStylesFromClass(attrClass, this._custStyles[custStyle].classNames);
              }
            }
            for (var i = selectedItems.length - 1; i >= 0; i--) {
              var isSubset = false;
              for (var j = 0; j < selectedItems.length; j++) {
                if (i === j) {
                  continue;
                }
                var intersect = ViperUtil.arrayIntersect(
                  this._custStyles[selectedItems[j]].classNames,
                  this._custStyles[selectedItems[i]].classNames
                );
                if (intersect.length === this._custStyles[selectedItems[i]].classNames.length) {
                  isSubset = true;
                  break;
                }
              }
              if (isSubset === true) {
                ViperUtil.removeArrayIndex(selectedItems, i);
              }
            }
          }
          if (this._custStyles) {
            var nodeTagName = ViperUtil.getTagName(node) || "text-selection";
            var list = this.viper.Tools.getItem(this._styleListid);
            var itemShown = false;
            for (var classNames in this._custStyles) {
              var hideFor = this._custStyles[classNames].hideFor;
              var showFor = this._custStyles[classNames].showFor;
              if (hideFor && (hideFor === "*" || ViperUtil.inArray(nodeTagName, hideFor) === true) && (!showFor || ViperUtil.inArray(nodeTagName, showFor) === false)) {
                list.hideItem(classNames);
              } else if (!showFor || showFor === "*" || ViperUtil.inArray(nodeTagName, showFor) === true) {
                list.showItem(classNames);
                itemShown = true;
              } else {
                list.hideItem(classNames);
              }
            }
            if (itemShown === true) {
              ViperUtil.removeClass(this._stylePickerRow, "ViperUtil-hidden");
            } else {
              ViperUtil.addClass(this._stylePickerRow, "ViperUtil-hidden");
            }
            list.setSelectedItems(selectedItems, true);
            this._updateDefinedStylesList();
          }
          attrClass = ViperUtil.trim(attrClass);
          return attrClass;
        },
        _removeDefinedStylesFromClass: function(attrClass, definedStyles) {
          var re = new RegExp("(\\s|^)" + definedStyles.join("|") + "(\\s|$)", "g");
          attrClass = attrClass.replace(re, "").replace(/\s{2,}/gi, " ");
          return attrClass;
        },
        updateInlineToolbar: function(data, removeLinkOnly) {
          if (!data.lineage || data.range.collapsed === true) {
            return;
          }
          var tools = this.viper.Tools;
          var prefix = "ViperFormatPlugin:vitp:";
          var selectedNode = data.lineage[data.current];
          if (this._canShowHeadingOptions(selectedNode) === true) {
            data.toolbar.showButton("vitpHeadings");
            for (var i = 1; i <= 6; i++) {
              var tagName = "h" + i;
              for (var j = 0; j < data.lineage.length; j++) {
                if (ViperUtil.isTag(data.lineage[j], tagName) === true) {
                  tools.setButtonActive(prefix + "heading:h" + i);
                  tools.setButtonActive("vitpHeadings");
                } else {
                  tools.setButtonInactive(prefix + "heading:h" + i);
                }
              }
            }
          } else {
            tools.setButtonInactive("vitpHeadings");
            for (var i = 1; i <= 6; i++) {
              tools.setButtonInactive(prefix + "heading:h" + i);
            }
          }
          var formatButtons = {
            p: "P",
            div: "DIV",
            blockquote: "Quote",
            pre: "PRE"
          };
          var ignoredTags = ["caption", "li", "ul", "ol", "img", "table", "tr", "tbody", "tfoot", "thead"];
          var formatButtonStatuses = null;
          var currentElement = data.lineage[data.current];
          if (ViperUtil.isBlockElement(currentElement) === true && ViperUtil.inArray(ViperUtil.getTagName(currentElement), ignoredTags) === false) {
            if (currentElement.nodeType === ViperUtil.TEXT_NODE && data.lineage.length === 1) {
              formatButtonStatuses = this.getFormatButtonStatuses();
            } else {
              formatButtonStatuses = this.getFormatButtonStatuses(data.lineage[data.current]);
            }
            var enableFormatsButton = formatButtonStatuses._none;
            for (var button in formatButtonStatuses) {
              if (button === "_none" || button === "_canChange") {
                continue;
              }
              if (formatButtonStatuses[button] === true) {
                enableFormatsButton = true;
                tools.enableButton(prefix + "formats:" + formatButtons[button]);
                tools.setButtonInactive(prefix + "formats:" + formatButtons[button]);
              } else {
                tools.setButtonInactive(prefix + "formats:" + formatButtons[button]);
                tools.disableButton(prefix + "formats:" + formatButtons[button]);
              }
            }
            tools.getItem("vitpFormats").setIconClass("Viper-formats");
            if (enableFormatsButton === true) {
              tools.enableButton("vitpFormats");
              if (currentElement.nodeType === ViperUtil.TEXT_NODE && data.lineage.length > 1) {
                currentElement = data.lineage[data.current - 1];
              } else if (ViperUtil.isBlockElement(currentElement) === true) {
                data.toolbar.showButton("vitpFormats");
              }
              var isBlockQuote = false;
              if (ViperUtil.isTag(currentElement, "p") === true && ViperUtil.isTag(currentElement.parentNode, "blockquote") === true) {
                isBlockQuote = true;
              }
              for (var tag in formatButtons) {
                if (ViperUtil.isTag(currentElement, tag) === true) {
                  if (formatButtonStatuses[tag] === true) {
                    tools.enableButton(prefix + "formats:" + formatButtons[tag]);
                    if (isBlockQuote !== true) {
                      tools.setButtonActive(prefix + "formats:" + formatButtons[tag]);
                    }
                  }
                  tools.setButtonActive("vitpFormats");
                  if (isBlockQuote === true) {
                    tools.setButtonActive(prefix + "formats:" + formatButtons["blockquote"]);
                    tools.getItem("vitpFormats").setIconClass("Viper-formats-blockquote");
                  } else {
                    tools.setButtonActive(prefix + "formats:" + formatButtons[tag]);
                    tools.getItem("vitpFormats").setIconClass("Viper-formats-" + tag);
                  }
                }
              }
            } else {
              tools.disableButton("vitpFormats");
            }
          } else if ((!currentElement || currentElement.nodeType === ViperUtil.TEXT_NODE || ViperUtil.isBlockElement(currentElement) === true && ViperUtil.inArray(ViperUtil.getTagName(currentElement), ignoredTags) === false) && this.isWholeBlockSelection(data.range)) {
            var pOnly = this._selectionHasPTagsOnly(data.range);
            for (var tag in formatButtons) {
              tools.setButtonInactive(prefix + "formats:" + formatButtons[tag]);
              if (tag === "div" || pOnly === true && tag === "blockquote") {
                tools.enableButton(prefix + "formats:" + formatButtons[tag]);
              } else {
                tools.disableButton(prefix + "formats:" + formatButtons[tag]);
              }
            }
            tools.getItem("vitpFormats").setIconClass("Viper-formats");
            tools.enableButton("vitpFormats");
            data.toolbar.showButton("vitpFormats");
          } else {
            tools.disableButton("vitpFormats");
          }
          var startNode = data.range.getStartNode();
          var endNode = data.range.getEndNode();
          if (!endNode) {
            endNode = startNode;
          }
          this._selectedNode = selectedNode;
          tools.getItem("ViperFormatPlugin:vitp:anchor:subSection").setActionButtonTitle(_("Insert Anchor"));
          tools.getItem("ViperFormatPlugin:vitp:class:subSection").setActionButtonTitle(_("Apply Styles"));
          if (selectedNode && (selectedNode.nodeType === ViperUtil.ELEMENT_NODE || ViperUtil.getFirstBlockParent(startNode) === ViperUtil.getFirstBlockParent(endNode))) {
            var attrId = this._getAttributeValue("id", selectedNode);
            if (attrId) {
              tools.setButtonActive("vitpAnchor");
              tools.getItem("ViperFormatPlugin:vitp:anchor:subSection").setActionButtonTitle(_("Update Anchor"));
            }
            var attrClass = this._getAttributeValue("class", selectedNode);
            if (attrClass) {
              tools.setButtonActive("vitpClass");
              tools.getItem("ViperFormatPlugin:vitp:class:subSection").setActionButtonTitle(_("Apply Styles"));
            }
            attrClass = this._getClassInitialValue(attrClass, selectedNode);
            tools.getItem(prefix + "anchor:input").setValue(attrId);
            tools.getItem(prefix + "class:input").setValue(attrClass);
            data.toolbar.showButton("vitpAnchor");
            data.toolbar.showButton("vitpClass");
          }
        },
        _createToolbarContent: function() {
          var self = this;
          var tools = this.viper.Tools;
          var toolbar = this.toolbarPlugin;
          var prefix = "ViperFormatPlugin:vtp:";
          var content = this._getToolbarContents("vtp");
          var buttonGroup = tools.createButtonGroup(prefix + "formatAndHeadingButtons");
          tools.createButton("formats", "", _("Formats"), "Viper-formats", null, true);
          tools.createButton("headings", "", _("Headings"), "Viper-headings", null, true);
          tools.addButtonToGroup("formats", prefix + "formatAndHeadingButtons");
          tools.addButtonToGroup("headings", prefix + "formatAndHeadingButtons");
          toolbar.addButton(buttonGroup);
          var buttonGroup = tools.createButtonGroup(prefix + "anchorAndClassButtons");
          tools.createButton("anchor", "", _("Anchor ID"), "Viper-anchorID", null, true);
          tools.createButton("class", "", _("Class"), "Viper-cssClass", null, true);
          tools.addButtonToGroup("anchor", prefix + "anchorAndClassButtons");
          tools.addButtonToGroup("class", prefix + "anchorAndClassButtons");
          toolbar.addButton(buttonGroup);
          toolbar.createBubble(prefix + "formatsBubble", _("Formats"), null, content.formats);
          toolbar.setBubbleButton(prefix + "formatsBubble", "formats");
          toolbar.createBubble(prefix + "headingsBubble", _("Headings"), null, content.headings);
          toolbar.setBubbleButton(prefix + "headingsBubble", "headings");
          toolbar.createBubble(prefix + "anchorBubble", _("Anchor ID"), content.anchor);
          toolbar.setBubbleButton(prefix + "anchorBubble", "anchor");
          tools.getItem(prefix + "anchorBubble").setSubSectionAction(
            prefix + "anchorBubbleSubSection",
            function() {
              var value = tools.getItem(prefix + "anchor:input").getValue();
              self._setAttributeForSelection("id", value);
            },
            [prefix + "anchor:input"]
          );
          toolbar.createBubble(prefix + "classBubble", _("Class"), content.cssClass);
          toolbar.setBubbleButton(prefix + "classBubble", "class");
          tools.getItem(prefix + "classBubble").setSubSectionAction(
            prefix + "classBubbleSubSection",
            function() {
              var value = tools.getItem(prefix + "class:input").getValue();
              self._updateClassAttribute(value);
            },
            [prefix + "class:input", self._styleListid]
          );
          var headingTags = ["h1", "h2", "h3", "h4", "h5", "h6"];
          var formatButtons = {
            p: "P",
            div: "DIV",
            blockquote: "Quote",
            pre: "PRE"
          };
          var ignoredTags = "tr|table|tbody|thead|tfoot|caption|ul|ol|li|img".split("|");
          this.viper.registerCallback("ViperToolbarPlugin:updateToolbar", "ViperFormatPlugin", function(data) {
            setTimeout(function() {
              updateToolbar();
            }, 10);
          });
          var updateToolbar = function() {
            var range = self.viper.getViperRange();
            try {
              if (range) {
                if (range.startContainer) {
                  range.startContainer.parentNode;
                }
                if (range.endContainer) {
                  range.endContainer.parentNode;
                }
              }
            } catch (e) {
            }
            var nodeSelection = range.getNodeSelection(null, true);
            var startNode = range.getStartNode();
            var endNode = range.getEndNode();
            if (!endNode) {
              endNode = startNode;
            }
            if (!endNode) {
              return;
            }
            if ((!nodeSelection || nodeSelection.nodeType !== ViperUtil.ELEMENT_NODE || nodeSelection === self.viper.getViperElement() && self.viper.getDefaultBlockTag() !== "") && (range.collapsed === true || ViperUtil.getFirstBlockParent(startNode) !== ViperUtil.getFirstBlockParent(endNode)) || startNode === endNode && ViperUtil.isTag(startNode, "br") === true && range.collapsed === true) {
              tools.disableButton("anchor");
              tools.disableButton("class");
              tools.setButtonInactive("anchor");
              tools.setButtonInactive("class");
            } else if (nodeSelection && nodeSelection === self.viper.getViperElement() && self.viper.getDefaultBlockTag() !== "") {
              tools.disableButton("anchor");
              tools.disableButton("class");
              tools.setButtonInactive("anchor");
              tools.setButtonInactive("class");
            } else if (nodeSelection && range.collapsed === true && nodeSelection.nodeType === ViperUtil.ELEMENT_NODE) {
              tools.disableButton("anchor");
              tools.disableButton("class");
              tools.setButtonInactive("anchor");
              tools.setButtonInactive("class");
            } else {
              tools.enableButton("anchor");
              tools.enableButton("class");
            }
            if (nodeSelection === self.viper.getViperElement()) {
              nodeSelection = null;
            }
            if (!startNode && !endNode && range.startContainer === range.endContainer) {
              startNode = range.startContainer;
            }
            var viperElement = self.viper.getViperElement();
            var lineage = [];
            var currentLinIndex = 0;
            if (self._inlineToolbar) {
              lineage = self._inlineToolbar.getLineage();
              currentLinIndex = self._inlineToolbar.getCurrentLineageIndex(true);
            }
            var formatElement = lineage[currentLinIndex];
            if (!nodeSelection || lineage[lineage.length - 1] !== nodeSelection) {
              if (formatElement && formatElement.nodeType !== ViperUtil.TEXT_NODE) {
                nodeSelection = formatElement;
              }
            }
            if (formatElement && nodeSelection && formatElement !== nodeSelection) {
              nodeSelection = formatElement;
            }
            tools.getItem("ViperFormatPlugin:vtp:anchorBubbleSubSection").setActionButtonTitle(_("Insert Anchor"));
            tools.getItem("ViperFormatPlugin:vtp:classBubbleSubSection").setActionButtonTitle(_("Apply Styles"));
            if (nodeSelection || range.collapsed === false || ViperUtil.isTag(startNode, "br") === false && (startNode.nodeType === ViperUtil.TEXT_NODE && ViperUtil.trim(startNode.data) === "") === false) {
              if (nodeSelection && nodeSelection === self.viper.getViperElement()) {
                tools.disableButton("anchor");
                tools.disableButton("class");
                tools.setButtonInactive("anchor");
                tools.setButtonInactive("class");
              } else if (nodeSelection && range.collapsed !== true) {
                tools.enableButton("anchor");
                tools.enableButton("class");
                var attrId = self._getAttributeValue("id", nodeSelection);
                tools.getItem(prefix + "anchor:input").setValue(attrId);
                if (attrId) {
                  tools.setButtonActive("anchor");
                  tools.getItem("ViperFormatPlugin:vtp:anchorBubbleSubSection").setActionButtonTitle(_("Update Anchor"));
                } else {
                  tools.setButtonInactive("anchor");
                }
                var originalAttrClass = self._getAttributeValue("class", nodeSelection);
                const attrClass = self._getClassInitialValue(originalAttrClass, nodeSelection);
                tools.getItem(prefix + "class:input").setValue(attrClass);
                if (originalAttrClass) {
                  tools.setButtonActive("class");
                  tools.getItem("ViperFormatPlugin:vtp:classBubbleSubSection").setActionButtonTitle(_("Apply Styles"));
                } else {
                  tools.setButtonInactive("class");
                }
              } else {
                tools.getItem(prefix + "class:input").setValue("");
                tools.getItem(prefix + "anchor:input").setValue("");
                tools.setButtonInactive("anchor");
                tools.setButtonInactive("class");
              }
            }
            tools.disableButton("headings");
            tools.disableButton("formats");
            tools.setButtonInactive("headings");
            tools.setButtonInactive("formats");
            if (nodeSelection) {
              var inTableHeaderCell = false;
              if (ViperUtil.isTag(nodeSelection, "th") === true || ViperUtil.getParents(nodeSelection, "th", self.viper.getViperElement()).length > 0) {
                inTableHeaderCell = true;
              }
              if (ViperUtil.isBlockElement(nodeSelection) === false) {
                var surroundParent = ViperUtil.getSurroundingParents(
                  nodeSelection,
                  null,
                  "block",
                  self.viper.getViperElement()
                );
                if (surroundParent.length > 0) {
                  nodeSelection = surroundParent.shift();
                }
              }
              if (nodeSelection.nodeType === ViperUtil.TEXT_NODE) {
                if (range.collapsed === true) {
                  if (inTableHeaderCell === false) {
                    var blockquote = ViperUtil.getParents(nodeSelection, "blockquote", self.viper.getViperElement());
                    if (blockquote.length === 0 || ViperUtil.getTag("p", blockquote[0]).length <= 1) {
                      tools.enableButton("headings");
                    }
                  }
                }
              } else if ((ViperUtil.isTag(nodeSelection, "blockquote") !== true || ViperUtil.getTag("p", nodeSelection).length <= 1) && (ViperUtil.isTag(nodeSelection, "p") !== true || ViperUtil.isTag(nodeSelection.parentNode, "blockquote") === false)) {
                if (inTableHeaderCell === false && ViperUtil.isBlockElement(nodeSelection) === true && ViperUtil.inArray(ViperUtil.getTagName(nodeSelection), ignoredTags) === false) {
                  var blockChildren = ViperUtil.getBlockChildren(nodeSelection);
                  if (blockChildren.length <= 1) {
                    tools.enableButton("headings");
                  }
                }
              }
            } else if (range.collapsed === true && formatElement) {
              var firstBlock = ViperUtil.getFirstBlockParent(formatElement);
              if (ViperUtil.inArray(ViperUtil.getTagName(firstBlock), ignoredTags) === false && ViperUtil.isTag(firstBlock, "th") === false) {
                var isBlockQuote = false;
                if (ViperUtil.isTag(firstBlock, "p") === true && ViperUtil.isTag(firstBlock.parentNode, "blockquote") === true) {
                  firstBlock = firstBlock.parentNode;
                  isBlockQuote = true;
                } else if (ViperUtil.isTag(firstBlock, "blockquote") === true) {
                  isBlockQuote = true;
                }
                if (firstBlock && (isBlockQuote === false || ViperUtil.getTag("p", firstBlock).length === 1) && ViperUtil.getParents(firstBlock, "th", self.viper.getViperElement()).length === 0) {
                  tools.enableButton("headings");
                }
              }
            }
            for (var i = 0; i < headingTags.length; i++) {
              tools.setButtonInactive(prefix + "heading:" + headingTags[i]);
            }
            var headingElement = self.getTagFromRange(range, headingTags);
            if (headingElement) {
              var tagName = ViperUtil.getTagName(headingElement);
              tools.setButtonActive("headings");
              tools.setButtonActive(prefix + "heading:" + tagName);
            }
            var getValidParent = function(node) {
              var parent2 = ViperUtil.getFirstBlockParent(node);
              if (parent2 && ViperUtil.isTag(parent2, "p") === true && ViperUtil.isTag(parent2.parentNode, "blockquote") === true) {
                parent2 = parent2.parentNode;
              } else if (parent2 === self.viper.getViperElement()) {
                parent2 = null;
              }
              return parent2;
            };
            if (self._canEnableFormatButtons(startNode, nodeSelection, range) === true) {
              tools.getItem("formats").setIconClass("Viper-formats");
              if (range.collapsed === true) {
                var parent = getValidParent(startNode);
                if (parent !== null) {
                  tools.enableButton("formats");
                  var parentTagName = ViperUtil.getTagName(parent, range);
                  if (formatButtons[parentTagName]) {
                    tools.getItem("formats").setIconClass("Viper-formats-" + parentTagName);
                  }
                  var formatButtonStatuses = self.getFormatButtonStatuses(parent);
                  for (var tag in formatButtons) {
                    if (formatButtonStatuses[tag] === true) {
                      tools.enableButton(prefix + "formats:" + formatButtons[tag]);
                    } else {
                      tools.disableButton(prefix + "formats:" + formatButtons[tag]);
                    }
                    if (tag === parentTagName) {
                      tools.setButtonActive(prefix + "formats:" + formatButtons[tag]);
                      tools.setButtonActive("formats");
                    } else {
                      tools.setButtonInactive(prefix + "formats:" + formatButtons[tag]);
                    }
                  }
                } else {
                  tools.disableButton("formats");
                }
              } else if (nodeSelection && nodeSelection.nodeType === ViperUtil.ELEMENT_NODE) {
                var parentTagName = ViperUtil.getTagName(nodeSelection);
                var parent = nodeSelection;
                if (ViperUtil.isBlockElement(nodeSelection) === false) {
                  parent = getValidParent(startNode);
                  parentTagName = ViperUtil.getTagName(parent);
                } else if (parentTagName === "p" && ViperUtil.isTag(parent.parentNode, "blockquote") === true) {
                  parent = parent.parentNode;
                  parentTagName = "blockquote";
                }
                if (formatButtons[parentTagName] && nodeSelection !== viperElement) {
                  tools.getItem("formats").setIconClass("Viper-formats-" + parentTagName);
                }
                var isBlockElement2 = ViperUtil.isBlockElement(nodeSelection);
                if (isBlockElement2 === true) {
                  if (ViperUtil.isTag(nodeSelection, "p") === true && ViperUtil.isTag(nodeSelection.parentNode, "blockquote") === true && ViperUtil.getTag("p", nodeSelection.parentNode).length > 1) {
                    tools.disableButton("formats");
                  } else {
                    tools.enableButton("formats");
                    var formatButtonStatuses = self.getFormatButtonStatuses(parent);
                    for (var tag in formatButtons) {
                      if (formatButtonStatuses[tag] === true) {
                        tools.enableButton(prefix + "formats:" + formatButtons[tag]);
                      } else {
                        tools.disableButton(prefix + "formats:" + formatButtons[tag]);
                      }
                      if (tag === parentTagName) {
                        if (nodeSelection !== viperElement) {
                          tools.setButtonActive(prefix + "formats:" + formatButtons[tag]);
                          tools.setButtonActive("formats");
                        } else {
                          tools.setButtonInactive(prefix + "formats:" + formatButtons[tag]);
                        }
                      } else {
                        tools.setButtonInactive(prefix + "formats:" + formatButtons[tag]);
                      }
                    }
                  }
                } else if (parentTagName === "div") {
                  tools.enableButton("formats");
                  for (var tag in formatButtons) {
                    tools.setButtonInactive(prefix + "formats:" + formatButtons[tag]);
                    tools.enableButton(prefix + "formats:" + formatButtons[tag]);
                  }
                }
                var surroundingParents = ViperUtil.getSurroundingParents(
                  nodeSelection,
                  null,
                  "block",
                  self.viper.getViperElement()
                );
                if (surroundingParents.length > 0) {
                  var surroundingParent = surroundingParents[0];
                  var surTagName = ViperUtil.getTagName(surroundingParent);
                  if (surroundingParents.length > 1 && surTagName === "p" && ViperUtil.getTagName(surroundingParents[1]) === "blockquote") {
                    surTagName = "blockquote";
                  }
                  tools.setButtonActive(prefix + "formats:" + formatButtons[surTagName]);
                }
              } else {
                var startBlock = ViperUtil.getFirstBlockParent(startNode);
                var commonParent = self.getCommonFormatElement(range);
                if (commonParent && ViperUtil.isBlockElement(commonParent) === false) {
                  commonParent = ViperUtil.getFirstBlockParent(commonParent);
                }
                var commonTagName = ViperUtil.getTagName(commonParent);
                if (commonParent && formatButtons[commonTagName]) {
                  if (commonTagName === "p" && ViperUtil.isTag(commonParent.parentNode, "blockquote") === true) {
                    tools.getItem("formats").setIconClass("Viper-formats-blockquote");
                  } else {
                    tools.getItem("formats").setIconClass("Viper-formats-" + commonTagName);
                    if (commonTagName === "div") {
                      tools.enableButton("formats");
                    }
                  }
                  if (commonParent && startBlock !== commonParent) {
                    tools.enableButton("formats");
                    var formatButtonStatuses = self.getFormatButtonStatuses(commonParent);
                    for (var tag in formatButtons) {
                      if (formatButtonStatuses[tag] === true) {
                        tools.enableButton(prefix + "formats:" + formatButtons[tag]);
                      } else {
                        tools.disableButton(prefix + "formats:" + formatButtons[tag]);
                      }
                      if (tag === commonTagName) {
                        if (commonParent !== viperElement) {
                          if (tag !== "div") {
                            tools.setButtonActive(prefix + "formats:" + formatButtons[tag]);
                          } else {
                            tools.enableButton(prefix + "formats:" + formatButtons[tag]);
                          }
                        }
                        tools.enableButton("formats");
                        tools.setButtonActive("formats");
                      } else {
                        tools.setButtonInactive(prefix + "formats:" + formatButtons[tag]);
                      }
                    }
                  } else {
                    if (commonTagName === "div") {
                      for (var tag in formatButtons) {
                        tools.enableButton(prefix + "formats:" + formatButtons[tag]);
                        tools.setButtonInactive(prefix + "formats:" + formatButtons[tag]);
                      }
                    }
                  }
                } else if (startBlock === self.viper.getViperElement() && self.viper.getViperElement() === ViperUtil.getFirstBlockParent(endNode)) {
                  tools.enableButton("formats");
                  for (var tag in formatButtons) {
                    tools.setButtonInactive(prefix + "formats:" + formatButtons[tag]);
                  }
                } else {
                  tools.enableButton("formats");
                  var pOnly = self._selectionHasPTagsOnly(range);
                  for (var tag in formatButtons) {
                    tools.setButtonInactive(prefix + "formats:" + formatButtons[tag]);
                    if (tag === "div" || pOnly === true && tag === "blockquote") {
                      tools.enableButton(prefix + "formats:" + formatButtons[tag]);
                    } else {
                      tools.disableButton(prefix + "formats:" + formatButtons[tag]);
                    }
                  }
                }
              }
            } else {
              tools.getItem("formats").setIconClass("Viper-formats");
              if (range.collapsed === true) {
                var parent = getValidParent(startNode);
                var parentTagName = ViperUtil.getTagName(parent);
                if (formatButtons[parentTagName]) {
                  tools.getItem("formats").setIconClass("Viper-formats-" + parentTagName);
                }
              }
            }
          };
        },
        _updateTableEditorContent: function(data) {
          if (data.type === "cell" || data.type === "row" || data.type === "table") {
            var prefix = "ViperTableEditor-Format-" + data.type + ":";
            var element = data.cell;
            switch (data.type) {
              case "row":
                element = element.parentNode;
                break;
              case "table":
                element = ViperUtil.getParents(element, "table")[0];
                break;
              default:
                break;
            }
            var classBtnActive = false;
            var classAttribute = "";
            if (ViperUtil.hasAttribute(element, "class") === true) {
              classAttribute = element.getAttribute("class");
              this.viper.Tools.setButtonActive(prefix + "classBtn-" + data.type);
            } else {
              this.viper.Tools.setButtonInactive(prefix + "classBtn-" + data.type);
            }
            classAttribute = this._getClassInitialValue(classAttribute, element);
            this.viper.Tools.getItem(prefix + "class:input").setValue(classAttribute);
            data.toolbar.showButton(prefix + "classBtn-" + data.type);
          }
        },
        _createTableEditorContent: function(toolbar, type) {
          if (type === "cell" || type === "row" || type === "table") {
            var prefix = "ViperTableEditor-Format-" + type + ":";
            var element = null;
            var buttonIndex = null;
            switch (type) {
              case "row":
                buttonIndex = -1;
                break;
              case "table":
                buttonIndex = -1;
                break;
              default:
                buttonIndex = null;
                break;
            }
            var tools = this.viper.Tools;
            var button = tools.createButton(
              prefix + "classBtn-" + type,
              "",
              _("Class name"),
              "Viper-cssClass",
              null,
              false,
              false
            );
            toolbar.addButton(button, buttonIndex);
            var self = this;
            var tableEditorPlugin = this.viper.PluginManager.getPlugin("ViperTableEditorPlugin");
            var classSection = this._getClassSection(prefix);
            toolbar.makeSubSection(prefix + "class:subSection-" + type, classSection);
            toolbar.setSubSectionAction(
              prefix + "class:subSection-" + type,
              function() {
                var element2 = tableEditorPlugin.getActiveCell();
                switch (type) {
                  case "row":
                    element2 = element2.parentNode;
                    break;
                  case "table":
                    element2 = ViperUtil.getParents(element2, "table")[0];
                    break;
                  default:
                    break;
                }
                var value = tools.getItem(prefix + "class:input").getValue();
                self._updateClassAttribute(value, element2);
                tools.getItem(prefix + "class:input").setValue(value, true);
                if (value) {
                  tools.setButtonActive(prefix + "classBtn-" + type);
                } else {
                  tools.setButtonInactive(prefix + "classBtn-" + type);
                }
                self.viper.contentChanged(true);
              },
              [prefix + "class:input"]
            );
            tools.viper.registerCallback(
              "ViperTools:changed:" + this._styleListid,
              "ViperFormatPlugin-toolbar",
              function() {
                tools.enableButton(toolbar.getActiveSection() + "-applyButton");
              }
            );
            toolbar.setSubSectionButton(prefix + "classBtn-" + type, prefix + "class:subSection-" + type);
          }
        },
        _updateDefinedStylesList: function() {
          var tools = this.viper.Tools;
          var list = tools.getItem(this._styleListid);
          var selectedItems = list.getSelectedItems();
          var listItems = [];
          for (var i = 0; i < selectedItems.length; i++) {
            var styleListItem = document.createElement("div");
            ViperUtil.addClass(styleListItem, "ViperFormatPlugin-styleListItem");
            var content = '<div class="ViperFormatPlugin-styleListItem-name">' + this._custStyleNames[selectedItems[i]] + "</div>";
            content += '<div class="ViperFormatPlugin-styleListItem-classes">.' + this._custStyles[selectedItems[i]].classNames.join(" .") + "</div>";
            content += '<span class="ViperFormatPlugin-styleListItem-remove Viper-textbox-action" data-id="' + selectedItems[i] + '"></span>';
            ViperUtil.setHtml(styleListItem, content);
            listItems.push(styleListItem);
          }
          for (var i = 0; i < this._stylesListElement.length; i++) {
            ViperUtil.empty(this._stylesListElement[i]);
            if (listItems.length > 0) {
              for (var j = 0; j < listItems.length; j++) {
                this._stylesListElement[i].appendChild(listItems[j].cloneNode(true));
              }
            }
          }
        },
        _setAttributeForElement: function(element, attr2, value) {
          if (element.nodeType === ViperUtil.ELEMENT_NODE) {
            this.viper.setAttribute(element, attr2, value);
            return element;
          }
          return null;
        },
        _setAttributeForSelection: function(attr2, value) {
          var range = this.viper.getViperRange();
          var selectedNode = this.viper.getNodeSelection();
          if (selectedNode) {
            var oldVal = "";
            if (selectedNode.nodeType === ViperUtil.TEXT_NODE) {
              var span = document.createElement("span");
              ViperUtil.insertBefore(selectedNode, span);
              span.appendChild(selectedNode);
              selectedNode = span;
              range.selectNode(span);
              ViperSelection.addRange(range);
            } else {
              oldVal = selectedNode.getAttribute(attr2) || "";
            }
            this.viper.setAttribute(selectedNode, attr2, value);
            this.viper.contentChanged();
            this.viper.fireCallbacks("ViperFormatPlugin:elementAttributeSet", {
              element: selectedNode,
              oldValue: oldVal,
              newValue: value
            });
            return;
          } else if (ViperUtil.trim(value) === "") {
            return;
          }
          var bookmark = this.viper.createBookmark();
          var span = null;
          if (bookmark.start && bookmark.end) {
            if (bookmark.start.nextSibling && bookmark.start.nextSibling.nodeType === ViperUtil.ELEMENT_NODE && bookmark.start.nextSibling === bookmark.end.previousSibling) {
              span = bookmark.start.nextSibling;
              this.viper.removeBookmarks();
              this._setAttributeForElement(span, attr2, value);
              range.selectNode(span);
            } else {
              var attributes = { attributes: {} };
              attributes.attributes[attr2] = value;
              range = this.viper.selectBookmark(bookmark);
              this.viper.surroundContents("span", attributes, range);
              range = this.viper.getViperRange();
              this.viper.removeBookmarks();
            }
            ViperSelection.addRange(range);
            this.viper.adjustRange();
            this.viper.contentChanged();
            this.viper.fireCallbacks("ViperFormatPlugin:elementAttributeSet", {
              element: span,
              oldValue: "",
              newValue: value
            });
            return span;
          }
          return null;
        },
        _canShowHeadingOptions: function(node) {
          if (!node) {
            return false;
          }
          if (node.nodeType === ViperUtil.TEXT_NODE) {
            return false;
          } else if (ViperUtil.isBlockElement(node) === false) {
            return false;
          } else {
            switch (node.tagName.toLowerCase()) {
              case "li":
              case "ul":
              case "ol":
              case "img":
              case "th":
              case "tr":
              case "td":
              case "table":
              case "caption":
                return false;
                break;
              case "blockquote":
                if (ViperUtil.getTag("p", node).length > 1) {
                  return false;
                } else {
                  var textContent = ViperUtil.getNodeTextContent(node);
                  if (textContent && textContent.length > 80) {
                    return false;
                  }
                }
                break;
              default:
                if (ViperUtil.isTag(node, "p") === true && ViperUtil.isTag(node.parentNode, "blockquote") === true) {
                  return false;
                }
                var textContent = ViperUtil.getNodeTextContent(node);
                if (textContent && textContent.length > 80) {
                  return false;
                }
                return true;
                break;
            }
          }
          return true;
        },
        _canEnableFormatButtons: function(startNode, nodeSelection, range) {
          var ignoredTagsStr = "tr|table|tbody|thead|tfoot|caption|ul|ol|li|img";
          var ignoredTags = ignoredTagsStr.split("|");
          var viperElement = this.viper.getViperElement();
          var parents = ViperUtil.getParents(startNode, "caption,ul,ol,li,img", viperElement);
          if (parents.length > 0 || ViperUtil.isStubElement(startNode) === true && ViperUtil.isTag(startNode, "br") === false) {
            return false;
          } else if (range.collapsed === true && startNode.nodeType === ViperUtil.TEXT_NODE) {
            var blockquotes = ViperUtil.getParents(startNode, "blockquote", viperElement);
            if (blockquotes.length === 1 && ViperUtil.getTag("p", blockquotes[0]).length > 1) {
              return false;
            }
          }
          if (nodeSelection) {
            if (ViperUtil.inArray(ViperUtil.getTagName(nodeSelection), ignoredTags) === true) {
              return false;
            } else if (ViperUtil.isBlockElement(nodeSelection) === false && ViperUtil.inArray(ViperUtil.getTagName(ViperUtil.getFirstBlockParent(nodeSelection)), ignoredTags) === true) {
              return false;
            }
          } else if (startNode) {
            if (ViperUtil.inArray(ViperUtil.getTagName(ViperUtil.getFirstBlockParent(startNode)), ignoredTags) === true) {
              return false;
            }
          }
          return true;
        },
        isWholeBlockSelection: function(range) {
          range = range || this.viper.getViperRange();
          var nodeSelection = range.getNodeSelection();
          if (nodeSelection && ViperUtil.isBlockElement(nodeSelection) === true) {
            return nodeSelection;
          }
          if (range.startContainer.nodeType === ViperUtil.TEXT_NODE && range.endContainer.nodeType === ViperUtil.TEXT_NODE && range.startOffset === 0 && range.endOffset === range.endContainer.data.length) {
            var startBlock = ViperUtil.getFirstBlockParent(range.startContainer);
            var endBlock = ViperUtil.getFirstBlockParent(range.endContainer);
            if (range._getFirstSelectableChild(startBlock) === range.startContainer && range._getLastSelectableChild(endBlock) === range.endContainer) {
              return true;
            }
          }
          return false;
        },
        _selectionHasPTagsOnly: function(range) {
          var startBlock = ViperUtil.getFirstBlockParent(range.startContainer);
          var endBlock = ViperUtil.getFirstBlockParent(range.endContainer);
          var common = range.getCommonElement();
          var elements = ViperUtil.getElementsBetween(startBlock, endBlock);
          if (startBlock) {
            elements.push(startBlock);
          }
          if (endBlock) {
            elements.push(endBlock);
          }
          for (var i = 0; i < elements.length; i++) {
            if (elements[i].nodeType === ViperUtil.TEXT_NODE && ViperUtil.trim(elements[i].data) === "") {
              continue;
            } else if (ViperUtil.isBlockElement(elements[i]) === true && ViperUtil.isTag(elements[i], "p") === false) {
              return false;
            } else {
              var blockParents = ViperUtil.getParents(elements[i], null, common, true);
              for (var j = 0; j < blockParents.length; j++) {
                if (ViperUtil.isTag(blockParents[j], "p") === false) {
                  return false;
                }
              }
            }
          }
          return true;
        },
        /**
         * Returns the statuses of buttons for the current range.
         *
         * @return {object}
         */
        getFormatButtonStatuses: function(element) {
          var statuses = {
            p: false,
            pre: false,
            div: false,
            blockquote: false,
            _none: false,
            _canChange: false
          };
          var range = this.viper.getViperRange();
          var selectedNode = element || range.getNodeSelection();
          var viperElement = this.viper.getViperElement();
          var defaultTag = this.viper.getDefaultBlockTag();
          if (!selectedNode && range.startContainer === range.endContainer && range.collapsed === true) {
            selectedNode = ViperUtil.getFirstBlockParent(range.startContainer);
          }
          if (selectedNode === viperElement) {
            statuses = {
              p: true,
              pre: true,
              div: true,
              blockquote: true,
              _none: false,
              _canChange: true
            };
            var parasOnly = true;
            var hasBlockChildren = false;
            for (var node = selectedNode.firstChild; node; node = node.nextSibling) {
              if (ViperUtil.isBlockElement(node) === true) {
                hasBlockChildren = true;
                if (ViperUtil.isTag(node, "p") !== true) {
                  parasOnly = false;
                  break;
                }
              }
            }
            if (parasOnly === false) {
              statuses.p = false;
              statuses.pre = false;
              statuses.blockquote = false;
            } else if (hasBlockChildren === true) {
              statuses.p = false;
              statuses.pre = false;
            }
            return statuses;
          }
          if (selectedNode && ViperUtil.isBlockElement(selectedNode) === true) {
            var isBlockquote = false;
            var singlePTag = true;
            if (ViperUtil.isTag(selectedNode, "p") === true && ViperUtil.isTag(selectedNode.parentNode, "blockquote") === true) {
              selectedNode = selectedNode.parentNode;
              isBlockquote = true;
              if (ViperUtil.getTag("p", selectedNode).length > 1) {
                singlePTag = false;
              }
            }
            for (var tagName in statuses) {
              if (isBlockquote === true) {
                statuses[tagName] = singlePTag;
                continue;
              }
              var canConvert = this.canConvert(selectedNode, tagName);
              statuses[tagName] = canConvert;
              if (canConvert === true) {
                statuses._canChange = false;
              }
            }
            statuses._none = singlePTag;
          } else if (selectedNode && selectedNode.nodeType === ViperUtil.TEXT_NODE) {
            var parent = ViperUtil.getFirstBlockParent(selectedNode);
            if (ViperUtil.isTag(parent, "div") === true) {
              statuses = {
                p: true,
                pre: true,
                div: true,
                blockquote: true
              };
            }
          } else {
            var start = range.getStartNode();
            if (!start) {
              return statuses;
            }
            var end = range.getEndNode();
            var elements = ViperUtil.getElementsBetween(start, end);
            var commonElem = range.getCommonElement();
            elements.unshift(start);
            if (start !== end && end) {
              elements.push(end);
            }
            var parents = [];
            for (var i = 0; i < elements.length; i++) {
              var elem = elements[i];
              if (elem.nodeType === ViperUtil.TEXT_NODE && ViperUtil.trim(elem.data) === "") {
                continue;
              }
              if (ViperUtil.isBlockElement(elem) === true) {
                parents.push(elem);
              }
              var elemParents = ViperUtil.getParents(elem, null, commonElem);
              for (var j = 0; j < elemParents.length; j++) {
                if (ViperUtil.isBlockElement(elemParents[j]) === true) {
                  parents.push(elemParents[j]);
                }
              }
            }
            if (parents.length === 0) {
              var parent = ViperUtil.getFirstBlockParent(start);
              if (ViperUtil.isTag(parent, "div") === true) {
                statuses = {
                  p: true,
                  pre: true,
                  div: true,
                  blockquote: true,
                  _canChange: true
                };
              }
            } else {
              statuses.div = true;
              statuses._canChange = true;
              if (parents.length > 0) {
                statuses.blockquote = true;
              }
            }
          }
          return statuses;
        },
        canConvert: function(element, toTagName) {
          var tagName = ViperUtil.getTagName(element);
          if (tagName === "p") {
            if (ViperUtil.isTag(element.parentNode, "blockquote") === true) {
              return false;
            }
          }
          if (toTagName === "_none") {
            if (this.viper.getDefaultBlockTag() === "") {
              return true;
            }
            return false;
          } else if (tagName === toTagName && this.viper.getDefaultBlockTag() !== "") {
            return false;
          }
          switch (toTagName) {
            case "p":
              if (this.hasBlockChildren(element) === true) {
                return false;
              }
              var preTags = ViperUtil.getParents(element, "pre", this.viper.getViperElement());
              if (preTags.length > 0) {
                return false;
              }
              break;
            case "pre":
              if (this.hasBlockChildren(element) === true) {
                return false;
              }
              break;
            case "blockquote":
              var tags = ViperUtil.getTag("*", element);
              for (var i = 0; i < tags.length; i++) {
                if (ViperUtil.isBlockElement(tags[i]) === true && ViperUtil.isTag(tags[i], "p") === false && ViperUtil.isStubElement(tags[i]) === false) {
                  return false;
                }
              }
              break;
          }
          return true;
        },
        hasBlockChildren: function(element) {
          var isBlockQuote = ViperUtil.isTag(element, "blockquote");
          var hasBlock = false;
          var tags = ViperUtil.getTag("*", element);
          for (var i = 0; i < tags.length; i++) {
            if (ViperUtil.isBlockElement(tags[i]) === true && ViperUtil.isStubElement(tags[i]) === false) {
              if (isBlockQuote === true && hasBlock === false && ViperUtil.isTag(tags[i], "p") === true) {
                hasBlock = true;
                continue;
              }
              return true;
            }
          }
          return false;
        },
        /**
         * Handles the format change.
         *
         * @param {string} type The type of the element.
         */
        handleFormat: function(type) {
          var lineage = [];
          var currentLinIndex = 0;
          if (this._inlineToolbar) {
            lineage = this._inlineToolbar.getLineage();
            currentLinIndex = this._inlineToolbar.getCurrentLineageIndex();
          }
          var range = this.viper.getViperRange();
          var selectedNode = selectedNode || range.getNodeSelection();
          var nodeSelection = selectedNode;
          var viperElement = this.viper.getViperElement();
          var formatElement = null;
          if (range.collapsed !== true) {
            formatElement = lineage[currentLinIndex];
            if (formatElement && formatElement.nodeType !== ViperUtil.TEXT_NODE) {
              selectedNode = formatElement;
            }
          }
          if (selectedNode === viperElement) {
            selectedNode = null;
          } else if (selectedNode && ViperUtil.isBlockElement(selectedNode) === false) {
            var surroundingBlockElems = ViperUtil.getSurroundingParents(selectedNode, null, true);
            if (surroundingBlockElems.length > 0) {
              selectedNode = surroundingBlockElems[0];
            }
          }
          if (selectedNode && (selectedNode.nodeType !== ViperUtil.ELEMENT_NODE || ViperUtil.isStubElement(selectedNode) === true)) {
            selectedNode = ViperUtil.getFirstBlockParent(selectedNode);
          } else if (!selectedNode && (range.collapsed === true || type.match(/^h\d$/))) {
            var startNode = range.getStartNode();
            if (ViperUtil.isBlockElement(startNode) === true) {
              selectedNode = startNode;
            } else {
              selectedNode = ViperUtil.getFirstBlockParent(range.startContainer, null, true);
            }
          } else if (selectedNode && ViperUtil.isBlockElement(selectedNode) === false) {
            var surroundParent = ViperUtil.getSurroundingParents(selectedNode, null, "block", this.viper.getViperElement());
            if (surroundParent.length > 0) {
              selectedNode = surroundParent.shift();
            }
          }
          if (selectedNode) {
            var ignoreTags = ["li"];
            if (ViperUtil.inArray(ViperUtil.getTagName(selectedNode), ignoreTags) === true) {
              return false;
            }
            if (selectedNode !== viperElement) {
              var bookmark = this.viper.createBookmark();
              if (ViperUtil.isTag(selectedNode, "td") === true || ViperUtil.isTag(selectedNode, "th") === true || ViperUtil.isTag(selectedNode, "caption") === true) {
                var newElem = document.createElement(type);
                if (type === "blockquote" && ViperUtil.getTag(selectedNode, "p").length === 0) {
                  newElem.appendChild(document.createElement("p"));
                  while (selectedNode.firstChild) {
                    newElem.firstChild.appendChild(selectedNode.firstChild);
                  }
                } else if (type.match(/^h\d$/)) {
                  while (selectedNode.firstChild) {
                    if (ViperUtil.isBlockElement(selectedNode.firstChild) === true) {
                      while (selectedNode.firstChild.firstChild) {
                        newElem.appendChild(selectedNode.firstChild.firstChild);
                      }
                      ViperUtil.remove(selectedNode.firstChild);
                    } else {
                      newElem.appendChild(selectedNode.firstChild);
                    }
                  }
                } else {
                  while (selectedNode.firstChild) {
                    newElem.appendChild(selectedNode.firstChild);
                  }
                }
                selectedNode.appendChild(newElem);
                this.viper.selectBookmark(bookmark);
              } else if (ViperUtil.isBlockElement(selectedNode) === false) {
                var newElem = document.createElement(type);
                ViperUtil.insertBefore(selectedNode, newElem);
                if (type === "blockquote") {
                  var p = document.createElement("p");
                  newElem.appendChild(p);
                  newElem = p;
                }
                newElem.appendChild(selectedNode);
                range = this.viper.selectBookmark(bookmark);
                ViperSelection.addRange(range);
              } else {
                var newElem = this._convertSingleElement(selectedNode, type);
                if (nodeSelection && newElem) {
                  this.viper.removeBookmarks();
                  if (ViperUtil.hasContent(newElem) === false) {
                    if (type === "blockquote") {
                      ViperUtil.setHtml(newElem, "<p><br/></p>");
                      range.setStart(newElem.firstElementChild.firstElementChild, 0);
                    } else if (type === "pre") {
                      ViperUtil.setHtml(newElem, " ");
                      range.setStart(newElem.firstChild, 0);
                    } else {
                      ViperUtil.setHtml(newElem, "<br/>");
                      range.setStart(newElem.firstElementChild, 0);
                    }
                    range.collapse(true);
                  } else {
                    range.selectNode(newElem);
                  }
                  ViperSelection.addRange(range);
                } else {
                  this.viper.selectBookmark(bookmark);
                }
              }
              this.viper.contentChanged();
            } else {
              this._handleTopLevelFormat(type, range);
            }
          } else {
            var start = range.getStartNode();
            var end = range.getEndNode();
            var elements = ViperUtil.getElementsBetween(start, end);
            elements.unshift(start);
            if (start !== end && end) {
              if (end.nodeType === ViperUtil.TEXT_NODE && range.endOffset > 0) {
                elements.push(end);
              } else {
                var elem = range.getPreviousContainer(end, null, true);
                range.setEnd(elem, elem.data.length);
                ViperSelection.addRange(range);
              }
            }
            var parents = [];
            var c = elements.length;
            for (var i = 0; i < c; i++) {
              if (elements[i].nodeType === ViperUtil.TEXT_NODE && ViperUtil.isBlank(ViperUtil.trim(elements[i].data)) === true) {
                continue;
              } else if (ViperUtil.isBlockElement(elements[i]) === true) {
                if (ViperUtil.inArray(elements[i], parents) === false) {
                  parents.push(elements[i]);
                }
              } else {
                var parent = ViperUtil.getFirstBlockParent(elements[i]);
                if (parent && ViperUtil.inArray(parent, parents) === false) {
                  parents.push(parent);
                }
              }
            }
            if (parents.length === 1 && range.collapsed === false) {
              var parent = parents[0];
              var newElement = document.createElement(type);
              var contents = range.getHTMLContents();
              if (type === "blockquote") {
                contents = "<p>" + contents + "</p>";
              }
              ViperUtil.setHtml(newElement, contents);
              var bookmark = this.viper.createBookmark();
              ViperUtil.remove(ViperUtil.getElementsBetween(bookmark.start, bookmark.end));
              ViperUtil.insertAfter(bookmark.start, newElement);
              this.viper.selectBookmark(bookmark);
              this.viper.contentChanged();
              this.viper.fireCallbacks("ViperFormatPlugin:formatChanged", type);
              return;
            }
            var prevParent = null;
            var siblings = true;
            var commonElem = range.getCommonElement();
            var newParents = [];
            for (var i = 0; i < parents.length; i++) {
              var parent = parents[i];
              if (parent !== commonElem && parent.parentNode !== commonElem) {
                var parentParents = ViperUtil.getParents(parent, null, commonElem);
                var skip = false;
                if (newParents.length !== 0) {
                  for (var j = 0; j < parentParents.length; j++) {
                    if (ViperUtil.inArray(parentParents[j], newParents) === true) {
                      skip = true;
                      break;
                    }
                  }
                }
                if (skip === true) {
                  continue;
                }
                for (var j = 0; j < parentParents.length; j++) {
                  var parentParent = parentParents[j];
                  for (var node = parent.previousSibling; node; node = node.previousSibling) {
                    if (node && node.nodeType === ViperUtil.ELEMENT_NODE || ViperUtil.trim(node.data) !== "") {
                      return false;
                    }
                  }
                  parent = parentParent;
                }
                newParents.push(parent);
              } else {
                newParents.push(parent);
              }
            }
            if (newParents.length > 0) {
              var removeType = false;
              if (ViperUtil.isTag(commonElem, type) === true && commonElem !== viperElement) {
                var firstSelectableParent = ViperUtil.getFirstBlockParent(range._getFirstSelectableChild(commonElem));
                var lastSelectableParent = ViperUtil.getFirstBlockParent(range._getLastSelectableChild(commonElem));
                var lastParent = newParents[newParents.length - 1];
                if (firstSelectableParent === newParents[0]) {
                  while (lastSelectableParent !== commonElem) {
                    if (lastSelectableParent === lastParent) {
                      removeType = true;
                      break;
                    }
                    lastSelectableParent = lastSelectableParent.parentNode;
                  }
                }
              }
              var bookmark = this.viper.createBookmark();
              if (removeType === true) {
                for (var i = 0; i < newParents.length; i++) {
                  ViperUtil.insertBefore(commonElem, newParents[i]);
                }
                ViperUtil.remove(commonElem);
              } else {
                var newElem = document.createElement(type);
                ViperUtil.insertBefore(newParents[0], newElem);
                for (var i = 0; i < newParents.length; i++) {
                  if (type === "blockquote" && ViperUtil.isTag(newParents[i], "p") === false) {
                    var pTag = document.createElement("p");
                    while (newParents[i].firstChild) {
                      pTag.appendChild(newParents[i].firstChild);
                    }
                    newElem.appendChild(pTag);
                    ViperUtil.remove(newParents[i]);
                  } else {
                    newElem.appendChild(newParents[i]);
                  }
                }
              }
              this.viper.selectBookmark(bookmark);
              this.viper.contentChanged();
            }
          }
          this.viper.fireCallbacks("ViperFormatPlugin:formatChanged", type);
        },
        _convertSingleElement: function(element, type) {
          var isBlockQuote = false;
          if (ViperUtil.isTag(element, "p") === true && ViperUtil.isTag(element.parentNode, "blockquote") === true) {
            element = element.parentNode;
            isBlockQuote = true;
          } else if (ViperUtil.isTag(element, "blockquote") === true) {
            isBlockQuote = true;
          }
          if (ViperUtil.isTag(element, type) === true) {
            if (element.parentNode === this.viper.getViperElement()) {
              if (this.viper.getDefaultBlockTag() !== "") {
                if (type === this.viper.getDefaultBlockTag()) {
                  return null;
                } else if (ViperUtil.hasBlockChildren(element) === false) {
                  return this._convertSingleElement(element, this.viper.getDefaultBlockTag());
                } else {
                  var parentElem = null;
                  while (element.firstChild) {
                    if (ViperUtil.isBlockElement(element.firstChild) === false) {
                      if (element.firstChild.nodeType === ViperUtil.TEXT_NODE && ViperUtil.isBlank(ViperUtil.trim(element.firstChild.data)) === true) {
                        ViperUtil.remove(element.firstChild);
                        continue;
                      } else if (!parentElem) {
                        parentElem = document.createElement(this.viper.getDefaultBlockTag());
                        ViperUtil.insertBefore(element, parentElem);
                      }
                      parentElem.appendChild(element.firstChild);
                    } else {
                      parentElem = null;
                      ViperUtil.insertBefore(element, element.firstChild);
                    }
                  }
                  ViperUtil.remove(element);
                  return;
                }
              }
            }
            if (type.indexOf("h") === 0) {
              var p = document.createElement("p");
              while (element.firstChild) {
                p.appendChild(element.firstChild);
              }
              ViperUtil.insertBefore(element, p);
            } else {
              while (element.firstChild) {
                if (isBlockQuote === true && ViperUtil.isTag(element.firstChild, "p") === true) {
                  while (element.firstChild.firstChild) {
                    ViperUtil.insertBefore(element, element.firstChild.firstChild);
                  }
                  ViperUtil.remove(element.firstChild);
                } else {
                  ViperUtil.insertBefore(element, element.firstChild);
                }
              }
            }
            if (type === "pre") {
              this._convertNewLineToBr(element);
            }
            ViperUtil.remove(element);
          } else if (type === "blockquote") {
            var newElem = document.createElement(type);
            ViperUtil.insertBefore(element, newElem);
            if (ViperUtil.isTag(element, "p") === true) {
              newElem.appendChild(element);
            } else if (ViperUtil.getTag("p", element).length > 0) {
              while (element.firstChild) {
                newElem.appendChild(element.firstChild);
              }
              ViperUtil.remove(element);
            } else {
              var p = document.createElement("p");
              newElem.appendChild(p);
              while (element.firstChild) {
                p.appendChild(element.firstChild);
              }
              ViperUtil.remove(element);
            }
            ViperUtil.copyAttributes(element, newElem);
            return newElem;
          } else {
            var newElem = document.createElement(type);
            if (isBlockQuote === true && (type === "p" || type === "pre")) {
              for (var childPTag = element.firstChild; childPTag; childPTag = childPTag.nextSibling) {
                while (childPTag.firstChild) {
                  newElem.appendChild(childPTag.firstChild);
                }
              }
            } else if (isBlockQuote === true && type.match(/^h\d$/)) {
              while (element.firstChild) {
                newElem.appendChild(element.firstChild);
              }
              var pTag = ViperUtil.getTag("p", newElem)[0];
              while (pTag.firstChild) {
                newElem.appendChild(pTag.firstChild);
              }
              ViperUtil.remove(pTag);
            } else if (isBlockQuote === true && type === "div") {
              var childPTags = ViperUtil.getTag("p", element);
              for (var i = 0; i < childPTags.length; i++) {
                var childPTag = childPTags[i];
                var div = document.createElement("div");
                ViperUtil.copyAttributes(element, div);
                ViperUtil.insertBefore(element, div);
                while (childPTag.firstChild) {
                  div.appendChild(childPTag.firstChild);
                }
              }
              newElem = null;
            } else if (type.match(/^h\d$/)) {
              while (element.firstChild) {
                if (ViperUtil.isBlockElement(element.firstChild) === true) {
                  var firstChild = element.firstChild;
                  if (ViperUtil.isTag(firstChild, "blockquote") === true) {
                    firstChild = firstChild.firstChild;
                  }
                  while (firstChild.firstChild) {
                    newElem.appendChild(firstChild.firstChild);
                  }
                  ViperUtil.remove(element.firstChild);
                } else {
                  newElem.appendChild(element.firstChild);
                }
              }
            } else {
              while (element.firstChild) {
                newElem.appendChild(element.firstChild);
              }
            }
            if (newElem) {
              if (type === "pre") {
                this._convertBrToNewLine(newElem);
              } else if (ViperUtil.isTag(element, "pre") === true) {
                this._convertNewLineToBr(newElem);
              }
              ViperUtil.insertBefore(element, newElem);
              ViperUtil.copyAttributes(element, newElem);
            }
            ViperUtil.remove(element);
            return newElem;
          }
          return null;
        },
        _convertBrToNewLine: function(element) {
          var brTags = ViperUtil.getTag("br", element);
          for (var i = 0; i < brTags.length; i++) {
            var node = document.createTextNode("\n");
            ViperUtil.insertBefore(brTags[i], node);
            ViperUtil.remove(brTags[i]);
          }
        },
        _convertNewLineToBr: function(element) {
          if (element.nodeType === ViperUtil.TEXT_NODE) {
            var nlIndex = -1;
            do {
              nlIndex = element.data.lastIndexOf("\n");
              if (nlIndex >= 0) {
                var newNode = element.splitText(nlIndex);
                var br = document.createElement("br");
                ViperUtil.insertBefore(newNode, br);
                if (newNode.data.length === 1) {
                  ViperUtil.remove(newNode);
                } else {
                  newNode.data = newNode.data.substring(1, newNode.data.length);
                }
              }
            } while (nlIndex >= 0);
          } else {
            var textNodes = ViperUtil.getTextNodes(element);
            var c = textNodes.length;
            for (var i = 0; i < c; i++) {
              var textNode = textNodes[i];
              this._convertNewLineToBr(textNode);
            }
          }
        },
        _handleTopLevelFormat: function(type, range) {
          var bookmark = this.viper.createBookmark();
          var elements = [];
          var node = bookmark.start;
          while (node && ViperUtil.isBlockElement(node) === false) {
            elements.unshift(node);
            node = node.previousSibling;
          }
          var insideSelection = ViperUtil.getElementsBetween(bookmark.start, bookmark.end);
          var count = insideSelection.length;
          for (var i = 0; i < count; i++) {
            if (ViperUtil.isBlockElement(insideSelection[i]) === true && ViperUtil.isStubElement(insideSelection[i]) === false) {
              var group = [];
              for (var j = 0; j < insideSelection[i].childNodes.length; j++) {
                group.push(insideSelection[i].childNodes[j]);
              }
              elements.push(group);
            } else {
              elements.push(insideSelection[i]);
            }
          }
          node = bookmark.end;
          while (node && ViperUtil.isBlockElement(node) === false) {
            elements.push(node);
            node = node.nextSibling;
          }
          if (elements.length === 0) {
            return;
          }
          var newBlock = document.createElement(type);
          var prevBlock = newBlock;
          ViperUtil.insertBefore(elements[0], newBlock);
          var c = elements.length;
          for (var i = 0; i < c; i++) {
            if (elements[i] instanceof Array) {
              newBlock = document.createElement(type);
              for (var j = 0; j < elements[i].length; j++) {
                newBlock.appendChild(elements[i][j]);
              }
              ViperUtil.insertAfter(prevBlock, newBlock);
              prevBlock = newBlock;
              newBlock = null;
            } else {
              if (!newBlock) {
                newBlock = document.createElement(type);
                ViperUtil.insertAfter(prevBlock, newBlock);
                prevBlock = newBlock;
              }
              newBlock.appendChild(elements[i]);
            }
          }
          this.viper.selectBookmark(bookmark);
          this.viper.contentChanged();
        },
        _getFormat: function(startNode) {
          while (startNode.parentNode) {
            if (startNode === document) {
              return null;
            }
            if (startNode.tagName) {
              var tagName = startNode.tagName.toLowerCase();
              if (this.styleTags[tagName]) {
                return tagName;
              }
            }
            startNode = startNode.parentNode;
          }
          return null;
        }
      };
    };
  }
});

// src/Plugins/ViperListPlugin/ViperListPlugin.js
var ViperListPlugin_exports = {};
__export(ViperListPlugin_exports, {
  registerPlugin: () => registerPlugin15
});
var registerPlugin15;
var init_ViperListPlugin = __esm({
  "src/Plugins/ViperListPlugin/ViperListPlugin.js"() {
    "use strict";
    registerPlugin15 = (Viper2) => {
      const { Util: ViperUtil, Selection: ViperSelection, DOMRange: ViperDOMRange, _ } = Viper2;
      function ViperListPlugin(viper) {
        this.viper = viper;
        this.toolbarPlugin = null;
        this.initInlineToolbar();
      }
      Viper2.PluginManager.addPlugin("ViperListPlugin", ViperListPlugin);
      ViperListPlugin.prototype = {
        init: function() {
          var self = this;
          var toolbarPlugin = this.viper.PluginManager.getPlugin("ViperToolbarPlugin");
          if (toolbarPlugin) {
            var self = this;
            var tools = this.viper.Tools;
            this._toolbarPlugin = toolbarPlugin;
            var toolbarButtons = {
              ul: "unorderedList",
              ol: "orderedList",
              indent: "indentList",
              outdent: "outdentList"
            };
            var btnGroup = tools.createButtonGroup("ViperListPlugin:vtp:buttons");
            tools.createButton(
              "unorderedList",
              "",
              _("Make Unordered List"),
              "Viper-listUL",
              function() {
                var statuses = self._getButtonStatuses(null, true);
                return self._makeListButtonAction(statuses.list, "ul");
              },
              true
            );
            tools.createButton(
              "orderedList",
              "",
              _("Make Ordered List"),
              "Viper-listOL",
              function() {
                var statuses = self._getButtonStatuses(null, true);
                return self._makeListButtonAction(statuses.list, "ol");
              },
              true
            );
            tools.createButton(
              "indentList",
              "",
              _("Indent List"),
              "Viper-listIndent",
              function() {
                if (self.tabRange(null, false, true) === false) {
                  self.convertRangeToList();
                } else {
                  self.tabRange();
                }
              },
              true
            );
            tools.createButton(
              "outdentList",
              "",
              _("Outdent List"),
              "Viper-listOutdent",
              function() {
                self.tabRange(null, true);
              },
              true
            );
            tools.addButtonToGroup("unorderedList", "ViperListPlugin:vtp:buttons");
            tools.addButtonToGroup("orderedList", "ViperListPlugin:vtp:buttons");
            tools.addButtonToGroup("indentList", "ViperListPlugin:vtp:buttons");
            tools.addButtonToGroup("outdentList", "ViperListPlugin:vtp:buttons");
            this._toolbarPlugin.addButton(btnGroup);
            this.viper.registerCallback("ViperToolbarPlugin:updateToolbar", "ViperListPlugin", function(data) {
              self._updateToolbar(toolbarButtons, data.range);
            });
          }
          this.viper.registerCallback("Viper:keyDown", "ViperListPlugin", function(e) {
            if (e.which === 9) {
              var range = self.viper.getViperRange();
              var startNode = range.getStartNode();
              if (!startNode) {
                startNode = range.startContainer;
              }
              if (!startNode) {
                return;
              }
              var firstBlock = ViperUtil.getFirstBlockParent(startNode, null, true);
              if (ViperUtil.isTag(firstBlock, "li") === true) {
                if (range.collapsed === true && ViperUtil.getParents(startNode, "td,th", self.viper.getViperElement()).length > 0) {
                  return;
                } else if (self.tabRange(range, e.shiftKey, true) === true) {
                  self.tabRange(range, e.shiftKey);
                }
                ViperUtil.preventDefault(e);
                return false;
              } else if (e.shiftKey !== true) {
                if (ViperUtil.isTag(startNode, "p") === true || (startNode.nodeType === ViperUtil.TEXT_NODE || ViperUtil.isStubElement(startNode) === true) && ViperUtil.isTag(ViperUtil.getFirstBlockParent(startNode), "p") === true) {
                  if (ViperUtil.getParents(startNode, "td,th,blockquote", self.viper.getViperElement()).length === 0) {
                    self.convertRangeToList(range);
                    ViperUtil.preventDefault(e);
                    return false;
                  }
                }
              }
            }
          });
          this.viper.registerCallback("Viper:editableElementChanged", "ViperListPlugin", function() {
            var touched = false;
            var x = null;
            ViperUtil.addEvent(self.viper.getViperElement(), "touchstart", function(e) {
              x = e.pageX;
              touched = true;
            });
            ViperUtil.addEvent(self.viper.getViperElement(), "touchmove", function(e) {
              if (touched === true && x < e.pageX) {
                self.indentListItems([e.target]);
              } else if (touched === true && x > e.pageX) {
                self.outdentListItems([e.target]);
              }
              touched = false;
            });
            ViperUtil.addEvent(self.viper.getViperElement(), "touchend", function(e) {
              touched = false;
            });
          });
        },
        initInlineToolbar: function() {
          var self = this;
          this.viper.registerCallback("ViperInlineToolbarPlugin:initToolbar", "ViperListPlugin", function(toolbar) {
            self.createInlineToolbar(toolbar);
          });
          this.viper.registerCallback("ViperInlineToolbarPlugin:updateToolbar", "ViperListPlugin", function(data) {
            self.updateInlineToolbar(data);
          });
        },
        createInlineToolbar: function(toolbar) {
          var self = this;
          var tools = this.viper.Tools;
          var buttonGroup = tools.createButtonGroup("ViperListPlugin:vitp:buttons");
          toolbar.addButton(buttonGroup);
          tools.createButton("vitpUnorderedList", "", _("Make Unordered List"), "Viper-listUL", function() {
            var statuses = self._getButtonStatuses();
            self._makeListButtonAction(statuses.list, "ul");
          });
          tools.createButton("vitpOrderedList", "", _("Make Ordered List"), "Viper-listOL", function() {
            var statuses = self._getButtonStatuses();
            self._makeListButtonAction(statuses.list, "ol");
          });
          tools.addButtonToGroup("vitpUnorderedList", "ViperListPlugin:vitp:buttons");
          tools.addButtonToGroup("vitpOrderedList", "ViperListPlugin:vitp:buttons");
          tools.createButton("vitpIndentList", "", _("Indent List"), "Viper-listIndent", function() {
            self.tabRange();
          });
          tools.createButton("vitpOutdentList", "", _("Outdent List"), "Viper-listOutdent", function() {
            self.tabRange(null, true);
          });
          tools.addButtonToGroup("vitpIndentList", "ViperListPlugin:vitp:buttons");
          tools.addButtonToGroup("vitpOutdentList", "ViperListPlugin:vitp:buttons");
        },
        updateInlineToolbar: function(data) {
          var statuses = this._getButtonStatuses(data.range);
          if (!statuses) {
            return;
          }
          var tools = this.viper.Tools;
          if (statuses.ul === true || statuses.ol === true) {
            data.toolbar.showButton("vitpUnorderedList", !statuses.ul);
            data.toolbar.showButton("vitpOrderedList", !statuses.ol);
            if (statuses.isUL === true) {
              tools.setButtonActive("vitpUnorderedList");
              tools.setButtonInactive("vitpOrderedList");
            } else if (statuses.isOL === true) {
              tools.setButtonActive("vitpOrderedList");
              tools.setButtonInactive("vitpUnorderedList");
            }
          }
          if (statuses.increaseIndent === true || statuses.decreaseIndent === true) {
            data.toolbar.showButton("vitpIndentList", !statuses.increaseIndent);
            data.toolbar.showButton("vitpOutdentList", !statuses.decreaseIndent);
          }
        },
        removeListItem: function(li, sameList) {
          if (!li || !li.parentNode) {
            return false;
          }
          var list = this._getListElement(li);
          if (!list) {
            return;
          }
          var nextLevelList = this._getListElement(list);
          if (!nextLevelList) {
            var newElem = document.createElement("p");
            while (li.firstChild) {
              newElem.appendChild(li.firstChild);
            }
          }
          if (li.nextSibling) {
            var clone = list.cloneNode(false);
            for (var node = li.nextSibling; node; node = li.nextSibling) {
              clone.appendChild(node);
            }
            ViperUtil.insertAfter(list, clone);
          }
          ViperUtil.remove(li);
          if (!nextLevelList) {
            ViperUtil.insertAfter(list, newElem);
          } else {
            var newElem = document.createElement("br");
            ViperUtil.insertAfter(list, newElem);
            ViperUtil.insertAfter(newElem, li.childNodes);
          }
          if (ViperUtil.getNodeTextContent(list) === "") {
            ViperUtil.remove(list);
          }
          return newElem;
        },
        makeList: function(ordered, force) {
          var tag = "ul";
          if (ordered === true) {
            tag = "ol";
          }
          var range = this.viper.getViperRange().cloneRange();
          var bookmark = this.viper.createBookmark(range);
          if (bookmark.start.parentNode === bookmark.end.parentNode) {
            var li = this._getListItem(range.startContainer);
            var elem = this._getBlockParent(range.startContainer);
            if (li !== elem) {
              li = null;
            }
            if (li !== null) {
              var br = this._getLineBreak(bookmark.start);
              if (br) {
                var tmpDiv = document.createElement("div");
                ViperUtil.insertBefore(br, tmpDiv);
                var node = null;
                while (node = br.nextSibling) {
                  if (node.nodeType === ViperUtil.ELEMENT_NODE && node.tagName.toLowerCase() === "br") {
                    tmpDiv = document.createElement("div");
                    ViperUtil.insertBefore(node, tmpDiv);
                    ViperUtil.remove(br);
                    br = node;
                    continue;
                  }
                  tmpDiv.appendChild(node);
                }
                if (br.parentNode) {
                  ViperUtil.remove(br);
                }
                this.viper.selectBookmark(bookmark);
                this.makeList(ordered, true);
                return;
              }
            }
            if (li === null || force === true) {
              var list = null;
              if (elem === null) {
                elem = [range.startContainer];
              } else {
                elem = [elem];
              }
              var removeInsAfter = false;
              var insertAfter2 = elem[0].previousSibling;
              if (!insertAfter2) {
                insertAfter2 = document.createTextNode("");
                ViperUtil.insertBefore(elem[0], insertAfter2);
                removeInsAfter = true;
              }
              if (ViperUtil.isTag(elem[0], "td") === true) {
                var td = elem[0];
                var p = document.createElement("p");
                while (td.firstChild) {
                  p.appendChild(td.firstChild);
                }
                elem = [p];
                list = this._makeList(tag, elem);
                td.appendChild(list);
              } else {
                list = this._makeList(tag, elem);
                ViperUtil.insertAfter(insertAfter2, list);
              }
              this.viper.selectBookmark(bookmark);
              return true;
            } else {
              var listElement = this._getListElement(li);
              var convert = listElement && listElement.tagName.toLowerCase() !== tag;
              var newElem = this.removeListItem(li);
              this.viper.selectBookmark(bookmark);
              if (convert === true) {
                this.makeList(ordered);
              }
            }
          } else {
            var elements = ViperUtil.getElementsBetween(bookmark.start, bookmark.end);
            var comParents = this._getCommonParents(elements);
            if (!comParents) {
              return false;
            }
            var isWholeList = this._isWholeList(comParents);
            if (ViperUtil.isTag(comParents[0], "li") === true) {
              var sameType = true;
              ViperUtil.foreach(comParents, function(i) {
                if (ViperUtil.isTag(comParents[i], "li") !== true || ViperUtil.isTag(comParents[i].parentNode, tag) !== true) {
                  sameType = false;
                  return false;
                }
              });
              if (sameType === true) {
                var self = this;
                ViperUtil.foreach(comParents, function(i) {
                  self.removeListItem(comParents[i], isWholeList);
                });
                this.viper.selectBookmark(bookmark);
                return;
              } else {
                if (ViperUtil.isTag(comParents[0].parentNode, tag) === true) {
                  var firstItem = comParents.shift();
                  this._joinToList(firstItem.parentNode, comParents, firstItem);
                  this.viper.selectBookmark(bookmark);
                  return;
                } else {
                  var self = this;
                  ViperUtil.foreach(comParents, function(i) {
                    self.removeListItem(comParents[i], isWholeList);
                  });
                  this.viper.selectBookmark(bookmark);
                  return this.makeList(ordered);
                }
              }
            }
            var removeInsAfter = false;
            var insertAfter2 = comParents[0].previousSibling;
            if (!insertAfter2) {
              insertAfter2 = document.createTextNode("");
              ViperUtil.insertBefore(comParents[0], insertAfter2);
              removeInsAfter = true;
            }
            var list = this._makeList(tag, comParents);
            ViperUtil.insertAfter(insertAfter2, list);
            if (removeInsAfter === true) {
              ViperUtil.remove(insertAfter2);
            }
            this.viper.selectBookmark(bookmark);
          }
        },
        canIncreaseIndent: function(range) {
          return this.tabRange(range, false, true);
        },
        canDecreaseIndent: function(range) {
          return this.tabRange(range, true, true);
        },
        tabRange: function(range, outdent, testOnly, listType) {
          range = range || this.viper.getViperRange();
          var node = range.getStartNode() || range.getNodeSelection();
          if (!node) {
            node = range.startContainer;
          }
          var firstParent = null;
          if (ViperUtil.isBlockElement(node) === true) {
            firstParent = node;
          } else {
            firstParent = ViperUtil.getFirstBlockParent(node);
          }
          var listItems = [];
          if (!firstParent || ViperUtil.isTag(firstParent, "li") === true) {
            listItems = this._getListItemsFromRange(range, testOnly);
          }
          var bookmark = null;
          var updated = false;
          if (listItems.length > 0) {
            if (testOnly !== true) {
              bookmark = this.viper.createBookmark();
            }
            if (outdent !== true) {
              updated = this.indentListItems(listItems, testOnly);
            } else {
              updated = this.outdentListItems(listItems, testOnly);
            }
          } else if (firstParent && outdent !== true) {
            updated = this.convertRangeToList(range, testOnly, listType, true);
            if (updated === true && testOnly !== true) {
              this.viper.contentChanged();
            }
            return updated;
          }
          if (testOnly !== true) {
            if (bookmark) {
              this.viper.selectBookmark(bookmark);
            }
            this.viper.adjustRange();
            if (updated === true) {
              this.viper.contentChanged();
            }
          }
          return updated;
        },
        _getListItemsFromRange: function(range, testOnly, expand) {
          var startNode = range.getStartNode();
          var endNode = range.getEndNode();
          if (!startNode && !endNode && range.startContainer) {
            startNode = range.startContainer;
            if (testOnly !== true && ViperUtil.isTag(startNode, "br") === true) {
              var textNode = document.createTextNode("");
              ViperUtil.insertBefore(startNode, textNode);
              range.setStart(textNode, 0);
              range.collapse(true);
            }
          }
          if (!endNode && startNode.nodeType === ViperUtil.ELEMENT_NODE) {
            endNode = startNode;
          }
          var listItems = [];
          if (startNode === endNode) {
            if (ViperUtil.isTag(startNode, "ul") === true || ViperUtil.isTag(startNode, "ol") === true) {
              listItems.push(startNode);
            } else {
              listItems.push(this._getListItem(startNode));
            }
          } else {
            var elems = ViperUtil.getElementsBetween(startNode, endNode);
            if (ViperUtil.inArray(startNode, elems) === false) {
              elems.unshift(startNode);
            }
            if (ViperUtil.inArray(endNode, elems) === false) {
              if (ViperUtil.isBrowser("chrome") === true || ViperUtil.isBrowser("safari") === true) {
                if (range.endContainer.nodeType !== ViperUtil.ELEMENT_NODE || ViperUtil.isTag(range.endContainer, "li") === false || range.endOffset > 0) {
                  elems.push(endNode);
                }
              } else if (range.collapsed === true || ViperUtil.isText(range.endContainer) !== true || range.endOffset !== 0 || ViperUtil.isTag(ViperUtil.getFirstBlockParent(range.endContainer), "li") !== true) {
                elems.push(endNode);
              }
            }
            var c = elems.length;
            for (var i = 0; i < c; i++) {
              var elem = elems[i];
              if (!elems[i]) {
                continue;
              } else if (ViperUtil.isTag(elems[i], "li") === false && ViperUtil.isTag(elems[i], "ol") === false && ViperUtil.isTag(elems[i], "ul") === false) {
                if (elems[i].nodeType === ViperUtil.TEXT_NODE && elems[i].data.indexOf("\n") === 0) {
                  continue;
                }
                var li = this._getListItem(elems[i]);
                if (li && ViperUtil.inArray(li, listItems) === false) {
                  listItems.push(li);
                }
              } else {
                if (ViperUtil.inArray(elems[i], listItems) === false) {
                  listItems.push(elems[i]);
                }
                if (expand === true) {
                  listItems = listItems.concat(ViperUtil.getTag("li", elems[i]));
                }
              }
            }
          }
          return listItems;
        },
        indentListItems: function(listItems, testOnly) {
          if (!listItems || listItems.length === 0) {
            return false;
          }
          var topListItems = this.getTopLevelListItems(listItems);
          var includeSublist = false;
          if (listItems.length !== topListItems.length) {
            includeSublist = true;
          }
          var c = topListItems.length;
          for (var i = 0; i < c; i++) {
            if (this.indentListItem(topListItems[i], includeSublist, testOnly) === false) {
              return false;
            }
          }
          return true;
        },
        indentListItem: function(li, includeSublist, testOnly) {
          if (!li) {
            return false;
          }
          var prevItem = this.getPreviousItem(li);
          if (!prevItem) {
            return false;
          }
          var prevSubList = this.getSubListItem(prevItem);
          if (prevSubList && includeSublist !== true) {
            if (testOnly === true) {
              return true;
            }
            prevSubList.appendChild(li);
          } else {
            var subList = this.getSubListItem(li);
            if (subList && includeSublist !== true) {
              if (testOnly === true) {
                return true;
              }
              var itemContents = this.getItemContents(li);
              var newItem = document.createElement("li");
              while (itemContents.length > 0) {
                newItem.appendChild(itemContents.shift());
              }
              this.addItemToList(newItem, subList, 0);
              prevItem.appendChild(subList);
              ViperUtil.remove(li);
            } else {
              if (testOnly === true) {
                return true;
              }
              if (prevSubList) {
                prevSubList.appendChild(li);
              } else {
                var listElement = this._getListElement(li);
                var tagName = ViperUtil.getTagName(listElement);
                var newList = document.createElement(tagName);
                newList.appendChild(li);
                prevItem.appendChild(newList);
              }
            }
          }
          return true;
        },
        outdentListItems: function(listItems, testOnly) {
          if (!listItems || listItems.length === 0) {
            return false;
          }
          var itemsToOutdent = this.getTopLevelListItems(listItems);
          var c = itemsToOutdent.length;
          for (var i = 0; i < c; i++) {
            if (this.outdentListItem(itemsToOutdent[i], testOnly) === false) {
              return false;
            }
          }
          return true;
        },
        getTopLevelListItems: function(listItems) {
          listItems = listItems.concat([]);
          var topLevelItems = [listItems.shift()];
          for (var i = 0; i < listItems.length; i++) {
            var add = true;
            var parents = ViperUtil.getParents(listItems[i], "li");
            for (var j = 0; j < parents.length; j++) {
              if (ViperUtil.inArray(parents[j], topLevelItems, true) === true) {
                add = false;
                break;
              }
            }
            if (add === true) {
              topLevelItems.push(listItems[i]);
            }
          }
          return topLevelItems;
        },
        outdentListItem: function(li, testOnly) {
          if (!li) {
            return false;
          }
          var list = null;
          var isSubList = false;
          if (ViperUtil.isTag(li, "ul") === true || ViperUtil.isTag(li, "ol") === true) {
            list = li;
            isSubList = true;
          } else {
            list = this._getListElement(li);
          }
          var parentListItem = this._getListItem(list);
          var siblingItems = [];
          if (isSubList !== true) {
            for (var node = li.nextSibling; node; node = node.nextSibling) {
              if (ViperUtil.isTag(node, "li") === true) {
                siblingItems.push(node);
              }
            }
          }
          if (testOnly === true) {
            return true;
          }
          if (parentListItem) {
            if (siblingItems.length > 0) {
              var subList = this.getSubListItem(li);
              if (!subList) {
                subList = document.createElement(this.getListType(li));
                li.appendChild(subList);
              }
              for (var i = 0; i < siblingItems.length; i++) {
                subList.appendChild(siblingItems[i]);
              }
            }
            if (isSubList === true) {
              var childItems = [];
              for (var node = li.firstChild; node; node = node.nextSibling) {
                if (ViperUtil.isTag(node, "li") === true) {
                  childItems.push(node);
                }
              }
              for (var i = childItems.length; i >= 0; i--) {
                ViperUtil.insertAfter(parentListItem, childItems[i]);
              }
            } else {
              ViperUtil.insertAfter(parentListItem, li);
            }
            if (ViperUtil.getTag("li", list).length === 0) {
              ViperUtil.remove(list);
            }
            return true;
          } else {
            var subList = null;
            var bTag = this.viper.getDefaultBlockTag();
            var p = null;
            if (bTag !== "") {
              p = document.createElement(bTag);
              while (li.firstChild) {
                if (ViperUtil.isTag(li.firstChild, "ul") === true || ViperUtil.isTag(li.firstChild, "ol") === true) {
                  subList = li.firstChild;
                  li.removeChild(li.firstChild);
                } else {
                  p.appendChild(li.firstChild);
                }
              }
            } else {
              p = document.createElement("p");
            }
            var firstItem = true;
            for (var node = li.previousSibling; node; node = node.previousSibling) {
              if (ViperUtil.isTag(node, "li") === true) {
                firstItem = false;
                break;
              }
            }
            if (siblingItems.length === 0) {
              if (firstItem === true) {
                if (bTag !== "") {
                  ViperUtil.insertBefore(list, p);
                } else {
                  ViperUtil.insertBefore(list, li.childNodes);
                }
                ViperUtil.remove(li);
              } else {
                if (bTag !== "") {
                  ViperUtil.insertAfter(list, p);
                } else {
                  ViperUtil.insertAfter(list, li.childNodes);
                }
                ViperUtil.remove(li);
              }
            } else {
              if (firstItem === true) {
                if (bTag !== "") {
                  ViperUtil.insertBefore(list, p);
                } else {
                  ViperUtil.insertBefore(list, li.childNodes);
                }
                ViperUtil.remove(li);
              } else {
                var newList = document.createElement(ViperUtil.getTagName(list));
                for (var i = 0; i < siblingItems.length; i++) {
                  newList.appendChild(siblingItems[i]);
                }
                ViperUtil.remove(li);
                ViperUtil.insertAfter(list, newList);
                if (bTag !== "") {
                  ViperUtil.insertAfter(list, p);
                } else {
                  ViperUtil.insertAfter(list, li.childNodes);
                }
              }
            }
            if (subList) {
              if (ViperUtil.isTag(p.nextSibling, ViperUtil.getTagName(subList)) === true) {
                while (subList.firstChild) {
                  ViperUtil.insertBefore(p.nextSibling.firstChild, subList.firstChild);
                }
              } else {
                ViperUtil.insertAfter(p, subList);
              }
            }
            if (!ViperUtil.getFirstElementChild(list)) {
              ViperUtil.remove(list);
            }
            return true;
          }
          return false;
        },
        convertRangeToList: function(range, testOnly, listType, canJoin) {
          range = range || this.viper.getViperRange();
          testOnly = testOnly || false;
          listType = listType || null;
          var startNode = range.getStartNode();
          var endNode = range.getEndNode();
          var bookmark = null;
          if (testOnly !== true) {
            bookmark = this.viper.createBookmark();
          }
          if (!startNode && !endNode) {
            startNode = range.startContainer;
            endNode = startNode;
          } else if (startNode && !endNode && range.collapsed === true) {
            endNode = startNode;
          }
          var pElems = [];
          if (startNode === endNode) {
            var validParent = null;
            if (bookmark && bookmark.start) {
              validParent = this._getValidParentElement(bookmark.start);
            } else {
              validParent = this._getValidParentElement(startNode);
            }
            if (validParent) {
              if (testOnly !== true && (ViperUtil.isTag(validParent, "td") === true || ViperUtil.isTag(validParent, "th") === true)) {
                return this.makeList(listType === "ol");
              } else {
                pElems.push(validParent);
              }
            }
          } else {
            var elems = null;
            if (testOnly === true) {
              elems = ViperUtil.getElementsBetween(startNode, endNode);
              elems.unshift(startNode);
              elems.push(endNode);
            } else {
              elems = ViperUtil.getElementsBetween(bookmark.start, bookmark.end);
            }
            var c = elems.length;
            for (var i = 0; i < c; i++) {
              if (!elems[i]) {
                continue;
              }
              var p = this._getValidParentElement(elems[i]);
              if (p && ViperUtil.inArray(p, pElems) === false) {
                pElems.push(p);
              } else if (!p && elems[i].nodeType === ViperUtil.TEXT_NODE && ViperUtil.isBlank(elems[i].data) === true) {
                ViperUtil.remove(elems[i]);
              }
            }
          }
          if (pElems.length === 0) {
            return false;
          } else if (testOnly === true) {
            return true;
          }
          var list = null;
          var atEnd = true;
          if (!listType || canJoin === true) {
            for (var node = pElems[0].previousSibling; node; node = node.previousSibling) {
              if (node.nodeType === ViperUtil.ELEMENT_NODE) {
                if (listType && ViperUtil.isTag(node, listType) === true || !listType && (ViperUtil.isTag(node, "ol") === true || ViperUtil.isTag(node, "ul") === true)) {
                  list = node;
                  atEnd = true;
                }
                break;
              }
            }
            if (list === null) {
              for (var node = pElems[pElems.length - 1].nextSibling; node; node = node.nextSibling) {
                if (node.nodeType === ViperUtil.ELEMENT_NODE) {
                  if (listType && ViperUtil.isTag(node, listType) === true || !listType && (ViperUtil.isTag(node, "ol") === true || ViperUtil.isTag(node, "ul") === true)) {
                    list = node;
                    atEnd = false;
                  }
                  break;
                }
              }
            }
          }
          if (list === null) {
            list = document.createElement(listType || "ul");
            ViperUtil.insertBefore(pElems[0], list);
            atEnd = true;
          }
          var listItems = [];
          var prev = null;
          for (var i = 0; i < pElems.length; i++) {
            var p = pElems[i];
            var li = null;
            if (ViperUtil.isTag(p, ["ul", "ol"]) === true) {
              if (prev !== null) {
                prev.appendChild(p);
              }
            } else {
              var li = document.createElement("li");
              while (p.firstChild) {
                li.appendChild(p.firstChild);
              }
              if (ViperUtil.isTag(p, ["td", "th"]) === true) {
                ViperUtil.insertBefore(list, p);
                p.appendChild(list);
              } else {
                ViperUtil.remove(p);
              }
              if (atEnd !== true) {
                listItems.unshift(li);
              } else {
                listItems.push(li);
              }
              prev = li;
            }
          }
          if (atEnd === true) {
            for (var i = 0; i < listItems.length; i++) {
              list.appendChild(listItems[i]);
            }
            var listType = ViperUtil.getTagName(list);
            for (var node = list.nextSibling; node; node = node.nextSibling) {
              if (node.nodeType !== ViperUtil.TEXT_NODE) {
                if (ViperUtil.isTag(node, listType) === true) {
                  while (node.firstChild) {
                    list.appendChild(node.firstChild);
                  }
                  ViperUtil.remove(node);
                }
                break;
              } else if (ViperUtil.isBlank(ViperUtil.trim(node.data)) !== true) {
                break;
              }
            }
          } else {
            for (var i = 0; i < listItems.length; i++) {
              ViperUtil.insertBefore(list.firstChild, listItems[i]);
            }
          }
          this.viper.selectBookmark(bookmark);
          this.viper.contentChanged();
          if (canJoin === true) {
            return false;
          }
          return true;
        },
        convertRangeToParagraphs: function(range) {
          range = range = this.viper.getViperRange();
          var listItems = this._getListItemsFromRange(range, false, true);
          var bookmark = this.viper.createBookmark();
          var prevElem = null;
          var prevList = null;
          for (var i = 0; i < listItems.length; i++) {
            if (ViperUtil.isTag(listItems[i], "li") === false) {
              var childItems = ViperUtil.getTag("li", listItems[i]);
              var parent = null;
              if (!prevElem) {
                parent = listItems[i];
                prevList = parent;
              }
              for (var j = 0; j < childItems.length; j++) {
                var p = this.convertElement(childItems[j], "p", true);
                if (prevElem) {
                  ViperUtil.insertAfter(prevElem, p);
                } else {
                  ViperUtil.insertBefore(parent, p);
                }
                prevElem = p;
              }
              prevElem = null;
            } else {
              var parent = listItems[i].parentNode;
              var p = this.splitListAtItem(listItems[i]);
              if (prevElem) {
                ViperUtil.insertAfter(prevElem, p);
              }
              if (prevList !== parent) {
                prevList = parent;
              } else {
                prevElem = p;
              }
            }
          }
          this.viper.selectBookmark(bookmark);
          this.viper.contentChanged();
        },
        /**
         * Splits the item's list and converts item to a paragraph.
         */
        splitListAtItem: function(li) {
          var siblings = [];
          for (var node = li.nextSibling; node; node = node.nextSibling) {
            if (ViperUtil.isTag(node, "li") === false) {
              continue;
            }
            siblings.push(node);
          }
          var listElem = li.parentNode;
          var newList = null;
          if (siblings.length > 0) {
            newList = document.createElement(this.getListType(li));
            for (var i = 0; i < siblings.length; i++) {
              newList.appendChild(siblings[i]);
            }
          }
          var p = this.convertElement(li, "p", true);
          ViperUtil.insertAfter(listElem, p);
          if (newList) {
            ViperUtil.insertAfter(p, newList);
          }
          var node = p.lastChild;
          while (node) {
            var prevSibling = node.previousSibling;
            if (ViperUtil.isBlockElement(node) === true && ViperUtil.isStubElement(node) === false) {
              ViperUtil.insertAfter(p, node);
            }
            node = prevSibling;
          }
          if (ViperUtil.getTag("li", listElem).length === 0) {
            ViperUtil.remove(listElem);
          }
          return p;
        },
        /**
         * Converts given element to the specified element by creating a new element and moving its child nodes.
         */
        convertElement: function(elem, tagName, detached) {
          var newElem = document.createElement(tagName);
          while (elem.firstChild) {
            newElem.appendChild(elem.firstChild);
          }
          if (detached !== true) {
            ViperUtil.insertBefore(elem, newElem);
          }
          ViperUtil.remove(elem);
          return newElem;
        },
        changeListType: function(newType, range) {
          range = range || this.viper.getViperRange();
          var listItems = this._getListItemsFromRange(range, false, true);
          var bookmark = this.viper.createBookmark();
          var self = this;
          var convertChildItems = function(list) {
            var children = ViperUtil.find(list, "> li");
            if (children.length === 0) {
              return;
            }
            var newParent = null;
            var afterList = null;
            for (var i2 = 0; i2 < children.length; i2++) {
              if (ViperUtil.inArray(children[i2], listItems) === true) {
                if (newParent === null) {
                  newParent = document.createElement(newType);
                  ViperUtil.insertAfter(list, newParent);
                }
                newParent.appendChild(children[i2]);
                var subLists = ViperUtil.find(children[i2], "> ul");
                for (var j = 0; j < subLists.length; j++) {
                  convertChildItems(subLists[j]);
                }
              } else if (newParent !== null) {
                if (afterList === null) {
                  afterList = document.createElement(ViperUtil.getTagName(list));
                  ViperUtil.insertAfter(newParent, afterList);
                }
                afterList.appendChild(children[i2]);
              }
            }
            if (ViperUtil.getTag("li", list).length === 0) {
              ViperUtil.remove(list);
              var joinedList = self.joinSiblingLists(newParent);
              if (joinedList) {
                processedParents.push(joinedList);
              }
            }
          };
          var processedParents = [];
          for (var i = 0; i < listItems.length; i++) {
            if (!listItems[i].parentNode || ViperUtil.inArray(listItems[i].parentNode, processedParents) === true) {
              continue;
            }
            processedParents.push(listItems[i].parentNode);
            convertChildItems(listItems[i].parentNode);
          }
          this.viper.selectBookmark(bookmark);
        },
        listToParagraphs: function(list) {
          var pTags = [];
          for (var node = list.firstChild; node; node = node.nextSibling) {
            if (ViperUtil.isTag(node, "li") !== true) {
              continue;
            }
            var p = document.createElement("p");
            while (node.firstChild) {
              p.appendChild(node.firstChild);
            }
            ViperUtil.insertBefore(list, p);
            pTags.push(p);
          }
          if (pTags.length === 1 && (ViperUtil.isTag(pTags[0].parentNode, "td") === true || ViperUtil.isTag(pTags[0].parentNode, "th") === true)) {
            var cellElement = pTags[0].parentNode;
            var p = pTags[0];
            while (p.firstChild) {
              ViperUtil.insertBefore(p, p.firstChild);
            }
            ViperUtil.remove(p);
            pTags = [cellElement];
          }
          ViperUtil.remove(list);
          return pTags;
        },
        getSubListItem: function(li) {
          for (var node = li.firstChild; node; node = node.nextSibling) {
            if (ViperUtil.isTag(node, "ul") === true || ViperUtil.isTag(node, "ol") === true) {
              return node;
            }
          }
          return null;
        },
        addItemToList: function(li, list, pos) {
          if (!li || !list || ViperUtil.isTag(li, "li") === false) {
            return false;
          }
          pos = pos || 0;
          var tags = ViperUtil.getTag("li", list);
          if (tags.length <= pos) {
            list.appendChild(li);
          } else {
            ViperUtil.insertBefore(tags[pos], li);
          }
          return true;
        },
        /**
         * Returns item's contents excluding sub lists.
         *
         * @param {DOMNode} li The list item.
         *
         * @return {array} List of DOMNodes.
         */
        getItemContents: function(li) {
          var contentElements = [];
          for (var node = li.firstChild; node; node = node.nextSibling) {
            if (ViperUtil.isTag(node, "ul") === true || ViperUtil.isTag(node, "ol") === true) {
              continue;
            }
            contentElements.push(node);
          }
          return contentElements;
        },
        getListType: function(li) {
          var list = this._getListElement(li);
          if (!list) {
            return false;
          }
          return ViperUtil.getTagName(list);
        },
        getPreviousItem: function(li) {
          while (li.previousSibling) {
            li = li.previousSibling;
            if (ViperUtil.isTag(li, "li") === true) {
              return li;
            }
          }
          return null;
        },
        getNextItem: function(li) {
          while (li.nextSibling) {
            li = li.nextSibling;
            if (ViperUtil.isTag(li, "li") === true) {
              return li;
            }
          }
          return null;
        },
        _getButtonStatuses: function(range, mainToolbar) {
          range = range || this.viper.getViperRange();
          var startNode = range.getStartNode();
          var endNode = range.getEndNode();
          var makeList = false;
          var indent = false;
          var canMakeUL = false;
          var canMakeOL = false;
          var isUL = false;
          var isOL = false;
          var list = null;
          if (!startNode) {
            if (!range.startContainer || range.startContainer !== range.endContainer || ViperUtil.isStubElement(range.startContainer) !== true && ViperUtil.isTag(range.startContainer, "li") === false) {
              return;
            } else {
              startNode = range.startContainer;
              endNode = startNode;
            }
          }
          if (!endNode) {
            endNode = startNode;
          } else if (endNode === this.viper.getViperElement()) {
            endNode = range._getLastSelectableChild(this.viper.getViperElement());
          }
          var startParent = null;
          var listElement = null;
          if (ViperUtil.isTag(startNode, ["ul", "ol"]) === true) {
            listElement = startNode;
            startNode = range._getFirstSelectableChild(startNode);
          } else {
            listElement = this._getListElement(startNode);
          }
          var firstBlock = startNode;
          if (ViperUtil.isBlockElement(startNode) === false) {
            firstBlock = ViperUtil.getFirstBlockParent(startNode);
          }
          if (listElement && firstBlock && ViperUtil.isTag(firstBlock, "li") === false) {
            makeList = true;
            if (mainToolbar === true) {
              indent = true;
            }
          } else if (listElement && listElement === this._getListElement(endNode)) {
            if (range.collapsed === true && mainToolbar !== true) {
              return;
            }
            makeList = true;
            indent = true;
          } else if (listElement) {
            if (range.collapsed === true && mainToolbar !== true) {
              return;
            }
            makeList = true;
            indent = true;
          } else {
            var nodeSelection = range.getNodeSelection();
            if (nodeSelection && nodeSelection !== this.viper.getViperElement()) {
              startNode = nodeSelection;
              endNode = null;
            }
            if (ViperUtil.isBlockElement(startNode) === false) {
              startParent = ViperUtil.getFirstBlockParent(startNode);
            } else {
              startParent = startNode;
            }
            var endParent = null;
            if (!endNode) {
              endParent = startParent;
            } else {
              endParent = ViperUtil.getFirstBlockParent(endNode);
            }
            if (!startParent || !endParent) {
              return;
            } else if (startParent !== endParent && ViperUtil.isTag(startParent, "p") === true && ViperUtil.isTag(endParent, "p") === true && ViperUtil.isTag(startParent.parentNode, "blockquote") === false && ViperUtil.isTag(endParent.parentNode, "blockquote") === false) {
              makeList = true;
              var nextSibling = startParent.nextSibling;
              while (nextSibling && nextSibling !== endParent) {
                if (nextSibling.nodeType === ViperUtil.ELEMENT_NODE && ViperUtil.isTag(nextSibling, "p") !== true) {
                  makeList = false;
                  break;
                }
                nextSibling = nextSibling.nextSibling;
              }
            } else if (mainToolbar === true && (ViperUtil.isTag(startParent, "p") === true || ViperUtil.isTag(startParent, "td") === true) && ViperUtil.isTag(startParent.parentNode, "blockquote") === false) {
              makeList = true;
            }
          }
          if (makeList !== true && indent !== true) {
            return;
          }
          if (makeList === true) {
            if (ViperUtil.isTag(firstBlock, "li") === true) {
              list = this._getListElement(startNode, true);
            }
            if (!list && this.convertRangeToList(range, true) === true) {
              canMakeUL = true;
              canMakeOL = true;
            } else if (ViperUtil.isTag(list, "ol") === true) {
              canMakeUL = true;
              canMakeOL = true;
              isOL = true;
            } else if (ViperUtil.isTag(list, "ul") === true) {
              canMakeUL = true;
              canMakeOL = true;
              isUL = true;
            }
          }
          var increaseIndent = false;
          var decreaseIndent = false;
          if (indent === true) {
            increaseIndent = this.canIncreaseIndent(range);
            decreaseIndent = this.canDecreaseIndent(range);
          }
          if (mainToolbar === true && startParent && ViperUtil.isTag(startParent, "p") === true) {
            increaseIndent = true;
          }
          var statuses = {
            ul: canMakeUL,
            ol: canMakeOL,
            increaseIndent,
            decreaseIndent,
            list,
            isUL,
            isOL
          };
          return statuses;
        },
        _updateToolbar: function(toolbarButtons, range) {
          var toolbarPlugin = this.viper.PluginManager.getPlugin("ViperToolbarPlugin");
          if (!toolbarPlugin) {
            return;
          }
          var tools = this.viper.Tools;
          var statuses = this._getButtonStatuses(range, true);
          if (!statuses) {
            for (var btn in toolbarButtons) {
              tools.disableButton(toolbarButtons[btn]);
              tools.setButtonInactive(toolbarButtons[btn]);
            }
            return;
          }
          if (statuses.ul === true) {
            tools.enableButton(toolbarButtons.ul);
            if (ViperUtil.isTag(statuses.list, "ul") === true) {
              tools.setButtonActive(toolbarButtons.ul);
            } else {
              tools.setButtonInactive(toolbarButtons.ul);
            }
          } else {
            tools.disableButton(toolbarButtons.ul);
            tools.setButtonInactive(toolbarButtons.ul);
          }
          if (statuses.ol === true) {
            tools.enableButton(toolbarButtons.ol);
            if (ViperUtil.isTag(statuses.list, "ol") === true) {
              tools.setButtonActive(toolbarButtons.ol);
            } else {
              tools.setButtonInactive(toolbarButtons.ol);
            }
          } else {
            tools.disableButton(toolbarButtons.ol);
            tools.setButtonInactive(toolbarButtons.ol);
          }
          if (statuses.increaseIndent === true) {
            tools.enableButton(toolbarButtons.indent);
          } else {
            tools.disableButton(toolbarButtons.indent);
          }
          if (statuses.decreaseIndent === true) {
            tools.enableButton(toolbarButtons.outdent);
          } else {
            tools.disableButton(toolbarButtons.outdent);
          }
        },
        _makeListButtonAction: function(list, listType) {
          var currentType = "";
          var newType = "";
          if (!list) {
            currentType = listType;
          } else {
            currentType = ViperUtil.getTagName(list);
            if (listType !== currentType) {
              if (currentType === "ul") {
                newType = "ol";
              } else {
                newType = "ul";
              }
            } else {
              newType = listType;
            }
          }
          if (currentType !== listType) {
            this.changeListType(newType);
            this.viper.contentChanged();
            return;
          } else if (currentType !== newType) {
            this.tabRange(null, false, false, listType);
          } else if (currentType === listType) {
            return this.convertRangeToParagraphs();
          } else {
            var bookmark = this.viper.createBookmark();
            if (bookmark.start.nextSibling && ViperUtil.isTag(bookmark.start.nextSibling, "li") === true) {
              ViperUtil.insertBefore(bookmark.start.nextSibling.firstChild, bookmark.start);
            }
            if (bookmark.end.previousSibling && ViperUtil.isTag(bookmark.end.previousSibling, "li") === true) {
              bookmark.end.previousSibling.appendChild(bookmark.end);
            }
            var pTags = this.listToParagraphs(list);
            this.viper.selectBookmark(bookmark);
            this.viper.contentChanged();
          }
        },
        _joinToList: function(listElem, elements, refNode) {
          var self = this;
          ViperUtil.foreach(elements, function(i) {
            var elem = elements[i];
            if (elem.parentNode !== listElem) {
              if (ViperUtil.isTag(elem, "li") === false) {
                elem = self._createListItem(elem);
              }
              if (elem) {
                if (refNode) {
                  ViperUtil.insertAfter(refNode, elem);
                  refNode = elem;
                } else {
                  listElem.appendChild(elem);
                }
              }
            }
          });
        },
        joinSiblingLists: function(list) {
          var listType = ViperUtil.getTagName(list);
          for (var node = list.previousSibling; node; node = node.previousSibling) {
            if (node.nodeType === ViperUtil.TEXT_NODE && ViperUtil.isBlank(ViperUtil.trim(node.data)) === true) {
              continue;
            } else if (ViperUtil.isTag(node, listType) === false) {
              break;
            }
            while (list.firstChild) {
              node.appendChild(list.firstChild);
            }
            ViperUtil.remove(list);
            list = node;
          }
          for (var node = list.nextSibling; node; node = node.nextSibling) {
            if (node.nodeType === ViperUtil.TEXT_NODE && ViperUtil.isBlank(ViperUtil.trim(node.data)) === true) {
              continue;
            } else if (ViperUtil.isTag(node, listType) === false) {
              break;
            }
            while (node.firstChild) {
              list.appendChild(node.firstChild);
            }
            ViperUtil.remove(node);
          }
          return list;
        },
        _getLineBreak: function(ref) {
          while (ref = ref.previousSibling) {
            if (ref.nodeType === ViperUtil.ELEMENT_NODE && ref.tagName.toLowerCase() === "br") {
              return ref;
            }
          }
          return null;
        },
        _getBlockParent: function(element, tag) {
          while (element && element !== this.viper.element) {
            if (ViperUtil.isBlockElement(element) === true) {
              if (!tag || element.tagName.toLowerCase() === tag) {
                return element;
              }
            }
            element = element.parentNode;
          }
          return null;
        },
        _getCommonParents: function(elems) {
          elems = elems.concat([]);
          var parents = [];
          var eLen = elems.length;
          while (eLen > 0) {
            var elem = elems.shift();
            if (ViperUtil.isBlockElement(elem) === true) {
              if (elem.tagName.toLowerCase() === "ol" || elem.tagName.toLowerCase() === "ul") {
                for (var listChild = elem.firstChild; listChild; listChild = listChild.nextSibling) {
                  parents.push(listChild);
                }
              } else {
                parents.push(elem);
              }
            } else {
              while (elem) {
                elem = elem.parentNode;
                if (elem) {
                  if (elem === this.viper.element) {
                    break;
                  } else if (ViperUtil.isBlockElement(elem) === true) {
                    if (ViperUtil.inArray(elem, parents) === false) {
                      parents.push(elem);
                    }
                    break;
                  }
                }
              }
            }
            eLen = elems.length;
          }
          return parents;
        },
        _makeList: function(tag, elements) {
          if (!elements) {
            return;
          }
          tag = tag || "ul";
          var eln = elements.length;
          if (eln <= 0) {
            return;
          }
          var list = document.createElement(tag);
          if (eln === 1) {
            var listItems = [];
            var listLen = listItems.length;
            while (elements[0].firstChild || listLen > 0) {
              var child = elements[0].firstChild;
              if (child) {
                listItems.push(child);
              } else if (listItems.length > 0) {
                var listItem = this._createListItem(listItems.shift());
                if (listItem) {
                  list.appendChild(listItem);
                  while (listItems.length > 0) {
                    let listElem = listItems.shift();
                    listItem.appendChild(listElem);
                  }
                }
              }
              if (child) {
                ViperUtil.remove(child);
              }
              listLen = listItems.length;
            }
            ViperUtil.remove(elements[0]);
          } else {
            for (var i = 0; i < eln; i++) {
              var listItem = this._createListItem(elements[i]);
              if (listItem !== null) {
                list.appendChild(listItem);
              }
            }
          }
          return list;
        },
        _createListItem: function(element) {
          if (!element || element.nodeType === ViperUtil.TEXT_NODE && element.data.indexOf("\n") === 0 && ViperUtil.trim(element.data).length === 0) {
            return null;
          }
          var li = document.createElement("li");
          if (ViperUtil.isBlockElement(element) === true) {
            if (element.childNodes && element.childNodes.length > 0) {
              while (element.firstChild) {
                if (element.firstChild.nodeType === ViperUtil.TEXT_NODE) {
                  if (ViperUtil.trim(element.firstChild.data).length <= 0) {
                    ViperUtil.remove(element.firstChild);
                    continue;
                  }
                }
                li.appendChild(element.firstChild);
              }
            }
            ViperUtil.remove(element);
            if (li.childNodes.length === 0) {
              return null;
            }
          } else {
            li.appendChild(element);
          }
          return li;
        },
        /**
         * Given an element it will return its list item (li) node.
         */
        _getListItem: function(element) {
          while (element && element !== this.viper.element) {
            if (element.tagName && element.tagName.toLowerCase() === "li") {
              return element;
            }
            element = element.parentNode;
          }
          return null;
        },
        _getListElement: function(element, incElement) {
          if (incElement === true && ViperUtil.isTag(element, ["ul", "ol"]) === true) {
            return element;
          }
          element = element.parentNode;
          while (element && element !== this.viper.element) {
            if (element.tagName) {
              var tag = element.tagName.toLowerCase();
              if (tag === "ol" || tag === "ul") {
                return element;
              }
            }
            element = element.parentNode;
          }
          return null;
        },
        _getValidParentElement: function(element) {
          if (!element || element === this.viper.getViperElement()) {
            return;
          }
          if (ViperUtil.isTag(element, ["p", "td", "ul", "ol"]) === true) {
            return element;
          }
          return this._getValidParentElement(element.parentNode);
        },
        _isWholeList: function(elems) {
          var sameParent = false;
          var parentList = null;
          if (elems.length > 1) {
            var first = elems[0];
            var last = elems[elems.length - 1];
            if (ViperUtil.isTag(first.previousElementSibling, "li") === true) {
              return false;
            }
            var firstParent = first.parentNode;
            var lastParent = last.parentNode;
            if (firstParent === lastParent) {
              parentList = firstParent;
              sameParent = true;
            } else {
              for (var node = last.parentNode; last; node = node.parentNode) {
                var tagName = ViperUtil.getTagName(node);
                if (tagName !== "li" && tagName !== "ol" && tagName !== "ul") {
                  break;
                } else if (this.getNextItem(node)) {
                  break;
                } else if (node === firstParent) {
                  return true;
                }
              }
            }
          } else if (elems[0]) {
            sameParent = true;
            parentList = elems[0].parentNode;
          } else {
            return;
          }
          if (sameParent === true) {
            var count = 0;
            var child = null;
            var last = null;
            for (child = parentList.firstChild; child; child = child.nextSibling) {
              if (ViperUtil.isTag(child, "li") === true) {
                if (count === 0 && child !== elems[0]) {
                  return false;
                }
                last = child;
                count++;
              }
            }
            if (last === elems[elems.length - 1]) {
              return true;
            }
          }
          return false;
        },
        remove: function() {
          ViperUtil.remove(this.viper.Tools.getItem("unorderedList").element);
          ViperUtil.remove(this.viper.Tools.getItem("orderedList").element);
          ViperUtil.remove(this.viper.Tools.getItem("indentList").element);
          ViperUtil.remove(this.viper.Tools.getItem("outdentList").element);
        }
      };
    };
  }
});

// src/Plugins/ViperHistoryPlugin/ViperHistoryPlugin.js
var ViperHistoryPlugin_exports = {};
__export(ViperHistoryPlugin_exports, {
  registerPlugin: () => registerPlugin16
});
var registerPlugin16;
var init_ViperHistoryPlugin = __esm({
  "src/Plugins/ViperHistoryPlugin/ViperHistoryPlugin.js"() {
    "use strict";
    registerPlugin16 = (Viper2) => {
      const { Util: ViperUtil, Selection: ViperSelection, _ } = Viper2;
      function ViperHistoryPlugin(viper) {
        var self = this;
        var _toolbarPlugin = null;
        this.init = function() {
          var toolbarPlugin = viper.PluginManager.getPlugin("ViperToolbarPlugin");
          if (toolbarPlugin) {
            _toolbarPlugin = toolbarPlugin;
            var tools = viper.Tools;
            var toolbarButtons = {
              undo: "undo",
              redo: "redo"
            };
            var btnGroup = tools.createButtonGroup("ViperHistoryPlugin:buttons");
            tools.createButton("undo", "", _("Undo"), "Viper-historyUndo", function() {
              return self.handleUndo();
            });
            tools.createButton("redo", "", _("Redo"), "Viper-historyRedo", function() {
              return self.handleRedo();
            });
            tools.addButtonToGroup("undo", "ViperHistoryPlugin:buttons");
            tools.addButtonToGroup("redo", "ViperHistoryPlugin:buttons");
            toolbarPlugin.addButton(btnGroup);
            tools.getItem("undo").setButtonShortcut("CTRL+Z");
            tools.getItem("redo").setButtonShortcut("CTRL+SHIFT+Z");
            viper.registerCallback("ViperToolbarPlugin:updateToolbar", "ViperHistoryPlugin", function(data) {
              _updateToolbarButtonStates(toolbarButtons);
            });
            _updateToolbarButtonStates(toolbarButtons);
            viper.registerCallback(
              [
                "ViperHistoryManager:add",
                "ViperHistoryManager:undo",
                "ViperHistoryManager:redo",
                "ViperHistoryManager:clear"
              ],
              "ViperHistoryPlugin",
              function(e) {
                _updateToolbarButtonStates(toolbarButtons);
              }
            );
          }
        };
        this.handleUndo = function() {
          viper.HistoryManager.undo();
          return false;
        };
        this.handleRedo = function() {
          viper.HistoryManager.redo();
          return false;
        };
        var _updateToolbarButtonStates = function(toolbarButtons) {
          if (!_toolbarPlugin) {
            return;
          }
          var tools = viper.Tools;
          if (viper.HistoryManager.getUndoCount() > 1) {
            tools.enableButton(toolbarButtons.undo);
          } else {
            tools.disableButton(toolbarButtons.undo);
          }
          if (viper.HistoryManager.getRedoCount() > 0) {
            tools.enableButton(toolbarButtons.redo);
          } else {
            tools.disableButton(toolbarButtons.redo);
          }
        };
      }
      Viper2.PluginManager.addPlugin("ViperHistoryPlugin", ViperHistoryPlugin);
    };
  }
});

// src/Plugins/ViperTableEditorPlugin/ViperTableEditorPlugin.js
var ViperTableEditorPlugin_exports = {};
__export(ViperTableEditorPlugin_exports, {
  registerPlugin: () => registerPlugin17
});
var registerPlugin17;
var init_ViperTableEditorPlugin = __esm({
  "src/Plugins/ViperTableEditorPlugin/ViperTableEditorPlugin.js"() {
    "use strict";
    registerPlugin17 = (Viper2) => {
      const { Util: ViperUtil, Selection: ViperSelection, _ } = Viper2;
      function ViperTableEditorPlugin(viper) {
        this.viper = viper;
        this._tools = viper.Tools;
        this._toolbarWidget = null;
        this.toolbarPlugin = null;
        this.activeCell = null;
        this._highlightElement = null;
        this._cellTools = null;
        this._buttonClicked = false;
        this._tableRawCells = null;
        this._currentType = null;
        this._margin = 15;
        this._headerOptions = [null, [1, 0, 0, 1, 0, 0, 1, 0, 0], [1, 1, 1], [1, 1, 1, 1, 0, 0, 1, 0, 0]];
        this._targetToolbarButton = false;
      }
      Viper2.PluginManager.addPlugin("ViperTableEditorPlugin", ViperTableEditorPlugin);
      ViperTableEditorPlugin.prototype = {
        init: function() {
          var self = this;
          var clickedInToolbar = false;
          this.viper.registerCallback("Viper:editableElementChanged", "ViperTableEditorPlugin", function() {
            self._initTable();
            if (ViperUtil.isBrowser("firefox") === true) {
              Viper2.document.execCommand("enableInlineTableEditing", false, false);
              Viper2.document.execCommand("enableObjectResizing", false, false);
            }
            var vap = self.viper.PluginManager.getPlugin("ViperAccessibilityPlugin");
            if (vap) {
              vap.loadHTMLCS(function() {
                var tables = ViperUtil.getTag("table", self.viper.getViperElement());
                for (var i = 0; i < tables.length; i++) {
                  self.setTableHeaders(tables[i]);
                }
              });
            }
          });
          this.viper.registerCallback("ViperCopyPastePlugin:paste", "ViperTableEditorPlugin", function() {
            var vap = self.viper.PluginManager.getPlugin("ViperAccessibilityPlugin");
            if (vap) {
              vap.loadHTMLCS(function() {
                var tables = ViperUtil.getTag("table", self.viper.getViperElement());
                for (var i = 0; i < tables.length; i++) {
                  self.setTableHeaders(tables[i]);
                }
              });
            }
          });
          this.viper.registerCallback("Viper:setHtml", "ViperTableEditorPlugin", function(data, callback) {
            var vap = self.viper.PluginManager.getPlugin("ViperAccessibilityPlugin");
            if (vap) {
              vap.loadHTMLCS(function() {
                var tables2 = ViperUtil.getTag("table", data.element);
                for (var i2 = 0; i2 < tables2.length; i2++) {
                  self.setTableHeaders(tables2[i2]);
                  self._initTable(tables2[i2]);
                }
                callback.call(this);
              });
            } else {
              var tables = ViperUtil.getTag("table", data.element);
              for (var i = 0; i < tables.length; i++) {
                self._initTable(tables[i]);
              }
              callback.call(this);
            }
            return function() {
            };
          });
          this.viper.registerCallback("Viper:enabled", "ViperTableEditorPlugin", function() {
            var tables = ViperUtil.getTag("table", self.viper.getViperElement());
            for (var i = 0; i < tables.length; i++) {
              self._initTable(tables[i]);
            }
          });
          this.viper.registerCallback(
            ["Viper:mouseDown", "ViperHistoryManager:undo"],
            "ViperTableEditorPlugin",
            function(data) {
              if (ViperUtil.isBrowser("firefox") === true) {
                Viper2.document.execCommand("enableInlineTableEditing", false, false);
                Viper2.document.execCommand("enableObjectResizing", false, false);
              }
              if (data && data.target) {
                var cell = self._getCellElement(data.target);
                if (cell) {
                  var range = self.viper.getViperRange();
                  if (range.collapsed !== true && !range.getNodeSelection()) {
                    range.collapse(true);
                    ViperSelection.addRange(range);
                  }
                }
              }
              self.setActiveCell(null);
              clickedInToolbar = false;
              if (data && data.target) {
                var target = ViperUtil.getMouseEventTarget(data);
                if (target === self._toolbar || ViperUtil.isChildOf(target, self._toolbar) === true) {
                  clickedInToolbar = true;
                  if (ViperUtil.isTag(target, "input") === true || ViperUtil.isTag(target, "textarea") === true) {
                    return true;
                  }
                  return false;
                } else if (ViperUtil.isTag(target, "caption") === true && ViperUtil.getNodeTextContent(target) === "") {
                  target.innerHTML = "&nbsp;";
                }
              }
              self.hideToolbar();
            }
          );
          ViperUtil.addEvent(window, "resize", function() {
            self.hideCellToolsIcon();
            self.removeHighlights();
            var cell = self.getActiveCell();
            if (cell && self._toolbarWidget.isVisible() === true) {
              self._updatePosition(cell);
              self.highlightActiveCell(self._currentType);
            }
          });
          this.viper.registerCallback("Viper:keyDown", "ViperTableEditorPlugin", function(e) {
            if (e.which === 9) {
              self.removeHighlights();
              if (e.shiftKey === true && self.activeCell) {
                self.moveCaretToPreviousCell();
              } else {
                if (self.activeCell && self.moveCaretToNextCell() === false) {
                  self.insertRowAfter(self.activeCell);
                  self.moveCaretToNextCell();
                }
              }
              ViperUtil.preventDefault(e);
              return false;
            } else if (e.which === 39 || e.which === 40) {
              var range = self.viper.getCurrentRange();
              if (range.collapsed === true) {
                var startNode = range.getStartNode();
                if (startNode && (ViperUtil.isTag(startNode, "br") === true || startNode.nodeType === ViperUtil.TEXT_NODE && range.endOffset === startNode.data.length)) {
                  var cell = self.getActiveCell();
                  var lastSelectable = range._getLastSelectableChild(cell);
                  if (startNode === lastSelectable || !lastSelectable && ViperUtil.isTag(startNode, "br") === true) {
                    if (cell && !self.getNextRow(cell.parentNode)) {
                      var table = self.getCellTable(cell);
                      if (!table.nextElementSibling) {
                        var caretNode = null;
                        if (self.viper.getDefaultBlockTag()) {
                          caretNode = document.createElement(self.viper.getDefaultBlockTag());
                          ViperUtil.setHtml(caretNode, "<br/>");
                          ViperUtil.insertAfter(table, caretNode);
                          range.setStart(caretNode.firstChild, 0);
                        } else {
                          caretNode = document.createTextNode(" ");
                          ViperUtil.insertAfter(table, caretNode);
                          range.setStart(caretNode, 0);
                        }
                        range.collapse(true);
                        ViperSelection.addRange(range);
                      } else {
                        self.viper.moveCaretAway(table, false);
                      }
                    }
                  }
                }
              }
            } else if (ViperUtil.isInputKey(e) === true && e.which !== 13) {
              self.hideCellToolsIcon();
              self.removeHighlights();
              self.hideToolbar();
            }
          });
          this.viper.registerCallback(
            ["Viper:clickedOutside", "Viper:disabled"],
            "ViperTableEditorPlugin",
            function(data) {
              self.hideCellToolsIcon();
              self.removeHighlights();
            }
          );
          this.viper.registerCallback("ViperFormatPlugin:elementAttributeSet", "ViperTableEditorPlugin", function(data) {
            if (data.element && ViperUtil.isTag(data.element, "th") === true) {
              var table = self.getCellTable(data.element);
              var headerAttr = ViperUtil.find(table, '[headers~="' + data.oldValue + '"]');
              for (var i = 0; i < headerAttr.length; i++) {
                var attr2 = " " + headerAttr[i].getAttribute("headers");
                attr2 = attr2.replace(" " + data.oldValue, data.element.getAttribute("id") || "");
                headerAttr[i].setAttribute("headers", ViperUtil.trim(attr2));
              }
              self.setTableHeaders(table);
            } else if (data.element && ViperUtil.isTag(data.element, "table") === true) {
              self.setTableHeaders(data.element);
            }
          });
          this.toolbarPlugin = this.viper.PluginManager.getPlugin("ViperToolbarPlugin");
          if (this.toolbarPlugin) {
            var insertTable = true;
            this.viper.registerCallback("ViperToolbarPlugin:positionUpdated", "ViperTableEditorPlugin", function(data) {
              if (self._targetToolbarButton === true) {
                var activeCell = self.getActiveCell();
                if (activeCell) {
                  self.showCellToolsIcon(activeCell, true);
                }
              }
            });
            this.viper.registerCallback("ViperToolbarPlugin:enabled", "ViperTableEditorPlugin", function(data) {
              self.viper.Tools.enableButton("insertTable");
            });
            var button = this.viper.Tools.createButton(
              "insertTable",
              "",
              _("Insert Table"),
              "Viper-table",
              function() {
                var range = self.viper.getViperRange();
                var node = range.getStartNode();
                if (!node) {
                  node = range.getEndNode();
                  if (!node) {
                    if (range.startContainer !== range.endContainer) {
                      return;
                    } else {
                      node = range.startContainer;
                    }
                  }
                }
                insertTable = true;
                var parents = ViperUtil.getParents(node, "table", self.viper.getViperElement());
                if (parents.length > 0) {
                  insertTable = false;
                  var cell = self._getCellElement(node);
                  if (cell) {
                    if (self._cellTools && ViperUtil.hasClass(self._cellTools, "Viper-topBar") === true) {
                      self.hideCellToolsIcon();
                    } else {
                      self.showCellToolsIcon(cell, true);
                    }
                  }
                } else {
                  self.toolbarPlugin.toggleBubble("VTEP-bubble");
                }
              },
              true
            );
            this.toolbarPlugin.addButton(button);
            this._createToolbarEditorBubble();
          }
          if (this._isiPad() === false) {
            var showToolbar = false;
            this.viper.registerCallback("Viper:mouseUp", "ViperTableEditorPlugin", function(e) {
              var range = self.viper.getCurrentRange();
              var target = ViperUtil.getMouseEventTarget(e);
              if (!target) {
                return;
              }
              if (target === self._toolbar || ViperUtil.isChildOf(target, self._toolbar) === true) {
                self._buttonClicked = false;
                return false;
              }
              if (range.collapsed === false || ViperUtil.isTag(target, "a") === true || ViperUtil.isTag(target, "img") === true) {
                self.removeHighlights();
                self.hideCellToolsIcon();
                return true;
              }
              if (self.viper.isOutOfBounds(target) === true) {
                return;
              }
              var cell = self._getCellElement(target);
              if (cell) {
                self._initTable(self.getCellTable(cell));
                self.hideCellToolsIcon();
                self.removeHighlights();
                showToolbar = true;
                self.showCellToolsIcon(cell);
                return;
              }
              self.hideCellToolsIcon();
              self.removeHighlights();
              return true;
            });
            this.viper.registerCallback("Viper:selectionChanged", "ViperTableEditorPlugin", function(range) {
              var node = range.getStartNode();
              if (!node) {
                node = range.getEndNode();
                if (!node) {
                  if (range.startContainer && ViperUtil.isStubElement(range.startContainer) === true) {
                    node = range.startContainer;
                  } else {
                    return;
                  }
                }
              }
              if (self.viper.isOutOfBounds(node) === true) {
                return;
              }
              if (self.toolbarPlugin.isDisabled() === true) {
                self._tools.setButtonInactive("insertTable");
              } else {
                var parents = ViperUtil.getParents(node, "table");
                if (parents.length > 0 && self._tools) {
                  if (self.toolbarPlugin.isDisabled() === false) {
                    self._tools.setButtonActive("insertTable");
                  }
                } else {
                  if (ViperUtil.getParents(node, "li", self.viper.getViperElement()).length > 0) {
                    self._tools.disableButton("insertTable");
                  } else {
                    var nodeSelection = range.getNodeSelection();
                    if (!nodeSelection || ViperUtil.isStubElement(nodeSelection) === false || ViperUtil.isTag(node, "br") === true) {
                      self._tools.enableButton("insertTable");
                      self._tools.setButtonInactive("insertTable");
                    } else {
                      self._tools.disableButton("insertTable");
                      self._tools.setButtonInactive("insertTable");
                    }
                  }
                }
              }
              if (range.collapsed === false) {
                return;
              }
              if (clickedInToolbar === true || self.viper.rangeInViperBounds(range) === false) {
                clickedInToolbar = false;
                return;
              }
              if (showToolbar === false) {
                self.hideCellToolsIcon();
                self.hideToolbar();
              } else {
                showToolbar = false;
              }
            });
          } else {
            this.viper.registerCallback("Viper:selectionChanged", "ViperTableEditorPlugin", function(range) {
              var startNode = range.getStartNode();
              var cell = self._getCellElement(startNode);
              if (cell) {
                self.hideCellToolsIcon();
                self.removeHighlights();
                showToolbar = true;
                return self.showCellToolsIcon(cell);
              }
              self.hideCellToolsIcon();
              return true;
            });
          }
          if (this._isiPad() === true) {
            ViperUtil.addEvent(window, "gesturestart", function() {
              self.hideToolbar();
            });
            this.viper.registerCallback("Viper:elementScaled", "ViperTableEditorPlugin", function(data) {
              if (data.element !== self._toolbar) {
                return false;
              }
              if (data.scale === 1) {
                self._margin = 15;
              } else {
                self._margin = 15 - (1 - data.scale) / 0.1 * 5;
              }
              self.updateToolbar(self.getActiveCell(), self._currentType);
            });
          }
          this._initToolbar();
        },
        _initTable: function(table) {
          var cells = [];
          if (!table) {
            cells = ViperUtil.getTag("td, th", this.viper.getViperElement());
          } else {
            cells = ViperUtil.getTag("td,th", table);
          }
          var c = cells.length;
          for (var i = 0; i < c; i++) {
            var html = ViperUtil.trim(ViperUtil.getHtml(cells[i]));
            if (html === "" || html === "&nbsp;") {
              this._initCell(cells[i]);
            }
          }
        },
        /**
         * Shows the cell tools icon for the given cell element.
         *
         * When the icon is hovered, it will be converted to list of buttons where user
         * can pick between table/row/column/cell properties.
         *
         * @param {DOMNode} cell The table cell (TD/TH) element to point to and edit.
         */
        showCellToolsIcon: function(cell, inTopBar) {
          if (!cell) {
            return;
          }
          this.hideToolbar();
          var toolsid = this.viper.getId() + "-ViperTEP";
          var tools = ViperUtil.getid(toolsid);
          if (tools) {
            ViperUtil.remove(tools);
          }
          this.setActiveCell(cell);
          var self = this;
          var showTools = function(type) {
            ViperUtil.remove(tools);
            var range = self.viper.getCurrentRange();
            range.collapse(true);
            ViperSelection.addRange(range);
            self.showTableTools(cell, type);
          };
          tools = document.createElement("div");
          tools.id = toolsid;
          ViperUtil.addClass(tools, "ViperITP Viper-themeDark Viper-compact Viper-visible");
          this._cellTools = tools;
          var buttonGroup = this.viper.Tools.createButtonGroup("VTEP:cellTools:buttons", "ViperITP-tools");
          var tableBtn = this._tools.createButton(
            "VTEP:cellTools:table",
            "",
            _("Show Table tools"),
            "Viper-table",
            function() {
              showTools("table");
            }
          );
          var rowBtn = this._tools.createButton(
            "VTEP:cellTools:row",
            "",
            _("Show Row tools"),
            "Viper-tableRow Viper-hidden",
            function() {
              showTools("row");
            }
          );
          var colBtn = this._tools.createButton(
            "VTEP:cellTools:col",
            "",
            _("Show Column tools"),
            "Viper-tableCol Viper-hidden",
            function() {
              showTools("col");
            }
          );
          var cellBtn = this._tools.createButton(
            "VTEP:cellTools:cell",
            "",
            _("Show Cell tools"),
            "Viper-tableCell Viper-hidden",
            function() {
              showTools("cell");
            }
          );
          this._tools.addButtonToGroup("VTEP:cellTools:table", "VTEP:cellTools:buttons");
          this._tools.addButtonToGroup("VTEP:cellTools:row", "VTEP:cellTools:buttons");
          this._tools.addButtonToGroup("VTEP:cellTools:col", "VTEP:cellTools:buttons");
          this._tools.addButtonToGroup("VTEP:cellTools:cell", "VTEP:cellTools:buttons");
          var btns = [rowBtn, colBtn, cellBtn];
          tools.appendChild(buttonGroup);
          var cellCoords = null;
          var toolsWidth = 42;
          if (inTopBar !== true) {
            this._targetToolbarButton = false;
          } else {
            var scrollCoords = ViperUtil.getScrollCoords();
            this._targetToolbarButton = true;
            ViperUtil.removeClass(btns, "Viper-hidden");
            ViperUtil.setStyle(tools, "margin-left", "-45px");
            cellCoords = ViperUtil.getBoundingRectangle(this._tools.getItem("insertTable").element);
            if (ViperUtil.getStyle(this._tools.getItem("insertTable").element.parentNode, "position") === "fixed") {
              cellCoords.y2 += 5 - scrollCoords.y;
              ViperUtil.setStyle(tools, "position", "fixed");
            } else {
              ViperUtil.setStyle(tools, "position", "absolute");
            }
            ViperUtil.addClass(tools, "Viper-topBar");
            var offset = ViperUtil.getDocumentOffset();
            var left = Math.ceil(cellCoords.x1 + (cellCoords.x2 - cellCoords.x1) / 2 - toolsWidth / 2) + 1 + offset.x;
            var top = cellCoords.y2 + 5 + offset.y;
            ViperUtil.setStyle(tools, "top", top + "px");
            ViperUtil.setStyle(tools, "left", left + "px");
          }
          if (this._isiPad() === false) {
            ViperUtil.hover(
              tableBtn,
              function() {
                self.setActiveCell(cell);
                self.highlightActiveCell("table");
              },
              function() {
                self.removeHighlights();
              }
            );
            ViperUtil.hover(
              rowBtn,
              function() {
                self.setActiveCell(cell);
                self.highlightActiveCell("row");
              },
              function() {
                self.removeHighlights();
              }
            );
            ViperUtil.hover(
              colBtn,
              function() {
                self.setActiveCell(cell);
                self.highlightActiveCell("col");
              },
              function() {
                self.removeHighlights();
              }
            );
            ViperUtil.hover(
              cellBtn,
              function() {
                self.setActiveCell(cell);
                self.highlightActiveCell("cell");
              },
              function() {
                self.removeHighlights();
              }
            );
            if (this._targetToolbarButton !== true) {
              ViperUtil.hover(
                tools,
                function() {
                  self.setActiveCell(cell);
                  self.highlightActiveCell();
                  ViperUtil.removeClass(btns, "Viper-hidden");
                  ViperUtil.setStyle(tools, "margin-left", "-45px");
                },
                function() {
                  self.removeHighlights();
                  ViperUtil.addClass(btns, "Viper-hidden");
                  ViperUtil.setStyle(tools, "margin-left", "0");
                }
              );
            }
          } else {
            ViperUtil.addEvent(tools, "click", function() {
              showTools("cell");
            });
          }
          this.viper.addElement(tools);
          if (inTopBar !== true) {
            this.viper.Tools.updatePositionOfElement(tools, null, cell);
            ViperUtil.setStyle(tools, "width", "auto");
          }
          if (this.viper.isEditableInIframe() === true) {
            Viper2.Util.addEvent(this.viper.getViperElement().ownerDocument.defaultView, "scroll", function(e) {
              self.viper.Tools.updatePositionOfElement(tools, null, cell);
              ViperUtil.setStyle(tools, "width", "auto");
            });
          }
        },
        hideCellToolsIcon: function() {
          if (!this._cellTools) {
            return;
          }
          var toolsid = this.viper.getId() + "-ViperTEP";
          var tools = ViperUtil.getid(toolsid);
          if (tools) {
            ViperUtil.remove(tools);
          }
          this._cellTools = null;
        },
        showTableTools: function(cell, type) {
          if (!cell) {
            return;
          }
          this.updateToolbar(cell, type);
        },
        _initToolbar: function() {
          var tools = this.viper.Tools;
          var toolbarid = "ViperTableEditor-toolbar";
          var self = this;
          var toolbarElem = tools.createInlineToolbar(toolbarid);
          var toolbar = tools.getItem(toolbarid);
          this._toolbarWidget = toolbar;
          var lineage = document.createElement("ul");
          ViperUtil.addClass(lineage, "ViperITP-lineage");
          ViperUtil.insertBefore(toolbarElem.firstChild, lineage);
          this._lineage = lineage;
          this._createCellProperties();
          this.viper.fireCallbacks("ViperTableEditorPlugin:initToolbar", { toolbar, type: "cell" });
          this._createColProperties();
          this.viper.fireCallbacks("ViperTableEditorPlugin:initToolbar", { toolbar, type: "col" });
          this._createRowProperties();
          this.viper.fireCallbacks("ViperTableEditorPlugin:initToolbar", { toolbar, type: "row" });
          this._createTableProperties();
          this.viper.fireCallbacks("ViperTableEditorPlugin:initToolbar", { toolbar, type: "table" });
        },
        hideToolbar: function() {
          this._toolbarWidget.hide();
        },
        /**
         * Upudates the toolbar.
         *
         * This method is usually called by the Viper:selectionChanged event.
         *
         * @param {DOMRange} range The DOMRange object.
         */
        updateToolbar: function(cell, type, activeSubSection) {
          this._activeSection = null;
          this._tableRawCells = null;
          this.setActiveCell(cell);
          this.removeHighlights();
          this.hideToolbar();
          this._currentType = type;
          ViperUtil.removeClass(this._toolbar, "Viper-subSectionVisible");
          this.highlightActiveCell();
          this._toolbarWidget.resetButtons();
          this._updateLineage(type);
          this._updateInnerContainer(cell, type, activeSubSection);
          this._updatePosition(cell, type);
          this.highlightActiveCell(type);
          this._toolbarWidget._updateSubSectionArrowPos();
          this._toolbarWidget.focusSubSection();
          this.viper.removeHighlights();
        },
        _updateInnerContainer: function(cell, type, activeSubSection) {
          switch (type) {
            case "cell":
            default:
              this._showCellProperties(cell, activeSubSection);
              break;
            case "col":
              this._showColProperties(cell);
              break;
            case "row":
              this._showRowProperties(cell);
              break;
            case "table":
              this._showTableProperties(cell);
              break;
          }
          var callbackData = {
            cell,
            type,
            toolbar: this._toolbarWidget
          };
          this.viper.fireCallbacks("ViperTableEditorPlugin:updateToolbar", callbackData);
        },
        _showCellProperties: function(cell, activeSubSection) {
          this._toolbarWidget.showButton("VTEP:cellProps:mergeSplitSubSectionToggle");
          this._toolbarWidget.showButton("VTEP:cellProps:settings");
          this._tools.getItem("VTEP:cellProps:heading").setValue(ViperUtil.isTag(cell, "th"));
          if (this.getRowspan(cell) <= 1) {
            this._tools.disableButton("VTEP:cellProps:splitHoriz");
          } else {
            this._tools.enableButton("VTEP:cellProps:splitHoriz");
          }
          if (this.getColspan(cell) <= 1) {
            this._tools.disableButton("VTEP:cellProps:splitVert");
          } else {
            this._tools.enableButton("VTEP:cellProps:splitVert");
          }
          if (this.canMergeUp(cell) !== false) {
            this._tools.enableButton("VTEP:cellProps:mergeUp");
          } else {
            this._tools.disableButton("VTEP:cellProps:mergeUp");
          }
          if (this.canMergeDown(cell) !== false) {
            this._tools.enableButton("VTEP:cellProps:mergeDown");
          } else {
            this._tools.disableButton("VTEP:cellProps:mergeDown");
          }
          if (this.canMergeRight(cell) !== false) {
            this._tools.enableButton("VTEP:cellProps:mergeRight");
          } else {
            this._tools.disableButton("VTEP:cellProps:mergeRight");
          }
          if (this.canMergeLeft(cell) !== false) {
            this._tools.enableButton("VTEP:cellProps:mergeLeft");
          } else {
            this._tools.disableButton("VTEP:cellProps:mergeLeft");
          }
          if (activeSubSection === "merge") {
            this._toolbarWidget.toggleSubSection("VTEP:cellProps:mergeSplitSubSection");
          } else {
            this._toolbarWidget.toggleSubSection("VTEP:cellProps:settingsSubSection");
          }
        },
        _showColProperties: function(cell) {
          this._toolbarWidget.showButton("VTEP:colProps:settings");
          this._toolbarWidget.showButton("VTEP:colProps:insBefore");
          this._toolbarWidget.showButton("VTEP:colProps:insAfter");
          this._toolbarWidget.showButton("VTEP:colProps:moveLeft");
          this._toolbarWidget.showButton("VTEP:colProps:moveRight");
          this._toolbarWidget.showButton("VTEP:colProps:remove");
          var colWidth = this.getColumnWidth(cell);
          this._tools.getItem("VTEP:colProps:width").setValue(colWidth);
          var wholeColHeading = true;
          var cells = this._getCellsExpanded();
          var cellPos = this.getCellPosition(cell);
          for (var i = 0; i < cells.length; i++) {
            var colCell = cells[i][cellPos.col];
            var colCellPos = this.getCellPosition(colCell);
            if (colCellPos.col === cellPos.col) {
              if (ViperUtil.isTag(colCell, "td") === true) {
                wholeColHeading = false;
                break;
              }
            }
          }
          this._tools.getItem("VTEP:colProps:heading").setValue(wholeColHeading, true);
          if (this.canMoveColLeft(cell) === true) {
            this._tools.enableButton("VTEP:colProps:moveLeft");
          } else {
            this._tools.disableButton("VTEP:colProps:moveLeft");
          }
          if (this.canMoveColRight(cell) === true) {
            this._tools.enableButton("VTEP:colProps:moveRight");
          } else {
            this._tools.disableButton("VTEP:colProps:moveRight");
          }
          this._toolbarWidget.toggleSubSection("VTEP:colProps:settingsSubSection");
        },
        _showRowProperties: function(cell) {
          this._toolbarWidget.showButton("VTEP:rowProps:settings");
          this._toolbarWidget.showButton("VTEP:rowProps:insBefore");
          this._toolbarWidget.showButton("VTEP:rowProps:insAfter");
          this._toolbarWidget.showButton("VTEP:rowProps:moveUp");
          this._toolbarWidget.showButton("VTEP:rowProps:moveDown");
          this._toolbarWidget.showButton("VTEP:rowProps:remove");
          this._tools.getItem("VTEP:rowProps:heading").setValue(ViperUtil.getTag("td", cell.parentNode).length === 0);
          if (this.canMoveRowUp(cell) === false) {
            this._tools.disableButton("VTEP:rowProps:moveUp");
          } else {
            this._tools.enableButton("VTEP:rowProps:moveUp");
          }
          if (this.canMoveRowDown(cell) === false) {
            this._tools.disableButton("VTEP:rowProps:moveDown");
          } else {
            this._tools.enableButton("VTEP:rowProps:moveDown");
          }
          this._toolbarWidget.toggleSubSection("VTEP:rowProps:settingsSubSection");
        },
        _showTableProperties: function(cell) {
          var table = this.getCellTable(cell);
          this._toolbarWidget.showButton("VTEP:tableProps:settings");
          this._toolbarWidget.showButton("VTEP:tableProps:remove");
          var tableWidth = this.getTableWidth(table);
          this._tools.getItem("VTEP:tableProps:width").setValue(tableWidth);
          var summary = this.viper.getAttribute(table, "summary") || "";
          this._tools.getItem("VTEP:tableProps:summary").setValue(summary);
          this._tools.getItem("VTEP:tableProps:caption").setValue(ViperUtil.getTag("caption", table).length > 0);
          this._toolbarWidget.toggleSubSection("VTEP:tableProps:settingsSubSection");
        },
        tableUpdated: function(table) {
          this._tableRawCells = null;
          table = table || this.getCellTable(this.activeCell);
          this.setTableHeaders(table);
          this.viper.contentChanged(true);
        },
        _isiPad: function() {
          if (navigator.userAgent.match(/iPad/i) !== null) {
            return true;
          }
          return false;
        },
        /**
         * Updates the position of the inline toolbar.
         */
        _updatePosition: function(cell, verticalOnly) {
          var self = this;
          var toolbar = this._toolbarWidget.element;
          this.viper.Tools.updatePositionOfElement(toolbar, null, cell, function() {
            self.hideToolbar();
          });
        },
        _updateLineage: function(type) {
          var self = this;
          ViperUtil.empty(this._lineage);
          ViperUtil.removeClass(ViperUtil.getClass("Viper-selected", this._lineage), "Viper-selected");
          var table = document.createElement("li");
          ViperUtil.addClass(table, "ViperITP-lineageItem");
          ViperUtil.setHtml(table, _("Table"));
          this._lineage.appendChild(table);
          ViperUtil.addEvent(table, "mousedown", function(e) {
            self._buttonClicked = true;
            self.updateToolbar(self.getActiveCell(), "table");
            ViperUtil.preventDefault(e);
            return false;
          });
          if (type === "table") {
            ViperUtil.addClass(table, "Viper-selected");
          }
          var row = document.createElement("li");
          ViperUtil.addClass(row, "ViperITP-lineageItem");
          ViperUtil.setHtml(row, _("Row"));
          this._lineage.appendChild(row);
          ViperUtil.addEvent(row, "mousedown", function(e) {
            ViperUtil.removeClass(ViperUtil.getClass("Viper-selected", self._lineage), "Viper-selected");
            ViperUtil.addClass(row, "Viper-selected");
            self._buttonClicked = true;
            self.updateToolbar(self.getActiveCell(), "row");
            ViperUtil.preventDefault(e);
            return false;
          });
          if (type === "row") {
            ViperUtil.addClass(row, "Viper-selected");
          }
          var col = document.createElement("li");
          ViperUtil.addClass(col, "ViperITP-lineageItem");
          ViperUtil.setHtml(col, _("Column"));
          this._lineage.appendChild(col);
          ViperUtil.addEvent(col, "mousedown", function(e) {
            self._buttonClicked = true;
            self.updateToolbar(self.getActiveCell(), "col");
            ViperUtil.preventDefault(e);
            return false;
          });
          if (type === "col") {
            ViperUtil.addClass(col, "Viper-selected");
          }
          var cell = document.createElement("li");
          ViperUtil.addClass(cell, "ViperITP-lineageItem");
          ViperUtil.setHtml(cell, _("Cell"));
          this._lineage.appendChild(cell);
          ViperUtil.addEvent(cell, "mousedown", function(e) {
            self._buttonClicked = true;
            self.updateToolbar(self.getActiveCell(), "cell");
            ViperUtil.preventDefault(e);
            return false;
          });
          if (!type || type === "cell") {
            ViperUtil.addClass(cell, "Viper-selected");
          }
          setTimeout(function() {
            ViperUtil.hover(
              table,
              function() {
                self.highlightActiveCell("table");
              },
              function() {
                self.removeHighlights();
                self.highlightActiveCell(self._currentType);
              }
            );
            ViperUtil.hover(
              row,
              function() {
                self.highlightActiveCell("row");
              },
              function() {
                self.removeHighlights();
                self.highlightActiveCell(self._currentType);
              }
            );
            ViperUtil.hover(
              col,
              function() {
                self.highlightActiveCell("col");
              },
              function() {
                self.removeHighlights();
                self.highlightActiveCell(self._currentType);
              }
            );
            ViperUtil.hover(
              cell,
              function() {
                self.highlightActiveCell("cell");
              },
              function() {
                self.removeHighlights();
                self.highlightActiveCell(self._currentType);
              }
            );
          }, 100);
        },
        removeHighlights: function() {
          ViperUtil.remove(this._highlightElement);
          this._highlightElement = null;
        },
        highlightActiveCell: function(parentType, updatePositionOnly) {
          parentType = parentType || "cell";
          var activeCell = this.getActiveCell();
          var element = null;
          var coords = null;
          if (!activeCell) {
            return;
          }
          switch (parentType) {
            case "cell":
            default:
              element = activeCell;
              break;
            case "table":
              var table = this.getCellTable(activeCell);
              var tfoot = ViperUtil.getTag("tfoot", table);
              coords = ViperUtil.getBoundingRectangle(table);
              if (ViperUtil.isBrowser("firefox") === true) {
                var caption = ViperUtil.getTag("caption", table);
                if (caption.length > 0) {
                  caption = caption[0];
                  coords.y2 += ViperUtil.getElementHeight(caption);
                }
              }
              break;
            case "row":
              if (this.getRowspan(activeCell) > 1) {
                coords = ViperUtil.getBoundingRectangle(activeCell.parentNode);
                var cellCoords = ViperUtil.getBoundingRectangle(activeCell);
                coords.y2 = cellCoords.y2;
              } else {
                element = activeCell.parentNode;
              }
              break;
            case "col":
              var table = this.getCellTable(activeCell);
              var caption = ViperUtil.getTag("caption", table);
              coords = ViperUtil.getBoundingRectangle(table);
              if (caption.length > 0) {
                var captionHeight = ViperUtil.getElementHeight(caption[0]);
                coords.y1 += captionHeight;
                if (ViperUtil.isBrowser("firefox") === true) {
                  coords.y2 += captionHeight;
                }
              }
              var cellRect = ViperUtil.getBoundingRectangle(activeCell);
              coords.x1 = cellRect.x1;
              coords.x2 = cellRect.x2;
              break;
          }
          if (updatePositionOnly !== true) {
            this.removeHighlights();
          }
          if (element && !coords) {
            coords = ViperUtil.getBoundingRectangle(element);
          }
          var offset = ViperUtil.getDocumentOffset();
          coords.x1 += offset.x;
          coords.y1 += offset.y;
          coords.x2 += offset.x;
          coords.y2 += offset.y;
          var self = this;
          if (this.viper.isEditableInIframe() === true) {
            var scrollCoords = ViperUtil.getScrollCoords(Viper2.window);
            coords.y1 -= scrollCoords.y;
            coords.y2 -= scrollCoords.y;
          }
          var hElem = this._highlightElement;
          if (updatePositionOnly !== true || !hElem) {
            hElem = document.createElement("div");
            ViperUtil.addClass(hElem, "ViperITP-highlight Viper-tableHighlight");
            ViperUtil.addEvent(hElem, "mousedown", function(e) {
              ViperUtil.preventDefault(e);
              ViperUtil.remove(hElem);
              return false;
            });
            ViperUtil.hover(
              hElem,
              function() {
                ViperUtil.setStyle(hElem, "display", "none");
              },
              function() {
              }
            );
            ViperUtil.hover(
              self._toolbarWidget.element,
              function() {
                ViperUtil.setStyle(hElem, "display", "block");
              },
              function() {
              }
            );
            if (this.viper.isEditableInIframe() === true) {
              ViperUtil.removeEvent(
                this.viper.getViperElement().ownerDocument.defaultView,
                "scroll.ViperTableEditorPlugin-" + self.viper.getId()
              );
              ViperUtil.addEvent(
                this.viper.getViperElement().ownerDocument.defaultView,
                "scroll.ViperTableEditorPlugin-" + self.viper.getId(),
                function(e) {
                  self.highlightActiveCell(parentType, true);
                }
              );
            }
          }
          ViperUtil.setStyle(hElem, "width", coords.x2 - coords.x1 + "px");
          ViperUtil.setStyle(hElem, "height", coords.y2 - coords.y1 + "px");
          ViperUtil.setStyle(hElem, "top", coords.y1 + "px");
          ViperUtil.setStyle(hElem, "left", coords.x1 + "px");
          if (updatePositionOnly !== true) {
            this.viper.addElement(hElem);
            this._highlightElement = hElem;
          }
        },
        _createCellProperties: function() {
          var self = this;
          var settingsContent = document.createElement("div");
          var headingChanged = false;
          var settingsSubSection = this._toolbarWidget.makeSubSection("VTEP:cellProps:settingsSubSection", settingsContent);
          var settingsButton = this._tools.createButton(
            "VTEP:cellProps:settings",
            "",
            _("Toggle Settings"),
            "Viper-tableSettings"
          );
          this._toolbarWidget.addButton(settingsButton);
          this._toolbarWidget.setSubSectionButton("VTEP:cellProps:settings", "VTEP:cellProps:settingsSubSection");
          this._toolbarWidget.setSubSectionAction(
            "VTEP:cellProps:settingsSubSection",
            function() {
              var cell = self.getActiveCell();
              if (headingChanged === true) {
                var newCell = null;
                if (self._tools.getItem("VTEP:cellProps:heading").getValue() === true) {
                  newCell = self.convertToHeader(cell, "cell");
                } else {
                  newCell = self.convertToCell(cell, "cell");
                }
                self.updateToolbar(newCell, "cell");
              }
            },
            ["VTEP:cellProps:heading"]
          );
          var heading = this._tools.createCheckbox("VTEP:cellProps:heading", _("Heading"), false, function() {
            headingChanged = true;
          });
          settingsContent.appendChild(heading);
          this._tools.createButton("VTEP:cellProps:splitVert", "", _("Split Vertically"), "Viper-splitVert", function() {
            var cell = self.getActiveCell();
            self._buttonClicked = true;
            self.splitVertical(cell);
            self.updateToolbar(cell, "cell", "merge");
          });
          this._tools.createButton(
            "VTEP:cellProps:splitHoriz",
            "",
            _("Split Horizontally"),
            "Viper-splitHoriz",
            function() {
              var cell = self.getActiveCell();
              self._buttonClicked = true;
              self.splitHorizontal(cell);
              self.updateToolbar(cell, "cell", "merge");
            }
          );
          var splitBtnGroup = this._tools.createButtonGroup("VTEP:cellProps:splitButtons");
          this._tools.addButtonToGroup("VTEP:cellProps:splitVert", "VTEP:cellProps:splitButtons");
          this._tools.addButtonToGroup("VTEP:cellProps:splitHoriz", "VTEP:cellProps:splitButtons");
          var mergeUp = this._tools.createButton("VTEP:cellProps:mergeUp", "", _("Merge Up"), "Viper-mergeUp", function() {
            var cell = self.getActiveCell();
            self._buttonClicked = true;
            self.updateToolbar(self.mergeUp(cell), "cell", "merge");
          });
          var mergeDown = this._tools.createButton(
            "VTEP:cellProps:mergeDown",
            "",
            _("Merge Down"),
            "Viper-mergeDown",
            function() {
              var cell = self.getActiveCell();
              self._buttonClicked = true;
              self.updateToolbar(self.mergeDown(cell), "cell", "merge");
            }
          );
          var mergeLeft = this._tools.createButton(
            "VTEP:cellProps:mergeLeft",
            "",
            _("Merge Left"),
            "Viper-mergeLeft",
            function() {
              var cell = self.getActiveCell();
              self._buttonClicked = true;
              setTimeout(function() {
                self.updateToolbar(self.mergeLeft(cell), "cell", "merge");
              }, 100);
            }
          );
          var mergeRight = this._tools.createButton(
            "VTEP:cellProps:mergeRight",
            "",
            _("Merge Right"),
            "Viper-mergeRight",
            function() {
              var cell = self.getActiveCell();
              self._buttonClicked = true;
              setTimeout(function() {
                self.updateToolbar(self.mergeRight(cell), "cell", "merge");
              }, 100);
            }
          );
          var mergeBtnGroup = this._tools.createButtonGroup("VTEP:cellProps:mergeButtons");
          this._tools.addButtonToGroup("VTEP:cellProps:mergeUp", "VTEP:cellProps:mergeButtons");
          this._tools.addButtonToGroup("VTEP:cellProps:mergeDown", "VTEP:cellProps:mergeButtons");
          this._tools.addButtonToGroup("VTEP:cellProps:mergeLeft", "VTEP:cellProps:mergeButtons");
          this._tools.addButtonToGroup("VTEP:cellProps:mergeRight", "VTEP:cellProps:mergeButtons");
          var mergeSubWrapper = document.createElement("div");
          mergeSubWrapper.appendChild(splitBtnGroup);
          mergeSubWrapper.appendChild(mergeBtnGroup);
          var mergeSubSection = this._toolbarWidget.makeSubSection("VTEP:cellProps:mergeSplitSubSection", mergeSubWrapper);
          var mergeSplitToggle = this._tools.createButton(
            "VTEP:cellProps:mergeSplitSubSectionToggle",
            "",
            _("Toggle Merge/Split Options"),
            "Viper-splitMerge"
          );
          this._toolbarWidget.addButton(mergeSplitToggle);
          this._toolbarWidget.setSubSectionButton(
            "VTEP:cellProps:mergeSplitSubSectionToggle",
            "VTEP:cellProps:mergeSplitSubSection"
          );
        },
        _createColProperties: function() {
          var self = this;
          var settingsContent = document.createElement("div");
          var headingChanged = false;
          var settingsSubSection = this._toolbarWidget.makeSubSection("VTEP:colProps:settingsSubSection", settingsContent);
          var settingsButton = this._tools.createButton(
            "VTEP:colProps:settings",
            "",
            _("Toggle Settings"),
            "Viper-tableSettings"
          );
          this._toolbarWidget.addButton(settingsButton);
          this._toolbarWidget.setSubSectionButton("VTEP:colProps:settings", "VTEP:colProps:settingsSubSection");
          this._toolbarWidget.setSubSectionAction(
            "VTEP:colProps:settingsSubSection",
            function() {
              var cell = self.getActiveCell();
              var width2 = self._tools.getItem("VTEP:colProps:width").getValue();
              self.setColumnWidth(cell, width2);
              if (headingChanged === true) {
                var headingChecked = self._tools.getItem("VTEP:colProps:heading").getValue();
                var newCell = null;
                if (headingChecked !== true) {
                  newCell = self.convertToCell(cell, "col");
                } else {
                  newCell = self.convertToHeader(cell, "col");
                }
                self.updateToolbar(newCell, "col");
              } else {
                self.updateToolbar(self.getActiveCell(), "col");
              }
            },
            ["VTEP:colProps:width", "VTEP:colProps:heading"]
          );
          var width = this._tools.createTextbox("VTEP:colProps:width", _("Width"));
          settingsContent.appendChild(width);
          var heading = this._tools.createCheckbox("VTEP:colProps:heading", _("Heading"), false, function() {
            headingChanged = true;
          });
          settingsContent.appendChild(heading);
          this._tools.createButton("VTEP:colProps:insBefore", "", _("Insert Column Before"), "Viper-addLeft", function() {
            var cell = self.getActiveCell();
            self._buttonClicked = true;
            self.insertColBefore(cell);
            self.updateToolbar(cell, "col");
          });
          this._tools.createButton("VTEP:colProps:insAfter", "", _("Insert Column After"), "Viper-addRight", function() {
            var cell = self.getActiveCell();
            self._buttonClicked = true;
            self.insertColAfter(cell);
            self.updateToolbar(cell, "col");
          });
          var btnGroup = this._tools.createButtonGroup("VTEP:insColButtons");
          this._tools.addButtonToGroup("VTEP:colProps:insBefore", "VTEP:insColButtons");
          this._tools.addButtonToGroup("VTEP:colProps:insAfter", "VTEP:insColButtons");
          this._toolbarWidget.addButton(btnGroup);
          this._tools.createButton("VTEP:colProps:moveLeft", "", _("Move Left"), "Viper-mergeLeft", function() {
            var cell = self.getActiveCell();
            self._buttonClicked = true;
            setTimeout(function() {
              self.updateToolbar(self.moveColLeft(cell), "col");
            }, 100);
          });
          this._tools.createButton("VTEP:colProps:moveRight", "", _("Move Right"), "Viper-mergeRight", function() {
            var cell = self.getActiveCell();
            self._buttonClicked = true;
            setTimeout(function() {
              self.updateToolbar(self.moveColRight(cell), "col");
            }, 100);
          });
          btnGroup = this._tools.createButtonGroup("VTEP:moveColButtons");
          this._tools.addButtonToGroup("VTEP:colProps:moveLeft", "VTEP:moveColButtons");
          this._tools.addButtonToGroup("VTEP:colProps:moveRight", "VTEP:moveColButtons");
          this._toolbarWidget.addButton(btnGroup);
          var removeCol = this._tools.createButton(
            "VTEP:colProps:remove",
            "",
            _("Remove Column"),
            "Viper-delete",
            function() {
              var cell = self.getActiveCell();
              var table = self.getCellTable(cell);
              self._buttonClicked = true;
              self.removeCol(cell);
              self.removeHighlights();
              setTimeout(function() {
                self.hideToolbar();
              }, 50);
              self._setCaretToStart(table);
            }
          );
          this._toolbarWidget.addButton(removeCol);
          ViperUtil.hover(
            removeCol,
            function() {
              ViperUtil.addClass(self._highlightElement, "Viper-deleteOverlay");
            },
            function() {
              ViperUtil.removeClass(self._highlightElement, "Viper-deleteOverlay");
            }
          );
        },
        _createRowProperties: function() {
          var self = this;
          var settingsContent = document.createElement("div");
          var headingChanged = false;
          var settingsSubSection = this._toolbarWidget.makeSubSection("VTEP:rowProps:settingsSubSection", settingsContent);
          var settingsButton = this._tools.createButton(
            "VTEP:rowProps:settings",
            "",
            _("Toggle Settings"),
            "Viper-tableSettings"
          );
          this._toolbarWidget.addButton(settingsButton);
          this._toolbarWidget.setSubSectionButton("VTEP:rowProps:settings", "VTEP:rowProps:settingsSubSection");
          this._toolbarWidget.setSubSectionAction(
            "VTEP:rowProps:settingsSubSection",
            function() {
              if (headingChanged === true) {
                var cell = self.getActiveCell();
                var newCell = null;
                if (self._tools.getItem("VTEP:rowProps:heading").getValue() === true) {
                  newCell = self.convertToHeader(cell, "row");
                } else {
                  newCell = self.convertToCell(cell, "row");
                }
                self.updateToolbar(newCell, "row");
              }
            },
            ["VTEP:rowProps:heading"]
          );
          var heading = this._tools.createCheckbox("VTEP:rowProps:heading", _("Heading"), false, function() {
            headingChanged = true;
          });
          settingsContent.appendChild(heading);
          this._tools.createButton("VTEP:rowProps:insBefore", "", _("Insert Row Before"), "Viper-addAbove", function() {
            var cell = self.getActiveCell();
            self._buttonClicked = true;
            self.insertRowBefore(cell);
            self.updateToolbar(cell, "row");
          });
          this._tools.createButton("VTEP:rowProps:insAfter", "", _("Insert Row After"), "Viper-addBelow", function() {
            var cell = self.getActiveCell();
            self.insertRowAfter(cell);
            self.updateToolbar(cell, "row");
          });
          var btnGroup = this._tools.createButtonGroup("VTEP:insRowButtons");
          this._tools.addButtonToGroup("VTEP:rowProps:insBefore", "VTEP:insRowButtons");
          this._tools.addButtonToGroup("VTEP:rowProps:insAfter", "VTEP:insRowButtons");
          this._toolbarWidget.addButton(btnGroup);
          this._tools.createButton("VTEP:rowProps:moveUp", "", _("Move Up"), "Viper-mergeUp", function() {
            var cell = self.getActiveCell();
            self._buttonClicked = true;
            self.updateToolbar(self.moveRowUp(cell), "row");
          });
          this._tools.createButton("VTEP:rowProps:moveDown", "", _("Move Down"), "Viper-mergeDown", function() {
            var cell = self.getActiveCell();
            self._buttonClicked = true;
            self.updateToolbar(self.moveRowDown(cell), "row");
          });
          btnGroup = this._tools.createButtonGroup("VTEP:moveRowButtons");
          this._tools.addButtonToGroup("VTEP:rowProps:moveUp", "VTEP:moveRowButtons");
          this._tools.addButtonToGroup("VTEP:rowProps:moveDown", "VTEP:moveRowButtons");
          this._toolbarWidget.addButton(btnGroup);
          var removeRow = this._tools.createButton(
            "VTEP:rowProps:remove",
            "",
            _("Remove Row"),
            "Viper-delete",
            function() {
              var cell = self.getActiveCell();
              var table = self.getCellTable(cell);
              self._buttonClicked = true;
              self.removeRow(cell);
              self.removeHighlights();
              setTimeout(function() {
                self.hideToolbar();
              }, 50);
              self._setCaretToStart(table);
            }
          );
          this._toolbarWidget.addButton(removeRow);
          ViperUtil.hover(
            removeRow,
            function() {
              ViperUtil.addClass(self._highlightElement, "Viper-deleteOverlay");
            },
            function() {
              ViperUtil.removeClass(self._highlightElement, "Viper-deleteOverlay");
            }
          );
        },
        _createTableProperties: function(cell) {
          var self = this;
          var settingsContent = document.createElement("div");
          var settingsSubSection = this._toolbarWidget.makeSubSection(
            "VTEP:tableProps:settingsSubSection",
            settingsContent
          );
          var settingsButton = this._tools.createButton(
            "VTEP:tableProps:settings",
            "",
            _("Toggle Settings"),
            "Viper-tableSettings"
          );
          this._toolbarWidget.addButton(settingsButton);
          this._toolbarWidget.setSubSectionButton("VTEP:tableProps:settings", "VTEP:tableProps:settingsSubSection");
          this._toolbarWidget.setSubSectionAction(
            "VTEP:tableProps:settingsSubSection",
            function() {
              var table = self.getCellTable(self.getActiveCell());
              self.setTableWidth(table, self._tools.getItem("VTEP:tableProps:width").getValue());
              self.viper.setAttribute(table, "summary", self._tools.getItem("VTEP:tableProps:summary").getValue());
              var captionCheckbox = self._tools.getItem("VTEP:tableProps:caption").getValue();
              if (captionCheckbox === true) {
                self.createCaption(table);
              } else {
                self.removeCaption(table);
              }
              self.updateToolbar(self.getActiveCell(), "table");
            },
            ["VTEP:tableProps:width", "VTEP:tableProps:summary", "VTEP:tableProps:caption"]
          );
          var width = this._tools.createTextbox(
            "VTEP:tableProps:width",
            _("Width"),
            "",
            null,
            false,
            false,
            "",
            null,
            "4.5em"
          );
          settingsContent.appendChild(width);
          var tableSummary = this._tools.createTextarea(
            "VTEP:tableProps:summary",
            _("Summary"),
            "",
            false,
            "",
            null,
            "4.5em"
          );
          settingsContent.appendChild(tableSummary);
          var caption = this._tools.createCheckbox("VTEP:tableProps:caption", _("Use Caption"));
          settingsContent.appendChild(caption);
          var remove2 = this._tools.createButton(
            "VTEP:tableProps:remove",
            "",
            _("Remove Table"),
            "Viper-delete",
            function() {
              var table = self.getCellTable(self.getActiveCell());
              self._buttonClicked = true;
              self.removeTable(table);
              self.removeHighlights();
              setTimeout(function() {
                self.hideToolbar();
              }, 50);
            }
          );
          this._toolbarWidget.addButton(remove2);
          ViperUtil.hover(
            remove2,
            function() {
              ViperUtil.addClass(self._highlightElement, "Viper-deleteOverlay");
            },
            function() {
              ViperUtil.removeClass(self._highlightElement, "Viper-deleteOverlay");
            }
          );
        },
        setActiveCell: function(cell) {
          this.activeCell = cell;
        },
        getActiveCell: function(cell) {
          return this.activeCell;
        },
        createTableHeader: function(table) {
          if (ViperUtil.getTag("thead", table).length > 0) {
            return null;
          }
          var header = document.createElement("thead");
          var tfoot = ViperUtil.getTag("tfoot", table);
          if (tfoot.length === 0) {
            var tbody = ViperUtil.getTag("tbody", table);
            if (tbody.length === 0) {
              table.appendChild(header);
            } else {
              ViperUtil.insertBefore(tbody[0], header);
            }
          } else {
            ViperUtil.insertBefore(tfoot[0], header);
          }
          return header;
        },
        getTableHeader: function(table) {
          var header = ViperUtil.getTag("thead", table);
          if (header.length === 0) {
            return null;
          }
          return header[0];
        },
        createTableBody: function(table) {
          if (ViperUtil.getTag("tbody", table).length > 0) {
            return null;
          }
          var tbody = document.createElement("tbody");
          table.appendChild(tbody);
          return tbody;
        },
        getTableBody: function(table) {
          var tbody = ViperUtil.getTag("tbody", table);
          if (tbody.length === 0) {
            return null;
          }
          return tbody[0];
        },
        createCaption: function(table) {
          var caption = null;
          var captions = ViperUtil.getTag("caption", table);
          if (captions.length > 0) {
            caption = captions[0];
          } else {
            caption = document.createElement("caption");
            ViperUtil.setHtml(caption, "&nbsp;");
            ViperUtil.insertBefore(table.firstChild, caption);
          }
          var range = this.viper.getCurrentRange();
          var selectNode = range._getFirstSelectableChild(caption);
          range.setStart(selectNode, 0);
          range.collapse(true);
          ViperSelection.addRange(range);
          this.viper.fireSelectionChanged(null, true);
          this.removeHighlights();
          this.hideCellToolsIcon();
        },
        removeCaption: function(table) {
          var caption = null;
          var captions = ViperUtil.getTag("caption", table);
          if (captions.length > 0) {
            ViperUtil.remove(captions);
          }
        },
        /*
                Merging.
            */
        canMergeLeft: function(cell) {
          var cells = this._getCellsExpanded();
          var cellPos = this.getCellPosition(cell);
          var rowspan = this.getRowspan(cell);
          if (cellPos.col === 0) {
            return false;
          }
          var processedCells = [];
          var rowspans = 0;
          var prevColspan = null;
          for (var i = 0; i < rowspan; i++) {
            var prevCell = cells[cellPos.row + i][cellPos.col - 1];
            if (ViperUtil.inArray(prevCell, processedCells) === true) {
              continue;
            }
            processedCells.push(prevCell);
            var pos = this.getCellPosition(prevCell);
            if (i === 0 && pos.row !== cellPos.row) {
              return false;
            }
            rowspans += this.getRowspan(prevCell);
            if (rowspans > rowspan) {
              return false;
            } else if (prevColspan !== null && prevColspan !== this.getColspan(prevCell)) {
              return false;
            }
            prevColspan = this.getColspan(prevCell);
          }
          if (rowspans === rowspan) {
            return processedCells;
          }
          return false;
        },
        canMergeRight: function(cell) {
          var cells = this._getCellsExpanded();
          var cellPos = this.getCellPosition(cell);
          var rowspan = this.getRowspan(cell);
          var colspan = this.getColspan(cell);
          if (cell === cells[cellPos.row][cells[cellPos.row].length - 1]) {
            return false;
          }
          var processedCells = [];
          var rowspans = 0;
          var prevColspan = null;
          for (var i = 0; i < rowspan; i++) {
            var nextCell = cells[cellPos.row + i][cellPos.col + colspan];
            if (ViperUtil.inArray(nextCell, processedCells) === true) {
              continue;
            }
            processedCells.push(nextCell);
            var pos = this.getCellPosition(nextCell);
            if (i === 0 && pos.row !== cellPos.row) {
              return false;
            }
            rowspans += this.getRowspan(nextCell);
            if (rowspans > rowspan) {
              return false;
            } else if (prevColspan !== null && prevColspan !== this.getColspan(nextCell)) {
              return false;
            }
            prevColspan = this.getColspan(nextCell);
          }
          if (rowspans === rowspan) {
            return processedCells;
          }
          return false;
        },
        canMergeDown: function(cell) {
          var rowspan = this.getRowspan(cell);
          var colNum = this.getColNum(cell);
          var row = cell.parentNode;
          var colspan = this.getColspan(cell);
          while (rowspan >= 1) {
            row = this.getNextRow(row, true);
            rowspan--;
          }
          if (row) {
            var cspan = 0;
            var processedCells = [];
            var prevRowspan = null;
            for (var i = 0; i < colspan; i++) {
              var newCell = this.getCell(row, colNum + i);
              if (!newCell) {
                return false;
              }
              if (ViperUtil.inArray(newCell, processedCells) === true) {
                continue;
              }
              processedCells.push(newCell);
              var newCellRowspan = this.getRowspan(newCell);
              if (prevRowspan !== null && prevRowspan !== newCellRowspan) {
                return false;
              }
              prevRowspan = newCellRowspan;
              cspan += this.getColspan(newCell);
              if (colspan < cspan) {
                return false;
              }
            }
            return processedCells;
          }
          return false;
        },
        canMergeUp: function(cell) {
          var rowspan = this.getRowspan(cell);
          var colNum = this.getColNum(cell);
          var row = cell.parentNode;
          var newCell = null;
          var colspan = this.getColspan(cell);
          while (row && !newCell) {
            row = this.getPreviousRow(row, true);
            if (!row) {
              return false;
            }
            newCell = this.getCell(row, colNum);
          }
          if (row) {
            var cspan = 0;
            var processedCells = [];
            var prevRowspan = null;
            for (var i = 0; i < colspan; i++) {
              var newCell = this.getCell(row, colNum + i);
              if (!newCell) {
                return false;
              }
              if (ViperUtil.inArray(newCell, processedCells) === true) {
                continue;
              }
              processedCells.push(newCell);
              var newCellRowspan = this.getRowspan(newCell);
              if (prevRowspan !== null && prevRowspan !== newCellRowspan) {
                return false;
              }
              prevRowspan = newCellRowspan;
              cspan += this.getColspan(newCell);
              if (colspan < cspan) {
                return false;
              }
            }
            return processedCells;
          }
          return false;
        },
        mergeLeft: function(cell) {
          var mergeCells = this.canMergeLeft(cell);
          if (!mergeCells || mergeCells.length === 0) {
            return;
          }
          var newColspan = this.getColspan(cell) + this.getColspan(mergeCells[0]);
          this.setColspan(cell, newColspan);
          for (var i = 0; i < mergeCells.length; i++) {
            this._moveCellContent(mergeCells[i], cell);
            ViperUtil.remove(mergeCells[i]);
          }
          var table = this.getCellTable(cell);
          if (ViperUtil.getTag("tr", table).length === 1) {
            this.setColspan(cell, 1);
          }
          this.tableUpdated();
          return cell;
        },
        mergeRight: function(cell) {
          var mergeCells = this.canMergeRight(cell);
          if (!mergeCells || mergeCells.length === 0) {
            return;
          }
          var newColspan = this.getColspan(cell) + this.getColspan(mergeCells[0]);
          this.setColspan(cell, newColspan);
          for (var i = 0; i < mergeCells.length; i++) {
            this._moveCellContent(mergeCells[i], cell);
            ViperUtil.remove(mergeCells[i]);
          }
          var table = this.getCellTable(cell);
          if (ViperUtil.getTag("tr", table).length === 1) {
            this.setColspan(cell, 1);
          }
          var cells = ViperUtil.getTag("td,th", table);
          if (cells.length === 1) {
            this.setColspan(cells[0], 1);
            this.setRowspan(cells[0], 1);
            var rows = ViperUtil.getTag("tr", table);
            for (var i = 0; i < rows.length; i++) {
              if (ViperUtil.getTag("td,th", rows[i]).length === 0) {
                ViperUtil.remove(rows[i]);
              }
            }
          }
          this.tableUpdated();
          return cell;
        },
        mergeDown: function(cell) {
          var mergeCells = this.canMergeDown(cell);
          if (mergeCells.length === 0) {
            return false;
          }
          this.setActiveCell(cell);
          var parent = mergeCells[0].parentNode;
          for (var i = 0; i < mergeCells.length; i++) {
            this._moveCellContent(mergeCells[i], cell);
            ViperUtil.remove(mergeCells[i]);
          }
          var rowspan = this.getRowspan(cell) + this.getRowspan(mergeCells[0]);
          this.setRowspan(cell, rowspan);
          var cells = this._getCellsExpanded(true);
          var rowCells = this._getRowCells(parent);
          if (rowCells.length === 0) {
            var rows = ViperUtil.getTag("tr", this.getCellTable(cell));
            var rowIndex = -1;
            for (var i = 0; i < rows.length; i++) {
              if (rows[i] === parent) {
                rowIndex = i;
                break;
              }
            }
            if (rowIndex >= 0) {
              var processedCells = [];
              cells = cells[rowIndex];
              for (var i = 0; i < cells.length; i++) {
                if (ViperUtil.inArray(cells[i], processedCells) === true) {
                  continue;
                }
                processedCells.push(cells[i]);
                var rowspan = this.getRowspan(cells[i]) - 1;
                this.setRowspan(cells[i], rowspan);
              }
            }
            ViperUtil.remove(parent);
          }
          var table = this.getCellTable(cell);
          if (ViperUtil.getTag("tr", table).length === 1) {
            this.setColspan(cell, 1);
          }
          this.tableUpdated();
          return cell;
        },
        mergeUp: function(cell) {
          var mergeCells = this.canMergeUp(cell);
          if (mergeCells.length === 0) {
            return false;
          }
          this.setActiveCell(cell);
          var cellPos = this.getCellPosition(cell);
          var parent = cell.parentNode;
          var firstCell = mergeCells[0];
          for (var i = 1; i < mergeCells.length; i++) {
            this.setColspan(firstCell, this.getColspan(firstCell) + this.getColspan(mergeCells[i]));
            this._moveCellContent(mergeCells[i], firstCell);
            ViperUtil.remove(mergeCells[i]);
          }
          this._moveCellContent(cell, firstCell);
          ViperUtil.remove(cell);
          var rowspan = this.getRowspan(firstCell) + this.getRowspan(cell);
          this.setRowspan(firstCell, rowspan);
          this.setActiveCell(firstCell);
          var cells = this._getCellsExpanded(true);
          var rowCells = cells[cellPos.row];
          var prevPos = this.getCellPosition(firstCell).row;
          var remove2 = true;
          for (var i = 0; i < rowCells.length; i++) {
            var pos = this.getCellPosition(rowCells[i]);
            if (pos.row !== prevPos || rowspan !== this.getRowspan(rowCells[i])) {
              remove2 = false;
              break;
            }
          }
          if (remove2 === true) {
            ViperUtil.remove(parent);
            var processedCells = [];
            for (var i = 0; i < rowCells.length; i++) {
              if (ViperUtil.inArray(rowCells[i], processedCells) === true) {
                continue;
              }
              processedCells.push(rowCells[i]);
              var newRowspan = this.getRowspan(rowCells[i]) - 1;
              this.setRowspan(rowCells[i], newRowspan);
            }
          }
          var table = this.getCellTable(firstCell);
          if (ViperUtil.getTag("tr", table).length === 1) {
            this.setColspan(firstCell, 1);
          }
          this.tableUpdated();
          return firstCell;
        },
        /*
                Moving.
            */
        canMoveColLeft: function(cell) {
          var colNum = this.getColNum(cell);
          if (colNum === 0) {
            return false;
          }
          var pos = this.getCellPosition(cell);
          var cells = this._getCellsExpanded(true);
          var colspan = this.getColspan(cell);
          for (var i = 0; i < cells.length; i++) {
            var currColspan = this.getColspan(cells[i][pos.col]);
            var prevColspan = this.getColspan(cells[i][pos.col - 1]);
            var currRowspan = this.getRowspan(cells[i][pos.col]);
            var prevRowspan = this.getRowspan(cells[i][pos.col - 1]);
            if (colspan !== currColspan || currColspan !== prevColspan) {
              return false;
            } else if (currRowspan !== prevRowspan) {
              return false;
            }
          }
          return true;
        },
        canMoveColRight: function(cell) {
          var pos = this.getCellPosition(cell);
          var cells = this._getCellsExpanded(true);
          var colspan = this.getColspan(cell);
          if (!cells[pos.row][pos.col + 1]) {
            return false;
          }
          for (var i = 0; i < cells.length; i++) {
            var currColspan = this.getColspan(cells[i][pos.col]);
            var nextColspan = this.getColspan(cells[i][pos.col + 1]);
            var currRowspan = this.getRowspan(cells[i][pos.col]);
            var nextRowspan = this.getRowspan(cells[i][pos.col + 1]);
            if (colspan !== currColspan || currColspan !== nextColspan) {
              return false;
            } else if (currRowspan !== nextRowspan) {
              return false;
            }
          }
          return true;
        },
        canMoveRowUp: function(cell) {
          var pos = this.getCellPosition(cell);
          if (pos.row === 0) {
            return false;
          }
          var rowspan = this.getRowspan(cell);
          var cellRow = this.getCellRow(cell);
          var prevRow = this.getPreviousRow(cellRow);
          if (!prevRow) {
            return false;
          }
          var rowCellsCount = this._getRowCellCount(cellRow);
          var prevRowCellCount = this._getRowCellCount(prevRow);
          if (rowCellsCount !== prevRowCellCount) {
            return false;
          }
          var cells = this._getCellsExpanded();
          for (var i = 0; i < cells[pos.row].length; i++) {
            var rowCell = cells[pos.row][i];
            if (rowCell === cell) {
              continue;
            }
            var cellPos = this.getCellPosition(rowCell);
            if (cellPos.row !== pos.row || rowspan < this.getRowspan(rowCell)) {
              return false;
            }
          }
          return true;
        },
        canMoveRowDown: function(cell) {
          var pos = this.getCellPosition(cell);
          var cellRow = this.getCellRow(cell);
          var rowspan = this.getRowspan(cell);
          var nextRow = cellRow;
          for (var i = 0; i < rowspan; i++) {
            nextRow = this.getNextRow(nextRow);
            if (!nextRow) {
              return false;
            }
          }
          var rowCellsCount = this._getRowCellCount(cellRow);
          var nextRowCellCount = this._getRowCellCount(nextRow);
          if (rowCellsCount !== nextRowCellCount) {
            return false;
          }
          var cells = this._getCellsExpanded();
          for (var i = 0; i < cells[pos.row].length; i++) {
            var rowCell = cells[pos.row][i];
            if (rowCell === cell) {
              continue;
            }
            var cellPos = this.getCellPosition(rowCell);
            if (cellPos.row !== pos.row || rowspan < this.getRowspan(rowCell)) {
              return false;
            }
          }
          return true;
        },
        moveColLeft: function(cell) {
          if (this.canMoveColLeft(cell) === false) {
            return false;
          }
          var pos = this.getCellPosition(cell);
          var cells = this._getCellsExpanded(true);
          if (!cells[pos.row][pos.col - 1]) {
            return false;
          }
          for (var i = 0; i < cells.length; i++) {
            ViperUtil.insertBefore(cells[i][pos.col - 1], cells[i][pos.col]);
          }
          this.tableUpdated();
          return cell;
        },
        moveColRight: function(cell) {
          if (this.canMoveColRight(cell) === false) {
            return false;
          }
          var pos = this.getCellPosition(cell);
          var cells = this._getCellsExpanded(true);
          if (!cells[pos.row][pos.col + 1]) {
            return false;
          }
          for (var i = 0; i < cells.length; i++) {
            ViperUtil.insertAfter(cells[i][pos.col + 1], cells[i][pos.col]);
          }
          this.tableUpdated();
          return cell;
        },
        moveRowUp: function(cell) {
          if (this.canMoveRowUp(cell) === false) {
            return false;
          }
          var cellRow = this.getCellRow(cell);
          var prevRow = this.getPreviousRow(cellRow);
          var rowspan = this.getRowspan(cell);
          for (var i = 0; i < rowspan; i++) {
            cellRow = this.getNextRow(prevRow);
            ViperUtil.insertBefore(prevRow, cellRow);
          }
          this.tableUpdated();
          return cell;
        },
        moveRowDown: function(cell) {
          if (this.canMoveRowDown(cell) === false) {
            return false;
          }
          var rowspan = this.getRowspan(cell);
          var cellRow = this.getCellRow(cell);
          var nextRow = cellRow;
          for (var i = 0; i < rowspan; i++) {
            nextRow = this.getNextRow(nextRow);
            if (!nextRow) {
              return false;
            }
          }
          var startRow = nextRow;
          var cells = this._getRowCells(startRow);
          var maxRowspan = 1;
          for (var i = 0; i < cells.length; i++) {
            var cellRowspan = this.getRowspan(cells[i]);
            if (maxRowspan < cellRowspan) {
              maxRowspan = cellRowspan;
            }
          }
          let afterRow = startRow;
          if (maxRowspan > 1) {
            for (var i = 0; i < maxRowspan - 1; i++) {
              nextRow = this.getNextRow(nextRow);
            }
            afterRow = nextRow;
          }
          for (var i = 0; i < rowspan; i++) {
            var prevRow = this.getPreviousRow(startRow);
            if (!prevRow) {
              return false;
            }
            ViperUtil.insertAfter(afterRow, prevRow);
          }
          this.tableUpdated();
          return cell;
        },
        getRowspan: function(cell) {
          return parseInt(cell.getAttribute("rowspan") || 1);
        },
        setRowspan: function(cell, rowspan) {
          if (rowspan > 1) {
            cell.setAttribute("rowspan", rowspan);
          } else {
            ViperUtil.removeAttr(cell, "rowspan");
          }
        },
        getColspan: function(cell) {
          return parseInt(cell.getAttribute("colspan") || 1);
        },
        setColspan: function(cell, colspan) {
          if (colspan > 1) {
            cell.setAttribute("colspan", colspan);
          } else {
            ViperUtil.removeAttr(cell, "colspan");
          }
        },
        /**
         * Converts specified cell to header.
         *
         * @param {DOMNode} cell The table cell to convert.
         * @param {string}  type Valid values are 'cell', 'col', 'row'. If col is specified
         *                       then the whole column the cell belongs to will be converted.
         *                       If the row is specifed then the whole row the cell belongs
         *                       to will be converted. Cell is the default value.
         *
         * @return {DOMNode} The new header element.
         */
        convertToHeader: function(cell, type, actualType) {
          var elem = cell;
          type = type || "cell";
          if (type === "cell" && ViperUtil.isTag(cell, "td") === false) {
            return elem;
          }
          var activeCell = this.getActiveCell();
          if (type === "cell") {
            elem = document.createElement("th");
            while (cell.firstChild) {
              elem.appendChild(cell.firstChild);
            }
            for (var i = 0; i < cell.attributes.length; i++) {
              if (cell.attributes[i].nodeName.toLowerCase() === "rowspan") {
                this.setRowspan(elem, cell.attributes[i].nodeValue);
              } else if (cell.attributes[i].nodeName.toLowerCase() === "colspan") {
                this.setColspan(elem, cell.attributes[i].nodeValue);
              } else {
                elem.setAttribute(cell.attributes[i].nodeName, cell.attributes[i].nodeValue);
              }
            }
            if (cell === activeCell) {
              this.setActiveCell(elem);
            }
            ViperUtil.insertBefore(cell, elem);
            ViperUtil.remove(cell);
            if (!actualType || actualType === "cell") {
              this.tableUpdated();
            }
          } else if (type === "col") {
            var cells = this._getCellsExpanded();
            var cellPos = this.getCellPosition(cell);
            for (var i = 0; i < cells.length; i++) {
              var colCell = cells[i][cellPos.col];
              if (!colCell.parentNode || ViperUtil.isTag(colCell, "th") === true) {
                continue;
              }
              var colCellPos = this.getCellPosition(colCell);
              if (colCellPos.col === cellPos.col) {
                var newElement = this.convertToHeader(colCell, "cell", "col");
                if (cell === colCell) {
                  elem = newElement;
                }
              }
            }
            this.tableUpdated();
          } else if (type === "row") {
            var cellPos = this.getCellPosition(cell);
            var row = cell.parentNode;
            var cells = this._getRowCells(row);
            if (ViperUtil.isTag(row.parentNode, "thead") === false && !this.getPreviousRow(row, true)) {
              var moveToThead = true;
              var prevRowspan = null;
              for (var i = 0; i < cells.length; i++) {
                var rowspan = this.getRowspan(cells[i]);
                if (prevRowspan !== null && rowspan !== prevRowspan) {
                  moveToThead = false;
                  break;
                }
                prevRowspan = rowspan;
              }
              if (moveToThead === true) {
                var table = this.getRowTable(row);
                var thead = this.getTableHeader(table);
                if (!thead) {
                  thead = this.createTableHeader(table);
                }
                thead.appendChild(row);
              }
            }
            for (var i = 0; i < cells.length; i++) {
              var rowCell = cells[i];
              if (!rowCell.parentNode || ViperUtil.isTag(rowCell, "th") === true) {
                continue;
              }
              var newElement = this.convertToHeader(rowCell, "cell", "row");
              if (cell === rowCell) {
                elem = newElement;
              }
            }
            this.tableUpdated();
          }
          return elem;
        },
        /**
         * Converts specified header cell to normal cell.
         *
         * @param {DOMNode} cell The table cell to convert.
         * @param {string}  type Valid values are 'cell', 'col', 'row'. If col is specified
         *                       then the whole column the cell belongs to will be converted.
         *                       If the row is specifed then the whole row the cell belongs
         *                       to will be converted. Cell is the default value.
         *
         * @return {DOMNode} The new cell element.
         */
        convertToCell: function(cell, type, actualType) {
          var elem = cell;
          type = type || "cell";
          if (type === "cell" && ViperUtil.isTag(cell, "th") === false) {
            return elem;
          }
          var activeCell = this.getActiveCell();
          if (type === "cell") {
            elem = document.createElement("td");
            while (cell.firstChild) {
              elem.appendChild(cell.firstChild);
            }
            for (var i = 0; i < cell.attributes.length; i++) {
              if (cell.attributes[i].nodeName.toLowerCase() === "rowspan") {
                this.setRowspan(elem, cell.attributes[i].nodeValue);
              } else if (cell.attributes[i].nodeName.toLowerCase() === "colspan") {
                this.setColspan(elem, cell.attributes[i].nodeValue);
              } else {
                elem.setAttribute(cell.attributes[i].nodeName, cell.attributes[i].nodeValue);
              }
            }
            if (cell === activeCell) {
              this.setActiveCell(elem);
            }
            ViperUtil.insertBefore(cell, elem);
            var tableid = this.getCellTable(elem).id;
            var cellid = elem.id;
            if (cellid && cellid.indexOf(tableid) === 0) {
              cellid = cellid.replace(tableid, "");
              if (cellid.match(/r\d+c\d+/)) {
                elem.removeAttribute("id");
              }
            }
            ViperUtil.remove(cell);
            if (!actualType || actualType === "cell") {
              this.tableUpdated();
            }
          } else if (type === "col") {
            var cells = this._getCellsExpanded();
            var cellPos = this.getCellPosition(cell);
            for (var i = 0; i < cells.length; i++) {
              var colCell = cells[i][cellPos.col];
              if (!colCell.parentNode || ViperUtil.isTag(colCell, "td") === true) {
                continue;
              }
              var colCellPos = this.getCellPosition(colCell);
              if (colCellPos.col === cellPos.col) {
                var newElement = this.convertToCell(colCell, "cell", "col");
                if (cell === colCell) {
                  elem = newElement;
                }
              }
            }
            this.tableUpdated();
          } else if (type === "row") {
            var cellPos = this.getCellPosition(cell);
            var cells = this._getRowCells(cell.parentNode);
            var row = cell.parentNode;
            if (ViperUtil.isTag(row.parentNode, "thead") === true && !this.getNextRow(row, true)) {
              var table = this.getRowTable(row);
              var tbody = this.getTableBody(table);
              if (!tbody) {
                tbody = this.createTableBody(table);
                tbody.appendChild(row);
              } else {
                var rows = ViperUtil.getTag("tr", tbody);
                if (rows.length === 0) {
                  tbody.appendChild(row);
                } else {
                  ViperUtil.insertBefore(rows[0], row);
                }
              }
            }
            for (var i = 0; i < cells.length; i++) {
              var rowCell = cells[i];
              if (!rowCell.parentNode || ViperUtil.isTag(rowCell, "td") === true) {
                continue;
              }
              var newElement = this.convertToCell(rowCell, "cell", "row");
              if (cell === rowCell) {
                elem = newElement;
              }
            }
            this.tableUpdated();
          }
          return elem;
        },
        setColumnWidth: function(cell, width) {
          if (parseInt(width) === width) {
            width = width + "px";
          }
          var cells = this._getCellsExpanded();
          var cellPos = this.getCellPosition(cell);
          for (var i = 0; i < cells.length; i++) {
            var colCell = cells[i][cellPos.col];
            var colCellPos = this.getCellPosition(colCell);
            if (colCellPos.col === cellPos.col) {
              ViperUtil.setStyle(colCell, "width", width);
              this.tableUpdated();
              return;
            }
          }
        },
        getColumnWidth: function(cell) {
          var cells = this._getCellsExpanded();
          var cellPos = this.getCellPosition(cell);
          for (var i = 0; i < cells.length; i++) {
            var colCell = cells[i][cellPos.col];
            var colCellPos = this.getCellPosition(colCell);
            if (colCellPos.col === cellPos.col) {
              return colCell.style.width || "";
            }
          }
          return "";
        },
        setTableWidth: function(table, width) {
          if (parseInt(width) === width) {
            width = width + "px";
          }
          ViperUtil.setStyle(table, "width", width);
          if (table.getAttribute("style") === "") {
            table.removeAttribute("style");
          }
          this.tableUpdated(table);
        },
        getTableWidth: function(table) {
          var width = table.style.width || "";
          return width;
        },
        /**
         * Splits specified cell vertically only if it has rowspan > 1.
         *
         * @param {DOMNode} cell The table cell to split.
         *
         * @return {DOMNode} The new row that was created.
         */
        splitVertical: function(cell) {
          if (!cell || !cell.getAttribute("colspan")) {
            return;
          }
          var tagName = ViperUtil.getTagName(cell);
          var elem = document.createElement(tagName);
          this._initCell(elem);
          var colspan = parseInt(cell.getAttribute("colspan")) - 1;
          this.setColspan(cell, colspan);
          var rowspan = cell.getAttribute("rowspan");
          if (rowspan > 1) {
            this.setRowspan(elem, rowspan);
          }
          ViperUtil.insertAfter(cell, elem);
          this.tableUpdated();
          return elem;
        },
        /**
         * Splits specified cell horizontally only if it has colspan > 1.
         *
         * @param {DOMNode} cell The table cell to split.
         *
         * @return {DOMNode} The new column that was created.
         */
        splitHorizontal: function(cell) {
          var rowspan = this.getRowspan(cell);
          if (!cell || rowspan <= 1) {
            return false;
          }
          var rows = ViperUtil.getTag("tr", this.getCellTable(cell));
          var cellPos = this.getCellPosition(cell);
          var cells = this._getCellsExpanded();
          this.setRowspan(cell, rowspan - 1);
          var colspan = this.getColspan(cell);
          var newCell = document.createElement(ViperUtil.getTagName(cell));
          this._initCell(newCell);
          if (colspan > 1) {
            this.setColspan(newCell, colspan);
          }
          var nextRowIndex = cellPos.row + rowspan - 1;
          var rowCells = this._getRowCells(rows[nextRowIndex]);
          if (rowCells.length === 0) {
            rows[nextRowIndex].appendChild(newCell);
          } else if (cellPos.col === 0) {
            ViperUtil.insertBefore(rowCells[0], newCell);
          } else {
            var cellIndex = cellPos.col;
            var inserted = false;
            while (cells[nextRowIndex][--cellIndex]) {
              if (this.getCellPosition(cells[nextRowIndex][cellIndex]).row === nextRowIndex) {
                inserted = true;
                ViperUtil.insertAfter(cells[nextRowIndex][cellIndex], newCell);
                break;
              }
            }
            if (inserted === false) {
              cellIndex = cellPos.col;
              while (cells[nextRowIndex][++cellIndex]) {
                if (this.getCellPosition(cells[nextRowIndex][cellIndex]).row === nextRowIndex) {
                  ViperUtil.insertBefore(cells[nextRowIndex][cellIndex], newCell);
                  break;
                }
              }
            }
          }
          this.tableUpdated();
          return newCell;
        },
        insertRowBefore: function(cell) {
          var cellRow = cell.parentNode;
          var cellPos = this.getCellPosition(cell);
          var cells = this._getCellsExpanded();
          var rowCells = cells[cellPos.row];
          var rlen = rowCells.length;
          var newRow = document.createElement("tr");
          var processedCells = [];
          for (var i = 0; i < rlen; i++) {
            var rowCell = rowCells[i];
            if (ViperUtil.inArray(rowCell, processedCells) === true) {
              continue;
            }
            var rowspan = this.getRowspan(rowCell);
            if (rowspan > 1 && this.getCellPosition(rowCell).row < cellPos.row) {
              this.setRowspan(rowCell, rowspan + 1);
            } else {
              var newCell = document.createElement(ViperUtil.getTagName(rowCell));
              this._initCell(newCell);
              var colspan = this.getColspan(rowCell);
              if (colspan > 1) {
                this.setColspan(newCell, colspan);
              }
              newRow.appendChild(newCell);
            }
            processedCells.push(rowCell);
          }
          ViperUtil.insertBefore(cellRow, newRow);
          this.tableUpdated();
        },
        insertRowAfter: function(cell) {
          var rows = ViperUtil.getTag("tr", this.getCellTable(cell));
          var cellPos = this.getCellPosition(cell);
          var cells = this._getCellsExpanded();
          var rowCells = cells[cellPos.row + (this.getRowspan(cell) - 1)];
          var rlen = rowCells.length;
          var cellRow = rows[cellPos.row + (this.getRowspan(cell) - 1)];
          var newRow = document.createElement("tr");
          var processedCells = [];
          for (var i = 0; i < rlen; i++) {
            var rowCell = rowCells[i];
            if (ViperUtil.inArray(rowCell, processedCells) === true) {
              continue;
            }
            var rowspan = this.getRowspan(rowCell);
            if (rowspan > 1 && rowCell !== cell && this.getCellPosition(rowCell).row + this.getRowspan(rowCell) - 1 > cellPos.row) {
              this.setRowspan(rowCell, rowspan + 1);
            } else {
              var newCell = document.createElement(ViperUtil.getTagName(rowCell));
              this._initCell(newCell);
              var colspan = this.getColspan(rowCell);
              if (colspan > 1) {
                this.setColspan(newCell, colspan);
              }
              newRow.appendChild(newCell);
            }
            processedCells.push(rowCell);
          }
          ViperUtil.insertAfter(cellRow, newRow);
          this.tableUpdated();
        },
        removeRow: function(cell) {
          var table = this.getCellTable(cell);
          var tr = this.getCellRow(cell);
          var cellPos = this.getCellPosition(cell);
          var cells = this._getCellsExpanded();
          var rowspan = this.getRowspan(cell);
          var nextRowIndex = cellPos.row + rowspan;
          var nextRow = tr;
          for (var i = 0; i < rowspan; i++) {
            var rowToRemove = nextRow;
            nextRow = this.getNextRow(nextRow);
            rowToRemove.parentNode.removeChild(rowToRemove);
          }
          var rowCells = cells[cellPos.row];
          var cellsToMove = [];
          for (var i = 0; i < rowCells.length; i++) {
            var rowCell = rowCells[i];
            var rowCellPos = this.getCellPosition(rowCell);
            var rowCellRowspan = this.getRowspan(rowCell);
            if (rowCellPos.row !== cellPos.row || rowCellRowspan > rowspan) {
              if (rowCellPos.row === cellPos.row) {
                cellsToMove.push(rowCell);
              }
              this.setRowspan(rowCell, rowCellRowspan - rowspan);
            }
          }
          for (var i = 0; i < cellsToMove.length; i++) {
            var rowCell = cellsToMove[i];
            var rowCellPos = this.getCellPosition(rowCell);
            var rowCellRowspan = this.getRowspan(rowCell);
            rowCells = cells[cellPos.row + rowspan];
            var index = ViperUtil.arraySearch(rowCell, rowCells);
            if (index > 0) {
              for (var j = index - 1; j >= 0; j--) {
                if (this.getCellPosition(rowCells[j]).row === nextRowIndex) {
                  ViperUtil.insertAfter(rowCells[j], rowCell);
                  break;
                }
              }
            } else if (index === 0) {
              for (var j = 0; j < rowCells.length; j++) {
                if (this.getCellPosition(rowCells[j]).row === nextRowIndex) {
                  ViperUtil.insertBefore(rowCells[j], rowCell);
                  break;
                }
              }
            }
          }
          var rows = ViperUtil.getTag("tr", table);
          if (rows.length === 0) {
            ViperUtil.remove(table);
          }
          this.tableUpdated(table);
        },
        insertColAfter: function(cell) {
          var table = this.getCellTable(cell);
          var rows = ViperUtil.getTag("tr", table);
          var rln = rows.length;
          var colNum = this.getColNum(cell) + (this.getColspan(cell) - 1);
          var td = null;
          for (var i = 0; i < rln; i++) {
            var col = this.getCell(i, colNum);
            var cellPos = this.getCellPosition(col);
            if (cellPos.col !== colNum && col !== cell || col !== cell && this.getColspan(col) > 1) {
              this.setColspan(col, this.getColspan(col) + 1);
            } else if (cellPos.row < i) {
              if (td) {
                this.setRowspan(td, this.getRowspan(td) + 1);
              }
              continue;
            } else {
              td = document.createElement(col.tagName);
              this._initCell(td);
              ViperUtil.insertAfter(col, td);
            }
          }
          this.tableUpdated();
        },
        insertColBefore: function(cell) {
          var table = this.getCellTable(cell);
          var rows = ViperUtil.getTag("tr", table);
          var rln = rows.length;
          var colNum = this.getColNum(cell);
          var td = null;
          for (var i = 0; i < rln; i++) {
            var col = this.getCell(i, colNum);
            var cellPos = this.getCellPosition(col);
            if (cellPos.col !== colNum && col !== cell) {
              this.setColspan(col, this.getColspan(col) + 1);
            } else if (cellPos.row < i) {
              if (td) {
                this.setRowspan(td, this.getRowspan(td) + 1);
              }
              continue;
            } else {
              td = document.createElement(col.tagName);
              this._initCell(td);
              ViperUtil.insertBefore(col, td);
            }
          }
          this.tableUpdated();
        },
        getColumnCells: function(table, colNum) {
          if (!table) {
            return;
          }
          var cols = [];
          var rows = ViperUtil.getTag("tr", table);
          var rln = rows.length;
          for (var i = 0; i < rln; i++) {
            cols.push(this.getCell(rows[i], colNum));
          }
          return cols;
        },
        removeCol: function(cell) {
          var table = this.getCellTable(cell);
          var cellPos = this.getCellPosition(cell);
          var cells = this._getCellsExpanded();
          var rowCount = cells.length;
          var colspan = this.getColspan(cell);
          var processedCells = [];
          for (var i = 0; i < rowCount; i++) {
            for (var j = cellPos.col; j < cellPos.col + colspan; j++) {
              var rowCell = cells[i][j];
              if (ViperUtil.inArray(rowCell, processedCells) === true) {
                continue;
              }
              var rowCellColspan = this.getColspan(rowCell);
              if (rowCellColspan > colspan || rowCellColspan > 1 && this.getCellPosition(rowCell).col !== cellPos.col) {
                this.setColspan(rowCell, rowCellColspan - 1);
              } else {
                ViperUtil.remove(rowCell);
              }
              processedCells.push(rowCell);
            }
          }
          var rows = ViperUtil.getTag("td", table);
          if (rows.length === 0) {
            ViperUtil.remove(table);
          }
          this.tableUpdated(table);
        },
        getNextCell: function(cell) {
          var pos = this.getCellPosition(cell);
          if (!pos) {
            return null;
          }
          var nextCell = this.getCell(pos.row, pos.col + this.getColspan(cell));
          return nextCell;
        },
        getPreviousCell: function(cell) {
          var pos = this.getCellPosition(cell);
          if (!pos) {
            return null;
          }
          var prevCell = this.getCell(pos.row, pos.col - 1);
          return prevCell;
        },
        moveCaretToCell: function(cell) {
          if (cell) {
            var range = this.viper.getCurrentRange();
            var child = range._getFirstSelectableChild(cell);
            if (!child) {
              this._initCell(cell);
              child = cell.firstChild;
            }
            range.selectNode(child);
            range.setEnd(child, 0);
            range.collapse(false);
            ViperSelection.addRange(range);
            this.setActiveCell(cell);
            this.showCellToolsIcon(cell);
            return range;
          } else {
            this.hideCellToolsIcon();
          }
        },
        moveCaretToNextCell: function() {
          var range = this.viper.getCurrentRange();
          var cell = this._getRangeCellElement(range);
          if (!cell) {
            return false;
          }
          this.setActiveCell(cell);
          var node = cell;
          while (node) {
            if (!node.nextSibling) {
              var nextRow = this.getNextRow(node.parentNode);
              if (!nextRow) {
                return false;
              } else {
                node = nextRow.firstChild;
              }
            } else {
              node = node.nextSibling;
            }
            if (ViperUtil.isTag(node, "th") === true || ViperUtil.isTag(node, "td") === true) {
              break;
            }
          }
          if (!node) {
            return false;
          }
          this.moveCaretToCell(node);
          return true;
        },
        moveCaretToPreviousCell: function() {
          var range = this.viper.getCurrentRange();
          var cell = this._getRangeCellElement(range);
          if (!cell) {
            return false;
          }
          this.setActiveCell(cell);
          var node = cell;
          while (node) {
            if (!node.previousSibling) {
              var previousRow = this.getPreviousRow(node.parentNode);
              if (!previousRow) {
                return false;
              } else {
                node = previousRow.lastChild;
              }
            } else {
              node = node.previousSibling;
            }
            if (ViperUtil.isTag(node, "th") === true || ViperUtil.isTag(node, "td") === true) {
              break;
            }
          }
          if (!node) {
            return false;
          }
          this.moveCaretToCell(node);
          return true;
        },
        removeTable: function(table, emptyOnly) {
          if (emptyOnly === true) {
            if (ViperUtil.find(table, "tr > td").length > 0 || ViperUtil.find(table, "tr > th").length > 0) {
              return;
            }
          }
          if (ViperUtil.isBrowser("firefox") === true) {
            this.viper.focus();
          }
          this.hideCellToolsIcon();
          this.viper.moveCaretAway(table);
          ViperUtil.remove(table);
          this.viper.contentChanged();
        },
        getCellTable: function(cell) {
          if (!cell) {
            return null;
          }
          var node = cell;
          while (node) {
            if (node.nodeType === ViperUtil.ELEMENT_NODE) {
              var tagName = node.tagName.toLowerCase();
              if (tagName === "table") {
                return node;
              }
            }
            node = node.parentNode;
          }
        },
        getRowTable: function(row, tbody) {
          return this.getCellTable(row);
        },
        getCellRow: function(cell) {
          var rows = ViperUtil.getTag("tr", this.getCellTable(cell));
          var cellPos = this.getCellPosition(cell);
          return rows[cellPos.row];
        },
        /**
         * Inserts a table to the caret position.
         */
        _createToolbarEditorBubble: function() {
          var main = document.createElement("div");
          var maxRows = 6;
          var maxCols = 8;
          var selectedRows = 3;
          var selectedCols = 4;
          var selectedHeaderType = 2;
          var content = "";
          var sizePicker = '<p class="VTEP-bubble-label Viper-sizeLabel">Size (' + selectedCols + " x " + selectedRows + ")</p>";
          sizePicker += '<table class="VTEP-bubble-table Viper-sizePicker"><tbody>';
          for (var i = 0; i < maxRows; i++) {
            sizePicker += "<tr>";
            for (var j = 0; j < maxCols; j++) {
              var classAttr = "";
              if (selectedRows > i && selectedCols > j) {
                classAttr = ' class="Viper-selected"';
              }
              sizePicker += '<td data-viper-rowcol="' + i + ", " + j + '"' + classAttr + " ></td>";
            }
            sizePicker += "</tr>";
          }
          sizePicker += "</tbody></table>";
          content += sizePicker;
          var headerOpts = this._headerOptions;
          var headerOptTitles = [_("None"), _("Left"), _("Top"), _("Both")];
          var headers = '<p class="VTEP-bubble-label Viper-headers">' + _("Headers") + '</p><div class="VTEP-bubble-headersWrapper">';
          for (var h = 0; h < headerOpts.length; h++) {
            var selected = "";
            if (h === selectedHeaderType) {
              selected = " Viper-selected";
            }
            headers += '<div class="VTEP-bubble-headersTableWrapper' + selected + '">';
            headers += '<table class="VTEP-bubble-table Viper-headers"><tbody>';
            var c = 0;
            for (var i = 0; i < 3; i++) {
              headers += "<tr>";
              for (var j = 0; j < 3; j++) {
                if (headerOpts[h] && headerOpts[h][c]) {
                  headers += '<td class="Viper-hover"></td>';
                } else {
                  headers += "<td></td>";
                }
                c++;
              }
              headers += "</tr>";
            }
            headers += "</tbody></table>";
            headers += '<span class="VTEP-bubble-headerTitle">' + headerOptTitles[h] + "</span></div>";
          }
          headers += "</div>";
          content += headers;
          ViperUtil.setHtml(main, content);
          var trs = ViperUtil.getTag("tr", ViperUtil.getClass("Viper-sizePicker", main)[0]);
          var _setRowColsActive = function(row, col) {
            selectedRows = parseInt(row) + 1;
            selectedCols = parseInt(col) + 1;
            ViperUtil.setHtml(
              ViperUtil.getClass("Viper-sizeLabel", main)[0],
              _("Size") + " (" + selectedCols + " x " + selectedRows + ")"
            );
            for (var i2 = 0; i2 < maxRows; i2++) {
              for (var j2 = 0; j2 < maxCols; j2++) {
                if (i2 <= row && j2 <= col) {
                  ViperUtil.addClass(trs[i2].childNodes[j2], "Viper-selected");
                } else {
                  ViperUtil.removeClass(trs[i2].childNodes[j2], "Viper-selected");
                }
              }
            }
          };
          var _setRowColsHover = function(row, col) {
            ViperUtil.setHtml(
              ViperUtil.getClass("Viper-sizeLabel", main)[0],
              _("Size") + " (" + (parseInt(col) + 1) + " x " + (parseInt(row) + 1) + ")"
            );
            for (var i2 = 0; i2 < maxRows; i2++) {
              for (var j2 = 0; j2 < maxCols; j2++) {
                if (i2 <= row && j2 <= col) {
                  ViperUtil.addClass(trs[i2].childNodes[j2], "Viper-hover");
                } else {
                  ViperUtil.removeClass(trs[i2].childNodes[j2], "Viper-hover");
                }
              }
            }
          };
          var tdHover = null;
          var sizePickerElem = ViperUtil.getClass("Viper-sizePicker", main)[0];
          ViperUtil.addEvent(sizePickerElem, "mousemove", function(e) {
            var td = ViperUtil.getMouseEventTarget(e);
            if (td !== tdHover && ViperUtil.isTag(td, "td") === true) {
              tdHover = td;
              var rowcol = td.getAttribute("data-viper-rowcol").split(",");
              _setRowColsHover(rowcol[0], rowcol[1]);
            }
          });
          ViperUtil.addEvent(sizePickerElem, "click", function(e) {
            var td = ViperUtil.getMouseEventTarget(e);
            if (td && ViperUtil.isTag(td, "td") === true) {
              var rowcol = td.getAttribute("data-viper-rowcol").split(",");
              _setRowColsActive(rowcol[0], rowcol[1]);
            }
          });
          ViperUtil.hover(
            sizePickerElem,
            function() {
            },
            function() {
              ViperUtil.removeClass(ViperUtil.getClass("Viper-hover", sizePickerElem), "Viper-hover");
              ViperUtil.setHtml(
                ViperUtil.getClass("Viper-sizeLabel", main)[0],
                _("Size") + " (" + selectedRows + " x " + selectedCols + ")"
              );
            }
          );
          var headerTables = ViperUtil.getClass("VTEP-bubble-headersTableWrapper", main);
          for (var i = 0; i < headerTables.length; i++) {
            (function(type) {
              ViperUtil.addEvent(headerTables[type], "click", function(e) {
                selectedHeaderType = type;
                ViperUtil.removeClass(headerTables, "Viper-selected");
                ViperUtil.addClass(headerTables[type], "Viper-selected");
              });
            })(i);
          }
          var self = this;
          var insertTableBtn = this.viper.Tools.createButton(
            "VTEP-insertTableButton",
            _("Insert Table"),
            _("Insert Table"),
            "",
            function() {
              self.toolbarPlugin.closeBubble("VTEP-bubble");
              self.insertTable(selectedRows, selectedCols, selectedHeaderType);
            }
          );
          main.appendChild(insertTableBtn);
          this.toolbarPlugin.createBubble("VTEP-bubble", _("Insert Table"), main);
          this.toolbarPlugin.setBubbleButton("VTEP-bubble", "insertTable", true);
        },
        insertTable: function(rows, cols, headerType, tableid) {
          this.viper.HistoryManager.begin();
          rows = rows || 3;
          cols = cols || 3;
          var table = document.createElement("table");
          ViperUtil.setStyle(table, "display", "none");
          if (!tableid) {
            while (!tableid) {
              tableid = "table" + ViperUtil.getUniqueId().substr(-5, 5);
              var tElem = ViperUtil.getid(tableid);
              if (tElem) {
                tableid = null;
              }
            }
          }
          table.setAttribute("id", tableid);
          var tbody = document.createElement("tbody");
          var firstCol = null;
          var headerOpts = this._headerOptions;
          var thead = null;
          if (headerType === 2 || headerType === 3) {
            thead = document.createElement("thead");
          }
          for (var i = 0; i < rows; i++) {
            var tr = document.createElement("tr");
            for (var j = 0; j < cols; j++) {
              var cell = null;
              var isHeader = false;
              if (headerType === 1 && j === 0) {
                isHeader = true;
              } else if (headerType === 2 && i === 0) {
                isHeader = true;
              } else if (headerType === 3 && (i === 0 || j === 0)) {
                isHeader = true;
              }
              if (isHeader) {
                cell = document.createElement("th");
              } else {
                cell = document.createElement("td");
              }
              this._initCell(cell);
              tr.appendChild(cell);
              if (firstCol === null) {
                firstCol = cell;
              }
            }
            if (thead) {
              table.appendChild(thead);
              thead.appendChild(tr);
              thead = null;
            } else {
              tbody.appendChild(tr);
            }
          }
          table.appendChild(tbody);
          var viperHtml = ViperUtil.trim(this.viper.getHtml());
          if (viperHtml === "" || viperHtml === "<p>&nbsp;</p>" || viperHtml === "<p></p>") {
            ViperUtil.empty(this.viper.getViperElement());
            this.viper.getViperElement().appendChild(table);
          } else {
            var prevNode = this.viper.getKeyboardHandler().splitAtRange(true);
            if (ViperUtil.isTag(prevNode, "li") === true) {
              prevNode.appendChild(table);
              if (ViperUtil.isBlank(ViperUtil.getNodeTextContent(prevNode.nextSibling)) === true) {
                ViperUtil.remove(prevNode.nextSibling);
              }
            } else {
              ViperUtil.insertAfter(prevNode, table);
            }
          }
          var width = parseInt(ViperUtil.getComputedStyle(table, "width"));
          if (!width) {
            ViperUtil.setStyle(table, "width", "100%");
          }
          var col = ViperUtil.getTag("td,th", table)[0];
          var rightWidth = parseFloat(ViperUtil.getComputedStyle(col, "border-right-width"));
          var bottomWidth = parseFloat(ViperUtil.getComputedStyle(col, "border-bottom-width"));
          if (bottomWidth === 0 || rightWidth === 0 || isNaN(bottomWidth) === true || isNaN(rightWidth) === true) {
            ViperUtil.attr(table, "border", 1);
          }
          ViperUtil.setStyle(table, "display", "");
          if (!table.getAttribute("style")) {
            table.removeAttribute("style");
          }
          if (firstCol) {
            var range = this.viper.getCurrentRange();
            range.setStart(firstCol.firstChild, 0);
            range.collapse(true);
            ViperSelection.addRange(range);
            this.setActiveCell(firstCol);
          }
          this.viper.contentChanged();
          this.setTableHeaders(table);
          this.viper.HistoryManager.end();
          return table;
        },
        setTableHeaders: function(table) {
          if (!table) {
            return;
          }
          var headers = ViperUtil.find(table, "[headers]");
          var headersCount = headers.length;
          if (headersCount > 0) {
            for (var i = 0; i < headersCount; i++) {
              var headersAttr = headers[i].getAttribute("headers");
              if (headersAttr) {
                headersAttr = " " + headersAttr;
                if (headersAttr.match(/\s[\w\d]+r\d+c\d+/)) {
                  headers[i].removeAttribute("headers");
                }
              }
            }
          }
          headers = null;
          var thElements = ViperUtil.getTag("th", table);
          if (thElements.length === 0) {
            return;
          }
          var tableId = table.getAttribute("id");
          if (!tableId) {
            while (!tableId) {
              var uniqueid = ViperUtil.getUniqueId();
              tableId = "table" + uniqueid.substr(uniqueid.length - 5, 5);
              var tElem = ViperUtil.getid(tableId);
              if (tElem) {
                tableId = null;
              }
            }
            table.setAttribute("id", tableId);
          }
          var tableRows = ViperUtil.getTag("tr", table);
          for (var k = 0; k < tableRows.length; k++) {
            var row = tableRows[k];
            var cellCount = 0;
            for (var j = 0; j < row.childNodes.length; j++) {
              var cell = row.childNodes[j];
              if (cell.nodeType === ViperUtil.TEXT_NODE) {
                continue;
              }
              if (ViperUtil.isTag(cell, "th") === true) {
                var cellid = cell.getAttribute("id");
                if (!cellid || cellid.match(/r\d+c\d+/)) {
                  cellid = tableId + "r" + (k + 1) + "c" + (cellCount + 1);
                  var existingElem = ViperUtil.getid(cellid);
                  if (existingElem) {
                    existingElem.removeAttribute("id");
                  }
                  cell.setAttribute("id", cellid);
                }
              }
              cellCount++;
            }
          }
          if (window["HTMLCS"]) {
            var headers = HTMLCS.util.getCellHeaders(table);
            var c = headers.length;
            for (var i = 0; i < c; i++) {
              var header = headers[i];
              var headersAttr = header.cell.getAttribute("headers");
              if (!headersAttr || (" " + headersAttr).match(/\stable\d+r\d+c\d+/)) {
                header.cell.setAttribute("headers", header.headers);
              }
            }
          }
        },
        getHeadersContent: function(element) {
          var headers = element.getAttribute("headers");
          if (!headers) {
            return "";
          }
          var parts = headers.split(" ");
          var content = [];
          for (var i = 0; i < parts.length; i++) {
            var part = parts[i];
            content.push(ViperUtil.getHtml(ViperUtil.getid(part)));
          }
          content.push(ViperUtil.getHtml(element));
          content = content.join(" ");
          return content;
        },
        getCellContent: function(table, row, column) {
          var rows = ViperUtil.getTag("tr", table);
          if (!rows[row]) {
            return null;
          }
          var rowElem = rows[row];
          var cols = ViperUtil.getTag("td,th", rowElem);
          if (!cols[column]) {
            return null;
          }
          return ViperUtil.getHtml(cols[column]);
        },
        _setCaretToStart: function(table) {
          var cells = ViperUtil.getTag("td,th", table);
          if (cells.length > 0) {
            if (ViperUtil.getHtml(cells[0]) === "") {
              ViperUtil.setHtml(cells[0], "&nbsp;");
            }
            var cell = cells[0];
            var range = this.viper.getCurrentRange();
            var child = range._getFirstSelectableChild(cell);
            if (!child && cell.childNodes.length === 1) {
              child = cell.childNodes[0];
            }
            range.setStart(child, 0);
            range.collapse(true);
            ViperSelection.addRange(range);
          }
        },
        _getRangeCellElement: function(range) {
          return this._getCellElement(range.getCommonElement());
        },
        _getCellElement: function(element) {
          var cellElement = null;
          if (ViperUtil.isTag(element, "td") === false && ViperUtil.isTag(element, "th") === false) {
            var parents = ViperUtil.getParents(element, null, this.viper.getViperElement());
            var plen = parents.length;
            for (var i = 0; i < plen; i++) {
              if (ViperUtil.isTag(parents[i], "td") === true || ViperUtil.isTag(parents[i], "th") === true) {
                cellElement = parents[i];
                break;
              }
            }
          } else {
            cellElement = element;
          }
          if (!cellElement) {
            return false;
          }
          return cellElement;
        },
        _getTableCells: function(table, stopCell) {
          if (!table) {
            table = this.getCellTable(this.getActiveCell());
          }
          var cells = {};
          var rows = ViperUtil.getTag("tr", table);
          var rlen = rows.length;
          for (var i = 0; i < rlen; i++) {
            var rowCells = this._getRowCells(rows[i]);
            var rowCellsCount = rowCells.length;
            cells[i] = [];
            for (var j = 0; j < rowCellsCount; j++) {
              cells[i].push({
                cell: rowCells[j],
                rowspan: this.getRowspan(rowCells[j]),
                colspan: this.getColspan(rowCells[j])
              });
              if (stopCell === rowCells[j]) {
                return cells;
              }
            }
          }
          return cells;
        },
        _getRowNum: function(row) {
          var table = this.getRowTable(row, true);
          var rows = ViperUtil.getTag("tr", table);
          var rlen = rows.length;
          for (var i = 0; i < rlen; i++) {
            if (rows[i] === row) {
              return i;
            }
          }
          return null;
        },
        getColNum: function(cell) {
          if (!cell) {
            return null;
          }
          var cellNum = null;
          var cells = this._getCellsExpanded();
          var rows = cells.length;
          for (var i = 0; i < rows; i++) {
            var cellCount = cells[i].length;
            for (var j = 0; j < cellCount; j++) {
              if (cells[i][j] === cell) {
                return j;
              }
            }
          }
          return null;
        },
        /**
         * Returns the specified cell element.
         *
         * @param {integer} row  The row number.
         * @param {integer} cell The cell number.
         *
         * @return {DOMElement} The cell (td/th) element.
         */
        getCell: function(row, cell) {
          if (ViperUtil.isset(cell) === false) {
            return null;
          }
          if (typeof row !== "number") {
            row = this._getRowNum(row);
          }
          var cells = this._getCellsExpanded();
          return cells[row][cell];
        },
        getCellPosition: function(cell) {
          var cells = this._getCellsExpanded();
          var rows = cells.length;
          for (var i = 0; i < rows; i++) {
            var cellCount = cells[i].length;
            for (var j = 0; j < cellCount; j++) {
              if (cells[i][j] === cell) {
                return {
                  row: i,
                  col: j
                };
              }
            }
          }
          return null;
        },
        _getCellsExpanded: function(forceUpdate) {
          if (forceUpdate !== true && this._tableRawCells) {
            return this._tableRawCells;
          }
          var tableCells = this._getTableCells();
          var rawCells = [];
          ViperUtil.foreach(tableCells, function(rowNum) {
            rowNum = parseInt(rowNum);
            if (!rawCells[rowNum]) {
              rawCells[rowNum] = [];
            }
            ViperUtil.foreach(tableCells[rowNum], function(j) {
              var rowCell = tableCells[rowNum][j].cell;
              var rowspan = tableCells[rowNum][j].rowspan;
              var colspan = tableCells[rowNum][j].colspan;
              var modifier = 0;
              for (var i = 0; i < rowspan; i++) {
                for (var k = 0; k < colspan; k++) {
                  if (!rawCells[rowNum + i]) {
                    rawCells[rowNum + i] = [];
                  }
                  while (rawCells[rowNum + i][j + k + modifier]) {
                    modifier++;
                  }
                  rawCells[rowNum + i][j + k + modifier] = rowCell;
                }
              }
            });
          });
          this._tableRawCells = rawCells;
          return rawCells;
        },
        getPreviousRow: function(row, ignorePrevParent) {
          var sourceRow = row;
          while (row = row.previousSibling) {
            if (row.nodeType === ViperUtil.ELEMENT_NODE) {
              var tagName = row.tagName.toLowerCase();
              if (tagName === "tr") {
                return row;
              }
            }
          }
          if (ignorePrevParent !== true && ViperUtil.isTag(sourceRow.parentNode, "tbody") === true) {
            var rows = ViperUtil.getTag("tr", ViperUtil.getTag("thead", this.getRowTable(sourceRow)));
            if (rows.length > 0) {
              return rows[rows.length - 1];
            }
          }
        },
        getNextRow: function(row, ignoreNextParent) {
          var sourceRow = row;
          while (row = row.nextSibling) {
            if (row.nodeType === ViperUtil.ELEMENT_NODE) {
              var tagName = row.tagName.toLowerCase();
              if (tagName === "tr") {
                return row;
              }
            }
          }
          if (ignoreNextParent !== true && ViperUtil.isTag(sourceRow.parentNode, "thead") === true) {
            var rows = ViperUtil.getTag("tr", ViperUtil.getTag("tbody", this.getRowTable(sourceRow)));
            if (rows.length > 0) {
              return rows[0];
            }
          }
        },
        _getRowCells: function(row) {
          var tags = ViperUtil.getTag("td,th", row);
          return tags;
        },
        _getRowCellCount: function(row) {
          var cellCount = 0;
          for (var node = row.firstChild; node; node = node.nextSibling) {
            if (ViperUtil.isTag(node, "th") === true || ViperUtil.isTag(node, "td") === true) {
              cellCount += this.getColspan(node);
            }
          }
          return cellCount;
        },
        _moveCellContent: function(fromCell, toCell) {
          if (!fromCell || !toCell) {
            return false;
          }
          if (toCell.lastChild && ViperUtil.isTag(toCell.lastChild, "br") === true) {
            ViperUtil.remove(toCell.lastChild);
          }
          while (fromCell.firstChild) {
            if (ViperUtil.isTag(fromCell.firstChild, "br") === true) {
              ViperUtil.remove(fromCell.firstChild);
            } else if (fromCell.firstChild.nodeType !== ViperUtil.TEXT_NODE || ViperUtil.trim(fromCell.firstChild.data) !== "") {
              toCell.appendChild(fromCell.firstChild);
            } else {
              ViperUtil.remove(fromCell.firstChild);
            }
          }
          if (!toCell.lastChild) {
            this._initCell(toCell);
          }
        },
        isPluginElement: function(element) {
          if (element === this._highlightElement) {
            return true;
          }
          return false;
        },
        _initCell: function(cell) {
          ViperUtil.setHtml(cell, "<br />");
        }
      };
    };
  }
});

// src/Plugins/ViperLinkPlugin/ViperLinkPlugin.js
var ViperLinkPlugin_exports = {};
__export(ViperLinkPlugin_exports, {
  registerPlugin: () => registerPlugin18
});
var registerPlugin18;
var init_ViperLinkPlugin = __esm({
  "src/Plugins/ViperLinkPlugin/ViperLinkPlugin.js"() {
    "use strict";
    registerPlugin18 = (Viper2) => {
      const { Util: ViperUtil, Selection: ViperSelection, _ } = Viper2;
      function ViperLinkPlugin(viper) {
        this.viper = viper;
        this._autoLinkOpensInNewWindow = false;
        this._inlineToolbar = null;
        this.initToolbar();
        this.initInlineToolbar();
      }
      Viper2.PluginManager.addPlugin("ViperLinkPlugin", ViperLinkPlugin);
      ViperLinkPlugin.prototype = {
        init: function() {
          this.enableAutoLink();
        },
        setSettings: function(settings) {
          if (!settings) {
            return;
          }
          if (settings.autoLinkOpensInNewWindow === true) {
            this._autoLinkOpensInNewWindow = true;
          } else {
            this._autoLinkOpensInNewWindow = false;
          }
        },
        enableAutoLink: function() {
          var self = this;
          this.viper.registerCallback("Viper:keyUp", "ViperLinkPlugin", function(e) {
            if (e.which !== 32) {
              return;
            }
            self._autoLink(false);
          });
          this.viper.registerCallback("Viper:beforeEnter", "ViperLinkPlugin", function() {
            self._autoLink(true);
          });
        },
        _autoLink: function(isEnter) {
          var range = this.viper.getViperRange();
          if (range.collapsed !== true) {
            return;
          }
          var startNode = range.getStartNode();
          if (!startNode || startNode.nodeType !== ViperUtil.TEXT_NODE) {
            return;
          }
          var mod = 1;
          if (isEnter === true) {
            mod = 0;
          }
          var text = startNode.data.substr(0, range.startOffset - mod);
          var url = text.match(/ ((http[s]?:\/\/|www\.)\S+)$/);
          if (!url) {
            url = text.match(/^((http[s]?:\/\/|www\.)\S+)$/);
            if (!url) {
              return;
            }
          }
          url = url[1];
          var length = url.length;
          var a = document.createElement("a");
          ViperUtil.setHtml(a, url);
          if (url.match(/^[^:]+(?=:\/\/)/) === null) {
            url = "http://" + url;
          }
          a.setAttribute("href", url);
          if (this._autoLinkOpensInNewWindow === true) {
            a.setAttribute("target", "_blank");
          }
          var nextNode = startNode.splitText(range.startOffset - mod - length);
          ViperUtil.insertBefore(nextNode, a);
          nextNode.data = nextNode.data.slice(length);
          range.setStart(nextNode, mod);
          range.collapse(true);
          ViperSelection.addRange(range);
        },
        isEmail: function(url) {
          return this.validateEmail(url);
        },
        /**
         * Validates an email.
         *
         * Chose not to use a domain white list given .anything is on the way.  A feature
         * this regex currently does not support is <Name Part> of an email so add if
         * needed.
         *
         * @return boolean
         */
        validateEmail: function(email) {
          if (email.match(/@/g) === null) return false;
          var regExStr = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return regExStr.test(email);
        },
        getURL: function(idPrefix) {
          var url = ViperUtil.trim(this.viper.Tools.getItem(idPrefix + ":url").getValue());
          return url;
        },
        updateLinkAttributes: function(link, idPrefix, ignoreChange) {
          var url = this.getURL(idPrefix);
          var title = this.viper.Tools.getItem(idPrefix + ":title").getValue();
          var newWindow = this.viper.Tools.getItem(idPrefix + ":newWindow").getValue();
          if (this.isEmail(url.replace(/\s*mailto:\s*/i, "")) === true) {
            url = "mailto:" + url.replace(/\s*mailto:\s*/i, "");
            var subject = this.viper.Tools.getItem(idPrefix + ":subject").getValue();
            if (subject) {
              url += "?subject=" + encodeURIComponent(subject);
            }
          }
          this.viper.setAttribute(link, "href", url);
          if (title) {
            this.viper.setAttribute(link, "title", title);
          } else {
            link.removeAttribute("title");
          }
          if (newWindow === true) {
            this.viper.setAttribute(link, "target", "_blank");
          } else {
            link.removeAttribute("target");
          }
          var range = this.viper.getViperRange();
          range.selectNode(link);
          ViperSelection.addRange(range);
          if (ignoreChange !== true) {
            this.viper.contentChanged(false, range);
          }
        },
        updateLink: function(idPrefix) {
          var range = this.viper.getViperRange();
          var node = range.getNodeSelection();
          if (ViperUtil.isTag(node, "a") === false) {
            node = this.getLinkFromRange(range);
            if (!node) {
              return this.rangeToLink(idPrefix);
            } else {
              this.updateLinkAttributes(node, idPrefix);
            }
          } else {
            this.updateLinkAttributes(node, idPrefix);
          }
        },
        rangeToLink: function(idPrefix) {
          var url = this.viper.Tools.getItem(idPrefix + ":url").getValue();
          if (!url) {
            return;
          }
          var range = this.viper.getViperRange();
          var node = range.getNodeSelection();
          var a = document.createElement("a");
          if (ViperUtil.isElement(node) === true) {
            if (ViperUtil.isStubElement(node) === true || ViperUtil.isTag(node, "ul") === true || ViperUtil.isTag(node, "ol") === true) {
              ViperUtil.insertBefore(node, a);
              a.appendChild(node);
            } else if (this.viper.isSpecialElement(node) === true) {
              ViperUtil.insertBefore(node, a);
              a.appendChild(node);
            } else {
              var prevNode = null;
              while (node.firstChild) {
                var firstChild = node.firstChild;
                if (prevNode && prevNode.nodeType === ViperUtil.TEXT_NODE && firstChild.nodeType === ViperUtil.TEXT_NODE) {
                  prevNode.data += firstChild.data;
                  ViperUtil.remove(firstChild);
                } else {
                  a.appendChild(firstChild);
                }
                prevNode = firstChild;
              }
              if (ViperUtil.isTag(node, "span") === true && this.viper.isViperHighlightElement(node) === false) {
                for (var i = 0; i < node.attributes.length; i++) {
                  a.setAttribute(node.attributes[i].nodeName, node.attributes[i].nodeValue);
                }
                ViperUtil.insertBefore(node, a);
                ViperUtil.remove(node);
              } else {
                node.appendChild(a);
              }
            }
            this.updateLinkAttributes(a, idPrefix);
          } else {
            a = this.viper.surroundContents("a", null, range);
            this.updateLinkAttributes(a, idPrefix);
          }
          return a;
        },
        removeLink: function(linkTag) {
          if (!linkTag || !linkTag.parentNode) {
            return;
          }
          var bookmark = this.viper.createBookmark();
          var firstChild = linkTag.firstChild;
          var lastChild = linkTag.lastChild;
          while (linkTag.firstChild) {
            ViperUtil.insertBefore(linkTag, linkTag.firstChild);
          }
          ViperUtil.remove(linkTag);
          this.viper.selectBookmark(bookmark);
          var self = this;
          setTimeout(function() {
            self.viper.contentChanged();
          }, 10);
        },
        removeLinks: function() {
          var range = this.viper.getViperRange();
          var nodeSelection = range.getNodeSelection();
          if (nodeSelection) {
            var links = ViperUtil.getTag("a", nodeSelection);
            var c = links.length;
            for (var i = 0; i < c; i++) {
              var elem = links[i];
              while (elem.firstChild) {
                if (elem.firstChild.nodeType == ViperUtil.TEXT_NODE && elem.previousSibling && elem.previousSibling.nodeType === ViperUtil.TEXT_NODE) {
                  elem.previousSibling.data += elem.firstChild.data;
                  ViperUtil.remove(elem.firstChild);
                } else {
                  ViperUtil.insertBefore(elem, elem.firstChild);
                }
              }
              ViperUtil.remove(elem);
            }
            range.selectNode(nodeSelection);
            ViperSelection.addRange(range);
            this.viper.fireSelectionChanged(range, true);
          } else {
            var bookmark = this.viper.createBookmark();
            var elems = ViperUtil.getElementsBetween(bookmark.start, bookmark.end);
            ViperUtil.walk(
              bookmark.start,
              function(elem2) {
                if (elem2.nodeType === ViperUtil.ELEMENT_NODE && ViperUtil.isTag(elem2, "a") === true) {
                  var nextSibling = elem2.firstChild;
                  while (elem2.lastChild) {
                    ViperUtil.insertAfter(elem2, elem2.lastChild);
                  }
                  ViperUtil.remove(elem2);
                  return nextSibling;
                }
              },
              bookmark.end
            );
            this.viper.selectBookmark(bookmark);
            this.viper.fireSelectionChanged(null, true);
          }
          this.viper.contentChanged(true);
        },
        getLinkFromRange: function(range) {
          range = range || this.viper.getViperRange();
          var selectedNode = range.getNodeSelection();
          var common = range.getCommonElement();
          if (selectedNode && ViperUtil.isTag(selectedNode, "a") === true) {
            return selectedNode;
          }
          var viperElem = this.viper.getViperElement();
          while (common) {
            if (ViperUtil.isTag(common, "a") === true) {
              return common;
            } else if (common === viperElem || ViperUtil.isBlockElement(common) === true) {
              break;
            }
            common = common.parentNode;
          }
          return null;
        },
        selectionHasLinks: function(range) {
          range = range || this.viper.getViperRange();
          if (range.collapsed === true) {
            return false;
          }
          var nodeSelection = range.getNodeSelection();
          if (nodeSelection) {
            if (ViperUtil.getTag("a", nodeSelection).length > 0) {
              return true;
            }
            return false;
          }
          var contents = range.getHTMLContents();
          if (contents.toLowerCase().indexOf("<a ") >= 0) {
            return true;
          }
          return false;
        },
        getToolbarContent: function(idPrefix) {
          var self = this;
          var tools = this.viper.Tools;
          var url = tools.createTextbox(idPrefix + ":url", _("URL"), "", null, true);
          var title = tools.createTextbox(idPrefix + ":title", _("Title"), "");
          var subject = tools.createTextbox(idPrefix + ":subject", _("Subject"), "");
          var newWindow = tools.createCheckbox(idPrefix + ":newWindow", _("Open a New Window"));
          var urlRow = tools.createRow(idPrefix + ":urlRow", "Viper-urlRow");
          urlRow.appendChild(url);
          var titleRow = tools.createRow(idPrefix + ":titleRow", "Viper-titleRow");
          titleRow.appendChild(title);
          var subjectRow = tools.createRow(idPrefix + ":subjectRow", "Viper-subjectRow");
          subjectRow.appendChild(subject);
          var newWindowRow = tools.createRow(idPrefix + ":newWindowRow", "Viper-newWindowRow");
          newWindowRow.appendChild(newWindow);
          var main = document.createElement("div");
          main.appendChild(urlRow);
          main.appendChild(titleRow);
          main.appendChild(subjectRow);
          main.appendChild(newWindowRow);
          var subSectionElem = this.viper.Tools.getItem(idPrefix + ":link").element;
          ViperUtil.addClass(subSectionElem, "Viper-externalLink");
          this.viper.registerCallback("ViperTools:changed:" + idPrefix + ":url", "ViperLinkPlugin", function() {
            var urlValue = ViperUtil.trim(tools.getItem(idPrefix + ":url").getValue());
            if (urlValue.toLowerCase().indexOf("mailto:") === 0 || self.isEmail(urlValue) === true) {
              ViperUtil.removeClass(subSectionElem, "Viper-externalLink");
              ViperUtil.addClass(subSectionElem, "Viper-emailLink");
            } else {
              ViperUtil.removeClass(subSectionElem, "Viper-emailLink");
              ViperUtil.addClass(subSectionElem, "Viper-externalLink");
            }
          });
          return main;
        },
        initInlineToolbar: function() {
          var self = this;
          this.viper.registerCallback("ViperInlineToolbarPlugin:initToolbar", "ViperLinkPlugin", function(toolbar) {
            self._inlineToolbar = toolbar;
            self.createInlineToolbar(toolbar);
          });
          this.viper.registerCallback("ViperInlineToolbarPlugin:updateToolbar", "ViperLinkPlugin", function(data) {
            var selectionHasLinks = self.selectionHasLinks(data.range);
            if (selectionHasLinks !== true && self.showInlineToolbarIcons(data) === true) {
              self.updateInlineToolbar(data);
            } else if (selectionHasLinks === true) {
              self.updateInlineToolbar(data, true);
            }
          });
        },
        createInlineToolbar: function(toolbar) {
          var self = this;
          var main = document.createElement("div");
          toolbar.addKeepOpenTag("a");
          toolbar.makeSubSection("ViperLinkPlugin:vitp:link", main, function() {
            var range = self.viper.getViperRange();
            var node = self.getLinkFromRange(range);
            if (node) {
              range.selectNode(node);
              ViperSelection.addRange(range);
              self.viper.fireSelectionChanged(range);
            }
          });
          var insertLinkBtn = this.viper.Tools.createButton("vitpInsertLink", "", _("Toggle Link Options"), "Viper-link");
          var removeLinkBtn = this.viper.Tools.createButton(
            "vitpRemoveLink",
            "",
            _("Remove Link"),
            "Viper-linkRemove",
            function() {
              var range = self.viper.getViperRange();
              var link = self.getLinkFromRange(range);
              if (!link) {
                self.removeLinks();
              } else {
                self.removeLink(link);
              }
            }
          );
          var btnGroup = this.viper.Tools.createButtonGroup("ViperLinkPlugin:vitpButtons");
          this.viper.Tools.addButtonToGroup("vitpInsertLink", "ViperLinkPlugin:vitpButtons");
          this.viper.Tools.addButtonToGroup("vitpRemoveLink", "ViperLinkPlugin:vitpButtons");
          toolbar.addButton(btnGroup);
          toolbar.setSubSectionButton("vitpInsertLink", "ViperLinkPlugin:vitp:link");
          main.appendChild(this.getToolbarContent("ViperLinkPlugin:vitp"));
          toolbar.setSubSectionAction(
            "ViperLinkPlugin:vitp:link",
            function() {
              self.updateLink("ViperLinkPlugin:vitp");
            },
            [
              "ViperLinkPlugin:vitp:url",
              "ViperLinkPlugin:vitp:title",
              "ViperLinkPlugin:vitp:newWindow",
              "ViperLinkPlugin:vitp:subject"
            ]
          );
        },
        updateInlineToolbar: function(data, removeLinkOnly) {
          if (removeLinkOnly === true) {
            data.toolbar.showButton("vitpRemoveLink");
            return;
          }
          var link = this.getLinkFromRange(data.range);
          if (link || this.selectionHasLinks(data.range) === true) {
            if (link) {
              this.viper.Tools.setButtonActive("vitpInsertLink");
              this.updateInlineToolbarFields(link);
            } else {
              this.updateInlineToolbarFields();
            }
            data.toolbar.showButton("vitpInsertLink");
            data.toolbar.showButton("vitpRemoveLink");
          } else {
            data.toolbar.showButton("vitpInsertLink");
            this.updateInlineToolbarFields(link);
          }
        },
        showInlineToolbarIcons: function(data) {
          var inlineToolbarPlugin = this.viper.PluginManager.getPlugin("ViperInlineToolbarPlugin");
          var self = this;
          var range = this.viper.getCurrentRange();
          var currentIsLink = false;
          var startNode = null;
          var endNode = null;
          var nodeSelection = range.getNodeSelection();
          if (nodeSelection) {
            startNode = nodeSelection;
            endNode = startNode;
          } else {
            startNode = range.getStartNode();
            endNode = range.getEndNode();
          }
          if (startNode && endNode && ViperUtil.getFirstBlockParent(startNode) !== ViperUtil.getFirstBlockParent(endNode)) {
            return false;
          }
          if (ViperUtil.isTag(data.lineage[data.current], "a") === true) {
            currentIsLink = true;
          }
          if (currentIsLink !== true && (data.lineage[data.current].nodeType !== ViperUtil.TEXT_NODE || ViperUtil.isTag(data.lineage[data.current].parentNode, "a") === false) && range.collapsed === true) {
            if (range.collapsed === true && data.lineage[data.current].nodeType === ViperUtil.TEXT_NODE) {
              var parents = ViperUtil.getParents(data.lineage[data.current].parentNode, "a", this.viper.getViperElement());
              if (parents.length > 0 || range.startOffset === 0 && range.startContainer.previousSibling && ViperUtil.isTag(range.startContainer.previousSibling, "a") === true) {
                return true;
              } else if (range.collapsed === true && range.startOffset === 0 && range.startContainer.previousSibling && (ViperUtil.isTag(range.startContainer.previousSibling, "a") === true || ViperUtil.inArray("a", ViperUtil.getSurroundedChildren(range.startContainer.previousSibling, true)) === true)) {
                return true;
              }
            } else if (range.collapsed === true && range.startContainer.nodeType === ViperUtil.ELEMENT_NODE && range.startOffset >= range.startContainer.childNodes.length && ViperUtil.isTag(range.startContainer.childNodes[range.startOffset - 1], "a") === true) {
              return true;
            }
            return false;
          }
          return true;
        },
        initToolbar: function() {
          var toolbar = this.viper.PluginManager.getPlugin("ViperToolbarPlugin");
          if (!toolbar) {
            return;
          }
          var tools = this.viper.Tools;
          var btnGroup = tools.createButtonGroup("ViperLinkPlugin:vtp:btnGroup");
          var disabled = true;
          var self = this;
          tools.createButton("insertLink", "", _("Toggle Link Options"), "Viper-link", null, disabled);
          tools.createButton(
            "removeLink",
            "",
            _("Remove Link"),
            "Viper-linkRemove",
            function() {
              if (self.selectionHasLinks() === true) {
                self.removeLinks();
              } else {
                var link = self.getLinkFromRange();
                self.removeLink(link);
              }
            },
            disabled
          );
          tools.addButtonToGroup("insertLink", "ViperLinkPlugin:vtp:btnGroup");
          tools.addButtonToGroup("removeLink", "ViperLinkPlugin:vtp:btnGroup");
          toolbar.addButton(btnGroup);
          var main = document.createElement("div");
          toolbar.createBubble("ViperLinkPlugin:vtp:link", _("Insert Link"), main, null, function() {
            var range = self.viper.getViperRange();
            var node = self.getLinkFromRange(range);
            if (node) {
              range.selectNode(node);
              ViperSelection.addRange(range);
              self.viper.fireSelectionChanged(range);
            }
          });
          main.appendChild(this.getToolbarContent("ViperLinkPlugin:vtp"));
          toolbar.setBubbleButton("ViperLinkPlugin:vtp:link", "insertLink");
          tools.getItem("ViperLinkPlugin:vtp:link").setSubSectionAction(
            "ViperLinkPlugin:vtp:linkSubSection",
            function() {
              self.updateLink("ViperLinkPlugin:vtp");
            },
            [
              "ViperLinkPlugin:vtp:url",
              "ViperLinkPlugin:vtp:title",
              "ViperLinkPlugin:vtp:newWindow",
              "ViperLinkPlugin:vtp:subject"
            ]
          );
          this.viper.registerCallback("ViperToolbarPlugin:updateToolbar", "ViperLinkPlugin", function(data) {
            var range = data.range;
            if (self.viper.rangeInViperBounds(range) === false) {
              return;
            }
            var selectionHasLinks = self.selectionHasLinks(range);
            if (selectionHasLinks === true) {
              tools.setButtonInactive("insertLink");
              tools.disableButton("insertLink");
              tools.enableButton("removeLink");
              return;
            }
            var link = self.getLinkFromRange(range);
            if (link) {
              tools.setButtonActive("insertLink");
              tools.enableButton("removeLink");
              self.updateBubbleFields(link);
            } else {
              var nodeSelection = self.viper.getNodeSelection();
              var startNode = null;
              var endNode = null;
              if (nodeSelection) {
                startNode = nodeSelection;
                endNode = nodeSelection;
              } else {
                startNode = data.range.getStartNode();
                endNode = data.range.getEndNode();
              }
              tools.setButtonInactive("insertLink");
              if (range.collapsed === true || startNode && endNode && ViperUtil.getFirstBlockParent(startNode) !== ViperUtil.getFirstBlockParent(endNode)) {
                tools.disableButton("insertLink");
                toolbar.closeBubble("ViperLinkPlugin:vtp:link");
              } else {
                if (nodeSelection && nodeSelection.nodeType === ViperUtil.ELEMENT_NODE && ViperUtil.inArray(ViperUtil.getTagName(nodeSelection), "tr,table,thead,tfoot".split(","))) {
                  tools.disableButton("insertLink");
                } else {
                  tools.enableButton("insertLink");
                }
              }
              tools.disableButton("removeLink");
              self.updateBubbleFields();
            }
          });
        },
        updateBubbleFields: function(link) {
          var href = "";
          var title = "";
          var subject = "";
          var newWindow = false;
          var isEmailLink = false;
          var tools = this.viper.Tools;
          if (link) {
            href = this.viper.getAttribute(link, "href");
            title = this.viper.getAttribute(link, "title");
            if (link.getAttribute("target") === "_blank") {
              newWindow = true;
            }
            if (href) {
              if (href.indexOf("mailto:") === 0) {
                isEmailLink = true;
                var subjIndex = href.indexOf("?subject=");
                if (subjIndex >= 0) {
                  subject = href.substr(subjIndex + 9);
                  href = href.substr(0, subjIndex);
                }
                href = href.replace(/\s*mailto:\s*/i, "");
              }
            }
            tools.getItem("ViperLinkPlugin:vtp:linkSubSection").setActionButtonTitle(_("Update Link"));
          } else {
            tools.getItem("ViperLinkPlugin:vtp:linkSubSection").setActionButtonTitle(_("Insert Link"));
          }
          var main = this.viper.Tools.getItem("ViperLinkPlugin:vtp:link").element;
          if (isEmailLink === true) {
            ViperUtil.addClass(main, "Viper-emailLink");
            ViperUtil.removeClass(main, "Viper-externalLink");
          } else {
            ViperUtil.addClass(main, "Viper-externalLink");
            ViperUtil.removeClass(main, "Viper-emailLink");
          }
          tools.getItem("ViperLinkPlugin:vtp:url").setValue(href || "");
          tools.getItem("ViperLinkPlugin:vtp:title").setValue(title || "");
          tools.getItem("ViperLinkPlugin:vtp:subject").setValue(decodeURIComponent(subject) || "");
          tools.getItem("ViperLinkPlugin:vtp:newWindow").setValue(newWindow);
        },
        updateInlineToolbarFields: function(link) {
          var href = "";
          var title = "";
          var subject = "";
          var newWindow = false;
          var isEmailLink = false;
          var tools = this.viper.Tools;
          if (link) {
            href = this.viper.getAttribute(link, "href");
            title = this.viper.getAttribute(link, "title");
            if (link.getAttribute("target") === "_blank") {
              newWindow = true;
            }
            if (href) {
              if (href.indexOf("mailto:") === 0) {
                isEmailLink = true;
                var subjIndex = href.indexOf("?subject=");
                if (subjIndex >= 0) {
                  subject = href.substr(subjIndex + 9);
                  href = href.substr(0, subjIndex);
                }
                href = href.replace(/\s*mailto:\s*/i, "");
              }
            }
            tools.getItem("ViperLinkPlugin:vitp:link").setActionButtonTitle(_("Update Link"));
          } else {
            tools.getItem("ViperLinkPlugin:vitp:link").setActionButtonTitle(_("Insert Link"));
          }
          var main = this.viper.Tools.getItem("ViperLinkPlugin:vitp:link").element;
          if (isEmailLink === true) {
            ViperUtil.addClass(main, "Viper-emailLink");
            ViperUtil.removeClass(main, "Viper-externalLink");
          } else {
            ViperUtil.addClass(main, "Viper-externalLink");
            ViperUtil.removeClass(main, "Viper-emailLink");
          }
          tools.getItem("ViperLinkPlugin:vitp:url").setValue(href || "");
          tools.getItem("ViperLinkPlugin:vitp:title").setValue(title || "");
          tools.getItem("ViperLinkPlugin:vitp:subject").setValue(decodeURIComponent(subject) || "");
          tools.getItem("ViperLinkPlugin:vitp:newWindow").setValue(newWindow);
        }
      };
    };
  }
});

// src/Plugins/ViperSourceViewPlugin/jsbeautifier.js
var StyleHTML;
var init_jsbeautifier = __esm({
  "src/Plugins/ViperSourceViewPlugin/jsbeautifier.js"() {
    "use strict";
    StyleHTML = (html_source, indent_size, indent_character, max_char, brace_style) => {
      var multi_parser;
      function Parser() {
        this.pos = 0;
        this.token = "";
        this.current_mode = "CONTENT";
        this.tags = {
          //An object to hold tags, their position, and their parent-tags, initiated with default values
          parent: "parent1",
          parentcount: 1,
          parent1: ""
        };
        this.tag_type = "";
        this.token_text = this.last_token = this.last_text = this.token_type = "";
        this.Utils = {
          //Uilities made available to the various functions
          whitespace: "\n\r	 ".split(""),
          single_token: "br,input,link,meta,!doctype,basefont,base,area,hr,wbr,param,img,isindex,?xml,embed".split(","),
          //all the single tags for HTML
          extra_liners: "head,body,/html".split(","),
          //for tags that need a line of whitespace before them
          in_array: function(what, arr) {
            for (var i = 0; i < arr.length; i++) {
              if (what === arr[i]) {
                return true;
              }
            }
            return false;
          }
        };
        this.get_content = function() {
          var input_char = "";
          var content = [];
          var space = false;
          while (this.input.charAt(this.pos) !== "<") {
            if (this.pos >= this.input.length) {
              return content.length ? content.join("") : ["", "TK_EOF"];
            }
            input_char = this.input.charAt(this.pos);
            this.pos++;
            this.line_char_count++;
            if (this.Utils.in_array(input_char, this.Utils.whitespace)) {
              if (content.length || input_char === " ") {
                space = true;
              }
              this.line_char_count--;
              continue;
            } else if (space) {
              if (this.line_char_count >= this.max_char) {
                content.push("\n");
                for (var i = 0; i < this.indent_level; i++) {
                  content.push(this.indent_string);
                }
                this.line_char_count = 0;
              } else {
                content.push(" ");
                this.line_char_count++;
              }
              space = false;
            }
            content.push(input_char);
          }
          if (space === true) {
            content.push(input_char);
            space = false;
          }
          return content.length ? content.join("") : "";
        };
        this.get_script = function() {
          var input_char = "";
          var content = [];
          var reg_match = new RegExp("</script>", "igm");
          reg_match.lastIndex = this.pos;
          var reg_array = reg_match.exec(this.input);
          var end_script = reg_array ? reg_array.index : this.input.length;
          while (this.pos < end_script) {
            if (this.pos >= this.input.length) {
              return content.length ? content.join("") : ["", "TK_EOF"];
            }
            input_char = this.input.charAt(this.pos);
            this.pos++;
            content.push(input_char);
          }
          return content.length ? content.join("") : "";
        };
        this.record_tag = function(tag) {
          if (this.tags[tag + "count"]) {
            this.tags[tag + "count"]++;
            this.tags[tag + this.tags[tag + "count"]] = this.indent_level;
          } else {
            this.tags[tag + "count"] = 1;
            this.tags[tag + this.tags[tag + "count"]] = this.indent_level;
          }
          this.tags[tag + this.tags[tag + "count"] + "parent"] = this.tags.parent;
          this.tags.parent = tag + this.tags[tag + "count"];
        };
        this.retrieve_tag = function(tag) {
          if (this.tags[tag + "count"]) {
            var temp_parent = this.tags.parent;
            while (temp_parent) {
              if (tag + this.tags[tag + "count"] === temp_parent) {
                break;
              }
              temp_parent = this.tags[temp_parent + "parent"];
            }
            if (temp_parent) {
              this.indent_level = this.tags[tag + this.tags[tag + "count"]];
              this.tags.parent = this.tags[temp_parent + "parent"];
            }
            delete this.tags[tag + this.tags[tag + "count"] + "parent"];
            delete this.tags[tag + this.tags[tag + "count"]];
            if (this.tags[tag + "count"] == 1) {
              delete this.tags[tag + "count"];
            } else {
              this.tags[tag + "count"]--;
            }
          }
        };
        this.get_tag = function() {
          var input_char = "";
          var content = [];
          var space = false;
          do {
            if (this.pos >= this.input.length) {
              return content.length ? content.join("") : ["", "TK_EOF"];
            }
            input_char = this.input.charAt(this.pos);
            this.pos++;
            this.line_char_count++;
            if (this.Utils.in_array(input_char, this.Utils.whitespace)) {
              space = true;
              this.line_char_count--;
              continue;
            }
            if (input_char === "'" || input_char === '"') {
              if (!content[1] || content[1] !== "!") {
                input_char += this.get_unformatted(input_char);
                space = true;
              }
            }
            if (input_char === "=") {
              space = false;
            }
            if (content.length && content[content.length - 1] !== "=" && input_char !== ">" && space) {
              if (this.line_char_count >= this.max_char) {
                this.print_newline(false, content);
                this.line_char_count = 0;
              } else {
                content.push(" ");
                this.line_char_count++;
              }
              space = false;
            }
            content.push(input_char);
          } while (input_char !== ">");
          var tag_complete = content.join("");
          var tag_index;
          if (tag_complete.indexOf(" ") != -1) {
            tag_index = tag_complete.indexOf(" ");
          } else {
            tag_index = tag_complete.indexOf(">");
          }
          var tag_check = tag_complete.substring(1, tag_index).toLowerCase();
          if (tag_complete.charAt(tag_complete.length - 2) === "/" || this.Utils.in_array(tag_check, this.Utils.single_token)) {
            this.tag_type = "SINGLE";
          } else if (tag_check === "script") {
            this.record_tag(tag_check);
            this.tag_type = "SCRIPT";
          } else if (tag_check === "style") {
            this.record_tag(tag_check);
            this.tag_type = "STYLE";
          } else if (tag_check === "a") {
            var comment = this.get_unformatted("</a>", tag_complete);
            content.push(comment);
            this.tag_type = "INLINE";
          } else if ("|pre|strong|em|i|sub|sup|u|strike|span|".indexOf("|" + tag_check + "|") >= 0) {
            content.push(this.get_unformatted("</" + tag_check + ">"));
            this.tag_type = "INLINE";
          } else if (tag_check.charAt(0) === "!") {
            if (tag_check.indexOf("[if") != -1) {
              if (tag_complete.indexOf("!IE") != -1) {
                var comment = this.get_unformatted("-->", tag_complete);
                content.push(comment);
              }
              this.tag_type = "START";
            } else if (tag_check.indexOf("[endif") != -1) {
              this.tag_type = "END";
              this.unindent();
            } else if (tag_check.indexOf("[cdata[") != -1) {
              var comment = this.get_unformatted("]]>", tag_complete);
              content.push(comment);
              this.tag_type = "SINGLE";
            } else {
              var comment = this.get_unformatted("-->", tag_complete);
              content.push(comment);
              this.tag_type = "SINGLE";
            }
          } else {
            if (tag_check.charAt(0) === "/") {
              this.retrieve_tag(tag_check.substring(1));
              this.tag_type = "END";
            } else {
              this.record_tag(tag_check);
              this.tag_type = "START";
            }
            if (this.Utils.in_array(tag_check, this.Utils.extra_liners)) {
              this.print_newline(true, this.output);
            }
          }
          return content.join("");
        };
        this.get_unformatted = function(delimiter, orig_tag) {
          if (orig_tag && orig_tag.indexOf(delimiter) != -1) {
            return "";
          }
          var input_char = "";
          var content = "";
          var space = true;
          do {
            if (this.pos >= this.input.length) {
              return content;
            }
            input_char = this.input.charAt(this.pos);
            this.pos++;
            if (delimiter === "</pre>") {
              content += input_char;
              continue;
            }
            if (this.Utils.in_array(input_char, this.Utils.whitespace)) {
              if (!space) {
                this.line_char_count--;
                continue;
              }
              if (input_char === "\n" || input_char === "\r") {
                content += "\n";
                for (var i = 0; i < this.indent_level; i++) {
                  content += this.indent_string;
                }
                space = false;
                this.line_char_count = 0;
                continue;
              }
            }
            content += input_char;
            this.line_char_count++;
            space = true;
          } while (content.indexOf(delimiter) == -1);
          return content;
        };
        this.get_token = function() {
          var token;
          if (this.last_token === "TK_TAG_SCRIPT") {
            var temp_token = this.get_script();
            if (typeof temp_token !== "string") {
              return temp_token;
            }
            token = StyleHTML(temp_token, {
              indent_size: this.indent_size,
              indent_char: this.indent_character,
              indent_level: this.indent_level,
              brace_style: this.brace_style
            });
            return [token, "TK_CONTENT"];
          }
          if (this.current_mode === "CONTENT") {
            token = this.get_content();
            if (typeof token !== "string") {
              return token;
            } else {
              return [token, "TK_CONTENT"];
            }
          }
          if (this.current_mode === "TAG") {
            token = this.get_tag();
            if (typeof token !== "string") {
              return token;
            } else {
              var tag_name_type = "TK_TAG_" + this.tag_type;
              return [token, tag_name_type];
            }
          }
        };
        this.printer = function(js_source, indent_character2, indent_size2, max_char2, brace_style2) {
          this.input = js_source || "";
          this.output = [];
          this.indent_character = indent_character2 || " ";
          this.indent_string = "";
          this.indent_size = indent_size2 || 2;
          this.brace_style = brace_style2 || "collapse";
          this.indent_level = 0;
          this.max_char = max_char2 || 70;
          this.line_char_count = 0;
          for (var i = 0; i < this.indent_size; i++) {
            this.indent_string += this.indent_character;
          }
          this.print_newline = function(ignore, arr) {
            this.line_char_count = 0;
            if (!arr || !arr.length) {
              return;
            }
            if (!ignore) {
              while (this.Utils.in_array(arr[arr.length - 1], this.Utils.whitespace)) {
                arr.pop();
              }
            }
            arr.push("\n");
            for (var i2 = 0; i2 < this.indent_level; i2++) {
              arr.push(this.indent_string);
            }
          };
          this.print_token = function(text) {
            this.output.push(text);
          };
          this.indent = function() {
            this.indent_level++;
          };
          this.unindent = function() {
            if (this.indent_level > 0) {
              this.indent_level--;
            }
          };
        };
        return this;
      }
      multi_parser = new Parser();
      multi_parser.printer(html_source, indent_character, indent_size, 300, brace_style);
      while (true) {
        var t = multi_parser.get_token();
        multi_parser.token_text = t[0];
        multi_parser.token_type = t[1];
        if (multi_parser.token_type === "TK_EOF") {
          break;
        }
        switch (multi_parser.token_type) {
          case "TK_TAG_START":
          case "TK_TAG_SCRIPT":
          case "TK_TAG_STYLE":
            multi_parser.print_newline(false, multi_parser.output);
            multi_parser.print_token(multi_parser.token_text);
            multi_parser.indent();
            multi_parser.current_mode = "CONTENT";
            break;
          case "TK_TAG_END":
            multi_parser.print_newline(true, multi_parser.output);
            multi_parser.print_token(multi_parser.token_text);
            multi_parser.current_mode = "CONTENT";
            break;
          case "TK_TAG_SINGLE":
            multi_parser.print_token(multi_parser.token_text);
            multi_parser.current_mode = "CONTENT";
            break;
          // --> SQUIZ
          case "TK_TAG_INLINE":
            multi_parser.print_token(multi_parser.token_text);
            multi_parser.current_mode = "CONTENT";
            break;
          // -- SQUIZ
          case "TK_CONTENT":
            if (multi_parser.token_text !== "") {
              if (multi_parser.last_token !== "TK_TAG_INLINE" && multi_parser.last_token !== "TK_TAG_SINGLE") {
                multi_parser.print_newline(false, multi_parser.output);
              }
              multi_parser.print_token(multi_parser.token_text);
            }
            multi_parser.current_mode = "TAG";
            break;
        }
        multi_parser.last_token = multi_parser.token_type;
        multi_parser.last_text = multi_parser.token_text;
      }
      return multi_parser.output.join("");
    };
  }
});

// src/Plugins/ViperSourceViewPlugin/theme.js
var themeViper;
var init_theme = __esm({
  "src/Plugins/ViperSourceViewPlugin/theme.js"() {
    "use strict";
    themeViper = {
      isDark: false,
      cssClass: "ace-chrome",
      cssText: ""
    };
  }
});

// src/Plugins/ViperSourceViewPlugin/ViperSourceViewPlugin.js
var ViperSourceViewPlugin_exports = {};
__export(ViperSourceViewPlugin_exports, {
  registerPlugin: () => registerPlugin19
});
var import_ace_code, searchbox, import_html, registerPlugin19;
var init_ViperSourceViewPlugin = __esm({
  "src/Plugins/ViperSourceViewPlugin/ViperSourceViewPlugin.js"() {
    "use strict";
    import_ace_code = require("ace-code");
    searchbox = __toESM(require("ace-code/src/ext/searchbox.js"));
    import_html = require("ace-code/src/mode/html.js");
    init_jsbeautifier();
    init_theme();
    import_ace_code.config.setLoader((moduleName, afterLoad) => {
      const modules = {
        "ace/theme/viper": themeViper,
        "ace/ext/searchbox": searchbox
      };
      if (moduleName in modules) {
        afterLoad(null, modules[moduleName]);
      } else {
        afterLoad(new Error(`Cannot load module "${moduleName}". It has not been configured in the loader.`), null);
      }
    });
    registerPlugin19 = (Viper2) => {
      const { Util: ViperUtil, _ } = Viper2;
      function ViperSourceViewPlugin(viper) {
        this.viper = viper;
        this._editor = null;
        this._textEditor = null;
        this._resizeHandle = null;
        this._sourceView = null;
        this._sourceCont = null;
        this._closeConfirm = null;
        this._isVisible = false;
        this._originalSource = null;
        this._inNewWindow = false;
        this._ignoreUpdate = false;
        this._ignoreSourceUpdate = false;
        this._newWindowContents = "";
        this._jqueryURL = null;
        this._containerid = null;
        this._toolbarButtonToggles = false;
        this._aceTheme = "ace/theme/viper";
        this._base64Images = {};
        this._keepScrollAttr = false;
        this._aceMarkers = [];
      }
      Viper2.PluginManager.addPlugin("ViperSourceViewPlugin", ViperSourceViewPlugin);
      ViperSourceViewPlugin.prototype = {
        init: function() {
          var self = this;
          this.aceStylesManager = {
            legacyStyles: null,
            newStyles: null,
            swapToNewStyles() {
              if (!window.ace) return;
              const _legacy = document.querySelector('style[id="ace_editor.css"]');
              if (_legacy && !this.legacyStyles) {
                this.legacyStyles = _legacy;
                _legacy.remove();
              }
              if (this.newStyles) {
                _legacy?.remove();
                document.head.appendChild(this.newStyles);
              }
            },
            swapToLegacyStyles() {
              if (!window.ace) return;
              const _new = document.querySelector('style[id="ace_editor.css"]');
              if (_new && !this.newStyles) {
                this.newStyles = _new;
                _new.remove();
              }
              if (this.legacyStyles) {
                _new?.remove();
                document.head.appendChild(this.legacyStyles);
              }
            }
          };
          this.toolbarPlugin = this.viper.PluginManager.getPlugin("ViperToolbarPlugin");
          if (this.toolbarPlugin) {
            var toggle = this.viper.Tools.createButton(
              "sourceEditor",
              "",
              _("Toggle Source View"),
              "Viper-sourceView",
              function() {
                self.toggleSourceView();
              },
              true
            );
            this.toolbarPlugin.addButton(toggle);
            this.viper.registerCallback("ViperToolbarPlugin:enabled", "ViperSourceViewPlugin", function(data) {
              self.viper.Tools.enableButton("sourceEditor");
            });
            this.viper.registerCallback("ViperToolbarPlugin:updateToolbar", "ViperSourceViewPlugin", function(data) {
              self.viper.Tools.enableButton("sourceEditor");
            });
          }
          var updateTimer = null;
          this.viper.registerCallback("Viper:nodesChanged", "ViperSourceViewPlugin", function(nodes) {
            clearTimeout(updateTimer);
            if (self._ignoreSourceUpdate === true) {
              self._ignoreSourceUpdate = false;
              return;
            }
            updateTimer = setTimeout(function() {
              self.updateSourceContents();
            }, 250);
          });
          this.viper.registerCallback(
            ["Viper:editableElementChanged", "Viper:disabled"],
            "ViperSourceViewPlugin",
            function(nodes) {
              if (self._toolbarButtonToggles !== true) {
                self.hideSourceView();
              }
            }
          );
          this.viper.registerCallback("ViperToolbarPlugin:canEnableToolbar", "ViperSourceViewPlugin", function() {
            if (self._toolbarButtonToggles === true && self._isVisible === true) {
              self.toolbarPlugin.disable();
              return false;
            }
          });
          this.viper.registerCallback("ViperToolbarPlugin:disabled", "ViperSourceViewPlugin", function() {
            if (self._toolbarButtonToggles === true && self._isVisible === true) {
              self.viper.Tools.enableButton("sourceEditor");
              self.viper.Tools.setButtonActive("sourceEditor");
            }
          });
          this.viper.registerCallback("Viper:getHtml", "ViperSourceViewPlugin", function(data) {
            self._removeScrollAttribute(data.element);
          });
        },
        setSettings: function(settings) {
          if (settings.jqueryURL) {
            this._jqueryURL = settings.jqueryURL;
          }
          if (settings.parentid) {
            this._containerid = settings.parentid;
          }
          if (settings.toolbarButtonToggles) {
            this._toolbarButtonToggles = settings.toolbarButtonToggles;
          }
          if (settings.aceTheme) {
            this._aceTheme = settings.aceTheme;
          }
        },
        isSourceChanged: function() {
          var value = null;
          if (this._editor) {
            value = this._editor.getSession().getValue();
          } else if (this._textEditor) {
            value = this._textEditor.value;
          }
          if (this._originalSource === value) {
            return false;
          }
          return true;
        },
        showSourceView: function(content, callback) {
          var self = this;
          if (!this._sourceView) {
            this._createSourceView(function() {
              if (!content) {
                content = self.getContents();
              }
              self._originalSource = content;
              self.showSourceView(null, callback);
            });
          } else {
            if (!content) {
              content = this.getContents();
            } else {
              content = StyleHTML(content);
            }
            if (this._editor) {
              this.aceStylesManager.swapToNewStyles();
              this._ignoreUpdate = true;
              this._editor.getSession().setValue(content);
              this.scrollToText("__viper_scrollpos");
              self._removeScrollAttribute();
              self._editor.replaceAll("", { needle: ' __viper_scrollpos="true"' });
              self._originalSource = self._editor.getSession().getValue();
              if (!this._containerid) {
                self.viper.Tools.openPopup("VSVP:popup", 800, 600);
              } else if (this._toolbarButtonToggles === true) {
                this._isVisible = true;
                this.toolbarPlugin.disable();
              }
              this.viper.fireCallbacks("ViperSourceViewPlugin:showSourceView");
              setTimeout(function() {
                self._editor.resize();
                self._editor.focus();
                self._isVisible = true;
                self._setKeywordsReadonly();
              }, 50);
            } else {
              this._textEditor.value = content;
              this._originalSource = this._textEditor.value;
              this.viper.Tools.openPopup("VSVP:popup", 800, 600);
              this._textEditor.focus();
              this._isVisible = true;
            }
            if (callback) {
              callback.call(this);
            }
          }
        },
        _setKeywordsReadonly: function() {
          var editor = this._editor;
          for (var keyword in this._base64Images) {
            editor.$search.setOptions({ needle: keyword });
            const ranges = editor.$search.findAll(editor.session);
            this._createAnchorsForRanges(ranges);
          }
        },
        _createAnchorsForRanges: function(ranges) {
          var editor = this._editor;
          this._aceMarkers = [];
          for (var i = 0; i < ranges.length; i++) {
            var range = ranges[i];
            editor.session.addMarker(range, "ViperSourceViewPlugin-ace-keyword");
            range.start = editor.session.doc.createAnchor(range.start);
            range.end = editor.session.doc.createAnchor(range.end);
            this._aceMarkers.push(range);
          }
        },
        hideSourceView: function(newWindow) {
          if (this._inNewWindow === true && this._childWindow) {
            this._childWindow.close();
            this._inNewWindow = false;
            this._childWindow = false;
            ViperUtil.remove(this._sourceView);
            this._sourceView = null;
            this._editor = null;
          } else if (this._sourceView) {
            if (!this._containerid) {
              if (newWindow === true) {
                this.viper.Tools.closePopup("VSVP:popup", "discardChanges");
              } else {
                this.viper.Tools.closePopup("VSVP:popup");
              }
            }
            if (this._toolbarButtonToggles === true) {
              this._isVisible = false;
              this.updatePageContents();
              this.toolbarPlugin.enable();
              this.viper.Tools.setButtonInactive("sourceEditor");
            }
            this.viper.fireCallbacks("ViperSourceViewPlugin:hideSourceView");
          }
        },
        toggleSourceView: function() {
          if (!this._sourceView || !this._sourceView.parentNode || this._sourceView.nodeType !== ViperUtil.DOCUMENT_FRAGMENT_NODE && !this._containerid || ViperUtil.getElementWidth(this._sourceView) === 0) {
            this.showSourceView();
          } else {
            this.hideSourceView();
          }
        },
        updatePageContents: function(content) {
          var value = content;
          if (!value) {
            value = this.getSourceContents();
          }
          if (this._originalSource === value) {
            return;
          }
          value = this._convertBase64KeywordsToBase64SRC(value);
          this._base64Images = {};
          this.viper.setHtml(value);
          this.viper.fireSelectionChanged(null, true);
        },
        getSourceContents: function() {
          var value = "";
          if (this._editor) {
            value = this._editor.getSession().getValue();
          } else if (this._textEditor) {
            value = this._textEditor.value;
          }
          return value;
        },
        updateSourceContents: function(content) {
          if (!this._editor || this._isVisible !== true) {
            return;
          }
          this._ignoreUpdate = true;
          var value = content || this.getContents();
          if (this._editor) {
            this._editor.getSession().setValue(value);
          } else if (this._textEditor) {
            this._textEditor.value = value;
          }
        },
        updateOriginalSourceValue: function(content) {
          if (!content) {
            if (this._editor) {
              content = this._editor.getSession().getValue();
            } else if (this._textEditor) {
              content = this._textEditor.value;
            }
          }
          this._originalSource = content;
        },
        revertChanges: function() {
          this.viper.setHtml(this._originalSource);
        },
        _createSourceView: function(callback) {
          if (this._containerid) {
            this._sourceView = ViperUtil.getid(this._containerid);
            this._initAceEditor(this._sourceView, callback);
            return;
          }
          var self = this;
          var tools = this.viper.Tools;
          var content = document.createElement("div");
          var popupTop = document.createElement("div");
          ViperUtil.addClass(popupTop, "VSVP-confirmPanel");
          var discardButton = tools.createButton(
            "VSVP:discard",
            _("Discard"),
            _("Discard Changes"),
            "VSVP-confirmButton-discard",
            function() {
              self.viper.Tools.closePopup("VSVP:popup", "discardChanges");
            }
          );
          var applyButton = tools.createButton(
            "VSVP:apply",
            _("Apply Changes"),
            _("Apply Changes"),
            "VSVP-confirmButton-apply",
            function() {
              self.updatePageContents();
              self.viper.Tools.closePopup("VSVP:popup", "applyChanges");
            }
          );
          ViperUtil.setHtml(
            popupTop,
            '<div class="VSVP-confirmText">' + _("Would you like to apply your changes?") + "</div>"
          );
          popupTop.appendChild(applyButton);
          popupTop.appendChild(discardButton);
          this._closeConfirm = popupTop;
          var source = document.createElement("div");
          ViperUtil.addClass(source, "VSVP-source");
          content.appendChild(source);
          this._sourceCont = source;
          var popupBottom = document.createElement("div");
          ViperUtil.addClass(popupBottom, "VSVP-bottomPanel");
          var applyButtonBottom = tools.createButton(
            "VSVP:apply",
            _("Apply Changes"),
            _("Apply Changes"),
            "VSVP-bottomPanel-apply",
            function() {
              self.updatePageContents();
              self.viper.Tools.closePopup("VSVP:popup", "applyChanges");
            }
          );
          popupBottom.appendChild(applyButtonBottom);
          this._sourceView = tools.createPopup(
            "VSVP:popup",
            _("Source Editor"),
            popupTop,
            content,
            popupBottom,
            "VSVP-popup",
            true,
            true,
            null,
            function(closer) {
              if (closer !== "discardChanges" && closer !== "applyChanges") {
                if (self.isSourceChanged() === true) {
                  self.showCloseConfirm();
                  return false;
                }
              }
              self.viper.Tools.getItem("VSVP:popup").hideTop();
              self._closeEditor();
            },
            function() {
              if (self._editor) {
                self._editor.resize();
              }
            }
          );
          this._initAceEditor(source, callback);
        },
        _closeEditor: function() {
          var self = this;
          this.aceStylesManager.swapToLegacyStyles();
          this._removeScrollAttribute();
          this._isVisible = false;
          if (this.viper.isEnabled() !== false) {
            this.toolbarPlugin.enable();
            setTimeout(function() {
              self.viper.focus();
            }, 10);
          }
        },
        _initAceEditor: function(containerElement, callback) {
          var self = this;
          this.aceStylesManager.swapToNewStyles();
          var editor = (0, import_ace_code.edit)(containerElement);
          self._editor = editor;
          editor.$blockScrolling = Infinity;
          self.applyEditorSettings(editor);
          self.initEditorEvents(editor);
          callback.call(self);
        },
        applyEditorSettings: function(editor) {
          editor.setTheme(this._aceTheme);
          editor.getSession().setUseWorker(false);
          editor.getSession().setMode(new import_html.Mode());
          editor.getSession().setUseWrapMode(true);
          editor.renderer.setShowPrintMargin(false);
          editor.setHighlightActiveLine(true);
          editor.setShowInvisibles(true);
          editor.renderer.$textLayer.EOL_CHAR = String.fromCharCode(8629);
          editor.setSelectionStyle("line");
          editor.renderer.setHScrollBarAlwaysVisible(true);
          editor.getSession().setUseSoftTabs(true);
        },
        showCloseConfirm: function() {
          this.viper.Tools.getItem("VSVP:popup").showTop();
        },
        scrollToText: function(text) {
          var self = this;
          if (this._editor) {
            this._editor.find(text);
            setTimeout(function() {
              var anchor = self._editor.getSelection().getSelectionAnchor();
              self._editor.clearSelection();
              if (self._editor.isRowVisible(anchor.row) === false) {
                self._editor.scrollToRow(anchor.row);
              }
            }, 500);
          } else {
            var range = this._textEditor.createTextRange();
            if (range.findText(text) === true) {
              range.select();
              range.scrollIntoView();
            }
          }
        },
        replaceSelection: function(replacement) {
          if (this._editor) {
            this._editor.replace(replacement);
          } else {
            var selection = document.selection;
            selection.clear();
          }
        },
        initEditorEvents: function(editor) {
          var self = this;
          editor.on("change", function() {
            if (self._ignoreUpdate === true) {
              self._ignoreUpdate = false;
              return;
            } else if (self._inNewWindow === true) {
              self._ignoreSourceUpdate = true;
              self.updatePageContents();
            }
            self._setKeywordsReadonly();
            self.viper.fireCallbacks("ViperSourceViewPlugin:sourceChanged");
          });
          editor.addEventListener(
            "paste",
            function(e) {
              for (var i = 0; i < self._aceMarkers.length; i++) {
                var range = self._aceMarkers[i];
                if (editor.getSelectionRange().intersects(range) === true && editor.getSelectionRange().containsRange(range) === false) {
                  setTimeout(function() {
                    editor.undo();
                  }, 10);
                  return {
                    command: "null",
                    passEvent: false
                  };
                }
              }
            },
            true
          );
          var popup = self.viper.Tools.getItem("VSVP:popup");
          editor.keyBinding.addKeyboardHandler({
            handleKeyboard: function(data, hashId, keyString, keyCode, e) {
              if (!e) {
                return;
              }
              if (keyCode < 37 || keyCode > 40) {
                for (var i = 0; i < self._aceMarkers.length; i++) {
                  var range = self._aceMarkers[i];
                  if (editor.getSelectionRange().intersects(range) === true && editor.getSelectionRange().containsRange(range) === false) {
                    return {
                      command: "null",
                      passEvent: false
                    };
                  }
                }
              }
              if (!self._containerid) {
                if (keyString === "esc") {
                  self.viper.Tools.closePopup("VSVP:popup");
                } else if (e.metaKey !== true && e.ctrlKey !== true && e.which !== 16) {
                  popup.hideTop();
                }
              }
            }
          });
          var onFocus = editor.onFocus;
          editor.onFocus = function() {
            if (self._toolbarButtonToggles !== true) {
              if (self._inNewWindow !== true) {
                self.toolbarPlugin.disable();
              }
            }
            if (self.viper.isEnabled() === false) {
              self.viper.setEnabled(true);
            }
            onFocus.call(editor);
            if (!self._containerid) {
              setTimeout(function() {
                popup.hideTop();
              }, 200);
            }
          };
          editor.onBlur = function() {
            if (self._inNewWindow !== true && self.viper.isEnabled() === true) {
              self.toolbarPlugin.enable();
            }
          };
        },
        openInNewWindow: function() {
          this.hideSourceView(true);
          this.toolbarPlugin.enable();
          var viperid = "Viper-" + this.viper.getId() + "-ViperSVP";
          window[viperid] = this;
          var childWindow = window.open(
            "about:blank",
            _("Viper Source View"),
            "width=850,height=800,0,status=0,scrollbars=0"
          );
          this._isVisible = true;
          childWindow.document.write(this._getFrameContent(viperid));
          this._childWindow = childWindow;
          this._inNewWindow = true;
          var interval = null;
          var self = this;
          interval = setInterval(function() {
            if (!childWindow || childWindow.closed === true) {
              clearInterval(interval);
              self.hideSourceView();
            }
          }, 700);
        },
        getNewWindowContents: function() {
          return this._newWindowContents;
        },
        _getFrameContent: function(viperid) {
          var path = this.viper.getViperPath();
          var content = "";
          if (Viper2.build === true) {
            path = null;
          }
          this._newWindowContents = this.getSourceContents();
          content += '<!DOCTYPE html><html lang="en"><head>';
          content += '<meta charset="UTF-8"><meta http-equiv="X-UA-Compatible" content="IE=edge,chrome=1">';
          content += "<title>" + _("Viper Source View") + "</title>";
          content += '<style type="text/css" media="screen">body {overflow: hidden;}</style>';
          if (!path) {
            var viperPath = this.getViperURL();
            content += '<link href="' + viperPath + 'viper.css" media="screen" rel="stylesheet" />';
            if (this._jqueryURL !== null) {
              content += '<script src="' + this._jqueryURL + '" type="text/javascript" charset="utf-8"></script>';
            }
            content += '<script src="' + viperPath + 'viper.js" type="text/javascript" charset="utf-8"></script>';
          } else {
            content += '<link href="' + path + '/Css/viper_tools.css" media="screen" rel="stylesheet" />';
            content += '<link href="' + path + '/Plugins/ViperSourceViewPlugin/ViperSourceViewPlugin.css" media="screen" rel="stylesheet" />';
            content += '<script src="' + path + '/Plugins/ViperSourceViewPlugin/Ace/ace.js" type="text/javascript" charset="utf-8"></script>';
            content += '<script src="' + path + '/Plugins/ViperSourceViewPlugin/Ace/theme-viper.js" type="text/javascript" charset="utf-8"></script>';
            content += '<script src="' + path + '/Plugins/ViperSourceViewPlugin/Ace/mode-html.js" type="text/javascript" charset="utf-8"></script>';
          }
          content += "</head>";
          content += '<body id="ViperSourceViewPlugin-window" class="ViperSourceViewPlugin-window">';
          content += '<div class="Viper-popup Viper-themeDark VSVP-popup">';
          content += '<div class="VSVP-confirmPanel Viper-popup-top">';
          content += '<div class="VSVP-confirmText">' + _("Source code changes will be reflected in your edit preview window in real time.") + "</div>";
          content += '<div class="Viper-button" title="' + _("Revert Changes") + '" onclick="viperSVP.revertChanges();">' + _("Revert Changes") + "</div>";
          content += '<div class="Viper-button" title="' + _("Close Source View") + '" onclick="window.close();">' + _("Close Window") + "</div></div>";
          content += '<div class="Viper-popup-content"><pre id="editor"></pre></div></div>';
          content += "<script>";
          content += 'var viperid = "' + viperid + '";';
          content += "var viperSVP = window.opener[viperid];";
          content += 'var editor = ace.edit("editor");';
          content += "viperSVP.applyEditorSettings(editor);";
          content += "viperSVP.initEditorEvents(editor);";
          content += "viperSVP._editor = editor;";
          content += "viperSVP.updateSourceContents(viperSVP.getNewWindowContents());";
          content += 'var editorWrapper = document.getElementById("editor").parentNode;';
          content += 'window.onresize = function() {editorWrapper.style.height = (window.innerHeight - 55) + "px";};';
          content += "window.onresize();";
          content += "</script></body></html>";
          return content;
        },
        getViperURL: function() {
          var scripts = document.getElementsByTagName("script");
          var path = null;
          var c = scripts.length;
          for (var i = 0; i < c; i++) {
            if (scripts[i].src) {
              if (scripts[i].src.match(/\/viper\.js/)) {
                return scripts[i].src.replace(/\/viper.js.*/, "/");
              }
            }
          }
          return null;
        },
        getContents: function() {
          if (this._editor) {
            var range = this.viper.getViperRange();
            var node = range.getStartNode();
            if (node) {
              if (node.nodeType === ViperUtil.TEXT_NODE) {
                node = node.parentNode;
              }
              ViperUtil.attr(node, "__viper_scrollpos", "true");
            }
          }
          this._keepScrollAttr = true;
          var html = this.viper.getHtml(null, { emptyTableCellContent: "" });
          this._keepScrollAttr = false;
          var el = document.createElement("div");
          ViperUtil.setHtml(el, html);
          this._convertBase64ImagesToKeywords(el);
          html = ViperUtil.getHtml(el);
          if (typeof StyleHTML !== "undefined") {
            html = StyleHTML(html);
          }
          return html;
        },
        isPluginElement: function(element) {
          if (element !== this._sourceView && ViperUtil.isChildOf(element, this._sourceView) === false) {
            return false;
          }
          return true;
        },
        _removeScrollAttribute: function(elem) {
          if (this._keepScrollAttr === true) {
            return;
          }
          elem = elem || this.viper.getViperElement();
          var elems = ViperUtil.find(elem, "[__viper_scrollpos]");
          for (var i = 0; i < elems.length; i++) {
            ViperUtil.removeAttr(elems[i], "__viper_scrollpos");
          }
        },
        _convertBase64ImagesToKeywords: function(elem) {
          this._base64Images = {};
          var tags = ViperUtil.find(elem, '[src^="data:image/"]');
          for (var i = 0; i < tags.length; i++) {
            var alt = tags[i].alt;
            let key = alt ? tags[i].alt + ".base64" : "base64_image_" + (i + 1);
            this._base64Images[key] = tags[i].src;
            tags[i].src = key;
          }
        },
        _convertBase64KeywordsToBase64SRC: function(content) {
          for (var key in this._base64Images) {
            content = content.replace(new RegExp(key, "g"), this._base64Images[key]);
          }
          return content;
        }
      };
    };
  }
});

// src/Plugins/ViperImagePlugin/ViperImagePlugin.js
var ViperImagePlugin_exports = {};
__export(ViperImagePlugin_exports, {
  registerPlugin: () => registerPlugin20
});
var registerPlugin20;
var init_ViperImagePlugin = __esm({
  "src/Plugins/ViperImagePlugin/ViperImagePlugin.js"() {
    "use strict";
    registerPlugin20 = (Viper2) => {
      const { Util: ViperUtil, Selection: ViperSelection, _ } = Viper2;
      function ViperImagePlugin(viper) {
        this.viper = viper;
        this._previewBox = null;
        this._resizeImage = null;
        this._ieImageResize = null;
        this._resizeHandles = null;
        this._inlineToolbar = null;
        this._moveImage = null;
        this._initInlineToolbar();
      }
      Viper2.PluginManager.addPlugin("ViperImagePlugin", ViperImagePlugin);
      ViperImagePlugin.prototype = {
        init: function() {
          this.initTopToolbar();
          var self = this;
          this.viper.registerCallback("Viper:mouseDown", "ViperImagePlugin", function(e) {
            var target = ViperUtil.getMouseEventTarget(e);
            self._ieImageResize = null;
            if (ViperUtil.isTag(target, "img") === true) {
              ViperUtil.preventDefault(e);
              self.hideImageResizeHandles();
              self.showImageResizeHandles(target);
              self._cancelMove();
              self._updateToolbars(target);
              var range = self.viper.getViperRange();
              range.selectNode(target);
              ViperSelection.addRange(range);
              var toolbar = self.viper.PluginManager.getPlugin("ViperToolbarPlugin");
              if (toolbar && toolbar.isDisabled() === true) {
                toolbar.enable();
              }
              return false;
            } else {
              self._updateToolbars();
              return self.hideImageResizeHandles();
            }
          });
          this.viper.registerCallback("Viper:mouseUp", "ViperImagePlugin", function(e) {
            if (self.viper.isEnabled() !== true) {
              return;
            }
            var target = ViperUtil.getMouseEventTarget(e);
            if (ViperUtil.isTag(target, "img") === true && self.viper.isOutOfBounds(target) !== true) {
              self.hideImageResizeHandles();
              self.showImageResizeHandles(target);
              self._cancelMove();
              self._updateToolbars(target);
              var range = self.viper.getViperRange();
              range.selectNode(target);
              ViperSelection.addRange(range);
              self.viper.fireSelectionChanged(range, true);
            }
          });
          this.viper.registerCallback(["Viper:keyDown", "Viper:beforeDelete"], "ViperImagePlugin", function(e) {
            if (self._resizeImage && ViperUtil.isInputKey(e) && e.which !== 20 && e.which !== 16 && e.which !== 9) {
              self.hideImageResizeHandles();
            }
            if (e.which === 8 || e.which === 46) {
              var range = self.viper.getViperRange();
              if (range.getHTMLContentsObj().childNodes.length > 1) {
                return;
              }
              if (self._resizeImage) {
                if (self.removeImage(self._resizeImage) === true) {
                  self._updateToolbars();
                  self._inlineToolbar.hide();
                  return false;
                }
              }
              if (self._ieImageResize) {
                ViperUtil.remove(self._ieImageResize);
                self._ieImageResize = null;
                self.viper.contentChanged(true);
                return false;
              } else {
                var range = self.viper.getViperRange();
                var selectedNode = range.getNodeSelection();
                if (selectedNode) {
                  if (self.removeImage(selectedNode) === true) {
                    self._updateToolbars();
                    return false;
                  }
                }
              }
            }
          });
          this.viper.registerCallback("Viper:getHtml", "ViperImagePlugin", function(data) {
            var tags = ViperUtil.getClass("ui-resizable", data.element);
            for (var i = 0; i < tags.length; i++) {
              var parent = tags[i].parentNode;
              ViperUtil.removeClass(tags[i], "ui-resizable");
              ViperUtil.insertBefore(parent, tags[i]);
              self.hideImageResizeHandles();
              ViperUtil.remove(parent);
              if (!tags[i].getAttribute("style")) {
                tags[i].removeAttribute("style");
              }
              if (!tags[i].getAttribute("class")) {
                tags[i].removeAttribute("class");
              }
            }
          });
          this.viper.registerCallback("ViperToolbarPlugin:enabled", "ViperImagePlugin", function(data) {
            self.viper.Tools.enableButton("image");
          });
          this.viper.registerCallback("ViperCoreStylesPlugin:afterImageUpdate", "ViperImagePlugin", function(image) {
            self.showImageResizeHandles(image);
          });
          this.viper.registerCallback(
            [
              "ViperHistoryManager:beforeUndo",
              "Viper:clickedOutside",
              "ViperTools:popup:open",
              "ViperCoreStylesPlugin:beforeImageUpdate",
              "Viper:cut",
              "Viper:disabled"
            ],
            "ViperImagePlugin",
            function() {
              self.hideImageResizeHandles();
            }
          );
          this.viper.registerCallback("Viper:dropped", "ViperImagePlugin", function(data) {
            if (!data.dataTransfer.files) {
              return;
            }
            self.hideImageResizeHandles();
            var range = data.range;
            if (data.e.target && ViperUtil.isTag(data.e.target, "img") === true) {
              range.selectNode(data.e.target);
            }
            var bookmark = self.viper.createBookmark(range, null, "imageDrop");
            if (ViperUtil.isTag(bookmark.start.nextSibling, "img") === true && bookmark.start.nextSibling.nextSibling === bookmark.end) {
              ViperUtil.insertAfter(bookmark.end, bookmark.start.nextSibling);
            }
            for (var i = 0; i < data.dataTransfer.files.length; i++) {
              self.readDroppedImage(data.dataTransfer.files[i], function(image, file) {
                self.insertDroppedImage(image, range, file);
              });
            }
            if (data.dataTransfer.files.length > 0) {
              return false;
            }
          });
          this.viper.registerCallback("Viper:editableElementChanged", "ViperImagePlugin", function() {
            var elemDoc = self.viper.getViperElementDocument();
            if (elemDoc !== document) {
              ViperUtil.removeEvent(elemDoc.defaultView, "scroll.ViperImagePlugin");
              ViperUtil.addEvent(elemDoc.defaultView, "scroll.ViperImagePlugin", function(e) {
                if (self._resizeImage) {
                  self.showImageResizeHandles(self._resizeImage);
                }
              });
            }
          });
        },
        readDroppedImage: function(file, callback) {
          var self = this;
          var reader = new FileReader();
          reader.onload = function(event2) {
            var image = new Image();
            image.src = event2.target.result;
            callback.call(self, image, file);
          };
          reader.readAsDataURL(file);
        },
        insertDroppedImage: function(image, range, fileInfo) {
          fileInfo = fileInfo || {};
          range = range || this.viper.getViperRange();
          var alt = fileInfo.name || "";
          if (alt.length > 0) {
            alt = alt.replace(/\.\w+$/, "").replace(/[^a-z0-9]/gi, " ").replace(/\s+/g, " ");
            alt = ViperUtil.ucFirst(ViperUtil.trim(alt));
          }
          image.alt = alt;
          this._rangeToImage(range, image);
        },
        moveImage: function(image, range) {
          if (!range || !image) {
            return;
          }
          return this._rangeToImage(range, image, null, null, null, true);
        },
        rangeToImage: function(range, url, alt, title) {
          if (!range || !url) {
            return;
          }
          return this._rangeToImage(range, null, url, alt, title);
        },
        _rangeToImage: function(range, img, url, alt, title, isMoveAction) {
          this._resizeImage = null;
          range = range || this.viper.getViperRange();
          var selectedNode = range.getNodeSelection();
          if (ViperUtil.isBlockElement(selectedNode) === true && ViperUtil.isStubElement(selectedNode) === false) {
            ViperUtil.setHtml(selectedNode, "&nbsp");
            range.setStart(selectedNode.firstChild, 0);
            range.collapse(true);
            ViperSelection.addRange(range);
          }
          if (this.viper.rangeInViperBounds(range) === false) {
            range = this.viper.getViperRange();
          }
          var bookmark = this.viper.getBookmarkById("imageDrop") || this.viper.createBookmark(range);
          var elems = ViperUtil.getElementsBetween(bookmark.start, bookmark.end);
          if (elems.length === 1 && ViperUtil.isTag(elems[0], "img") === true) {
            ViperUtil.insertAfter(bookmark.end, elems[0]);
          } else {
            ViperUtil.remove(elems);
          }
          var newImage = false;
          if (!img) {
            newImage = true;
            img = document.createElement("img");
            this.viper.setAttribute(img, "src", url);
            if (alt !== null) {
              this.viper.setAttribute(img, "alt", alt, true);
            }
            if (title !== null && ViperUtil.trim(title).length !== 0) {
              this.viper.setAttribute(img, "title", title);
            }
          }
          if (isMoveAction === true) {
            var surroundingParents = ViperUtil.getSurroundingParents(img, null, null, this.viper.getViperElement());
            if (surroundingParents.length > 0) {
              var parent = null;
              while (parent = surroundingParents.pop()) {
                if (ViperUtil.isBlockElement(parent) === false) {
                  ViperUtil.insertBefore(bookmark.start, parent);
                  break;
                }
              }
              if (!parent) {
                if (bookmark.start.parentNode === img) {
                  this.viper.removeBookmark(bookmark, true);
                  this._cancelMove();
                  return;
                } else {
                  ViperUtil.insertBefore(bookmark.start, img);
                }
              }
            } else if (bookmark.start.parentNode === img) {
              this.viper.removeBookmark(bookmark, true);
              this._cancelMove();
              return;
            } else {
              ViperUtil.insertBefore(bookmark.start, img);
            }
          } else {
            ViperUtil.insertBefore(bookmark.start, img);
          }
          this.viper.removeBookmark(bookmark);
          ViperSelection.removeAllRanges();
          this.viper.contentChanged();
          return img;
        },
        removeImage: function(image) {
          if (image && ViperUtil.isTag(image, "img") === true) {
            this.hideImageResizeHandles();
            var node = null;
            var start = 0;
            if (image.nextSibling && image.nextSibling.nodeType === ViperUtil.TEXT_NODE) {
              node = image.nextSibling;
            } else if (image.previousSibling && image.previousSibling.nodeType === ViperUtil.TEXT_NODE) {
              node = image.previousSibling;
              start = node.data.length;
            } else if (image.parentNode && ViperUtil.isTag(image.parentNode, "a") === true) {
              if (image.parentNode.nextSibling && image.parentNode.nextSibling.nodeType === ViperUtil.TEXT_NODE) {
                node = image.parentNode.nextSibling;
              } else if (image.parentNode.previousSibling && image.parentNode.previousSibling.nodeType === ViperUtil.TEXT_NODE) {
                node = image.parentNode.previousSibling;
                start = image.parentNode.previousSibling.data.length;
              } else {
                node = document.createTextNode(" ");
                ViperUtil.insertAfter(image.parentNode, node);
              }
              ViperUtil.remove(image.parentNode);
            } else {
              node = document.createTextNode(" ");
              ViperUtil.insertAfter(image, node);
            }
            image.parentNode.removeChild(image);
            var range = this.viper.getViperRange();
            range.setStart(node, start);
            range.collapse(true);
            ViperSelection.addRange(range);
            this.viper.contentChanged();
            return true;
          }
          return false;
        },
        setImageAlt: function(image, alt, keepEmptyAttribute) {
          if (!image) {
            return;
          }
          this.viper.setAttribute(image, "alt", alt, keepEmptyAttribute);
        },
        setImageURL: function(image, url) {
          if (!image) {
            return;
          }
          this.viper.setAttribute(image, "src", url);
        },
        setImageTitle: function(image, title) {
          if (!image) {
            return;
          } else if (title === null) {
            image.removeAttribute("title");
          } else {
            this.viper.setAttribute(image, "title", title);
          }
        },
        initTopToolbar: function() {
          var toolbar = this.viper.PluginManager.getPlugin("ViperToolbarPlugin");
          if (!toolbar) {
            return;
          }
          var previewBox = document.createElement("div");
          ViperUtil.addClass(previewBox, "ViperITP-msgBox ViperImagePlugin-previewPanel");
          ViperUtil.setHtml(previewBox, "Loading preview");
          ViperUtil.setStyle(previewBox, "display", "none");
          this._previewBox = previewBox;
          var self = this;
          var tools = this.viper.Tools;
          var subContent = this._getToolbarContents("ViperImagePlugin");
          var imgTools = toolbar.createBubble("ViperImagePlugin:bubble", _("Insert Image"), subContent);
          tools.getItem("ViperImagePlugin:bubble").setSubSectionAction(
            "ViperImagePlugin:bubbleSubSection",
            function() {
              self._setImageAttributes("ViperImagePlugin");
            },
            [
              "ViperImagePlugin:urlInput",
              "ViperImagePlugin:altInput",
              "ViperImagePlugin:titleInput",
              "ViperImagePlugin:isDecorative"
            ]
          );
          subContent.appendChild(previewBox);
          var toggleImagePlugin = tools.createButton("image", "", _("Toggle Image Options"), "Viper-image", null, true);
          toolbar.addButton(toggleImagePlugin);
          toolbar.setBubbleButton("ViperImagePlugin:bubble", "image");
        },
        _getToolbarContents: function(prefix) {
          var self = this;
          var tools = this.viper.Tools;
          var createImageSubContent = document.createElement("div");
          var urlTextbox = null;
          var url = tools.createTextbox(prefix + ":urlInput", _("URL"), "", null, true);
          createImageSubContent.appendChild(url);
          urlTextbox = ViperUtil.getTag("input", createImageSubContent)[0];
          var inputTimeout = null;
          this.viper.registerCallback("ViperTools:changed:" + prefix + ":urlInput", "ViperImagePlugin", function() {
            clearTimeout(inputTimeout);
            var url2 = ViperUtil.trim(tools.getItem("ViperImagePlugin:urlInput").getValue());
            if (!url2) {
              ViperUtil.setStyle(self._previewBox, "display", "none");
              tools.setFieldErrors(prefix + ":urlInput", []);
            } else {
              if (url2 === "- Dropped Image -") {
                url2 = self._base64ImgSRC;
              }
              inputTimeout = setTimeout(function() {
                self._lastPreviewURL = null;
                self.updateImagePreview(url2);
              }, 1e3);
            }
          });
          var decorative = tools.createCheckbox(
            prefix + ":isDecorative",
            _("Image is decorative"),
            false,
            function(presVal) {
              if (presVal === true) {
                tools.getItem(prefix + ":altInput").disable();
                tools.getItem(prefix + ":titleInput").disable();
                tools.getItem(prefix + ":altInput").setRequired(false);
              } else {
                tools.getItem(prefix + ":altInput").setRequired(true);
                tools.getItem(prefix + ":altInput").enable();
                tools.getItem(prefix + ":titleInput").enable();
              }
            }
          );
          createImageSubContent.appendChild(decorative);
          var alt = tools.createTextbox(prefix + ":altInput", _("Alt"), "", null, true);
          createImageSubContent.appendChild(alt);
          var title = tools.createTextbox(prefix + ":titleInput", _("Title"));
          createImageSubContent.appendChild(title);
          return createImageSubContent;
        },
        _setImageAttributes: function(prefix) {
          var tools = this.viper.Tools;
          var url = tools.getItem(prefix + ":urlInput").getValue();
          var alt = tools.getItem(prefix + ":altInput").getValue();
          var title = tools.getItem(prefix + ":titleInput").getValue();
          var pres = tools.getItem(prefix + ":isDecorative").getValue();
          if (url === "- Dropped Image -") {
            url = this._base64ImgSRC;
          }
          if (pres === true) {
            title = null;
            alt = "";
          } else if (title === "") {
            title = null;
          }
          var image = this._resizeImage;
          if (!image || ViperUtil.isTag(image, "img") === false) {
            image = this.rangeToImage(this.viper.getViperRange(), this.getImageUrl(url), alt, title);
          } else {
            this.setImageURL(image, this.getImageUrl(url));
            this.setImageAlt(image, alt, pres);
            this.setImageTitle(image, title);
            this.viper.contentChanged(true);
          }
          this._updateToolbars(image);
          var self = this;
          var imageLoaded = function() {
            self.showImageResizeHandles(image);
            self.viper.fireSelectionChanged(null, true);
          };
          image.onload = imageLoaded;
          image.onerror = imageLoaded;
        },
        _updateToolbars: function(image) {
          this._updateToolbar(image, "ViperImagePlugin");
          this._updateToolbar(image, "vitpImagePlugin");
        },
        _updateToolbar: function(image, toolbarPrefix) {
          var toolbar = this.viper.PluginManager.getPlugin("ViperToolbarPlugin");
          if (!toolbar) {
            return;
          }
          var tools = this.viper.Tools;
          if (image && ViperUtil.isTag(image, "img") === true) {
            tools.setButtonActive("image");
            var src = this.viper.getAttribute(image, "src");
            this.setUrlFieldValue(src);
            tools.getItem(toolbarPrefix + ":altInput").setValue(this.viper.getAttribute(image, "alt") || "");
            tools.getItem(toolbarPrefix + ":titleInput").setValue(this.viper.getAttribute(image, "title") || "");
            if (!image.getAttribute("alt")) {
              tools.getItem(toolbarPrefix + ":isDecorative").setValue(true);
            } else {
              tools.getItem(toolbarPrefix + ":isDecorative").setValue(false);
            }
            this.hideURLField(toolbarPrefix);
            tools.getItem(toolbarPrefix + ":bubbleSubSection").setActionButtonTitle(_("Update Image"));
            this.updateImagePreview(src);
          } else {
            this.showURLField(toolbarPrefix);
            tools.getItem(toolbarPrefix + ":bubbleSubSection").setActionButtonTitle(_("Insert Image"));
            tools.enableButton("image");
            tools.setButtonInactive("image");
            tools.getItem(toolbarPrefix + ":isDecorative").setValue(false);
            tools.getItem(toolbarPrefix + ":urlInput").setValue("");
            tools.getItem(toolbarPrefix + ":altInput").setValue("");
            tools.getItem(toolbarPrefix + ":titleInput").setValue("");
            tools.setFieldErrors(toolbarPrefix + ":urlInput", []);
            this._lastPreviewURL = null;
            ViperUtil.empty(this._previewBox);
            ViperUtil.setStyle(this._previewBox, "display", "none");
          }
        },
        hideURLField: function(toolbarPrefix) {
          if (ViperUtil.isBrowser("chrome") === true) {
            ViperUtil.addClass(this.viper.Tools.getItem(toolbarPrefix + ":urlInput").element, "Viper-offScreen");
          } else {
            this.viper.Tools.getItem(toolbarPrefix + ":urlInput").hide();
          }
        },
        showURLField: function(toolbarPrefix) {
          if (ViperUtil.isBrowser("chrome") === true) {
            ViperUtil.removeClass(this.viper.Tools.getItem(toolbarPrefix + ":urlInput").element, "Viper-offScreen");
          } else {
            this.viper.Tools.getItem(toolbarPrefix + ":urlInput").show();
          }
        },
        _initInlineToolbar: function() {
          var self = this;
          this.viper.registerCallback("ViperInlineToolbarPlugin:initToolbar", "ViperImagePlugin", function(toolbar) {
            self.createInlineToolbar(toolbar);
          });
          this.viper.registerCallback("ViperInlineToolbarPlugin:updateToolbar", "ViperImagePlugin", function(data) {
            self._updateInlineToolbar(data);
          });
        },
        createInlineToolbar: function(toolbar) {
          var self = this;
          var tools = this.viper.Tools;
          var moveButton = null;
          var image = null;
          var idPrefix = "vitpImagePlugin";
          this._inlineToolbar = toolbar;
          tools.createToolTip(
            "ViperImageToolbar-tooltip",
            _(
              "The selected image will be moved to the next location you click. To cancel, press the move icon again, or ESC"
            ),
            "mouse"
          );
          var subContent = this._getToolbarContents(idPrefix);
          toolbar.makeSubSection(idPrefix + ":bubbleSubSection", subContent);
          var imageButton = tools.createButton("vitpImage", "", _("Toggle Image Options"), "Viper-image", null);
          toolbar.setSubSectionButton("vitpImage", idPrefix + ":bubbleSubSection");
          toolbar.setSubSectionAction(
            idPrefix + ":bubbleSubSection",
            function() {
              self._setImageAttributes(idPrefix);
            },
            [idPrefix + ":urlInput", idPrefix + ":altInput", idPrefix + ":titleInput", idPrefix + ":isDecorative"]
          );
          moveButton = tools.createButton("vitpImageMove", "", _("Move Image"), "Viper-move", function() {
            self._moveImage = self._resizeImage;
            if (ViperUtil.hasClass(moveButton, "Viper-selected") === true) {
              self._cancelMove();
              return;
            }
            ViperUtil.addClass(moveButton, "Viper-selected");
            tools.getItem("ViperImageToolbar-tooltip").show();
            self.viper.registerCallback("Viper:mouseUp", "ViperImagePlugin:move", function(e) {
              var imageElement = self._moveImage;
              self._cancelMove();
              var clickTarget = ViperUtil.getMouseEventTarget(e);
              if (clickTarget) {
                if (ViperUtil.isTag(clickTarget, "img") === true || self.viper.isOutOfBounds(clickTarget) === true) {
                  return;
                }
              }
              var range = self.viper.getViperRange();
              if (self.viper.rangeInViperBounds(range) === false) {
                return;
              }
              self.moveImage(imageElement, range);
              ViperSelection.removeAllRanges();
              range.selectNode(imageElement);
              ViperSelection.addRange(range);
              self.showImageResizeHandles(imageElement);
              self.viper.fireSelectionChanged(range, true);
              self._moveImage = null;
              return false;
            });
            ViperUtil.addEvent(document, "keydown.ViperImagePlugin:move", function(e) {
              if (e.which === 27) {
                self._cancelMove();
              }
            });
          });
          var buttonGroup = tools.createButtonGroup("vitpImageBtnGroup");
          buttonGroup.appendChild(imageButton);
          buttonGroup.appendChild(moveButton);
          toolbar.addButton(buttonGroup);
        },
        _updateInlineToolbar: function(data) {
          var nodeSelection = data.nodeSelection || data.range.getNodeSelection();
          var self = this;
          if (!this._resizeImage) {
            this.hideImageResizeHandles();
          }
          if (nodeSelection && ViperUtil.isTag(nodeSelection, "img") === true) {
            this._resizeImage = nodeSelection;
            this.showInlineToolbarButtons(data);
            nodeSelection.onload = function() {
              self.showImageResizeHandles(nodeSelection);
              self._inlineToolbar.update(null, nodeSelection);
            };
            this.viper.Tools.setButtonActive("vitpImage");
            this.showImageResizeHandles(nodeSelection);
            this._updateToolbars(nodeSelection);
          }
        },
        showInlineToolbarButtons: function(data) {
          data.toolbar.showButton("vitpImage");
          data.toolbar.showButton("vitpImageMove");
        },
        _cancelMove: function() {
          this.viper.Tools.getItem("ViperImageToolbar-tooltip").hide();
          this.viper.removeCallback("Viper:mouseUp", "ViperImagePlugin:move");
          ViperUtil.removeEvent(document, "keydown.ViperImagePlugin:move");
          ViperUtil.removeClass(this.viper.Tools.getItem("vitpImageMove").element, "Viper-selected");
          this._moveImage = null;
        },
        setUrlFieldValue: function(url) {
          if (url.indexOf("data:image") === 0) {
            this._base64ImgSRC = url;
            url = "- Dropped Image -";
          }
          this.viper.Tools.getItem("ViperImagePlugin:urlInput").setValue(url);
          this.viper.Tools.getItem("vitpImagePlugin:urlInput").setValue(url);
        },
        getImageUrl: function(url) {
          return url;
        },
        updateImagePreview: function(url) {
          if (this._lastPreviewURL === url) {
            return;
          }
          this._lastPreviewURL = url;
          ViperUtil.empty(this._previewBox);
          var self = this;
          this.setPreviewContent(false, true);
          this.loadImage(url, function(img) {
            self.setPreviewContent(img);
          });
        },
        loadImage: function(url, callback) {
          var img = new Image();
          img.onload = function() {
            callback.call(this, img);
          };
          img.onerror = function() {
            callback.call(this, false);
          };
          var replacementPlugin = this.viper.getPluginManager().getPlugin("ViperReplacementPlugin");
          if (replacementPlugin && url.indexOf("data:image") === -1) {
            var self = this;
            replacementPlugin.replaceKeywords(url, function(replaced) {
              self.viper.setAttribute(img, "src", replaced);
            });
          } else {
            this.viper.setAttribute(img, "src", url);
          }
        },
        setPreviewContent: function(img, loading) {
          var previewBox = this._previewBox;
          ViperUtil.setStyle(previewBox, "display", "block");
          if (loading === true) {
            ViperUtil.removeClass(previewBox, "Viper-info");
            ViperUtil.setHtml(previewBox, _("Loading preview"));
            this.viper.Tools.setFieldErrors("ViperImagePlugin:urlInput", []);
          } else if (!img) {
            ViperUtil.removeClass(previewBox, "Viper-info");
            ViperUtil.setStyle(previewBox, "display", "none");
            this.viper.Tools.setFieldErrors("ViperImagePlugin:urlInput", [_("Failed to load image")]);
          } else {
            this.viper.Tools.setFieldErrors("ViperImagePlugin:urlInput", []);
            ViperUtil.addClass(previewBox, "Viper-info");
            var tmp = document.createElement("div");
            ViperUtil.setStyle(tmp, "visibility", "hidden");
            ViperUtil.setStyle(tmp, "left", "-9999px");
            ViperUtil.setStyle(tmp, "top", "-9999px");
            ViperUtil.setStyle(tmp, "position", "absolute");
            tmp.appendChild(img);
            this.viper.addElement(tmp);
            ViperUtil.setStyle(img, "width", "");
            ViperUtil.setStyle(img, "height", "");
            var width = ViperUtil.getElementWidth(img);
            var height = ViperUtil.getElementHeight(img);
            ViperUtil.remove(tmp);
            img.removeAttribute("height");
            img.removeAttribute("width");
            var maxWidth = 185;
            var maxHeight = 185;
            if (height > maxHeight && width > maxWidth) {
              if (height > width) {
                ViperUtil.setStyle(img, "height", maxHeight + "px");
                ViperUtil.setStyle(img, "width", "auto");
              } else {
                ViperUtil.setStyle(img, "width", maxWidth + "px");
                ViperUtil.setStyle(img, "height", "auto");
              }
            } else if (width > maxWidth) {
              ViperUtil.setStyle(img, "width", maxWidth + "px");
              ViperUtil.setStyle(img, "height", "auto");
            } else if (height > maxHeight) {
              ViperUtil.setStyle(img, "height", maxHeight + "px");
              ViperUtil.setStyle(img, "width", "auto");
            }
            ViperUtil.empty(previewBox);
            ViperUtil.setHtml(previewBox, width + "px x " + height + "px<br/>");
            previewBox.appendChild(img);
          }
        },
        showImageResizeHandles: function(image) {
          this.hideImageResizeHandles(true);
          var self = this;
          var rect = ViperUtil.getBoundingRectangle(image);
          var offset = ViperUtil.getDocumentOffset();
          rect.x1 += offset.x;
          rect.x2 += offset.x;
          rect.y1 += offset.y;
          rect.y2 += offset.y;
          if (document !== image.ownerDocument) {
            var scrollCoords = ViperUtil.getScrollCoords(image.ownerDocument.defaultView);
            rect.x1 -= scrollCoords.x;
            rect.x2 -= scrollCoords.x;
            rect.y1 -= scrollCoords.y;
            rect.y2 -= scrollCoords.y;
          }
          this._resizeImage = image;
          if (!this._resizeBox) {
            var canResize = true;
            if (image.naturalWidth === 0 || image.naturalHeight === 0) {
              canResize = false;
            }
            var resizeBox = document.createElement("div");
            this._resizeBox = resizeBox;
            var windowWidth = ViperUtil.getWindowDimensions().width;
            var sizeDiv = document.createElement("div");
            ViperUtil.addClass(sizeDiv, "ViperImagePlugin-sizeDiv");
            ViperUtil.addEvent(sizeDiv, "mousedown", function(e) {
              self.resetImageSize(image);
              _updateSize();
              ViperUtil.preventDefault(e);
              self.viper.fireCallbacks("ViperImagePlugin:imageSizeReset", { image });
              self.hideImageResizeHandles();
              self.showImageResizeHandles(image);
            });
            resizeBox.appendChild(sizeDiv);
            var _updateSize = function(force) {
              if (force === true || ViperUtil.hasAttribute(image, "width") === true || ViperUtil.hasAttribute(image, "height") === true) {
                var sizeHtml = self.getImageSizeDisplayHtml(image);
                ViperUtil.setHtml(sizeDiv, sizeHtml);
                ViperUtil.addClass(sizeDiv, "visible");
              } else {
                ViperUtil.removeClass(sizeDiv, "visible");
              }
              if (image.width < 60 || image.height < 20) {
                ViperUtil.addClass(sizeDiv, "smallImage");
              } else {
                ViperUtil.removeClass(sizeDiv, "smallImage");
              }
            };
            _updateSize();
            ViperUtil.addClass(resizeBox, "ViperImagePlugin-resizeBox");
            ViperUtil.setStyle(resizeBox, "left", rect.x1 + "px");
            ViperUtil.setStyle(resizeBox, "top", rect.y1 + "px");
            ViperUtil.setStyle(resizeBox, "width", rect.x2 - rect.x1 + "px");
            ViperUtil.setStyle(resizeBox, "height", rect.y2 - rect.y1 + "px");
            if (canResize === true) {
              ViperUtil.addClass(resizeBox, "canResize");
              var _createHandle = function(className) {
                var handle = document.createElement("div");
                ViperUtil.addClass(
                  handle,
                  "ViperImagePlugin-resizeBox-handle ViperImagePlugin-resizeBox-handle-" + className
                );
                resizeBox.appendChild(handle);
                ViperUtil.addEvent(handle, "mousedown.ViperImagePlugin-resize", function(e) {
                  ViperUtil.preventDefault(e);
                  var posx = e.pageX;
                  var posy = e.pageY;
                  var ratio = image.height / image.width;
                  var width = image.width;
                  var height = image.height;
                  var naturalDim = self.getImageNaturalDimensions(image);
                  var both = e.shiftKey;
                  var resized = false;
                  var docs = ViperUtil.getDocuments(true, ViperUtil.getTopDocument());
                  ViperUtil.setStyle(image, "width", "");
                  ViperUtil.setStyle(image, "height", "");
                  self._inlineToolbar.hide();
                  _updateSize(true);
                  ViperUtil.addEvent(docs, "mousemove.ViperImagePlugin-resize", function(e2) {
                    var diffx = e2.pageX - posx;
                    var diffy = e2.pageY - posy;
                    posx = e2.pageX;
                    posy = e2.pageY;
                    resized = true;
                    if (ViperUtil.hasClass(handle, "ViperImagePlugin-resizeBox-handle-bottomLeft") === true || ViperUtil.hasClass(handle, "ViperImagePlugin-resizeBox-handle-topLeft") === true) {
                      width = image.width - diffx;
                    } else {
                      width = image.width + diffx;
                    }
                    image.setAttribute("width", width);
                    var widthStyle = parseInt(ViperUtil.getStyle(image, "width").replace("px", ""));
                    if (widthStyle !== width) {
                      image.setAttribute("width", widthStyle);
                      if (both !== true) {
                        image.setAttribute("height", parseInt(widthStyle * ratio));
                      }
                      _updateSize();
                      return;
                    } else if (widthStyle > naturalDim.width) {
                      image.setAttribute("width", naturalDim.width);
                      if (both !== true) {
                        image.setAttribute("height", naturalDim.height);
                      }
                      _updateSize();
                      return;
                    }
                    if (both === true) {
                      height += diffy;
                      image.setAttribute("height", parseInt(height));
                    } else {
                      image.setAttribute("height", parseInt(width * ratio));
                    }
                    _updateSize();
                    self.viper.fireCallbacks("ViperImagePlugin:imageResized", { image, size: rect2 });
                    var rect2 = ViperUtil.getBoundingRectangle(image);
                    var offset2 = ViperUtil.getDocumentOffset();
                    rect2.x1 += offset2.x;
                    rect2.x2 += offset2.x;
                    rect2.y1 += offset2.y;
                    rect2.y2 += offset2.y;
                    if (document !== image.ownerDocument) {
                      rect2.x1 -= scrollCoords.x;
                      rect2.x2 -= scrollCoords.x;
                      rect2.y1 -= scrollCoords.y;
                      rect2.y2 -= scrollCoords.y;
                    }
                    ViperUtil.setStyle(resizeBox, "left", rect2.x1 + "px");
                    ViperUtil.setStyle(resizeBox, "top", rect2.y1 + "px");
                    ViperUtil.setStyle(resizeBox, "width", rect2.x2 - rect2.x1 + "px");
                    ViperUtil.setStyle(resizeBox, "height", rect2.y2 - rect2.y1 + "px");
                    ViperUtil.preventDefault(e2);
                    return false;
                  });
                  ViperUtil.addEvent(docs, "mouseup.ViperImagePlugin-resize", function(e2) {
                    ViperUtil.removeEvent(docs, "mousemove.ViperImagePlugin-resize");
                    ViperUtil.removeEvent(docs, "mouseup.ViperImagePlugin-resize");
                    if (image.width === image.naturalWidth) {
                      ViperUtil.removeAttr(image, "width");
                    }
                    if (image.height === image.naturalHeight) {
                      ViperUtil.removeAttr(image, "height");
                    }
                    if (!image.getAttribute("style")) {
                      image.removeAttribute("style");
                    }
                    if (resized === true) {
                      self.viper.contentChanged(true);
                    }
                    self._updateToolbars(image);
                    self._inlineToolbar.update(null, image);
                  });
                  ViperUtil.preventDefault(e);
                  return false;
                });
                return handle;
              };
              var handles = {};
              handles.topLeft = _createHandle("topLeft");
              handles.topRight = _createHandle("topRight");
              handles.bottomLeft = _createHandle("bottomLeft");
              handles.bottomRight = _createHandle("bottomRight");
            }
            this.viper.addElement(resizeBox);
          }
        },
        getImageNaturalDimensions: function(image) {
          var dim = {
            width: image.naturalWidth,
            height: image.naturalHeight
          };
          return dim;
        },
        hideImageResizeHandles: function(noUpdate) {
          ViperUtil.remove(this._resizeBox);
          this._resizeBox = null;
          this._resizeImage = null;
        },
        resetImageSize: function(image) {
          ViperUtil.removeAttr(image, "width");
          ViperUtil.removeAttr(image, "height");
          this.viper.contentChanged(true);
        },
        getImageSizeDisplayHtml: function(image) {
          var naturalDim = this.getImageNaturalDimensions(image);
          var sizeHtml = '<div class="ViperImagePlugin-size';
          if (image.width === naturalDim.width || image.height === naturalDim.height) {
            sizeHtml += ' maximumSize">' + _("Maximum");
          } else {
            sizeHtml += '">' + image.width + " x " + image.height;
          }
          sizeHtml += '</div><div class="ViperImagePlugin-reset">' + _("Reset Size") + "</div>";
          return sizeHtml;
        }
      };
    };
  }
});

// src/Plugins/ViperSearchReplacePlugin/ViperSearchReplacePlugin.js
var ViperSearchReplacePlugin_exports = {};
__export(ViperSearchReplacePlugin_exports, {
  registerPlugin: () => registerPlugin21
});
var registerPlugin21;
var init_ViperSearchReplacePlugin = __esm({
  "src/Plugins/ViperSearchReplacePlugin/ViperSearchReplacePlugin.js"() {
    "use strict";
    registerPlugin21 = (Viper2) => {
      const { Util: ViperUtil, Selection: ViperSelection, _ } = Viper2;
      function ViperSearchReplacePlugin(viper) {
        this.viper = viper;
        this._matchCount = 0;
        this._finding = false;
      }
      Viper2.PluginManager.addPlugin("ViperSearchReplacePlugin", ViperSearchReplacePlugin);
      ViperSearchReplacePlugin.prototype = {
        init: function() {
          this._initToolbar();
        },
        _initToolbar: function() {
          var toolbar = this.viper.PluginManager.getPlugin("ViperToolbarPlugin");
          if (!toolbar) {
            return;
          }
          var self = this;
          var tools = this.viper.Tools;
          this.viper.registerCallback("ViperToolbarPlugin:enabled", "ViperSearchReplacePlugin", function(data) {
            self.viper.Tools.enableButton("searchReplace");
          });
          this.viper.registerCallback("ViperToolbarPlugin:updateToolbar", "ViperSearchReplacePlugin", function(data) {
            self.viper.Tools.enableButton("searchReplace");
          });
          var content = document.createElement("div");
          var search = tools.createTextbox("ViperSearchPlugin:searchInput", _("Search"), "");
          tools.setFieldEvent("ViperSearchPlugin:searchInput", "keyup", function() {
            if (tools.getItem("ViperSearchPlugin:searchInput").getValue()) {
              tools.enableButton("ViperSearchPlugin:findNext");
            } else {
              tools.disableButton("ViperSearchPlugin:findNext");
              tools.disableButton("ViperSearchPlugin:replace");
              tools.disableButton("ViperSearchPlugin:replaceAll");
            }
          });
          content.appendChild(search);
          var _replace = function() {
            self.replace(tools.getItem("ViperSearchPlugin:replaceInput").getValue());
            self._updateButtonStates();
            self.viper.contentChanged(true);
            return false;
          };
          var replace = tools.createTextbox("ViperSearchPlugin:replaceInput", _("Replace"), "", function(value) {
            var search2 = tools.getItem("ViperSearchPlugin:searchInput").getValue();
            self.getNumberOfMatches(search2);
            self.find(search2, false, true);
            self._updateButtonStates();
          });
          content.appendChild(replace);
          var _replaceAll = function() {
            var replaceCount = 0;
            var fromStart = true;
            while (self.find(tools.getItem("ViperSearchPlugin:searchInput").getValue(), false, fromStart) === true) {
              fromStart = false;
              self.replace(tools.getItem("ViperSearchPlugin:replaceInput").getValue());
              replaceCount++;
            }
            self._matchCount = 0;
            self._updateButtonStates();
            self.viper.contentChanged(true);
          };
          var replaceAllBtn = tools.createButton(
            "ViperSearchPlugin:replaceAll",
            _("Replace All"),
            _("Replace All"),
            "Viper-replaceAll",
            function() {
              var bubble = tools.getItem("ViperSearchPlugin:bubble");
              bubble.updateSubSectionAction("ViperSearchPlugin:bubbleSubSection", _replaceAll);
              var subSection = tools.getItem("ViperSearchPlugin:bubbleSubSection");
              return subSection.form.onsubmit();
            },
            true
          );
          var replaceBtn = tools.createButton(
            "ViperSearchPlugin:replace",
            _("Replace"),
            _("Replace"),
            "Viper-replaceText",
            function() {
              var bubble = tools.getItem("ViperSearchPlugin:bubble");
              bubble.updateSubSectionAction("ViperSearchPlugin:bubbleSubSection", _replace);
              var subSection = tools.getItem("ViperSearchPlugin:bubbleSubSection");
              return subSection.form.onsubmit();
            },
            true
          );
          content.appendChild(replaceAllBtn);
          content.appendChild(replaceBtn);
          var _findNext = function() {
            var found = self.find(tools.getItem("ViperSearchPlugin:searchInput").getValue());
            if (found !== true) {
              self.getNumberOfMatches(tools.getItem("ViperSearchPlugin:searchInput").getValue());
              if (self._matchCount > 0) {
                found = self.find(tools.getItem("ViperSearchPlugin:searchInput").getValue(), false, true);
                if (found !== true) {
                  self._matchCount = 0;
                }
              }
            }
            self._updateButtonStates(found);
            return false;
          };
          var findNext = tools.createButton(
            "ViperSearchPlugin:findNext",
            _("Find Next"),
            _("Find Next"),
            "",
            function() {
              var bubble = tools.getItem("ViperSearchPlugin:bubble");
              bubble.updateSubSectionAction("ViperSearchPlugin:bubbleSubSection", _findNext);
              var subSection = tools.getItem("ViperSearchPlugin:bubbleSubSection");
              return subSection.form.onsubmit();
            },
            true
          );
          content.appendChild(findNext);
          var searchTools = toolbar.createBubble(
            "ViperSearchPlugin:bubble",
            _("Search & Replace"),
            content,
            null,
            function() {
              self._matchCount = 0;
              self._updateButtonStates(false);
            }
          );
          var searchBtn = tools.createButton("searchReplace", "", _("Search & Replace"), "Viper-searchReplace", null, true);
          toolbar.addButton(searchBtn);
          toolbar.setBubbleButton("ViperSearchPlugin:bubble", "searchReplace");
          tools.getItem("ViperSearchPlugin:bubble").setSubSectionAction(
            "ViperSearchPlugin:bubbleSubSection",
            function() {
              return _findNext();
            },
            ["ViperSearchPlugin:searchInput"],
            "ViperSearchPlugin:findNext",
            true
          );
          this.viper.registerCallback("ViperToolbarPlugin:updateToolbar", "ViperSearchReplacePlugin", null);
        },
        _updateButtonStates: function(hasResult) {
          var self = this;
          var tools = this.viper.Tools;
          var enableReplace = true;
          if (hasResult !== true && this._matchCount === 0) {
            enableReplace = false;
          }
          var clone = this.viper.getCurrentRange();
          if (enableReplace === true) {
            tools.enableButton("ViperSearchPlugin:replace");
            tools.enableButton("ViperSearchPlugin:replaceAll");
          } else {
            tools.disableButton("ViperSearchPlugin:replace");
            tools.disableButton("ViperSearchPlugin:replaceAll");
          }
          var val = tools.getItem("ViperSearchPlugin:searchInput").getValue();
          tools.getItem("ViperSearchPlugin:searchInput").setValue("");
          tools.getItem("ViperSearchPlugin:searchInput").setValue(val);
          val = tools.getItem("ViperSearchPlugin:replaceInput").getValue();
          tools.getItem("ViperSearchPlugin:replaceInput").setValue("");
          tools.getItem("ViperSearchPlugin:replaceInput").setValue(val);
          ViperSelection.addRange(clone);
          this.viper.focus();
        },
        getNumberOfMatches: function(text) {
          this._matchCount = 0;
          var fromStart = true;
          while (this.find(text, false, fromStart) === true) {
            this._matchCount++;
            fromStart = false;
          }
          return this._matchCount;
        },
        find: function(text, backward, fromStart, testOnly, element) {
          var element = element || this.viper.getViperElement();
          if (!text || !element) {
            return;
          }
          var rangeClone = null;
          if (testOnly) {
            rangeClone = this.viper.getCurrentRange().cloneRange();
          }
          var viperRange = null;
          if (fromStart === true) {
            if (Viper2.document.activeElement && Viper2.document.activeElement !== this.viper.getViperElement() && Viper2.document.activeElement.blur && Viper2.document.activeElement !== document.body) {
              Viper2.document.activeElement.blur();
            }
            this.viper.focus();
            viperRange = this.viper.getCurrentRange();
            viperRange.setStart(viperRange._getFirstSelectableChild(element), 0);
            viperRange.collapse(true);
            ViperSelection.addRange(viperRange);
          }
          this.viper.focus();
          viperRange = this.viper.getViperRange();
          ViperSelection.addRange(viperRange);
          var found = Viper2.Util.getDocumentWindow().find(text, false, backward);
          if (found !== true || this.viper.rangeInViperBounds() === false) {
            if (testOnly === true) {
              ViperSelection.addRange(rangeClone);
            } else {
              ViperSelection.addRange(viperRange);
              this.viper.focus();
            }
            return false;
          } else if (testOnly === true) {
            ViperSelection.addRange(rangeClone);
            return true;
          } else {
            ViperSelection.addRange(this.viper.getCurrentRange());
          }
          return true;
        },
        replace: function(replacement) {
          var range = this.viper.getCurrentRange();
          if (this.viper.rangeInViperBounds(range) === false) {
            range = this.viper.getViperRange();
          }
          var bookmark = this.viper.createBookmark(range);
          var newNode = document.createTextNode(replacement);
          ViperUtil.insertBefore(bookmark.start, newNode);
          this.viper.removeBookmark(bookmark);
          range.setStart(newNode, 0);
          range.setEnd(newNode, newNode.data.length);
          ViperSelection.addRange(range);
          this._matchCount--;
        }
      };
    };
  }
});

// src/Plugins/ViperLangToolsPlugin/ViperLangToolsPlugin.js
var ViperLangToolsPlugin_exports = {};
__export(ViperLangToolsPlugin_exports, {
  registerPlugin: () => registerPlugin22
});
var registerPlugin22;
var init_ViperLangToolsPlugin = __esm({
  "src/Plugins/ViperLangToolsPlugin/ViperLangToolsPlugin.js"() {
    "use strict";
    registerPlugin22 = (Viper2) => {
      const { Util: ViperUtil, Selection: ViperSelection, _ } = Viper2;
      function ViperLangToolsPlugin(viper) {
        this.viper = viper;
        this._originalRange = null;
      }
      Viper2.PluginManager.addPlugin("ViperLangToolsPlugin", ViperLangToolsPlugin);
      ViperLangToolsPlugin.prototype = {
        init: function() {
          this._initToolbar();
        },
        rangeToTag: function(tagName, titleAttribute) {
          if (!titleAttribute) {
            return;
          }
          var range = this.viper.getViperRange();
          var node = range.getNodeSelection();
          var element = null;
          if (node) {
            if (ViperUtil.isTag(node, tagName) === true) {
              node.setAttribute("title", titleAttribute);
              element = node;
            } else {
              var nodeFromRange = this.getTagFromRange(range, tagName);
              if (nodeFromRange) {
                nodeFromRange.setAttribute("title", titleAttribute);
                element = nodeFromRange;
              } else {
                element = document.createElement(tagName);
                element.setAttribute("title", titleAttribute);
                ViperUtil.moveChildrenToElement(node, element);
                node.appendChild(element);
              }
            }
          } else {
            var bookmark = this.viper.createBookmark(range);
            element = document.createElement(tagName);
            element.setAttribute("title", titleAttribute);
            var elems = ViperUtil.getElementsBetween(bookmark.start, bookmark.end);
            var c = elems.length;
            for (var i = 0; i < c; i++) {
              element.appendChild(elems[i]);
            }
            ViperUtil.insertBefore(bookmark.start, element);
            this.viper.removeBookmark(bookmark);
          }
          range.selectNode(element);
          ViperSelection.addRange(range);
          this.viper.contentChanged();
          return element;
        },
        rangeToLang: function(langAttribute) {
          if (!langAttribute) {
            return;
          }
          var range = this.viper.getViperRange();
          var node = this.viper.getNodeSelection();
          var element = null;
          if (ViperUtil.isElement(node) === true) {
            var children = ViperUtil.getSurroundedChildren(node);
            if (children.length > 0) {
              node = children.pop();
            }
            var parents = ViperUtil.getSurroundingParents(node);
            ViperUtil.removeAttr(parents, "lang");
            node.setAttribute("lang", langAttribute);
            element = node;
          } else if (range.collapsed === true) {
            var node = range.getStartNode();
            if (!node) {
              node = range.getEndNode();
              if (!node) {
                return null;
              }
            }
            if (ViperUtil.isText(node) === true) {
              node = node.parentNode;
            }
            element = node;
          } else {
            var bookmark = this.viper.createBookmark(range);
            element = document.createElement("span");
            element.setAttribute("lang", langAttribute);
            var elems = ViperUtil.getElementsBetween(bookmark.start, bookmark.end);
            var c = elems.length;
            for (var i = 0; i < c; i++) {
              element.appendChild(elems[i]);
            }
            ViperUtil.insertBefore(bookmark.start, element);
            this.viper.removeBookmark(bookmark);
          }
          range.selectNode(element);
          ViperSelection.addRange(range);
          this.viper.contentChanged();
          return element;
        },
        removeElement: function(elem) {
          if (!elem && elem.parentNode) {
            return;
          }
          var firstChild = elem.firstChild;
          var lastChild = elem.lastChild;
          while (elem.firstChild) {
            ViperUtil.insertBefore(elem, elem.firstChild);
          }
          ViperUtil.remove(elem);
          var range = this.viper.getViperRange();
          if (firstChild === lastChild) {
            range.selectNode(firstChild);
          } else {
            range.setStart(firstChild, 0);
            if (lastChild.nodeType === ViperUtil.TEXT_NODE) {
              range.setEnd(lastChild, lastChild.data.length);
            } else {
              var lastSelectable = range._getLastSelectableChild(lastChild);
              if (lastSelectable) {
                range.setEnd(lastSelectable, lastSelectable.data.length);
              }
            }
          }
          ViperSelection.addRange(range);
          this.viper.contentChanged(false, range);
        },
        _getTagFromElement: function(element, tagName) {
          if (tagName && ViperUtil.isTag(element, tagName) === true) {
            return element;
          } else if (tagName === "lang" && ViperUtil.hasAttribute(element, "lang") === true) {
            return element;
          } else if (!tagName) {
            if (ViperUtil.isTag(element, "abbr") === true || ViperUtil.isTag(element, "acronym") === true) {
              return element;
            } else if (ViperUtil.hasAttribute(element, "lang") === true) {
              return element;
            }
          }
          return null;
        },
        getTagFromRange: function(range, tagName) {
          var selectedNode = this.viper.getNodeSelection();
          if (selectedNode && selectedNode.nodeType === ViperUtil.ELEMENT_NODE) {
            var element = this._getTagFromElement(selectedNode, tagName);
            if (element) {
              return element;
            } else {
              var parents = ViperUtil.getSurroundingParents(selectedNode);
              for (var i = 0; i < parents.length; i++) {
                var element = this._getTagFromElement(parents[i], tagName);
                if (element) {
                  return element;
                }
              }
              var children = ViperUtil.getSurroundedChildren(selectedNode);
              for (var i = 0; i < children.length; i++) {
                var element = this._getTagFromElement(children[i], tagName);
                if (element) {
                  return element;
                }
              }
            }
            return null;
          }
          var viperElem = this.viper.getViperElement();
          var common = range.getCommonElement();
          while (common) {
            if (tagName) {
              if (ViperUtil.isTag(common, tagName) === true) {
                return common;
              } else if (tagName === "lang" && ViperUtil.hasAttribute(common, "lang") === true) {
                return common;
              }
            } else {
              if (ViperUtil.isTag(common, "abbr") === true || ViperUtil.isTag(common, "acronym") === true) {
                return common;
              } else if (ViperUtil.hasAttribute(common, "lang") === true) {
                return common;
              }
            }
            if (common === viperElem || ViperUtil.isBlockElement(common) === true) {
              break;
            }
            common = common.parentNode;
          }
          return null;
        },
        /**
         * Returns list of parent elements that have only one child.
         *
         * @param node    {DOMNode} The child element to get parents of.
         * @param tagName {string}  The tag name filter.
         *
         * @return {array} Parent elements.
         */
        getSurroundingParents: function(node, tagName) {
          if (!node) {
            return;
          }
          var parents = [];
          var parent = node.parentNode;
          while (parent) {
            var c = parent.childNodes.length;
            for (var i = 0; i < c; i++) {
              var child = parent.childNodes[i];
              if (child.nodeType == ViperUtil.ELEMENT_NODE) {
                if (child !== node) {
                  return parents;
                }
              } else if (ViperUtil.isBlank(ViperUtil.trim(child.data)) !== true) {
                return parents;
              }
            }
            if (!tagName || ViperUtil.isTag(parent, tagName) === true) {
              parents.push(parent);
            }
            parent = parent.parentNode;
            node = parent;
          }
          return parents;
        },
        handleAcronym: function() {
          var value = ViperUtil.trim(this.viper.Tools.getItem("VLTP:acronymInput").getValue());
          if (value) {
            this.rangeToTag("acronym", value);
          } else {
            var node = this.viper.getViperRange().getNodeSelection();
            if (node) {
              if (ViperUtil.isTag(node, "acronym") !== true) {
                var parents = this.getSurroundingParents(node, "acronym");
                for (var i = 0; i < parents.length; i++) {
                  this.removeElement(parents[i]);
                }
              } else {
                this.removeElement(node);
              }
            }
          }
        },
        handleAbbreviation: function() {
          var value = ViperUtil.trim(this.viper.Tools.getItem("VLTP:abbrInput").getValue());
          if (value) {
            this.rangeToTag("abbr", value);
          } else {
            var node = this.viper.getViperRange().getNodeSelection();
            if (node) {
              if (ViperUtil.isTag(node, "abbr") !== true) {
                var parents = this.getSurroundingParents(node, "abbr");
                for (var i = 0; i < parents.length; i++) {
                  this.removeElement(parents[i]);
                }
              } else {
                this.removeElement(node);
              }
            }
          }
        },
        handleLanguage: function() {
          var value = ViperUtil.trim(this.viper.Tools.getItem("VLTP:langInput").getValue());
          if (value) {
            this.rangeToLang(value);
          } else {
            var node = this.viper.getViperRange().getNodeSelection();
            if (node) {
              if (node && ViperUtil.hasAttribute(node, "lang") === true) {
                node.removeAttribute("lang");
                if (!node.className && !node.id && ViperUtil.isTag(node, "span") === true) {
                  this.removeElement(node);
                } else {
                  this.viper.contentChanged();
                }
              } else {
                var parents = this.getSurroundingParents(node);
                for (var i = 0; i < parents.length; i++) {
                  parents[i].removeAttribute("lang");
                  if (!parents[i].className && !parents[i].id && ViperUtil.isTag(parents[i], "span") === true) {
                    this.removeElement(parents[i]);
                  }
                }
              }
            }
          }
        },
        getAcronymSubSection: function() {
          var self = this;
          var elem = document.createElement("div");
          var input = this.viper.Tools.createTextbox("VLTP:acronymInput", _("Acronym"));
          elem.appendChild(input);
          return elem;
        },
        getAbbreviationSubSection: function() {
          var self = this;
          var elem = document.createElement("div");
          var input = this.viper.Tools.createTextbox("VLTP:abbrInput", _("Abbreviation"));
          elem.appendChild(input);
          return elem;
        },
        getLangSubSection: function() {
          var self = this;
          var elem = document.createElement("div");
          var input = this.viper.Tools.createTextbox("VLTP:langInput", _("Language"));
          elem.appendChild(input);
          return elem;
        },
        _selectTag: function(tagName) {
          var range = this._originalRange.cloneRange();
          var element = this.getTagFromRange(range, tagName);
          if (element) {
            range.selectNode(element);
            ViperSelection.addRange(range);
          }
        },
        _initToolbar: function() {
          var toolbar = this.viper.PluginManager.getPlugin("ViperToolbarPlugin");
          if (!toolbar) {
            return;
          }
          var self = this;
          var tools = this.viper.Tools;
          var contents = document.createElement("div");
          toolbar.createBubble(
            "ViperLangToolsPlugin:bubble",
            _("Language Tools"),
            null,
            contents,
            function() {
              self._originalRange = self.viper.getViperRange().cloneRange();
            },
            function() {
              tools.getItem("ViperLangToolsPlugin:bubble").hideSubSection();
            }
          );
          var bubble = tools.getItem("ViperLangToolsPlugin:bubble");
          var toggleBtn = tools.createButton("langTools", "", _("Toggle Language Tools"), "Viper-langTools", null, true);
          toolbar.setBubbleButton("ViperLangToolsPlugin:bubble", "langTools");
          toolbar.addButton(toggleBtn);
          var acronymButton = tools.createButton(
            "ViperLangToolsPlugin:acronymButton",
            _("Acronym"),
            _("Toggle Acronym Options"),
            "",
            function() {
              bubble.showSubSection("VLTP:acronymSubSection");
              self._selectTag("acronym");
            }
          );
          var abbrButton = tools.createButton(
            "ViperLangToolsPlugin:abbrButton",
            _("Abbreviation"),
            _("Toggle Abbreviation Options"),
            "",
            function() {
              bubble.showSubSection("VLTP:abbreviationSubSection");
              self._selectTag("abbr");
            }
          );
          var langButton = tools.createButton(
            "ViperLangToolsPlugin:langButton",
            _("Language"),
            _("Toggle Language Options"),
            "",
            function() {
              bubble.showSubSection("VLTP:langSubSection");
              self._selectTag("lang");
            }
          );
          contents.appendChild(acronymButton);
          contents.appendChild(abbrButton);
          contents.appendChild(langButton);
          bubble.addSubSection("VLTP:acronymSubSection", this.getAcronymSubSection());
          bubble.addSubSection("VLTP:abbreviationSubSection", this.getAbbreviationSubSection());
          bubble.addSubSection("VLTP:langSubSection", this.getLangSubSection());
          bubble.setSubSectionButton("VLTP:acronymSubSection", "ViperLangToolsPlugin:acronymButton");
          bubble.setSubSectionButton("VLTP:abbreviationSubSection", "ViperLangToolsPlugin:abbrButton");
          bubble.setSubSectionButton("VLTP:langSubSection", "ViperLangToolsPlugin:langButton");
          bubble.setSubSectionAction(
            "VLTP:acronymSubSection",
            function() {
              self.handleAcronym();
            },
            ["VLTP:acronymInput"]
          );
          bubble.setSubSectionAction(
            "VLTP:abbreviationSubSection",
            function() {
              self.handleAbbreviation();
            },
            ["VLTP:abbrInput"]
          );
          bubble.setSubSectionAction(
            "VLTP:langSubSection",
            function() {
              self.handleLanguage();
            },
            ["VLTP:langInput"]
          );
          this.viper.registerCallback("ViperToolbarPlugin:updateToolbar", "ViperLangToolsPlugin", function(data) {
            tools.enableButton("langTools");
            if (data.range.collapsed === true) {
              tools.disableButton("langTools");
              tools.disableButton("ViperLangToolsPlugin:langButton");
              tools.disableButton("ViperLangToolsPlugin:abbrButton");
              tools.disableButton("ViperLangToolsPlugin:acronymButton");
            } else {
              var node = self.viper.getViperRange().getNodeSelection();
              tools.enableButton("ViperLangToolsPlugin:langButton");
              tools.enableButton("langTools");
              if (node && ViperUtil.isBlockElement(node) === true) {
                tools.disableButton("ViperLangToolsPlugin:abbrButton");
                tools.disableButton("ViperLangToolsPlugin:acronymButton");
              } else {
                tools.enableButton("ViperLangToolsPlugin:abbrButton");
                tools.enableButton("ViperLangToolsPlugin:acronymButton");
              }
            }
            var range = data.range;
            var tags = ["acronym", "abbr", "lang"];
            var c = tags.length;
            var hasActive = false;
            self.viper.Tools.getItem("VLTP:acronymInput").setValue("");
            self.viper.Tools.getItem("VLTP:abbrInput").setValue("");
            self.viper.Tools.getItem("VLTP:langInput").setValue("");
            tools.setButtonInactive("ViperLangToolsPlugin:abbrButton");
            tools.setButtonInactive("ViperLangToolsPlugin:acronymButton");
            tools.setButtonInactive("ViperLangToolsPlugin:langButton");
            tools.getItem("VLTP:abbreviationSubSection").setActionButtonTitle(_("Insert Abbreviation"));
            tools.getItem("VLTP:acronymSubSection").setActionButtonTitle(_("Insert Acronym"));
            tools.getItem("VLTP:langSubSection").setActionButtonTitle(_("Insert Language"));
            for (var i = 0; i < c; i++) {
              var element = self.getTagFromRange(range, tags[i]);
              if (element) {
                tools.setButtonActive("langTools");
                hasActive = true;
                if (ViperUtil.isTag(element, "abbr") === true) {
                  tools.setButtonActive("ViperLangToolsPlugin:abbrButton");
                  self.viper.Tools.getItem("VLTP:abbrInput").setValue(element.getAttribute("title"));
                  tools.getItem("VLTP:abbreviationSubSection").setActionButtonTitle(_("Update Abbreviation"));
                } else if (ViperUtil.isTag(element, "acronym") === true) {
                  tools.setButtonActive("ViperLangToolsPlugin:acronymButton");
                  self.viper.Tools.getItem("VLTP:acronymInput").setValue(element.getAttribute("title"));
                  tools.getItem("VLTP:acronymSubSection").setActionButtonTitle(_("Update Acronym"));
                }
                if (ViperUtil.hasAttribute(element, "lang") === true) {
                  tools.setButtonActive("ViperLangToolsPlugin:langButton");
                  self.viper.Tools.getItem("VLTP:langInput").setValue(element.getAttribute("lang"));
                  tools.getItem("VLTP:langSubSection").setActionButtonTitle(_("Update Language"));
                }
              }
            }
            if (hasActive === false) {
              tools.setButtonInactive("langTools");
            }
          });
        }
      };
    };
  }
});

// src/Plugins/ViperCharMapPlugin/ViperCharMapPlugin.js
var ViperCharMapPlugin_exports = {};
__export(ViperCharMapPlugin_exports, {
  registerPlugin: () => registerPlugin23
});
var registerPlugin23;
var init_ViperCharMapPlugin = __esm({
  "src/Plugins/ViperCharMapPlugin/ViperCharMapPlugin.js"() {
    "use strict";
    registerPlugin23 = (Viper2) => {
      const { Util: ViperUtil, Selection: ViperSelection, _ } = Viper2;
      function ViperCharMapPlugin(viper) {
        this.viper = viper;
      }
      Viper2.PluginManager.addPlugin("ViperCharMapPlugin", ViperCharMapPlugin);
      ViperCharMapPlugin.prototype = {
        init: function() {
          this._initToolbar();
        },
        _initToolbar: function() {
          var toolbar = this.viper.PluginManager.getPlugin("ViperToolbarPlugin");
          if (!toolbar) {
            return;
          }
          this.viper.registerCallback("ViperToolbarPlugin:updateToolbar", "ViperCharMapPlugin", function(data) {
            if (data.range) {
              var nodeSelection = data.range.getNodeSelection();
              if (nodeSelection && ViperUtil.isStubElement(nodeSelection) === true && ViperUtil.isTag(nodeSelection, "br") === false) {
                self.viper.Tools.disableButton("insertCharacter");
                return;
              }
            }
            self.viper.Tools.enableButton("insertCharacter");
          });
          this.viper.registerCallback("ViperToolbarPlugin:enabled", "ViperCharMapPlugin", function(data) {
            self.viper.Tools.enableButton("insertCharacter");
          });
          var self = this;
          var subContent = document.createElement("div");
          var categories = this.getCharacters("currency");
          var count = categories.length;
          var catTable = "";
          var list = '<ul class="VCMP-list">';
          for (var i = 0; i < count; i++) {
            var category = categories[i];
            list += "<li>" + category.name + "</li>";
            var tableClass = "VCMP-table";
            if (i === 0) {
              tableClass += " Viper-visible";
            }
            catTable += '<table class="' + tableClass + '" border="0" cellspacing="0" cellpadding="0"><tbody>';
            var charCount = category.chars.length;
            for (var j = 0; j < charCount; j++) {
              if (j % 10 === 0) {
                if (j !== 0) {
                  catTable += "</tr>";
                }
                catTable += "<tr>";
              }
              catTable += '<td data_viper_char="' + category.chars[j].replace("&", "") + '">' + category.chars[j] + "</td>";
            }
            catTable += "</tbody></table>";
          }
          list += "</ul>";
          var wrapper = '<div class="VCMP-wrapper">' + list + '<div class="VCMP-tablesWrapper">' + catTable + "</div></div>";
          ViperUtil.setHtml(subContent, wrapper);
          var tools = this.viper.Tools;
          var map = toolbar.createBubble(
            "ViperCMP:bubble",
            _("Insert Character"),
            subContent,
            null,
            null,
            null,
            "VCMP-main"
          );
          var toggle = tools.createButton("insertCharacter", "", _("Insert Character"), "Viper-charMap", null, true);
          toolbar.setBubbleButton("ViperCMP:bubble", "insertCharacter");
          toolbar.addButton(toggle);
          var listItems = ViperUtil.getTag("li", subContent);
          var tables = ViperUtil.getTag("table", subContent);
          ViperUtil.addClass(listItems[0], "Viper-selected");
          ViperUtil.addEvent(listItems, "click", function(e) {
            var target = ViperUtil.getMouseEventTarget(e);
            if (ViperUtil.isTag(target, "li") === false) {
              target = target.parentNode;
            }
            ViperUtil.removeClass(listItems, "Viper-selected");
            ViperUtil.addClass(target, "Viper-selected");
            var index = 0;
            while (target.previousSibling) {
              if (ViperUtil.isTag(target.previousSibling, "li") === true) {
                index++;
              }
              target = target.previousSibling;
            }
            ViperUtil.removeClass(tables, "Viper-visible");
            ViperUtil.addClass(tables[index], "Viper-visible");
          });
          var btn = document.createElement("div");
          ViperUtil.addClass(btn, "VCMP-hoverBtn Viper-button");
          subContent.appendChild(btn);
          ViperUtil.addEvent(btn, "click", function() {
            var charCode = btn.firstChild.data.charCodeAt(0);
            self.insertCharacter(charCode);
          });
          ViperUtil.hover(
            ViperUtil.getTag("td", subContent),
            function(e) {
              ViperUtil.setHtml(btn, ViperUtil.getHtml(e.target));
              var mapCoords = ViperUtil.getElementCoords(map);
              var coords = ViperUtil.getElementCoords(e.target);
              ViperUtil.setStyle(btn, "left", coords.x - mapCoords.x + "px");
              ViperUtil.setStyle(btn, "top", coords.y - mapCoords.y + "px");
              ViperUtil.setStyle(btn, "display", "block");
            },
            function(e) {
            }
          );
          ViperUtil.hover(
            btn,
            function() {
            },
            function() {
              ViperUtil.setStyle(btn, "display", "none");
            }
          );
        },
        insertCharacter: function(charCode) {
          var range = this.viper.getViperRange();
          if (range.collapsed !== true) {
            range = this.viper.deleteRangeContent();
          }
          var newNode = document.createTextNode(String.fromCharCode(charCode));
          var startNode = range.getStartNode();
          if (ViperUtil.isStubElement(startNode) === true) {
            if (ViperUtil.isTag(startNode, "br") === true) {
              ViperUtil.insertBefore(startNode, newNode);
            } else {
              ViperUtil.insertAfter(startNode, newNode);
            }
          } else {
            range.insertNode(newNode);
          }
          range.setStart(newNode, 1);
          range.collapse(true);
          ViperSelection.addRange(range);
          this.viper.contentChanged();
        },
        getCharacters: function() {
          var categories = [];
          var _getRange = function(start, stop) {
            var str = "";
            for (var i2 = start; i2 <= stop; i2++) {
              str += "|" + i2;
            }
            return str;
          };
          var chars = "$|&cent;|&pound;|&curren;|&yen";
          var htmlEnt = "|1547|2546|2547|2801|3065|3647|6107";
          htmlEnt += _getRange(8352, 8382);
          htmlEnt += "|65020|65129|65284|65504|65505|65509|65510";
          chars += htmlEnt.replace(/\|/g, ";|&#") + ";";
          chars = chars.split("|");
          var currency = chars;
          chars = "&Agrave;|&agrave;|&Aacute;|&aacute;|&Acirc;|&acirc;|&Atilde;|&atilde;|&Auml;|&auml;|&Aring;|&aring;|&#256;|&#257;|&AElig;|&aelig;|&Ccedil;|&ccedil;|&ETH;|&eth;|&Egrave;|&egrave;|&Eacute;|&eacute;|&Ecirc;|&ecirc;|&Euml;|&euml;|&#274;|&#275;|&Igrave;|&igrave;|&Iacute;|&iacute;";
          chars += "|&Icirc;|&icirc;|&Iuml;|&iuml;|&#298;|&#299;|&micro;|&Ntilde;|&ntilde;|&Ograve;|&ograve;|&Oacute;|&oacute;|&Ocirc;|&ocirc;|&Otilde;|&otilde;|&Ouml;|&ouml;|&#332;|&#333;|&Oslash;|&oslash;|&OElig;|&oelig;|&Scaron;|&scaron;|&szlig;|&THORN;|&thorn;|&Ugrave;|&ugrave;|&Uacute;|&uacute;|&Ucirc;|&ucirc;|&Uuml;|&uuml;|&#362;|&#363;|&Yacute;|&yacute;|&yuml;|&Yuml;";
          chars = chars.split("|");
          var latin = chars;
          chars = "&sup1;|&sup2;|&sup3;|&times;|&divide;|&frac14;|&frac12;|&frac34;|&ordf;|&ordm;|&not;|&deg;|&plusmn;|&Delta;|&fnof;|&Omega;|&circ;|&tilde;|&ndash;|&mdash;|&dagger;|&Dagger;|&bull;|&hellip;|&radic;|&infin;|&int;|&part;|&ne;|&le;|&ge;|&sum;|&permil;|&prod;|&pi;|&loz;";
          chars = chars.split("|");
          var maths = chars;
          chars = "&uml;|&macr;|&acute;|&cedil;|&iexcl;|&iquest;|&middot;|&brvbar;|&laquo;|&raquo;|&para;|&sect;|&copy;|&reg;|&trade;";
          chars = chars.split("|");
          var symbols = chars;
          var greek = [];
          for (var i = 880; i <= 1023; i++) {
            greek.push("&#" + i + ";");
          }
          categories.push({
            name: _("Symbols"),
            chars: symbols
          });
          categories.push({
            name: _("Latin"),
            chars: latin
          });
          categories.push({
            name: _("Mathematics"),
            chars: maths
          });
          categories.push({
            name: _("Currency"),
            chars: currency
          });
          categories.push({
            name: _("Greek"),
            chars: greek
          });
          return categories;
        }
      };
    };
  }
});

// src/Utils/outerHeight.ts
var outerHeight;
var init_outerHeight = __esm({
  "src/Utils/outerHeight.ts"() {
    "use strict";
    outerHeight = (element, includeMargin = false) => {
      const style = window.getComputedStyle(element);
      const height = element.offsetHeight;
      const marginTop = includeMargin ? parseFloat(style.marginTop) : 0;
      const marginBottom = includeMargin ? parseFloat(style.marginBottom) : 0;
      return height + marginTop + marginBottom;
    };
  }
});

// src/Plugins/ViperCursorAssistPlugin/ViperCursorAssistPlugin.js
var ViperCursorAssistPlugin_exports = {};
__export(ViperCursorAssistPlugin_exports, {
  registerPlugin: () => registerPlugin24
});
var registerPlugin24;
var init_ViperCursorAssistPlugin = __esm({
  "src/Plugins/ViperCursorAssistPlugin/ViperCursorAssistPlugin.js"() {
    "use strict";
    init_outerHeight();
    registerPlugin24 = (Viper2) => {
      const { Util: ViperUtil, Selection: ViperSelection, _ } = Viper2;
      function ViperCursorAssistPlugin(viper) {
        this.viper = viper;
        this._dist = 30;
      }
      Viper2.PluginManager.addPlugin("ViperCursorAssistPlugin", ViperCursorAssistPlugin);
      ViperCursorAssistPlugin.prototype = {
        init: function() {
          var self = this;
          var t = null;
          var validElems = "table,hr,img,object,ul,ol,iframe,canvas,audio,embed,figure,pre,blockquote";
          var validElemsArray = validElems.split(",");
          var prevElement = null;
          var prevPos = null;
          var hover2 = false;
          var _removeLine = function(line, clearPrev) {
            if (line) {
              ViperUtil.remove(line);
            }
            hover2 = false;
            if (clearPrev !== false) {
              prevElement = null;
              prevPos = null;
            }
          };
          this.viper.registerCallback("Viper:editableElementChanged", "ViperCursorAssistPlugin", function() {
            ViperUtil.addEvent(ViperUtil.getDocuments(), "mousemove", function(e) {
              clearTimeout(t);
              t = setTimeout(function() {
                var line = ViperUtil.getid(self.viper.getId() + "-cursorAssist");
                if (self.viper.isEnabled() === false) {
                  if (line) {
                    _removeLine(line);
                  }
                  return;
                }
                var hoverElem = self.viper.getElementAtCoords(e.clientX, e.clientY);
                if (hoverElem && (hover2 === true || hoverElem === line || hoverElem.parentNode && hoverElem.parentNode.parentNode === line)) {
                  return;
                }
                if (!hoverElem || self.viper.isOutOfBounds(hoverElem) === true) {
                  _removeLine(line);
                  return;
                }
                if (ViperUtil.inArray(ViperUtil.getTagName(hoverElem), validElemsArray) !== true) {
                  var elems = ViperUtil.getParents(hoverElem, validElems, self.viper.getViperElement());
                  if (elems.length === 0) {
                    _removeLine(line);
                    return;
                  } else {
                    hoverElem = elems.shift();
                    if (elems.length > 0 && (ViperUtil.isTag(hoverElem, "ul") === true || ViperUtil.isTag(hoverElem, "ol") === true)) {
                      if (ViperUtil.getParents(hoverElem, "ul,ol", self.viper.getViperElement()).length > 0) {
                        _removeLine(line);
                        return;
                      }
                    }
                  }
                }
                var sibling = "";
                var scroll = ViperUtil.getScrollCoords();
                var mousePos = e.clientY + scroll.y;
                var elemRect = ViperUtil.getBoundingRectangle(hoverElem);
                var dist = self._dist;
                var childScrollCoords = { x: 0, y: 0 };
                if (self.viper.isEditableInIframe() === true) {
                  childScrollCoords = ViperUtil.getScrollCoords(hoverElem.ownerDocument.defaultView);
                  mousePos += childScrollCoords.y;
                }
                if (ViperUtil.isTag(hoverElem, "table") === true && ViperUtil.isBrowser("firefox") === true) {
                  var caption = ViperUtil.getTag("caption", hoverElem);
                  if (caption) {
                    elemRect.y2 += outerHeight(caption[0], true);
                  }
                }
                var height = elemRect.y2 - elemRect.y1;
                if (height < 40) {
                  dist = height / 2;
                }
                var relYPoint = null;
                if (elemRect.y1 + dist > mousePos) {
                  sibling = "previousSibling";
                  relYPoint = elemRect.y1;
                } else if (elemRect.y2 - dist < mousePos) {
                  sibling = "nextSibling";
                  relYPoint = elemRect.y2;
                } else {
                  _removeLine(line);
                  return;
                }
                if (prevElement === hoverElem && prevPos === sibling) {
                  return;
                }
                if (self.isInToolbarBounds(relYPoint) === true) {
                  return;
                }
                prevElement = hoverElem;
                prevPos = sibling;
                var inBetween = false;
                var canShowLine = function(siblingType) {
                  var siblingElem = hoverElem[siblingType];
                  while (siblingElem) {
                    if (siblingElem.nodeType !== ViperUtil.TEXT_NODE) {
                      if (ViperUtil.inArray(ViperUtil.getTagName(siblingElem), validElemsArray) !== true) {
                        if (line) {
                          _removeLine(line, false);
                        }
                        return false;
                      } else {
                        inBetween = true;
                        return true;
                      }
                    }
                    siblingElem = siblingElem[siblingType];
                  }
                  return true;
                };
                if (canShowLine(sibling) !== true) {
                  return;
                }
                if (line) {
                  _removeLine(line, false);
                }
                line = document.createElement("div");
                line.id = self.viper.getId() + "-cursorAssist";
                ViperUtil.addClass(line, "ViperCursorAssistPlugin");
                ViperUtil.setHtml(
                  line,
                  '<span class="ViperCursorAssistPlugin-cursorText">Insert</span><span class="ViperCursorAssistPlugin-cursorLine"></span>'
                );
                hover2 = false;
                ViperUtil.hover(
                  line,
                  function() {
                    hover2 = true;
                  },
                  function() {
                    hover2 = false;
                  }
                );
                ViperUtil.addEvent(line, "mousedown", function() {
                  _removeLine(line, false);
                  var p = document.createElement("p");
                  ViperUtil.setHtml(p, "<br/>");
                  if (ViperUtil.isBlockElement(hoverElem) === false || ViperUtil.isStubElement(hoverElem) === true) {
                    var blockParent = ViperUtil.getFirstBlockParent(hoverElem, self.viper.getViperElement());
                    if (blockParent) {
                      if (ViperUtil.isTag(blockParent, ["td", "th", "caption"]) !== true) {
                        hoverElem = blockParent;
                      }
                    }
                  }
                  if (sibling === "previousSibling") {
                    ViperUtil.insertBefore(hoverElem, p);
                  } else {
                    ViperUtil.insertAfter(hoverElem, p);
                  }
                  setTimeout(function() {
                    self.viper.focus();
                    var range = self.viper.getCurrentRange();
                    var offset = 0;
                    range.setEnd(p.firstChild, offset);
                    range.setStart(p.firstChild, offset);
                    range.collapse(false);
                    ViperSelection.addRange(range);
                    self.viper.contentChanged();
                  }, 10);
                });
                if (self.viper.isEditableInIframe() === true) {
                  childScrollCoords = ViperUtil.getScrollCoords(hoverElem.ownerDocument.defaultView);
                  elemRect.y1 -= childScrollCoords.y;
                  elemRect.y2 -= childScrollCoords.y;
                  var frameOffset = ViperUtil.getDocumentOffset(hoverElem.ownerDocument);
                  elemRect.y1 += frameOffset.y;
                  elemRect.y2 += frameOffset.y;
                  elemRect.x1 += frameOffset.x;
                  elemRect.x2 += frameOffset.x;
                }
                ViperUtil.removeClass(line, "insertBetween");
                if (sibling === "previousSibling") {
                  ViperUtil.setStyle(line, "top", elemRect.y1 + "px");
                  ViperUtil.removeClass(line, "insertAfter");
                  if (inBetween === true) {
                    ViperUtil.addClass(line, "insertBetween");
                  } else {
                    ViperUtil.addClass(line, "insertBefore");
                  }
                } else {
                  ViperUtil.setStyle(line, "top", elemRect.y2 + "px");
                  ViperUtil.removeClass(line, "insertBefore");
                  if (inBetween === true) {
                    ViperUtil.addClass(line, "insertBetween");
                  } else {
                    ViperUtil.addClass(line, "insertAfter");
                  }
                }
                ViperUtil.setStyle(line, "left", elemRect.x1 + "px");
                ViperUtil.setStyle(line, "width", elemRect.x2 - elemRect.x1 + "px");
                self.viper.addElement(line);
                setTimeout(function() {
                  if (self.isInToolbarBounds(relYPoint) === true) {
                    _removeLine(line);
                    return;
                  }
                }, 100);
              }, 200);
            });
          });
          this.viper.registerCallback(["Viper:mouseDown", "Viper:mouseUp"], "ViperCursorAssistPlugin", function() {
            setTimeout(function() {
              var line = ViperUtil.getid(self.viper.getId() + "-cursorAssist");
              if (line) {
                _removeLine(line, false);
              }
            }, 50);
          });
        },
        isInToolbarBounds: function(yPoint) {
          return false;
        },
        isPluginElement: function(elem) {
          var viperid = this.viper.getId();
          if (elem.id === viperid + "-cursorAssist" || elem.parentNode && elem.parentNode.id === viperid + "-cursorAssist") {
            return true;
          }
        }
      };
    };
  }
});

// src/Plugins/ViperReplacementPlugin/ViperReplacementPlugin.js
var ViperReplacementPlugin_exports = {};
__export(ViperReplacementPlugin_exports, {
  registerPlugin: () => registerPlugin25
});
var registerPlugin25;
var init_ViperReplacementPlugin = __esm({
  "src/Plugins/ViperReplacementPlugin/ViperReplacementPlugin.js"() {
    "use strict";
    registerPlugin25 = (Viper2) => {
      const { Util: ViperUtil, Selection: ViperSelection, _ } = Viper2;
      function ViperReplacementPlugin(viper) {
        this.viper = viper;
        this._searchPattern = null;
        this._replacementsCallback = null;
      }
      Viper2.PluginManager.addPlugin("ViperReplacementPlugin", ViperReplacementPlugin);
      ViperReplacementPlugin.prototype = {
        setSettings: function(settings) {
          if (settings.callback) {
            this.setReplacementsCallback(settings.callback);
          }
          if (settings.pattern) {
            this.setSearchPattern(settings.pattern);
          }
          var self = this;
          this.showReplacements(null, function() {
            self.viper.getHistoryManager().clear();
            self.viper.getHistoryManager().add();
          });
        },
        isSpecialElement: function(element) {
          if (ViperUtil.hasAttribute(element, "data-viper-keyword") === true) {
            return true;
          }
          if (element.childNodes.length !== 1) {
            return false;
          }
          return this.isSpecialElement(element.firstChild);
        },
        init: function() {
          var self = this;
          this.viper.registerCallback("Viper:editableElementChanged", "ViperReplacementPlugin", function() {
            self.viper.getHistoryManager().clear();
            self.showReplacements(null, function() {
              self.viper.getHistoryManager().add();
            });
          });
          this.viper.registerCallback("Viper:getHtml", "ViperReplacementPlugin", function(data) {
            self.showKeywords(data.element);
          });
          this.viper.registerCallback("Viper:setHtml", "ViperReplacementPlugin", function(data, callback) {
            self.showReplacements(data.element, callback);
            return function() {
            };
          });
          this.viper.registerCallback("Viper:setHtmlContent", "ViperReplacementPlugin", function(content, callback) {
            self.showAttributeReplacements(content, function(cont) {
              callback.call(this, cont);
            });
            return function() {
            };
          });
          var ignoredKeys = [9, 13, 16, 17, 18, 20, 27, 91, 93, 37, 38, 39, 40, 224];
          this.viper.registerCallback("Viper:keyDown", "ViperReplacementPlugin", function(e) {
            if (ViperUtil.inArray(e.which, ignoredKeys) === true) {
              return;
            } else if (e.metaKey === true || e.ctrlKey === true) {
              return;
            }
            var range = self.viper.getViperRange();
            var startNode = range.getStartNode();
            var selNode = range.getNodeSelection();
            if (startNode && startNode.nodeType === ViperUtil.TEXT_NODE) {
              var rep = self._getKeywordElement(startNode);
              if (!rep) {
                if (range.startOffset === 0) {
                  rep = self._getKeywordElement(range.getPreviousContainer(startNode, null, false, false, true));
                  if (rep) {
                    if (e.which === ViperUtil.DOM_VK_BACKSPACE || e.which === ViperUtil.DOM_VK_DELETE) {
                      var elem = ViperUtil.getTopSurroundingParent(rep) || rep;
                      ViperUtil.remove(elem);
                      self.viper.contentChanged();
                      return false;
                    }
                    if (e.which === 32 && range.startContainer.data === "") {
                      startNode.data = String.fromCharCode(160);
                      range.setStart(startNode, 1);
                      range.collapse(true);
                      ViperSelection.addRange(range);
                      return false;
                    } else {
                      range.setStart(startNode, 0);
                    }
                    range.collapse(true);
                    ViperSelection.addRange(range);
                  } else {
                    rep = self._getKeywordElement(range.getNextContainer(startNode, null, false, false, true));
                    if (rep) {
                      if (e.which === ViperUtil.DOM_VK_BACKSPACE || e.which === ViperUtil.DOM_VK_DELETE) {
                        return;
                      }
                      if (startNode.data[0] === " ") {
                        startNode.data = String.fromCharCode(160) + startNode.data;
                      } else if (startNode.data.length === 0) {
                        startNode.data = String.fromCharCode(160);
                      } else {
                        startNode.data = " " + startNode.data;
                      }
                      range.setStart(startNode, 0);
                      range.collapse(true);
                      ViperSelection.addRange(range);
                      setTimeout(function() {
                        startNode.data = ViperUtil.rtrim(startNode.data);
                        if (startNode.data.length > 0) {
                          range.setStart(startNode, 1);
                        } else {
                          range.setStart(startNode, 0);
                        }
                        range.collapse(true);
                        ViperSelection.addRange(range);
                      }, 2);
                    }
                  }
                  return;
                }
                if (!rep) {
                  return;
                }
              }
            } else {
              rep = self._getKeywordElement(selNode);
            }
            if (selNode === rep) {
              var parents = ViperUtil.getSurroundingParents(selNode);
              if (parents.length > 0) {
                selNode = parents.pop();
              }
              var info = self._normaliseTextNodeSiblings(selNode);
              if (info) {
                range.setStart(info.textNode, info.splitOffset);
              } else {
                var cont = range.getPreviousContainer(selNode, null, false, false, true);
                if (!cont) {
                  cont = range.getNextContainer(selNode, null, false, false, true);
                  if (!cont) {
                    cont = document.createTextNode("");
                    ViperUtil.insertBefore(selNode, cont);
                  } else {
                    self._trimExtraSpaceFromStart(cont, true);
                  }
                  range.setStart(cont, 0);
                } else {
                  self._trimExtraSpaceFromEnd(cont, true);
                  range.setStart(cont, cont.data.length);
                }
              }
              range.collapse(true);
              ViperSelection.addRange(range);
              ViperUtil.remove(selNode);
              return;
            }
          });
          if (ViperUtil.isBrowser("safari") === true) {
            this.viper.registerCallback("Viper:keyPress", "ViperReplacementPlugin", function(e) {
              var range = self.viper.getViperRange();
              var startNode = range.getStartNode();
              var selNode = range.getNodeSelection();
              var rep = self._getKeywordElement(startNode);
              if (!rep) {
                return;
              }
              if (ViperUtil.isText(range.startContainer) === true && range.startOffset === range.startContainer.data.length && range.collapsed === true) {
                var char = String.fromCharCode(e.which);
                var textNode = rep.nextSibling;
                if (ViperUtil.isText(textNode) === true && textNode.data.length === 0) {
                  textNode.data = char + textNode.data;
                } else {
                  textNode = document.createTextNode(char);
                }
                ViperUtil.insertAfter(rep, textNode);
                if (char === " " && textNode.nextSibling === null && ViperUtil.isBlockElement(textNode.parentNode) === true) {
                  textNode.parentNode.appendChild(document.createElement("br"));
                }
                range.setStart(textNode, 1);
                range.collapse(true);
                ViperSelection.addRange(range);
                self.viper.fireNodesChanged();
                return false;
              }
            });
          }
          var ignoreSelectionChange = false;
          this.viper.registerCallback("Viper:selectionChanged", "ViperReplacementPlugin", function(range) {
            if (ignoreSelectionChange === true) {
              ignoreSelectionChange = false;
              return;
            }
            var start = range.getStartNode();
            var end = range.getEndNode();
            var startKeyword = self._getKeywordElement(start);
            var endKeyword = self._getKeywordElement(end);
            if (startKeyword !== false && startKeyword === endKeyword) {
              if (range.collapsed === true && start.nodeType === ViperUtil.TEXT_NODE) {
                if (range.startOffset === start.data.length) {
                  var textNode = startKeyword.nextSibling;
                  if (!textNode || textNode.nodeType !== ViperUtil.TEXT_NODE) {
                    textNode = document.createTextNode("");
                    ViperUtil.insertAfter(startKeyword, textNode);
                  }
                  range.setStart(textNode, 0);
                  range.collapse(true);
                  ViperSelection.addRange(range);
                  return;
                } else if (range.startOffset === 0) {
                  var textNode = document.createTextNode("");
                  ViperUtil.insertBefore(startKeyword, textNode);
                  range.setStart(textNode, 0);
                  range.collapse(true);
                  ViperSelection.addRange(range);
                  return;
                }
              }
              if (startKeyword.firstChild.nodeType === ViperUtil.TEXT_NODE && startKeyword.lastChild.nodeType === ViperUtil.TEXT_NODE) {
                range.setStart(startKeyword.firstChild, 0);
                range.setEnd(startKeyword.lastChild, startKeyword.lastChild.data.length);
              } else {
                range.selectNode(startKeyword);
              }
              ViperSelection.addRange(range);
              ignoreSelectionChange = true;
              self.viper.fireSelectionChanged(null, true);
            } else if (startKeyword !== false && endKeyword === false) {
              var node = startKeyword.previousSibling;
              if (!node || node.nodeType !== ViperUtil.TEXT_NODE) {
                node = document.createTextNode("");
                ViperUtil.insertBefore(startKeyword, node);
              }
              range.setStart(node, node.data.length);
              ViperSelection.addRange(range);
            } else if (endKeyword !== false && startKeyword === false) {
              var node = endKeyword.nextSibling;
              if (!node || node.nodeType !== ViperUtil.TEXT_NODE) {
                node = document.createTextNode("");
                ViperUtil.insertAfter(endKeyword, node);
              }
              range.setEnd(node, 0);
              ViperSelection.addRange(range);
            }
          });
          this.viper.registerCallback(
            "ViperInlineToolbarPlugin:lineageItemSelected",
            "ViperReplacementPlugin",
            function(node) {
              ignoreSelectionChange = true;
            }
          );
          this.viper.registerCallback("Viper:attributeRemoved", "ViperReplacementPlugin", function(data) {
            var cloneName = "data-viper-" + data.attribute;
            if (ViperUtil.hasAttribute(data.element, cloneName) === true) {
              ViperUtil.removeAttr(data.element, cloneName);
            }
            var remove2 = true;
            for (var i = 0; i < data.element.attributes.length; i++) {
              if (ViperUtil.hasAttribute(data.element, "data-viper-" + data.element.attributes[i].nodeName) === true) {
                remove2 = false;
                break;
              }
            }
            if (remove2 === true) {
              ViperUtil.removeAttr(data.element, "data-viper-attribute-keywords");
            }
          });
          this.viper.addAttributeGetModifier(function(element, attribute, value) {
            value = element.getAttribute("data-viper-" + attribute) || value;
            return value;
          });
          this.viper.addAttributeSetModifier(function(element, attribute, value, callback) {
            if (self._canIgnoreAttribute(attribute, value) === true) {
              return value;
            }
            var regex = new RegExp(self.getReplacementRegex(), "gi");
            var matches = value.match(regex);
            if (matches !== null) {
              var keywords = {};
              var match = null;
              while (match = matches.pop()) {
                keywords[match] = "";
              }
              self.getKeywordReplacements(keywords, function(replacements) {
                for (var keyword in keywords) {
                  self._replaceAttributeKeyword(element, attribute, keyword, replacements[keyword], value, true);
                }
                callback.call(this);
              });
              return false;
            } else {
              var cloneName = "data-viper-" + attribute;
              if (ViperUtil.hasAttribute(element, cloneName) === true) {
                ViperUtil.removeAttr(element, cloneName);
              }
            }
            return value;
          });
          this.viper.registerCallback(
            "ViperInlineToolbarPlugin:getReadableTagName",
            "ViperReplacementPlugin",
            function(data) {
              if (data.tag && ViperUtil.hasAttribute(data.tag, "data-viper-keyword") === true) {
                return _("Keyword");
              }
              return null;
            }
          );
        },
        replaceKeywords: function(string, callback) {
          if (!callback) {
            return;
          }
          var regex = this.getReplacementRegex();
          if (!regex) {
            callback.call(this, string);
            return;
          }
          regex = new RegExp(regex, "gi");
          var matches = string.match(regex);
          if (matches) {
            this.getKeywordReplacements(matches, function(replacements) {
              for (var keyword in replacements) {
                string = string.replace(keyword, replacements[keyword]);
              }
              callback.call(this, string);
            });
          } else {
            callback.call(this, string);
          }
        },
        _trimExtraSpaceFromStart: function(textNode, useNbsp) {
          var fromIdx = -1;
          for (var i = 0; i < textNode.data.length; i++) {
            if (textNode.data[i] === " ") {
              fromIdx = i;
            } else {
              break;
            }
          }
          if (useNbsp === true && fromIdx >= 0) {
            textNode.data = String.fromCharCode(160) + textNode.data.substr(fromIdx + 1);
          } else if (fromIdx > 0) {
            textNode.data = textNode.data.substr(fromIdx);
          }
        },
        _trimExtraSpaceFromEnd: function(textNode, useNbsp) {
          var fromIdx = -1;
          for (var i = textNode.data.length - 1; i >= 0; i--) {
            var c = textNode.data[i];
            if (c === " ") {
              fromIdx = i;
            } else {
              break;
            }
          }
          if (useNbsp === true && fromIdx >= 0) {
            textNode.data = textNode.data.substr(0, fromIdx) + String.fromCharCode(160);
          } else if (fromIdx > 0) {
            textNode.data = textNode.data.substr(0, fromIdx);
          }
        },
        _normaliseTextNodeSiblings: function(element) {
          var prevCont = element.previousSibling;
          var nextCont = element.nextSibling;
          var info = null;
          if (prevCont && nextCont && prevCont.nodeType === ViperUtil.TEXT_NODE && nextCont.nodeType === ViperUtil.TEXT_NODE) {
            info = {
              splitOffset: prevCont.data.length,
              textNode: prevCont
            };
            if (nextCont.data[0] === " " && prevCont.data[prevCont.data.length - 1] === " ") {
              nextCont.data = String.fromCharCode(160) + nextCont.data.substr(1);
            }
            prevCont.data += nextCont.data;
          }
          return info;
        },
        _fixRange: function(range, keywordElem, start) {
          if (start === true) {
            var cont = range.getPreviousContainer(keywordElem);
            range.setEnd(cont, cont.data.length);
          } else {
            var cont = range.getNextContainer(keywordElem);
            range.setStart(cont, 0);
            range.collapse(true);
          }
          return range;
        },
        _getKeywordElement: function(elem) {
          if (!elem) {
            return false;
          }
          if (ViperUtil.hasAttribute(elem, "data-viper-keyword") === true) {
            return elem;
          }
          var viperElement = this.viper.getViperElement();
          while (elem.parentNode && elem.parentNode !== viperElement) {
            elem = elem.parentNode;
            if (ViperUtil.hasAttribute(elem, "data-viper-keyword") === true) {
              return elem;
            }
          }
          return false;
        },
        setReplacementsCallback: function(callback) {
          this._replacementsCallback = callback;
        },
        setSearchPattern: function(regexStr) {
          this._searchPattern = regexStr;
        },
        getReplacementRegex: function() {
          return this._searchPattern;
        },
        getReplacementsCallback: function() {
          return this._replacementsCallback;
        },
        /**
         * Replaceses all the keywords in the content with their replacements.
         */
        showReplacements: function(element, callback) {
          element = element || this.viper.getViperElement();
          var cache = {};
          var keywords = this.scanKeywords(element, cache);
          if (!keywords || ViperUtil.isEmpty(keywords) === true) {
            if (callback) {
              callback.call(self);
            }
            return;
          }
          var self = this;
          this.getKeywordReplacements(keywords, function(replacements) {
            self._convertContentKeywords(replacements, cache);
            var content = ViperUtil.getHtml(element);
            content = self._convertAttributeKeywords(content, replacements, cache);
            ViperUtil.setHtml(element, content);
            if (callback) {
              callback.call(self);
            }
          });
        },
        showAttributeReplacements: function(content, callback) {
          var keywords = {};
          var cache = {};
          this._scanAttributeKeywords(content, keywords, cache);
          var self = this;
          this.getKeywordReplacements(keywords, function(replacements) {
            content = self._convertAttributeKeywords(content, replacements, cache);
            if (callback) {
              callback.call(self, content);
            }
          });
        },
        /**
         * Shows the keywords instead of their replacements.
         */
        showKeywords: function(elem) {
          this._convertContentReplacementsToKeywords(elem);
          this._convertAttributeReplacementsToKeywords(elem);
        },
        _convertContentReplacementsToKeywords: function(parentElem) {
          var keywordElements = ViperUtil.find(parentElem, "[data-viper-keyword]");
          var ln = keywordElements.length;
          for (var i = 0; i < ln; i++) {
            var keywordElem = keywordElements[i];
            var keyword = ViperUtil.attr(keywordElem, "data-viper-keyword");
            if (keywordElem.attributes.length > 2) {
              ViperUtil.removeAttr(keywordElem, "data-viper-keyword");
              ViperUtil.removeAttr(keywordElem, "title");
              ViperUtil.setHtml(keywordElem, keyword);
            } else {
              var textNode = document.createTextNode(keyword);
              ViperUtil.insertAfter(keywordElem, textNode);
              ViperUtil.remove(keywordElem);
            }
          }
        },
        _convertAttributeReplacementsToKeywords: function(parentElem) {
          parentElem = parentElem || this.viper.getViperElement();
          var elems = ViperUtil.getTag("*", parentElem);
          var ln = elems.length;
          for (var i = 0; i < elems.length; i++) {
            for (var j = elems[i].attributes.length - 1; j >= 0; j--) {
              var attr2 = elems[i].attributes[j];
              if (attr2.nodeName === "data-viper-attribute-keywords") {
                ViperUtil.removeAttr(elems[i], attr2.nodeName);
              } else if (attr2.nodeName.indexOf("data-viper-") === 0) {
                var attrName = attr2.nodeName.replace("data-viper-", "");
                if (attrName === "src") {
                  attrName = "__viper_attr_src";
                  ViperUtil.removeAttr(elems[i], "src");
                }
                ViperUtil.attr(elems[i], attrName, attr2.value);
                ViperUtil.removeAttr(elems[i], attr2.nodeName);
              }
            }
          }
        },
        getKeywordReplacements: function(keywords, callback) {
          if (ViperUtil.isArray(keywords) === true) {
            var keywordsObj = {};
            for (var i = 0; i < keywords.length; i++) {
              keywordsObj[keywords[i]] = "";
            }
            keywords = keywordsObj;
          }
          var repCallback = this.getReplacementsCallback();
          if (!repCallback) {
            callback.call(this, keywords);
            return;
          }
          var self = this;
          repCallback(keywords, function(replacements) {
            callback.call(self, replacements);
          });
        },
        /**
         * Scands the text nodes and element attributes for keywords.
         *
         * @param {DOMNode} parentElem The element to scan.
         *
         * @return {array}
         */
        scanKeywords: function(parentElem, cache) {
          if (!this.getReplacementRegex()) {
            return;
          }
          var keywords = {};
          parentElem = parentElem || this.viper.getViperElement();
          var content = ViperUtil.getHtml(parentElem);
          this._scanAttributeKeywords(content, keywords, cache);
          this._scanContentKeywords(parentElem, keywords, cache);
          return keywords;
        },
        _scanAttributeKeywords: function(content, keywords, cache) {
          var self = this;
          var subRegex = `\\s+([:\\w]+)(?:\\s*=\\s*("(?:[^"]+)?"|'(?:[^']+)?'|[^'">\\s]+))?`;
          var tagRegex = new RegExp("(<[\\w:]+)(?:" + subRegex + ")+\\s*(/?>)", "g");
          var attrRegex = new RegExp(subRegex, "g");
          var regex = self.getReplacementRegex();
          if (!regex || !content) {
            return keywords;
          }
          regex = new RegExp(regex, "gi");
          cache.attributes = {};
          content = content.replace(/__viper_attr_/g, "");
          content = content.replace(tagRegex, function(match, tagStart, a, tagEnd) {
            match = match.replace(attrRegex, function(a2, attrName, attrValue) {
              attrName = attrName.toLowerCase();
              var res = " " + attrName;
              if (attrValue) {
                res += "=" + attrValue;
                if (!cache.attributes[res]) {
                  var matches = attrValue.match(regex);
                  if (matches !== null) {
                    cache.attributes[res] = [];
                    var match2 = null;
                    while (match2 = matches.pop()) {
                      cache.attributes[res].push(match2);
                      keywords[match2] = "";
                    }
                  }
                }
              }
              return res;
            });
            return match;
          });
          return keywords;
        },
        _scanContentKeywords: function(parentElem, keywords, cache) {
          parentElem = parentElem || this.viper.getViperElement();
          var regex = this.getReplacementRegex();
          if (!regex || !parentElem) {
            return keywords;
          }
          regex = new RegExp(regex, "gi");
          cache.textNodes = [];
          var textNodes = ViperUtil.getTextNodes(parentElem);
          var ln = textNodes.length;
          var prevNode = null;
          var nodeData = null;
          for (var i = 0; i < ln; i++) {
            var matches = textNodes[i].data.match(regex);
            if (matches !== null) {
              var match = null;
              while (match = matches.shift()) {
                if (prevNode !== textNodes[i]) {
                  nodeData = {
                    elem: textNodes[i],
                    keywords: []
                  };
                  cache.textNodes.push(nodeData);
                }
                if (ViperUtil.isset(keywords[match]) === false) {
                  keywords[match] = "";
                }
                nodeData.keywords.push(match);
                prevNode = textNodes[i];
              }
            }
          }
          return keywords;
        },
        /**
         * Converts keywords inside conent (not attributes).
         */
        _convertContentKeywords: function(replacements, cache) {
          var ln = cache.textNodes.length;
          for (var i = 0; i < ln; i++) {
            var kc = cache.textNodes[i].keywords.length;
            for (var j = kc - 1; j >= 0; j--) {
              var textNode = cache.textNodes[i].elem;
              var keyword = cache.textNodes[i].keywords[j];
              if (textNode.data === keyword && ViperUtil.isTag(textNode.parentNode, "span") === true) {
                var parent = textNode.parentNode;
                ViperUtil.attr(parent, "data-viper-keyword", keyword);
                ViperUtil.attr(parent, "title", keyword);
                ViperUtil.setHtml(parent, replacements[keyword]);
              } else {
                var startIndex = textNode.data.lastIndexOf(keyword);
                if (startIndex < 0) {
                  continue;
                }
                var startText = textNode.data.substr(0, startIndex);
                var endText = textNode.data.substr(startIndex + keyword.length);
                var newTextNode = document.createTextNode(endText);
                textNode.data = startText;
                ViperUtil.insertAfter(textNode, newTextNode);
                var keywordHolder = this._createUneditableElement({
                  attributes: {
                    "data-viper-keyword": keyword,
                    title: keyword
                  },
                  content: replacements[keyword]
                });
                ViperUtil.insertAfter(textNode, keywordHolder);
              }
            }
          }
        },
        /**
         * Creates an element that cannot be edited.
         */
        _createUneditableElement: function(options) {
          if (!options) {
            options = {};
          }
          var tagName = options.tagName || "div";
          var content = options.content || "";
          var elem = document.createElement(tagName);
          ViperUtil.setHtml(elem, content);
          if (!options.tagName && ViperUtil.hasBlockChildren(elem) !== true) {
            elem = document.createElement("span");
            ViperUtil.setHtml(elem, content);
          }
          if (options.attributes) {
            for (var attrName in options.attributes) {
              ViperUtil.attr(elem, attrName, options.attributes[attrName]);
            }
          }
          return elem;
        },
        _convertAttributeKeywords: function(content, replacements, cache) {
          if (typeof content !== "string") {
            content = ViperUtil.getHtml(content);
          }
          content = content.replace(/__viper_attr_/g, "");
          for (var attr2 in cache.attributes) {
            var attrRep = attr2;
            for (var i = 0; i < cache.attributes[attr2].length; i++) {
              var keyword = cache.attributes[attr2][i];
              attrRep = attrRep.replace(keyword, replacements[keyword]) + " data-viper-" + ViperUtil.ltrim(attr2);
            }
            content = ViperUtil.replaceAll(attr2, attrRep, content);
          }
          return content;
        },
        _replaceAttributeKeyword: function(element, attribute, keyword, replacement, value, forceUpdate) {
          if (this._canIgnoreAttribute(attribute, value) === true) {
            return value;
          }
          var cloneName = "data-viper-" + attribute;
          if (forceUpdate === true || ViperUtil.hasAttribute(element, cloneName) === false) {
            ViperUtil.attr(element, cloneName, value);
          }
          var realValue = value;
          realValue = realValue.replace(keyword, replacement);
          ViperUtil.attr(element, attribute, realValue);
          ViperUtil.attr(element, "data-viper-attribute-keywords", "true");
          return realValue;
        },
        _canIgnoreAttribute: function(attribute, value) {
          if (attribute === "src" && value.indexOf("data:image") === 0) {
            return true;
          }
          return false;
        }
      };
    };
  }
});

// src/index.js
var src_exports = {};
__export(src_exports, {
  Viper: () => Viper
});
module.exports = __toCommonJS(src_exports);

// src/Lib/Viper.js
init_getParents();
function Viper(id, options, callback, editables) {
  this.id = id;
  this._document = document;
  this._browserType = null;
  this._specialKeys = [];
  this._prevRange = null;
  this.enabled = false;
  this.inlineMode = false;
  this.HistoryManager = null;
  this.PluginManager = null;
  this.Tools = null;
  this._settings = {};
  this._viperElementHolder = null;
  this._registeredElements = [];
  this._attributeGetModifiers = [];
  this._attributeSetModifiers = [];
  this._mouseDownEvent = null;
  this._retrievingValues = 0;
  this._memberElements = [];
  this._viperRange = null;
  this.callbacks = {};
  if (!options) {
    options = {};
  }
  this.setSetting("emptyTableCellContent", "<br />");
  this.init();
  if (editables && editables.length > 0) {
    this.registerEditableElements(editables);
    for (var i = 0; i < editables.length; i++) {
      (function(editableElement) {
        Viper.Util.addEvent(editableElement, "mousedown", function(e) {
          self.setEditableElement(editableElement);
        });
      })(editables[i]);
    }
  }
  if (options) {
    var self = this;
    this._processOptions(options, function() {
      if (callback) {
        callback.call(self, self);
      }
    });
  }
}
Viper.document = document;
Viper.window = window;
Viper.prototype = {
  get document() {
    return this._document;
  },
  /**
   * Initialise Viper.
   *
   * @return {void}
   */
  init: function() {
    this.Tools = new Viper.Tools(this);
    this.HistoryManager = new Viper.HistoryManager(this);
    this.PluginManager = new Viper.PluginManager(this);
    this.KeyboardHandler = new Viper.KeyboardHandler(this);
    Viper.Selection._viper = this;
    this.registerCallback("Viper:setHtmlContent", "Viper", function(content, callback) {
      callback.call(this, content);
      return function() {
      };
    });
  },
  destroy: function() {
    this.fireCallbacks("Viper:destroy");
    this.setEnabled(false);
    Viper.Util.removeEvent(Viper.Util.getDocuments(), "." + this.getEventNamespace());
    if (this._viperElementHolder) {
      Viper.Util.remove(this._viperElementHolder);
    }
  },
  getId: function() {
    return this.id;
  },
  _processOptions: function(options, callback) {
    var self = this;
    for (var op in options) {
      var fn = "set" + Viper.Util.ucFirst(op);
      if (fn === "setSetting") {
        delete options[op];
        continue;
      }
      if (Viper.Util.isFn(this[fn]) === true) {
        this[fn](options[op], function() {
          delete options[op];
          self._processOptions(options, callback);
        });
        return;
      }
      fn = "_" + fn;
      if (Viper.Util.isFn(this[fn]) === true) {
        this[fn](options[op], function() {
          delete options[op];
          self._processOptions(options, callback);
        });
        return;
      } else {
        this.setSetting(op, options[op]);
        delete options[op];
        self._processOptions(options, callback);
        return;
      }
    }
    callback.call(this);
  },
  getPluginManager: function() {
    return this.PluginManager;
  },
  getHistoryManager: function() {
    return this.HistoryManager;
  },
  getKeyboardHandler: function() {
    return this.KeyboardHandler;
  },
  setSetting: function(setting, value) {
    this._settings[setting] = value;
    var fn = "set" + Viper.Util.ucFirst(setting);
    if (Viper.Util.isFn(this[fn]) === true) {
      this[fn].call(this, value);
    }
  },
  /**
   * Sets the given settings.
   *
   * @param {object}  settings Setting name and value list.
   * @param {boolean} clean    If true then the original settings will be wiped out.
   *
   * @return void
   */
  setSettings: function(settings, clean) {
    if (clean === true) {
      this._settings = {};
    }
    for (var setting in settings) {
      this.setSetting(setting, settings[setting]);
    }
  },
  getSetting: function(setting) {
    return this._settings[setting];
  },
  getSettings: function() {
    return Viper.Util.clone(this._settings);
  },
  /**
   * Sets the custom class of this Viper instance.
   */
  setCustomClass: function(className) {
    this._settings["customClass"] = className;
    if (this._viperElementHolder) {
      Viper.Util.addClass(this._viperElementHolder, className);
    }
  },
  getDefaultBlockTag: function() {
    var defaultBlockTag = this.getSetting("defaultBlockTag");
    if (Viper.Util.isset(defaultBlockTag) === true) {
      return defaultBlockTag;
    }
    return "p";
  },
  _setLanguage: function(lang, callback) {
    if (!lang) {
      return;
    }
    var code = null;
    var src = null;
    if (typeof lang === "object" && lang.code) {
      code = lang.code;
      src = lang.src;
    } else {
      code = lang;
    }
    if (code) {
      code = code.replace(/-\w+/, "");
    }
    if (code === "en") {
      callback.call(this);
      return;
    }
    if (!src) {
      src = this.getViperPath().replace(/\/build$/, "") + "/build/Translation/" + code + ".js";
    }
    if (Viper.Translation.isLoaded(code) === false && src) {
      Viper.Util.loadScript(
        src,
        function() {
          Viper.Translation.setLanguage(code);
          callback.call(this);
        },
        2e3
      );
    } else {
      Viper.Translation.setLanguage(code);
      callback.call(this);
    }
  },
  /**
   * Adds a Viper related element to Viper elements holder.
   *
   * Plugins should use this method to add their elements to DOM.
   */
  addElement: function(element) {
    if (!element) {
      return;
    }
    this._viperElementHolder = Viper.Util.getid(this.getId() + "-elementHolder", Viper.document);
    if (!this._viperElementHolder) {
      this._viperElementHolder = this._createElementHolder();
    }
    this._viperElementHolder.appendChild(element);
  },
  _createElementHolder: function() {
    var holder = document.createElement("div");
    holder.id = this.getId() + "-elementHolder";
    Viper.document.body.appendChild(holder);
    var browser = Viper.Util.getBrowserType();
    var version = Viper.Util.getBrowserVersion();
    if (browser && version) {
      Viper.Util.addClass(holder, "Viper-browser-" + browser);
      Viper.Util.addClass(holder, "Viper-browserVer-" + browser + version);
    }
    if (this._settings.customClass) {
      Viper.Util.addClass(holder, this._settings.customClass);
    }
    return holder;
  },
  getElementHolder: function() {
    if (!this._viperElementHolder) {
      this._viperElementHolder = this._createElementHolder();
    }
    return this._viperElementHolder;
  },
  /**
   * Set Viper mode.
   *
   * If Viper is using "inline" mode then some of the actions will be disabled
   *
   * @param {string} mode The Viper mode (inline or block).
   *
   * @return {void}
   */
  setMode: function(mode) {
    if (mode === "inline") {
      this.inlineMode = true;
    } else {
      this.inlineMode = false;
    }
  },
  /**
   * Returns the current browser type.
   *
   * @return {string}
   */
  getBrowserType: function() {
    if (this._browserType === null) {
      const userAgent = navigator.userAgent.toLowerCase();
      if (userAgent.includes("chrome")) {
        this._browserType = "chrome";
      } else if (userAgent.includes("firefox")) {
        this._browserType = "firefox";
      } else if (userAgent.includes("safari")) {
        this._browserType = "safari";
      } else {
        this._browserType = "other";
      }
    }
    return this._browserType;
  },
  /**
   * Returns the version of the current browser.
   *
   * @return {integer}
   */
  getBrowserVersion: function() {
    var browsers = ["Chrome", "Safari", "Firefox"];
    var uAgent = navigator.userAgent;
    var browserName = null;
    for (var i = 0; i < browsers.length; i++) {
      if (uAgent.indexOf(browsers[i]) >= 0) {
        browserName = browsers[i];
        break;
      }
    }
    if (!browserName) {
      return null;
    }
    if (browserName === "Safari") {
      browserName = "Version";
    }
    var re = new RegExp(browserName + "/(\\d+)");
    var matches = re.exec(uAgent);
    if (!matches) {
      return null;
    }
    return parseInt(matches[1]);
  },
  /**
   * Returns the path to the Viper JS file directory.
   *
   * Plugins can use this to load extra JS files.
   *
   * @return {string} Path to JS file directory.
   */
  getViperPath: function() {
    var scripts = document.getElementsByTagName("script");
    var path = null;
    var c = scripts.length;
    for (var i = 0; i < c; i++) {
      if (scripts[i].src) {
        if (scripts[i].src.match(/\/Lib\/Viper\.js.*/)) {
          path = scripts[i].src.replace(/\/Lib\/Viper\.js.*/, "");
          break;
        } else if (scripts[i].src.match(/\/viper-combined\.js.*/)) {
          path = scripts[i].src.replace(/\/viper-combined\.js.*/, "");
          break;
        } else if (scripts[i].src.match(/\/viper\.js.*/)) {
          path = scripts[i].src.replace(/\/viper\.js.*/, "");
          break;
        }
      }
    }
    return path;
  },
  getEventNamespace: function() {
    return "viper-" + this.id;
  },
  /**
   * Adds the events required for mouse navigating and key navigating/typing.
   *
   * @return {void}
   */
  _addEvents: function(elem) {
    if (!elem) {
      elem = this.element;
    }
    var namespace = this.getEventNamespace();
    Viper.Util.removeEvent(Viper.Util.getDocuments(), "." + namespace);
    this._removeEvents(elem);
    var self = this;
    Viper.Util.addEvent(this._document, "mouseup." + namespace, function(e) {
      return self.mouseUp(e);
    });
    Viper.Util.addEvent(this._document, "mousedown." + namespace, function(e) {
      return self.mouseDown(e);
    });
    this.KeyboardHandler.init();
    Viper.Util.addEvent(elem, "blur." + namespace, function(e) {
      if (!self._viperRange) {
        self.resetViperRange(self._currentRange);
      }
    });
    var _dragRange = null;
    Viper.Util.addEvent(elem, "dragstart." + namespace, function(e) {
      _dragRange = self.getViperRange();
    });
    Viper.Util.addEvent(elem, "drop." + namespace, function(e) {
      Viper.Util.preventDefault(e);
      e.dataTransfer.dropEffect = "move";
      var range = self.getRangeFromCoords(e.clientX, e.clientY);
      var dataTransfer = e.dataTransfer;
      var origRange = null;
      if (origRange !== null) {
        origRange = _dragRange.cloneRange();
      }
      if (self.fireCallbacks("Viper:dropped", {
        dataTransfer,
        range: range.cloneRange(),
        e,
        origRange
      }) === false) {
        return false;
      }
      var textPlain = null;
      if (dataTransfer.types) {
        for (var i = 0; i < dataTransfer.types.length; i++) {
          try {
            var data = {
              data: dataTransfer.getData(dataTransfer.types[i]),
              range,
              origRange: _dragRange
            };
          } catch (e2) {
            continue;
          }
          if (dataTransfer.types[i] === "text/plain" || dataTransfer.types[i] === "Text") {
            textPlain = data;
          }
          if (self.fireCallbacks("Viper:dropped:" + dataTransfer.types[i], data) === false) {
            return false;
          }
        }
      }
      if (textPlain !== null && textPlain.data) {
        Viper.Selection.addRange(range);
        self.insertNodeAtCaret(document.createTextNode(textPlain.data));
      }
      return false;
    });
    Viper.Util.addEvent(elem, "focus." + namespace, function(e) {
      if (self.fireCallbacks("Viper:viperElementFocused") === false) {
        return;
      }
      self.highlightToSelection();
    });
    if (navigator.userAgent.match(/iPad/i) !== null) {
      setInterval(function() {
        self.fireSelectionChanged();
      }, 500);
      Viper.Util.addEvent(window, "gestureend", function() {
        var elements = Viper.Util.getClass("Viper-scalable");
        var c = elements.length;
        for (var i = 0; i < c; i++) {
          var scale = Viper.Tools.scaleElement(elements[i]);
          self.fireCallbacks("Viper:elementScaled", {
            element: elements[i],
            scale
          });
        }
      });
    }
  },
  /**
   * Removes the events required for mouse navigating and key navigating/typing.
   *
   * @return void
   */
  _removeEvents: function(elem) {
    if (!elem) {
      elem = this.element;
    }
    Viper.Util.removeEvent(elem, "." + this.getEventNamespace());
  },
  /**
   * Enables or disables Viper.
   *
   * @param boolean enabled If true viper will be enabled, otherwise it will be
   *                        disabled.
   */
  setEnabled: function(enabled) {
    this.resetViperRange(null);
    if (!this.element) {
      return;
    }
    var range = null;
    if (enabled === true && this.enabled === false) {
      this._addEvents();
      this.enabled = true;
      this._setRadOnlyStyles();
      Viper.Selection._viper = this;
      this.element.setAttribute("contentEditable", true);
      Viper.Util.setStyle(this.element, "outline", "none");
      this.focus();
      if (!range) {
        range = this.getCurrentRange();
      }
      if (this.rangeInViperBounds(range) === false) {
        this.initEditableElement();
      }
      var editableChild = range._getFirstSelectableChild(this.element);
      if (!editableChild) {
        var tags = "iframe,img,object,table";
        if (Viper.Util.getTag(tags, this.element).length === 0) {
          var blockElement = null;
          for (var node = this.element.firstChild; node; node = node.nextSibling) {
            if (Viper.Util.isBlockElement(node) === true && Viper.Util.isStubElement(node) === false) {
              blockElement = node;
              break;
            }
          }
          if (blockElement) {
            blockElement.appendChild(document.createTextNode(" "));
            editableChild = range._getFirstSelectableChild(this.element, true);
          } else {
            var tagName = this.getDefaultBlockTag();
            if (!tagName) {
              Viper.Util.setHtml(this.element, "");
            } else {
              blockElement = document.createElement(tagName);
              Viper.Util.setHtml(blockElement, "&nbsp;");
              this.element.appendChild(blockElement);
              editableChild = range._getFirstSelectableChild(this.element);
            }
          }
          var self = this;
          setTimeout(function() {
            self.element.focus();
            if (editableChild) {
              range.setStart(editableChild, 0);
              range.collapse(true);
              Viper.Selection.addRange(range);
            }
          }, 10);
        }
      } else if (Viper.Util.isBrowser("firefox") === true) {
        range.setStart(editableChild, 0);
        range.collapse(true);
        Viper.Selection.addRange(range);
      }
      this.fireCallbacks("Viper:enabled");
    } else if (enabled === false && this.enabled === true) {
      this.cleanDOM(this.element);
      this.element.setAttribute("contentEditable", false);
      Viper.Util.setStyle(this.element, "outline", "invert");
      this._removeEvents();
      this.enabled = false;
      this.fireCallbacks("Viper:disabled", true);
    } else if (enabled === false) {
      this.fireCallbacks("Viper:disabled", false);
    }
  },
  enable: function() {
    this.setEnabled(true);
  },
  disable: function() {
    this.setEnabled(false);
  },
  /**
   * Returns true if Viper is enabled false otherwise.
   *
   * @return {boolean}
   */
  isEnabled: function() {
    return this.enabled;
  },
  /**
   * Sets the read only (contenteditable=false) styles so they remain the same when its set to true.
   */
  _setRadOnlyStyles: function() {
    if (!this.element) {
      return;
    }
    var styles = ["word-wrap"];
    for (var i = 0; i < styles.length; i++) {
      var value = Viper.Util.getComputedStyle(this.element, styles[i]);
      Viper.Util.setStyle(this.element, styles[i], value);
    }
  },
  /**
   * Sets the element that should be editable. The current element that is
   * editable will become non-editable.
   *
   * If you wish to have two elements that are editable simutaneously, then
   * construct to viper instances.
   *
   * @param DomElement elem The element to become editable.
   *
   * @return void
   */
  setEditableElement: function(elem) {
    var self = this;
    if (this.element === elem) {
      return;
    } else if (!elem) {
      this.setEnabled(false);
      this.element = null;
      Viper.Util.setViperElement(null);
      return;
    }
    if (this.PluginManager.getPlugins() === null) {
      this._useDefaultPlugins();
    }
    this.resetViperRange(null);
    if (this.element) {
      this.element.setAttribute("contentEditable", false);
      Viper.Util.setStyle(this.element, "outline", "invert");
    }
    this._document = elem.ownerDocument;
    this.setEnabled(false);
    this.element = elem;
    Viper.Util.setViperElement(elem);
    if (Viper.Util.inArray(elem, this._registeredElements) === false) {
      this.registerEditableElement(elem);
    }
    this.setEnabled(true);
    this.HistoryManager.setActiveElement(elem);
    this.inlineMode = false;
    elem.setAttribute("contentEditable", true);
    Viper.Util.setStyle(elem, "outline", "none");
    this.fireCallbacks("Viper:editableElementChanged", { element: elem });
    var tabTextfield = Viper.Util.getid(this.getId() + "-tabTextfield");
    if (!tabTextfield) {
      tabTextfield = document.createElement("input");
      tabTextfield.type = "text";
      tabTextfield.id = this.getId() + "-tabTextfield";
      Viper.Util.setStyle(tabTextfield, "left", "-9999px");
      Viper.Util.setStyle(tabTextfield, "top", "-9999px");
      Viper.Util.setStyle(tabTextfield, "position", "absolute");
      Viper.Util.insertBefore(this.element, tabTextfield);
    }
    Viper.Util.addEvent(tabTextfield, "focus", function(e) {
      tabTextfield.blur();
      self.setEnabled(true);
      self.element.focus();
      self.fireCallbacks("Viper:clickedInside", e);
      self.initEditableElement();
      var range = self.getCurrentRange();
      var selectable = range._getFirstSelectableChild(self.element);
      if (!selectable) {
        var brTags = Viper.Util.getTag("br", self.element);
        if (brTags.length > 0) {
          range.selectNode(brTags[0]);
        }
      }
      if (selectable) {
        range.setEnd(selectable, 0);
        range.setStart(selectable, 0);
      }
      range.collapse(true);
      Viper.Selection.addRange(range);
      self.fireSelectionChanged(range, true);
    });
    if (document !== elem.ownerDocument) {
      var style = elem.ownerDocument.createElement("style");
      style.innerHTML = ".__viper_selHighlight {background-color: #CCC !important;}";
      elem.ownerDocument.head.appendChild(style);
    }
  },
  registerEditableElements: function(elements) {
    for (var i = 0; i < elements.length; i++) {
      this.registerEditableElement(elements[i]);
    }
  },
  registerEditableElement: function(element) {
    this.initEditableElement(element);
    this._registeredElements.push(element);
  },
  initEditableElement: function(elem) {
    var elem = elem || this.element;
    if (!elem) {
      return;
    }
    var tmp = Viper.document.createElement("div");
    var content = this.getContents(elem);
    content = this._closeStubTags(content);
    content = this.removeInvalidCharacters(content);
    Viper.Util.setHtml(tmp, content);
    if ((Viper.Util.trim(Viper.Util.getNodeTextContent(tmp)).length === 0 || Viper.Util.getHtml(tmp) === "&nbsp;") && Viper.Util.getTag("*", tmp).length === 0) {
      var tags = Viper.Util.getTag("*", tmp);
      var hasStubElems = false;
      Viper.Util.foreach(tags, function(i2) {
        if (Viper.Util.isStubElement(tags[i2]) === true) {
          hasStubElems = true;
          return false;
        }
      });
      if (hasStubElems !== true) {
        var range = this.getCurrentRange();
        var blockTag = this.getDefaultBlockTag();
        if (!blockTag) {
          Viper.Util.setHtml(elem, "");
          elem.appendChild(document.createTextNode(" "));
        } else {
          var emptyCont = "<br/>";
          Viper.Util.setHtml(elem, Viper.Util.getHtml(elem) + "<" + blockTag + ">" + emptyCont + "</" + blockTag + ">");
        }
        try {
          range.setStart(elem.firstChild, 0);
          range.setEnd(elem.firstChild, 0);
          range.collapse(false);
          Viper.Selection.addRange(range);
        } catch (e) {
        }
      }
    } else {
      var cleanedContent = this.cleanHTML(content);
      if (cleanedContent !== content) {
        Viper.Util.setHtml(elem, cleanedContent);
      }
      var defaultTagName = this.getDefaultBlockTag();
      if (defaultTagName) {
        var nodesToRemove = [];
        var childNode = elem.firstChild;
        while (childNode) {
          var child = childNode;
          childNode = child.nextSibling;
          if (Viper.Util.isBlockElement(child) === true && Viper.Util.isStubElement(child) === false || child.nodeType !== Viper.Util.ELEMENT_NODE && child.nodeType !== Viper.Util.TEXT_NODE || Viper.Util.isTag(child, "hr") === true || Viper.Util.isTag(child, "iframe") === true || Viper.Util.isTag(child, "object") === true) {
            continue;
          } else if (child.nodeType === Viper.Util.TEXT_NODE && Viper.Util.trim(child.data) === "") {
            nodesToRemove.push(child);
            continue;
          }
          var p = null;
          if (child.previousSibling && Viper.Util.isTag(child.previousSibling, defaultTagName) === true) {
            p = child.previousSibling;
          } else {
            p = document.createElement(defaultTagName);
            Viper.Util.insertBefore(child, p);
          }
          p.appendChild(child);
        }
        Viper.Util.remove(nodesToRemove);
        var range = this.getCurrentRange();
        var firstSelectable = range._getFirstSelectableChild(elem);
        if (!firstSelectable && elem.childNodes.length > 0) {
          for (var i = 0; i < elem.childNodes.length; i++) {
            var child = elem.childNodes[i];
            if (Viper.Util.isBlockElement(child) === true && Viper.Util.isStubElement(child) === false && Viper.Util.getHtml(child) === "") {
              Viper.Util.setHtml(child, "&nbsp;");
            }
          }
        }
      }
    }
  },
  getEditableElement: function() {
    return this.element;
  },
  setMemberElements: function(elements) {
    this._memberElements = elements;
  },
  addMemberElements: function(elements) {
    this._memberElements = this._memberElements.concat(elements);
  },
  isMemberElement: function(element) {
    var isMember = Viper.Util.inArray(element, this._memberElements);
    return isMember;
  },
  resetPlugins: function() {
    this._useDefaultPlugins();
  },
  _useDefaultPlugins: function() {
    var plugins = "ViperCoreStylesPlugin|ViperInlineToolbarPlugin|ViperHistoryPlugin|ViperListPlugin|ViperFormatPlugin|ViperToolbarPlugin|ViperCopyPastePlugin|ViperImagePlugin|ViperLinkPlugin|ViperAccessibilityPlugin|ViperSourceViewPlugin|ViperSearchReplacePlugin|ViperLangToolsPlugin|ViperCharMapPlugin|ViperCursorAssistPlugin|ViperReplacementPlugin|ViperTableEditorPlugin";
    this.PluginManager.setPlugins(plugins.split("|"));
    var buttons = [
      ["bold", "italic", "subscript", "superscript", "strikethrough", "code", "class"],
      "removeFormat",
      ["justify", "formats", "headings"],
      ["undo", "redo"],
      ["unorderedList", "orderedList", "indentList", "outdentList"],
      "insertTable",
      "image",
      "hr",
      ["insertLink", "removeLink", "anchor"],
      "insertCharacter",
      "searchReplace",
      "langTools",
      "accessibility",
      "sourceEditor"
    ];
    this.getPluginManager().setPluginSettings("ViperToolbarPlugin", { buttons });
    var inlineToolbarButtons = [
      ["bold", "italic", "class"],
      ["justify", "formats", "headings"],
      ["unorderedList", "orderedList", "indentList", "outdentList"],
      ["insertLink", "removeLink", "anchor"],
      ["image", "imageMove"]
    ];
    this.getPluginManager().setPluginSettings("ViperInlineToolbarPlugin", { buttons: inlineToolbarButtons });
    this.getPluginManager().setPluginSettings("ViperAccessibilityPlugin", { standard: "WCAG2AA" });
    this.setSetting("defaultBlockTag", this.getDefaultBlockTag());
  },
  getViperElement: function() {
    return this.element;
  },
  getViperElementDocument: function() {
    return this.element.ownerDocument;
  },
  /**
   * Returns the current range.
   *
   * Note that this range may be out side of Viper element.
   *
   * @return {Viper.DOMRange} The Vipe DOMRange object.
   */
  getCurrentRange: function() {
    var range = Viper.Selection.getRangeAt(0);
    this._currentRange = range.cloneRange();
    return range;
  },
  /**
   * Returns the range that was set before Viper lost focus.
   *
   * Plugins that steal focus from the Viper element may need to give the focus
   * back to Viper element and also select the text/node that selected before they
   * took the focus. In that case this method should be used instead of the
   * getCurrentRange.
   *
   * @return {Viper.DOMRange} The Vipe DOMRange object.
   */
  getViperRange: function(element) {
    this.highlightToSelection(element);
    if (this._viperRange) {
      return this._viperRange;
    }
    return this.getCurrentRange();
  },
  resetViperRange: function(range) {
    range = range || null;
    this._viperRange = range;
  },
  /**
   * Selects the specified element.
   *
   * @param {DOMNode} element The element to select.
   */
  selectElement: function(element) {
    var range = this.getViperRange();
    range.selectNode(element);
    Viper.Selection.addRange(range);
  },
  selectAll: function(elem) {
    elem = elem || this.getViperElement();
    var range = this.getViperRange();
    if (!elem.firstChild) {
      return;
    }
    var start = elem.firstChild;
    if (start.nodeType !== Viper.Util.TEXT_NODE) {
      start = document.createTextNode("");
      Viper.Util.insertBefore(elem.firstChild, start);
    }
    var end = elem.lastChild;
    if (end.nodeType !== Viper.Util.TEXT_NODE) {
      end = document.createTextNode("");
      Viper.Util.insertAfter(elem.lastChild, end);
    }
    range.setStart(start, 0);
    range.setEnd(end, end.data.length);
    Viper.Selection.addRange(range);
  },
  getNodeSelection: function(range) {
    range = range || this.getViperRange();
    var nodeSelection = range.getNodeSelection();
    if (nodeSelection === this.getViperElement()) {
      nodeSelection = null;
    }
    var node = this.fireCallbacks("Viper:getNodeSelection", { range });
    if (node) {
      nodeSelection = node;
    }
    return nodeSelection;
  },
  addAttributeGetModifier: function(callback) {
    this._attributeGetModifiers.push(callback);
  },
  addAttributeSetModifier: function(callback) {
    this._attributeSetModifiers.push(callback);
  },
  /**
   * Returns the value of the specified attribute of an eleement.
   *
   * Plugins can use the addAttributeModifier method to change the value that this method returns.
   *
   * @param {DOMNode}  element   The element to update.
   * @param {string}   attribute The attribute name.
   *
   * @return {string}
   */
  getAttribute: function(element, attribute) {
    var value = element.getAttribute(attribute);
    var modifiersCount = this._attributeGetModifiers.length;
    if (modifiersCount > 0) {
      for (var i = 0; i < modifiersCount; i++) {
        value = this._attributeGetModifiers[i].call(this, element, attribute, value);
      }
    }
    return value;
  },
  /**
   * Sets the attribute of an element.
   *
   * If the specified value is empty and the attribute value is empty then
   * attribute will be removed from the element.
   *
   * @param {DOMNode}  element   The element to update.
   * @param {string}   attribute The attribute name.
   * @param {string}   value     The value of the attribute.
   */
  setAttribute: function(element, attribute, value, keepEmptyAttribute) {
    if (!element || !element.setAttribute) {
      return;
    }
    if (!value && keepEmptyAttribute !== true && Viper.Util.hasAttribute(element, attribute) === true) {
      element.removeAttribute(attribute);
      this.fireCallbacks("Viper:attributeRemoved", { element, attribute });
      if (Viper.Util.isTag(element, "span") === true && element.attributes && element.attributes.length === 0) {
        var range = this.getViperRange();
        var selectedNode = range.getNodeSelection();
        var firstSelectable = null;
        var lastSelectable = null;
        if (selectedNode === element) {
          firstSelectable = range._getFirstSelectableChild(element);
          lastSelectable = range._getLastSelectableChild(element);
        }
        while (element.firstChild) {
          Viper.Util.insertBefore(element, element.firstChild);
        }
        Viper.Util.remove(element);
        if (firstSelectable && lastSelectable) {
          range.setStart(firstSelectable, 0);
          range.setEnd(lastSelectable, lastSelectable.data.length);
          Viper.Selection.addRange(range);
          this.resetViperRange(range);
        }
      }
    } else if (value || keepEmptyAttribute === true) {
      var self = this;
      var notModified = true;
      var modifiersCount = this._attributeSetModifiers.length;
      if (modifiersCount > 0) {
        this._retrievingValues++;
        var doneCount = 0;
        for (var i = 0; i < modifiersCount; i++) {
          notModified = this._attributeSetModifiers[i].call(this, element, attribute, value, function() {
            doneCount++;
            if (doneCount === modifiersCount) {
              self._retrievingValues--;
              if (self._valuesRetrievedCallback) {
                self._valuesRetrievedCallback.call(self);
              }
            }
          });
        }
        if (notModified !== false) {
          element.setAttribute(attribute, value);
          self._retrievingValues--;
          if (self._valuesRetrievedCallback) {
            self._valuesRetrievedCallback.call(self);
          }
        }
      } else {
        element.setAttribute(attribute, value);
      }
    }
  },
  /**
   * Removes the specified attribute of an element.
   *
   * @param {DOMNode} element   The element to remove.
   * @param {string}  attribute The attribute name.
   */
  removeAttribute: function(element, attribute) {
    return this.setAttribute(element, attribute, "", false);
  },
  /**
   * Find the next good position for the caret outside of the sourceElement.
   *
   * This method should be used when removing an element where caret is in.
   * If no valid elements found a new element will be created using the defaultBlockTag setting.
   */
  moveCaretAway: function(sourceElement, back) {
    back = back || false;
    var range = this.getViperRange();
    return range.moveCaretAway(sourceElement, this.getViperElement(), this.getDefaultBlockTag(), back);
  },
  /**
   * Returns the caret coords.
   *
   * @return {object} The x and y position of the caret.
   */
  getCaretCoords: function() {
    var coords = {};
    try {
      var bookmark = this.createBookmark();
      Viper.Util.setStyle(bookmark.end, "display", "inline");
      coords = Viper.Util.getElementCoords(bookmark.end);
      Viper.Util.remove(bookmark.start);
      Viper.Util.remove(bookmark.end);
    } catch (e) {
      coords = {
        x: -1,
        y: -1
      };
    }
    return coords;
  },
  /**
   * Returns the range object for the given coords.
   *
   * @param {integer} x The x coord.
   * @param {integer} y The y coord.
   *
   * @return {DOMRange}
   */
  getRangeFromCoords: function(x, y) {
    var doc = this.getViperElement().ownerDocument;
    var range = null;
    if (doc.caretRangeFromPoint) {
      var rangeObj = doc.caretRangeFromPoint(x, y);
      range = new Viper.MozRange(rangeObj);
    } else if (doc.caretPositionFromPoint) {
      var rangeObj = doc.caretPositionFromPoint(x, y);
      range = this.getCurrentRange().cloneRange();
      range.setStart(rangeObj.offsetNode, rangeObj.offset);
      range.collapse(true);
    }
    return range;
  },
  /**
   * Returns the element at the specified coords.
   *
   * @param {integer} x The x coord.
   * @param {integer} y The y coord.
   *
   * @return {DOMNode}
   */
  getElementAtCoords: function(x, y) {
    var elem = null;
    var doc = this.getViperElement().ownerDocument;
    if (doc.caretRangeFromPoint) {
      var range = doc.caretRangeFromPoint(x, y);
      if (range) {
        if (range.startContainer === range.endContainer && range.startOffset === range.endOffset) {
          if (range.startContainer.nodeType !== Viper.Util.TEXT_NODE && range.startOffset < range.startContainer.childNodes.length) {
            elem = range.startContainer.childNodes[range.startOffset];
          } else {
            elem = range.startContainer;
          }
        }
      }
    } else if (doc.caretPositionFromPoint) {
      var range = doc.caretPositionFromPoint(x, y);
      if (range) {
        if (Viper.Util.isBlockElement(range.offsetNode) === true) {
          var offset = range.offset;
          if (offset >= range.offsetNode.childNodes.length) {
            offset = range.offsetNode.childNodes.length - 1;
          }
          elem = range.offsetNode.childNodes[offset];
        } else {
          elem = range.offsetNode;
        }
      }
    }
    return elem;
  },
  /**
   * Returns true if given selection is in side the Viper element false otherwise.
   *
   * @param {Viper.DOMRange} range The range object to check.
   *
   * @return {boolean} True if range is inside Viper element.
   */
  rangeInViperBounds: function(range) {
    range = range || this.getCurrentRange();
    if (range === null || this.isOutOfBounds(range.startContainer) || this.isOutOfBounds(range.endContainer)) {
      return false;
    }
    return true;
  },
  /**
   * Checks if specified element is inside Viper element.
   *
   * @param {DOMNode} element The element to test.
   *
   * @return {boolean} True if the element is inside Viper element.
   */
  isOutOfBounds: function(element) {
    if (element === this.element || Viper.Util.isChildOf(element, this.element) === true) {
      return false;
    }
    return true;
  },
  isWholeViperElementSelected: function(range) {
    range = range || this.getViperRange();
    if (range.collapsed === false) {
      var viperElement = this.getViperElement();
      var firstSelectable = range._getFirstSelectableChild(viperElement);
      if ((firstSelectable === range.startContainer || viperElement === range.startContainer) && range.startOffset === 0) {
        var prevContainer = range.getPreviousContainer(range.startContainer, null, false, true);
        if (this.isOutOfBounds(prevContainer) === false) {
          return false;
        }
        var nextContainer = range.getNextContainer(range.endContainer, null, true, true);
        if (this.isOutOfBounds(nextContainer) === false) {
          return false;
        }
        var lastSelectable = range._getLastSelectableChild(viperElement);
        if (range.endContainer === viperElement && range.endOffset >= viperElement.childNodes.length || range.endContainer === lastSelectable && range.endOffset === lastSelectable.data.length) {
          return true;
        }
      }
    }
    return false;
  },
  /**
   * Inserts a node after the current caret position.
   *
   * If the current selection is not collapsed, then the contents currently
   * selected will be deleted before inserting the specified node The new caret
   * position will exist after the inserted node.
   *
   * @param DOMNode node The node to insert.
   *
   * @return void
   */
  insertNodeAtCaret: function(node, range) {
    range = range || this.getViperRange();
    if (range.collapsed !== true) {
      if (Viper.Util.isBrowser("chrome") === true && range.startOffset === 0 && range.startContainer === range._getFirstSelectableChild(this.element) && range.endOffset === this.element.childNodes.length - 1) {
        Viper.Util.setHtml(this.element, "");
      } else {
        range.deleteContents();
        Viper.Selection.addRange(range);
      }
      if (Viper.Util.trim(Viper.Util.getHtml(this.element)) === "") {
        this.initEditableElement();
      }
      range = this.getCurrentRange();
      if (range.startContainer === range.endContainer && this.element === range.startContainer && range.startOffset === range.endOffset && range.startOffset === 0) {
        Viper.Util.empty(this.element);
        this.initEditableElement();
        var firstSelectable = range._getFirstSelectableChild(this.element);
        range.setStart(firstSelectable, 0);
        range.collapse(true);
      }
    } else if (Viper.Util.isStubElement(range.startContainer.parentNode) === true) {
      var newNode = Viper.document.createTextNode("");
      Viper.Util.insertBefore(range.startContainer.parentNode, newNode);
      Viper.Util.remove(range.startContainer.parentNode);
      range.setStart(newNode, 0);
      range.collapse(true);
      Viper.Selection.addRange(range);
    }
    if (typeof node === "string") {
      if (node === "\r") {
        return;
      }
      var newNode = Viper.document.createTextNode(node);
      var noBlock = true;
      const newRange = range;
      if (newRange.collapsed === true && newRange.startContainer.parentNode && newRange.startContainer.parentNode.firstChild.nodeType === Viper.Util.TEXT_NODE && newRange.startContainer.parentNode.firstChild === newRange.startContainer.parentNode.lastChild && Viper.Util.trim(newRange.startContainer.parentNode.firstChild.data) === "") {
        newRange.setStart(newRange.startContainer.parentNode.firstChild, 0);
        newRange.collapse(true);
        newRange.startContainer.parentNode.firstChild.data = "";
      } else if (newRange.collapsed === true && Viper.Util.isStubElement(newRange.startContainer) === true) {
        var tmpTextNode = Viper.document.createTextNode("");
        Viper.Util.insertBefore(newRange.startContainer, tmpTextNode);
        Viper.Util.remove(newRange.startContainer);
        newRange.setStart(tmpTextNode, 0);
        newRange.collapse(true);
      }
      if (this.fireCallbacks("Viper:nodesInserted", { node: newNode, range: newRange }) === false) {
        noBlock = false;
      }
      if (noBlock === false) {
        return false;
      }
      this.contentChanged();
      return;
    } else {
      if (node.nodeType === Viper.Util.DOCUMENT_FRAGMENT_NODE) {
        var newNode = null;
        var clen = node.childNodes.length;
        for (var i = 0; i < clen; i++) {
          var child = node.childNodes[i];
          if (child.nodeType === Viper.Util.TEXT_NODE) {
            if (Viper.Util.trim(child.data) === "") {
              continue;
            }
          }
          newNode = Viper.document.importNode(child, true);
          range.insertNode(newNode);
          range.selectNode(newNode);
          range.collapse(false);
        }
        node = newNode;
        range.moveEnd("character", -1);
        range.moveEnd("character", 1);
        range.collapse(false);
        return;
      } else if (Viper.Util.isStubElement(range.startContainer) === true) {
        Viper.Util.insertBefore(range.startContainer, node);
      } else {
        range.insertNode(node);
      }
      range.setEndAfter(node, this._getNodeOffset(node) + 1);
      range.collapse(false);
    }
  },
  /**
   * Inserts the specified text after the current caret location.
   *
   * If the current selection is not collapsed, then the contents currently
   * selected will be deleted before inserting the specified node The new caret
   * position will exist after the inserted node.
   *
   * @param string text The text to insert.
   *
   * @return void
   */
  insertTextAtCaret: function(text) {
    if (typeof text !== "string") {
      throw "InvalidArgumentException: text must be a string";
    }
    return this.insertNodeAtCaret(text);
  },
  /**
   * Removes the selection contents and returns the updated range.
   *
   * @return DOMRange
   */
  deleteRangeContent: function() {
    var range = this.getViperRange();
    if (this.KeyboardHandler.handleDelete() !== false) {
      range.deleteContents();
      Viper.Selection.addRange(range);
    }
    range = this.getViperRange();
    return range;
  },
  /**
   * Returns the offset where the node exists in the parent's childNodes property.
   *
   * @param DomNode node The node to obtain the offset for.
   *
   * @return integer
   */
  _getNodeOffset: function(node) {
    var nodes = node.parentNode.childNodes;
    var ln = nodes.length;
    for (var i = 0; i < ln; i++) {
      if (nodes[i] === node) {
        return i;
      }
    }
  },
  /**
   * Creates an element that cannot be edited.
   */
  createUneditableElement: function(options) {
    if (!options) {
      options = {};
    }
    var tagName = options.tagName || "span";
    var content = options.content || "";
    var elem = document.createElement(tagName);
    Viper.Util.attr(elem, "contenteditable", false);
    Viper.Util.setHtml(elem, content);
    if (options.attributes) {
      for (var attrName in options.attributes) {
        Viper.Util.attr(elem, attrName, options.attributes[attrName]);
      }
    }
    return elem;
  },
  makeElementUneditable: function(element) {
    Viper.Util.attr(element, "contenteditable", false);
  },
  createDefaultBlockElement: function() {
    var baseTag = this.getDefaultBlockTag();
    if (baseTag) {
      var el = document.createElement(baseTag);
      el.appendChild(document.createElement("br"));
      return el;
    }
    return null;
  },
  /**
   * This is not as simple as wrapping a selection with the specified node.
   * For example, if the specified node is a STRONG tag, which is an inline
   * ELEMENT_NODE then it cannot be a parent to block element (i.e. P, DIV).
   */
  surroundContents: function(tag, attributes, range, keepSelection) {
    range = range || this.getCurrentRange();
    if (range.collapsed === true) {
      return;
    }
    if (this.rangeInViperBounds(range) !== true) {
      return;
    }
    var otag = tag;
    var startContainer = range.getStartNode();
    var endContainer = range.getEndNode();
    var nodeSelection = range.getNodeSelection(null, true);
    if (nodeSelection) {
      var parents = Viper.Util.getSurroundingParents(nodeSelection, null, "inline", this.getViperElement());
      if (parents.length > 0 || Viper.Util.isBlockElement(nodeSelection) === false && Viper.Util.isStubElement(nodeSelection) === false) {
        if (parents.length > 0) {
          nodeSelection = parents.pop();
        }
        var node = Viper.document.createElement(tag);
        this._setWrapperElemAttributes(node, attributes);
        Viper.Util.insertBefore(nodeSelection, node);
        node.appendChild(nodeSelection);
        if (keepSelection !== true) {
          range.setStart(range._getFirstSelectableChild(node), 0);
          range.setEnd(range._getLastSelectableChild(node), range._getLastSelectableChild(node).data.length);
          Viper.Selection.addRange(range);
        }
        return node;
      }
    }
    if (startContainer === endContainer) {
      if (startContainer.nodeType === Viper.Util.TEXT_NODE) {
        var node = Viper.document.createElement(tag);
        this._setWrapperElemAttributes(node, attributes);
        var rangeContent = range.toString();
        Viper.Util.setNodeTextContent(node, rangeContent);
        range.deleteContents();
        range.insertNode(node);
        var textNode = node.firstChild;
        if (!attributes && Viper.Util.isTag(node.previousSibling, tag) === true) {
          Viper.Util.moveChildrenToElement(node, node.previousSibling);
          node = node.previousSibling;
          Viper.Util.remove(node.nextSibling);
        }
        if (!attributes && Viper.Util.isTag(node.nextSibling, tag) === true) {
          Viper.Util.moveChildrenToElement(node.nextSibling, node);
          Viper.Util.remove(node.nextSibling);
        }
        if (keepSelection !== true) {
          range.setStart(textNode, 0);
          range.setEnd(textNode, textNode.data.length);
          Viper.Selection.addRange(range);
        }
        return node;
      } else {
        var self = this;
        this._wrapElement(startContainer.childNodes[range.startOffset], tag, null, attributes);
      }
    } else {
      if (nodeSelection && Viper.Util.isBlockElement(nodeSelection) === false && nodeSelection.nodeType !== Viper.Util.TEXT_NODE) {
        var newElement = document.createElement(otag);
        this._setWrapperElemAttributes(newElement, attributes);
        while (nodeSelection.firstChild) {
          newElement.appendChild(nodeSelection.firstChild);
        }
        nodeSelection.appendChild(newElement);
        range.selectNode(newElement);
        Viper.Selection.addRange(range);
        return newElement;
      } else if (startContainer.nodeType === Viper.Util.TEXT_NODE && this.getViperElement().firstChild === startContainer && Viper.Util.trim(startContainer.data) === "") {
        startContainer = range._getFirstSelectableChild(this.getViperElement());
      }
      var startBlockParent = Viper.Util.getFirstBlockParent(startContainer);
      if (!endContainer) {
        if (range.endContainer === this.getViperElement() && range.endContainer.childNodes && !range.endContainer.childNodes[range.endOffset]) {
          endContainer = range._getLastSelectableChild(this.getViperElement());
        } else {
          endContainer = startContainer;
        }
      }
      var rangeContents = range.getHTMLContentsObj();
      var endBlockParent = Viper.Util.getFirstBlockParent(endContainer);
      var bookmark = this.createBookmark();
      if (startBlockParent === endBlockParent && !nodeSelection) {
        if (!bookmark.start.previousSibling && bookmark.start.parentNode !== startBlockParent) {
          Viper.Util.insertBefore(bookmark.start.parentNode, bookmark.start);
        }
        if (!bookmark.end.nextSibling && bookmark.end.parentNode !== endBlockParent) {
          Viper.Util.insertAfter(bookmark.end.parentNode, bookmark.end);
        }
        var elements = Viper.Util.getElementsBetween(bookmark.start, bookmark.end);
        Viper.Util.remove(elements);
        if (!bookmark.start.nextSibling) {
          var parent = bookmark.start.parentNode;
          while (!parent.nextSibling) {
            parent = parent.parentNode;
          }
          Viper.Util.insertAfter(parent, bookmark.start);
        }
        if (!bookmark.end.previousSibling) {
          var parent = bookmark.end.parentNode;
          while (!parent.previousSibling) {
            parent = parent.parentNode;
          }
          Viper.Util.insertBefore(parent, bookmark.end);
        }
        var newElement = null;
        if (otag !== "span" && bookmark.start.previousSibling && Viper.Util.isTag(bookmark.start.previousSibling, otag) === true) {
          newElement = bookmark.start.previousSibling;
          newElement.appendChild(bookmark.start);
          while (rangeContents.firstChild) {
            newElement.appendChild(rangeContents.firstChild);
          }
          newElement.appendChild(bookmark.end);
        } else if (otag !== "span" && bookmark.end.nextSibling && Viper.Util.isTag(bookmark.end.nextSibling, otag) === true) {
          newElement = bookmark.end.nextSibling;
          if (newElement.firstChild) {
            Viper.Util.insertBefore(newElement.firstChild, bookmark.end);
          } else {
            newElement.appendChild(bookmark.end);
          }
          while (rangeContents.lastChild) {
            Viper.Util.insertBefore(newElement.firstChild, rangeContents.lastChild);
          }
          Viper.Util.insertBefore(newElement.firstChild, bookmark.start);
        } else {
          newElement = document.createElement(otag);
          Viper.Util.insertAfter(bookmark.start, newElement);
          while (rangeContents.firstChild) {
            newElement.appendChild(rangeContents.firstChild);
          }
        }
        this._setWrapperElemAttributes(newElement, attributes);
        var nestedTags = Viper.Util.getTag(otag, newElement);
        var nestedTagsCount = nestedTags.length;
        for (var i = 0; i < nestedTagsCount; i++) {
          if (this.isBookmarkElement(nestedTags[i]) === true || otag === "span") {
            continue;
          }
          while (nestedTags[i].firstChild) {
            Viper.Util.insertBefore(nestedTags[i], nestedTags[i].firstChild);
          }
          Viper.Util.remove(nestedTags[i]);
        }
        if (keepSelection !== true) {
          this.selectBookmark(bookmark);
        } else {
          Viper.Util.remove(bookmark.start);
          Viper.Util.remove(bookmark.end);
        }
        return newElement;
      }
      var startContainer = null;
      var endContainer = null;
      startContainer = bookmark.start.previousSibling;
      endContainer = bookmark.end.nextSibling;
      if (!endContainer) {
        var bookmarkEnd = bookmark.end.parentNode;
        while (bookmarkEnd) {
          if (bookmark.start.parentNode === bookmarkEnd.parentNode) {
            Viper.Util.insertAfter(bookmarkEnd, bookmark.end);
            break;
          } else if (bookmark.end.nextSibling || bookmarkEnd === this.getViperElement()) {
            break;
          } else {
            Viper.Util.insertAfter(bookmarkEnd, bookmark.end);
            if (bookmark.end.nextSibling) {
              break;
            } else {
              bookmarkEnd = bookmark.end.parentNode;
            }
          }
        }
        endContainer = Viper.document.createTextNode("");
        Viper.Util.insertAfter(bookmark.end, endContainer);
      }
      if (!startContainer) {
        var bookmarkStart = bookmark.start.parentNode;
        while (bookmarkStart) {
          if (bookmark.end.parentNode === bookmarkStart.parentNode) {
            Viper.Util.insertBefore(bookmarkStart, bookmark.start);
            break;
          } else if (bookmarkStart.previousSibling || bookmarkStart === this.getViperElement()) {
            break;
          }
          bookmarkStart = bookmarkStart.parentNode;
        }
        startContainer = Viper.document.createTextNode("");
        Viper.Util.insertBefore(bookmark.start, startContainer);
      }
      var elements = Viper.Util.getElementsBetween(startContainer, endContainer);
      var c = elements.length;
      var self = this;
      for (var i = 0; i < c; i++) {
        this._wrapElement(elements[i], tag, null, attributes);
      }
      if (keepSelection !== true) {
        this.selectBookmark(bookmark);
      } else {
        Viper.Util.remove(bookmark.start);
        Viper.Util.remove(bookmark.end);
      }
    }
  },
  /**
   * Wraps specified tag name around parent node.
   *
   * @param DomNode  parent   A domNode that needs to be wrapped by new tag.
   * @param string   tag      Name of the tag to create.
   * @param function callback A callback function that will be called when a
   *                          new tag is created.
   */
  _wrapElement: function(parent, tag, callback, attributes) {
    if (!parent) {
      return;
    } else if (Viper.Util.attr(parent, "viperbookmark")) {
      return;
    } else if (parent.nodeType === Viper.Util.COMMENT_NODE) {
      if (callback) {
        callback.call(this, parent);
      }
      return;
    }
    if (!attributes && Viper.Util.getParents(parent, tag).length > 0) {
      return;
    }
    if (parent.nodeType === Viper.Util.TEXT_NODE) {
      if (Viper.Util.isBlank(parent.data) !== true) {
        if (parent.previousSibling && parent.previousSibling.nodeType === Viper.Util.TEXT_NODE) {
          if (parent.previousSibling.nodeValue === "") {
            Viper.Util.remove(parent.previousSibling);
          }
        }
        if (parent.previousSibling && Viper.Util.isTag(parent.previousSibling, tag) === true && !Viper.Util.attr(parent.previousSibling, "viperbookmark") && (!attributes || attributes.cssClass !== "__viper_selHighlight")) {
          parent.previousSibling.appendChild(parent);
        } else if (parent.nextSibling && Viper.Util.isTag(parent.nextSibling, tag) === true && !Viper.Util.attr(parent.nextSibling, "viperbookmark") && (!attributes || attributes.cssClass !== "__viper_selHighlight")) {
          if (parent.nextSibling.firstChild) {
            Viper.Util.insertBefore(parent.nextSibling.firstChild, parent);
          } else {
            parent.nextSibling.appendChild(parent);
          }
        } else {
          var elem = Viper.document.createElement(tag);
          this._setWrapperElemAttributes(elem, attributes);
          Viper.Util.setNodeTextContent(elem, parent.nodeValue);
          Viper.Util.insertBefore(parent, elem);
          Viper.Util.remove(parent);
          if (callback) {
            callback.call(this, elem);
          }
        }
      } else if (parent.previousSibling && Viper.Util.isTag(parent.previousSibling, tag) === true && !Viper.Util.attr(parent.previousSibling, "viperbookmark")) {
        parent.previousSibling.appendChild(parent);
      }
    } else if (Viper.Util.isStubElement(parent) === false) {
      if (Viper.Util.isBlockElement(parent) === false && Viper.Util.hasBlockChildren(parent) === false) {
        if (Viper.Util.isTag(parent, tag) !== true) {
          if (parent.previousSibling && parent.previousSibling.tagName && parent.previousSibling.tagName.toLowerCase() === tag && Viper.Util.isBlockElement(parent) === false && !Viper.Util.attr(parent.previousSibling, "viperbookmark")) {
            parent.previousSibling.appendChild(parent);
          } else {
            var elem = Viper.document.createElement(tag);
            this._setWrapperElemAttributes(elem, attributes);
            Viper.Util.insertBefore(parent, elem);
            elem.appendChild(parent);
            this.removeTagFromChildren(elem, tag);
            if (callback) {
              callback.call(this, elem);
            }
          }
        } else if (!parent.firstChild) {
          parent.parentNode.removeChild(parent);
        } else if (parent.previousSibling && Viper.Util.isTag(parent.previousSibling, tag) === true && !Viper.Util.attr(parent.previousSibling, "viperbookmark")) {
          while (parent.firstChild) {
            parent.previousSibling.appendChild(parent.firstChild);
          }
          parent.parentNode.removeChild(parent);
        }
      } else {
        var c = parent.childNodes.length;
        var children = [];
        for (var i = 0; i < c; i++) {
          children.push(parent.childNodes[i]);
        }
        for (var i = 0; i < c; i++) {
          this._wrapElement(children[i], tag, callback, attributes);
        }
      }
    }
  },
  _setWrapperElemAttributes: function(element, attributes) {
    if (!element || !attributes) {
      return;
    }
    if (attributes.cssClass) {
      Viper.Util.addClass(element, attributes.cssClass);
    }
    if (attributes.attributes) {
      for (var attr2 in attributes.attributes) {
        this.setAttribute(element, attr2, attributes.attributes[attr2]);
      }
    }
  },
  /**
   * Removes all matching tags from the parent element.
   * Note: This does not remove the contents of the matching elements,
   * it joins them to sibling elements.
   */
  removeTagFromChildren: function(parent, tag, incParent) {
    var c = parent.childNodes.length;
    var childNodes = [];
    for (var i = 0; i < c; i++) {
      childNodes.push(parent.childNodes[i]);
    }
    for (var i = 0; i < c; i++) {
      var child = childNodes[i];
      if (child.nodeType === Viper.Util.ELEMENT_NODE) {
        this.removeTagFromChildren(child, tag, true);
      }
    }
    if (incParent === true) {
      this.removeTag(parent, tag);
    }
  },
  removeTag: function(elem, tag) {
    if (elem.parentNode && elem.parentNode.nodeType === Viper.Util.ELEMENT_NODE) {
      if (elem.nodeType === Viper.Util.ELEMENT_NODE) {
        if (elem.tagName.toLowerCase() === tag) {
          var span = null;
          while (elem.firstChild) {
            if (span !== null) {
              span.appendChild(elem.firstChild);
            } else {
              Viper.Util.insertBefore(elem, elem.firstChild);
            }
          }
          Viper.Util.remove(elem);
        }
      }
    }
  },
  removeStylesBetweenElems: function(start, end, style, range) {
    var elems = Viper.Util.getElementsBetween(start, end, range);
    elems.unshift(start);
    var len = elems.length;
    for (var i = 0; i < len; i++) {
      this.removeTagFromChildren(elems[i], style, true);
    }
  },
  removeStyle: function(style, nodeSelection) {
    var range = this.getViperRange();
    range = this.adjustRange(range);
    var startNode = range.getStartNode();
    var endNode = range.getEndNode();
    var viperElement = this.getViperElement();
    var nodeSelection = nodeSelection || range.getNodeSelection();
    if (nodeSelection) {
      var startSelNode = range._getFirstSelectableChild(nodeSelection);
      var endSelNode = range._getLastSelectableChild(nodeSelection);
      var styleTags = Viper.Util.getTag(style, nodeSelection);
      var sln = styleTags.length;
      for (var i = 0; i < sln; i++) {
        while (styleTags[i].firstChild) {
          Viper.Util.insertBefore(styleTags[i], styleTags[i].firstChild);
        }
        Viper.Util.remove(styleTags[i]);
      }
      var surrounding = Viper.Util.getSurroundingParents(nodeSelection, style, null, this.getViperElement());
      for (var i = 0; i < surrounding.length; i++) {
        if (Viper.Util.isTag(surrounding[i], style) === true) {
          while (surrounding[i].firstChild) {
            Viper.Util.insertBefore(surrounding[i], surrounding[i].firstChild);
          }
          Viper.Util.remove(surrounding[i]);
        }
      }
      if (Viper.Util.isTag(nodeSelection, style) === true) {
        while (nodeSelection.firstChild) {
          Viper.Util.insertBefore(nodeSelection, nodeSelection.firstChild);
        }
        Viper.Util.remove(nodeSelection);
      }
      if (Viper.Util.getParents(nodeSelection, style, this.getViperElement()).length === 0) {
        range.setStart(startSelNode, 0);
        range.setEnd(endSelNode, endSelNode.data.length);
        Viper.Selection.addRange(range);
        return;
      }
    }
    var bookmark = this.createBookmark(range);
    startNode = range.getStartNode();
    endNode = range.getEndNode();
    if (startNode.nodeType === Viper.Util.TEXT_NODE && Viper.Util.trim(startNode.data) === "" && startNode === viperElement.firstChild) {
      startNode = range._getFirstSelectableChild(viperElement);
    }
    if (!endNode) {
      endNode = startNode;
    }
    this.removeStylesBetweenElems(startNode, endNode, style, range);
    var startParents = Viper.Util.getParents(bookmark.start, style, this.element);
    var endParents = Viper.Util.getParents(bookmark.end, style, this.element);
    if (startParents.length === 0 && endParents.length === 0) {
      Viper.Selection.addRange(range);
      this.removeBookmarks();
      return;
    }
    var startTopParent = startParents.pop();
    var endTopParent = endParents.pop();
    if (startTopParent === endTopParent) {
      var start = Viper.Util.cloneNode(startTopParent);
      var selection = Viper.Util.cloneNode(startTopParent);
      var end = Viper.Util.cloneNode(startTopParent);
      var lastChild = Viper.Util.getLastChildTextNode(start);
      var elemsBetween = Viper.Util.getElementsBetween(this.getBookmark(start, "start"), lastChild);
      elemsBetween.push(this.getBookmark(start, "start"));
      elemsBetween.push(this.getBookmark(start, "end"));
      elemsBetween.push(lastChild);
      Viper.Util.remove(elemsBetween);
      var firstChild = Viper.Util.getFirstChildTextNode(end);
      var elemsBetween = Viper.Util.getElementsBetween(firstChild, this.getBookmark(end, "end"));
      elemsBetween.push(this.getBookmark(end, "end"));
      elemsBetween.push(this.getBookmark(end, "start"));
      elemsBetween.push(firstChild);
      Viper.Util.remove(elemsBetween);
      var firstChild = Viper.Util.getFirstChildTextNode(selection);
      var elemsBetween = Viper.Util.getElementsBetween(firstChild, this.getBookmark(selection, "start"));
      elemsBetween.push(firstChild);
      Viper.Util.remove(elemsBetween);
      var lastChild = Viper.Util.getLastChildTextNode(selection);
      var elemsBetween = Viper.Util.getElementsBetween(this.getBookmark(selection, "end"), lastChild);
      elemsBetween.push(lastChild);
      Viper.Util.remove(elemsBetween);
      var div = Viper.document.createElement("div");
      div.appendChild(selection);
      this.removeTagFromChildren(div, style, true);
      Viper.Util.removeEmptyNodes(start);
      Viper.Util.removeEmptyNodes(end);
      Viper.Util.removeEmptyNodes(div, function(elToDel) {
        if (Viper.Util.isTag(elToDel, "span") === true && Viper.Util.hasClass(elToDel, "viperBookmark") === true) {
          return false;
        }
      });
      if (start.firstChild) {
        if (Viper.Util.isBlank(Viper.Util.getNodeTextContent(start)) !== true) {
          Viper.Util.insertBefore(startTopParent, start);
        } else {
          while (start.firstChild) {
            Viper.Util.insertBefore(startTopParent, start.firstChild);
          }
        }
      }
      Viper.Util.insertBefore(startTopParent, div.childNodes);
      if (end.firstChild) {
        if (Viper.Util.isBlank(Viper.Util.getNodeTextContent(end)) !== true) {
          Viper.Util.insertBefore(startTopParent, end);
        } else {
          while (end.firstChild) {
            Viper.Util.insertBefore(startTopParent, end.firstChild);
          }
        }
      }
      Viper.Util.remove(startTopParent);
      var originalBookmark = {
        start: this.getBookmark(this.element, "start"),
        end: this.getBookmark(this.element, "end")
      };
      this.selectBookmark(originalBookmark);
      return;
    }
    if (startTopParent) {
      var clone = Viper.Util.cloneNode(startTopParent);
      var lastChild = Viper.Util.getLastChildTextNode(startTopParent);
      var elemsBetween = Viper.Util.getElementsBetween(bookmark.start, lastChild);
      elemsBetween.push(bookmark.start);
      elemsBetween.push(lastChild);
      Viper.Util.remove(elemsBetween);
      var firstChild = Viper.Util.getFirstChildTextNode(clone);
      elemsBetween = Viper.Util.getElementsBetween(firstChild, this.getBookmark(clone, "start"));
      elemsBetween.push(firstChild);
      Viper.Util.remove(elemsBetween);
      var div = Viper.document.createElement("div");
      div.appendChild(clone);
      this.removeTagFromChildren(div, style);
      Viper.Util.insertAfter(startTopParent, div.childNodes);
      if (Viper.Util.isTag(startTopParent, style) === true) {
        this.removeEmptyNodes(startTopParent);
        if (startTopParent.childNodes.length === 0) {
          Viper.Util.remove(startTopParent);
        }
      }
    }
    if (endTopParent) {
      var clone = Viper.Util.cloneNode(endTopParent);
      var firstChild = Viper.Util.getFirstChildTextNode(endTopParent);
      var elemsBetween = Viper.Util.getElementsBetween(firstChild, bookmark.end);
      elemsBetween.push(firstChild);
      Viper.Util.remove(elemsBetween);
      var lastChild = Viper.Util.getLastChildTextNode(clone);
      elemsBetween = Viper.Util.getElementsBetween(this.getBookmark(clone, "end"), lastChild);
      elemsBetween.push(lastChild);
      Viper.Util.remove(elemsBetween);
      var div = Viper.document.createElement("div");
      div.appendChild(clone);
      this.removeTagFromChildren(div, style);
      Viper.Util.insertBefore(endTopParent, div.childNodes);
      if (Viper.Util.isTag(endTopParent, style) === true) {
        this.removeEmptyNodes(endTopParent);
        if (endTopParent.childNodes.length === 0) {
          Viper.Util.remove(endTopParent);
        }
      }
    }
    var originalBookmark = {
      start: this.getBookmark(this.element, "start"),
      end: this.getBookmark(this.element, "end")
    };
    this.selectBookmark(originalBookmark);
  },
  /**
   * Sets the caret position right after the given node.
   *
   * If node does not have a text node sibling then it will be created.
   *
   * @param {DOMNode} node DOMNode to use.
   *
   * @return {boolean} True if it was successful.
   */
  setCaretAfterNode: function(node) {
    if (!node || !node.parentNode) {
      return false;
    }
    var range = this.getCurrentRange();
    if (node.nextSibling && node.nextSibling.nodeType === Viper.Util.TEXT_NODE) {
      node = node.nextSibling;
    } else {
      var text = null;
      if (node.nextSibling) {
        text = Viper.Util.getFirstChildTextNode(node.nextSibling);
      }
      if (!text) {
        text = Viper.document.createTextNode(String.fromCharCode(160));
        Viper.Util.insertAfter(node, text);
      }
      node = text;
    }
    range.setStart(node, 0);
    range.collapse(true);
    Viper.Selection.addRange(range);
    this.fireCaretUpdated();
    return true;
  },
  createSpaceNode: function() {
    return Viper.document.createTextNode(" ");
  },
  /**
   * Inserts the newNode after the specified node.
   *
   * Fires 'Viper:beforeInsertAfter' event before inserting the new node so that
   * plugins can prevent or modify node insertion.
   *
   * Also fires 'Viper:nodesChanged' on node.parentNode.
   *
   * @param {DOMNode} node    The node to insert after.
   * @param {DOMNode} newNode The node to insert.
   *
   * @return void
   */
  insertAfter: function(node, newNode) {
    this.fireCallbacks("Viper:beforeInsertAfter", { node, newNode });
    Viper.Util.insertAfter(node, newNode);
    this.contentChanged(true);
  },
  /**
   * Inserts the newNode before the specified node.
   *
   * Fires 'Viper:beforeInsertBefore' event before inserting the new node so that
   * plugins can prevent or modify node insertion.
   *
   * Also fires 'Viper:nodesChanged' on node.parentNode.
   *
   * @param {DOMNode} node    The node to insert before.
   * @param {DOMNode} newNode The node to insert.
   *
   * @return void
   */
  insertBefore: function(node, newNode) {
    this.fireCallbacks("Viper:beforeInsertBefore", { node, newNode });
    Viper.Util.insertBefore(node, newNode);
    this.contentChanged(true);
  },
  selectBookmark: function(bookmark) {
    this.blurActiveElement();
    var range = this.getCurrentRange();
    var startPos = null;
    var endPos = null;
    var startOffset = 0;
    var endOffset = 0;
    if (bookmark.start.nextSibling === bookmark.end || Viper.Util.getElementsBetween(bookmark.start, bookmark.end).length === 0) {
      if (bookmark.end.nextSibling && (Viper.Util.isBlockElement(bookmark.end.nextSibling) === false || !bookmark.start.previousSibling || Viper.Util.isBlockElement(bookmark.start.previousSibling))) {
        if (Viper.Util.isTag(bookmark.end.nextSibling, "span") !== true || Viper.Util.hasClass(bookmark.end.nextSibling, "viperBookmark") === false) {
          if (Viper.Util.isStubElement(bookmark.end.nextSibling) === false) {
            startPos = Viper.Util.getFirstChildTextNode(bookmark.end.nextSibling);
          } else if (Viper.Util.isTag(bookmark.end.nextSibling, "br") === true) {
            startPos = bookmark.end.nextSibling;
          } else {
            startPos = document.createTextNode("");
            Viper.Util.insertAfter(bookmark.end, startPos);
          }
        } else {
          startPos = document.createTextNode("");
          Viper.Util.insertAfter(bookmark.end, startPos);
        }
      } else if (bookmark.start.previousSibling) {
        startPos = Viper.Util.getFirstChildTextNode(bookmark.start.previousSibling);
        if (startPos && startPos.nodeType === Viper.Util.TEXT_NODE) {
          startOffset = startPos.length;
        }
      } else {
        bookmark.end.parentNode.appendChild(Viper.document.createTextNode(""));
        startPos = Viper.Util.getFirstChildTextNode(bookmark.end.nextSibling);
      }
    } else {
      if (bookmark.start.nextSibling) {
        startPos = Viper.Util.getFirstChildTextNode(bookmark.start.nextSibling);
        if (startPos && startPos.nodeType === Viper.Util.TEXT_NODE) {
          while (startPos && startPos.data.length === 0 && startPos.nextSibling) {
            startPos = Viper.Util.getFirstChildTextNode(startPos.nextSibling);
          }
        } else {
          var tmpTextNode = document.createTextNode("");
          Viper.Util.insertBefore(bookmark.start.nextSibling, tmpTextNode);
          startPos = tmpTextNode;
          startOffset = 0;
        }
      } else {
        if (!bookmark.start.previousSibling) {
          var tmp = Viper.document.createTextNode("");
          Viper.Util.insertBefore(bookmark.start, tmp);
        }
        startPos = Viper.Util.getLastChildTextNode(bookmark.start.previousSibling);
        startOffset = startPos.length;
      }
      if (bookmark.end.previousSibling) {
        endPos = Viper.Util.getLastChildTextNode(bookmark.end.previousSibling);
        if (endPos && endPos.nodeType === Viper.Util.TEXT_NODE) {
          while (endPos && endPos.data.length === 0 && endPos.previousSibling) {
            endPos = Viper.Util.getLastChildTextNode(endPos.previousSibling);
          }
          if (endPos.data) {
            endOffset = endPos.data.length;
          }
        } else {
          var tmpTextNode = document.createTextNode("");
          Viper.Util.insertAfter(bookmark.end.previousSibling, tmpTextNode);
          endPos = tmpTextNode;
          endOffset = 0;
        }
      } else {
        endPos = Viper.Util.getFirstChildTextNode(bookmark.end.nextSibling);
        endOffset = 0;
      }
    }
    Viper.Util.remove([bookmark.start, bookmark.end]);
    if (endPos === null) {
      range.setStart(startPos, startOffset);
      range.setEnd(startPos, startOffset);
      range.collapse(false);
    } else {
      var length = 0;
      if (Viper.Util.isStubElement(startPos) === true) {
        Viper.Selection.removeAllRanges();
        range.selectNode(startPos);
      } else if (Viper.Util.isStubElement(endPos) === true) {
        Viper.Selection.removeAllRanges();
        range.selectNode(endPos);
      } else {
        while (startPos && startPos.previousSibling && startPos.previousSibling.nodeType === Viper.Util.TEXT_NODE) {
          startOffset += startPos.previousSibling.data.length;
          if (endPos === startPos) {
            endOffset += startPos.previousSibling.data.length;
          }
          startPos.data = startPos.previousSibling.data + startPos.data;
          Viper.Util.remove(startPos.previousSibling);
        }
        while (endPos && endPos.nextSibling && endPos.nextSibling.nodeType === Viper.Util.TEXT_NODE) {
          endPos.data += endPos.nextSibling.data;
          Viper.Util.remove(endPos.nextSibling);
        }
        if (endPos.previousSibling === startPos) {
          endOffset += startPos.data.length;
          startPos.data += endPos.data;
          Viper.Util.remove(endPos);
          endPos = startPos;
        } else {
          while (endPos.previousSibling && endPos.previousSibling.nodeType === Viper.Util.TEXT_NODE) {
            endPos.data = endPos.previousSibling.data + endPos.data;
            endOffset += endPos.previousSibling.data.length;
            if (endPos.previousSibling === startPos) {
              startPos = endPos;
            }
            Viper.Util.remove(endPos.previousSibling);
          }
          if (endPos !== startPos) {
            while (startPos.nextSibling && startPos.nextSibling.nodeType === Viper.Util.TEXT_NODE) {
              startPos.data += startPos.nextSibling.data;
              Viper.Util.remove(startPos.nextSibling);
            }
          }
        }
        Viper.Selection.removeAllRanges();
        range.setEnd(endPos, endOffset);
        range.setStart(startPos, startOffset);
        range.setEnd(endPos, endOffset);
        range.setStart(startPos, startOffset);
      }
    }
    try {
      if (this.isEditableInIframe() === true) {
        this.focus();
      }
      Viper.Selection.addRange(range);
    } catch (e) {
    }
    return range;
  },
  getBookmark: function(parent, type) {
    var bookmarks = Viper.Util.getClass("viperBookmark_" + type, parent);
    var elem = bookmarks.shift();
    Viper.Util.remove(bookmarks);
    return elem;
  },
  getBookmarkById: function(bookmarkid, parent) {
    parent = parent || this.getViperElement();
    var bookmarks = Viper.Util.find(parent, '[data-bookmarkid="' + bookmarkid + '"]');
    if (bookmarks.length !== 2) {
      return null;
    }
    var bookmark = {
      start: bookmarks[0],
      end: bookmarks[1]
    };
    return bookmark;
  },
  isBookmarkElement: function(element) {
    if (Viper.Util.hasClass(element, "viperBookmark") === true) {
      return true;
    }
    return false;
  },
  removeBookmarks: function(elem, removeContent) {
    elem = elem || this.element;
    if (removeContent === true) {
      var starts = Viper.Util.find(elem, ".viperBookmark_start");
      var ends = Viper.Util.find(elem, ".viperBookmark_end");
      for (var i = 0; i < starts.length; i++) {
        var bookmark = {
          start: starts[i],
          end: ends[i]
        };
        this.removeBookmark(bookmark);
      }
    }
    Viper.Util.remove(Viper.Util.getClass("viperBookmark", elem, "span"));
  },
  /**
   * Removes the specified bookmark and the contents in it.
   */
  removeBookmark: function(bookmark, keepParent) {
    if (!bookmark.start || !bookmark.end) {
      return false;
    }
    var viperElement = this.getViperElement();
    var elems = Viper.Util.getElementsBetween(bookmark.start, bookmark.end);
    elems.push(bookmark.start, bookmark.end);
    var parents = getParents(elems);
    Viper.Util.remove(elems);
    if (keepParent !== true) {
      for (var i = 0; i < parents.length; i++) {
        if (parents[i] === viperElement) {
          break;
        }
        if (Viper.Util.elementIsEmpty(parents[i]) === true) {
          Viper.Util.remove(parents[i]);
        }
      }
    }
  },
  createBookmark: function(range, keepOldBookmarks, bookmarkid) {
    if (keepOldBookmarks !== true) {
      this.removeBookmarks(this.element);
    }
    var currRange = range || this.getViperRange();
    var range = currRange.cloneRange();
    var startContainer = range.startContainer;
    var endContainer = range.endContainer;
    var startOffset = range.startOffset;
    var endOffset = range.endOffset;
    if (range.startContainer && range.startContainer === range.endContainer && Viper.Util.isTag(range.startContainer, "br") === true) {
      var prevSibling = range.startContainer.previousSibling;
      var nextSibling = range.startContainer.nextSibling;
      if (prevSibling && prevSibling.nodeType === Viper.Util.TEXT_NODE) {
        range.setStart(prevSibling, prevSibling.data.length);
      } else if (nextSibling && nextSibling.nodeType === Viper.Util.TEXT_NODE) {
        range.setStart(nextSibling, 0);
      } else {
        var tmpNode = document.createTextNode("");
        Viper.Util.insertBefore(range.startContainer, tmpNode);
        range.setStart(tmpNode, 0);
      }
      range.collapse(true);
      Viper.Selection.addRange(range);
    } else if (Viper.Util.isBrowser("firefox") === true && startContainer === endContainer && startOffset === 0 && startContainer === this.getViperElement() && endOffset >= endContainer.childNodes.length) {
      var firstSelectable = range._getFirstSelectableChild(this.getViperElement());
      var lastSelectable = range._getLastSelectableChild(this.getViperElement());
      if (firstSelectable && lastSelectable) {
        startContainer = firstSelectable;
        startOffset = 0;
        range.setStart(firstSelectable, 0);
        range.setEnd(lastSelectable, lastSelectable.data.length);
      }
    }
    var endBookmark = Viper.document.createElement("span");
    endBookmark.style.display = "none";
    Viper.Util.setHtml(endBookmark, "&nbsp;");
    Viper.Util.addClass(endBookmark, "viperBookmark viperBookmark_end");
    endBookmark.setAttribute("viperBookmark", "end");
    if (bookmarkid) {
      endBookmark.setAttribute("data-bookmarkid", bookmarkid);
    }
    var startBookmark = Viper.document.createElement("span");
    startBookmark.style.display = "none";
    Viper.Util.addClass(startBookmark, "viperBookmark viperBookmark_start");
    Viper.Util.setHtml(startBookmark, "&nbsp;");
    startBookmark.setAttribute("viperBookmark", "start");
    if (bookmarkid) {
      startBookmark.setAttribute("data-bookmarkid", bookmarkid);
    }
    var viperElement = this.getViperElement();
    var nodeSelection = range.getNodeSelection();
    if (nodeSelection === viperElement) {
      if (!viperElement.firstChild) {
        viperElement.appendChild(startBookmark);
        viperElement.appendChild(endBookmark);
      } else {
        Viper.Util.insertBefore(viperElement.firstChild, startBookmark);
        Viper.Util.insertAfter(viperElement.lastChild, endBookmark);
      }
    } else {
      range.collapse(false);
      var startNode = range.getStartNode();
      if (Viper.Util.isStubElement(startNode) === true && Viper.Util.isBlockElement(startNode) === true) {
        var tmpText = document.createTextNode("");
        Viper.Util.insertAfter(startNode, tmpText);
        range.setStart(tmpText, 0);
        range.collapse(true);
      }
      range.insertNode(endBookmark);
      if (Viper.Util.isChildOf(endBookmark, this.element) === false) {
        this.element.appendChild(endBookmark);
      }
      if (startContainer.parentNode) {
        range.setStart(startContainer, startOffset);
        range.collapse(true);
      }
      try {
        if (startContainer.parentNode) {
          range.insertNode(startBookmark);
        } else {
          Viper.Util.insertBefore(endBookmark, startBookmark);
        }
        if (startBookmark.previousSibling === endBookmark) {
          Viper.Util.insertBefore(endBookmark, startBookmark);
        }
      } catch (e) {
        Viper.Util.insertBefore(endBookmark, startBookmark);
      }
      if (Viper.Util.isChildOf(startBookmark, this.element) === false) {
        if (this.element.firstChild) {
          Viper.Util.insertBefore(this.element.firstChild, startBookmark);
        } else {
          this.element.appendChild(startBookmark);
        }
      }
      if (!endBookmark.previousSibling) {
        var node = range.getPreviousContainer(endBookmark, null, true, true);
        if (node === startBookmark.parentNode) {
          var lastSelectable = range._getLastSelectableChild(node, null, true);
          if (lastSelectable) {
            Viper.Util.insertAfter(lastSelectable, endBookmark);
          } else {
            startBookmark.parentNode.appendChild(endBookmark);
          }
        } else if (node && Viper.Util.isChildOf(node, startBookmark.parentNode) == true) {
          Viper.Util.insertAfter(node, endBookmark);
        }
      }
      if (!endBookmark.previousSibling) {
        var tmp = Viper.document.createTextNode("");
        Viper.Util.insertBefore(endBookmark, tmp);
      }
      if (!startBookmark.nextSibling) {
        var tmp = Viper.document.createTextNode("");
        Viper.Util.insertAfter(startBookmark, tmp);
      }
      currRange.setStart(startBookmark.nextSibling, 0);
      currRange.setEnd(endBookmark.previousSibling, endBookmark.previousSibling.length || 0);
      if (nodeSelection && this.isSpecialElement(nodeSelection) === true) {
        Viper.Util.insertBefore(nodeSelection, startBookmark);
        Viper.Util.insertAfter(nodeSelection, endBookmark);
      }
    }
    var bookmark = {
      start: startBookmark,
      end: endBookmark
    };
    return bookmark;
  },
  /**
   * Creates a bookmark using the Viper highlight.
   *
   * @return object
   */
  createBookmarkFromHighlight: function(outer) {
    var highlights = this.getHighlights();
    if (highlights.length === 0) {
      return null;
    }
    var startBookmark = Viper.document.createElement("span");
    startBookmark.style.display = "none";
    Viper.Util.addClass(startBookmark, "viperBookmark viperBookmark_start");
    Viper.Util.setHtml(startBookmark, "&nbsp;");
    startBookmark.setAttribute("viperBookmark", "start");
    var outerParent = null;
    if (outer === true && highlights.length === 1) {
      outerParent = Viper.Util.getTopSurroundingParent(highlights[0]);
      if (outerParent) {
        Viper.Util.insertBefore(outerParent, startBookmark);
      }
    }
    if (!outerParent) {
      Viper.Util.insertBefore(highlights[0], startBookmark);
    }
    var endBookmark = Viper.document.createElement("span");
    endBookmark.style.display = "none";
    Viper.Util.setHtml(endBookmark, "&nbsp;");
    Viper.Util.addClass(endBookmark, "viperBookmark viperBookmark_end");
    endBookmark.setAttribute("viperBookmark", "end");
    if (outerParent) {
      Viper.Util.insertAfter(outerParent, endBookmark);
    } else {
      Viper.Util.insertAfter(highlights[highlights.length - 1], endBookmark);
    }
    var bookmark = {
      start: startBookmark,
      end: endBookmark
    };
    return bookmark;
  },
  insertNodeAtBookmark: function(node, bookmark, noSelect) {
    if (!bookmark || !node) {
      return;
    }
    Viper.Util.insertBefore(bookmark.start, node);
    if (noSelect !== true) {
      this.selectBookmark(bookmark);
    }
  },
  splitNodeAtRange: function(tag, range, copyMidTags) {
    range = range || this.getCurrentRange();
    var bookmark = this.createBookmark(range);
    return this.splitNodeAtBookmark(tag, bookmark, copyMidTags);
  },
  /**
          <p>
              sdfsdfsdf <em><strong>ddd<strong><em>sdfkj*sdhf</em>sdfsdfsdf</strong>xxxx</strong></em>
          </p>
  
          =>
          <p>
              sdfsdfsdf <em><strong>ddd<strong><em>sdfkj</em></strong></strong>
              *<strong>ddd<strong><em>sdhf</em>sdfsdfsdf</strong>xxxx</strong></em>
      */
  splitNodeAtBookmark: function(tag, bookmark, copyMidTags) {
    if (!bookmark) {
      return;
    }
    var node = bookmark.start.parentNode;
    var foundNode = null;
    while (node && node !== this.element) {
      if (Viper.Util.isTag(node, tag) === true) {
        foundNode = node;
      }
      node = node.parentNode;
    }
    var prevNode = null;
    var nextNode = null;
    var midNode = null;
    if (foundNode === null) {
      prevNode = bookmark.start.previousSibling;
      nextNode = bookmark.end.nextSibling;
      if (!prevNode && !nextNode) {
        prevNode = Viper.document.createTextNode("");
        Viper.Util.insertBefore(bookmark.start, prevNode);
        nextNode = prevNode;
      }
    } else {
      var selStart = document.createTextNode("");
      var selEnd = document.createTextNode("");
      Viper.Util.insertAfter(bookmark.end, selStart);
      Viper.Util.insertAfter(foundNode, selEnd);
      var range = this.getViperRange();
      range.setStart(selStart, 0);
      range.setEnd(selEnd, 0);
      var endContents = range.extractContents();
      var tmp = document.createElement("div");
      while (endContents.firstChild) {
        tmp.appendChild(endContents.firstChild);
      }
      var nextNode = null;
      if (Viper.Util.elementIsEmpty(tmp) === false) {
        while (tmp.lastChild) {
          nextNode = tmp.lastChild;
          Viper.Util.remove(tmp.lastChild);
          Viper.Util.insertAfter(selEnd, nextNode);
        }
      }
      Viper.Util.empty(tmp);
      Viper.Util.insertBefore(bookmark.start, selStart);
      Viper.Util.insertAfter(foundNode, selEnd);
      range.setStart(selStart, 0);
      range.setEnd(selEnd, 0);
      var midContents = range.extractContents();
      while (midContents.firstChild) {
        tmp.appendChild(midContents.firstChild);
      }
      var tagsToRemove = Viper.Util.getTag(tag, tmp);
      for (var i = 0; i < tagsToRemove.length; i++) {
        while (tagsToRemove[i].firstChild) {
          Viper.Util.insertBefore(tagsToRemove[i], tagsToRemove[i].firstChild);
        }
        Viper.Util.remove(tagsToRemove);
      }
      while (tmp.lastChild) {
        Viper.Util.insertAfter(foundNode, tmp.lastChild);
      }
      var prevNode = foundNode;
      Viper.Util.remove(selEnd);
      try {
        selStart.data = "";
      } catch (e) {
        selStart = document.createTextNode("");
      }
      Viper.Util.insertAfter(bookmark.start, selStart);
      midNode = selStart;
    }
    this.selectBookmark(bookmark);
    return {
      prevNode,
      nextNode,
      midNode
    };
  },
  /**
   * Highlights the current Viper selection.
   *
   * This method is useful when Viper loses focus and selection needs to be shown,
   * E.g. when a textbox takes focus the Viper selection will be lost, this method
   * will be similar to bookmarking a selection but visible to the user.
   *
   * If the range is collaped nothing will be highlighted.
   *
   * @return {DOMNode}
   */
  highlightSelection: function() {
    var highlights = Viper.Util.getClass("__viper_selHighlight", this.element);
    if (highlights.length > 0) {
      return false;
    }
    var range = this.getViperRange();
    if (this.rangeInViperBounds(range) === false) {
      return false;
    }
    var selectedNode = range.getNodeSelection();
    if (selectedNode && selectedNode === this.element) {
      selectedNode = null;
    }
    if (selectedNode && selectedNode.nodeType === Viper.Util.ELEMENT_NODE) {
      Viper.Util.addClass(selectedNode, "__viper_selHighlight __viper_cleanOnly");
    } else if (range.collapsed === true) {
      var span = document.createElement("span");
      Viper.Util.addClass(span, "__viper_selHighlight");
      Viper.Util.setStyle(span, "border-right", "1px solid #000");
      if (Viper.Util.isStubElement(range.startContainer) === false) {
        range.insertNode(span);
        var parentNode = span.parentNode;
      } else {
        parentNode = range.startContainer.parentNode;
      }
      if (parentNode) {
        var tagName = Viper.Util.getTagName(parentNode);
        if (Viper.Util.inArray(tagName, ["table", "tbody", "tr"]) === true) {
          Viper.Util.remove(span);
        }
      }
    } else if (range.startContainer && range.endContainer && range.endContainer.previousSibling === range.startContainer.nextSibling && Viper.Util.isTag(range.startContainer.nextSibling, "img") === true && Viper.Util.isTag(range.endContainer.previousSibling, "img") === true) {
      Viper.Util.addClass(range.startContainer.nextSibling, "__viper_selHighlight __viper_cleanOnly");
    } else {
      var attributes = {
        cssClass: "__viper_selHighlight"
      };
      var span = document.createElement("span");
      span.setAttribute("class", "__viper_selHighlight");
      this.surroundContents("span", attributes, range, true);
    }
  },
  highlightToSelection: function(element) {
    element = element || this.element;
    var highlights = Viper.Util.getClass("__viper_selHighlight", element);
    if (highlights.length === 0) {
      return false;
    }
    var range = this.getCurrentRange();
    var c = highlights.length;
    var startNode = false;
    var child = null;
    if (c === 1 && Viper.Util.hasClass(highlights[0], "__viper_cleanOnly") === true) {
      Viper.Util.removeClass(highlights[0], "__viper_cleanOnly");
      Viper.Util.removeClass(highlights[0], "__viper_selHighlight");
      if (!highlights[0].getAttribute("class")) {
        highlights[0].removeAttribute("class");
      }
      if (element === this.element) {
        range.selectNode(highlights[0]);
        Viper.Selection.addRange(range);
      }
      return true;
    }
    for (var i = 0; i < c; i++) {
      if (highlights[i].firstChild) {
        while (highlights[i].firstChild) {
          child = highlights[i].firstChild;
          Viper.Util.insertBefore(highlights[i], child);
          if (!startNode) {
            startNode = child;
            range.setStart(child, 0);
          }
        }
        Viper.Util.remove(highlights[i]);
        if (i === c - 1) {
          if (child.nodeType === Viper.Util.TEXT_NODE) {
            range.setEnd(child, child.data.length);
          } else if (startNode === child) {
            range.selectNode(startNode);
          } else {
            var lastSelectable = range._getLastSelectableChild(child);
            range.setEnd(lastSelectable, lastSelectable.data.length);
          }
        }
      } else {
        if (highlights[i].nextSibling && highlights[i].nextSibling.nodeType === Viper.Util.TEXT_NODE) {
          var nextSibling = highlights[i].nextSibling;
          if (!startNode) {
            range.setStart(nextSibling, 0);
            startNode = nextSibling;
          }
          Viper.Util.remove(highlights[i]);
          if (i === c - 1) {
            range.setEnd(nextSibling, 0);
          }
        } else {
          var textNode = document.createTextNode("");
          Viper.Util.insertAfter(highlights[i], textNode);
          range.setStart(textNode, 0);
          range.collapse(true);
          Viper.Util.remove(highlights[i]);
          if (i === c - 1) {
            range.setEnd(textNode, 0);
          }
        }
      }
    }
    if (element === this.element) {
      Viper.Selection.addRange(range);
      this.resetViperRange(range.cloneRange());
    }
    return true;
  },
  removeHighlights: function(element) {
    element = element || this.element;
    var highlights = this.getHighlights(element);
    if (highlights.length === 0) {
      return;
    }
    for (var i = 0; i < highlights.length; i++) {
      var highlight = highlights[i];
      if (Viper.Util.hasClass(highlight, "__viper_cleanOnly") === true) {
        Viper.Util.removeClass(highlight, "__viper_cleanOnly");
        Viper.Util.removeClass(highlight, "__viper_selHighlight");
        if (!highlight.getAttribute("class")) {
          highlight.removeAttribute("class");
        }
      } else {
        while (highlight.firstChild) {
          const child = highlight.firstChild;
          Viper.Util.insertBefore(highlight, child);
        }
        Viper.Util.remove(highlight);
      }
    }
    return true;
  },
  getHighlights: function(element) {
    element = element || this.element;
    var highlights = Viper.Util.getClass("__viper_selHighlight", element);
    return highlights;
  },
  isViperHighlightElement: function(element) {
    if (Viper.Util.isTag(element, "span") === true && Viper.Util.hasClass(element, "__viper_selHighlight") === true) {
      return true;
    }
    return false;
  },
  /**
   * Returns true if the given element is the current editable element.
   */
  isEditableElement: function(element) {
    if (element === this.getViperElement()) {
      return true;
    }
    return false;
  },
  isSpecialElement: function(element) {
    var isSpecialElem = false;
    if (element) {
      isSpecialElem = this.getPluginManager().isSpecialElement(element);
    }
    return isSpecialElem;
  },
  fireSelectionChanged: function(range, forceUpdate) {
    if (!range) {
      range = this.getViperRange();
      try {
        range = this.adjustRange(range);
      } catch (e) {
      }
    }
    if (!this._prevRange || forceUpdate === true || this._prevRange.startContainer !== range.startContainer || this._prevRange.endContainer !== range.endContainer || this._prevRange.startOffset !== range.startOffset || this._prevRange.endOffset !== range.endOffset || this._prevRange.collapsed !== range.collapsed) {
      this._prevRange = range;
      if (this._retrievingValues > 0) {
        var self = this;
        this._valuesRetrievedCallback = function() {
          self.fireCallbacks("Viper:selectionChanged", range);
        };
      } else {
        this._valuesRetrievedCallback = null;
        this.fireCallbacks("Viper:selectionChanged", range);
      }
    }
  },
  /**
   * Returns true if the given key event is using a registered special key.
   *
   * Special keys allow plugins to modify the key events when a specific key is pressed.
   *
   * @param {event} e The DOM key event.
   */
  isSpecialKey: function(e) {
    return Viper.Util.inArray(e.which, this._specialKeys);
  },
  /**
   * Registers a special key.
   *
   * Special keys allow plugins to modify the key events when a specific key is pressed.
   *
   * @param {integer} keyCode The key code for the key event.
   */
  addSpecialKey: function(keyCode) {
    this._specialKeys.push(keyCode);
  },
  targetIsOutside: function(target) {
    if (this.element !== target && Viper.Util.isChildOfElems(target, [this.element]) !== true && this.isMemberElement(target) !== true) {
      var pluginName = this._getPluginForElement(target);
      if (!pluginName && Viper.Util.isChildOfElems(target, [this._viperElementHolder]) !== true) {
        return true;
      }
    }
  },
  mouseDown: function(e) {
    Viper.Selection._viper = this;
    this._mouseDownEvent = e;
    if (e.which === 3) {
      this.fireCallbacks("Viper:rightMouseDown", e);
      return false;
    }
    var target = Viper.Util.getMouseEventTarget(e);
    var inside = true;
    if (this.element !== target && Viper.Util.isChildOfElems(target, [this.element]) !== true && this.isMemberElement(target) !== true && Viper.Util.isChildOfElems(target, this._memberElements) !== true) {
      inside = false;
      var pluginName = this._getPluginForElement(target);
      if (!pluginName && Viper.Util.isChildOfElems(target, [this._viperElementHolder]) !== true) {
        this.setEnabled(false);
        return this.fireCallbacks("Viper:clickedOutside", e);
      } else {
        return true;
      }
    } else if (this.enabled === false) {
      this.setEnabled(true);
    }
    this.removeHighlights();
    this.fireCallbacks("Viper:clickedInside", e);
    this.fireCaretUpdated();
    if (this.fireCallbacks("Viper:mouseDown", e) === false) {
      Viper.Util.preventDefault(e);
      return false;
    }
    if (inside !== true || this.removeHighlights() !== true) {
      var self = this;
      setTimeout(function() {
        var range = null;
        try {
          range = self.adjustRange();
        } catch (e2) {
        }
        self.fireSelectionChanged(range);
      }, 5);
    }
    this.resetViperRange(null);
  },
  mouseUp: function(e) {
    Viper.Selection._viper = this;
    if (e.which === 3) {
      this.fireCallbacks("Viper:rightMouseUp", e);
      return false;
    }
    if (this.fireCallbacks("Viper:mouseUp", e) === false) {
      Viper.Util.preventDefault(e);
      return false;
    }
    var target = Viper.Util.getMouseEventTarget(e);
    var pluginName = this._getPluginForElement(target);
    if (pluginName || Viper.Util.isChildOfElems(target, [this._viperElementHolder]) === true) {
      return;
    }
    var self = this;
    setTimeout(function() {
      var range = null;
      try {
        range = self.adjustRange(null, "mouseup");
      } catch (e2) {
      }
      self.fireSelectionChanged(range, true);
    }, 8);
  },
  /**
   * Adjusts the given range so a better selection is made.
   *
   * @param {Viper.DOMRange} The range object.
   *
   * @return {Viper.DOMRange} The updated range.
   */
  adjustRange: function(range, type) {
    range = range || this.getViperRange();
    if (range.collapsed !== false) {
      return range;
    }
    var startNode = range.getStartNode();
    var endNode = range.getEndNode();
    if (!endNode && startNode && Viper.Util.isStubElement(startNode) === true) {
      return range;
    }
    if (!endNode && range.startContainer && range.startContainer.nodeType === Viper.Util.ELEMENT_NODE) {
      var lastSelectable = range._getLastSelectableChild(range.startContainer);
      if (lastSelectable) {
        endNode = lastSelectable;
        range.endContainer = endNode;
        range.endOffset = endNode.data.length;
        Viper.Selection.addRange(range);
      }
    }
    if (type === "mouseup" && endNode && endNode.nodeType === Viper.Util.TEXT_NODE && range.endOffset === 0 && endNode !== startNode && endNode.previousSibling && endNode.previousSibling.nodeType !== Viper.Util.TEXT_NODE) {
      var textChild = range._getLastSelectableChild(endNode.previousSibling);
      if (textChild) {
        range.setEnd(textChild, textChild.data.length);
        Viper.Selection.addRange(range);
      }
    }
    if (Viper.Util.isBrowser("firefox") === true) {
      if (startNode && startNode.nodeType === Viper.Util.TEXT_NODE && endNode && endNode.nodeType === Viper.Util.TEXT_NODE && startNode.data.length === range.startOffset && range.endOffset === 0 && startNode.nextSibling && startNode.nextSibling === endNode.previousSibling && startNode.nextSibling.nodeType !== Viper.Util.TEXT_NODE) {
        var firstSelectable = range._getFirstSelectableChild(startNode.nextSibling);
        var lastSelectable = range._getLastSelectableChild(startNode.nextSibling);
        range.setStart(firstSelectable, 0);
        range.setEnd(lastSelectable, lastSelectable.data.length);
        Viper.Selection.addRange(range);
      } else if (startNode && startNode.nodeType === Viper.Util.TEXT_NODE && endNode && endNode.nodeType === Viper.Util.TEXT_NODE && startNode.data.length === range.startOffset && startNode !== endNode && startNode.nextSibling && startNode.nextSibling.nodeType !== Viper.Util.TEXT_NODE) {
        var firstSelectable = range._getFirstSelectableChild(startNode.nextSibling);
        if (firstSelectable) {
          range.setStart(firstSelectable, 0);
          Viper.Selection.addRange(range);
        }
      }
    } else if (startNode && endNode && startNode.nodeType === Viper.Util.TEXT_NODE && endNode.nodeType === Viper.Util.TEXT_NODE && range.startOffset === 0 && range.endOffset === endNode.data.length) {
      if (range.endOffset === 0 && !endNode.previousSibling) {
        var lastSelectable = range._getLastSelectableChild(endNode.parentNode.previousSibling.previousSibling);
        if (lastSelectable) {
          range.setEnd(lastSelectable, lastSelectable.data.length);
          Viper.Selection.addRange(range);
        }
      } else if (range.endOffset > 0 && Viper.Util.isBlank(Viper.Util.trim(endNode.data)) === true && range.commonAncestorContainer === this.getViperElement() && range.commonAncestorContainer.firstElementChild === range.commonAncestorContainer.lastElementChild && range._getFirstSelectableChild(range.commonAncestorContainer, startNode) && range._getLastSelectableChild(range.commonAncestorContainer, endNode)) {
        range.selectNode(range.commonAncestorContainer.firstElementChild);
        Viper.Selection.addRange(range);
      }
    } else if (endNode && endNode.nodeType === Viper.Util.ELEMENT_NODE && Viper.Util.isTag(endNode, "br") === true) {
      if (endNode.previousSibling) {
        var child = range._getLastSelectableChild(endNode.previousSibling);
        if (child) {
          range.setEnd(child, child.data.length);
          Viper.Selection.addRange(range);
        }
      }
    } else if (range.startContainer.nodeType === Viper.Util.TEXT_NODE && range.endContainer.nodeType === Viper.Util.ELEMENT_NODE && range.endOffset === 0 && range.startOffset === range.startContainer.data.length) {
      range.collapse(true);
      Viper.Selection.addRange(range);
    }
    return range;
  },
  focus: function() {
    if (this.element) {
      try {
        var elementScrollCoords = Viper.Util.getElementScrollCoords(this.element);
        var scrollCoords = Viper.Util.getScrollCoords(Viper.Util.getDocumentWindow());
        this.element.focus();
        var range = this.getViperRange();
        Viper.Selection.addRange(range);
        this.element.scrollTop = elementScrollCoords.y;
        this.element.scrollLeft = elementScrollCoords.x;
        Viper.window.scrollTo(scrollCoords.x, scrollCoords.y);
        this.fireCaretUpdated();
        this.fireCallbacks("Viper:focused");
      } catch (e) {
      }
    }
  },
  isEditableInIframe: function(element) {
    element = element || this.element;
    if (document !== element.ownerDocument) {
      return true;
    }
    return false;
  },
  blurActiveElement: function() {
    if (document.activeElement && document.activeElement !== this.element && document.activeElement.blur && document.activeElement !== document.body) {
      document.activeElement.blur();
    }
  },
  fireCaretUpdated: function(range) {
    range = range || this.getCurrentRange();
    this.fireCallbacks("caretPositioned", { range });
  },
  fireNodesChanged: function(nodes) {
    if (!nodes) {
      nodes = [this.element];
    }
    this.getViperRange().clearNodeSelectionCache();
    this.fireCallbacks("Viper:nodesChanged", nodes);
    if (nodes.length === 1 && nodes[0] && nodes[0].nodeType === Viper.Util.TEXT_NODE) {
      this.HistoryManager.add("Viper", "text_change");
    } else {
      this.HistoryManager.add();
    }
  },
  contentChanged: function(selectionNotChanged, range) {
    range = range || null;
    if (selectionNotChanged !== true) {
      this.fireSelectionChanged(range, true);
    }
    this.fireNodesChanged();
  },
  _getPluginForElement: function(element) {
    return this.getPluginManager().getPluginForElement(element);
  },
  registerCallback: function(type, namespace, callback) {
    if (Viper.Util.isFn(callback) === false) {
      return;
    }
    if (Viper.Util.isArray(type) === true) {
      for (var i = 0; i < type.length; i++) {
        this.registerCallback(type[i], namespace, callback);
      }
      return;
    }
    if (!this.callbacks[type]) {
      this.callbacks[type] = {
        namespaces: {},
        others: []
      };
    }
    if (namespace) {
      this.callbacks[type].namespaces[namespace] = callback;
    } else {
      this.callbacks[type].others.push(callback);
    }
  },
  fireCallbacks: function(type, data, doneCallback) {
    var callbackList = [];
    if (this.callbacks[type]) {
      for (var namespace in this.callbacks[type].namespaces) {
        if (this.callbacks[type].namespaces.hasOwnProperty(namespace) === true) {
          var callback = this.callbacks[type].namespaces[namespace];
          if (callback) {
            callbackList.push(callback);
          }
        }
      }
      var len = this.callbacks[type].others.length;
      for (var i = 0; i < len; i++) {
        callbackList.push(this.callbacks[type].others[i]);
      }
    }
    return this._fireCallbacks(callbackList, data, doneCallback, null, type);
  },
  _fireCallbacks: function(callbacks, data, doneCallback, retVal, type) {
    if (callbacks.length === 0) {
      if (doneCallback) {
        doneCallback.call(this, data, retVal);
      }
      return retVal;
    }
    var callback = callbacks.shift();
    if (callback) {
      var self = this;
      try {
        var returnValue = callback.call(this, data, function(returnValue2) {
          if (retVal === false) {
            returnValue2 = false;
          }
          self._fireCallbacks(callbacks, data, doneCallback, returnValue2, type);
        });
        if (Viper.Util.isFn(returnValue) === true) {
          return;
        }
        if (retVal === false) {
          returnValue = false;
        }
        return this._fireCallbacks(callbacks, data, doneCallback, returnValue, type);
      } catch (e) {
        console.error(e, callback, e.stack);
      }
    }
  },
  removeCallback: function(type, namespace) {
    if (!type) {
      if (namespace) {
        for (var type in this.callbacks) {
          if (this.callbacks.hasOwnProperty(type) === true) {
            this.removeCallback(type, namespace);
          }
        }
      }
    } else if (this.callbacks[type]) {
      if (namespace) {
        if (this.callbacks[type].namespaces[namespace]) {
          delete this.callbacks[type].namespaces[namespace];
        }
      } else {
        delete this.callbacks[type];
      }
    }
  },
  /**
   * Gets the clean source code of the element.
   *
   * @return string.
   */
  getHtml: function(elem, settings) {
    elem = elem || this.element;
    if (typeof elem === "string") {
      var tmp = elem;
      elem = Viper.document.createElement("div");
      Viper.Util.setHtml(elem, tmp);
    }
    if (!elem) {
      return "";
    }
    var originalSettings = this.getSettings();
    if (!settings) {
      this.setSetting("emptyTableCellContent", "&nbsp;");
    } else {
      this.setSettings(settings);
    }
    var clone = Viper.Util.cloneNode(elem);
    this.removeHighlights(clone);
    this.removeEmptyNodes(clone);
    this._removeViperElements(clone);
    this.fireCallbacks("Viper:getHtml", { element: clone });
    var html = Viper.Util.getHtml(clone);
    html = this.cleanHTML(html);
    var defaultBlockTag = this.getDefaultBlockTag();
    if (html === "" && defaultBlockTag) {
      html = "<" + defaultBlockTag + "></" + defaultBlockTag + ">";
    }
    html = html.replace(/<\/viper:param>/gi, "");
    html = html.replace(/<viper:param /gi, "<param ");
    html = html.replace(/<:object/gi, "<object");
    html = html.replace(/<\/:object/gi, "</object");
    html = html.replace(/__viper_attr_/g, "");
    html = this.removeInvalidCharacters(html);
    this.setSettings(originalSettings, true);
    return html;
  },
  getRawHTML: function(elem) {
    elem = elem || this.element;
    return Viper.Util.getHtml(elem);
  },
  setRawHTML: function(html) {
    Viper.Util.setHtml(this.element, html);
  },
  /**
   * Gets the HTML (not source) contents of the editable element.
   * Returned value contains Viper specific elements.
   *
   * @return string.
   */
  getContents: function(elem) {
    elem = elem || this.element;
    var clone = Viper.Util.cloneNode(elem);
    this._removeViperElements(clone);
    this.fireCallbacks("getContents", { element: clone });
    var html = Viper.Util.getHtml(clone);
    return html;
  },
  _removeViperElements: function(elem) {
    var bookmarks = Viper.Util.getClass("viperBookmark", elem);
    if (bookmarks) {
      Viper.Util.remove(bookmarks);
    }
    var highlights = Viper.Util.getClass("__viper_selHighlight", elem);
    for (var i = 0; i < highlights.length; i++) {
      if (Viper.Util.hasClass(highlights[i], "__viper_cleanOnly") !== true) {
        while (highlights[i].firstChild) {
          Viper.Util.insertBefore(highlights[i], highlights[i].firstChild);
        }
        Viper.Util.remove(highlights[i]);
      } else {
        Viper.Util.removeClass(highlights[i], "__viper_selHighlight");
        Viper.Util.removeClass(highlights[i], "__viper_cleanOnly");
        if (!highlights[0].getAttribute("class")) {
          highlights[0].removeAttribute("class");
        }
      }
    }
  },
  /**
   * Sets the Viper content that may contain Viper specified elements.
   */
  setContents: function(contents) {
    if (typeof contents === "string") {
      this.element.innerHTML = contents;
    } else if (contents) {
      this.element.appendChild(contents);
    }
    this.fireCallbacks("setContents", { element: this.element });
    this.initEditableElement();
  },
  /**
   * Sets the Viper content, content cannot contain Viper specific elements.
   */
  setHtml: function(contents, callback, element) {
    contents = this.removeInvalidCharacters(contents);
    var self = this;
    this.fireCallbacks("Viper:setHtmlContent", contents, function(data, newContents) {
      self._setHTML(newContents, callback, element);
    });
  },
  _setHTML: function(contents, callback, element) {
    element = element || this.element;
    var clone = Viper.document.createElement("div");
    if (typeof contents === "string") {
      clone.innerHTML = contents;
      Viper.Util.remove(Viper.Util.getTag("script", clone));
    } else if (contents) {
      clone.appendChild(contents);
    }
    this.resetViperRange(null);
    var range = this.getCurrentRange();
    var lastSelectable = range._getLastSelectableChild(clone);
    if (lastSelectable && lastSelectable.nodeType === Viper.Util.TEXT_NODE && (!lastSelectable.nextSibling || Viper.Util.isTag(lastSelectable.nextSibling, "br") === true)) {
      lastSelectable.data = Viper.Util.rtrim(lastSelectable.data);
    }
    this.removeEmptyNodes(clone);
    var self = this;
    this.fireCallbacks("Viper:setHtml", { element: clone }, function() {
      var html = Viper.Util.getHtml(clone);
      element.innerHTML = html;
      self.initEditableElement(element);
      self.contentChanged();
      if (callback) {
        callback.call(this);
      }
    });
  },
  _closeStubTags: function(content) {
    var re = /<(area|base|basefont|br|hr|input|img|link|meta|embed|viper:param|param)((\s+[_\-\w]+(\s*=\s*(?:"[^">]*"|\'[^\'>]+\'))?)+)?\s*>/gi;
    content = content.replace(re, "<$1$2 />");
    return content;
  },
  cleanHTML: function(content, attrBlacklist) {
    attrBlacklist = attrBlacklist || ["sizset"];
    content = content.replace(
      /<(p|div|h1|h2|h3|h4|h5|h6|li)((\s+\w+(\s*=\s*(?:".*?"|\'.*?\'|[^\'">\s]+))?)+)?\s*>\s*/gi,
      "<$1$2>"
    );
    content = content.replace(
      /\s*<\/(p|div|h1|h2|h3|h4|h5|h6|li)((\s+\w+(\s*=\s*(?:".*?"|\'.*?\'|[^\'">\s]+))?)+)?\s*>/gi,
      "</$1$2>"
    );
    content = this._closeStubTags(content);
    content = content.replace(/<\/?\s*([A-Z\d:]+)/g, function(str) {
      return str.toLowerCase();
    });
    content = this.replaceEntities(content);
    var subRegex = `\\s+([_\\-:\\w]+)(?:\\s*=\\s*("(?:[^"]+)?"|'(?:[^']+)?'|[^'">\\s]+))?`;
    var tagRegex = new RegExp("(<[\\w:]+)(?:" + subRegex + ")+\\s*(/?>)", "g");
    var attrRegex = new RegExp(subRegex, "g");
    content = content.replace(tagRegex, function(match, tagStart, a, tagEnd) {
      match = match.replace(attrRegex, function(a2, attrName, attrValue) {
        attrName = attrName.toLowerCase();
        if (Viper.Util.inArray(attrName, attrBlacklist) === true) {
          return "";
        } else if (attrName.indexOf(":") >= 0) {
          return "";
        } else if (attrName.match(/^sizcache\d+$/)) {
          return "";
        }
        if (attrName === "style") {
          attrValue = attrValue.toLowerCase();
        }
        var res = " " + attrName;
        if (typeof attrValue != "undefined") {
          attrValue = Viper.Util.trim(attrValue, `"'`);
          res += '="' + attrValue + '"';
        }
        return res;
      });
      return match;
    });
    return content;
  },
  /**
   * Cleans the contents of the given DOM element.
   *
   * @param {DOMNode} elem    The element to clean, if not specified Viper element is used.
   * @param {string}  tagName If specified only this type of tag is cleaned.
   *
   * @return {void}
   */
  cleanDOM: function(elem, tagName) {
    if (!elem) {
      elem = this.element;
    }
    Viper.Util.removeAttr(Viper.Util.find(elem, '[style=""]'), "style");
    Viper.Util.removeAttr(Viper.Util.find(elem, '[class=""]'), "class");
    this.removeNotAllowedAttributes(elem);
    this._cleanDOM(elem, tagName, true);
    if (Viper.Util.isBlockElement(elem) === true) {
      var range = this.getViperRange(elem);
      var lastElem = range._getLastSelectableChild(elem);
      if (lastElem && lastElem.nodeType === Viper.Util.TEXT_NODE && (!lastElem.nextSibling || Viper.Util.isTag(lastElem.nextSibling, "br") === true)) {
        lastElem.data = Viper.Util.rtrim(lastElem.data.replace(/(&nbsp;)*$/, ""));
      }
    }
    this.fireCallbacks("Viper:cleanDOM", { element: elem });
  },
  /**
   * Removes attributes that are not allowed in Viper.
   *
   * @param {DOMNode} elem The element to clean.
   *
   * @return {void}
   */
  removeNotAllowedAttributes: function(elem) {
    var notAllowedAttributes = ["contenteditable"];
    for (var i = 0; i < notAllowedAttributes.length; i++) {
      Viper.Util.removeAttr(Viper.Util.find(elem, "[" + notAllowedAttributes[i] + "]"), notAllowedAttributes[i]);
    }
  },
  _cleanDOM: function(elem, tagName, topLevel) {
    if (!elem) {
      return;
    }
    if (elem.firstChild && Viper.Util.isTag(elem, "pre") !== true) {
      this._cleanDOM(elem.firstChild, tagName);
    }
    if (elem === this.element || topLevel === true) {
      return;
    }
    var nextSibling = elem.nextSibling;
    this._cleanNode(elem, tagName);
    if (nextSibling) {
      this._cleanDOM(nextSibling, tagName);
    }
  },
  _cleanNode: function(node, tag) {
    if (node === this.element) {
      return;
    }
    if (node.nodeType === Viper.Util.ELEMENT_NODE) {
      var tagName = node.tagName.toLowerCase();
      if (tag && tag !== tagName) {
        return;
      } else if (node.className !== "" || node.id !== "") {
        switch (tagName) {
          case "textarea":
          case "form":
          case "input":
          case "button":
          case "select":
          case "label":
            Viper.Util.remove(node);
            break;
          default:
            break;
        }
        return;
      }
      switch (tagName) {
        case "br":
          if (!node.nextSibling || node.hasAttribute && node.hasAttribute("_moz_dirty")) {
            if (!node.previousSibling && (Viper.Util.isTag(node.parentNode, "td") === true || Viper.Util.isTag(node.parentNode, "th") === true)) {
              var emptyTableCellContent = this.getSetting("emptyTableCellContent");
              Viper.Util.setHtml(node.parentNode, emptyTableCellContent);
              return;
            }
            var prev = node.previousSibling;
            while (prev) {
              if (Viper.Util.isTag(prev, "br") === true || prev.nodeType === Viper.Util.TEXT_NODE && Viper.Util.trim(prev.nodeValue) === "") {
                var removeNode = prev;
                prev = prev.previousSibling;
                Viper.Util.remove(removeNode);
              } else {
                break;
              }
            }
            if (tag) {
              var newNode = Viper.document.createTextNode(" ");
              Viper.Util.insertBefore(node, newNode);
            }
            Viper.Util.remove(node);
          } else {
            var next = node.nextSibling;
            var brLast = true;
            while (next) {
              if (next.nodeType !== Viper.Util.TEXT_NODE || Viper.Util.trim(next.nodeValue) !== "") {
                brLast = false;
                break;
              }
              next = next.nextSibling;
            }
            if (brLast === true) {
              var prev = node.previousSibling;
              while (prev) {
                if (Viper.Util.isTag(prev, "br") === true || prev.nodeType === Viper.Util.TEXT_NODE && Viper.Util.trim(prev.nodeValue) === "") {
                  var removeNode = prev;
                  prev = prev.previousSibling;
                  Viper.Util.remove(removeNode);
                } else {
                  break;
                }
              }
              Viper.Util.remove(node);
            } else if (Viper.Util.isTag(node.nextSibling, ["ol", "ul"]) === true && Viper.Util.isTag(node.parentNode, "li") === true) {
              Viper.Util.remove(node);
            }
          }
          break;
        case "a":
          if (!node.getAttribute("name") && !node.firstChild) {
            Viper.Util.remove(node);
          }
          break;
        case "td":
        case "th":
        case "li":
        case "caption":
          var html = Viper.Util.trim(Viper.Util.getHtml(node));
          if (html === "" || Viper.Util.trim(html.replace(/&nbsp;/g, "")) === "") {
            Viper.Util.setHtml(node, "&nbsp;");
          }
          break;
        case "textarea":
        case "form":
        case "input":
        case "button":
        case "select":
        case "label":
          Viper.Util.remove(node);
          break;
        case "strong":
        case "em":
          if (Viper.Util.isTag(node.parentNode, tagName) === true) {
            while (node.firstChild) {
              Viper.Util.insertBefore(node, node.firstChild);
            }
            Viper.Util.remove(node);
            break;
          } else if (node.previousSibling && Viper.Util.isTag(node.previousSibling, tagName) === true) {
            while (node.firstChild) {
              node.previousSibling.appendChild(node.firstChild);
            }
            Viper.Util.remove(node);
            break;
          }
        default:
          var cont = Viper.Util.trim(Viper.Util.getHtml(node));
          if (Viper.Util.isStubElement(node) === false && !node.firstChild || cont === "&nbsp;" || cont === "" && Viper.Util.isTag(node, ["p", "div"])) {
            if (this.isSpecialElement(node) !== true) {
              Viper.Util.remove(node);
            }
          }
          break;
      }
    } else if (node.nodeType === Viper.Util.TEXT_NODE && !tag) {
      if (Viper.Util.isTag(node.parentNode, "td") === false) {
        if (Viper.Util.trim(node.data, "\f\n\r	\v\u2028\u2029") === "") {
          Viper.Util.remove(node);
        } else if (Viper.Util.trim(node.data) === "" && node.data.indexOf("\n") === 0) {
          Viper.Util.remove(node);
        } else if (node.data.match(/\n\s+\S+\n\s+/) !== null && !node.previousSibling && !node.nextSibling) {
          node.data = Viper.Util.trim(node.data);
        } else {
          var nbsp = String.fromCharCode(160);
          node.data = node.data.replace(/^\s+/g, " ");
          node.data = node.data.replace(/\s*\n\s*/g, " ");
          if ((!node.nextSibling || Viper.Util.isSpacerBR(node.nextSibling) === true) && Viper.Util.isBlockElement(node.parentNode) === true) {
            node.data = node.data.replace(/\s+$/g, "");
          }
          if (node.data.charAt(0) === " " && node.previousSibling && node.previousSibling.nodeType === Viper.Util.TEXT_NODE && (node.previousSibling.data.charAt(node.previousSibling.data.length - 1) === nbsp || node.previousSibling.data.charAt(node.previousSibling.data.length - 1) === " ")) {
            node.data = node.data.replace(/^\s+/g, nbsp);
          }
          if (node.data.charAt(node.data.length - 1) === " " && node.nextSibling && node.nextSibling.nodeType === Viper.Util.TEXT_NODE && (node.nextSibling.data.charAt(0) === " " || node.nextSibling.data.charAt(0) === nbsp)) {
            node.data = node.data.replace(/\s+$/g, nbsp);
          }
          node.data = node.data.replace(/\s{2,2}/g, nbsp + nbsp);
        }
      } else {
        node.data = node.data.replace(/^\n+\s*$/m, "");
      }
    }
  },
  removeEmptyNodes: function(element, content) {
    if (content && !element) {
      element = document.createElement("div");
      Viper.Util.setHtml(element, content);
    } else if (!content) {
      if (!element) {
        element = this.element;
      }
    } else {
      return;
    }
    this.cleanDOM(element);
    return element;
  },
  replaceEntities: function(html) {
    var specialCharcodes = {
      8211: "&ndash;",
      8212: "&mdash;",
      8226: "*"
    };
    for (var code in specialCharcodes) {
      html = html.replace(new RegExp(String.fromCharCode(code), "g"), specialCharcodes[code]);
    }
    return Viper.Util.replaceCommonNamedEntities(html);
  },
  removeElem: function(elem) {
    if (Viper.Util.isArray(elem) === true) {
      var eln = elem.length;
      for (var i = 0; i < eln; i++) {
        this.removeElem(elem[i]);
      }
    } else if (elem) {
      var parent = elem.parentNode;
      Viper.Util.remove(elem);
      if (parent) {
        for (var node = parent.firstChild; node; node = node.nextSibling) {
          if (node.nodeType !== Viper.Util.TEXT_NODE || node.nodeValue.length !== 0) {
            return;
          }
        }
        Viper.Util.remove(parent);
      }
    }
  },
  removeInvalidCharacters: function(content) {
    content = content.replace(/[\x00-\x09]/g, "");
    return content;
  }
};

// src/index.js
[
  (init_Util(), __toCommonJS(Util_exports)),
  (init_Translation(), __toCommonJS(Translation_exports)),
  (init_Tools(), __toCommonJS(Tools_exports)),
  (init_Selection(), __toCommonJS(Selection_exports)),
  (init_DOMRange(), __toCommonJS(DOMRange_exports)),
  (init_MozRange(), __toCommonJS(MozRange_exports)),
  (init_PluginManager(), __toCommonJS(PluginManager_exports)),
  (init_HistoryManager(), __toCommonJS(HistoryManager_exports)),
  (init_KeyboardHandler(), __toCommonJS(KeyboardHandler_exports))
].forEach(({ registerPlugin: registerPlugin26 }) => {
  registerPlugin26(Viper);
});
[
  (init_ViperCopyPastePlugin(), __toCommonJS(ViperCopyPastePlugin_exports)),
  (init_ViperToolbarPlugin(), __toCommonJS(ViperToolbarPlugin_exports)),
  (init_ViperInlineToolbarPlugin(), __toCommonJS(ViperInlineToolbarPlugin_exports)),
  (init_ViperCoreStylesPlugin(), __toCommonJS(ViperCoreStylesPlugin_exports)),
  (init_ViperFormatPlugin(), __toCommonJS(ViperFormatPlugin_exports)),
  (init_ViperListPlugin(), __toCommonJS(ViperListPlugin_exports)),
  (init_ViperHistoryPlugin(), __toCommonJS(ViperHistoryPlugin_exports)),
  (init_ViperTableEditorPlugin(), __toCommonJS(ViperTableEditorPlugin_exports)),
  (init_ViperLinkPlugin(), __toCommonJS(ViperLinkPlugin_exports)),
  // require('./Plugins/ViperAccessibilityPlugin/ViperAccessibilityPlugin.js'),
  (init_ViperSourceViewPlugin(), __toCommonJS(ViperSourceViewPlugin_exports)),
  (init_ViperImagePlugin(), __toCommonJS(ViperImagePlugin_exports)),
  (init_ViperSearchReplacePlugin(), __toCommonJS(ViperSearchReplacePlugin_exports)),
  (init_ViperLangToolsPlugin(), __toCommonJS(ViperLangToolsPlugin_exports)),
  (init_ViperCharMapPlugin(), __toCommonJS(ViperCharMapPlugin_exports)),
  (init_ViperCursorAssistPlugin(), __toCommonJS(ViperCursorAssistPlugin_exports)),
  (init_ViperReplacementPlugin(), __toCommonJS(ViperReplacementPlugin_exports))
].forEach(({ registerPlugin: registerPlugin26 }) => {
  registerPlugin26(Viper);
});
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  Viper
});
//# sourceMappingURL=index.js.map
